var Bg = Object.defineProperty;
var Ug = (e, t, n) => t in e ? Bg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var on = (e, t, n) => Ug(e, typeof t != "symbol" ? t + "" : t, n);
import { getCurrentInstance as ms, inject as Xn, ref as F, shallowRef as Gg, computed as Te, watch as ot, onMounted as Mt, onUnmounted as Ka, defineComponent as qe, h as yp, createVNode as d, Text as Wg, Fragment as ze, toRefs as ln, createElementBlock as J, openBlock as O, createElementVNode as y, normalizeStyle as Tt, toDisplayString as V, readonly as zg, nextTick as fn, mergeProps as Pe, createCommentVNode as ue, renderSlot as St, mergeModels as xn, useModel as Ln, unref as r, withCtx as w, resolveComponent as Cn, normalizeClass as He, toHandlers as Ci, createBlock as he, resolveDynamicComponent as Ea, renderList as Rt, reactive as et, createTextVNode as yt, toRaw as zn, watchEffect as Wa, isRef as za, onBeforeUnmount as On, withModifiers as ka, withDirectives as Pt, vShow as sn, Teleport as au, resolveDirective as ou, toRef as Hg, normalizeProps as bo, guardReactiveProps as Cl, Transition as Yg, createSlots as Kg, withKeys as Zg, vModelRadio as wc, vModelCheckbox as Go } from "vue";
import { useModals as Mo, MUSwitch as Jg, useAssets as ia, MContainerRow as Be, MContainerColumn as at, MContainerGrow as Lt, MContainerSplit as Wo, getAboutInfoModel as Sc, MModal as Xg, MDialogCancelButton as qg, MDialogFooter as Qg, MTabItem as Ul, MUButton as Ce, MContainer as Ee, MFSwitch as io, useReactiveModel as eh, MInputNumber as Ic, useNavbar as Po, ButtonEnum as Ie, MDialogConfirmButtonRedesign as la, MDialogCancelButtonRedesign as ya, getSleeveOriginalName as _p, useServerApi as Jn, meshFormats as Hi, textureFormats as wp, exception as Sp, TVersionTypes as Va, MPickList as th, MSlider as Yi, useAuth as ml, MColorPicker as nh, useSTLLibraryStore as fl, STLLibraryCache as lu, useSTLLibraryApi as iu, MListComponent as Bn, MenuType as vn, useUserSettingsStore as oa, ImageListItem as ah, imgFormats as Ip, MUErrorModal as $i, fileFormats as oh, MIcon as su, isUserWeblinkOperator as lh, getIconSrc as ih, useResizeObserver as ru, useGuiConfiguration as Ep, AppName as al, success as uo, error as Tn, NavbarEventBus as ol, NavbarNamedEvents as ll, MLoading as fs, devLogger as Ye, useUtilStore as Tp, getOemSerialNumber as sh, setWizardBackground as Cp, setPatientListBackground as Np, formatFileSizeBytes as rh, OemSerialNumber as uh, MTogglePanel as Ec, AppThemeConfigComponent as ch, AppLanguageComponent as dh, getNamespacedUuid as ph, isDicomImportCandidate as mh, readDicomVolumeMetadata as fh, addDicomSeriesSlice as gh, selectDicomVolumeSeries as hh, getDicomMiddleSlice as bh } from "@xlabmedical/medic-web-framework";
import vh from "primevue/slider/style";
import yh from "primevue/radiobutton/style";
import ca from "primevue/inputtext";
import _h from "primevue/inputnumber/style";
import wh from "primevue/divider/style";
import { crosshairTypes as Sh, LayoutTemplate as Ve, useProjectContext as pn, ToolType as un, ToolLayer as Qt, volumeOptionsDefaultTemplates as Ih, takeVolumeTemplateScreenshot as Eh, VolumeShadingMode as Nl, TJSLambdaType as qt, retrieveCurrentWizardGUIWithRetry as gs, DynamicGUIComponent as hs, DynamicPrevNext as bs, getSignedSleeveParameter as Ki, parseSleeveBoolean as Gl, ObjectType as Le, dynamicRoundNumber as ki, getProjectImplantDefaults as Lp, convertColor as Yo, UniversalFilePicker as ql, uploadObjectToContext as vs, useReactivity as Th, takeStlScreenshot as Zi, mapColorFromVtk as Op, CustomUndoData as Wl, UndoEvent as zl, ViewMode as Nn, Maxilla0Mandible as an, takeImplantPartScreenshot as ea, mapColorToVtk as Tc, ItemStatus as pt, getProjectPinDefaults as Ch, JawboneType as Jt, MTeethView as wr, ToothEditMode as Ta, HoverIconType as Fn, ViewPreset as Cc, getMandibleTeethNames as ys, getMaxillaTeethNames as _s, ImportTypeLabels as Nh, PresenterWindow3D as Lh, ViewSTL3DPreview as Oh, viewports as Dp, getTeethLibraryList as Ap, xml2json as Dh, StlObject as Ah, TReconstructionDesign as ve, TCADObjectType as It, eOType as ut, TReconstructionPreSelectedMode as pa, TReconstructionPreSelectedWorkflow as Rh, TReconstructionWorkflow as We, loadTeethLibToWasm as uu, CADTeethView as Nc, CADTeethViewLegend as Mh, ImportObjectsFromPlanner as Rp, ActiveRecontstruction as Ph, ReconstructionType as xh, takeViewScreenshot as Ko, TMode as Sr, getEmptyErpFile as jh, getEmptyImplantObj as Fh, getEmptyPinObj as $h, WizardType as we, makePath as Ji, statIfFile as Xi, createImageDataFromProject as kh, VolumeInterpolationType as Vh, convertToothName as vo, ToothMarker as Bh, calculateOwnerNormal as Uh, takeVtkActorScreenshotWithCamera as Gh, useOverlayComponents as cu, Observable as so, ObjectList as du, AnchorPosition as Ql, ScalarBarWidget as Mp, ScalarBar as nn, parseMenuItems as pu, DocumentContext as ws, measurementToolModel as mu, MouseMode as kn, provideProjectContext as Ss, setupVtkOverrides as Is, checkVolumeTextureLoad as Wh, Set3DOrientationType as Ll, UploadPreviewGeneratorWasm as zh, UploadPreviewGenerator as Hh, unlinkAllCadPartFiles as Yh, unlinkTeethLibsFromWasm as Kh, createImageDataFromWasm as Zh } from "@xlabmedical/medic-web-engine";
import Pn from "primevue/select";
import Jh from "primevue/orderlist";
import { AppWizard as Pp } from "@xlabmedical/web-cad-platform";
import { useDialog as Aa } from "primevue/usedialog";
import Xh from "primevue/progressspinner/style";
import { useConfirm as mi } from "primevue/useconfirm";
import { mat4 as qi, vec3 as yo } from "gl-matrix";
import Gn from "primevue/dialog";
import qh from "primevue/inputtext/style";
import xp from "primevue/inputnumber";
import { defineStore as Qh, storeToRefs as Co } from "pinia";
import { useResizeObserver as eb } from "@vueuse/core";
import tb from "primevue/progressspinner";
import fi from "jszip";
import { ProjectFileType as ga, ResponseStatusEnum as Qa } from "@xlabmedical/medic-api";
import nb from "primevue/badge";
import jp from "primevue/ripple";
import ab from "primevue/button/style";
import ob from "primevue/focustrap";
import lb from "primevue/portal";
import ib from "primevue/image/style";
import sb from "primevue/iconfield";
import rb from "primevue/inputicon";
import ub from "primevue/virtualscroller";
import cb from "primevue/listbox/style";
import Js from "primevue/datepicker";
import Lc from "primevue/colorpicker";
import db from "primevue/checkbox";
import Qn from "primevue/floatlabel";
import pb from "primevue/floatlabel/style";
import mb from "primevue/textarea";
import tn from "primevue/radiobutton";
import fb from "primevue/toolbar/style";
import gi from "primevue/progressbar";
import gb from "primevue/steps/style";
import { useRouter as Es, useRoute as gl } from "vue-router";
import hb from "primevue/divider";
/*!
  * shared v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function La(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Oc = {};
function bb(e) {
  Oc[e] || (Oc[e] = !0, La(e));
}
const Ya = typeof window < "u";
let Kn, No;
if (process.env.NODE_ENV !== "production") {
  const e = Ya && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Kn = (t) => {
    e.mark(t);
  }, No = (t, n, a) => {
    e.measure(t, n, a), e.clearMarks(n), e.clearMarks(a);
  });
}
const vb = /\{([0-9a-zA-Z]+)\}/g;
function Ts(e, ...t) {
  return t.length === 1 && jt(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(vb, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const Za = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), yb = (e, t, n) => _b({ l: e, k: t, s: n }), _b = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), _n = (e) => typeof e == "number" && isFinite(e), wb = (e) => fu(e) === "[object Date]", Qi = (e) => fu(e) === "[object RegExp]", Cs = (e) => xt(e) && Object.keys(e).length === 0, wn = Object.assign, Sb = Object.create, Ut = (e = null) => Sb(e);
let Dc;
const _o = () => Dc || (Dc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Ut());
function Ac(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Rc(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Ib(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (a, o, l) => `${o}="${Rc(l)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (a, o, l) => `${o}='${Rc(l)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && La("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((a) => {
    e = e.replace(a, "$1javascript&#58;");
  }), e;
}
const Eb = Object.prototype.hasOwnProperty;
function ma(e, t) {
  return Eb.call(e, t);
}
const cn = Array.isArray, Xt = (e) => typeof e == "function", tt = (e) => typeof e == "string", rn = (e) => typeof e == "boolean", jt = (e) => e !== null && typeof e == "object", Tb = (e) => jt(e) && Xt(e.then) && Xt(e.catch), Fp = Object.prototype.toString, fu = (e) => Fp.call(e), xt = (e) => fu(e) === "[object Object]", Cb = (e) => e == null ? "" : cn(e) || xt(e) && e.toString === Fp ? JSON.stringify(e, null, 2) : String(e);
function gu(e, t = "") {
  return e.reduce((n, a, o) => o === 0 ? n + a : n + t + a, "");
}
const Mc = 2;
function Nb(e, t = 0, n = e.length) {
  const a = e.split(/\r?\n/);
  let o = 0;
  const l = [];
  for (let s = 0; s < a.length; s++)
    if (o += a[s].length + 1, o >= t) {
      for (let i = s - Mc; i <= s + Mc || n > o; i++) {
        if (i < 0 || i >= a.length)
          continue;
        const c = i + 1;
        l.push(`${c}${" ".repeat(3 - String(c).length)}|  ${a[i]}`);
        const u = a[i].length;
        if (i === s) {
          const p = t - (o - u) + 1, b = Math.max(1, n > o ? u - p : n - t);
          l.push("   |  " + " ".repeat(p) + "^".repeat(b));
        } else if (i > s) {
          if (n > o) {
            const p = Math.max(Math.min(n - o, u), 1);
            l.push("   |  " + "^".repeat(p));
          }
          o += u + 1;
        }
      }
      break;
    }
  return l.join(`
`);
}
function Lb() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, a) {
      const o = e.get(n);
      o && o.push(a) || e.set(n, [a]);
    },
    off(n, a) {
      const o = e.get(n);
      o && o.splice(o.indexOf(a) >>> 0, 1);
    },
    emit(n, a) {
      (e.get(n) || []).slice().map((o) => o(a)), (e.get("*") || []).slice().map((o) => o(n, a));
    }
  };
}
const Ni = (e) => !jt(e) || cn(e);
function Vi(e, t) {
  if (Ni(e) || Ni(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: a, des: o } = n.pop();
    Object.keys(a).forEach((l) => {
      l !== "__proto__" && (jt(a[l]) && !jt(o[l]) && (o[l] = Array.isArray(a[l]) ? [] : Ut()), Ni(o[l]) || Ni(a[l]) ? o[l] = a[l] : n.push({ src: a[l], des: o[l] }));
    });
  }
}
/*!
  * message-compiler v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Ob(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Ir(e, t, n) {
  return { start: e, end: t };
}
const ht = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Db = 17, Ab = {
  // tokenizer error messages
  [ht.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [ht.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [ht.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [ht.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [ht.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [ht.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [ht.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [ht.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [ht.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [ht.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [ht.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [ht.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [ht.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [ht.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [ht.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [ht.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function hl(e, t, n = {}) {
  const { domain: a, messages: o, args: l } = n, s = process.env.NODE_ENV !== "production" ? Ts((o || Ab)[e] || "", ...l || []) : e, i = new SyntaxError(String(s));
  return i.code = e, t && (i.location = t), i.domain = a, i;
}
function Rb(e) {
  throw e;
}
const Mb = /<\/?[\w\s="/.':;#-\/]+>/, Pb = (e) => Mb.test(e), _a = " ", xb = "\r", Rn = `
`, jb = "\u2028", Fb = "\u2029";
function $b(e) {
  const t = e;
  let n = 0, a = 1, o = 1, l = 0;
  const s = (C) => t[C] === xb && t[C + 1] === Rn, i = (C) => t[C] === Rn, c = (C) => t[C] === Fb, u = (C) => t[C] === jb, p = (C) => s(C) || i(C) || c(C) || u(C), b = () => n, f = () => a, h = () => o, I = () => l, m = (C) => s(C) || c(C) || u(C) ? Rn : t[C], S = () => m(n), E = () => m(n + l);
  function g() {
    return l = 0, p(n) && (a++, o = 0), s(n) && n++, n++, o++, t[n];
  }
  function v() {
    return s(n + l) && l++, l++, t[n + l];
  }
  function T() {
    n = 0, a = 1, o = 1, l = 0;
  }
  function R(C = 0) {
    l = C;
  }
  function L() {
    const C = n + l;
    for (; C !== n; )
      g();
    l = 0;
  }
  return {
    index: b,
    line: f,
    column: h,
    peekOffset: I,
    charAt: m,
    currentChar: S,
    currentPeek: E,
    next: g,
    peek: v,
    reset: T,
    resetPeek: R,
    skipToPeek: L
  };
}
const Pa = void 0, kb = ".", Pc = "'", Vb = "tokenizer";
function Bb(e, t = {}) {
  const n = t.location !== !1, a = $b(e), o = () => a.index(), l = () => Ob(a.line(), a.column(), a.index()), s = l(), i = o(), c = {
    currentType: 13,
    offset: i,
    startLoc: s,
    endLoc: s,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: s,
    lastEndLoc: s,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => c, { onError: p } = t;
  function b(G, P, de, ...fe) {
    const ke = u();
    if (P.column += de, P.offset += de, p) {
      const le = n ? Ir(ke.startLoc, P) : null, pe = hl(G, le, {
        domain: Vb,
        args: fe
      });
      p(pe);
    }
  }
  function f(G, P, de) {
    G.endLoc = l(), G.currentType = P;
    const fe = { type: P };
    return n && (fe.loc = Ir(G.startLoc, G.endLoc)), de != null && (fe.value = de), fe;
  }
  const h = (G) => f(
    G,
    13
    /* TokenTypes.EOF */
  );
  function I(G, P) {
    return G.currentChar() === P ? (G.next(), P) : (b(ht.EXPECTED_TOKEN, l(), 0, P), "");
  }
  function m(G) {
    let P = "";
    for (; G.currentPeek() === _a || G.currentPeek() === Rn; )
      P += G.currentPeek(), G.peek();
    return P;
  }
  function S(G) {
    const P = m(G);
    return G.skipToPeek(), P;
  }
  function E(G) {
    if (G === Pa)
      return !1;
    const P = G.charCodeAt(0);
    return P >= 97 && P <= 122 || // a-z
    P >= 65 && P <= 90 || // A-Z
    P === 95;
  }
  function g(G) {
    if (G === Pa)
      return !1;
    const P = G.charCodeAt(0);
    return P >= 48 && P <= 57;
  }
  function v(G, P) {
    const { currentType: de } = P;
    if (de !== 2)
      return !1;
    m(G);
    const fe = E(G.currentPeek());
    return G.resetPeek(), fe;
  }
  function T(G, P) {
    const { currentType: de } = P;
    if (de !== 2)
      return !1;
    m(G);
    const fe = G.currentPeek() === "-" ? G.peek() : G.currentPeek(), ke = g(fe);
    return G.resetPeek(), ke;
  }
  function R(G, P) {
    const { currentType: de } = P;
    if (de !== 2)
      return !1;
    m(G);
    const fe = G.currentPeek() === Pc;
    return G.resetPeek(), fe;
  }
  function L(G, P) {
    const { currentType: de } = P;
    if (de !== 7)
      return !1;
    m(G);
    const fe = G.currentPeek() === ".";
    return G.resetPeek(), fe;
  }
  function C(G, P) {
    const { currentType: de } = P;
    if (de !== 8)
      return !1;
    m(G);
    const fe = E(G.currentPeek());
    return G.resetPeek(), fe;
  }
  function A(G, P) {
    const { currentType: de } = P;
    if (!(de === 7 || de === 11))
      return !1;
    m(G);
    const fe = G.currentPeek() === ":";
    return G.resetPeek(), fe;
  }
  function j(G, P) {
    const { currentType: de } = P;
    if (de !== 9)
      return !1;
    const fe = () => {
      const le = G.currentPeek();
      return le === "{" ? E(G.peek()) : le === "@" || le === "|" || le === ":" || le === "." || le === _a || !le ? !1 : le === Rn ? (G.peek(), fe()) : x(G, !1);
    }, ke = fe();
    return G.resetPeek(), ke;
  }
  function N(G) {
    m(G);
    const P = G.currentPeek() === "|";
    return G.resetPeek(), P;
  }
  function x(G, P = !0) {
    const de = (ke = !1, le = "") => {
      const pe = G.currentPeek();
      return pe === "{" || pe === "@" || !pe ? ke : pe === "|" ? !(le === _a || le === Rn) : pe === _a ? (G.peek(), de(!0, _a)) : pe === Rn ? (G.peek(), de(!0, Rn)) : !0;
    }, fe = de();
    return P && G.resetPeek(), fe;
  }
  function z(G, P) {
    const de = G.currentChar();
    return de === Pa ? Pa : P(de) ? (G.next(), de) : null;
  }
  function X(G) {
    const P = G.charCodeAt(0);
    return P >= 97 && P <= 122 || // a-z
    P >= 65 && P <= 90 || // A-Z
    P >= 48 && P <= 57 || // 0-9
    P === 95 || // _
    P === 36;
  }
  function H(G) {
    return z(G, X);
  }
  function M(G) {
    const P = G.charCodeAt(0);
    return P >= 97 && P <= 122 || // a-z
    P >= 65 && P <= 90 || // A-Z
    P >= 48 && P <= 57 || // 0-9
    P === 95 || // _
    P === 36 || // $
    P === 45;
  }
  function te(G) {
    return z(G, M);
  }
  function ne(G) {
    const P = G.charCodeAt(0);
    return P >= 48 && P <= 57;
  }
  function W(G) {
    return z(G, ne);
  }
  function se(G) {
    const P = G.charCodeAt(0);
    return P >= 48 && P <= 57 || // 0-9
    P >= 65 && P <= 70 || // A-F
    P >= 97 && P <= 102;
  }
  function be(G) {
    return z(G, se);
  }
  function Re(G) {
    let P = "", de = "";
    for (; P = W(G); )
      de += P;
    return de;
  }
  function U(G) {
    let P = "";
    for (; ; ) {
      const de = G.currentChar();
      if (de === "{" || de === "}" || de === "@" || de === "|" || !de)
        break;
      if (de === _a || de === Rn)
        if (x(G))
          P += de, G.next();
        else {
          if (N(G))
            break;
          P += de, G.next();
        }
      else
        P += de, G.next();
    }
    return P;
  }
  function ie(G) {
    S(G);
    let P = "", de = "";
    for (; P = te(G); )
      de += P;
    const fe = G.currentChar();
    if (fe && fe !== "}" && fe !== Pa && fe !== _a && fe !== Rn && fe !== "　") {
      const ke = K(G);
      return b(ht.INVALID_TOKEN_IN_PLACEHOLDER, l(), 0, de + ke), de + ke;
    }
    return G.currentChar() === Pa && b(ht.UNTERMINATED_CLOSING_BRACE, l(), 0), de;
  }
  function re(G) {
    S(G);
    let P = "";
    return G.currentChar() === "-" ? (G.next(), P += `-${Re(G)}`) : P += Re(G), G.currentChar() === Pa && b(ht.UNTERMINATED_CLOSING_BRACE, l(), 0), P;
  }
  function q(G) {
    return G !== Pc && G !== Rn;
  }
  function De(G) {
    S(G), I(G, "'");
    let P = "", de = "";
    for (; P = z(G, q); )
      P === "\\" ? de += _e(G) : de += P;
    const fe = G.currentChar();
    return fe === Rn || fe === Pa ? (b(ht.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, l(), 0), fe === Rn && (G.next(), I(G, "'")), de) : (I(G, "'"), de);
  }
  function _e(G) {
    const P = G.currentChar();
    switch (P) {
      case "\\":
      case "'":
        return G.next(), `\\${P}`;
      case "u":
        return xe(G, P, 4);
      case "U":
        return xe(G, P, 6);
      default:
        return b(ht.UNKNOWN_ESCAPE_SEQUENCE, l(), 0, P), "";
    }
  }
  function xe(G, P, de) {
    I(G, P);
    let fe = "";
    for (let ke = 0; ke < de; ke++) {
      const le = be(G);
      if (!le) {
        b(ht.INVALID_UNICODE_ESCAPE_SEQUENCE, l(), 0, `\\${P}${fe}${G.currentChar()}`);
        break;
      }
      fe += le;
    }
    return `\\${P}${fe}`;
  }
  function k(G) {
    return G !== "{" && G !== "}" && G !== _a && G !== Rn;
  }
  function K(G) {
    S(G);
    let P = "", de = "";
    for (; P = z(G, k); )
      de += P;
    return de;
  }
  function Ae(G) {
    let P = "", de = "";
    for (; P = H(G); )
      de += P;
    return de;
  }
  function me(G) {
    const P = (de) => {
      const fe = G.currentChar();
      return fe === "{" || fe === "@" || fe === "|" || fe === "(" || fe === ")" || !fe || fe === _a ? de : (de += fe, G.next(), P(de));
    };
    return P("");
  }
  function Ne(G) {
    S(G);
    const P = I(
      G,
      "|"
      /* TokenChars.Pipe */
    );
    return S(G), P;
  }
  function Ge(G, P) {
    let de = null;
    switch (G.currentChar()) {
      case "{":
        return P.braceNest >= 1 && b(ht.NOT_ALLOW_NEST_PLACEHOLDER, l(), 0), G.next(), de = f(
          P,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(G), P.braceNest++, de;
      case "}":
        return P.braceNest > 0 && P.currentType === 2 && b(ht.EMPTY_PLACEHOLDER, l(), 0), G.next(), de = f(
          P,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), P.braceNest--, P.braceNest > 0 && S(G), P.inLinked && P.braceNest === 0 && (P.inLinked = !1), de;
      case "@":
        return P.braceNest > 0 && b(ht.UNTERMINATED_CLOSING_BRACE, l(), 0), de = Ue(G, P) || h(P), P.braceNest = 0, de;
      default: {
        let ke = !0, le = !0, pe = !0;
        if (N(G))
          return P.braceNest > 0 && b(ht.UNTERMINATED_CLOSING_BRACE, l(), 0), de = f(P, 1, Ne(G)), P.braceNest = 0, P.inLinked = !1, de;
        if (P.braceNest > 0 && (P.currentType === 4 || P.currentType === 5 || P.currentType === 6))
          return b(ht.UNTERMINATED_CLOSING_BRACE, l(), 0), P.braceNest = 0, Ke(G, P);
        if (ke = v(G, P))
          return de = f(P, 4, ie(G)), S(G), de;
        if (le = T(G, P))
          return de = f(P, 5, re(G)), S(G), de;
        if (pe = R(G, P))
          return de = f(P, 6, De(G)), S(G), de;
        if (!ke && !le && !pe)
          return de = f(P, 12, K(G)), b(ht.INVALID_TOKEN_IN_PLACEHOLDER, l(), 0, de.value), S(G), de;
        break;
      }
    }
    return de;
  }
  function Ue(G, P) {
    const { currentType: de } = P;
    let fe = null;
    const ke = G.currentChar();
    switch ((de === 7 || de === 8 || de === 11 || de === 9) && (ke === Rn || ke === _a) && b(ht.INVALID_LINKED_FORMAT, l(), 0), ke) {
      case "@":
        return G.next(), fe = f(
          P,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), P.inLinked = !0, fe;
      case ".":
        return S(G), G.next(), f(
          P,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(G), G.next(), f(
          P,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return N(G) ? (fe = f(P, 1, Ne(G)), P.braceNest = 0, P.inLinked = !1, fe) : L(G, P) || A(G, P) ? (S(G), Ue(G, P)) : C(G, P) ? (S(G), f(P, 11, Ae(G))) : j(G, P) ? (S(G), ke === "{" ? Ge(G, P) || fe : f(P, 10, me(G))) : (de === 7 && b(ht.INVALID_LINKED_FORMAT, l(), 0), P.braceNest = 0, P.inLinked = !1, Ke(G, P));
    }
  }
  function Ke(G, P) {
    let de = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (P.braceNest > 0)
      return Ge(G, P) || h(P);
    if (P.inLinked)
      return Ue(G, P) || h(P);
    switch (G.currentChar()) {
      case "{":
        return Ge(G, P) || h(P);
      case "}":
        return b(ht.UNBALANCED_CLOSING_BRACE, l(), 0), G.next(), f(
          P,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ue(G, P) || h(P);
      default: {
        if (N(G))
          return de = f(P, 1, Ne(G)), P.braceNest = 0, P.inLinked = !1, de;
        if (x(G))
          return f(P, 0, U(G));
        break;
      }
    }
    return de;
  }
  function st() {
    const { currentType: G, offset: P, startLoc: de, endLoc: fe } = c;
    return c.lastType = G, c.lastOffset = P, c.lastStartLoc = de, c.lastEndLoc = fe, c.offset = o(), c.startLoc = l(), a.currentChar() === Pa ? f(
      c,
      13
      /* TokenTypes.EOF */
    ) : Ke(a, c);
  }
  return {
    nextToken: st,
    currentOffset: o,
    currentPosition: l,
    context: u
  };
}
const Ub = "parser", Gb = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Wb(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || n, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function zb(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function a(E, g, v, T, ...R) {
    const L = E.currentPosition();
    if (L.offset += T, L.column += T, n) {
      const C = t ? Ir(v, L) : null, A = hl(g, C, {
        domain: Ub,
        args: R
      });
      n(A);
    }
  }
  function o(E, g, v) {
    const T = { type: E };
    return t && (T.start = g, T.end = g, T.loc = { start: v, end: v }), T;
  }
  function l(E, g, v, T) {
    t && (E.end = g, E.loc && (E.loc.end = v));
  }
  function s(E, g) {
    const v = E.context(), T = o(3, v.offset, v.startLoc);
    return T.value = g, l(T, E.currentOffset(), E.currentPosition()), T;
  }
  function i(E, g) {
    const v = E.context(), { lastOffset: T, lastStartLoc: R } = v, L = o(5, T, R);
    return L.index = parseInt(g, 10), E.nextToken(), l(L, E.currentOffset(), E.currentPosition()), L;
  }
  function c(E, g) {
    const v = E.context(), { lastOffset: T, lastStartLoc: R } = v, L = o(4, T, R);
    return L.key = g, E.nextToken(), l(L, E.currentOffset(), E.currentPosition()), L;
  }
  function u(E, g) {
    const v = E.context(), { lastOffset: T, lastStartLoc: R } = v, L = o(9, T, R);
    return L.value = g.replace(Gb, Wb), E.nextToken(), l(L, E.currentOffset(), E.currentPosition()), L;
  }
  function p(E) {
    const g = E.nextToken(), v = E.context(), { lastOffset: T, lastStartLoc: R } = v, L = o(8, T, R);
    return g.type !== 11 ? (a(E, ht.UNEXPECTED_EMPTY_LINKED_MODIFIER, v.lastStartLoc, 0), L.value = "", l(L, T, R), {
      nextConsumeToken: g,
      node: L
    }) : (g.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wa(g)), L.value = g.value || "", l(L, E.currentOffset(), E.currentPosition()), {
      node: L
    });
  }
  function b(E, g) {
    const v = E.context(), T = o(7, v.offset, v.startLoc);
    return T.value = g, l(T, E.currentOffset(), E.currentPosition()), T;
  }
  function f(E) {
    const g = E.context(), v = o(6, g.offset, g.startLoc);
    let T = E.nextToken();
    if (T.type === 8) {
      const R = p(E);
      v.modifier = R.node, T = R.nextConsumeToken || E.nextToken();
    }
    switch (T.type !== 9 && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(T)), T = E.nextToken(), T.type === 2 && (T = E.nextToken()), T.type) {
      case 10:
        T.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(T)), v.key = b(E, T.value || "");
        break;
      case 4:
        T.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(T)), v.key = c(E, T.value || "");
        break;
      case 5:
        T.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(T)), v.key = i(E, T.value || "");
        break;
      case 6:
        T.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(T)), v.key = u(E, T.value || "");
        break;
      default: {
        a(E, ht.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const R = E.context(), L = o(7, R.offset, R.startLoc);
        return L.value = "", l(L, R.offset, R.startLoc), v.key = L, l(v, R.offset, R.startLoc), {
          nextConsumeToken: T,
          node: v
        };
      }
    }
    return l(v, E.currentOffset(), E.currentPosition()), {
      node: v
    };
  }
  function h(E) {
    const g = E.context(), v = g.currentType === 1 ? E.currentOffset() : g.offset, T = g.currentType === 1 ? g.endLoc : g.startLoc, R = o(2, v, T);
    R.items = [];
    let L = null;
    do {
      const j = L || E.nextToken();
      switch (L = null, j.type) {
        case 0:
          j.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(j)), R.items.push(s(E, j.value || ""));
          break;
        case 5:
          j.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(j)), R.items.push(i(E, j.value || ""));
          break;
        case 4:
          j.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(j)), R.items.push(c(E, j.value || ""));
          break;
        case 6:
          j.value == null && a(E, ht.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, wa(j)), R.items.push(u(E, j.value || ""));
          break;
        case 7: {
          const N = f(E);
          R.items.push(N.node), L = N.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const C = g.currentType === 1 ? g.lastOffset : E.currentOffset(), A = g.currentType === 1 ? g.lastEndLoc : E.currentPosition();
    return l(R, C, A), R;
  }
  function I(E, g, v, T) {
    const R = E.context();
    let L = T.items.length === 0;
    const C = o(1, g, v);
    C.cases = [], C.cases.push(T);
    do {
      const A = h(E);
      L || (L = A.items.length === 0), C.cases.push(A);
    } while (R.currentType !== 13);
    return L && a(E, ht.MUST_HAVE_MESSAGES_IN_PLURAL, v, 0), l(C, E.currentOffset(), E.currentPosition()), C;
  }
  function m(E) {
    const g = E.context(), { offset: v, startLoc: T } = g, R = h(E);
    return g.currentType === 13 ? R : I(E, v, T, R);
  }
  function S(E) {
    const g = Bb(E, wn({}, e)), v = g.context(), T = o(0, v.offset, v.startLoc);
    return t && T.loc && (T.loc.source = E), T.body = m(g), e.onCacheKey && (T.cacheKey = e.onCacheKey(E)), v.currentType !== 13 && a(g, ht.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, E[v.offset] || ""), l(T, g.currentOffset(), g.currentPosition()), T;
  }
  return { parse: S };
}
function wa(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Hb(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (l) => (n.helpers.add(l), l) };
}
function xc(e, t) {
  for (let n = 0; n < e.length; n++)
    hu(e[n], t);
}
function hu(e, t) {
  switch (e.type) {
    case 1:
      xc(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      xc(e.items, t);
      break;
    case 6: {
      hu(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Yb(e, t = {}) {
  const n = Hb(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && hu(e.body, n);
  const a = n.context();
  e.helpers = Array.from(a.helpers);
}
function Kb(e) {
  const t = e.body;
  return t.type === 2 ? jc(t) : t.cases.forEach((n) => jc(n)), e;
}
function jc(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const a = e.items[n];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = gu(t);
      for (let n = 0; n < e.items.length; n++) {
        const a = e.items[n];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const Zb = "minifier";
function Zo(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Zo(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let a = 0; a < n.length; a++)
        Zo(n[a]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let a = 0; a < n.length; a++)
        Zo(n[a]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Zo(t.key), t.k = t.key, delete t.key, t.modifier && (Zo(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw hl(ht.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Zb,
          args: [e.type]
        });
  }
  delete e.type;
}
const Jb = "parser";
function Xb(e, t) {
  const { filename: n, breakLineCode: a, needIndent: o } = t, l = t.location !== !1, s = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: o,
    indentLevel: 0
  };
  l && e.loc && (s.source = e.loc.source);
  const i = () => s;
  function c(m, S) {
    s.code += m;
  }
  function u(m, S = !0) {
    const E = S ? a : "";
    c(o ? E + "  ".repeat(m) : E);
  }
  function p(m = !0) {
    const S = ++s.indentLevel;
    m && u(S);
  }
  function b(m = !0) {
    const S = --s.indentLevel;
    m && u(S);
  }
  function f() {
    u(s.indentLevel);
  }
  return {
    context: i,
    push: c,
    indent: p,
    deindent: b,
    newline: f,
    helper: (m) => `_${m}`,
    needIndent: () => s.needIndent
  };
}
function qb(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), il(e, t.key), t.modifier ? (e.push(", "), il(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Qb(e, t) {
  const { helper: n, needIndent: a } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const o = t.items.length;
  for (let l = 0; l < o && (il(e, t.items[l]), l !== o - 1); l++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function ev(e, t) {
  const { helper: n, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const o = t.cases.length;
    for (let l = 0; l < o && (il(e, t.cases[l]), l !== o - 1); l++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function tv(e, t) {
  t.body ? il(e, t.body) : e.push("null");
}
function il(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      tv(e, t);
      break;
    case 1:
      ev(e, t);
      break;
    case 2:
      Qb(e, t);
      break;
    case 6:
      qb(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw hl(ht.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Jb,
          args: [t.type]
        });
  }
}
const nv = (e, t = {}) => {
  const n = tt(t.mode) ? t.mode : "normal", a = tt(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const o = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, l = t.needIndent ? t.needIndent : n !== "arrow", s = e.helpers || [], i = Xb(e, {
    filename: a,
    breakLineCode: o,
    needIndent: l
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(l), s.length > 0 && (i.push(`const { ${gu(s.map((p) => `${p}: _${p}`), ", ")} } = ctx`), i.newline()), i.push("return "), il(i, e), i.deindent(l), i.push("}"), delete e.helpers;
  const { code: c, map: u } = i.context();
  return {
    ast: e,
    code: c,
    map: u ? u.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function av(e, t = {}) {
  const n = wn({}, t), a = !!n.jit, o = !!n.minify, l = n.optimize == null ? !0 : n.optimize, i = zb(n).parse(e);
  return a ? (l && Kb(i), o && Zo(i), { ast: i, code: "" }) : (Yb(i, n), nv(i, n));
}
/*!
  * core-base v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function ov() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (_o().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (_o().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function ha(e) {
  return jt(e) && bu(e) === 0 && (ma(e, "b") || ma(e, "body"));
}
const $p = ["b", "body"];
function lv(e) {
  return po(e, $p);
}
const kp = ["c", "cases"];
function iv(e) {
  return po(e, kp, []);
}
const Vp = ["s", "static"];
function sv(e) {
  return po(e, Vp);
}
const Bp = ["i", "items"];
function rv(e) {
  return po(e, Bp, []);
}
const Up = ["t", "type"];
function bu(e) {
  return po(e, Up);
}
const Gp = ["v", "value"];
function Li(e, t) {
  const n = po(e, Gp);
  if (n != null)
    return n;
  throw ei(t);
}
const Wp = ["m", "modifier"];
function uv(e) {
  return po(e, Wp);
}
const zp = ["k", "key"];
function cv(e) {
  const t = po(e, zp);
  if (t)
    return t;
  throw ei(
    6
    /* NodeTypes.Linked */
  );
}
function po(e, t, n) {
  for (let a = 0; a < t.length; a++) {
    const o = t[a];
    if (ma(e, o) && e[o] != null)
      return e[o];
  }
  return n;
}
const Hp = [
  ...$p,
  ...kp,
  ...Vp,
  ...Bp,
  ...zp,
  ...Wp,
  ...Gp,
  ...Up
];
function ei(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Xs(e) {
  return (n) => dv(n, e);
}
function dv(e, t) {
  const n = lv(t);
  if (n == null)
    throw ei(
      0
      /* NodeTypes.Resource */
    );
  if (bu(n) === 1) {
    const l = iv(n);
    return e.plural(l.reduce((s, i) => [
      ...s,
      Fc(e, i)
    ], []));
  } else
    return Fc(e, n);
}
function Fc(e, t) {
  const n = sv(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const a = rv(t).reduce((o, l) => [...o, Er(e, l)], []);
    return e.normalize(a);
  }
}
function Er(e, t) {
  const n = bu(t);
  switch (n) {
    case 3:
      return Li(t, n);
    case 9:
      return Li(t, n);
    case 4: {
      const a = t;
      if (ma(a, "k") && a.k)
        return e.interpolate(e.named(a.k));
      if (ma(a, "key") && a.key)
        return e.interpolate(e.named(a.key));
      throw ei(n);
    }
    case 5: {
      const a = t;
      if (ma(a, "i") && _n(a.i))
        return e.interpolate(e.list(a.i));
      if (ma(a, "index") && _n(a.index))
        return e.interpolate(e.list(a.index));
      throw ei(n);
    }
    case 6: {
      const a = t, o = uv(a), l = cv(a);
      return e.linked(Er(e, l), o ? Er(e, o) : void 0, e.type);
    }
    case 7:
      return Li(t, n);
    case 8:
      return Li(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const pv = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function mv(e, t) {
  t && Pb(e) && La(Ts(pv, { source: e }));
}
const fv = (e) => e;
let Oi = Ut();
function gv(e, t = {}) {
  let n = !1;
  const a = t.onError || Rb;
  return t.onError = (o) => {
    n = !0, a(o);
  }, { ...av(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function hv(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && tt(e)) {
    const n = rn(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && mv(e, n);
    const o = (t.onCacheKey || fv)(e), l = Oi[o];
    if (l)
      return l;
    const { ast: s, detectError: i } = gv(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), c = Xs(s);
    return i ? c : Oi[o] = c;
  } else {
    if (process.env.NODE_ENV !== "production" && !ha(e))
      return La(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), (() => e);
    const n = e.cacheKey;
    if (n) {
      const a = Oi[n];
      return a || (Oi[n] = Xs(e));
    } else
      return Xs(e);
  }
}
let ti = null;
function bv(e) {
  ti = e;
}
function vv(e, t, n) {
  ti && ti.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const yv = /* @__PURE__ */ _v("function:translate");
function _v(e) {
  return (t) => ti && ti.emit(e, t);
}
const Mn = {
  INVALID_ARGUMENT: Db,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, wv = 24;
function Ba(e) {
  return hl(e, null, process.env.NODE_ENV !== "production" ? { messages: Sv } : void 0);
}
const Sv = {
  [Mn.INVALID_ARGUMENT]: "Invalid arguments",
  [Mn.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Mn.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Mn.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Mn.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Mn.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Mn.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function vu(e, t) {
  return t.locale != null ? $c(t.locale) : $c(e.locale);
}
let qs;
function $c(e) {
  if (tt(e))
    return e;
  if (Xt(e)) {
    if (e.resolvedOnce && qs != null)
      return qs;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Tb(t))
        throw Ba(Mn.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return qs = t;
    } else
      throw Ba(Mn.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Ba(Mn.NOT_SUPPORT_LOCALE_TYPE);
}
function Iv(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...cn(t) ? t : jt(t) ? Object.keys(t) : tt(t) ? [t] : [n]
  ])];
}
function Yp(e, t, n) {
  const a = tt(n) ? n : es, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let l = o.__localeChainCache.get(a);
  if (!l) {
    l = [];
    let s = [n];
    for (; cn(s); )
      s = kc(l, s, t);
    const i = cn(t) || !xt(t) ? t : t.default ? t.default : null;
    s = tt(i) ? [i] : i, cn(s) && kc(l, s, !1), o.__localeChainCache.set(a, l);
  }
  return l;
}
function kc(e, t, n) {
  let a = !0;
  for (let o = 0; o < t.length && rn(a); o++) {
    const l = t[o];
    tt(l) && (a = Ev(e, t[o], n));
  }
  return a;
}
function Ev(e, t, n) {
  let a;
  const o = t.split("-");
  do {
    const l = o.join("-");
    a = Tv(e, l, n), o.splice(-1, 1);
  } while (o.length && a === !0);
  return a;
}
function Tv(e, t, n) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (cn(n) || xt(n)) && n[o] && (a = n[o]);
  }
  return a;
}
const mo = [];
mo[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
mo[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
mo[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
mo[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
mo[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
mo[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
mo[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Cv = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Nv(e) {
  return Cv.test(e);
}
function Lv(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Ov(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function Dv(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Nv(t) ? Lv(t) : "*" + t;
}
function Av(e) {
  const t = [];
  let n = -1, a = 0, o = 0, l, s, i, c, u, p, b;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    s === void 0 ? s = i : s += i;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    s !== void 0 && (t.push(s), s = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), o++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, a = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, s === void 0 || (s = Dv(s), s === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const I = e[n + 1];
    if (a === 5 && I === "'" || a === 6 && I === '"')
      return n++, i = "\\" + I, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (n++, l = e[n], !(l === "\\" && h())) {
      if (c = Ov(l), b = mo[a], u = b[c] || b.l || 8, u === 8 || (a = u[0], u[1] !== void 0 && (p = f[u[1]], p && (i = l, p() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const Vc = /* @__PURE__ */ new Map();
function Rv(e, t) {
  return jt(e) ? e[t] : null;
}
function Mv(e, t) {
  if (!jt(e))
    return null;
  let n = Vc.get(t);
  if (n || (n = Av(t), n && Vc.set(t, n)), !n)
    return null;
  const a = n.length;
  let o = e, l = 0;
  for (; l < a; ) {
    const s = n[l];
    if (Hp.includes(s) && ha(o))
      return null;
    const i = o[s];
    if (i === void 0 || Xt(o))
      return null;
    o = i, l++;
  }
  return o;
}
const Un = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Pv = 8, xv = {
  [Un.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Un.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Un.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Un.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Un.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Un.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Un.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Lo(e, ...t) {
  return Ts(xv[e], ...t);
}
const jv = "11.1.12", Ns = -1, es = "en-US", ts = "", Bc = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Fv() {
  return {
    upper: (e, t) => t === "text" && tt(e) ? e.toUpperCase() : t === "vnode" && jt(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && tt(e) ? e.toLowerCase() : t === "vnode" && jt(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && tt(e) ? Bc(e) : t === "vnode" && jt(e) && "__v_isVNode" in e ? Bc(e.children) : e
  };
}
let Kp;
function $v(e) {
  Kp = e;
}
let Zp;
function kv(e) {
  Zp = e;
}
let Jp;
function Vv(e) {
  Jp = e;
}
let Xp = null;
const Bv = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Xp = e;
}, Uv = /* @__NO_SIDE_EFFECTS__ */ () => Xp;
let qp = null;
const Uc = (e) => {
  qp = e;
}, Gv = () => qp;
let Gc = 0;
function Wv(e = {}) {
  const t = Xt(e.onWarn) ? e.onWarn : La, n = tt(e.version) ? e.version : jv, a = tt(e.locale) || Xt(e.locale) ? e.locale : es, o = Xt(a) ? es : a, l = cn(e.fallbackLocale) || xt(e.fallbackLocale) || tt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, s = xt(e.messages) ? e.messages : Qs(o), i = xt(e.datetimeFormats) ? e.datetimeFormats : Qs(o), c = xt(e.numberFormats) ? e.numberFormats : Qs(o), u = wn(Ut(), e.modifiers, Fv()), p = e.pluralRules || Ut(), b = Xt(e.missing) ? e.missing : null, f = rn(e.missingWarn) || Qi(e.missingWarn) ? e.missingWarn : !0, h = rn(e.fallbackWarn) || Qi(e.fallbackWarn) ? e.fallbackWarn : !0, I = !!e.fallbackFormat, m = !!e.unresolving, S = Xt(e.postTranslation) ? e.postTranslation : null, E = xt(e.processor) ? e.processor : null, g = rn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, v = !!e.escapeParameter, T = Xt(e.messageCompiler) ? e.messageCompiler : Kp;
  process.env.NODE_ENV !== "production" && Xt(e.messageCompiler) && bb(Lo(Un.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const R = Xt(e.messageResolver) ? e.messageResolver : Zp || Rv, L = Xt(e.localeFallbacker) ? e.localeFallbacker : Jp || Iv, C = jt(e.fallbackContext) ? e.fallbackContext : void 0, A = e, j = jt(A.__datetimeFormatters) ? A.__datetimeFormatters : /* @__PURE__ */ new Map(), N = jt(A.__numberFormatters) ? A.__numberFormatters : /* @__PURE__ */ new Map(), x = jt(A.__meta) ? A.__meta : {};
  Gc++;
  const z = {
    version: n,
    cid: Gc,
    locale: a,
    fallbackLocale: l,
    messages: s,
    modifiers: u,
    pluralRules: p,
    missing: b,
    missingWarn: f,
    fallbackWarn: h,
    fallbackFormat: I,
    unresolving: m,
    postTranslation: S,
    processor: E,
    warnHtmlMessage: g,
    escapeParameter: v,
    messageCompiler: T,
    messageResolver: R,
    localeFallbacker: L,
    fallbackContext: C,
    onWarn: t,
    __meta: x
  };
  return z.datetimeFormats = i, z.numberFormats = c, z.__datetimeFormatters = j, z.__numberFormatters = N, process.env.NODE_ENV !== "production" && (z.__v_emitter = A.__v_emitter != null ? A.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && vv(z, n, x), z;
}
const Qs = (e) => ({ [e]: Ut() });
function Ls(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Qp(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function yu(e, t, n, a, o) {
  const { missing: l, onWarn: s } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: o,
      groupId: `${o}:${t}`
    });
  }
  if (l !== null) {
    const i = l(e, n, t, o);
    return tt(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Qp(a, t) && s(Lo(Un.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Ol(e, t, n) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function em(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function zv(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let a = n + 1; a < t.length; a++)
    if (em(e, t[a]))
      return !0;
  return !1;
}
const Wc = typeof Intl < "u", tm = {
  dateTimeFormat: Wc && typeof Intl.DateTimeFormat < "u",
  numberFormat: Wc && typeof Intl.NumberFormat < "u"
};
function zc(e, ...t) {
  const { datetimeFormats: n, unresolving: a, fallbackLocale: o, onWarn: l, localeFallbacker: s } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !tm.dateTimeFormat)
    return l(Lo(Un.CANNOT_FORMAT_DATE)), ts;
  const [c, u, p, b] = Tr(...t), f = rn(p.missingWarn) ? p.missingWarn : e.missingWarn, h = rn(p.fallbackWarn) ? p.fallbackWarn : e.fallbackWarn, I = !!p.part, m = vu(e, p), S = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    m
  );
  if (!tt(c) || c === "")
    return new Intl.DateTimeFormat(m, b).format(u);
  let E = {}, g, v = null, T = m, R = null;
  const L = "datetime format";
  for (let j = 0; j < S.length; j++) {
    if (g = R = S[j], process.env.NODE_ENV !== "production" && m !== g && Ls(h, c) && l(Lo(Un.FALLBACK_TO_DATE_FORMAT, {
      key: c,
      target: g
    })), process.env.NODE_ENV !== "production" && m !== g) {
      const N = e.__v_emitter;
      N && N.emit("fallback", {
        type: L,
        key: c,
        from: T,
        to: R,
        groupId: `${L}:${c}`
      });
    }
    if (E = n[g] || {}, v = E[c], xt(v))
      break;
    yu(e, c, g, f, L), T = R;
  }
  if (!xt(v) || !tt(g))
    return a ? Ns : c;
  let C = `${g}__${c}`;
  Cs(b) || (C = `${C}__${JSON.stringify(b)}`);
  let A = i.get(C);
  return A || (A = new Intl.DateTimeFormat(g, wn({}, v, b)), i.set(C, A)), I ? A.formatToParts(u) : A.format(u);
}
const nm = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Tr(...e) {
  const [t, n, a, o] = e, l = Ut();
  let s = Ut(), i;
  if (tt(t)) {
    const c = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!c)
      throw Ba(Mn.INVALID_ISO_DATE_ARGUMENT);
    const u = c[3] ? c[3].trim().startsWith("T") ? `${c[1].trim()}${c[3].trim()}` : `${c[1].trim()}T${c[3].trim()}` : c[1].trim();
    i = new Date(u);
    try {
      i.toISOString();
    } catch {
      throw Ba(Mn.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (wb(t)) {
    if (isNaN(t.getTime()))
      throw Ba(Mn.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (_n(t))
    i = t;
  else
    throw Ba(Mn.INVALID_ARGUMENT);
  return tt(n) ? l.key = n : xt(n) && Object.keys(n).forEach((c) => {
    nm.includes(c) ? s[c] = n[c] : l[c] = n[c];
  }), tt(a) ? l.locale = a : xt(a) && (s = a), xt(o) && (s = o), [l.key || "", i, l, s];
}
function Hc(e, t, n) {
  const a = e;
  for (const o in n) {
    const l = `${t}__${o}`;
    a.__datetimeFormatters.has(l) && a.__datetimeFormatters.delete(l);
  }
}
function Yc(e, ...t) {
  const { numberFormats: n, unresolving: a, fallbackLocale: o, onWarn: l, localeFallbacker: s } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !tm.numberFormat)
    return l(Lo(Un.CANNOT_FORMAT_NUMBER)), ts;
  const [c, u, p, b] = Cr(...t), f = rn(p.missingWarn) ? p.missingWarn : e.missingWarn, h = rn(p.fallbackWarn) ? p.fallbackWarn : e.fallbackWarn, I = !!p.part, m = vu(e, p), S = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    m
  );
  if (!tt(c) || c === "")
    return new Intl.NumberFormat(m, b).format(u);
  let E = {}, g, v = null, T = m, R = null;
  const L = "number format";
  for (let j = 0; j < S.length; j++) {
    if (g = R = S[j], process.env.NODE_ENV !== "production" && m !== g && Ls(h, c) && l(Lo(Un.FALLBACK_TO_NUMBER_FORMAT, {
      key: c,
      target: g
    })), process.env.NODE_ENV !== "production" && m !== g) {
      const N = e.__v_emitter;
      N && N.emit("fallback", {
        type: L,
        key: c,
        from: T,
        to: R,
        groupId: `${L}:${c}`
      });
    }
    if (E = n[g] || {}, v = E[c], xt(v))
      break;
    yu(e, c, g, f, L), T = R;
  }
  if (!xt(v) || !tt(g))
    return a ? Ns : c;
  let C = `${g}__${c}`;
  Cs(b) || (C = `${C}__${JSON.stringify(b)}`);
  let A = i.get(C);
  return A || (A = new Intl.NumberFormat(g, wn({}, v, b)), i.set(C, A)), I ? A.formatToParts(u) : A.format(u);
}
const am = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Cr(...e) {
  const [t, n, a, o] = e, l = Ut();
  let s = Ut();
  if (!_n(t))
    throw Ba(Mn.INVALID_ARGUMENT);
  const i = t;
  return tt(n) ? l.key = n : xt(n) && Object.keys(n).forEach((c) => {
    am.includes(c) ? s[c] = n[c] : l[c] = n[c];
  }), tt(a) ? l.locale = a : xt(a) && (s = a), xt(o) && (s = o), [l.key || "", i, l, s];
}
function Kc(e, t, n) {
  const a = e;
  for (const o in n) {
    const l = `${t}__${o}`;
    a.__numberFormatters.has(l) && a.__numberFormatters.delete(l);
  }
}
const Hv = (e) => e, Yv = (e) => "", Kv = "text", Zv = (e) => e.length === 0 ? "" : gu(e), Jv = Cb;
function Zc(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Xv(e) {
  const t = _n(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (_n(e.named.count) || _n(e.named.n)) ? _n(e.named.count) ? e.named.count : _n(e.named.n) ? e.named.n : t : t;
}
function qv(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Qv(e = {}) {
  const t = e.locale, n = Xv(e), a = jt(e.pluralRules) && tt(t) && Xt(e.pluralRules[t]) ? e.pluralRules[t] : Zc, o = jt(e.pluralRules) && tt(t) && Xt(e.pluralRules[t]) ? Zc : void 0, l = (E) => E[a(n, E.length, o)], s = e.list || [], i = (E) => s[E], c = e.named || Ut();
  _n(e.pluralIndex) && qv(n, c);
  const u = (E) => c[E];
  function p(E, g) {
    const v = Xt(e.messages) ? e.messages(E, !!g) : jt(e.messages) ? e.messages[E] : !1;
    return v || (e.parent ? e.parent.message(E) : Yv);
  }
  const b = (E) => e.modifiers ? e.modifiers[E] : Hv, f = xt(e.processor) && Xt(e.processor.normalize) ? e.processor.normalize : Zv, h = xt(e.processor) && Xt(e.processor.interpolate) ? e.processor.interpolate : Jv, I = xt(e.processor) && tt(e.processor.type) ? e.processor.type : Kv, S = {
    list: i,
    named: u,
    plural: l,
    linked: (E, ...g) => {
      const [v, T] = g;
      let R = "text", L = "";
      g.length === 1 ? jt(v) ? (L = v.modifier || L, R = v.type || R) : tt(v) && (L = v || L) : g.length === 2 && (tt(v) && (L = v || L), tt(T) && (R = T || R));
      const C = p(E, !0)(S), A = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        R === "vnode" && cn(C) && L ? C[0] : C
      );
      return L ? b(L)(A, R) : A;
    },
    message: p,
    type: I,
    interpolate: h,
    normalize: f,
    values: wn(Ut(), s, c)
  };
  return S;
}
const Jc = () => "", ta = (e) => Xt(e);
function Xc(e, ...t) {
  const { fallbackFormat: n, postTranslation: a, unresolving: o, messageCompiler: l, fallbackLocale: s, messages: i } = e, [c, u] = Nr(...t), p = rn(u.missingWarn) ? u.missingWarn : e.missingWarn, b = rn(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, f = rn(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, h = !!u.resolvedMessage, I = tt(u.default) || rn(u.default) ? rn(u.default) ? l ? c : () => c : u.default : n ? l ? c : () => c : null, m = n || I != null && (tt(I) || Xt(I)), S = vu(e, u);
  f && ey(u);
  let [E, g, v] = h ? [
    c,
    S,
    i[S] || Ut()
  ] : om(e, c, S, s, b, p), T = E, R = c;
  if (!h && !(tt(T) || ha(T) || ta(T)) && m && (T = I, R = T), !h && (!(tt(T) || ha(T) || ta(T)) || !tt(g)))
    return o ? Ns : c;
  if (process.env.NODE_ENV !== "production" && tt(T) && e.messageCompiler == null)
    return La(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${c}'.`), c;
  let L = !1;
  const C = () => {
    L = !0;
  }, A = ta(T) ? T : lm(e, c, g, T, R, C);
  if (L)
    return T;
  const j = oy(e, g, v, u), N = Qv(j), x = ty(e, A, N);
  let z = a ? a(x, c) : x;
  if (f && tt(z) && (z = Ib(z)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const X = {
      timestamp: Date.now(),
      key: tt(c) ? c : ta(T) ? T.key : "",
      locale: g || (ta(T) ? T.locale : ""),
      format: tt(T) ? T : ta(T) ? T.source : "",
      message: z
    };
    X.meta = wn({}, e.__meta, /* @__PURE__ */ Uv() || {}), yv(X);
  }
  return z;
}
function ey(e) {
  cn(e.list) ? e.list = e.list.map((t) => tt(t) ? Ac(t) : t) : jt(e.named) && Object.keys(e.named).forEach((t) => {
    tt(e.named[t]) && (e.named[t] = Ac(e.named[t]));
  });
}
function om(e, t, n, a, o, l) {
  const { messages: s, onWarn: i, messageResolver: c, localeFallbacker: u } = e, p = u(e, a, n);
  let b = Ut(), f, h = null, I = n, m = null;
  const S = "translate";
  for (let E = 0; E < p.length; E++) {
    if (f = m = p[E], process.env.NODE_ENV !== "production" && n !== f && !em(n, f) && Ls(o, t) && i(Lo(Un.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: f
    })), process.env.NODE_ENV !== "production" && n !== f) {
      const R = e.__v_emitter;
      R && R.emit("fallback", {
        type: S,
        key: t,
        from: I,
        to: m,
        groupId: `${S}:${t}`
      });
    }
    b = s[f] || Ut();
    let g = null, v, T;
    if (process.env.NODE_ENV !== "production" && Ya && (g = window.performance.now(), v = "intlify-message-resolve-start", T = "intlify-message-resolve-end", Kn && Kn(v)), (h = c(b, t)) === null && (h = b[t]), process.env.NODE_ENV !== "production" && Ya) {
      const R = window.performance.now(), L = e.__v_emitter;
      L && g && h && L.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: h,
        time: R - g,
        groupId: `${S}:${t}`
      }), v && T && Kn && No && (Kn(T), No("intlify message resolve", v, T));
    }
    if (tt(h) || ha(h) || ta(h))
      break;
    if (!zv(f, p)) {
      const R = yu(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        f,
        l,
        S
      );
      R !== t && (h = R);
    }
    I = m;
  }
  return [h, f, b];
}
function lm(e, t, n, a, o, l) {
  const { messageCompiler: s, warnHtmlMessage: i } = e;
  if (ta(a)) {
    const f = a;
    return f.locale = f.locale || n, f.key = f.key || t, f;
  }
  if (s == null) {
    const f = (() => a);
    return f.locale = n, f.key = t, f;
  }
  let c = null, u, p;
  process.env.NODE_ENV !== "production" && Ya && (c = window.performance.now(), u = "intlify-message-compilation-start", p = "intlify-message-compilation-end", Kn && Kn(u));
  const b = s(a, ny(e, n, o, a, i, l));
  if (process.env.NODE_ENV !== "production" && Ya) {
    const f = window.performance.now(), h = e.__v_emitter;
    h && c && h.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: f - c,
      groupId: `translate:${t}`
    }), u && p && Kn && No && (Kn(p), No("intlify message compilation", u, p));
  }
  return b.locale = n, b.key = t, b.source = a, b;
}
function ty(e, t, n) {
  let a = null, o, l;
  process.env.NODE_ENV !== "production" && Ya && (a = window.performance.now(), o = "intlify-message-evaluation-start", l = "intlify-message-evaluation-end", Kn && Kn(o));
  const s = t(n);
  if (process.env.NODE_ENV !== "production" && Ya) {
    const i = window.performance.now(), c = e.__v_emitter;
    c && a && c.emit("message-evaluation", {
      type: "message-evaluation",
      value: s,
      time: i - a,
      groupId: `translate:${t.key}`
    }), o && l && Kn && No && (Kn(l), No("intlify message evaluation", o, l));
  }
  return s;
}
function Nr(...e) {
  const [t, n, a] = e, o = Ut();
  if (!tt(t) && !_n(t) && !ta(t) && !ha(t))
    throw Ba(Mn.INVALID_ARGUMENT);
  const l = _n(t) ? String(t) : (ta(t), t);
  return _n(n) ? o.plural = n : tt(n) ? o.default = n : xt(n) && !Cs(n) ? o.named = n : cn(n) && (o.list = n), _n(a) ? o.plural = a : tt(a) ? o.default = a : xt(a) && wn(o, a), [l, o];
}
function ny(e, t, n, a, o, l) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (s) => {
      if (l && l(s), process.env.NODE_ENV !== "production") {
        const i = ay(a), c = `Message compilation error: ${s.message}`, u = s.location && i && Nb(i, s.location.start.offset, s.location.end.offset), p = e.__v_emitter;
        p && i && p.emit("compile-error", {
          message: i,
          error: s.message,
          start: s.location && s.location.start.offset,
          end: s.location && s.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(u ? `${c}
${u}` : c);
      } else
        throw s;
    },
    onCacheKey: (s) => yb(t, n, s)
  };
}
function ay(e) {
  if (tt(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function oy(e, t, n, a) {
  const { modifiers: o, pluralRules: l, messageResolver: s, fallbackLocale: i, fallbackWarn: c, missingWarn: u, fallbackContext: p } = e, f = {
    locale: t,
    modifiers: o,
    pluralRules: l,
    messages: (h, I) => {
      let m = s(n, h);
      if (m == null && (p || I)) {
        const [, , S] = om(
          p || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          h,
          t,
          i,
          c,
          u
        );
        m = s(S, h);
      }
      if (tt(m) || ha(m)) {
        let S = !1;
        const g = lm(e, h, t, m, h, () => {
          S = !0;
        });
        return S ? Jc : g;
      } else return ta(m) ? m : Jc;
    }
  };
  return e.processor && (f.processor = e.processor), a.list && (f.list = a.list), a.named && (f.named = a.named), _n(a.plural) && (f.pluralIndex = a.plural), f;
}
ov();
/*!
  * vue-i18n v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const ly = "11.1.12";
function iy() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (_o().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (_o().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (_o().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (_o().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const In = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: wv,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function ni(e, ...t) {
  return hl(e, null, process.env.NODE_ENV !== "production" ? { messages: sy, args: t } : void 0);
}
const sy = {
  [In.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [In.INVALID_ARGUMENT]: "Invalid argument",
  [In.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [In.NOT_INSTALLED]: "Need to install with `app.use` function",
  [In.UNEXPECTED_ERROR]: "Unexpected error",
  [In.REQUIRED_VALUE]: "Required in value: {0}",
  [In.INVALID_VALUE]: "Invalid value",
  [In.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [In.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [In.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [In.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Lr = /* @__PURE__ */ Za("__translateVNode"), Or = /* @__PURE__ */ Za("__datetimeParts"), Dr = /* @__PURE__ */ Za("__numberParts"), Ar = /* @__PURE__ */ Za("__enableEmitter"), Rr = /* @__PURE__ */ Za("__disableEmitter"), ry = Za("__setPluralRules"), im = /* @__PURE__ */ Za("__injectWithOption"), Mr = /* @__PURE__ */ Za("__dispose"), Ia = {
  FALLBACK_TO_ROOT: Pv,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, uy = {
  [Ia.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Ia.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Ia.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ia.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ia.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [Ia.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function ns(e, ...t) {
  return Ts(uy[e], ...t);
}
function ai(e) {
  if (!jt(e) || ha(e))
    return e;
  for (const t in e)
    if (ma(e, t))
      if (!t.includes("."))
        jt(e[t]) && ai(e[t]);
      else {
        const n = t.split("."), a = n.length - 1;
        let o = e, l = !1;
        for (let s = 0; s < a; s++) {
          if (n[s] === "__proto__")
            throw new Error(`unsafe key: ${n[s]}`);
          if (n[s] in o || (o[n[s]] = Ut()), !jt(o[n[s]])) {
            process.env.NODE_ENV !== "production" && La(ns(Ia.IGNORE_OBJ_FLATTEN, {
              key: n[s]
            })), l = !0;
            break;
          }
          o = o[n[s]];
        }
        if (l || (ha(o) ? Hp.includes(n[a]) || delete e[t] : (o[n[a]] = e[t], delete e[t])), !ha(o)) {
          const s = o[n[a]];
          jt(s) && ai(s);
        }
      }
  return e;
}
function sm(e, t) {
  const { messages: n, __i18n: a, messageResolver: o, flatJson: l } = t, s = xt(n) ? n : cn(a) ? Ut() : { [e]: Ut() };
  if (cn(a) && a.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: c, resource: u } = i;
      c ? (s[c] = s[c] || Ut(), Vi(u, s[c])) : Vi(u, s);
    } else
      tt(i) && Vi(JSON.parse(i), s);
  }), o == null && l)
    for (const i in s)
      ma(s, i) && ai(s[i]);
  return s;
}
function rm(e) {
  return e.type;
}
function cy(e, t, n) {
  let a = jt(t.messages) ? t.messages : Ut();
  "__i18nGlobal" in n && (a = sm(e.locale.value, {
    messages: a,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(a);
  o.length && o.forEach((l) => {
    e.mergeLocaleMessage(l, a[l]);
  });
  {
    if (jt(t.datetimeFormats)) {
      const l = Object.keys(t.datetimeFormats);
      l.length && l.forEach((s) => {
        e.mergeDateTimeFormat(s, t.datetimeFormats[s]);
      });
    }
    if (jt(t.numberFormats)) {
      const l = Object.keys(t.numberFormats);
      l.length && l.forEach((s) => {
        e.mergeNumberFormat(s, t.numberFormats[s]);
      });
    }
  }
}
function qc(e) {
  return d(Wg, null, e, 0);
}
const Qc = "__INTLIFY_META__", ed = () => [], dy = () => !1;
let td = 0;
function nd(e) {
  return ((t, n, a, o) => e(n, a, ms() || void 0, o));
}
const py = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ms();
  let t = null;
  return e && (t = rm(e)[Qc]) ? { [Qc]: t } : null;
};
function my(e = {}) {
  const { __root: t, __injectWithOption: n } = e, a = t === void 0, o = e.flatJson, l = Ya ? F : Gg;
  let s = rn(e.inheritLocale) ? e.inheritLocale : !0;
  const i = l(
    // prettier-ignore
    t && s ? t.locale.value : tt(e.locale) ? e.locale : es
  ), c = l(
    // prettier-ignore
    t && s ? t.fallbackLocale.value : tt(e.fallbackLocale) || cn(e.fallbackLocale) || xt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), u = l(sm(i.value, e)), p = l(xt(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), b = l(xt(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let f = t ? t.missingWarn : rn(e.missingWarn) || Qi(e.missingWarn) ? e.missingWarn : !0, h = t ? t.fallbackWarn : rn(e.fallbackWarn) || Qi(e.fallbackWarn) ? e.fallbackWarn : !0, I = t ? t.fallbackRoot : rn(e.fallbackRoot) ? e.fallbackRoot : !0, m = !!e.fallbackFormat, S = Xt(e.missing) ? e.missing : null, E = Xt(e.missing) ? nd(e.missing) : null, g = Xt(e.postTranslation) ? e.postTranslation : null, v = t ? t.warnHtmlMessage : rn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, T = !!e.escapeParameter;
  const R = t ? t.modifiers : xt(e.modifiers) ? e.modifiers : {};
  let L = e.pluralRules || t && t.pluralRules, C;
  C = (() => {
    a && Uc(null);
    const Z = {
      version: ly,
      locale: i.value,
      fallbackLocale: c.value,
      messages: u.value,
      modifiers: R,
      pluralRules: L,
      missing: E === null ? void 0 : E,
      missingWarn: f,
      fallbackWarn: h,
      fallbackFormat: m,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: v,
      escapeParameter: T,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    Z.datetimeFormats = p.value, Z.numberFormats = b.value, Z.__datetimeFormatters = xt(C) ? C.__datetimeFormatters : void 0, Z.__numberFormatters = xt(C) ? C.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (Z.__v_emitter = xt(C) ? C.__v_emitter : void 0);
    const ee = Wv(Z);
    return a && Uc(ee), ee;
  })(), Ol(C, i.value, c.value);
  function j() {
    return [
      i.value,
      c.value,
      u.value,
      p.value,
      b.value
    ];
  }
  const N = Te({
    get: () => i.value,
    set: (Z) => {
      C.locale = Z, i.value = Z;
    }
  }), x = Te({
    get: () => c.value,
    set: (Z) => {
      C.fallbackLocale = Z, c.value = Z, Ol(C, i.value, Z);
    }
  }), z = Te(() => u.value), X = /* @__PURE__ */ Te(() => p.value), H = /* @__PURE__ */ Te(() => b.value);
  function M() {
    return Xt(g) ? g : null;
  }
  function te(Z) {
    g = Z, C.postTranslation = Z;
  }
  function ne() {
    return S;
  }
  function W(Z) {
    Z !== null && (E = nd(Z)), S = Z, C.missing = E;
  }
  function se(Z, ee) {
    return Z !== "translate" || !ee.resolvedMessage;
  }
  const be = (Z, ee, $, _, D, Y) => {
    j();
    let Q;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (C.fallbackContext = t ? Gv() : void 0), Q = Z(C);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (C.fallbackContext = void 0);
    }
    if ($ !== "translate exists" && // for not `te` (e.g `t`)
    _n(Q) && Q === Ns || $ === "translate exists" && !Q) {
      const [ae, ge] = ee();
      if (process.env.NODE_ENV !== "production" && t && tt(ae) && se($, ge) && (I && (Ls(h, ae) || Qp(f, ae)) && La(ns(Ia.FALLBACK_TO_ROOT, {
        key: ae,
        type: $
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Fe } = C;
        Fe && I && Fe.emit("fallback", {
          type: $,
          key: ae,
          to: "global",
          groupId: `${$}:${ae}`
        });
      }
      return t && I ? _(t) : D(ae);
    } else {
      if (Y(Q))
        return Q;
      throw ni(In.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Re(...Z) {
    return be((ee) => Reflect.apply(Xc, null, [ee, ...Z]), () => Nr(...Z), "translate", (ee) => Reflect.apply(ee.t, ee, [...Z]), (ee) => ee, (ee) => tt(ee));
  }
  function U(...Z) {
    const [ee, $, _] = Z;
    if (_ && !jt(_))
      throw ni(In.INVALID_ARGUMENT);
    return Re(ee, $, wn({ resolvedMessage: !0 }, _ || {}));
  }
  function ie(...Z) {
    return be((ee) => Reflect.apply(zc, null, [ee, ...Z]), () => Tr(...Z), "datetime format", (ee) => Reflect.apply(ee.d, ee, [...Z]), () => ts, (ee) => tt(ee) || cn(ee));
  }
  function re(...Z) {
    return be((ee) => Reflect.apply(Yc, null, [ee, ...Z]), () => Cr(...Z), "number format", (ee) => Reflect.apply(ee.n, ee, [...Z]), () => ts, (ee) => tt(ee) || cn(ee));
  }
  function q(Z) {
    return Z.map((ee) => tt(ee) || _n(ee) || rn(ee) ? qc(String(ee)) : ee);
  }
  const _e = {
    normalize: q,
    interpolate: (Z) => Z,
    type: "vnode"
  };
  function xe(...Z) {
    return be((ee) => {
      let $;
      const _ = ee;
      try {
        _.processor = _e, $ = Reflect.apply(Xc, null, [_, ...Z]);
      } finally {
        _.processor = null;
      }
      return $;
    }, () => Nr(...Z), "translate", (ee) => ee[Lr](...Z), (ee) => [qc(ee)], (ee) => cn(ee));
  }
  function k(...Z) {
    return be((ee) => Reflect.apply(Yc, null, [ee, ...Z]), () => Cr(...Z), "number format", (ee) => ee[Dr](...Z), ed, (ee) => tt(ee) || cn(ee));
  }
  function K(...Z) {
    return be((ee) => Reflect.apply(zc, null, [ee, ...Z]), () => Tr(...Z), "datetime format", (ee) => ee[Or](...Z), ed, (ee) => tt(ee) || cn(ee));
  }
  function Ae(Z) {
    L = Z, C.pluralRules = L;
  }
  function me(Z, ee) {
    return be(() => {
      if (!Z)
        return !1;
      const $ = tt(ee) ? ee : i.value, _ = Ue($), D = C.messageResolver(_, Z);
      return ha(D) || ta(D) || tt(D);
    }, () => [Z], "translate exists", ($) => Reflect.apply($.te, $, [Z, ee]), dy, ($) => rn($));
  }
  function Ne(Z) {
    let ee = null;
    const $ = Yp(C, c.value, i.value);
    for (let _ = 0; _ < $.length; _++) {
      const D = u.value[$[_]] || {}, Y = C.messageResolver(D, Z);
      if (Y != null) {
        ee = Y;
        break;
      }
    }
    return ee;
  }
  function Ge(Z) {
    const ee = Ne(Z);
    return ee ?? (t ? t.tm(Z) || {} : {});
  }
  function Ue(Z) {
    return u.value[Z] || {};
  }
  function Ke(Z, ee) {
    if (o) {
      const $ = { [Z]: ee };
      for (const _ in $)
        ma($, _) && ai($[_]);
      ee = $[Z];
    }
    u.value[Z] = ee, C.messages = u.value;
  }
  function st(Z, ee) {
    u.value[Z] = u.value[Z] || {};
    const $ = { [Z]: ee };
    if (o)
      for (const _ in $)
        ma($, _) && ai($[_]);
    ee = $[Z], Vi(ee, u.value[Z]), C.messages = u.value;
  }
  function G(Z) {
    return p.value[Z] || {};
  }
  function P(Z, ee) {
    p.value[Z] = ee, C.datetimeFormats = p.value, Hc(C, Z, ee);
  }
  function de(Z, ee) {
    p.value[Z] = wn(p.value[Z] || {}, ee), C.datetimeFormats = p.value, Hc(C, Z, ee);
  }
  function fe(Z) {
    return b.value[Z] || {};
  }
  function ke(Z, ee) {
    b.value[Z] = ee, C.numberFormats = b.value, Kc(C, Z, ee);
  }
  function le(Z, ee) {
    b.value[Z] = wn(b.value[Z] || {}, ee), C.numberFormats = b.value, Kc(C, Z, ee);
  }
  td++, t && Ya && (ot(t.locale, (Z) => {
    s && (i.value = Z, C.locale = Z, Ol(C, i.value, c.value));
  }), ot(t.fallbackLocale, (Z) => {
    s && (c.value = Z, C.fallbackLocale = Z, Ol(C, i.value, c.value));
  }));
  const pe = {
    id: td,
    locale: N,
    fallbackLocale: x,
    get inheritLocale() {
      return s;
    },
    set inheritLocale(Z) {
      s = Z, Z && t && (i.value = t.locale.value, c.value = t.fallbackLocale.value, Ol(C, i.value, c.value));
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: z,
    get modifiers() {
      return R;
    },
    get pluralRules() {
      return L || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(Z) {
      f = Z, C.missingWarn = f;
    },
    get fallbackWarn() {
      return h;
    },
    set fallbackWarn(Z) {
      h = Z, C.fallbackWarn = h;
    },
    get fallbackRoot() {
      return I;
    },
    set fallbackRoot(Z) {
      I = Z;
    },
    get fallbackFormat() {
      return m;
    },
    set fallbackFormat(Z) {
      m = Z, C.fallbackFormat = m;
    },
    get warnHtmlMessage() {
      return v;
    },
    set warnHtmlMessage(Z) {
      v = Z, C.warnHtmlMessage = Z;
    },
    get escapeParameter() {
      return T;
    },
    set escapeParameter(Z) {
      T = Z, C.escapeParameter = Z;
    },
    t: Re,
    getLocaleMessage: Ue,
    setLocaleMessage: Ke,
    mergeLocaleMessage: st,
    getPostTranslationHandler: M,
    setPostTranslationHandler: te,
    getMissingHandler: ne,
    setMissingHandler: W,
    [ry]: Ae
  };
  return pe.datetimeFormats = X, pe.numberFormats = H, pe.rt = U, pe.te = me, pe.tm = Ge, pe.d = ie, pe.n = re, pe.getDateTimeFormat = G, pe.setDateTimeFormat = P, pe.mergeDateTimeFormat = de, pe.getNumberFormat = fe, pe.setNumberFormat = ke, pe.mergeNumberFormat = le, pe[im] = n, pe[Lr] = xe, pe[Or] = K, pe[Dr] = k, process.env.NODE_ENV !== "production" && (pe[Ar] = (Z) => {
    C.__v_emitter = Z;
  }, pe[Rr] = () => {
    C.__v_emitter = void 0;
  }), pe;
}
function ad(e, t) {
}
const _u = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function fy({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, o) => [
    ...a,
    // prettier-ignore
    ...o.type === ze ? o.children : [o]
  ], []) : t.reduce((n, a) => {
    const o = e[a];
    return o && (n[a] = o()), n;
  }, Ut());
}
function um() {
  return ze;
}
wn({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => _n(e) || !isNaN(e)
  }
}, _u);
function gy(e) {
  return cn(e) && !tt(e[0]);
}
function cm(e, t, n, a) {
  const { slots: o, attrs: l } = t;
  return () => {
    const s = { part: !0 };
    let i = Ut();
    e.locale && (s.locale = e.locale), tt(e.format) ? s.key = e.format : jt(e.format) && (tt(e.format.key) && (s.key = e.format.key), i = Object.keys(e.format).reduce((f, h) => n.includes(h) ? wn(Ut(), f, { [h]: e.format[h] }) : f, Ut()));
    const c = a(e.value, s, i);
    let u = [s.key];
    cn(c) ? u = c.map((f, h) => {
      const I = o[f.type], m = I ? I({ [f.type]: f.value, index: h, parts: c }) : [f.value];
      return gy(m) && (m[0].key = `${f.type}-${h}`), m;
    }) : tt(c) && (u = [c]);
    const p = wn(Ut(), l), b = tt(e.tag) || jt(e.tag) ? e.tag : um();
    return yp(b, p, u);
  };
}
wn({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, _u);
const hy = /* @__PURE__ */ Za("global-vue-i18n");
function Yt(e = {}) {
  const t = ms();
  if (t == null)
    throw ni(In.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw ni(In.NOT_INSTALLED);
  const n = by(t), a = yy(n), o = rm(t), l = vy(e, o);
  if (l === "global")
    return cy(a, e, o), a;
  if (l === "parent") {
    let c = _y(n, t, e.__useComponent);
    return c == null && (process.env.NODE_ENV !== "production" && La(ns(Ia.NOT_FOUND_PARENT_SCOPE)), c = a), c;
  }
  const s = n;
  let i = s.__getInstance(t);
  if (i == null) {
    const c = wn({}, e);
    "__i18n" in o && (c.__i18n = o.__i18n), a && (c.__root = a), i = my(c), s.__composerExtend && (i[Mr] = s.__composerExtend(i)), Sy(s, t, i), s.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && l === "local" && La(ns(Ia.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function by(e) {
  const t = Xn(e.isCE ? hy : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw ni(e.isCE ? In.NOT_INSTALLED_WITH_PROVIDE : In.UNEXPECTED_ERROR);
  return t;
}
function vy(e, t) {
  return Cs(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function yy(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function _y(e, t, n = !1) {
  let a = null;
  const o = t.root;
  let l = wy(t, n);
  for (; l != null; ) {
    const s = e;
    if (e.mode === "composition")
      a = s.__getInstance(l);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = s.__getInstance(l);
      i != null && (a = i.__composer, n && a && !a[im] && (a = null));
    }
    if (a != null || o === l)
      break;
    l = l.parent;
  }
  return a;
}
function wy(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Sy(e, t, n) {
  let a = null;
  Mt(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, a = Lb();
      const o = n;
      o[Ar] && o[Ar](a), a.on("*", ad);
    }
  }, t), Ka(() => {
    const o = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", ad), o[Rr] && o[Rr](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const l = o[Mr];
    l && (l(), delete o[Mr]);
  }, t);
}
wn({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, _u);
iy();
$v(hv);
kv(Mv);
Vv(Yp);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = _o();
  e.__INTLIFY__ = !0, bv(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Iy = { class: "picker-container" }, Ey = { style: { "white-space": "nowrap" } }, Ty = /* @__PURE__ */ qe({
  __name: "ViewerSettingsColorPicker",
  props: {
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const { t: n } = Yt(), a = e, o = t, l = Mo(), { modelValue: s } = ln(a), i = async () => {
      const p = await l.showColorPickerModal(n("medic-web-engine.setColor"), s.value);
      p && c(p);
    }, c = (p) => {
      o("update:modelValue", p);
    }, u = Te(() => ({
      backgroundColor: `rgb(${s.value[0]}, ${s.value[1]}, ${s.value[2]})`
    }));
    return (p, b) => (O(), J("div", Iy, [
      y("div", {
        class: "color-preview-button",
        onClick: i
      }, [
        y("div", {
          style: Tt(u.value),
          class: "color-preview-button-inner"
        }, null, 4)
      ]),
      y("div", Ey, V(e.label), 1)
    ]));
  }
});
function Cy(e, t) {
  return e ? e.classList ? e.classList.contains(t) : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className) : !1;
}
function dm(e, t) {
  if (e && t) {
    const n = (a) => {
      Cy(e, a) || (e.classList ? e.classList.add(a) : e.className += " " + a);
    };
    [t].flat().filter(Boolean).forEach((a) => a.split(" ").forEach(n));
  }
}
function Ny() {
  return window.innerWidth - document.documentElement.offsetWidth;
}
function pm(e) {
  for (const t of document == null ? void 0 : document.styleSheets)
    try {
      for (const n of t == null ? void 0 : t.cssRules)
        for (const a of n == null ? void 0 : n.style)
          if (e.test(a))
            return { name: a, value: n.style.getPropertyValue(a).trim() };
    } catch {
    }
  return null;
}
function Ly(e = "p-overflow-hidden") {
  const t = pm(/-scrollbar-width$/);
  t != null && t.name && document.body.style.setProperty(t.name, Ny() + "px"), dm(document.body, e);
}
function Oy(e, t) {
  if (e && t) {
    const n = (a) => {
      e.classList ? e.classList.remove(a) : e.className = e.className.replace(new RegExp("(^|\\b)" + a.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };
    [t].flat().filter(Boolean).forEach((a) => a.split(" ").forEach(n));
  }
}
function od(e = "p-overflow-hidden") {
  const t = pm(/-scrollbar-width$/);
  t != null && t.name && document.body.style.removeProperty(t.name), Oy(document.body, e);
}
function Dy() {
  let e = document.documentElement;
  return (window.pageXOffset || e.scrollLeft) - (e.clientLeft || 0);
}
function Ay() {
  let e = document.documentElement;
  return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0);
}
function xo(e) {
  return typeof HTMLElement == "object" ? e instanceof HTMLElement : e && typeof e == "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
}
function Ry() {
  if (window.getSelection) {
    const e = window.getSelection() || {};
    e.empty ? e.empty() : e.removeAllRanges && e.rangeCount > 0 && e.getRangeAt(0).getClientRects().length > 0 && e.removeAllRanges();
  }
}
function Pr(e, t = {}) {
  if (xo(e)) {
    const n = (a, o) => {
      var l, s;
      const i = (l = e == null ? void 0 : e.$attrs) != null && l[a] ? [(s = e == null ? void 0 : e.$attrs) == null ? void 0 : s[a]] : [];
      return [o].flat().reduce((c, u) => {
        if (u != null) {
          const p = typeof u;
          if (p === "string" || p === "number")
            c.push(u);
          else if (p === "object") {
            const b = Array.isArray(u) ? n(a, u) : Object.entries(u).map(([f, h]) => a === "style" && (h || h === 0) ? `${f.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${h}` : h ? f : void 0);
            c = b.length ? c.concat(b.filter((f) => !!f)) : c;
          }
        }
        return c;
      }, i);
    };
    Object.entries(t).forEach(([a, o]) => {
      if (o != null) {
        const l = a.match(/^on(.+)/);
        l ? e.addEventListener(l[1].toLowerCase(), o) : a === "p-bind" || a === "pBind" ? Pr(e, o) : (o = a === "class" ? [...new Set(n("class", o))].join(" ").trim() : a === "style" ? n("style", o).join(";").trim() : o, (e.$attrs = e.$attrs || {}) && (e.$attrs[a] = o), e.setAttribute(a, o));
      }
    });
  }
}
function mm(e, t) {
  return xo(e) ? Array.from(e.querySelectorAll(t)) : [];
}
function wu(e, t) {
  return xo(e) ? e.matches(t) ? e : e.querySelector(t) : null;
}
function Bi(e, t) {
  e && document.activeElement !== e && e.focus(t);
}
function fm(e, t) {
  if (xo(e)) {
    const n = e.getAttribute(t);
    return isNaN(n) ? n === "true" || n === "false" ? n === "true" : n : +n;
  }
}
function My(e, t = "") {
  let n = mm(
    e,
    `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t}`
  ), a = [];
  for (let o of n)
    getComputedStyle(o).display != "none" && getComputedStyle(o).visibility != "hidden" && a.push(o);
  return a;
}
function ld(e, t) {
  const n = My(e, t);
  return n.length > 0 ? n[0] : null;
}
function Py(e) {
  if (e) {
    let t = e.parentNode;
    return t && t instanceof ShadowRoot && t.host && (t = t.host), t;
  }
  return null;
}
function id() {
  if (window.getSelection) return window.getSelection().toString();
  if (document.getSelection) return document.getSelection().toString();
}
function xy(e) {
  return !!(e !== null && typeof e < "u" && e.nodeName && Py(e));
}
function jy(e, t, n) {
  return xo(e) ? fm(e, t) === n : !1;
}
function gm() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Fy(e) {
  return e ? getComputedStyle(e).direction === "rtl" : !1;
}
function $y(e, t = "", n) {
  xo(e) && n !== null && n !== void 0 && e.setAttribute(t, n);
}
function ky() {
  const e = /* @__PURE__ */ new Map();
  return {
    on(t, n) {
      let a = e.get(t);
      return a ? a.push(n) : a = [n], e.set(t, a), this;
    },
    off(t, n) {
      let a = e.get(t);
      return a && a.splice(a.indexOf(n) >>> 0, 1), this;
    },
    emit(t, n) {
      let a = e.get(t);
      a && a.slice().map((o) => {
        o(n);
      });
    },
    clear() {
      e.clear();
    }
  };
}
function hi(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function xr(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (e === t) return !0;
  if (!e || !t || typeof e != "object" || typeof t != "object" || n.has(e) || n.has(t)) return !1;
  n.add(e).add(t);
  let a = Array.isArray(e), o = Array.isArray(t), l, s, i;
  if (a && o) {
    if (s = e.length, s != t.length) return !1;
    for (l = s; l-- !== 0; ) if (!xr(e[l], t[l], n)) return !1;
    return !0;
  }
  if (a != o) return !1;
  let c = e instanceof Date, u = t instanceof Date;
  if (c != u) return !1;
  if (c && u) return e.getTime() == t.getTime();
  let p = e instanceof RegExp, b = t instanceof RegExp;
  if (p != b) return !1;
  if (p && b) return e.toString() == t.toString();
  let f = Object.keys(e);
  if (s = f.length, s !== Object.keys(t).length) return !1;
  for (l = s; l-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(t, f[l])) return !1;
  for (l = s; l-- !== 0; )
    if (i = f[l], !xr(e[i], t[i], n)) return !1;
  return !0;
}
function Vy(e, t) {
  return xr(e, t);
}
function Su(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function Dt(e) {
  return !hi(e);
}
function Fa(e, t) {
  if (!e || !t)
    return null;
  try {
    const n = e[t];
    if (Dt(n)) return n;
  } catch {
  }
  if (Object.keys(e).length) {
    if (Su(t))
      return t(e);
    if (t.indexOf(".") === -1)
      return e[t];
    {
      let n = t.split("."), a = e;
      for (let o = 0, l = n.length; o < l; ++o) {
        if (a == null)
          return null;
        a = a[n[o]];
      }
      return a;
    }
  }
  return null;
}
function as(e, t, n) {
  return n ? Fa(e, n) === Fa(t, n) : Vy(e, t);
}
function Di(e, t) {
  let n = -1;
  if (Dt(e))
    try {
      n = e.findLastIndex(t);
    } catch {
      n = e.lastIndexOf([...e].reverse().find(t));
    }
  return n;
}
function sl(e, t = !0) {
  return e instanceof Object && e.constructor === Object && (t || Object.keys(e).length !== 0);
}
function fa(e, ...t) {
  return Su(e) ? e(...t) : e;
}
function Ca(e, t = !0) {
  return typeof e == "string" && (t || e !== "");
}
function no(e) {
  return Ca(e) ? e.replace(/(-|_)/g, "").toLowerCase() : e;
}
function hm(e, t = "", n = {}) {
  const a = no(t).split("."), o = a.shift();
  return o ? sl(e) ? hm(fa(e[Object.keys(e).find((l) => no(l) === o) || ""], n), a.join("."), n) : void 0 : fa(e, n);
}
function Iu(e, t = !0) {
  return Array.isArray(e) && (t || e.length !== 0);
}
function By(e) {
  return Dt(e) && !isNaN(e);
}
function Uy(e = "") {
  return Dt(e) && e.length === 1 && !!e.match(/\S| /);
}
function Ua(e, t) {
  if (t) {
    const n = t.test(e);
    return t.lastIndex = 0, n;
  }
  return !1;
}
function Hl(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":");
}
function qn(e) {
  if (e && /[\xC0-\xFF\u0100-\u017E]/.test(e)) {
    const n = {
      A: /[\xC0-\xC5\u0100\u0102\u0104]/g,
      AE: /[\xC6]/g,
      C: /[\xC7\u0106\u0108\u010A\u010C]/g,
      D: /[\xD0\u010E\u0110]/g,
      E: /[\xC8-\xCB\u0112\u0114\u0116\u0118\u011A]/g,
      G: /[\u011C\u011E\u0120\u0122]/g,
      H: /[\u0124\u0126]/g,
      I: /[\xCC-\xCF\u0128\u012A\u012C\u012E\u0130]/g,
      IJ: /[\u0132]/g,
      J: /[\u0134]/g,
      K: /[\u0136]/g,
      L: /[\u0139\u013B\u013D\u013F\u0141]/g,
      N: /[\xD1\u0143\u0145\u0147\u014A]/g,
      O: /[\xD2-\xD6\xD8\u014C\u014E\u0150]/g,
      OE: /[\u0152]/g,
      R: /[\u0154\u0156\u0158]/g,
      S: /[\u015A\u015C\u015E\u0160]/g,
      T: /[\u0162\u0164\u0166]/g,
      U: /[\xD9-\xDC\u0168\u016A\u016C\u016E\u0170\u0172]/g,
      W: /[\u0174]/g,
      Y: /[\xDD\u0176\u0178]/g,
      Z: /[\u0179\u017B\u017D]/g,
      a: /[\xE0-\xE5\u0101\u0103\u0105]/g,
      ae: /[\xE6]/g,
      c: /[\xE7\u0107\u0109\u010B\u010D]/g,
      d: /[\u010F\u0111]/g,
      e: /[\xE8-\xEB\u0113\u0115\u0117\u0119\u011B]/g,
      g: /[\u011D\u011F\u0121\u0123]/g,
      i: /[\xEC-\xEF\u0129\u012B\u012D\u012F\u0131]/g,
      ij: /[\u0133]/g,
      j: /[\u0135]/g,
      k: /[\u0137,\u0138]/g,
      l: /[\u013A\u013C\u013E\u0140\u0142]/g,
      n: /[\xF1\u0144\u0146\u0148\u014B]/g,
      p: /[\xFE]/g,
      o: /[\xF2-\xF6\xF8\u014D\u014F\u0151]/g,
      oe: /[\u0153]/g,
      r: /[\u0155\u0157\u0159]/g,
      s: /[\u015B\u015D\u015F\u0161]/g,
      t: /[\u0163\u0165\u0167]/g,
      u: /[\xF9-\xFC\u0169\u016B\u016D\u016F\u0171\u0173]/g,
      w: /[\u0175]/g,
      y: /[\xFD\xFF\u0177]/g,
      z: /[\u017A\u017C\u017E]/g
    };
    for (let a in n)
      e = e.replace(n[a], a);
  }
  return e;
}
function bm(e) {
  return Ca(e) ? e.replace(/(_)/g, "-").replace(/[A-Z]/g, (t, n) => n === 0 ? t : "-" + t.toLowerCase()).toLowerCase() : e;
}
function sd(e) {
  return Ca(e) ? e.replace(/[A-Z]/g, (t, n) => n === 0 ? t : "." + t.toLowerCase()).toLowerCase() : e;
}
var Ai = {};
function vm(e = "pui_id_") {
  return Ai.hasOwnProperty(e) || (Ai[e] = 0), Ai[e]++, `${e}${Ai[e]}`;
}
function Gy() {
  let e = [];
  const t = (s, i, c = 999) => {
    const u = o(s, i, c), p = u.value + (u.key === s ? 0 : c) + 1;
    return e.push({ key: s, value: p }), p;
  }, n = (s) => {
    e = e.filter((i) => i.value !== s);
  }, a = (s, i) => o(s).value, o = (s, i, c = 0) => [...e].reverse().find((u) => !0) || { key: s, value: c }, l = (s) => s && parseInt(s.style.zIndex, 10) || 0;
  return {
    get: l,
    set: (s, i, c) => {
      i && (i.style.zIndex = String(t(s, !0, c)));
    },
    clear: (s) => {
      s && (n(l(s)), s.style.zIndex = "");
    },
    getCurrent: (s) => a(s)
  };
}
var er = Gy(), Wy = Object.defineProperty, zy = Object.defineProperties, Hy = Object.getOwnPropertyDescriptors, os = Object.getOwnPropertySymbols, ym = Object.prototype.hasOwnProperty, _m = Object.prototype.propertyIsEnumerable, rd = (e, t, n) => t in e ? Wy(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, da = (e, t) => {
  for (var n in t || (t = {}))
    ym.call(t, n) && rd(e, n, t[n]);
  if (os)
    for (var n of os(t))
      _m.call(t, n) && rd(e, n, t[n]);
  return e;
}, tr = (e, t) => zy(e, Hy(t)), xa = (e, t) => {
  var n = {};
  for (var a in e)
    ym.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && os)
    for (var a of os(e))
      t.indexOf(a) < 0 && _m.call(e, a) && (n[a] = e[a]);
  return n;
}, Yy = ky(), to = Yy;
function ud(e, t) {
  Iu(e) ? e.push(...t || []) : sl(e) && Object.assign(e, t);
}
function Ky(e) {
  return sl(e) && e.hasOwnProperty("value") && e.hasOwnProperty("type") ? e.value : e;
}
function Zy(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function jr(e = "", t = "") {
  return Zy(`${Ca(e, !1) && Ca(t, !1) ? `${e}-` : e}${t}`);
}
function wm(e = "", t = "") {
  return `--${jr(e, t)}`;
}
function Jy(e = "") {
  const t = (e.match(/{/g) || []).length, n = (e.match(/}/g) || []).length;
  return (t + n) % 2 !== 0;
}
function Sm(e, t = "", n = "", a = [], o) {
  if (Ca(e)) {
    const l = /{([^}]*)}/g, s = e.trim();
    if (Jy(s))
      return;
    if (Ua(s, l)) {
      const i = s.replaceAll(l, (p) => {
        const f = p.replace(/{|}/g, "").split(".").filter((h) => !a.some((I) => Ua(h, I)));
        return `var(${wm(n, bm(f.join("-")))}${Dt(o) ? `, ${o}` : ""})`;
      }), c = /(\d+\s+[\+\-\*\/]\s+\d+)/g, u = /var\([^)]+\)/g;
      return Ua(i.replace(u, "0"), c) ? `calc(${i})` : i;
    }
    return s;
  } else if (By(e))
    return e;
}
function Xy(e, t, n) {
  Ca(t, !1) && e.push(`${t}:${n};`);
}
function Jo(e, t) {
  return e ? `${e}{${t}}` : "";
}
var Yl = (...e) => qy(bn.getTheme(), ...e), qy = (e = {}, t, n, a) => {
  if (t) {
    const { variable: o, options: l } = bn.defaults || {}, { prefix: s, transform: i } = (e == null ? void 0 : e.options) || l || {}, u = Ua(t, /{([^}]*)}/g) ? t : `{${t}}`;
    return a === "value" || hi(a) && i === "strict" ? bn.getTokenValue(t) : Sm(u, void 0, s, [o.excludedKeyRegex], n);
  }
  return "";
};
function Qy(e, t = {}) {
  const n = bn.defaults.variable, { prefix: a = n.prefix, selector: o = n.selector, excludedKeyRegex: l = n.excludedKeyRegex } = t, s = (u, p = "") => Object.entries(u).reduce(
    (b, [f, h]) => {
      const I = Ua(f, l) ? jr(p) : jr(p, bm(f)), m = Ky(h);
      if (sl(m)) {
        const { variables: S, tokens: E } = s(m, I);
        ud(b.tokens, E), ud(b.variables, S);
      } else
        b.tokens.push((a ? I.replace(`${a}-`, "") : I).replaceAll("-", ".")), Xy(b.variables, wm(I), Sm(m, I, a, [l]));
      return b;
    },
    { variables: [], tokens: [] }
  ), { variables: i, tokens: c } = s(e, a);
  return {
    value: i,
    tokens: c,
    declarations: i.join(""),
    css: Jo(o, i.join(""))
  };
}
var ua = {
  regex: {
    rules: {
      class: {
        pattern: /^\.([a-zA-Z][\w-]*)$/,
        resolve(e) {
          return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
        }
      },
      attr: {
        pattern: /^\[(.*)\]$/,
        resolve(e) {
          return { type: "attr", selector: `:root${e}`, matched: this.pattern.test(e.trim()) };
        }
      },
      media: {
        pattern: /^@media (.*)$/,
        resolve(e) {
          return { type: "media", selector: `${e}{:root{[CSS]}}`, matched: this.pattern.test(e.trim()) };
        }
      },
      system: {
        pattern: /^system$/,
        resolve(e) {
          return { type: "system", selector: "@media (prefers-color-scheme: dark){:root{[CSS]}}", matched: this.pattern.test(e.trim()) };
        }
      },
      custom: {
        resolve(e) {
          return { type: "custom", selector: e, matched: !0 };
        }
      }
    },
    resolve(e) {
      const t = Object.keys(this.rules).filter((n) => n !== "custom").map((n) => this.rules[n]);
      return [e].flat().map((n) => {
        var a;
        return (a = t.map((o) => o.resolve(n)).find((o) => o.matched)) != null ? a : this.rules.custom.resolve(n);
      });
    }
  },
  _toVariables(e, t) {
    return Qy(e, { prefix: t == null ? void 0 : t.prefix });
  },
  getCommon({ name: e = "", theme: t = {}, params: n, set: a, defaults: o }) {
    var l, s, i, c, u, p, b;
    const { preset: f, options: h } = t;
    let I, m, S, E, g, v, T;
    if (Dt(f) && h.transform !== "strict") {
      const { primitive: R, semantic: L, extend: C } = f, A = L || {}, { colorScheme: j } = A, N = xa(A, ["colorScheme"]), x = C || {}, { colorScheme: z } = x, X = xa(x, ["colorScheme"]), H = j || {}, { dark: M } = H, te = xa(H, ["dark"]), ne = z || {}, { dark: W } = ne, se = xa(ne, ["dark"]), be = Dt(R) ? this._toVariables({ primitive: R }, h) : {}, Re = Dt(N) ? this._toVariables({ semantic: N }, h) : {}, U = Dt(te) ? this._toVariables({ light: te }, h) : {}, ie = Dt(M) ? this._toVariables({ dark: M }, h) : {}, re = Dt(X) ? this._toVariables({ semantic: X }, h) : {}, q = Dt(se) ? this._toVariables({ light: se }, h) : {}, De = Dt(W) ? this._toVariables({ dark: W }, h) : {}, [_e, xe] = [(l = be.declarations) != null ? l : "", be.tokens], [k, K] = [(s = Re.declarations) != null ? s : "", Re.tokens || []], [Ae, me] = [(i = U.declarations) != null ? i : "", U.tokens || []], [Ne, Ge] = [(c = ie.declarations) != null ? c : "", ie.tokens || []], [Ue, Ke] = [(u = re.declarations) != null ? u : "", re.tokens || []], [st, G] = [(p = q.declarations) != null ? p : "", q.tokens || []], [P, de] = [(b = De.declarations) != null ? b : "", De.tokens || []];
      I = this.transformCSS(e, _e, "light", "variable", h, a, o), m = xe;
      const fe = this.transformCSS(e, `${k}${Ae}`, "light", "variable", h, a, o), ke = this.transformCSS(e, `${Ne}`, "dark", "variable", h, a, o);
      S = `${fe}${ke}`, E = [.../* @__PURE__ */ new Set([...K, ...me, ...Ge])];
      const le = this.transformCSS(e, `${Ue}${st}color-scheme:light`, "light", "variable", h, a, o), pe = this.transformCSS(e, `${P}color-scheme:dark`, "dark", "variable", h, a, o);
      g = `${le}${pe}`, v = [.../* @__PURE__ */ new Set([...Ke, ...G, ...de])], T = fa(f.css, { dt: Yl });
    }
    return {
      primitive: {
        css: I,
        tokens: m
      },
      semantic: {
        css: S,
        tokens: E
      },
      global: {
        css: g,
        tokens: v
      },
      style: T
    };
  },
  getPreset({ name: e = "", preset: t = {}, options: n, params: a, set: o, defaults: l, selector: s }) {
    var i, c, u;
    let p, b, f;
    if (Dt(t) && n.transform !== "strict") {
      const h = e.replace("-directive", ""), I = t, { colorScheme: m, extend: S, css: E } = I, g = xa(I, ["colorScheme", "extend", "css"]), v = S || {}, { colorScheme: T } = v, R = xa(v, ["colorScheme"]), L = m || {}, { dark: C } = L, A = xa(L, ["dark"]), j = T || {}, { dark: N } = j, x = xa(j, ["dark"]), z = Dt(g) ? this._toVariables({ [h]: da(da({}, g), R) }, n) : {}, X = Dt(A) ? this._toVariables({ [h]: da(da({}, A), x) }, n) : {}, H = Dt(C) ? this._toVariables({ [h]: da(da({}, C), N) }, n) : {}, [M, te] = [(i = z.declarations) != null ? i : "", z.tokens || []], [ne, W] = [(c = X.declarations) != null ? c : "", X.tokens || []], [se, be] = [(u = H.declarations) != null ? u : "", H.tokens || []], Re = this.transformCSS(h, `${M}${ne}`, "light", "variable", n, o, l, s), U = this.transformCSS(h, se, "dark", "variable", n, o, l, s);
      p = `${Re}${U}`, b = [.../* @__PURE__ */ new Set([...te, ...W, ...be])], f = fa(E, { dt: Yl });
    }
    return {
      css: p,
      tokens: b,
      style: f
    };
  },
  getPresetC({ name: e = "", theme: t = {}, params: n, set: a, defaults: o }) {
    var l;
    const { preset: s, options: i } = t, c = (l = s == null ? void 0 : s.components) == null ? void 0 : l[e];
    return this.getPreset({ name: e, preset: c, options: i, params: n, set: a, defaults: o });
  },
  getPresetD({ name: e = "", theme: t = {}, params: n, set: a, defaults: o }) {
    var l;
    const s = e.replace("-directive", ""), { preset: i, options: c } = t, u = (l = i == null ? void 0 : i.directives) == null ? void 0 : l[s];
    return this.getPreset({ name: s, preset: u, options: c, params: n, set: a, defaults: o });
  },
  applyDarkColorScheme(e) {
    return !(e.darkModeSelector === "none" || e.darkModeSelector === !1);
  },
  getColorSchemeOption(e, t) {
    var n;
    return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === !0 ? t.options.darkModeSelector : (n = e.darkModeSelector) != null ? n : t.options.darkModeSelector) : [];
  },
  getLayerOrder(e, t = {}, n, a) {
    const { cssLayer: o } = t;
    return o ? `@layer ${fa(o.order || "primeui", n)}` : "";
  },
  getCommonStyleSheet({ name: e = "", theme: t = {}, params: n, props: a = {}, set: o, defaults: l }) {
    const s = this.getCommon({ name: e, theme: t, params: n, set: o, defaults: l }), i = Object.entries(a).reduce((c, [u, p]) => c.push(`${u}="${p}"`) && c, []).join(" ");
    return Object.entries(s || {}).reduce((c, [u, p]) => {
      if (p != null && p.css) {
        const b = Hl(p == null ? void 0 : p.css), f = `${u}-variables`;
        c.push(`<style type="text/css" data-primevue-style-id="${f}" ${i}>${b}</style>`);
      }
      return c;
    }, []).join("");
  },
  getStyleSheet({ name: e = "", theme: t = {}, params: n, props: a = {}, set: o, defaults: l }) {
    var s;
    const i = { name: e, theme: t, params: n, set: o, defaults: l }, c = (s = e.includes("-directive") ? this.getPresetD(i) : this.getPresetC(i)) == null ? void 0 : s.css, u = Object.entries(a).reduce((p, [b, f]) => p.push(`${b}="${f}"`) && p, []).join(" ");
    return c ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${u}>${Hl(c)}</style>` : "";
  },
  createTokens(e = {}, t, n = "", a = "", o = {}) {
    return Object.entries(e).forEach(([l, s]) => {
      const i = Ua(l, t.variable.excludedKeyRegex) ? n : n ? `${n}.${sd(l)}` : sd(l), c = a ? `${a}.${l}` : l;
      sl(s) ? this.createTokens(s, t, i, c, o) : (o[i] || (o[i] = {
        paths: [],
        computed(u, p = {}) {
          var b, f;
          return this.paths.length === 1 ? (b = this.paths[0]) == null ? void 0 : b.computed(this.paths[0].scheme, p.binding) : u && u !== "none" ? (f = this.paths.find((h) => h.scheme === u)) == null ? void 0 : f.computed(u, p.binding) : this.paths.map((h) => h.computed(h.scheme, p[h.scheme]));
        }
      }), o[i].paths.push({
        path: c,
        value: s,
        scheme: c.includes("colorScheme.light") ? "light" : c.includes("colorScheme.dark") ? "dark" : "none",
        computed(u, p = {}) {
          const b = /{([^}]*)}/g;
          let f = s;
          if (p.name = this.path, p.binding || (p.binding = {}), Ua(s, b)) {
            const I = s.trim().replaceAll(b, (E) => {
              var g;
              const v = E.replace(/{|}/g, ""), T = (g = o[v]) == null ? void 0 : g.computed(u, p);
              return Iu(T) && T.length === 2 ? `light-dark(${T[0].value},${T[1].value})` : T == null ? void 0 : T.value;
            }), m = /(\d+\w*\s+[\+\-\*\/]\s+\d+\w*)/g, S = /var\([^)]+\)/g;
            f = Ua(I.replace(S, "0"), m) ? `calc(${I})` : I;
          }
          return hi(p.binding) && delete p.binding, {
            colorScheme: u,
            path: this.path,
            paths: p,
            value: f.includes("undefined") ? void 0 : f
          };
        }
      }));
    }), o;
  },
  getTokenValue(e, t, n) {
    var a;
    const l = ((c) => c.split(".").filter((p) => !Ua(p.toLowerCase(), n.variable.excludedKeyRegex)).join("."))(t), s = t.includes("colorScheme.light") ? "light" : t.includes("colorScheme.dark") ? "dark" : void 0, i = [(a = e[l]) == null ? void 0 : a.computed(s)].flat().filter((c) => c);
    return i.length === 1 ? i[0].value : i.reduce((c = {}, u) => {
      const p = u, { colorScheme: b } = p, f = xa(p, ["colorScheme"]);
      return c[b] = f, c;
    }, void 0);
  },
  getSelectorRule(e, t, n, a) {
    return n === "class" || n === "attr" ? Jo(Dt(t) ? `${e}${t},${e} ${t}` : e, a) : Jo(e, Dt(t) ? Jo(t, a) : a);
  },
  transformCSS(e, t, n, a, o = {}, l, s, i) {
    if (Dt(t)) {
      const { cssLayer: c } = o;
      if (a !== "style") {
        const u = this.getColorSchemeOption(o, s);
        t = n === "dark" ? u.reduce((p, { type: b, selector: f }) => (Dt(f) && (p += f.includes("[CSS]") ? f.replace("[CSS]", t) : this.getSelectorRule(f, i, b, t)), p), "") : Jo(i ?? ":root", t);
      }
      if (c) {
        const u = {
          name: "primeui"
        };
        sl(c) && (u.name = fa(c.name, { name: e, type: a })), Dt(u.name) && (t = Jo(`@layer ${u.name}`, t), l == null || l.layerNames(u.name));
      }
      return t;
    }
    return "";
  }
}, bn = {
  defaults: {
    variable: {
      prefix: "p",
      selector: ":root",
      excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi
    },
    options: {
      prefix: "p",
      darkModeSelector: "system",
      cssLayer: !1
    }
  },
  _theme: void 0,
  _layerNames: /* @__PURE__ */ new Set(),
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  _loadingStyles: /* @__PURE__ */ new Set(),
  _tokens: {},
  update(e = {}) {
    const { theme: t } = e;
    t && (this._theme = tr(da({}, t), {
      options: da(da({}, this.defaults.options), t.options)
    }), this._tokens = ua.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
  },
  get theme() {
    return this._theme;
  },
  get preset() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.preset) || {};
  },
  get options() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.options) || {};
  },
  get tokens() {
    return this._tokens;
  },
  getTheme() {
    return this.theme;
  },
  setTheme(e) {
    this.update({ theme: e }), to.emit("theme:change", e);
  },
  getPreset() {
    return this.preset;
  },
  setPreset(e) {
    this._theme = tr(da({}, this.theme), { preset: e }), this._tokens = ua.createTokens(e, this.defaults), this.clearLoadedStyleNames(), to.emit("preset:change", e), to.emit("theme:change", this.theme);
  },
  getOptions() {
    return this.options;
  },
  setOptions(e) {
    this._theme = tr(da({}, this.theme), { options: e }), this.clearLoadedStyleNames(), to.emit("options:change", e), to.emit("theme:change", this.theme);
  },
  getLayerNames() {
    return [...this._layerNames];
  },
  setLayerNames(e) {
    this._layerNames.add(e);
  },
  getLoadedStyleNames() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded(e) {
    return this._loadedStyleNames.has(e);
  },
  setLoadedStyleName(e) {
    this._loadedStyleNames.add(e);
  },
  deleteLoadedStyleName(e) {
    this._loadedStyleNames.delete(e);
  },
  clearLoadedStyleNames() {
    this._loadedStyleNames.clear();
  },
  getTokenValue(e) {
    return ua.getTokenValue(this.tokens, e, this.defaults);
  },
  getCommon(e = "", t) {
    return ua.getCommon({ name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getComponent(e = "", t) {
    const n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ua.getPresetC(n);
  },
  getDirective(e = "", t) {
    const n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ua.getPresetD(n);
  },
  getCustomPreset(e = "", t, n, a) {
    const o = { name: e, preset: t, options: this.options, selector: n, params: a, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ua.getPreset(o);
  },
  getLayerOrderCSS(e = "") {
    return ua.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
  },
  transformCSS(e = "", t, n = "style", a) {
    return ua.transformCSS(e, t, a, n, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
  },
  getCommonStyleSheet(e = "", t, n = {}) {
    return ua.getCommonStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getStyleSheet(e, t, n = {}) {
    return ua.getStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  onStyleMounted(e) {
    this._loadingStyles.add(e);
  },
  onStyleUpdated(e) {
    this._loadingStyles.add(e);
  },
  onStyleLoaded(e, { name: t }) {
    this._loadingStyles.size && (this._loadingStyles.delete(t), to.emit(`theme:${t}:load`, e), !this._loadingStyles.size && to.emit("theme:load"));
  }
}, Dl = {
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  getLoadedStyleNames: function() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded: function(t) {
    return this._loadedStyleNames.has(t);
  },
  setLoadedStyleName: function(t) {
    this._loadedStyleNames.add(t);
  },
  deleteLoadedStyleName: function(t) {
    this._loadedStyleNames.delete(t);
  },
  clearLoadedStyleNames: function() {
    this._loadedStyleNames.clear();
  }
};
function oi(e) {
  "@babel/helpers - typeof";
  return oi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oi(e);
}
function cd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function dd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cd(Object(n), !0).forEach(function(a) {
      e1(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cd(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function e1(e, t, n) {
  return (t = t1(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function t1(e) {
  var t = n1(e, "string");
  return oi(t) == "symbol" ? t : t + "";
}
function n1(e, t) {
  if (oi(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (oi(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function a1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  ms() ? Mt(e) : t ? e() : fn(e);
}
var o1 = 0;
function l1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = F(!1), a = F(e), o = F(null), l = gm() ? window.document : void 0, s = t.document, i = s === void 0 ? l : s, c = t.immediate, u = c === void 0 ? !0 : c, p = t.manual, b = p === void 0 ? !1 : p, f = t.name, h = f === void 0 ? "style_".concat(++o1) : f, I = t.id, m = I === void 0 ? void 0 : I, S = t.media, E = S === void 0 ? void 0 : S, g = t.nonce, v = g === void 0 ? void 0 : g, T = t.first, R = T === void 0 ? !1 : T, L = t.onMounted, C = L === void 0 ? void 0 : L, A = t.onUpdated, j = A === void 0 ? void 0 : A, N = t.onLoad, x = N === void 0 ? void 0 : N, z = t.props, X = z === void 0 ? {} : z, H = function() {
  }, M = function(W) {
    var se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (i) {
      var be = dd(dd({}, X), se), Re = be.name || h, U = be.id || m, ie = be.nonce || v;
      o.value = i.querySelector('style[data-primevue-style-id="'.concat(Re, '"]')) || i.getElementById(U) || i.createElement("style"), o.value.isConnected || (a.value = W || e, Pr(o.value, {
        type: "text/css",
        id: U,
        media: E,
        nonce: ie
      }), R ? i.head.prepend(o.value) : i.head.appendChild(o.value), $y(o.value, "data-primevue-style-id", Re), Pr(o.value, be), o.value.onload = function(re) {
        return x == null ? void 0 : x(re, {
          name: Re
        });
      }, C == null || C(Re)), !n.value && (H = ot(a, function(re) {
        o.value.textContent = re, j == null || j(Re);
      }, {
        immediate: !0
      }), n.value = !0);
    }
  }, te = function() {
    !i || !n.value || (H(), xy(o.value) && i.head.removeChild(o.value), n.value = !1);
  };
  return u && !b && a1(M), {
    id: m,
    name: h,
    el: o,
    css: a,
    unload: te,
    load: M,
    isLoaded: zg(n)
  };
}
function li(e) {
  "@babel/helpers - typeof";
  return li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, li(e);
}
function pd(e, t) {
  return u1(e) || r1(e, t) || s1(e, t) || i1();
}
function i1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function s1(e, t) {
  if (e) {
    if (typeof e == "string") return md(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? md(e, t) : void 0;
  }
}
function md(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function r1(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var a, o, l, s, i = [], c = !0, u = !1;
    try {
      if (l = (n = n.call(e)).next, t !== 0) for (; !(c = (a = l.call(n)).done) && (i.push(a.value), i.length !== t); c = !0) ;
    } catch (p) {
      u = !0, o = p;
    } finally {
      try {
        if (!c && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw o;
      }
    }
    return i;
  }
}
function u1(e) {
  if (Array.isArray(e)) return e;
}
function fd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function nr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fd(Object(n), !0).forEach(function(a) {
      c1(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fd(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function c1(e, t, n) {
  return (t = d1(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function d1(e) {
  var t = p1(e, "string");
  return li(t) == "symbol" ? t : t + "";
}
function p1(e, t) {
  if (li(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (li(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var m1 = function(t) {
  var n = t.dt;
  return `
*,
::before,
::after {
    box-sizing: border-box;
}

/* Non vue overlay animations */
.p-connected-overlay {
    opacity: 0;
    transform: scaleY(0.8);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-visible {
    opacity: 1;
    transform: scaleY(1);
}

.p-connected-overlay-hidden {
    opacity: 0;
    transform: scaleY(1);
    transition: opacity 0.1s linear;
}

/* Vue based overlay animations */
.p-connected-overlay-enter-from {
    opacity: 0;
    transform: scaleY(0.8);
}

.p-connected-overlay-leave-to {
    opacity: 0;
}

.p-connected-overlay-enter-active {
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-leave-active {
    transition: opacity 0.1s linear;
}

/* Toggleable Content */
.p-toggleable-content-enter-from,
.p-toggleable-content-leave-to {
    max-height: 0;
}

.p-toggleable-content-enter-to,
.p-toggleable-content-leave-from {
    max-height: 1000px;
}

.p-toggleable-content-leave-active {
    overflow: hidden;
    transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
}

.p-toggleable-content-enter-active {
    overflow: hidden;
    transition: max-height 1s ease-in-out;
}

.p-disabled,
.p-disabled * {
    cursor: default;
    pointer-events: none;
    user-select: none;
}

.p-disabled,
.p-component:disabled {
    opacity: `.concat(n("disabled.opacity"), `;
}

.pi {
    font-size: `).concat(n("icon.size"), `;
}

.p-icon {
    width: `).concat(n("icon.size"), `;
    height: `).concat(n("icon.size"), `;
}

.p-overlay-mask {
    background: `).concat(n("mask.background"), `;
    color: `).concat(n("mask.color"), `;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-overlay-mask-enter {
    animation: p-overlay-mask-enter-animation `).concat(n("mask.transition.duration"), ` forwards;
}

.p-overlay-mask-leave {
    animation: p-overlay-mask-leave-animation `).concat(n("mask.transition.duration"), ` forwards;
}

@keyframes p-overlay-mask-enter-animation {
    from {
        background: transparent;
    }
    to {
        background: `).concat(n("mask.background"), `;
    }
}
@keyframes p-overlay-mask-leave-animation {
    from {
        background: `).concat(n("mask.background"), `;
    }
    to {
        background: transparent;
    }
}
`);
}, f1 = function(t) {
  var n = t.dt;
  return `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.p-hidden-accessible input,
.p-hidden-accessible select {
    transform: scale(0);
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: `.concat(n("scrollbar.width"), `;
}
`);
}, g1 = {}, h1 = {}, ja = {
  name: "base",
  css: f1,
  theme: m1,
  classes: g1,
  inlineStyles: h1,
  load: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(l) {
      return l;
    }, o = a(fa(t, {
      dt: Yl
    }));
    return Dt(o) ? l1(Hl(o), nr({
      name: this.name
    }, n)) : {};
  },
  loadCSS: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, t);
  },
  loadTheme: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.theme, n, function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return bn.transformCSS(n.name || t.name, "".concat(o).concat(a));
    });
  },
  getCommonTheme: function(t) {
    return bn.getCommon(this.name, t);
  },
  getComponentTheme: function(t) {
    return bn.getComponent(this.name, t);
  },
  getDirectiveTheme: function(t) {
    return bn.getDirective(this.name, t);
  },
  getPresetTheme: function(t, n, a) {
    return bn.getCustomPreset(this.name, t, n, a);
  },
  getLayerOrderThemeCSS: function() {
    return bn.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var a = fa(this.css, {
        dt: Yl
      }) || "", o = Hl("".concat(a).concat(t)), l = Object.entries(n).reduce(function(s, i) {
        var c = pd(i, 2), u = c[0], p = c[1];
        return s.push("".concat(u, '="').concat(p, '"')) && s;
      }, []).join(" ");
      return Dt(o) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(l, ">").concat(o, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return bn.getCommonStyleSheet(this.name, t, n);
  },
  getThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = [bn.getStyleSheet(this.name, t, n)];
    if (this.theme) {
      var o = this.name === "base" ? "global-style" : "".concat(this.name, "-style"), l = fa(this.theme, {
        dt: Yl
      }), s = Hl(bn.transformCSS(o, l)), i = Object.entries(n).reduce(function(c, u) {
        var p = pd(u, 2), b = p[0], f = p[1];
        return c.push("".concat(b, '="').concat(f, '"')) && c;
      }, []).join(" ");
      Dt(s) && a.push('<style type="text/css" data-primevue-style-id="'.concat(o, '" ').concat(i, ">").concat(s, "</style>"));
    }
    return a.join("");
  },
  extend: function(t) {
    return nr(nr({}, this), {}, {
      css: void 0,
      theme: void 0
    }, t);
  }
}, gd = ja.extend({
  name: "common"
});
function ii(e) {
  "@babel/helpers - typeof";
  return ii = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ii(e);
}
function b1(e) {
  return Tm(e) || v1(e) || Em(e) || Im();
}
function v1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Al(e, t) {
  return Tm(e) || y1(e, t) || Em(e, t) || Im();
}
function Im() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Em(e, t) {
  if (e) {
    if (typeof e == "string") return hd(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? hd(e, t) : void 0;
  }
}
function hd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function y1(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var a, o, l, s, i = [], c = !0, u = !1;
    try {
      if (l = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (a = l.call(n)).done) && (i.push(a.value), i.length !== t); c = !0) ;
    } catch (p) {
      u = !0, o = p;
    } finally {
      try {
        if (!c && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw o;
      }
    }
    return i;
  }
}
function Tm(e) {
  if (Array.isArray(e)) return e;
}
function bd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Nt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bd(Object(n), !0).forEach(function(a) {
      jl(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bd(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function jl(e, t, n) {
  return (t = _1(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _1(e) {
  var t = w1(e, "string");
  return ii(t) == "symbol" ? t : t + "";
}
function w1(e, t) {
  if (ii(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (ii(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ja = {
  name: "BaseComponent",
  props: {
    pt: {
      type: Object,
      default: void 0
    },
    ptOptions: {
      type: Object,
      default: void 0
    },
    unstyled: {
      type: Boolean,
      default: void 0
    },
    dt: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    }
  },
  watch: {
    isUnstyled: {
      immediate: !0,
      handler: function(t) {
        t || (this._loadCoreStyles(), this._themeChangeListener(this._loadCoreStyles));
      }
    },
    dt: {
      immediate: !0,
      handler: function(t) {
        var n = this;
        t ? (this._loadScopedThemeStyles(t), this._themeChangeListener(function() {
          return n._loadScopedThemeStyles(t);
        })) : this._unloadScopedThemeStyles();
      }
    }
  },
  scopedStyleEl: void 0,
  rootEl: void 0,
  $attrSelector: void 0,
  beforeCreate: function() {
    var t, n, a, o, l, s, i, c, u, p, b, f = (t = this.pt) === null || t === void 0 ? void 0 : t._usept, h = f ? (n = this.pt) === null || n === void 0 || (n = n.originalValue) === null || n === void 0 ? void 0 : n[this.$.type.name] : void 0, I = f ? (a = this.pt) === null || a === void 0 || (a = a.value) === null || a === void 0 ? void 0 : a[this.$.type.name] : this.pt;
    (o = I || h) === null || o === void 0 || (o = o.hooks) === null || o === void 0 || (l = o.onBeforeCreate) === null || l === void 0 || l.call(o);
    var m = (s = this.$primevueConfig) === null || s === void 0 || (s = s.pt) === null || s === void 0 ? void 0 : s._usept, S = m ? (i = this.$primevue) === null || i === void 0 || (i = i.config) === null || i === void 0 || (i = i.pt) === null || i === void 0 ? void 0 : i.originalValue : void 0, E = m ? (c = this.$primevue) === null || c === void 0 || (c = c.config) === null || c === void 0 || (c = c.pt) === null || c === void 0 ? void 0 : c.value : (u = this.$primevue) === null || u === void 0 || (u = u.config) === null || u === void 0 ? void 0 : u.pt;
    (p = E || S) === null || p === void 0 || (p = p[this.$.type.name]) === null || p === void 0 || (p = p.hooks) === null || p === void 0 || (b = p.onBeforeCreate) === null || b === void 0 || b.call(p), this.$attrSelector = vm("pc");
  },
  created: function() {
    this._hook("onCreated");
  },
  beforeMount: function() {
    this.rootEl = wu(this.$el, '[data-pc-name="'.concat(no(this.$.type.name), '"]')), this.rootEl && (this.$attrSelector && !this.rootEl.hasAttribute(this.$attrSelector) && this.rootEl.setAttribute(this.$attrSelector, ""), this.rootEl.$pc = Nt({
      name: this.$.type.name,
      attrSelector: this.$attrSelector
    }, this.$params)), this._loadStyles(), this._hook("onBeforeMount");
  },
  mounted: function() {
    this._hook("onMounted");
  },
  beforeUpdate: function() {
    this._hook("onBeforeUpdate");
  },
  updated: function() {
    this._hook("onUpdated");
  },
  beforeUnmount: function() {
    this._hook("onBeforeUnmount");
  },
  unmounted: function() {
    this._unloadScopedThemeStyles(), this._hook("onUnmounted");
  },
  methods: {
    _hook: function(t) {
      if (!this.$options.hostName) {
        var n = this._usePT(this._getPT(this.pt, this.$.type.name), this._getOptionValue, "hooks.".concat(t)), a = this._useDefaultPT(this._getOptionValue, "hooks.".concat(t));
        n == null || n(), a == null || a();
      }
    },
    _mergeProps: function(t) {
      for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
        a[o - 1] = arguments[o];
      return Su(t) ? t.apply(void 0, a) : Pe.apply(void 0, a);
    },
    _loadStyles: function() {
      var t = this, n = function() {
        Dl.isStyleNameLoaded("base") || (ja.loadCSS(t.$styleOptions), t._loadGlobalStyles(), Dl.setLoadedStyleName("base")), t._loadThemeStyles();
      };
      n(), this._themeChangeListener(n);
    },
    _loadCoreStyles: function() {
      var t, n;
      !Dl.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name && (gd.loadCSS(this.$styleOptions), this.$options.style && this.$style.loadCSS(this.$styleOptions), Dl.setLoadedStyleName(this.$style.name));
    },
    _loadGlobalStyles: function() {
      var t = this._useGlobalPT(this._getOptionValue, "global.css", this.$params);
      Dt(t) && ja.load(t, Nt({
        name: "global"
      }, this.$styleOptions));
    },
    _loadThemeStyles: function() {
      var t, n;
      if (!(this.isUnstyled || this.$theme === "none")) {
        if (!bn.isStyleNameLoaded("common")) {
          var a, o, l = ((a = this.$style) === null || a === void 0 || (o = a.getCommonTheme) === null || o === void 0 ? void 0 : o.call(a)) || {}, s = l.primitive, i = l.semantic, c = l.global, u = l.style;
          ja.load(s == null ? void 0 : s.css, Nt({
            name: "primitive-variables"
          }, this.$styleOptions)), ja.load(i == null ? void 0 : i.css, Nt({
            name: "semantic-variables"
          }, this.$styleOptions)), ja.load(c == null ? void 0 : c.css, Nt({
            name: "global-variables"
          }, this.$styleOptions)), ja.loadTheme(Nt({
            name: "global-style"
          }, this.$styleOptions), u), bn.setLoadedStyleName("common");
        }
        if (!bn.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name) {
          var p, b, f, h, I = ((p = this.$style) === null || p === void 0 || (b = p.getComponentTheme) === null || b === void 0 ? void 0 : b.call(p)) || {}, m = I.css, S = I.style;
          (f = this.$style) === null || f === void 0 || f.load(m, Nt({
            name: "".concat(this.$style.name, "-variables")
          }, this.$styleOptions)), (h = this.$style) === null || h === void 0 || h.loadTheme(Nt({
            name: "".concat(this.$style.name, "-style")
          }, this.$styleOptions), S), bn.setLoadedStyleName(this.$style.name);
        }
        if (!bn.isStyleNameLoaded("layer-order")) {
          var E, g, v = (E = this.$style) === null || E === void 0 || (g = E.getLayerOrderThemeCSS) === null || g === void 0 ? void 0 : g.call(E);
          ja.load(v, Nt({
            name: "layer-order",
            first: !0
          }, this.$styleOptions)), bn.setLoadedStyleName("layer-order");
        }
      }
    },
    _loadScopedThemeStyles: function(t) {
      var n, a, o, l = ((n = this.$style) === null || n === void 0 || (a = n.getPresetTheme) === null || a === void 0 ? void 0 : a.call(n, t, "[".concat(this.$attrSelector, "]"))) || {}, s = l.css, i = (o = this.$style) === null || o === void 0 ? void 0 : o.load(s, Nt({
        name: "".concat(this.$attrSelector, "-").concat(this.$style.name)
      }, this.$styleOptions));
      this.scopedStyleEl = i.el;
    },
    _unloadScopedThemeStyles: function() {
      var t;
      (t = this.scopedStyleEl) === null || t === void 0 || (t = t.value) === null || t === void 0 || t.remove();
    },
    _themeChangeListener: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      Dl.clearLoadedStyleNames(), to.on("theme:change", t);
    },
    _getHostInstance: function(t) {
      return t ? this.$options.hostName ? t.$.type.name === this.$options.hostName ? t : this._getHostInstance(t.$parentInstance) : t.$parentInstance : void 0;
    },
    _getPropValue: function(t) {
      var n;
      return this[t] || ((n = this._getHostInstance(this)) === null || n === void 0 ? void 0 : n[t]);
    },
    _getOptionValue: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return hm(t, n, a);
    },
    _getPTValue: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, s = /./g.test(a) && !!o[a.split(".")[0]], i = this._getPropValue("ptOptions") || ((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.ptOptions) || {}, c = i.mergeSections, u = c === void 0 ? !0 : c, p = i.mergeProps, b = p === void 0 ? !1 : p, f = l ? s ? this._useGlobalPT(this._getPTClassValue, a, o) : this._useDefaultPT(this._getPTClassValue, a, o) : void 0, h = s ? void 0 : this._getPTSelf(n, this._getPTClassValue, a, Nt(Nt({}, o), {}, {
        global: f || {}
      })), I = this._getPTDatasets(a);
      return u || !u && h ? b ? this._mergeProps(b, f, h, I) : Nt(Nt(Nt({}, f), h), I) : Nt(Nt({}, h), I);
    },
    _getPTSelf: function() {
      for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
        a[o - 1] = arguments[o];
      return Pe(
        this._usePT.apply(this, [this._getPT(t, this.$name)].concat(a)),
        // Exp; <component :pt="{}"
        this._usePT.apply(this, [this.$_attrsPT].concat(a))
        // Exp; <component :pt:[passthrough_key]:[attribute]="{value}" or <component :pt:[passthrough_key]="() =>{value}"
      );
    },
    _getPTDatasets: function() {
      var t, n, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = "data-pc-", l = a === "root" && Dt((t = this.pt) === null || t === void 0 ? void 0 : t["data-pc-section"]);
      return a !== "transition" && Nt(Nt({}, a === "root" && Nt(Nt(jl({}, "".concat(o, "name"), no(l ? (n = this.pt) === null || n === void 0 ? void 0 : n["data-pc-section"] : this.$.type.name)), l && jl({}, "".concat(o, "extend"), no(this.$.type.name))), gm() && jl({}, "".concat(this.$attrSelector), ""))), {}, jl({}, "".concat(o, "section"), no(a)));
    },
    _getPTClassValue: function() {
      var t = this._getOptionValue.apply(this, arguments);
      return Ca(t) || Iu(t) ? {
        class: t
      } : t;
    },
    _getPT: function(t) {
      var n = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 ? arguments[2] : void 0, l = function(i) {
        var c, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, p = o ? o(i) : i, b = no(a), f = no(n.$name);
        return (c = u ? b !== f ? p == null ? void 0 : p[b] : void 0 : p == null ? void 0 : p[b]) !== null && c !== void 0 ? c : p;
      };
      return t != null && t.hasOwnProperty("_usept") ? {
        _usept: t._usept,
        originalValue: l(t.originalValue),
        value: l(t.value)
      } : l(t, !0);
    },
    _usePT: function(t, n, a, o) {
      var l = function(m) {
        return n(m, a, o);
      };
      if (t != null && t.hasOwnProperty("_usept")) {
        var s, i = t._usept || ((s = this.$primevueConfig) === null || s === void 0 ? void 0 : s.ptOptions) || {}, c = i.mergeSections, u = c === void 0 ? !0 : c, p = i.mergeProps, b = p === void 0 ? !1 : p, f = l(t.originalValue), h = l(t.value);
        return f === void 0 && h === void 0 ? void 0 : Ca(h) ? h : Ca(f) ? f : u || !u && h ? b ? this._mergeProps(b, f, h) : Nt(Nt({}, f), h) : h;
      }
      return l(t);
    },
    _useGlobalPT: function(t, n, a) {
      return this._usePT(this.globalPT, t, n, a);
    },
    _useDefaultPT: function(t, n, a) {
      return this._usePT(this.defaultPT, t, n, a);
    },
    ptm: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this._getPTValue(this.pt, t, Nt(Nt({}, this.$params), n));
    },
    ptmi: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return Pe(this.$_attrsWithoutPT, this.ptm(t, n));
    },
    ptmo: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this._getPTValue(t, n, Nt({
        instance: this
      }, a), !1);
    },
    cx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.isUnstyled ? void 0 : this._getOptionValue(this.$style.classes, t, Nt(Nt({}, this.$params), n));
    },
    sx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (n) {
        var o = this._getOptionValue(this.$style.inlineStyles, t, Nt(Nt({}, this.$params), a)), l = this._getOptionValue(gd.inlineStyles, t, Nt(Nt({}, this.$params), a));
        return [l, o];
      }
    }
  },
  computed: {
    globalPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(a) {
        return fa(a, {
          instance: n
        });
      });
    },
    defaultPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(a) {
        return n._getOptionValue(a, n.$name, Nt({}, n.$params)) || fa(a, Nt({}, n.$params));
      });
    },
    isUnstyled: function() {
      var t;
      return this.unstyled !== void 0 ? this.unstyled : (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.unstyled;
    },
    $inProps: function() {
      var t, n = Object.keys(((t = this.$.vnode) === null || t === void 0 ? void 0 : t.props) || {});
      return Object.fromEntries(Object.entries(this.$props).filter(function(a) {
        var o = Al(a, 1), l = o[0];
        return n == null ? void 0 : n.includes(l);
      }));
    },
    $theme: function() {
      var t;
      return (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.theme;
    },
    $style: function() {
      return Nt(Nt({
        classes: void 0,
        inlineStyles: void 0,
        load: function() {
        },
        loadCSS: function() {
        },
        loadTheme: function() {
        }
      }, (this._getHostInstance(this) || {}).$style), this.$options.style);
    },
    $styleOptions: function() {
      var t;
      return {
        nonce: (t = this.$primevueConfig) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
      };
    },
    $primevueConfig: function() {
      var t;
      return (t = this.$primevue) === null || t === void 0 ? void 0 : t.config;
    },
    $name: function() {
      return this.$options.hostName || this.$.type.name;
    },
    $params: function() {
      var t = this._getHostInstance(this) || this.$parent;
      return {
        instance: this,
        props: this.$props,
        state: this.$data,
        attrs: this.$attrs,
        parent: {
          instance: t,
          props: t == null ? void 0 : t.$props,
          state: t == null ? void 0 : t.$data,
          attrs: t == null ? void 0 : t.$attrs
        }
      };
    },
    $_attrsPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Al(t, 1), a = n[0];
        return a == null ? void 0 : a.startsWith("pt:");
      }).reduce(function(t, n) {
        var a = Al(n, 2), o = a[0], l = a[1], s = o.split(":"), i = b1(s), c = i.slice(1);
        return c == null || c.reduce(function(u, p, b, f) {
          return !u[p] && (u[p] = b === f.length - 1 ? l : {}), u[p];
        }, t), t;
      }, {});
    },
    $_attrsWithoutPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Al(t, 1), a = n[0];
        return !(a != null && a.startsWith("pt:"));
      }).reduce(function(t, n) {
        var a = Al(n, 2), o = a[0], l = a[1];
        return t[o] = l, t;
      }, {});
    }
  }
}, Eu = {
  name: "BaseEditableHolder",
  extends: Ja,
  emits: ["update:modelValue", "value-change"],
  props: {
    modelValue: {
      type: null,
      default: void 0
    },
    defaultValue: {
      type: null,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    invalid: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    formControl: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcForm: {
      default: void 0
    },
    $pcFormField: {
      default: void 0
    }
  },
  data: function() {
    return {
      d_value: this.defaultValue || this.modelValue
    };
  },
  watch: {
    modelValue: function(t) {
      this.d_value = t;
    },
    defaultValue: function(t) {
      this.d_value = t;
    },
    $formName: {
      immediate: !0,
      handler: function(t) {
        var n, a;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (a = n.register) === null || a === void 0 ? void 0 : a.call(n, t, this.$formControl)) || {};
      }
    },
    $formControl: {
      immediate: !0,
      handler: function(t) {
        var n, a;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (a = n.register) === null || a === void 0 ? void 0 : a.call(n, this.$formName, t)) || {};
      }
    },
    $formDefaultValue: {
      immediate: !0,
      handler: function(t) {
        this.d_value !== t && (this.d_value = t);
      }
    }
  },
  formField: {},
  methods: {
    writeValue: function(t, n) {
      var a, o;
      this.controlled && (this.d_value = t, this.$emit("update:modelValue", t)), this.$emit("value-change", t), (a = (o = this.formField).onChange) === null || a === void 0 || a.call(o, {
        originalEvent: n,
        value: t
      });
    }
  },
  computed: {
    $filled: function() {
      return Dt(this.d_value);
    },
    $invalid: function() {
      var t, n, a, o;
      return (t = (n = this.invalid) !== null && n !== void 0 ? n : (a = this.$pcFormField) === null || a === void 0 || (a = a.$field) === null || a === void 0 ? void 0 : a.invalid) !== null && t !== void 0 ? t : (o = this.$pcForm) === null || o === void 0 || (o = o.states) === null || o === void 0 || (o = o[this.$formName]) === null || o === void 0 ? void 0 : o.invalid;
    },
    $formName: function() {
      var t;
      return this.name || ((t = this.$formControl) === null || t === void 0 ? void 0 : t.name);
    },
    $formControl: function() {
      var t;
      return this.formControl || ((t = this.$pcFormField) === null || t === void 0 ? void 0 : t.formControl);
    },
    $formDefaultValue: function() {
      var t, n, a, o;
      return (t = (n = this.d_value) !== null && n !== void 0 ? n : (a = this.$pcFormField) === null || a === void 0 ? void 0 : a.initialValue) !== null && t !== void 0 ? t : (o = this.$pcForm) === null || o === void 0 || (o = o.initialValues) === null || o === void 0 ? void 0 : o[this.$formName];
    },
    controlled: function() {
      return this.$inProps.hasOwnProperty("modelValue") || !this.$inProps.hasOwnProperty("modelValue") && !this.$inProps.hasOwnProperty("defaultValue");
    },
    // @deprecated use $filled instead
    filled: function() {
      return this.$filled;
    }
  }
};
const S1 = {
  name: "BaseSlider",
  extends: Eu,
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    orientation: {
      type: String,
      default: "horizontal"
    },
    step: {
      type: Number,
      default: null
    },
    range: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: vh,
  provide() {
    return {
      $pcSlider: this,
      $parentInstance: this
    };
  }
}, $t = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, o] of t)
    n[a] = o;
  return n;
}, I1 = {
  name: "Slider",
  extends: S1,
  inheritAttrs: !1,
  emits: ["change", "slideend"],
  dragging: !1,
  handleIndex: null,
  initX: null,
  initY: null,
  barWidth: null,
  barHeight: null,
  dragListener: null,
  dragEndListener: null,
  beforeUnmount() {
    this.unbindDragListeners();
  },
  methods: {
    updateDomData() {
      let e = this.$el.getBoundingClientRect();
      this.initX = e.left + Dy(), this.initY = e.top + Ay(), this.barWidth = this.$el.offsetWidth, this.barHeight = this.$el.offsetHeight;
    },
    setValue(e) {
      let t, n = e.touches ? e.touches[0].pageX : e.pageX, a = e.touches ? e.touches[0].pageY : e.pageY;
      this.orientation === "horizontal" ? Fy(this.$el) ? t = (this.initX + this.barWidth - n) * 100 / this.barWidth : t = (n - this.initX) * 100 / this.barWidth : t = (this.initY + this.barHeight - a) * 100 / this.barHeight;
      let o = (this.max - this.min) * (t / 100) + this.min;
      if (this.step) {
        const l = this.range ? this.value[this.handleIndex] : this.value, s = o - l;
        s < 0 ? o = l + Math.ceil(o / this.step - l / this.step) * this.step : s > 0 && (o = l + Math.floor(o / this.step - l / this.step) * this.step);
      } else
        o = Math.floor(o);
      this.updateModel(e, o);
    },
    updateModel(e, t) {
      let n = parseFloat(t.toFixed(10)), a;
      this.range ? (a = this.value ? [...this.value] : [], this.handleIndex == 0 ? (n < this.min ? n = this.min : n >= this.max && (n = this.max), a[0] = n) : (n > this.max ? n = this.max : n <= this.min && (n = this.min), a[1] = n)) : (n < this.min ? n = this.min : n > this.max && (n = this.max), a = n), this.writeValue(a, e), this.$emit("change", a);
    },
    onDragStart(e, t) {
      this.disabled || (this.$el.setAttribute("data-p-sliding", !0), this.dragging = !0, this.updateDomData(), this.range && this.value[0] === this.max ? this.handleIndex = 0 : this.handleIndex = t, e.currentTarget.focus());
    },
    onDrag(e) {
      this.dragging && this.setValue(e);
    },
    onDragEnd(e) {
      this.dragging && (this.dragging = !1, this.$el.setAttribute("data-p-sliding", !1), this.$emit("slideend", { originalEvent: e, value: this.value }));
    },
    onBarClick(e) {
      this.disabled || fm(e.target, "data-pc-section") !== "handle" && (this.updateDomData(), this.setValue(e));
    },
    onMouseDown(e, t) {
      this.bindDragListeners(), this.onDragStart(e, t);
    },
    onKeyDown(e, t) {
      switch (this.handleIndex = t, e.code) {
        case "ArrowDown":
        case "ArrowLeft":
          this.decrementValue(e, t), e.preventDefault();
          break;
        case "ArrowUp":
        case "ArrowRight":
          this.incrementValue(e, t), e.preventDefault();
          break;
        case "PageDown":
          this.decrementValue(e, t, !0), e.preventDefault();
          break;
        case "PageUp":
          this.incrementValue(e, t, !0), e.preventDefault();
          break;
        case "Home":
          this.updateModel(e, this.min), e.preventDefault();
          break;
        case "End":
          this.updateModel(e, this.max), e.preventDefault();
          break;
      }
    },
    onBlur(e, t) {
      var n, a;
      (a = (n = this.formField).onBlur) == null || a.call(n, e);
    },
    decrementValue(e, t, n = !1) {
      let a;
      this.range ? this.step ? a = this.value[t] - this.step : a = this.value[t] - 1 : this.step ? a = this.value - this.step : !this.step && n ? a = this.value - 10 : a = this.value - 1, this.updateModel(e, a), e.preventDefault();
    },
    incrementValue(e, t, n = !1) {
      let a;
      this.range ? this.step ? a = this.value[t] + this.step : a = this.value[t] + 1 : this.step ? a = this.value + this.step : !this.step && n ? a = this.value + 10 : a = this.value + 1, this.updateModel(e, a), e.preventDefault();
    },
    bindDragListeners() {
      this.dragListener || (this.dragListener = this.onDrag.bind(this), document.addEventListener("mousemove", this.dragListener)), this.dragEndListener || (this.dragEndListener = this.onDragEnd.bind(this), document.addEventListener("mouseup", this.dragEndListener));
    },
    unbindDragListeners() {
      this.dragListener && (document.removeEventListener("mousemove", this.dragListener), this.dragListener = null), this.dragEndListener && (document.removeEventListener("mouseup", this.dragEndListener), this.dragEndListener = null);
    },
    rangeStyle() {
      if (this.range) {
        const e = this.rangeEndPosition > this.rangeStartPosition ? this.rangeEndPosition - this.rangeStartPosition : this.rangeStartPosition - this.rangeEndPosition, t = this.rangeEndPosition > this.rangeStartPosition ? this.rangeStartPosition : this.rangeEndPosition;
        return this.horizontal ? { "inset-inline-start": t + "%", width: e + "%" } : { bottom: t + "%", height: e + "%" };
      } else
        return this.horizontal ? { width: this.handlePosition + "%" } : { height: this.handlePosition + "%" };
    },
    handleStyle() {
      return this.horizontal ? { "inset-inline-start": this.handlePosition + "%" } : { bottom: this.handlePosition + "%" };
    },
    rangeStartHandleStyle() {
      return this.horizontal ? { "inset-inline-start": this.rangeStartPosition + "%" } : { bottom: this.rangeStartPosition + "%" };
    },
    rangeEndHandleStyle() {
      return this.horizontal ? { "inset-inline-start": this.rangeEndPosition + "%" } : { bottom: this.rangeEndPosition + "%" };
    }
  },
  computed: {
    value() {
      var e, t;
      return this.range ? [((e = this.d_value) == null ? void 0 : e[0]) ?? this.min, ((t = this.d_value) == null ? void 0 : t[1]) ?? this.max] : this.d_value ?? this.min;
    },
    horizontal() {
      return this.orientation === "horizontal";
    },
    vertical() {
      return this.orientation === "vertical";
    },
    handlePosition() {
      return this.value < this.min ? 0 : this.value > this.max ? 100 : (this.value - this.min) * 100 / (this.max - this.min);
    },
    rangeStartPosition() {
      return this.value && this.value[0] !== void 0 ? this.value[0] < this.min ? 0 : (this.value[0] - this.min) * 100 / (this.max - this.min) : 0;
    },
    rangeEndPosition() {
      return this.value && this.value.length === 2 && this.value[1] !== void 0 ? this.value[1] > this.max ? 100 : (this.value[1] - this.min) * 100 / (this.max - this.min) : 100;
    }
  }
}, E1 = ["tabindex", "aria-valuemin", "aria-valuenow", "aria-valuemax", "aria-labelledby", "aria-label", "aria-orientation"], T1 = ["tabindex", "aria-valuemin", "aria-valuenow", "aria-valuemax", "aria-labelledby", "aria-label", "aria-orientation"], C1 = ["tabindex", "aria-valuemin", "aria-valuenow", "aria-valuemax", "aria-labelledby", "aria-label", "aria-orientation"];
function N1(e, t, n, a, o, l) {
  return O(), J("div", Pe({
    class: e.cx("root"),
    onClick: t[18] || (t[18] = (...s) => l.onBarClick && l.onBarClick(...s))
  }, e.ptmi("root"), { "data-p-sliding": !1 }), [
    y("span", Pe({
      class: e.cx("range"),
      style: [e.sx("range"), l.rangeStyle()]
    }, e.ptm("range")), null, 16),
    e.range ? ue("", !0) : (O(), J("span", Pe({
      key: 0,
      class: e.cx("handle"),
      style: [e.sx("handle"), l.handleStyle()],
      onTouchstartPassive: t[0] || (t[0] = (s) => l.onDragStart(s)),
      onTouchmovePassive: t[1] || (t[1] = (s) => l.onDrag(s)),
      onTouchend: t[2] || (t[2] = (s) => l.onDragEnd(s)),
      onMousedown: t[3] || (t[3] = (s) => l.onMouseDown(s)),
      onKeydown: t[4] || (t[4] = (s) => l.onKeyDown(s)),
      onBlur: t[5] || (t[5] = (s) => l.onBlur(s)),
      tabindex: e.tabindex,
      role: "slider",
      "aria-valuemin": e.min,
      "aria-valuenow": e.d_value,
      "aria-valuemax": e.max,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-orientation": e.orientation
    }, e.ptm("handle")), null, 16, E1)),
    e.range ? (O(), J("span", Pe({
      key: 1,
      class: e.cx("handle"),
      style: [e.sx("handle"), l.rangeStartHandleStyle()],
      onTouchstartPassive: t[6] || (t[6] = (s) => l.onDragStart(s, 0)),
      onTouchmovePassive: t[7] || (t[7] = (s) => l.onDrag(s)),
      onTouchend: t[8] || (t[8] = (s) => l.onDragEnd(s)),
      onMousedown: t[9] || (t[9] = (s) => l.onMouseDown(s, 0)),
      onKeydown: t[10] || (t[10] = (s) => l.onKeyDown(s, 0)),
      onBlur: t[11] || (t[11] = (s) => l.onBlur(s, 0)),
      tabindex: e.tabindex,
      role: "slider",
      "aria-valuemin": e.min,
      "aria-valuenow": e.d_value ? e.d_value[0] : null,
      "aria-valuemax": e.max,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-orientation": e.orientation
    }, e.ptm("startHandler")), null, 16, T1)) : ue("", !0),
    e.range ? (O(), J("span", Pe({
      key: 2,
      class: e.cx("handle"),
      style: [e.sx("handle"), l.rangeEndHandleStyle()],
      onTouchstartPassive: t[12] || (t[12] = (s) => l.onDragStart(s, 1)),
      onTouchmovePassive: t[13] || (t[13] = (s) => l.onDrag(s)),
      onTouchend: t[14] || (t[14] = (s) => l.onDragEnd(s)),
      onMousedown: t[15] || (t[15] = (s) => l.onMouseDown(s, 1)),
      onKeydown: t[16] || (t[16] = (s) => l.onKeyDown(s, 1)),
      onBlur: t[17] || (t[17] = (s) => l.onBlur(s, 1)),
      tabindex: e.tabindex,
      role: "slider",
      "aria-valuemin": e.min,
      "aria-valuenow": e.d_value ? e.d_value[1] : null,
      "aria-valuemax": e.max,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-orientation": e.orientation
    }, e.ptm("endHandler")), null, 16, C1)) : ue("", !0)
  ], 16);
}
const L1 = /* @__PURE__ */ $t(I1, [["render", N1]]), O1 = { class: "slider-container" }, D1 = { style: { "white-space": "nowrap" } }, A1 = /* @__PURE__ */ qe({
  __name: "ViewerSettingsSlider",
  props: {
    label: {},
    modelValue: {},
    min: {},
    max: {},
    step: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, a = (o) => {
      n("update:modelValue", o);
    };
    return (o, l) => {
      const s = L1;
      return O(), J("div", O1, [
        y("div", D1, V(e.label), 1),
        d(s, {
          max: e.max,
          min: e.min,
          modelValue: e.modelValue,
          range: !1,
          step: e.step,
          style: { width: "100%" },
          "onUpdate:modelValue": a
        }, null, 8, ["max", "min", "modelValue", "step"])
      ]);
    };
  }
});
var Tu = {
  name: "BaseInput",
  extends: Eu,
  props: {
    size: {
      type: String,
      default: null
    },
    fluid: {
      type: Boolean,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcFluid: {
      default: void 0
    }
  },
  computed: {
    $variant: function() {
      var t;
      return (t = this.variant) !== null && t !== void 0 ? t : this.$primevue.config.inputStyle || this.$primevue.config.inputVariant;
    },
    $fluid: function() {
      var t;
      return (t = this.fluid) !== null && t !== void 0 ? t : !!this.$pcFluid;
    },
    // @deprecated use $fluid instead
    hasFluid: function() {
      return this.$fluid;
    }
  }
};
const R1 = {
  name: "BaseRadioButton",
  extends: Tu,
  props: {
    value: null,
    binary: Boolean,
    readonly: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: yh,
  provide() {
    return {
      $pcRadioButton: this,
      $parentInstance: this
    };
  }
}, M1 = {
  name: "RadioButton",
  extends: R1,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur"],
  inject: {
    $pcRadioButtonGroup: {
      default: void 0
    }
  },
  methods: {
    getPTOptions(e) {
      return (e === "root" ? this.ptmi : this.ptm)(e, {
        context: {
          checked: this.checked,
          disabled: this.disabled
        }
      });
    },
    onChange(e) {
      if (!this.disabled && !this.readonly) {
        const t = this.binary ? !this.checked : this.value;
        this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.writeValue(t, e) : this.writeValue(t, e), this.$emit("change", e);
      }
    },
    onFocus(e) {
      this.$emit("focus", e);
    },
    onBlur(e) {
      var t, n;
      this.$emit("blur", e), (n = (t = this.formField).onBlur) == null || n.call(t, e);
    }
  },
  computed: {
    groupName() {
      return this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.groupName : this.$formName;
    },
    checked() {
      const e = this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.d_value : this.d_value;
      return e != null && (this.binary ? !!e : as(e, this.value));
    }
  }
}, P1 = ["data-p-checked", "data-p-disabled"], x1 = ["id", "value", "name", "checked", "tabindex", "disabled", "readonly", "aria-labelledby", "aria-label", "aria-invalid"];
function j1(e, t, n, a, o, l) {
  return O(), J("div", Pe({
    class: e.cx("root")
  }, l.getPTOptions("root"), {
    "data-p-checked": l.checked,
    "data-p-disabled": e.disabled
  }), [
    y("input", Pe({
      id: e.inputId,
      type: "radio",
      class: [e.cx("input"), e.inputClass],
      style: e.inputStyle,
      value: e.value,
      name: l.groupName,
      checked: l.checked,
      tabindex: e.tabindex,
      disabled: e.disabled,
      readonly: e.readonly,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-invalid": e.invalid || void 0,
      onFocus: t[0] || (t[0] = (...s) => l.onFocus && l.onFocus(...s)),
      onBlur: t[1] || (t[1] = (...s) => l.onBlur && l.onBlur(...s)),
      onChange: t[2] || (t[2] = (...s) => l.onChange && l.onChange(...s))
    }, l.getPTOptions("input")), null, 16, x1),
    y("div", Pe({
      class: e.cx("box")
    }, l.getPTOptions("box")), [
      y("div", Pe({
        class: e.cx("icon")
      }, l.getPTOptions("icon")), null, 16)
    ], 16)
  ], 16, P1);
}
const F1 = /* @__PURE__ */ $t(M1, [["render", j1]]), $1 = { class: "container" }, k1 = { style: { "font-weight": "bold" } }, V1 = { style: { "padding-top": "16px", "flex-direction": "column", "flex-gap": "16px" } }, B1 = /* @__PURE__ */ qe({
  __name: "ViewerSettingsSection",
  props: {
    title: {}
  },
  setup(e) {
    return (t, n) => (O(), J("div", $1, [
      y("div", k1, V(e.title), 1),
      n[0] || (n[0] = y("div", { class: "divider" }, null, -1)),
      y("div", V1, [
        St(t.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), U1 = /* @__PURE__ */ $t(B1, [["__scopeId", "data-v-b710c6d5"]]), G1 = { class: "switch-container" }, W1 = {
  class: "ml-2",
  style: { "white-space": "nowrap" }
}, z1 = /* @__PURE__ */ qe({
  __name: "ViewerSettingsSwitch",
  props: /* @__PURE__ */ xn({
    label: {}
  }, {
    state: { type: Boolean, required: !0 },
    stateModifiers: {}
  }),
  emits: ["update:state"],
  setup(e) {
    const t = Ln(e, "state"), n = F({
      state: t.value,
      clicked: !1,
      disabled: !1
    });
    return ot(
      n.value,
      () => {
        t.value = n.value.state;
      },
      { deep: !0 }
    ), (a, o) => (O(), J("div", G1, [
      d(r(Jg), {
        state: r(n).state,
        "onUpdate:state": o[0] || (o[0] = (l) => r(n).state = l),
        style: { margin: "0px" }
      }, {
        trueLabel: w(() => [
          y("span", W1, V(e.label), 1)
        ]),
        _: 1
      }, 8, ["state"])
    ]));
  }
});
var H1 = `
.p-icon {
    display: inline-block;
    vertical-align: baseline;
}

.p-icon-spin {
    -webkit-animation: p-icon-spin 2s infinite linear;
    animation: p-icon-spin 2s infinite linear;
}

@-webkit-keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
`, Y1 = ja.extend({
  name: "baseicon",
  css: H1
});
function si(e) {
  "@babel/helpers - typeof";
  return si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, si(e);
}
function vd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function yd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vd(Object(n), !0).forEach(function(a) {
      K1(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vd(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function K1(e, t, n) {
  return (t = Z1(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Z1(e) {
  var t = J1(e, "string");
  return si(t) == "symbol" ? t : t + "";
}
function J1(e, t) {
  if (si(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (si(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var sa = {
  name: "BaseIcon",
  extends: Ja,
  props: {
    label: {
      type: String,
      default: void 0
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  style: Y1,
  provide: function() {
    return {
      $pcIcon: this,
      $parentInstance: this
    };
  },
  methods: {
    pti: function() {
      var t = hi(this.label);
      return yd(yd({}, !this.isUnstyled && {
        class: ["p-icon", {
          "p-icon-spin": this.spin
        }]
      }), {}, {
        role: t ? void 0 : "img",
        "aria-label": t ? void 0 : this.label,
        "aria-hidden": t
      });
    }
  }
}, Cm = {
  name: "AngleDownIcon",
  extends: sa
};
function X1(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M3.58659 4.5007C3.68513 4.50023 3.78277 4.51945 3.87379 4.55723C3.9648 4.59501 4.04735 4.65058 4.11659 4.7207L7.11659 7.7207L10.1166 4.7207C10.2619 4.65055 10.4259 4.62911 10.5843 4.65956C10.7427 4.69002 10.8871 4.77074 10.996 4.88976C11.1049 5.00877 11.1726 5.15973 11.1889 5.32022C11.2052 5.48072 11.1693 5.6422 11.0866 5.7807L7.58659 9.2807C7.44597 9.42115 7.25534 9.50004 7.05659 9.50004C6.85784 9.50004 6.66722 9.42115 6.52659 9.2807L3.02659 5.7807C2.88614 5.64007 2.80725 5.44945 2.80725 5.2507C2.80725 5.05195 2.88614 4.86132 3.02659 4.7207C3.09932 4.64685 3.18675 4.58911 3.28322 4.55121C3.37969 4.51331 3.48305 4.4961 3.58659 4.5007Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Cm.render = X1;
var Nm = {
  name: "AngleUpIcon",
  extends: sa
};
function q1(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M10.4134 9.49931C10.3148 9.49977 10.2172 9.48055 10.1262 9.44278C10.0352 9.405 9.95263 9.34942 9.88338 9.27931L6.88338 6.27931L3.88338 9.27931C3.73811 9.34946 3.57409 9.3709 3.41567 9.34044C3.25724 9.30999 3.11286 9.22926 3.00395 9.11025C2.89504 8.99124 2.82741 8.84028 2.8111 8.67978C2.79478 8.51928 2.83065 8.35781 2.91338 8.21931L6.41338 4.71931C6.55401 4.57886 6.74463 4.49997 6.94338 4.49997C7.14213 4.49997 7.33276 4.57886 7.47338 4.71931L10.9734 8.21931C11.1138 8.35994 11.1927 8.55056 11.1927 8.74931C11.1927 8.94806 11.1138 9.13868 10.9734 9.27931C10.9007 9.35315 10.8132 9.41089 10.7168 9.44879C10.6203 9.48669 10.5169 9.5039 10.4134 9.49931Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Nm.render = q1;
const Q1 = {
  name: "BaseInputNumber",
  extends: Tu,
  props: {
    format: {
      type: Boolean,
      default: !0
    },
    showButtons: {
      type: Boolean,
      default: !1
    },
    buttonLayout: {
      type: String,
      default: "stacked"
    },
    incrementButtonClass: {
      type: String,
      default: null
    },
    decrementButtonClass: {
      type: String,
      default: null
    },
    incrementButtonIcon: {
      type: String,
      default: void 0
    },
    incrementIcon: {
      type: String,
      default: void 0
    },
    decrementButtonIcon: {
      type: String,
      default: void 0
    },
    decrementIcon: {
      type: String,
      default: void 0
    },
    locale: {
      type: String,
      default: void 0
    },
    localeMatcher: {
      type: String,
      default: void 0
    },
    mode: {
      type: String,
      default: "decimal"
    },
    prefix: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: void 0
    },
    currencyDisplay: {
      type: String,
      default: void 0
    },
    useGrouping: {
      type: Boolean,
      default: !0
    },
    minFractionDigits: {
      type: Number,
      default: void 0
    },
    maxFractionDigits: {
      type: Number,
      default: void 0
    },
    roundingMode: {
      type: String,
      default: "halfExpand",
      validator(e) {
        return ["ceil", "floor", "expand", "trunc", "halfCeil", "halfFloor", "halfExpand", "halfTrunc", "halfEven"].includes(e);
      }
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    highlightOnFocus: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: _h,
  provide() {
    return {
      $pcInputNumber: this,
      $parentInstance: this
    };
  }
}, e_ = {
  name: "InputNumber",
  extends: Q1,
  inheritAttrs: !1,
  emits: ["input", "focus", "blur"],
  inject: {
    $pcFluid: { default: null }
  },
  numberFormat: null,
  _numeral: null,
  _decimal: null,
  _group: null,
  _minusSign: null,
  _currency: null,
  _suffix: null,
  _prefix: null,
  _index: null,
  groupChar: "",
  isSpecialChar: null,
  prefixChar: null,
  suffixChar: null,
  timer: null,
  data() {
    return {
      // @deprecated
      d_modelValue: this.d_value,
      focused: !1
    };
  },
  watch: {
    d_value(e) {
      this.d_modelValue = e;
    },
    locale(e, t) {
      this.updateConstructParser(e, t);
    },
    localeMatcher(e, t) {
      this.updateConstructParser(e, t);
    },
    mode(e, t) {
      this.updateConstructParser(e, t);
    },
    currency(e, t) {
      this.updateConstructParser(e, t);
    },
    currencyDisplay(e, t) {
      this.updateConstructParser(e, t);
    },
    useGrouping(e, t) {
      this.updateConstructParser(e, t);
    },
    minFractionDigits(e, t) {
      this.updateConstructParser(e, t);
    },
    maxFractionDigits(e, t) {
      this.updateConstructParser(e, t);
    },
    suffix(e, t) {
      this.updateConstructParser(e, t);
    },
    prefix(e, t) {
      this.updateConstructParser(e, t);
    }
  },
  created() {
    this.constructParser();
  },
  methods: {
    getOptions() {
      return {
        localeMatcher: this.localeMatcher,
        style: this.mode,
        currency: this.currency,
        currencyDisplay: this.currencyDisplay,
        useGrouping: this.useGrouping,
        minimumFractionDigits: this.minFractionDigits,
        maximumFractionDigits: this.maxFractionDigits,
        roundingMode: this.roundingMode
      };
    },
    constructParser() {
      this.numberFormat = new Intl.NumberFormat(this.locale, this.getOptions());
      const e = [...new Intl.NumberFormat(this.locale, { useGrouping: !1 }).format(9876543210)].reverse(), t = new Map(e.map((n, a) => [n, a]));
      this._numeral = new RegExp(`[${e.join("")}]`, "g"), this._group = this.getGroupingExpression(), this._minusSign = this.getMinusSignExpression(), this._currency = this.getCurrencyExpression(), this._decimal = this.getDecimalExpression(), this._suffix = this.getSuffixExpression(), this._prefix = this.getPrefixExpression(), this._index = (n) => t.get(n);
    },
    updateConstructParser(e, t) {
      e !== t && this.constructParser();
    },
    escapeRegExp(e) {
      return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    },
    getDecimalExpression() {
      const e = new Intl.NumberFormat(this.locale, { ...this.getOptions(), useGrouping: !1 });
      return new RegExp(`[${e.format(1.1).replace(this._currency, "").trim().replace(this._numeral, "")}]`, "g");
    },
    getGroupingExpression() {
      const e = new Intl.NumberFormat(this.locale, { useGrouping: !0 });
      return this.groupChar = e.format(1e6).trim().replace(this._numeral, "").charAt(0), new RegExp(`[${this.groupChar}]`, "g");
    },
    getMinusSignExpression() {
      const e = new Intl.NumberFormat(this.locale, { useGrouping: !1 });
      return new RegExp(`[${e.format(-1).trim().replace(this._numeral, "")}]`, "g");
    },
    getCurrencyExpression() {
      if (this.currency) {
        const e = new Intl.NumberFormat(this.locale, { style: "currency", currency: this.currency, currencyDisplay: this.currencyDisplay, minimumFractionDigits: 0, maximumFractionDigits: 0, roundingMode: this.roundingMode });
        return new RegExp(`[${e.format(1).replace(/\s/g, "").replace(this._numeral, "").replace(this._group, "")}]`, "g");
      }
      return new RegExp("[]", "g");
    },
    getPrefixExpression() {
      if (this.prefix)
        this.prefixChar = this.prefix;
      else {
        const e = new Intl.NumberFormat(this.locale, { style: this.mode, currency: this.currency, currencyDisplay: this.currencyDisplay });
        this.prefixChar = e.format(1).split("1")[0];
      }
      return new RegExp(`${this.escapeRegExp(this.prefixChar || "")}`, "g");
    },
    getSuffixExpression() {
      if (this.suffix)
        this.suffixChar = this.suffix;
      else {
        const e = new Intl.NumberFormat(this.locale, { style: this.mode, currency: this.currency, currencyDisplay: this.currencyDisplay, minimumFractionDigits: 0, maximumFractionDigits: 0, roundingMode: this.roundingMode });
        this.suffixChar = e.format(1).split("1")[1];
      }
      return new RegExp(`${this.escapeRegExp(this.suffixChar || "")}`, "g");
    },
    formatValue(e) {
      if (e != null) {
        if (e === "-")
          return e;
        if (this.format) {
          let n = new Intl.NumberFormat(this.locale, this.getOptions()).format(e);
          return this.prefix && (n = this.prefix + n), this.suffix && (n = n + this.suffix), n;
        }
        return e.toString();
      }
      return "";
    },
    parseValue(e) {
      let t = e.replace(this._suffix, "").replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, "").replace(this._group, "").replace(this._minusSign, "-").replace(this._decimal, ".").replace(this._numeral, this._index);
      if (t) {
        if (t === "-")
          return t;
        let n = +t;
        return isNaN(n) ? null : n;
      }
      return null;
    },
    repeat(e, t, n) {
      if (this.readonly)
        return;
      let a = t || 500;
      this.clearTimer(), this.timer = setTimeout(() => {
        this.repeat(e, 40, n);
      }, a), this.spin(e, n);
    },
    spin(e, t) {
      if (this.$refs.input) {
        let n = this.step * t, a = this.parseValue(this.$refs.input.$el.value) || 0, o = this.validateValue(a + n);
        this.updateInput(o, null, "spin"), this.updateModel(e, o), this.handleOnInput(e, a, o);
      }
    },
    onUpButtonMouseDown(e) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(e, null, 1), e.preventDefault());
    },
    onUpButtonMouseUp() {
      this.disabled || this.clearTimer();
    },
    onUpButtonMouseLeave() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyUp() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyDown(e) {
      (e.code === "Space" || e.code === "Enter" || e.code === "NumpadEnter") && this.repeat(e, null, 1);
    },
    onDownButtonMouseDown(e) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(e, null, -1), e.preventDefault());
    },
    onDownButtonMouseUp() {
      this.disabled || this.clearTimer();
    },
    onDownButtonMouseLeave() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyUp() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyDown(e) {
      (e.code === "Space" || e.code === "Enter" || e.code === "NumpadEnter") && this.repeat(e, null, -1);
    },
    onUserInput() {
      this.isSpecialChar && (this.$refs.input.$el.value = this.lastValue), this.isSpecialChar = !1;
    },
    onInputKeyDown(e) {
      if (this.readonly)
        return;
      if (e.altKey || e.ctrlKey || e.metaKey) {
        this.isSpecialChar = !0, this.lastValue = this.$refs.input.$el.value;
        return;
      }
      this.lastValue = e.target.value;
      let t = e.target.selectionStart, n = e.target.selectionEnd, a = n - t, o = e.target.value, l = null;
      switch (e.code || e.key) {
        case "ArrowUp":
          this.spin(e, 1), e.preventDefault();
          break;
        case "ArrowDown":
          this.spin(e, -1), e.preventDefault();
          break;
        case "ArrowLeft":
          if (a > 1) {
            const i = this.isNumeralChar(o.charAt(t)) ? t + 1 : t + 2;
            this.$refs.input.$el.setSelectionRange(i, i);
          } else this.isNumeralChar(o.charAt(t - 1)) || e.preventDefault();
          break;
        case "ArrowRight":
          if (a > 1) {
            const i = n - 1;
            this.$refs.input.$el.setSelectionRange(i, i);
          } else this.isNumeralChar(o.charAt(t)) || e.preventDefault();
          break;
        case "Tab":
        case "Enter":
        case "NumpadEnter":
          l = this.validateValue(this.parseValue(o)), this.$refs.input.$el.value = this.formatValue(l), this.$refs.input.$el.setAttribute("aria-valuenow", l), this.updateModel(e, l);
          break;
        case "Backspace": {
          if (e.preventDefault(), t === n) {
            const i = o.charAt(t - 1), { decimalCharIndex: c, decimalCharIndexWithoutPrefix: u } = this.getDecimalCharIndexes(o);
            if (this.isNumeralChar(i)) {
              const p = this.getDecimalLength(o);
              if (this._group.test(i))
                this._group.lastIndex = 0, l = o.slice(0, t - 2) + o.slice(t - 1);
              else if (this._decimal.test(i))
                this._decimal.lastIndex = 0, p ? this.$refs.input.$el.setSelectionRange(t - 1, t - 1) : l = o.slice(0, t - 1) + o.slice(t);
              else if (c > 0 && t > c) {
                const b = this.isDecimalMode() && (this.minFractionDigits || 0) < p ? "" : "0";
                l = o.slice(0, t - 1) + b + o.slice(t);
              } else u === 1 ? (l = o.slice(0, t - 1) + "0" + o.slice(t), l = this.parseValue(l) > 0 ? l : "") : l = o.slice(0, t - 1) + o.slice(t);
            }
            this.updateValue(e, l, null, "delete-single");
          } else
            l = this.deleteRange(o, t, n), this.updateValue(e, l, null, "delete-range");
          break;
        }
        case "Delete":
          if (e.preventDefault(), t === n) {
            const i = o.charAt(t), { decimalCharIndex: c, decimalCharIndexWithoutPrefix: u } = this.getDecimalCharIndexes(o);
            if (this.isNumeralChar(i)) {
              const p = this.getDecimalLength(o);
              if (this._group.test(i))
                this._group.lastIndex = 0, l = o.slice(0, t) + o.slice(t + 2);
              else if (this._decimal.test(i))
                this._decimal.lastIndex = 0, p ? this.$refs.input.$el.setSelectionRange(t + 1, t + 1) : l = o.slice(0, t) + o.slice(t + 1);
              else if (c > 0 && t > c) {
                const b = this.isDecimalMode() && (this.minFractionDigits || 0) < p ? "" : "0";
                l = o.slice(0, t) + b + o.slice(t + 1);
              } else u === 1 ? (l = o.slice(0, t) + "0" + o.slice(t + 1), l = this.parseValue(l) > 0 ? l : "") : l = o.slice(0, t) + o.slice(t + 1);
            }
            this.updateValue(e, l, null, "delete-back-single");
          } else
            l = this.deleteRange(o, t, n), this.updateValue(e, l, null, "delete-range");
          break;
        case "Home":
          e.preventDefault(), Dt(this.min) && this.updateModel(e, this.min);
          break;
        case "End":
          e.preventDefault(), Dt(this.max) && this.updateModel(e, this.max);
          break;
      }
    },
    onInputKeyPress(e) {
      if (this.readonly)
        return;
      let t = e.key, n = this.isDecimalSign(t);
      const a = this.isMinusSign(t);
      e.code !== "Enter" && e.preventDefault(), (Number(t) >= 0 && Number(t) <= 9 || a || n) && this.insert(e, t, { isDecimalSign: n, isMinusSign: a });
    },
    onPaste(e) {
      e.preventDefault();
      let t = (e.clipboardData || window.clipboardData).getData("Text");
      if (t) {
        let n = this.parseValue(t);
        n != null && this.insert(e, n.toString());
      }
    },
    allowMinusSign() {
      return this.min === null || this.min < 0;
    },
    isMinusSign(e) {
      return this._minusSign.test(e) || e === "-" ? (this._minusSign.lastIndex = 0, !0) : !1;
    },
    isDecimalSign(e) {
      return this._decimal.test(e) ? (this._decimal.lastIndex = 0, !0) : !1;
    },
    isDecimalMode() {
      return this.mode === "decimal";
    },
    getDecimalCharIndexes(e) {
      let t = e.search(this._decimal);
      this._decimal.lastIndex = 0;
      const a = e.replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, "").search(this._decimal);
      return this._decimal.lastIndex = 0, { decimalCharIndex: t, decimalCharIndexWithoutPrefix: a };
    },
    getCharIndexes(e) {
      const t = e.search(this._decimal);
      this._decimal.lastIndex = 0;
      const n = e.search(this._minusSign);
      this._minusSign.lastIndex = 0;
      const a = e.search(this._suffix);
      this._suffix.lastIndex = 0;
      const o = e.search(this._currency);
      return this._currency.lastIndex = 0, { decimalCharIndex: t, minusCharIndex: n, suffixCharIndex: a, currencyCharIndex: o };
    },
    insert(e, t, n = { isDecimalSign: !1, isMinusSign: !1 }) {
      const a = t.search(this._minusSign);
      if (this._minusSign.lastIndex = 0, !this.allowMinusSign() && a !== -1)
        return;
      const o = this.$refs.input.$el.selectionStart, l = this.$refs.input.$el.selectionEnd;
      let s = this.$refs.input.$el.value.trim();
      const { decimalCharIndex: i, minusCharIndex: c, suffixCharIndex: u, currencyCharIndex: p } = this.getCharIndexes(s);
      let b;
      if (n.isMinusSign)
        o === 0 && (b = s, (c === -1 || l !== 0) && (b = this.insertText(s, t, 0, l)), this.updateValue(e, b, t, "insert"));
      else if (n.isDecimalSign)
        i > 0 && o === i ? this.updateValue(e, s, t, "insert") : i > o && i < l ? (b = this.insertText(s, t, o, l), this.updateValue(e, b, t, "insert")) : i === -1 && this.maxFractionDigits && (b = this.insertText(s, t, o, l), this.updateValue(e, b, t, "insert"));
      else {
        const f = this.numberFormat.resolvedOptions().maximumFractionDigits, h = o !== l ? "range-insert" : "insert";
        if (i > 0 && o > i) {
          if (o + t.length - (i + 1) <= f) {
            const I = p >= o ? p - 1 : u >= o ? u : s.length;
            b = s.slice(0, o) + t + s.slice(o + t.length, I) + s.slice(I), this.updateValue(e, b, t, h);
          }
        } else
          b = this.insertText(s, t, o, l), this.updateValue(e, b, t, h);
      }
    },
    insertText(e, t, n, a) {
      if ((t === "." ? t : t.split(".")).length === 2) {
        const l = e.slice(n, a).search(this._decimal);
        return this._decimal.lastIndex = 0, l > 0 ? e.slice(0, n) + this.formatValue(t) + e.slice(a) : this.formatValue(t) || e;
      } else return a - n === e.length ? this.formatValue(t) : n === 0 ? t + e.slice(a) : a === e.length ? e.slice(0, n) + t : e.slice(0, n) + t + e.slice(a);
    },
    deleteRange(e, t, n) {
      let a;
      return n - t === e.length ? a = "" : t === 0 ? a = e.slice(n) : n === e.length ? a = e.slice(0, t) : a = e.slice(0, t) + e.slice(n), a;
    },
    initCursor() {
      let e = this.$refs.input.$el.selectionStart, t = this.$refs.input.$el.value, n = t.length, a = null, o = (this.prefixChar || "").length;
      t = t.replace(this._prefix, ""), e = e - o;
      let l = t.charAt(e);
      if (this.isNumeralChar(l))
        return e + o;
      let s = e - 1;
      for (; s >= 0; )
        if (l = t.charAt(s), this.isNumeralChar(l)) {
          a = s + o;
          break;
        } else
          s--;
      if (a !== null)
        this.$refs.input.$el.setSelectionRange(a + 1, a + 1);
      else {
        for (s = e; s < n; )
          if (l = t.charAt(s), this.isNumeralChar(l)) {
            a = s + o;
            break;
          } else
            s++;
        a !== null && this.$refs.input.$el.setSelectionRange(a, a);
      }
      return a || 0;
    },
    onInputClick() {
      const e = this.$refs.input.$el.value;
      !this.readonly && e !== id() && this.initCursor();
    },
    isNumeralChar(e) {
      return e.length === 1 && (this._numeral.test(e) || this._decimal.test(e) || this._group.test(e) || this._minusSign.test(e)) ? (this.resetRegex(), !0) : !1;
    },
    resetRegex() {
      this._numeral.lastIndex = 0, this._decimal.lastIndex = 0, this._group.lastIndex = 0, this._minusSign.lastIndex = 0;
    },
    updateValue(e, t, n, a) {
      let o = this.$refs.input.$el.value, l = null;
      t != null && (l = this.parseValue(t), l = !l && !this.allowEmpty ? 0 : l, this.updateInput(l, n, a, t), this.handleOnInput(e, o, l));
    },
    handleOnInput(e, t, n) {
      var a, o;
      this.isValueChanged(t, n) && (this.$emit("input", { originalEvent: e, value: n, formattedValue: t }), (o = (a = this.formField).onInput) == null || o.call(a, { originalEvent: e, value: n }));
    },
    isValueChanged(e, t) {
      if (t === null && e !== null)
        return !0;
      if (t != null) {
        let n = typeof e == "string" ? this.parseValue(e) : e;
        return t !== n;
      }
      return !1;
    },
    validateValue(e) {
      return e === "-" || e == null ? null : this.min != null && e < this.min ? this.min : this.max != null && e > this.max ? this.max : e;
    },
    updateInput(e, t, n, a) {
      t = t || "";
      let o = this.$refs.input.$el.value, l = this.formatValue(e), s = o.length;
      if (l !== a && (l = this.concatValues(l, a)), s === 0) {
        this.$refs.input.$el.value = l, this.$refs.input.$el.setSelectionRange(0, 0);
        const c = this.initCursor() + t.length;
        this.$refs.input.$el.setSelectionRange(c, c);
      } else {
        let i = this.$refs.input.$el.selectionStart, c = this.$refs.input.$el.selectionEnd;
        this.$refs.input.$el.value = l;
        let u = l.length;
        if (n === "range-insert") {
          const p = this.parseValue((o || "").slice(0, i)), f = (p !== null ? p.toString() : "").split("").join(`(${this.groupChar})?`), h = new RegExp(f, "g");
          h.test(l);
          const I = t.split("").join(`(${this.groupChar})?`), m = new RegExp(I, "g");
          m.test(l.slice(h.lastIndex)), c = h.lastIndex + m.lastIndex, this.$refs.input.$el.setSelectionRange(c, c);
        } else if (u === s)
          n === "insert" || n === "delete-back-single" ? this.$refs.input.$el.setSelectionRange(c + 1, c + 1) : n === "delete-single" ? this.$refs.input.$el.setSelectionRange(c - 1, c - 1) : (n === "delete-range" || n === "spin") && this.$refs.input.$el.setSelectionRange(c, c);
        else if (n === "delete-back-single") {
          let p = o.charAt(c - 1), b = o.charAt(c), f = s - u, h = this._group.test(b);
          h && f === 1 ? c += 1 : !h && this.isNumeralChar(p) && (c += -1 * f + 1), this._group.lastIndex = 0, this.$refs.input.$el.setSelectionRange(c, c);
        } else if (o === "-" && n === "insert") {
          this.$refs.input.$el.setSelectionRange(0, 0);
          const b = this.initCursor() + t.length + 1;
          this.$refs.input.$el.setSelectionRange(b, b);
        } else
          c = c + (u - s), this.$refs.input.$el.setSelectionRange(c, c);
      }
      this.$refs.input.$el.setAttribute("aria-valuenow", e);
    },
    concatValues(e, t) {
      if (e && t) {
        let n = t.search(this._decimal);
        return this._decimal.lastIndex = 0, this.suffixChar ? n !== -1 ? e.replace(this.suffixChar, "").split(this._decimal)[0] + t.replace(this.suffixChar, "").slice(n) + this.suffixChar : e : n !== -1 ? e.split(this._decimal)[0] + t.slice(n) : e;
      }
      return e;
    },
    getDecimalLength(e) {
      if (e) {
        const t = e.split(this._decimal);
        if (t.length === 2)
          return t[1].replace(this._suffix, "").trim().replace(/\s/g, "").replace(this._currency, "").length;
      }
      return 0;
    },
    updateModel(e, t) {
      this.writeValue(t, e);
    },
    onInputFocus(e) {
      this.focused = !0, !this.disabled && !this.readonly && this.$refs.input.$el.value !== id() && this.highlightOnFocus && e.target.select(), this.$emit("focus", e);
    },
    onInputBlur(e) {
      var a, o;
      this.focused = !1;
      let t = e.target, n = this.validateValue(this.parseValue(t.value));
      this.$emit("blur", { originalEvent: e, value: t.value }), (o = (a = this.formField).onBlur) == null || o.call(a, e), t.value = this.formatValue(n), t.setAttribute("aria-valuenow", n), this.updateModel(e, n), !this.disabled && !this.readonly && this.highlightOnFocus && Ry();
    },
    clearTimer() {
      this.timer && clearInterval(this.timer);
    },
    maxBoundry() {
      return this.d_value >= this.max;
    },
    minBoundry() {
      return this.d_value <= this.min;
    }
  },
  computed: {
    upButtonListeners() {
      return {
        mousedown: (e) => this.onUpButtonMouseDown(e),
        mouseup: (e) => this.onUpButtonMouseUp(e),
        mouseleave: (e) => this.onUpButtonMouseLeave(e),
        keydown: (e) => this.onUpButtonKeyDown(e),
        keyup: (e) => this.onUpButtonKeyUp(e)
      };
    },
    downButtonListeners() {
      return {
        mousedown: (e) => this.onDownButtonMouseDown(e),
        mouseup: (e) => this.onDownButtonMouseUp(e),
        mouseleave: (e) => this.onDownButtonMouseLeave(e),
        keydown: (e) => this.onDownButtonKeyDown(e),
        keyup: (e) => this.onDownButtonKeyUp(e)
      };
    },
    formattedValue() {
      const e = !this.d_value && !this.allowEmpty ? 0 : this.d_value;
      return this.formatValue(e);
    },
    getFormatter() {
      return this.numberFormat;
    }
  },
  components: {
    InputText: ca,
    AngleUpIcon: Nm,
    AngleDownIcon: Cm
  }
}, t_ = ["disabled"], n_ = ["disabled"], a_ = ["disabled"], o_ = ["disabled"];
function l_(e, t, n, a, o, l) {
  const s = Cn("InputText");
  return O(), J("span", Pe({
    class: e.cx("root")
  }, e.ptmi("root")), [
    d(s, {
      ref: "input",
      id: e.inputId,
      role: "spinbutton",
      class: He([e.cx("pcInputText"), e.inputClass]),
      style: Tt(e.inputStyle),
      value: l.formattedValue,
      "aria-valuemin": e.min,
      "aria-valuemax": e.max,
      "aria-valuenow": e.d_value,
      inputmode: e.mode === "decimal" && !e.minFractionDigits ? "numeric" : "decimal",
      disabled: e.disabled,
      readonly: e.readonly,
      placeholder: e.placeholder,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      size: e.size,
      invalid: e.invalid,
      variant: e.variant,
      onInput: l.onUserInput,
      onKeydown: l.onInputKeyDown,
      onKeypress: l.onInputKeyPress,
      onPaste: l.onPaste,
      onClick: l.onInputClick,
      onFocus: l.onInputFocus,
      onBlur: l.onInputBlur,
      pt: e.ptm("pcInputText"),
      unstyled: e.unstyled
    }, null, 8, ["id", "class", "style", "value", "aria-valuemin", "aria-valuemax", "aria-valuenow", "inputmode", "disabled", "readonly", "placeholder", "aria-labelledby", "aria-label", "size", "invalid", "variant", "onInput", "onKeydown", "onKeypress", "onPaste", "onClick", "onFocus", "onBlur", "pt", "unstyled"]),
    e.showButtons && e.buttonLayout === "stacked" ? (O(), J("span", Pe({
      key: 0,
      class: e.cx("buttonGroup")
    }, e.ptm("buttonGroup")), [
      St(e.$slots, "incrementbutton", { listeners: l.upButtonListeners }, () => [
        y("button", Pe({
          class: [e.cx("incrementButton"), e.incrementButtonClass]
        }, Ci(l.upButtonListeners, !0), {
          disabled: e.disabled,
          tabindex: -1,
          "aria-hidden": "true",
          type: "button"
        }, e.ptm("incrementButton")), [
          St(e.$slots, e.$slots.incrementicon ? "incrementicon" : "incrementbuttonicon", {}, () => [
            (O(), he(Ea(e.incrementIcon || e.incrementButtonIcon ? "span" : "AngleUpIcon"), Pe({
              class: [e.incrementIcon, e.incrementButtonIcon]
            }, e.ptm("incrementIcon"), { "data-pc-section": "incrementicon" }), null, 16, ["class"]))
          ])
        ], 16, t_)
      ]),
      St(e.$slots, "decrementbutton", { listeners: l.downButtonListeners }, () => [
        y("button", Pe({
          class: [e.cx("decrementButton"), e.decrementButtonClass]
        }, Ci(l.downButtonListeners, !0), {
          disabled: e.disabled,
          tabindex: -1,
          "aria-hidden": "true",
          type: "button"
        }, e.ptm("decrementButton")), [
          St(e.$slots, e.$slots.decrementicon ? "decrementicon" : "decrementbuttonicon", {}, () => [
            (O(), he(Ea(e.decrementIcon || e.decrementButtonIcon ? "span" : "AngleDownIcon"), Pe({
              class: [e.decrementIcon, e.decrementButtonIcon]
            }, e.ptm("decrementIcon"), { "data-pc-section": "decrementicon" }), null, 16, ["class"]))
          ])
        ], 16, n_)
      ])
    ], 16)) : ue("", !0),
    St(e.$slots, "incrementbutton", { listeners: l.upButtonListeners }, () => [
      e.showButtons && e.buttonLayout !== "stacked" ? (O(), J("button", Pe({
        key: 0,
        class: [e.cx("incrementButton"), e.incrementButtonClass]
      }, Ci(l.upButtonListeners, !0), {
        disabled: e.disabled,
        tabindex: -1,
        "aria-hidden": "true",
        type: "button"
      }, e.ptm("incrementButton")), [
        St(e.$slots, e.$slots.incrementicon ? "incrementicon" : "incrementbuttonicon", {}, () => [
          (O(), he(Ea(e.incrementIcon || e.incrementButtonIcon ? "span" : "AngleUpIcon"), Pe({
            class: [e.incrementIcon, e.incrementButtonIcon]
          }, e.ptm("incrementIcon"), { "data-pc-section": "incrementicon" }), null, 16, ["class"]))
        ])
      ], 16, a_)) : ue("", !0)
    ]),
    St(e.$slots, "decrementbutton", { listeners: l.downButtonListeners }, () => [
      e.showButtons && e.buttonLayout !== "stacked" ? (O(), J("button", Pe({
        key: 0,
        class: [e.cx("decrementButton"), e.decrementButtonClass]
      }, Ci(l.downButtonListeners, !0), {
        disabled: e.disabled,
        tabindex: -1,
        "aria-hidden": "true",
        type: "button"
      }, e.ptm("decrementButton")), [
        St(e.$slots, e.$slots.decrementicon ? "decrementicon" : "decrementbuttonicon", {}, () => [
          (O(), he(Ea(e.decrementIcon || e.decrementButtonIcon ? "span" : "AngleDownIcon"), Pe({
            class: [e.decrementIcon, e.decrementButtonIcon]
          }, e.ptm("decrementIcon"), { "data-pc-section": "decrementicon" }), null, 16, ["class"]))
        ])
      ], 16, o_)) : ue("", !0)
    ])
  ], 16);
}
const i_ = /* @__PURE__ */ $t(e_, [["render", l_]]), s_ = { class: "number-input-container" }, r_ = { style: { "white-space": "nowrap" } }, u_ = /* @__PURE__ */ qe({
  __name: "ViewerSettingsNumberInput",
  props: {
    label: {},
    modelValue: {},
    min: {},
    max: {},
    step: {},
    showButtons: { type: Boolean },
    suffix: {},
    minFractionDigits: {},
    maxFractionDigits: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, a = (o) => {
      n("update:modelValue", o);
    };
    return (o, l) => {
      const s = i_;
      return O(), J("div", s_, [
        y("div", r_, V(e.label), 1),
        d(s, {
          max: e.max,
          min: e.min,
          modelValue: e.modelValue,
          showButtons: e.showButtons,
          step: e.step,
          suffix: e.suffix,
          minFractionDigits: e.minFractionDigits,
          maxFractionDigits: e.maxFractionDigits,
          "onUpdate:modelValue": a
        }, null, 8, ["max", "min", "modelValue", "showButtons", "step", "suffix", "minFractionDigits", "maxFractionDigits"])
      ]);
    };
  }
}), c_ = {
  name: "BaseDivider",
  extends: Ja,
  props: {
    align: {
      type: String,
      default: null
    },
    layout: {
      type: String,
      default: "horizontal"
    },
    type: {
      type: String,
      default: "solid"
    }
  },
  style: wh,
  provide() {
    return {
      $pcDivider: this,
      $parentInstance: this
    };
  }
}, d_ = {
  name: "Divider",
  extends: c_,
  inheritAttrs: !1
}, p_ = ["aria-orientation"];
function m_(e, t, n, a, o, l) {
  return O(), J("div", Pe({
    class: e.cx("root"),
    style: e.sx("root"),
    role: "separator",
    "aria-orientation": e.layout
  }, e.ptmi("root")), [
    e.$slots.default ? (O(), J("div", Pe({
      key: 0,
      class: e.cx("content")
    }, e.ptm("content")), [
      St(e.$slots, "default")
    ], 16)) : ue("", !0)
  ], 16, p_);
}
const Lm = /* @__PURE__ */ $t(d_, [["render", m_]]), f_ = ["src", "alt"], g_ = {
  class: "pointer-events-none flex grow",
  style: { "font-weight": "600", color: "black" }
}, mn = /* @__PURE__ */ qe({
  __name: "IPAboutInfoInput",
  props: {
    label: String,
    value: String,
    logo: String,
    center: Boolean
  },
  setup(e) {
    const t = ia(), n = e, a = F(n.value);
    return (o, l) => (O(), he(r(Be), {
      class: He(["items-center h-full", { "justify-center": e.center, "gap-1": !0 }])
    }, {
      default: w(() => [
        (n.label ?? "").length > 0 ? (O(), he(r(at), {
          key: 0,
          class: "grow"
        }, {
          default: w(() => [
            y("span", null, V(n.label), 1)
          ]),
          _: 1
        })) : ue("", !0),
        e.logo ? (O(), he(r(at), {
          key: 1,
          class: "items-center"
        }, {
          default: w(() => [
            y("img", {
              src: r(t).getAssetUrl(`/icons/info/${e.logo}.png`),
              width: "15",
              alt: e.logo
            }, null, 8, f_)
          ]),
          _: 1
        })) : ue("", !0),
        d(r(at), null, {
          default: w(() => [
            y("span", g_, V(a.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Rl = /* @__PURE__ */ qe({
  __name: "IPAboutInfoDivider",
  setup(e) {
    return (t, n) => (O(), he(r(Be), { class: "w-full" }, {
      default: w(() => [
        d(r(Lt), null, {
          default: w(() => [...n[0] || (n[0] = [
            y("hr", { style: { border: "none", "border-top": "1px solid lightgrey", width: "100%" } }, null, -1)
          ])]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), h_ = ["src"], b_ = ["src"], v_ = {
  class: "text-2xl",
  style: { color: "black", "font-weight": "600" }
}, y_ = ["src"], __ = ["src"], w_ = ["src"], S_ = ["src"], I_ = {
  class: "text-2xl",
  style: { color: "black", "font-weight": "600" }
}, E_ = ["src"], T_ = ["src"], Om = /* @__PURE__ */ qe({
  __name: "IPAboutInfoBody",
  props: {
    model: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:model"],
  setup(e) {
    const t = Ln(e, "model"), n = ia();
    function a() {
      return t.value.company.addressLines ?? [t.value.company.address];
    }
    function o() {
      return t.value.manufacturerCompany.addressLines ?? [t.value.manufacturerCompany.address];
    }
    return (l, s) => (O(), he(r(at), { class: "gap-2 bg-white all-radius-16 overflow-y-auto h-full" }, {
      default: w(() => [
        d(Rl),
        d(r(Be), null, {
          default: w(() => [
            d(r(Wo), { class: "justify-center" }, {
              default: w(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/factory.png"),
                  width: "100",
                  alt: "factory"
                }, null, 8, h_)
              ]),
              _: 1
            }),
            d(r(Wo), null, {
              default: w(() => [
                d(r(at), { class: "grow" }, {
                  default: w(() => [
                    d(mn, {
                      value: t.value.manufacturerCompany.name
                    }, null, 8, ["value"]),
                    (O(!0), J(ze, null, Rt(o(), (i) => (O(), he(mn, {
                      key: i,
                      value: i
                    }, null, 8, ["value"]))), 128)),
                    d(mn, {
                      value: t.value.manufacturerCompany.website
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.manufacturerCompany.email
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.manufacturerCompany.telephone
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Rl),
        d(r(Be), null, {
          default: w(() => [
            d(r(Wo), { class: "justify-center" }, {
              default: w(() => [
                d(r(at), { class: "items-center justify-center grow md:p-6 lg:p-20" }, {
                  default: w(() => [
                    d(r(Be), { class: "justify-start" }, {
                      default: w(() => [...s[0] || (s[0] = [
                        y("span", {
                          class: "ml-3",
                          style: { color: "black" }
                        }, "LBL 01 04 0 00 REV 10_05-2025", -1)
                      ])]),
                      _: 1
                    }),
                    y("img", {
                      src: r(n).getAssetUrl("/icons/info/infobook.png"),
                      width: "100",
                      alt: "infobook"
                    }, null, 8, b_),
                    d(r(Be), { class: "justify-center" }, {
                      default: w(() => [
                        y("span", v_, V(l.$t("medic-web-framework.eIFU")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Wo), null, {
              default: w(() => [
                d(r(at), { class: "grow" }, {
                  default: w(() => [
                    d(mn, {
                      value: t.value.model
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.version,
                      logo: "modelNumber"
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.license,
                      logo: "softwareLicence"
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.softwareVersion,
                      logo: "softwareVersions"
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.udi,
                      logo: "UDIsymbol"
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.build,
                      logo: "manufactureDate"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Rl),
        d(r(Be), null, {
          default: w(() => [
            d(r(at), { class: "items-center justify-center grow" }, {
              default: w(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/certificate.png"),
                  width: "75",
                  alt: "certificate"
                }, null, 8, y_)
              ]),
              _: 1
            }),
            d(r(at), { class: "items-center justify-center grow" }, {
              default: w(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/MD.png"),
                  width: "75",
                  alt: "MD"
                }, null, 8, __)
              ]),
              _: 1
            }),
            d(r(at), { class: "items-center justify-center grow" }, {
              default: w(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/RX.png"),
                  width: "75",
                  alt: "RX"
                }, null, 8, w_)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Rl),
        d(r(Be), null, {
          default: w(() => [
            d(r(at), { class: "items-center justify-center grow" }, {
              default: w(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/black_rg.png"),
                  width: "75",
                  alt: "RG"
                }, null, 8, S_),
                d(r(Be), { class: "justify-center" }, {
                  default: w(() => [
                    y("span", I_, V(t.value.realGuideLogoCaption), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(at), { class: "grow" }, {
              default: w(() => [
                d(mn, {
                  value: t.value.company.name,
                  center: !0
                }, null, 8, ["value"]),
                (O(!0), J(ze, null, Rt(a(), (i) => (O(), he(mn, {
                  key: i,
                  value: i,
                  center: !0
                }, null, 8, ["value"]))), 128)),
                d(mn, {
                  value: t.value.company.website,
                  center: !0
                }, null, 8, ["value"]),
                d(mn, {
                  value: t.value.company.email,
                  center: !0
                }, null, 8, ["value"]),
                d(mn, {
                  value: t.value.company.telephone,
                  center: !0
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            d(r(at), { class: "items-center justify-center grow" }, {
              default: w(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/distributor.png"),
                  width: "75",
                  alt: "distributor"
                }, null, 8, E_)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Rl),
        d(r(Be), null, {
          default: w(() => [
            d(r(Wo), null, {
              default: w(() => [
                d(r(at), { class: "items-center justify-center grow" }, {
                  default: w(() => [
                    y("img", {
                      src: r(n).getAssetUrl("/icons/info/CH-REP.png"),
                      width: "150",
                      alt: "CH-REP"
                    }, null, 8, T_)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Wo), null, {
              default: w(() => [
                d(r(at), { class: "grow" }, {
                  default: w(() => [
                    d(mn, {
                      value: t.value.headquarter.name
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.headquarter.address
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.headquarter.city
                    }, null, 8, ["value"]),
                    d(mn, {
                      value: t.value.headquarter.country
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), C_ = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
function Dm() {
  return C_;
}
let Fr, $r;
function Ex(e) {
  Fr = e;
}
function Tx(e) {
  $r = e;
}
function N_() {
  return Fr || Dm().VITE_APP_ENVIRONMENT;
}
function _d() {
  return $r !== void 0 ? $r : Dm().NODE_ENV === "development";
}
function Am() {
  const e = N_();
  return console.log("isDevelopmentModulesEnabled", e, _d()), _d() || ["sigma"].includes(e || "");
}
class L_ {
  constructor() {
    on(this, "SHOW_CAD_WIZARD", !1);
    on(this, "VENDOR_ID");
  }
}
const oo = new L_(), O_ = {
  style: { width: "860px" },
  class: "ip-viewer-settings -mt-2"
}, D_ = { class: "p-tabmenu p-component -mt-2" }, A_ = { key: 0 }, R_ = { class: "settings-rows" }, M_ = { style: { width: "100%", display: "grid", "grid-template-columns": "1fr 1fr", "grid-template-rows": "auto auto auto", "grid-gap": "16px" } }, P_ = { class: "grid-auto-equal-columns" }, x_ = { class: "settings-rows" }, j_ = { class: "settings-rows" }, F_ = { class: "grid-auto-equal-columns" }, $_ = ["for"], k_ = { class: "settings-rows" }, V_ = { style: { width: "100%", display: "grid", "grid-template-columns": "1fr 1fr", "grid-template-rows": "auto auto auto", "grid-gap": "16px" } }, B_ = { key: 1 }, U_ = { class: "settings-rows" }, G_ = { style: { width: "100%", display: "grid", "grid-auto-rows": "1fr", "grid-auto-columns": "1fr", gap: "16px" } }, W_ = { class: "settings-rows" }, z_ = { class: "grid-auto-equal-columns" }, H_ = { style: { display: "flex", width: "100%", "justify-content": "center", gap: "16px" } }, Y_ = { class: "grid-auto-equal-columns" }, K_ = { class: "settings-rows" }, Z_ = { class: "settings-rows" }, J_ = { class: "settings-rows" }, X_ = {
  key: 2,
  class: "pt-4"
}, q_ = {
  key: 0,
  style: { display: "flex", "justify-content": "center" }
}, Cu = /* @__PURE__ */ qe({
  __name: "IPViewerSettings",
  props: {
    visible: { type: Boolean, default: !1 },
    settings: {},
    license: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: o } = ln(n), l = (m) => {
      s.value = Sc(m, oo.VENDOR_ID);
    }, s = F(Sc(n.license, oo.VENDOR_ID)), i = () => ({
      general: zn(b),
      implants: zn(f),
      defaultColors: zn(h)
    }), c = () => {
      n.settings.update(structuredClone(i())), a("confirm");
    }, u = () => {
      a("cancel");
    }, p = F(null);
    ot(o, async () => {
      var m;
      o.value && (await fn(), (m = p.value) == null || m.$el.focus());
    }), Mt(() => {
      var m;
      o.value && ((m = p.value) == null || m.$el.focus());
    }), ot(
      () => n.license,
      (m) => {
        l(m);
      }
    ), ot(
      () => o.value,
      (m) => {
        m && l(n.license);
      },
      { immediate: !0 }
    );
    const b = et(structuredClone(n.settings.general)), f = et(structuredClone(n.settings.implants)), h = et(structuredClone(n.settings.defaultColors)), I = F(
      0
      /* General */
    );
    return (m, S) => {
      const E = Lm, g = u_, v = z1, T = U1, R = F1, L = A1, C = Ty;
      return O(), he(r(Xg), {
        onClose: u,
        visible: r(o),
        style: { width: "1200px !important" }
      }, {
        header: w(() => [
          St(m.$slots, "header", {}, () => [
            yt(V(m.$t("shared.settings")), 1)
          ])
        ]),
        default: w(() => [
          y("div", O_, [
            y("div", D_, [
              d(r(Be), {
                class: "gap-2 -mt-1",
                role: "tablist"
              }, {
                default: w(() => [
                  d(r(Ul), {
                    state: I.value,
                    "onUpdate:state": S[0] || (S[0] = (A) => I.value = A),
                    index: 0,
                    class: "mt-1"
                  }, {
                    default: w(() => [
                      yt(V(m.$t("implant-planner.general")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "index"]),
                  d(r(Ul), {
                    state: I.value,
                    "onUpdate:state": S[1] || (S[1] = (A) => I.value = A),
                    index: 1,
                    class: "mt-1"
                  }, {
                    default: w(() => [
                      yt(V(m.$t("implant-planner.implants")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "index"]),
                  d(r(Ul), {
                    state: I.value,
                    "onUpdate:state": S[2] || (S[2] = (A) => I.value = A),
                    index: 2,
                    class: "mt-1",
                    style: { width: "75px !important" }
                  }, {
                    default: w(() => [
                      yt(V(m.$t("shared.info")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "index"])
                ]),
                _: 1
              })
            ]),
            d(E),
            I.value === 0 ? (O(), J("div", A_, [
              d(T, {
                title: m.$t("implant-planner.general")
              }, {
                default: w(() => [
                  y("div", R_, [
                    y("div", M_, [
                      d(g, {
                        modelValue: b.autosaveIntervalMinutes,
                        "onUpdate:modelValue": S[3] || (S[3] = (A) => b.autosaveIntervalMinutes = A),
                        max: 240,
                        min: 0,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.autosaveInterval"),
                        style: { "grid-column": "1", "grid-row": "1" },
                        suffix: " min"
                      }, null, 8, ["modelValue", "label"]),
                      d(g, {
                        modelValue: b.measurementFont,
                        "onUpdate:modelValue": S[4] || (S[4] = (A) => b.measurementFont = A),
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.measurementFont"),
                        style: { "grid-column": "1", "grid-row": "2" }
                      }, null, 8, ["modelValue", "label"]),
                      d(g, {
                        modelValue: b.topCenterlineSizeOn3dMm,
                        "onUpdate:modelValue": S[5] || (S[5] = (A) => b.topCenterlineSizeOn3dMm = A),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.topCenterlineSizeOnD"),
                        style: { "grid-column": "1", "grid-row": "3" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(g, {
                        modelValue: b.crossSectionSizeMm,
                        "onUpdate:modelValue": S[6] || (S[6] = (A) => b.crossSectionSizeMm = A),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.crossSectionSize"),
                        style: { "grid-column": "2", "grid-row": "2" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(g, {
                        modelValue: b.bottomCenterlineSizeOn3dMm,
                        "onUpdate:modelValue": S[7] || (S[7] = (A) => b.bottomCenterlineSizeOn3dMm = A),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.bottomCenterlineSizeOnD"),
                        style: { "grid-column": "2", "grid-row": "3" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    y("div", P_, [
                      y("div", x_, [
                        d(v, {
                          state: b.useUSStyleToothChart,
                          "onUpdate:state": S[8] || (S[8] = (A) => b.useUSStyleToothChart = A),
                          label: m.$t("implant-planner.useUsStyleToothChart")
                        }, null, 8, ["state", "label"]),
                        d(v, {
                          state: b.refreshAll2dWhileMovingObjects,
                          "onUpdate:state": S[9] || (S[9] = (A) => b.refreshAll2dWhileMovingObjects = A),
                          label: m.$t("implant-planner.refreshAllDImagesWhileMovingImplantsAndObjects")
                        }, null, 8, ["state", "label"]),
                        d(v, {
                          state: b.useLeftButtonForRotationOn3d,
                          "onUpdate:state": S[10] || (S[10] = (A) => b.useLeftButtonForRotationOn3d = A),
                          label: m.$t("implant-planner.useLeftMouseButtonInsteadOfRightForRotationInD")
                        }, null, 8, ["state", "label"])
                      ]),
                      y("div", j_, [
                        d(v, {
                          state: b.snapToImplant,
                          "onUpdate:state": S[11] || (S[11] = (A) => b.snapToImplant = A),
                          label: m.$t("implant-planner.snapToImplant")
                        }, null, 8, ["state", "label"]),
                        d(v, {
                          state: b.showCPRScoutPlane,
                          "onUpdate:state": S[12] || (S[12] = (A) => b.showCPRScoutPlane = A),
                          label: m.$t("implant-planner.showCprScoutPlane")
                        }, null, 8, ["state", "label"]),
                        ue("", !0),
                        d(v, {
                          state: b.allowTelemetry,
                          "onUpdate:state": S[14] || (S[14] = (A) => b.allowTelemetry = A),
                          label: m.$t("implant-planner.allowTelemetry")
                        }, null, 8, ["state", "label"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              d(T, {
                title: m.$t("implant-planner.crosshairType")
              }, {
                default: w(() => [
                  y("div", F_, [
                    (O(!0), J(ze, null, Rt(r(Sh), (A) => (O(), J("div", {
                      key: A,
                      style: { display: "flex", gap: "8px" }
                    }, [
                      d(R, {
                        modelValue: b.crosshairType,
                        "onUpdate:modelValue": (j) => b.crosshairType = j,
                        inputId: A,
                        value: A
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "value"]),
                      y("label", { for: A }, V(m.$t("implant-planner.crosshairType" + A)), 9, $_)
                    ]))), 128))
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              d(T, {
                title: m.$t("implant-planner.defaultBrightnesscontrast")
              }, {
                default: w(() => [
                  y("div", k_, [
                    y("div", V_, [
                      d(g, {
                        modelValue: b.defaultWindowWidth,
                        "onUpdate:modelValue": S[15] || (S[15] = (A) => b.defaultWindowWidth = A),
                        max: 1e4,
                        maxFractionDigits: 0,
                        min: -1e4,
                        minFractionDigits: 0,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.ww"),
                        style: { "grid-column": "1", "grid-row": "1" },
                        suffix: ""
                      }, null, 8, ["modelValue", "label"]),
                      d(g, {
                        modelValue: b.defaultWindowLevel,
                        "onUpdate:modelValue": S[16] || (S[16] = (A) => b.defaultWindowLevel = A),
                        max: 1e4,
                        maxFractionDigits: 0,
                        min: -1e4,
                        minFractionDigits: 0,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.wl"),
                        style: { "grid-column": "2", "grid-row": "1" },
                        suffix: ""
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ])) : ue("", !0),
            I.value === 1 ? (O(), J("div", B_, [
              d(T, {
                title: m.$t("implant-planner.warnings")
              }, {
                default: w(() => [
                  y("div", U_, [
                    y("div", G_, [
                      d(v, {
                        state: f.showWarningsPopup,
                        "onUpdate:state": S[17] || (S[17] = (A) => f.showWarningsPopup = A),
                        label: m.$t("implant-planner.showWarningsPopup"),
                        style: { "grid-column": "1", "grid-row": "1" }
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: f.nerveWarning,
                        "onUpdate:state": S[18] || (S[18] = (A) => f.nerveWarning = A),
                        label: m.$t("implant-planner.nerveWarning"),
                        style: { "grid-column": "1", "grid-row": "2" }
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: f.securityZone,
                        "onUpdate:state": S[19] || (S[19] = (A) => f.securityZone = A),
                        label: m.$t("implant-planner.securityZone"),
                        style: { "grid-column": "1", "grid-row": "3" }
                      }, null, 8, ["state", "label"]),
                      d(g, {
                        modelValue: f.minimumDistanceFromNerveMm,
                        "onUpdate:modelValue": S[20] || (S[20] = (A) => f.minimumDistanceFromNerveMm = A),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.minimumDistanceFromNerve"),
                        style: { "grid-column": "2", "grid-row": "2" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(g, {
                        modelValue: f.securityZoneSizeMm,
                        "onUpdate:modelValue": S[21] || (S[21] = (A) => f.securityZoneSizeMm = A),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.5,
                        label: m.$t("implant-planner.securityZoneSize"),
                        style: { "grid-column": "2", "grid-row": "3" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    d(L, {
                      modelValue: f.securityZoneTransparencyPercent,
                      "onUpdate:modelValue": S[22] || (S[22] = (A) => f.securityZoneTransparencyPercent = A),
                      max: 100,
                      min: 0,
                      step: 1,
                      label: m.$t("implant-planner.securityZoneTransparency")
                    }, null, 8, ["modelValue", "label"])
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              d(T, { title: "" }, {
                default: w(() => [
                  y("div", W_, [
                    y("div", z_, [
                      d(v, {
                        state: f.showImplantStepButtons,
                        "onUpdate:state": S[23] || (S[23] = (A) => f.showImplantStepButtons = A),
                        label: m.$t("implant-planner.showImplantStepButtons")
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: f.showBLAngle,
                        "onUpdate:state": S[24] || (S[24] = (A) => f.showBLAngle = A),
                        label: m.$t("implant-planner.showBlAngle")
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: f.showAllAbutmentManufacturers,
                        "onUpdate:state": S[25] || (S[25] = (A) => f.showAllAbutmentManufacturers = A),
                        label: m.$t("implant-planner.showAllTheAbutmentManufacturers")
                      }, null, 8, ["state", "label"])
                    ]),
                    y("div", H_, [
                      d(g, {
                        modelValue: f.preciseMovementStepMm,
                        "onUpdate:modelValue": S[26] || (S[26] = (A) => f.preciseMovementStepMm = A),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.5,
                        label: m.$t("implant-planner.preciseMovementStep"),
                        style: { "flex-grow": "1" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(g, {
                        modelValue: f.preciseRotationStepDeg,
                        "onUpdate:modelValue": S[27] || (S[27] = (A) => f.preciseRotationStepDeg = A),
                        max: 9.99,
                        maxFractionDigits: 2,
                        min: 0.1,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.2,
                        label: m.$t("implant-planner.preciseRotationStep"),
                        style: { "flex-grow": "1" },
                        suffix: "°"
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ])
                ]),
                _: 1
              }),
              d(T, {
                title: m.$t("implant-planner.defaultColors")
              }, {
                default: w(() => [
                  y("div", Y_, [
                    y("div", K_, [
                      d(C, {
                        modelValue: h.implant,
                        "onUpdate:modelValue": S[28] || (S[28] = (A) => h.implant = A),
                        label: m.$t("implant-planner.implant color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.abutment,
                        "onUpdate:modelValue": S[29] || (S[29] = (A) => h.abutment = A),
                        label: m.$t("implant-planner.abutment color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.securityZone,
                        "onUpdate:modelValue": S[30] || (S[30] = (A) => h.securityZone = A),
                        label: m.$t("implant-planner.security zone color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.sleeves,
                        "onUpdate:modelValue": S[31] || (S[31] = (A) => h.sleeves = A),
                        label: m.$t("implant-planner.sleeves color")
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    y("div", Z_, [
                      d(C, {
                        modelValue: h.nerves,
                        "onUpdate:modelValue": S[32] || (S[32] = (A) => h.nerves = A),
                        label: m.$t("implant-planner.nerves color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.collision,
                        "onUpdate:modelValue": S[33] || (S[33] = (A) => h.collision = A),
                        label: m.$t("implant-planner.collision color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.modelTools,
                        "onUpdate:modelValue": S[34] || (S[34] = (A) => h.modelTools = A),
                        label: m.$t("implant-planner.model tools color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.teeth,
                        "onUpdate:modelValue": S[35] || (S[35] = (A) => h.teeth = A),
                        label: m.$t("implant-planner.teeth color")
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    y("div", J_, [
                      d(C, {
                        modelValue: h.prosthesisScanStl,
                        "onUpdate:modelValue": S[36] || (S[36] = (A) => h.prosthesisScanStl = A),
                        label: m.$t("implant-planner.prosthesis scan STL color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.teethScanStl,
                        "onUpdate:modelValue": S[37] || (S[37] = (A) => h.teethScanStl = A),
                        label: m.$t("implant-planner.teeth scan STL color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.guides,
                        "onUpdate:modelValue": S[38] || (S[38] = (A) => h.guides = A),
                        label: m.$t("implant-planner.guides color")
                      }, null, 8, ["modelValue", "label"]),
                      d(C, {
                        modelValue: h.cprColor,
                        "onUpdate:modelValue": S[39] || (S[39] = (A) => h.cprColor = A),
                        label: m.$t("implant-planner.cprColor")
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ])) : ue("", !0),
            I.value === 2 ? (O(), J("div", X_, [
              d(Om, {
                model: s.value,
                "onUpdate:model": S[40] || (S[40] = (A) => s.value = A)
              }, null, 8, ["model"])
            ])) : ue("", !0)
          ])
        ]),
        actions: w(() => [
          I.value === 2 ? (O(), J("div", q_, [
            d(r(qg), {
              label: m.$t("shared.close"),
              icon: "pi pi-times",
              onClick: u
            }, null, 8, ["label"])
          ])) : (O(), he(r(Qg), {
            key: 1,
            acceptLabel: m.$t("shared.ok"),
            rejectLabel: m.$t("shared.cancel"),
            onAccept: c,
            onReject: u
          }, null, 8, ["acceptLabel", "rejectLabel"]))
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), Q_ = { class: "h-full" }, Nu = /* @__PURE__ */ qe({
  __name: "IPWizardCardContainer",
  props: {
    isFirstItem: { type: Boolean },
    isLastItem: { type: Boolean },
    isVisible: { type: Boolean }
  },
  emits: ["hideWizard", "previousStep", "nextStep"],
  setup(e, { emit: t }) {
    const n = e, a = t;
    return (o, l) => (O(), J("div", Q_, [
      d(r(at), {
        class: "h-full",
        style: { width: "309px", position: "relative" }
      }, {
        default: w(() => [
          d(r(at), {
            class: "overflow-x-hidden overflow-y-auto h-full grow",
            id: "wizardBody"
          }, {
            default: w(() => [
              St(o.$slots, "default", {
                onHideWizard: l[0] || (l[0] = (s) => a("hideWizard"))
              })
            ]),
            _: 3
          }),
          e.isVisible ? (O(), he(r(Be), {
            key: 0,
            class: "horizontal-padding gap-2 pt-16px pb-16px"
          }, {
            default: w(() => [
              d(r(Ce), {
                id: "btnPreviousStep",
                disabled: n.isFirstItem,
                iconSrc: "/icons/rg_chevron_left.svg",
                "icon-src-height": "21px",
                "icon-src-width": "21px",
                class: He(["web-rg-icon-btn"]),
                label: o.$t("implant-planner.previousStep"),
                style: { flex: "1 1 0" },
                onClick: l[1] || (l[1] = (s) => o.$emit("previousStep"))
              }, null, 8, ["disabled", "label"]),
              d(r(Ce), {
                id: "btnNextStep",
                disabled: n.isLastItem,
                iconRight: !0,
                iconSrc: "/icons/rg_chevron_right.svg",
                "icon-src-height": "21px",
                "icon-src-width": "21px",
                class: He(["h-56px grow"]),
                label: o.$t("implant-planner.nextStep"),
                style: { "border-radius": "16px", flex: "1 1 0" },
                onClick: l[2] || (l[2] = (s) => o.$emit("nextStep"))
              }, null, 8, ["disabled", "label"])
            ]),
            _: 1
          })) : ue("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
function rl(e) {
  return {
    wizardIndex: 0,
    oldLayout: e || Ve._FULLSCREEN_3D,
    newLayout: e || Ve._FULLSCREEN_3D,
    fullscreen: void 0,
    wizardPanelVisible: !0
  };
}
function e0(e, t, n) {
  return {
    wizardIndex: e,
    oldLayout: Ve._FULLSCREEN_3D,
    newLayout: void 0,
    availableLayouts: t || (n ? n0() : t0()),
    wizardPanelVisible: !1
  };
}
function t0() {
  return [
    { name: "MPR", code: Ve._MPR },
    { name: "3D + MPR", code: Ve._3D_MPR },
    { name: "LARGE 3D + MPR", code: Ve._LARGE_3D_MPR },
    { name: "FULLSCREEN", code: Ve._FULLSCREEN_3D },
    { name: "3D + 3x1 + CPR XRay", code: Ve._3D_3X1_CPR_XRAY },
    { name: "3D + Cross + Axial", code: Ve._3D_CROSS_AXIAL },
    { name: "3D + Cross + CPR", code: Ve._3D_CROSS_CPR },
    { name: "3D + Cross + Tangent + Axial", code: Ve._3D_CROSS_TANGENT_AXIAL },
    { name: "3D + CPR + Cross + Tangent + Axial", code: Ve._3D_CPR_CROSS_TANGENT_AXIAL },
    { name: "3D + Axial + 5x1", code: Ve._3D_AXIAL_5X1 }
  ];
}
function n0() {
  return [
    { name: "MPR", code: Ve._MPR },
    { name: "3D + MPR", code: Ve._3D_MPR },
    { name: "LARGE 3D + MPR", code: Ve._LARGE_3D_MPR },
    { name: "FULLSCREEN", code: Ve._FULLSCREEN_3D },
    { name: "3D + Cross + Axial", code: Ve._3D_CROSS_AXIAL },
    // { name: "3D + Cross + CPR", code: LayoutTemplate._3D_CROSS_CPR },
    { name: "3D + Cross + Tangent + Axial", code: Ve._3D_CROSS_TANGENT_AXIAL }
    // { name: "3D + CPR + Cross + Tangent + Axial", code: LayoutTemplate._3D_CPR_CROSS_TANGENT_AXIAL },
  ];
}
function a0() {
  return [
    { name: "Preview + Cross + Tangent", code: Ve._STL_PICKER_PREVIEW },
    { name: "Preview + Cross + 3D", code: Ve._STL_PICKER_PREVIEW_2 }
  ];
}
function o0() {
  return [
    { name: "3D", code: Ve._FULLSCREEN_3D },
    { name: "AXIAL", code: Ve._FULLSCREEN_AXIAL },
    { name: "CORONAL", code: Ve._FULLSCREEN_CORONAL },
    { name: "SAGITTAL", code: Ve._FULLSCREEN_SAGITTAL },
    { name: "CPR", code: Ve._FULLSCREEN_CPR },
    { name: "CROSS", code: Ve._FULLSCREEN_CROSS }
  ];
}
const l0 = { class: "layout-dialog-grid mt-6" }, i0 = ["data-cy", "onClick"], s0 = ["src"], r0 = {
  key: 0,
  class: "flex items-center justify-center layout-dialog-grid-item-label"
}, u0 = {
  key: 0,
  class: "mt-1"
}, c0 = /* @__PURE__ */ qe({
  __name: "IPLayoutDialog",
  props: /* @__PURE__ */ xn({
    modelValue: {}
  }, {
    cadMode: { type: Boolean, default: !1 },
    cadModeModifiers: {}
  }),
  emits: /* @__PURE__ */ xn(["updateLayout"], ["update:cadMode"]),
  setup(e, { emit: t }) {
    const n = e, a = Ln(e, "cadMode"), o = et(e0(n.modelValue.wizardIndex, void 0, a.value)), l = pn(), s = l.objects.hasCPR(), i = t, c = F(Number(n.modelValue.oldLayout)), u = ia(), p = (g) => {
      const v = Object.keys(Ve).indexOf(g.toString());
      return l.layoutManager.layoutTemplateContainsCpr(v);
    }, b = (g) => !s && p(g), f = o0().filter((g) => !b(g.code)), h = F(f.find((g) => g.code === n.modelValue.newLayout));
    Wa(() => {
      n.modelValue && Object.assign(o, n.modelValue);
    }), Mt(() => {
      n.modelValue && Object.assign(o, n.modelValue);
    });
    const I = (g) => {
      c.value = g, i("updateLayout", Object.keys(Ve).indexOf(g.toString()));
    }, m = () => {
      h.value && i("updateLayout", Object.keys(Ve).indexOf(h.value.code.toString()));
    }, S = (g, v) => {
      const T = "/img/" + g + ".svg";
      return u.getAssetUrl(T);
    }, E = (g) => g === 3;
    return (g, v) => (O(), J("div", l0, [
      (O(!0), J(ze, null, Rt(o.availableLayouts, (T) => (O(), J("div", {
        key: T.name,
        class: "cursor-pointer flex flex-col items-center",
        style: Tt({
          opacity: b(T.code) ? "0.5" : "1",
          pointerEvents: b(T.code) ? "none" : "auto"
        }),
        "data-cy": `layout-${T.name}`,
        onClick: (R) => I(T.code)
      }, [
        y("div", null, [
          y("div", {
            class: He(["flex colored-background", { "colored-background-selected": T.code == c.value }])
          }, [
            y("img", {
              src: S(T.code, c.value),
              alt: "",
              class: He(["filter-class", { "filter-class-selected": T.code == c.value }]),
              draggable: "false"
            }, null, 10, s0)
          ], 2),
          E(T.code) ? ue("", !0) : (O(), J("span", r0, V(T.name), 1))
        ]),
        E(T.code) ? (O(), J("div", u0, [
          d(r(Pn), {
            modelValue: h.value,
            "onUpdate:modelValue": v[0] || (v[0] = (R) => h.value = R),
            options: r(f),
            optionLabel: "name",
            placeholder: g.$t("implant-planner.fullscreen"),
            style: { width: "192px" },
            onChange: m
          }, null, 8, ["modelValue", "options", "placeholder"])
        ])) : ue("", !0)
      ], 12, i0))), 128))
    ]));
  }
}), Lu = /* @__PURE__ */ $t(c0, [["__scopeId", "data-v-564ee045"]]), d0 = {}, p0 = { class: "text-2xl" };
function m0(e, t) {
  return O(), J("div", p0, [
    St(e.$slots, "default")
  ]);
}
const co = /* @__PURE__ */ $t(d0, [["render", m0]]), jo = /* @__PURE__ */ qe({
  __name: "IPWizardTitle",
  props: {
    hideWizardBtn: { type: Boolean, default: !1 },
    hideWizardBtnModifiers: {},
    ignoreHorizontalPadding: { type: Boolean, default: !1 },
    ignoreHorizontalPaddingModifiers: {}
  },
  emits: /* @__PURE__ */ xn(["hideWizard", "showWizard"], ["update:hideWizardBtn", "update:ignoreHorizontalPadding"]),
  setup(e, { emit: t }) {
    const n = Ln(e, "hideWizardBtn"), a = Ln(e, "ignoreHorizontalPadding"), o = t, l = Te(() => a.value ? "" : "padding-left: 16px"), s = Te(() => a.value ? "" : "padding-right: 16px");
    return (i, c) => (O(), he(r(Be), {
      class: "vertical-padding",
      style: { "border-bottom": "1px var(--p-rg-border-color) solid" }
    }, {
      default: w(() => [
        d(r(Lt), {
          class: "text-2xl items-center",
          style: Tt(r(l))
        }, {
          default: w(() => [
            St(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["style"]),
        n.value ? ue("", !0) : (O(), he(r(Ee), {
          key: 0,
          class: "items-center",
          style: Tt(r(s))
        }, {
          default: w(() => [
            d(r(Ce), {
              class: "web-rg-toggle-wiz-btn",
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_left_panel_close.svg",
              onClick: c[0] || (c[0] = (u) => o("hideWizard"))
            })
          ]),
          _: 1
        }, 8, ["style"]))
      ]),
      _: 3
    }));
  }
}), bl = /* @__PURE__ */ qe({
  __name: "IPWizardBody",
  setup(e) {
    return (t, n) => (O(), he(r(at), {
      class: "mt-2 gap-2 horizontal-padding",
      style: { height: "100% !important", "overflow-y": "auto" }
    }, {
      default: w(() => [
        St(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), f0 = {
  key: 0,
  class: "mb-3 text-sm"
}, g0 = { class: "font-medium mr-2" }, h0 = { class: "font-medium ml-2" }, b0 = /* @__PURE__ */ qe({
  __name: "IPVoiSettingsWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const n = t;
    let a = et({
      disabled: !1,
      pressable: !0,
      pressed: !0
    });
    const o = F(!1), l = F(!1);
    let s = et({
      disabled: !0,
      pressable: !1,
      pressed: !1
    }), i = et({
      disabled: !0,
      pressable: !1,
      pressed: !1
    }), c = et({
      disabled: !0,
      pressable: !0,
      toggleable: !0
    });
    ot(a, () => {
      console.log("btnPermanentlyTrim", a);
    });
    const u = pn();
    let p = F(!1), b = null, f = null;
    function h() {
      o.value = !1, i.disabled = !0, l.value = !1, c.disabled = !0, s.disabled = !0;
    }
    function I() {
      o.value = !0, i.disabled = !1, l.value = !1, c.disabled = !1, s.disabled = !1;
    }
    function m() {
      const { volumeMapper: L } = u.getVolume();
      L && (L.removeAllClippingPlanes(), L.modified()), u.repaint();
    }
    ot(p, () => {
      if (u.volumeDecimated) {
        p.value = !1;
        return;
      }
      console.log("Switch changed"), p.value ? (console.log("crop on"), h(), a.pressed = !1, u.toolManager.setTool(un.CROPPING, Qt.PRIMARY), f = u.toolManager.getToolInstance(Qt.PRIMARY)) : (console.log("crop off"), u.toolManager.getTool(Qt.PRIMARY) === un.CROPPING && (u.toolManager.setTool(un.NONE, Qt.PRIMARY), m()), f = null, a.pressed = !0);
    });
    async function S() {
      u.volumeDecimated || p.value && (console.log("Permanently trim!"), await (f == null ? void 0 : f.permanentlyCrop()), p.value = !1);
    }
    const E = () => {
      console.log("Calling flipZ"), u.flipImage(!1, !1, !0);
    };
    function g(L, C, A) {
      console.log("Rotating image!"), u.rotateImage(L, C, A);
    }
    async function v(L) {
      u.volumeDecimated && L || (L ? (p.value && (p.value = !1), await u.toolManager.setTool(un.SCULPTING, Qt.PRIMARY), b = u.toolManager.getToolInstance(Qt.PRIMARY), I()) : (u.toolManager.getTool(Qt.PRIMARY) === un.SCULPTING && u.toolManager.setTool(un.NONE, Qt.PRIMARY), b = null, h()));
    }
    async function T() {
      u.volumeDecimated || (await (b == null ? void 0 : b.sculpt()), b = null, h());
    }
    function R() {
      console.log("Invert pressed", l.value), b == null || b.invert(l.value);
    }
    return (L, C) => {
      const A = jo, j = co;
      return O(), J(ze, null, [
        d(A, {
          onHideWizard: C[0] || (C[0] = (N) => n("hideWizard"))
        }, {
          default: w(() => [
            yt(V(L.$t("implant-planner.imageWizard")), 1)
          ]),
          _: 1
        }),
        d(bl, null, {
          default: w(() => [
            r(u).volumeDecimated ? (O(), J("p", f0, V(L.$t("implant-planner.reducedVolumeReadOnly")), 1)) : ue("", !0),
            d(r(Be), null, {
              default: w(() => [
                d(r(Lt), null, {
                  default: w(() => [
                    d(j, null, {
                      default: w(() => [
                        yt(V(L.$t("implant-planner.trimming")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Ee), null, {
                  default: w(() => [
                    d(r(io), {
                      id: "switchTrimming",
                      disabled: r(u).volumeDecimated,
                      state: r(p),
                      "onUpdate:state": C[1] || (C[1] = (N) => za(p) ? p.value = N : p = N)
                    }, {
                      falseLabel: w(() => [
                        y("span", g0, V(L.$t("implant-planner.off")), 1)
                      ]),
                      trueLabel: w(() => [
                        y("span", h0, V(L.$t("implant-planner.on")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "state"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Be), null, {
              default: w(() => [
                d(r(Lt), { class: "mt-2" }, {
                  default: w(() => [
                    d(r(Ce), {
                      id: "btnPermanentlyTrim",
                      class: "w-full web-rg-wiz-btn",
                      disabled: r(u).volumeDecimated || r(a).pressed,
                      label: L.$t("implant-planner.permanentlyTrim"),
                      onClick: S
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(at), null, {
              default: w(() => [
                d(r(Lt), null, {
                  default: w(() => [
                    d(j, null, {
                      default: w(() => [
                        yt(V(L.$t("implant-planner.sculpting")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(at), { class: "mt-2 gap-2" }, {
                  default: w(() => [
                    d(r(Ce), {
                      disabled: r(u).volumeDecimated,
                      toggled: o.value,
                      togglable: !0,
                      class: "w-full web-rg-wiz-btn",
                      label: L.$t("implant-planner.startSculpting"),
                      "data-cy": "startSculpting",
                      onToggledChange: C[2] || (C[2] = (N) => v(N))
                    }, null, 8, ["disabled", "toggled", "label"]),
                    d(r(Ce), {
                      disabled: r(u).volumeDecimated || r(c).disabled,
                      togglable: !0,
                      toggled: l.value,
                      "onUpdate:toggled": C[3] || (C[3] = (N) => l.value = N),
                      class: "w-full web-rg-wiz-btn",
                      label: L.$t("implant-planner.invert"),
                      "data-cy": "invertSculpting",
                      onToggledChange: C[4] || (C[4] = (N) => R())
                    }, null, 8, ["disabled", "toggled", "label"]),
                    d(r(Ce), {
                      disabled: r(u).volumeDecimated || r(i).disabled,
                      class: "w-full web-rg-wiz-btn",
                      label: L.$t("implant-planner.sculpt"),
                      "data-cy": "sculpt",
                      onClick: T
                    }, null, 8, ["disabled", "label"]),
                    d(r(Ce), {
                      disabled: r(u).volumeDecimated || r(s).disabled,
                      class: "w-full web-rg-wiz-btn",
                      label: L.$t("shared.cancel"),
                      "data-cy": "cancelSculpting",
                      onClick: C[5] || (C[5] = (N) => v(!1))
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(at), { class: "gap-2" }, {
              default: w(() => [
                d(r(Lt), null, {
                  default: w(() => [
                    d(j, null, {
                      default: w(() => [
                        yt(V(L.$t("implant-planner.changeOrientation")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Lt), null, {
                  default: w(() => [
                    d(r(Ce), {
                      id: "btnFlipZ",
                      disabled: r(u).volumeDecimated,
                      class: "w-full web-rg-wiz-btn",
                      label: L.$t("implant-planner.flipZ"),
                      onClick: E
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Lt), { class: "items-center" }, {
                      default: w(() => [
                        y("span", null, V(L.$t("implant-planner.rotateAxial")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Ee), { class: "gap-2" }, {
                      default: w(() => [
                        d(r(Ce), {
                          id: "btnRotateAxialMinus",
                          disabled: r(u).volumeDecimated,
                          class: "w-full web-rg-wiz-btn",
                          label: "90 -",
                          onClick: C[6] || (C[6] = (N) => g(0, 0, -90))
                        }, null, 8, ["disabled"]),
                        d(r(Ce), {
                          id: "btnRotateAxialPlus",
                          disabled: r(u).volumeDecimated,
                          class: "w-full web-rg-wiz-btn",
                          label: "90 +",
                          onClick: C[7] || (C[7] = (N) => g(0, 0, 90))
                        }, null, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Lt), { class: "items-center" }, {
                      default: w(() => [
                        y("span", null, V(L.$t("implant-planner.rotateCoronal")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Ee), { class: "gap-2" }, {
                      default: w(() => [
                        d(r(Ce), {
                          id: "btnRotateCoronalMinus",
                          disabled: r(u).volumeDecimated,
                          class: "w-full web-rg-wiz-btn",
                          label: "90 -",
                          onClick: C[8] || (C[8] = (N) => g(0, 90, 0))
                        }, null, 8, ["disabled"]),
                        d(r(Ce), {
                          id: "btnRotateCoronalPlus",
                          disabled: r(u).volumeDecimated,
                          class: "w-full web-rg-wiz-btn",
                          label: "90 +",
                          onClick: C[9] || (C[9] = (N) => g(0, -90, 0))
                        }, null, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), { class: "mt-2" }, {
                  default: w(() => [
                    d(r(Lt), { class: "items-center" }, {
                      default: w(() => [
                        y("span", null, V(L.$t("implant-planner.rotateSaggital")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Ee), { class: "gap-2" }, {
                      default: w(() => [
                        d(r(Ce), {
                          id: "btnRotateSaggitalMinus",
                          disabled: r(u).volumeDecimated,
                          class: "w-full web-rg-wiz-btn",
                          label: "90 -",
                          onClick: C[10] || (C[10] = (N) => g(-90, 0, 0))
                        }, null, 8, ["disabled"]),
                        d(r(Ce), {
                          id: "btnRotateSaggitalPlus",
                          disabled: r(u).volumeDecimated,
                          class: "w-full web-rg-wiz-btn",
                          label: "90 +",
                          onClick: C[11] || (C[11] = (N) => g(90, 0, 0))
                        }, null, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), Ou = /* @__PURE__ */ $t(b0, [["__scopeId", "data-v-8bd36ca3"]]), Xo = 1e-6;
function Na(e, t, n) {
  return Number.isFinite(e) ? Math.max(t, Math.min(n, e)) : t;
}
function yn(e) {
  return Na(e, 0, 1);
}
function Rm(e) {
  return Math.sqrt(Math.sqrt(yn(e)));
}
function v0(e) {
  const t = yn(e);
  return t * t * t * t;
}
function Kl(e) {
  return e.map((t) => ({ ...t }));
}
function Mm(e) {
  return [...e].sort((t, n) => t.intensity - n.intensity);
}
function na(e) {
  const t = Number.isFinite(e[0]) ? e[0] : 0, n = Number.isFinite(e[1]) ? e[1] : 1;
  return t <= n ? [t, n] : [n, t];
}
function kr(e, t) {
  const n = Number(e);
  return Number.isFinite(n) ? n : t;
}
function ar(e) {
  const t = kr(e, 0);
  return t > 1 && t <= 255 ? yn(t / 255) : yn(t);
}
function or(e, t, n) {
  const a = e, o = a[t];
  return o ?? a[n];
}
function aa(e) {
  return {
    red: ar(or(e, "red", "r")),
    green: ar(or(e, "green", "g")),
    blue: ar(or(e, "blue", "b"))
  };
}
function Pm(e, t) {
  const n = na(t), a = aa(e);
  return {
    intensity: Na(kr(e.intensity, n[0]), n[0], n[1]),
    alpha: yn(kr(e.alpha, 0)),
    red: a.red,
    green: a.green,
    blue: a.blue
  };
}
function ro(e, t) {
  const n = na(t), a = Mm(e).map((o) => Pm(o, n));
  if (a.length === 0)
    return [
      { intensity: n[0], alpha: 0, red: 0, green: 0, blue: 0 },
      { intensity: n[1], alpha: 1, red: 1, green: 1, blue: 1 }
    ];
  if (a.length === 1) {
    const o = a[0];
    return [
      { ...o, intensity: n[0] },
      { ...o, intensity: n[1] }
    ];
  }
  return a[0] = { ...a[0], intensity: n[0] }, a[a.length - 1] = { ...a[a.length - 1], intensity: n[1] }, a;
}
function y0(e, t, n) {
  const a = Kl(e);
  if (a.length === 0)
    return a;
  if (a.length >= 4) {
    const l = a.length - 2;
    return a[1] = { ...a[1], red: yn(t[0]), green: yn(t[1]), blue: yn(t[2]) }, a[l] = { ...a[l], red: yn(n[0]), green: yn(n[1]), blue: yn(n[2]) }, a;
  }
  return a[0] = { ...a[0], red: yn(t[0]), green: yn(t[1]), blue: yn(t[2]) }, a[a.length - 1] = { ...a[a.length - 1], red: yn(n[0]), green: yn(n[1]), blue: yn(n[2]) }, a;
}
function _0(e, t) {
  return t.map((n, a) => {
    const o = e[a];
    if (!o)
      return n;
    const l = aa(o);
    return {
      ...n,
      red: l.red,
      green: l.green,
      blue: l.blue
    };
  });
}
function w0(e) {
  const t = Mm(e);
  if (t.length >= 4) {
    const n = aa(t[1]), a = aa(t[t.length - 2]);
    return {
      left: [Math.round(n.red * 255), Math.round(n.green * 255), Math.round(n.blue * 255)],
      right: [Math.round(a.red * 255), Math.round(a.green * 255), Math.round(a.blue * 255)]
    };
  }
  if (t.length >= 2) {
    const n = aa(t[0]), a = aa(t[t.length - 1]);
    return {
      left: [Math.round(n.red * 255), Math.round(n.green * 255), Math.round(n.blue * 255)],
      right: [Math.round(a.red * 255), Math.round(a.green * 255), Math.round(a.blue * 255)]
    };
  }
  return {
    left: [255, 255, 255],
    right: [255, 255, 255]
  };
}
function Vr(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++) {
    const a = e[n], o = t[n];
    if (Math.abs(a.intensity - o.intensity) > Xo || Math.abs(a.alpha - o.alpha) > Xo || Math.abs(a.red - o.red) > Xo || Math.abs(a.green - o.green) > Xo || Math.abs(a.blue - o.blue) > Xo)
      return !1;
  }
  return !0;
}
function ri(e, t) {
  const n = na(t), a = Math.max(n[1] - n[0], Xo);
  return Na((e - n[0]) / a, 0, 1);
}
function Br(e, t) {
  const n = na(t);
  return n[0] + Na(e, 0, 1) * (n[1] - n[0]);
}
function S0(e, t, n) {
  if (e.length === 0)
    return "";
  const a = ro(e, t), o = n.top + n.height, l = [`M ${n.left} ${o}`];
  for (const s of a) {
    const i = ri(s.intensity, t), c = Rm(s.alpha), u = n.left + i * n.width, p = o - c * n.height;
    l.push(`L ${u} ${p}`);
  }
  return l.push(`L ${n.left + n.width} ${o}`), l.push("Z"), l.join(" ");
}
function I0(e, t) {
  if (!e.length)
    return "";
  const n = t.width / Math.max(e.length - 1, 1), a = e.map((l, s) => {
    const i = t.left + n * s, c = t.top + (1 - yn(l)) * t.height;
    return [i, c];
  }), o = [`M ${a[0][0]} ${a[0][1]}`];
  for (let l = 1; l < a.length; l++) {
    const [s, i] = a[l];
    o.push(`L ${s} ${i}`);
  }
  return o.join(" ");
}
const E0 = ["viewBox"], T0 = ["offset", "stop-color"], C0 = ["x", "y", "width", "height", "fill"], N0 = ["x", "y", "width", "height"], L0 = ["d"], O0 = ["d"], D0 = ["x", "y", "width", "height"], A0 = ["cx", "cy", "onPointerdown", "onContextmenu"], R0 = ["x", "y", "width", "height"], wd = 640, Sd = 360, M0 = /* @__PURE__ */ qe({
  __name: "TransferFunctionEditor",
  props: {
    modelValue: {},
    intensityRange: {},
    histogram: { default: () => [] },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: o } = Yt(), l = Mo(), s = F(), i = {
      left: 12,
      top: 12,
      width: 616,
      height: 312
    }, c = `tf-gradient-${Math.random().toString(36).slice(2)}`, u = F([]);
    let p = 1;
    function b(H, M) {
      return ro(Kl(H), M).map((ne) => ({ ...ne, __id: p++ }));
    }
    ot(
      () => [n.modelValue, n.intensityRange],
      ([H, M]) => {
        const te = na(M), ne = ro(H || [], te), W = u.value.map(({ __id: se, ...be }) => be);
        Vr(ne, W) || (u.value = b(ne, te));
      },
      { immediate: !0, deep: !0 }
    );
    const f = Te(() => {
      const H = na(n.intensityRange);
      return u.value.map((M) => ({
        offset: ri(M.intensity, H) * 100,
        color: m(M)
      }));
    }), h = Te(() => I0(n.histogram || [], i)), I = Te(() => {
      const H = u.value.map(({ __id: M, ...te }) => te);
      return S0(H, n.intensityRange, i);
    });
    function m(H) {
      const M = aa(H);
      return `rgb(${Math.round(M.red * 255)}, ${Math.round(M.green * 255)}, ${Math.round(M.blue * 255)})`;
    }
    function S(H) {
      const M = aa(H);
      return 0.299 * M.red + 0.587 * M.green + 0.114 * M.blue > 0.5 ? "#111111" : "#f5f5f5";
    }
    function E(H) {
      const M = ri(H, n.intensityRange);
      return i.left + M * i.width;
    }
    function g(H) {
      const M = Rm(H);
      return i.top + (1 - M) * i.height;
    }
    function v(H) {
      const M = Na((i.top + i.height - H) / i.height, 0, 1);
      return v0(M);
    }
    function T(H) {
      const M = s.value;
      if (!M)
        return { x: 0, y: 0 };
      const te = M.getBoundingClientRect(), ne = wd / te.width, W = Sd / te.height;
      return {
        x: (H.clientX - te.left) * ne,
        y: (H.clientY - te.top) * W
      };
    }
    function R(H) {
      const M = na(n.intensityRange), te = ro(
        H.map(({ __id: ne, ...W }) => Pm(W, M)),
        M
      );
      u.value = te.map((ne, W) => {
        var se;
        return { ...ne, __id: ((se = H[W]) == null ? void 0 : se.__id) ?? p++ };
      }), a("update:modelValue", te);
    }
    let L = null;
    function C(H, M) {
      n.disabled || M.button !== 0 || (L = H, window.addEventListener("pointermove", A), window.addEventListener("pointerup", j));
    }
    function A(H) {
      if (L === null)
        return;
      const M = u.value.findIndex((q) => q.__id === L);
      if (M === -1)
        return;
      const te = M === 0, ne = M === u.value.length - 1, W = T(H), se = na(n.intensityRange);
      let be = Br(Na((W.x - i.left) / i.width, 0, 1), se);
      te ? be = se[0] : ne && (be = se[1]);
      const Re = v(Na(W.y, i.top, i.top + i.height)), U = u.value.map((q) => ({ ...q }));
      U[M] = {
        ...U[M],
        intensity: be,
        alpha: Re
      };
      const ie = U.sort((q, De) => q.intensity - De.intensity), re = _0(u.value, ie);
      R(re);
    }
    function j() {
      L = null, window.removeEventListener("pointermove", A), window.removeEventListener("pointerup", j);
    }
    function N(H) {
      if (n.disabled || H.button !== 0)
        return;
      const M = T(H);
      if (!(M.x >= i.left && M.x <= i.left + i.width && M.y >= i.top && M.y <= i.top + i.height))
        return;
      const ne = Br((M.x - i.left) / i.width, n.intensityRange), W = v(M.y), se = {
        __id: p++,
        intensity: ne,
        alpha: W,
        red: 1,
        green: 1,
        blue: 1
      }, be = [...u.value.map((Re) => ({ ...Re })), se].sort((Re, U) => Re.intensity - U.intensity);
      R(be);
    }
    async function x(H, M) {
      if (n.disabled)
        return;
      const te = u.value.findIndex((se) => se.__id === H);
      if (te === -1)
        return;
      if (te === 0 || te === u.value.length - 1) {
        await z(H);
        return;
      }
      const W = await l.showContextMenu([o("shared.changeColor"), o("shared.delete")], M.clientX, M.clientY);
      W === 0 ? await z(H) : W === 1 && await X(H);
    }
    async function z(H) {
      const M = u.value.findIndex((Re) => Re.__id === H);
      if (M === -1)
        return;
      const te = u.value[M], ne = aa(te), W = [Math.round(ne.red * 255), Math.round(ne.green * 255), Math.round(ne.blue * 255)], se = await l.showColorPickerModal(o("shared.changeColor"), W);
      if (!se)
        return;
      const be = u.value.map((Re) => ({ ...Re }));
      be[M] = {
        ...be[M],
        red: se[0] / 255,
        green: se[1] / 255,
        blue: se[2] / 255
      }, R(be);
    }
    async function X(H) {
      if (u.value.length <= 4) {
        await l.showInfoModal(o("implant-planner.warning"), o("implant-planner.transferFunctionMinPointsWarning"));
        return;
      }
      const M = u.value.filter((te) => te.__id !== H).map((te) => ({ ...te }));
      R(M);
    }
    return On(() => {
      j();
    }), (H, M) => (O(), J("div", {
      class: "tf-editor",
      style: { width: "100%", userSelect: "none", maxHeight: "52vh" },
      onMousedown: M[0] || (M[0] = ka(() => {
      }, ["prevent"]))
    }, [
      (O(), J("svg", {
        ref_key: "svgRef",
        ref: s,
        class: "tf-editor-svg",
        style: { width: "100%", height: "100%", display: "block" },
        viewBox: `0 0 ${wd} ${Sd}`,
        preserveAspectRatio: "none"
      }, [
        y("defs", null, [
          y("linearGradient", {
            id: c,
            x1: "0%",
            y1: "0%",
            x2: "100%",
            y2: "0%"
          }, [
            (O(!0), J(ze, null, Rt(f.value, (te, ne) => (O(), J("stop", {
              key: `s-${ne}`,
              offset: `${te.offset}%`,
              "stop-color": te.color
            }, null, 8, T0))), 128))
          ])
        ]),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          fill: `url(#${c})`,
          rx: "4",
          ry: "4"
        }, null, 8, C0),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          fill: "rgba(255,255,255,0.08)",
          rx: "4",
          ry: "4"
        }, null, 8, N0),
        h.value ? (O(), J("path", {
          key: 0,
          d: h.value,
          class: "tf-editor-histogram",
          style: { fill: "none", stroke: "rgba(0, 255, 0, 0.5)", "stroke-width": "5" }
        }, null, 8, L0)) : ue("", !0),
        I.value ? (O(), J("path", {
          key: 1,
          d: I.value,
          class: "tf-editor-opacity",
          style: { fill: "rgba(255, 255, 255, 0.15)", stroke: "rgba(255, 255, 255, 0.9)", "stroke-width": "2" }
        }, null, 8, O0)) : ue("", !0),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          class: "tf-editor-hit-area",
          style: { fill: "transparent", cursor: "crosshair" },
          onPointerdown: N
        }, null, 40, D0),
        y("g", null, [
          (O(!0), J(ze, null, Rt(u.value, (te) => (O(), J("circle", {
            key: te.__id,
            cx: E(te.intensity),
            cy: g(te.alpha),
            r: "12",
            class: "tf-editor-point",
            style: Tt({ fill: m(te), stroke: S(te), strokeWidth: 2, cursor: "pointer" }),
            onPointerdown: ka((ne) => C(te.__id, ne), ["stop"]),
            onContextmenu: ka((ne) => x(te.__id, ne), ["stop", "prevent"])
          }, null, 44, A0))), 128))
        ]),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          class: "tf-editor-border",
          style: { fill: "none", stroke: "rgb(146, 146, 146)", "stroke-width": "1" },
          rx: "4",
          ry: "4"
        }, null, 8, R0)
      ], 8, E0))
    ], 32));
  }
}), P0 = ["viewBox"], x0 = ["offset", "stop-color"], j0 = ["x", "y", "width", "height", "fill"], F0 = ["x", "y", "width", "height"], $0 = ["cx", "cy"], k0 = ["cx", "cy"], V0 = ["cx", "cy"], B0 = ["height"], U0 = ["x", "y", "text-anchor"], lr = 640, Id = 86, ir = 54, G0 = /* @__PURE__ */ qe({
  __name: "TransferFunctionWindowLevelStrip",
  props: {
    points: {},
    intensityRange: {},
    windowWidth: {},
    windowLevel: {},
    showIntermediatePoints: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    height: { default: 45 }
  },
  emits: ["update:windowLevel", "update:endpointColors"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = Mo(), { t: l } = Yt(), s = F(), i = {
      left: 12,
      top: 10,
      width: 616,
      height: 36
    }, c = `tf-strip-gradient-${Math.random().toString(36).slice(2)}`, u = Te(() => n.windowLevel - n.windowWidth / 2), p = Te(() => n.windowLevel + n.windowWidth / 2), b = Te(() => n.height ? `${Math.max(40, Math.round(n.height))}px` : "clamp(74px, 9vw, 96px)"), f = Te(() => {
      const z = na(n.intensityRange), X = n.points.length ? n.points : [
        { intensity: z[0], alpha: 0, red: 0, green: 0, blue: 0 },
        { intensity: z[1], alpha: 1, red: 1, green: 1, blue: 1 }
      ];
      return ro(X, z);
    }), h = Te(() => {
      const z = na(n.intensityRange);
      return f.value.map((X) => {
        const H = aa(X);
        return {
          offset: ri(X.intensity, z) * 100,
          color: `rgb(${Math.round(H.red * 255)}, ${Math.round(H.green * 255)}, ${Math.round(H.blue * 255)})`
        };
      });
    });
    function I(z, X) {
      return X >= 4 ? z === 1 || z === X - 2 : z === 0 || z === X - 1;
    }
    const m = Te(() => {
      if (!n.showIntermediatePoints)
        return [];
      const z = f.value;
      return z.filter((X, H) => !I(H, z.length));
    });
    function S(z) {
      const X = aa(z);
      return `rgb(${Math.round(X.red * 255)}, ${Math.round(X.green * 255)}, ${Math.round(X.blue * 255)})`;
    }
    function E(z) {
      const X = aa(z);
      return 0.299 * X.red + 0.587 * X.green + 0.114 * X.blue > 0.55 ? "#101010" : "#f2f2f2";
    }
    function g(z) {
      return i.left + ri(z, n.intensityRange) * i.width;
    }
    function v(z) {
      const X = Na((z - i.left) / i.width, 0, 1);
      return Br(X, n.intensityRange);
    }
    function T() {
      return w0(n.points);
    }
    let R = null;
    function L(z) {
      const X = s.value;
      if (!X)
        return 0;
      const H = X.getBoundingClientRect(), M = lr / H.width;
      return (z.clientX - H.left) * M;
    }
    function C(z, X) {
      n.disabled || X.button !== 0 || (R = z, window.addEventListener("pointermove", A), window.addEventListener("pointerup", j));
    }
    function A(z) {
      if (!R)
        return;
      const X = Na(L(z), i.left, i.left + i.width), H = v(X);
      let M = u.value, te = p.value;
      R === "left" ? M = Math.min(H, te - 1e-6) : te = Math.max(H, M + 1e-6), a("update:windowLevel", {
        width: te - M,
        level: (te + M) / 2
      });
    }
    function j() {
      R = null, window.removeEventListener("pointermove", A), window.removeEventListener("pointerup", j);
    }
    async function N(z) {
      if (n.disabled)
        return;
      const X = T(), H = await o.showColorPickerModal(l("shared.changeColor"), z === "left" ? X.left : X.right);
      H && a("update:endpointColors", {
        left: z === "left" ? H : X.left,
        right: z === "right" ? H : X.right
      });
    }
    const x = Te(() => {
      const z = na(n.intensityRange), X = ir + 20, H = `${Math.round(z[0])}`, M = `${Math.round(u.value)}`, te = `${Math.round(p.value)}`, ne = `${Math.round(z[1])}`, W = (q, De, _e, xe) => {
        const k = Math.max(20, De.length * 7 + 8);
        return xe === "start" ? { key: q, text: De, x: _e, y: X, anchor: xe, left: _e, right: _e + k } : xe === "end" ? { key: q, text: De, x: _e, y: X, anchor: xe, left: _e - k, right: _e } : { key: q, text: De, x: _e, y: X, anchor: xe, left: _e - k / 2, right: _e + k / 2 };
      }, se = 6, be = [], Re = W("left", H, i.left, "start");
      be.push(Re);
      const U = W("low", M, g(u.value), "middle");
      U.left >= be[be.length - 1].right + se && be.push(U);
      const ie = W("high", te, g(p.value), "middle");
      ie.left >= be[be.length - 1].right + se && be.push(ie);
      const re = W("right", ne, i.left + i.width, "end");
      return re.left >= be[be.length - 1].right + se && be.push(re), be;
    });
    return On(() => {
      j();
    }), (z, X) => (O(), J("div", {
      class: "tf-strip",
      style: { width: "100%", userSelect: "none" },
      onMousedown: X[4] || (X[4] = ka(() => {
      }, ["prevent"]))
    }, [
      (O(), J("svg", {
        ref_key: "svgRef",
        ref: s,
        class: "tf-strip-svg",
        style: Tt({ width: "100%", height: b.value, display: "block" }),
        viewBox: `0 0 ${lr} ${Id}`,
        preserveAspectRatio: "none"
      }, [
        y("defs", null, [
          y("linearGradient", {
            id: c,
            x1: "0%",
            y1: "0%",
            x2: "100%",
            y2: "0%"
          }, [
            (O(!0), J(ze, null, Rt(h.value, (H, M) => (O(), J("stop", {
              key: `stop-${M}`,
              offset: `${H.offset}%`,
              "stop-color": H.color
            }, null, 8, x0))), 128))
          ])
        ]),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          fill: `url(#${c})`,
          rx: "4",
          ry: "4"
        }, null, 8, j0),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          class: "tf-strip-border",
          style: { fill: "transparent", stroke: "rgb(146, 146, 146)", "stroke-width": "1" },
          rx: "4",
          ry: "4"
        }, null, 8, F0),
        (O(!0), J(ze, null, Rt(m.value, (H, M) => (O(), J("circle", {
          key: `preview-${M}`,
          cx: g(H.intensity),
          cy: i.top + i.height / 2,
          r: "5",
          style: Tt({ fill: S(H), stroke: E(H), strokeWidth: 1.6 })
        }, null, 12, $0))), 128)),
        y("circle", {
          class: "tf-strip-handle",
          cx: g(u.value),
          cy: i.top + i.height / 2,
          r: "8",
          style: { fill: "rgba(191, 191, 191, 0.95)", stroke: "#ffffff", "stroke-width": "2", cursor: "ew-resize" },
          onPointerdown: X[0] || (X[0] = ka((H) => C("left", H), ["stop"])),
          onContextmenu: X[1] || (X[1] = ka((H) => N("left"), ["stop", "prevent"]))
        }, null, 40, k0),
        y("circle", {
          class: "tf-strip-handle",
          cx: g(p.value),
          cy: i.top + i.height / 2,
          r: "8",
          style: { fill: "rgba(191, 191, 191, 0.95)", stroke: "#ffffff", "stroke-width": "2", cursor: "ew-resize" },
          onPointerdown: X[2] || (X[2] = ka((H) => C("right", H), ["stop"])),
          onContextmenu: X[3] || (X[3] = ka((H) => N("right"), ["stop", "prevent"]))
        }, null, 40, V0),
        y("rect", {
          x: 0,
          y: ir,
          width: lr,
          height: Id - ir,
          fill: "rgba(0, 0, 0, 0.28)"
        }, null, 8, B0),
        (O(!0), J(ze, null, Rt(x.value, (H) => (O(), J("text", {
          key: H.key,
          x: H.x,
          y: H.y,
          "text-anchor": H.anchor,
          style: { fill: "#ffffff", "font-size": "1.5rem", "font-weight": "bold" }
        }, V(H.text), 9, U0))), 128))
      ], 12, P0))
    ], 32));
  }
});
function W0(e) {
  if (!e)
    return null;
  const t = e.getPointData(), n = t.getScalars() || t.getArrays()[0];
  return n ? n.getData() : null;
}
function z0(e, t, n = 64, a = 8) {
  const o = new Array(Math.max(1, Math.floor(n))).fill(0);
  if (!e || e.length === 0)
    return o;
  const l = na(t), s = l[0], i = l[1], c = Math.max(i - s, 1e-6), u = Math.max(1, Math.floor(a));
  for (let b = 0; b < e.length; b += u) {
    const f = Number(e[b]);
    if (!Number.isFinite(f) || f < s || f > i)
      continue;
    const h = Na((f - s) / c, 0, 1), I = Math.min(o.length - 1, Math.floor(h * o.length));
    o[I] += 1;
  }
  const p = Math.max(...o);
  return p <= 0 ? o : o.map((b) => b / p);
}
function H0(e, t, n = 64, a = 8) {
  const o = W0(e);
  return z0(o, t, n, a);
}
function Y0(e) {
  if (typeof window > "u") {
    setTimeout(e, 0);
    return;
  }
  const t = window.requestIdleCallback;
  t ? t(e, { timeout: 40 }) : setTimeout(e, 0);
}
async function K0(e, t, n = 64, a = 8) {
  return new Promise((o) => {
    Y0(() => {
      o(H0(e, t, n, a));
    });
  });
}
let tl = null;
function Cx(e) {
  tl = e.global;
}
function Z0() {
  return tl || (console.warn("[lib] i18n not initialized. Returning fallback composer."), {
    t: (e) => e
    // just echoes the key back
    // you can add other methods as needed (d, n, locale, etc.)
  });
}
function J0() {
  const e = tl == null ? void 0 : tl.locale;
  if (typeof e == "string")
    return e;
  if (e && typeof e.value == "string")
    return e.value;
  if (typeof localStorage < "u") {
    const t = localStorage.getItem("langApp");
    if (t)
      try {
        const n = JSON.parse(t);
        if (typeof n == "string")
          return n;
      } catch {
      }
  }
  return "en";
}
function nt(e, t) {
  return Z0().t(e);
}
function X0() {
  return {
    volumeOptions: [],
    selectedVolumeOption: {
      name: nt("implant-planner.noShading"),
      code: 0
    },
    mip: !1,
    wWidth: 406,
    wLevel: -310,
    dicomTransparency: {
      value: 23,
      isRange: !1,
      iconSrc: "",
      minValue: 0,
      maxValue: 100,
      step: 1,
      showValue: !1
    },
    templates: [],
    transferFunction: [
      { intensity: -1024, alpha: 0, red: 0, green: 0, blue: 0 },
      { intensity: 3071, alpha: 1, red: 1, green: 1, blue: 1 }
    ]
  };
}
const q0 = {
  class: "ip3d-volume-header",
  style: { display: "flex", "align-items": "center", "justify-content": "space-between", gap: "clamp(8px, 1.6vw, 14px)" }
}, Q0 = { style: { width: "100%", flex: "1 1 auto" } }, ew = { class: "flex-1" }, tw = ["src", "alt"], nw = { class: "text-lg text-center" }, Du = /* @__PURE__ */ qe({
  __name: "IP3dSettingsWizard",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Yt(), a = e, o = t, l = et(X0());
    eh(l, a, o);
    const s = pn(), i = ia(), c = F(null), u = F(), p = F(!0), b = F(!0), f = F([]), h = F([-1024, 3071]), I = F(new Array(64).fill(0)), m = F(null);
    let S = 0;
    Wa(() => {
      a.modelValue && Object.assign(l, a.modelValue);
    });
    const E = Te(() => ({
      disabled: c.value === null || Object.values(R).length <= 1
    })), g = Te(() => ({
      disabled: c.value === null
    })), v = et({
      value: l.dicomTransparency.value,
      minValue: l.dicomTransparency.minValue,
      maxValue: l.dicomTransparency.maxValue,
      step: 1
    });
    let T = 0;
    const R = F(
      structuredClone(Object.values(Ih.Dental).map((re) => [(T++).toString(), re]))
    ), L = F([]), C = {
      Airways: "medic-web-engine.airways",
      Bones: "medic-web-engine.bones",
      Default: "weblink.default",
      "Soft Tissues": "medic-web-engine.softTissues",
      Teeth: "shared.teeth",
      "X-Ray": "medic-web-engine.xRay",
      "Bone Vessels": "medic-web-engine.boneVessels",
      MIP: "medic-web-engine.mip",
      "Vessels Bones Airways": "medic-web-engine.vesselsBonesAirways",
      Vessels: "medic-web-engine.vessels"
    };
    ot(
      R,
      async (re) => {
        const q = [];
        for (const [De, _e] of re) {
          let xe = "";
          _e.thumbnailFile ? xe = i.getAssetUrl(`/resources/3d_template_thumbnails/${_e.thumbnailFile}`) : xe = await Eh(s, _e) || "";
          const k = C[_e.name];
          q.push({
            id: Number(De),
            name: k ? n(k).replace(":", "") : _e.name,
            image: xe
          });
        }
        L.value = q;
      },
      { immediate: !0, deep: !0 }
    ), l.volumeOptions = [
      { name: n("implant-planner.noShading"), code: Nl.NO_SHADING },
      { name: n("implant-planner.bright"), code: Nl.LIGHT_SHADING },
      { name: n("medic-web-framework.dark"), code: Nl.DARK_SHADING },
      { name: n("implant-planner.shining"), code: Nl.SHINY_SHADING }
    ];
    function A() {
      const q = s.getImageData().getPointData(), De = q.getScalars() || q.getArrays()[0], _e = De == null ? void 0 : De.getRange(), xe = Number.isFinite(_e == null ? void 0 : _e[0]) ? _e[0] : -1024, k = Number.isFinite(_e == null ? void 0 : _e[1]) ? _e[1] : 3071;
      return xe <= k ? [Math.floor(xe), Math.ceil(k)] : [Math.floor(k), Math.ceil(xe)];
    }
    function j(re) {
      if (re.length >= 2) {
        const q = [...re].sort((De, _e) => De.intensity - _e.intensity);
        return [Math.floor(q[0].intensity), Math.ceil(q[q.length - 1].intensity)];
      }
      return A();
    }
    async function N() {
      const re = ++S, q = await K0(s.getImageData(), h.value, 64, 8);
      re === S && (I.value = q);
    }
    function x() {
      const re = s.getCurrentVolumeOptions();
      z();
      const q = l.volumeOptions.findIndex((xe) => xe.code === re.shading);
      q !== -1 && (l.selectedVolumeOption = l.volumeOptions[q]);
      const De = (1 - (re.volumeOpacity || 0)) * 100;
      if (l.dicomTransparency.value = De, v.value = De, h.value = j(re.points || []), f.value = ro(Kl(re.points || []), h.value), l.transferFunction = f.value.map((xe) => ({ ...xe })), c.value !== null) {
        const xe = R.value.findIndex((k) => k[0] === c.value);
        xe !== -1 && (R.value[xe][1] = re);
      }
      (!m.value || m.value[0] !== h.value[0] || m.value[1] !== h.value[1]) && (m.value = [...h.value], N());
    }
    function z() {
      const [re, q] = s.getVolumeWindowWidthLevel();
      l.wWidth = Math.max(1, Math.round(re)), l.wLevel = Math.round(q);
    }
    function X(re, q) {
      c.value = re.toString(), s.setVolumeOptions(q), x();
    }
    X("-1", s.getCurrentVolumeOptions());
    function H() {
      if (c.value === null)
        return;
      const re = R.value.findIndex((q) => q[0] === c.value);
      re !== -1 && R.value.splice(re, 1), R.value.length > 0 ? re > 0 ? X(...R.value[re - 1]) : X(...R.value[0]) : c.value = null;
    }
    function M() {
      var _e;
      let re;
      c.value !== null && (re = (_e = R.value.find((xe) => xe[0] === c.value)) == null ? void 0 : _e[1]), re || (re = s.getCurrentVolumeOptions());
      const q = JSON.parse(JSON.stringify(re));
      q.name = `${re.name} (copy)`;
      const De = (T++).toString();
      R.value.push([De, q]), X(De, q);
    }
    function te(re) {
      const q = re.value.code;
      if (!(q in Nl)) {
        console.warn("unknown shading mode");
        return;
      }
      s.setVolumeShading(q);
    }
    function ne(re) {
      Number.isFinite(re) && (l.wWidth = Math.max(1, Math.round(re)), s.setVolumeWindowWidthLevel(l.wWidth, l.wLevel), z());
    }
    function W(re) {
      Number.isFinite(re) && (l.wLevel = Math.round(re), s.setVolumeWindowWidthLevel(l.wWidth, l.wLevel), z());
    }
    function se(re) {
      const q = Math.max(1, Math.round(re.width)), De = Math.round(re.level);
      if (q === l.wWidth && De === l.wLevel)
        return;
      l.wWidth = q, l.wLevel = De, s.setVolumeWindowWidthLevel(q, De), z();
      const _e = s.getCurrentVolumeOptions().points || [], xe = j(_e);
      h.value = xe, f.value = ro(Kl(_e), xe), l.transferFunction = f.value.map((k) => ({ ...k }));
    }
    function be(re) {
      const q = ro(Kl(re), h.value);
      Vr(q, f.value) || (f.value = q, l.transferFunction = q.map((De) => ({ ...De })), s.setVolumePoints(q));
    }
    function Re(re) {
      const q = [re.left[0] / 255, re.left[1] / 255, re.left[2] / 255], De = [re.right[0] / 255, re.right[1] / 255, re.right[2] / 255], _e = y0(f.value, q, De);
      Vr(_e, f.value) || (f.value = _e, l.transferFunction = _e.map((xe) => ({ ...xe })), s.setVolumePoints(_e));
    }
    function U(re) {
      if (!re.value || !re.value.length)
        return;
      const q = re.value[0].id.toString();
      p.value = !1;
      const De = R.value.find((_e) => _e[0] === q);
      De && X(...De);
    }
    function ie() {
      x();
    }
    return s.onVolumeOptionsModified.subscribe(ie), Ka(() => {
      s.onVolumeOptionsModified.unsubscribe(ie);
    }), (re, q) => (O(), J(ze, null, [
      d(jo, {
        onHideWizard: q[0] || (q[0] = (De) => o("hideWizard"))
      }, {
        default: w(() => [
          yt(V(re.$t("implant-planner.dSettings")), 1)
        ]),
        _: 1
      }),
      d(bl, null, {
        default: w(() => [
          d(r(at), { style: { gap: "clamp(10px, 1.8vh, 16px)", padding: "clamp(12px, 2.4vw, 20px) clamp(12px, 2.4vw, 20px) clamp(10px, 2vw, 14px)", "margin-bottom": "10px" } }, {
            default: w(() => [
              y("div", q0, [
                d(co, null, {
                  default: w(() => [
                    yt(V(re.$t("implant-planner.volumeOptions")), 1)
                  ]),
                  _: 1
                }),
                d(r(Ce), {
                  icon: "pi pi-ellipsis-h",
                  onToggledChange: q[1] || (q[1] = (De) => b.value = !b.value),
                  toggled: !b.value,
                  togglable: !0
                }, null, 8, ["toggled"])
              ]),
              b.value ? ue("", !0) : (O(), he(r(Be), { key: 0 }, {
                default: w(() => [
                  d(r(Pn), {
                    modelValue: l.selectedVolumeOption,
                    "onUpdate:modelValue": q[2] || (q[2] = (De) => l.selectedVolumeOption = De),
                    options: l.volumeOptions,
                    class: "w-full mt-1 p-inputtext",
                    optionLabel: "name",
                    style: { "align-items": "center" },
                    onChange: te
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })),
              y("div", Q0, [
                b.value ? ue("", !0) : (O(), he(M0, {
                  key: 0,
                  modelValue: f.value,
                  intensityRange: h.value,
                  histogram: I.value,
                  "onUpdate:modelValue": be
                }, null, 8, ["modelValue", "intensityRange", "histogram"])),
                d(G0, {
                  points: f.value,
                  intensityRange: h.value,
                  windowWidth: l.wWidth,
                  windowLevel: l.wLevel,
                  showIntermediatePoints: !b.value,
                  "onUpdate:windowLevel": se,
                  "onUpdate:endpointColors": Re
                }, null, 8, ["points", "intensityRange", "windowWidth", "windowLevel", "showIntermediatePoints"])
              ]),
              d(r(Be), { style: { display: "flex", "flex-wrap": "wrap", gap: "12px 18px", "align-items": "flex-start" } }, {
                default: w(() => [
                  d(r(Be), { style: { display: "flex", "align-items": "center", gap: "10px", flex: "1 1 260px", "min-width": "min(100%, 260px)" } }, {
                    default: w(() => [
                      y("span", null, V(re.$t("implant-planner.wWidth")), 1),
                      d(r(Ic), {
                        class: "w-full ip3d-number-input",
                        style: { flex: "1 1 auto" },
                        max: 3e4,
                        min: 1,
                        modelValue: l.wWidth,
                        "onUpdate:modelValue": ne
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  d(r(Be), { style: { display: "flex", "align-items": "center", gap: "10px", flex: "1 1 260px", "min-width": "min(100%, 260px)" } }, {
                    default: w(() => [
                      y("span", null, V(re.$t("implant-planner.wLevel")), 1),
                      d(r(Ic), {
                        class: "w-full ip3d-number-input",
                        style: { flex: "1 1 auto" },
                        max: 3e4,
                        min: -3e4,
                        modelValue: l.wLevel,
                        "onUpdate:modelValue": W
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          ue("", !0),
          d(r(at), { class: "gap-2 h-full overflow-y-auto" }, {
            default: w(() => [
              d(co, null, {
                default: w(() => [
                  yt(V(re.$t("implant-planner.templates")), 1)
                ]),
                _: 1
              }),
              d(r(Be), { class: "h-full overflow-y-auto" }, {
                default: w(() => [
                  d(r(Jh), {
                    modelValue: L.value,
                    "onUpdate:modelValue": q[4] || (q[4] = (De) => L.value = De),
                    selection: u.value,
                    "onUpdate:selection": q[5] || (q[5] = (De) => u.value = De),
                    class: "h-full overflow-y-auto w-full",
                    metaKeySelection: !0,
                    dataKey: "id",
                    breakpoint: "575px",
                    "pt:pcListbox:root": "w-full h-full overflow-y-auto p-listbox-template",
                    "pt:pcListbox:option": "p-listbox-option-template",
                    onSelectionChange: U
                  }, {
                    option: w(({ option: De, selected: _e }) => [
                      d(r(Be), {
                        class: He([_e ? "rg-primary-color" : "rg-main-bg-color", "p-4 justify-center items-center gap-2 w-full cardListHover"]),
                        style: { border: "2px var(--p-rg-border-color) solid", "border-radius": "16px" }
                      }, {
                        default: w(() => [
                          y("div", ew, [
                            y("img", {
                              src: De.image,
                              alt: De.name,
                              draggable: "false"
                            }, null, 8, tw)
                          ]),
                          d(r(Ee), { class: "flex-1 justify-center" }, {
                            default: w(() => [
                              y("span", nw, V(De.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "selection"])
                ]),
                _: 1
              }),
              d(r(Be), { class: "gap-2" }, {
                default: w(() => [
                  d(r(Ce), {
                    disabled: E.value.disabled || p.value,
                    class: "web-rg-wiz-btn grow",
                    label: re.$t("implant-planner.deleteTemplate"),
                    onClick: H
                  }, null, 8, ["disabled", "label"]),
                  d(r(Ce), {
                    disabled: g.value.disabled || p.value,
                    class: "web-rg-wiz-btn grow",
                    label: re.$t("implant-planner.saveTemplate"),
                    style: { background: "var(--p-primary-color) !important" },
                    onClick: M
                  }, null, 8, ["disabled", "label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 64));
  }
});
var Wn = /* @__PURE__ */ ((e) => (e[e.MATCHING = 0] = "MATCHING", e[e.KEEP_ORIGINAL_POSTION = 1] = "KEEP_ORIGINAL_POSTION", e[e.SAME_AS = 2] = "SAME_AS", e))(Wn || {});
const aw = /* @__PURE__ */ qe({
  __name: "IPMatchingCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = F([]), a, o = F("");
    const l = F(Math.random());
    let s = F();
    const i = Po();
    let c, u = !1;
    const p = t;
    return Mt(() => {
      i.enableNavbarButtons([Ie.UNDO, Ie.REDO]);
    }), On(() => {
      i.disableNavbarButtons([Ie.UNDO, Ie.REDO]);
    }), Mt(async () => {
      u = !0, c = pn(), c.showLoading(nt("implant-planner.loadingMatchingWizard"), !1, void 0, !0), c.setCADMode(!0), c.contextCAD.GetMainForm().SetJSLambda((f) => {
        u && (console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI start toolwidget exists", !!f), f ? (n.value = f.GetWidgetOrder().slice(), a = f.GetWidgets(), o.value = f.GetToolTitle(), console.log(
          "000000 DynamicGUIComponent RETRIEVESTATICGUI widgets, order title",
          f.GetWidgetOrder().slice(),
          f.GetToolTitle(),
          f.GetWidgets()
        )) : (n.value = [], a = void 0, o.value = ""), l.value = Math.random(), console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI end"));
      }, qt.eJSLT_RETIEVE_GUI);
      const b = (f) => {
        u && (console.log("DEBUGG: finalizeCADWizard"), c.objects.stls.forEach((h) => {
          h.IsVolume() || h.syncWasmInfo();
        }), setTimeout(() => {
          u && (c.setCADMode(!1), p(f ? "nextStepNested" : "previousStepNested"));
        }, 300));
      };
      c.contextCAD.GetMainForm().SetJSLambda(b, qt.eJSLT_FINALIZE_CAD_WIZARD), await c.contextCAD.showSTLMatchingWizard(), s.value = c.contextCAD.tabWidgetHandler, await gs({
        mainForm: c.contextCAD.GetMainForm(),
        widgetsOrder: n,
        isActive: () => u
      }), console.log("tabWidgetHandler", s), c.hideLoading();
    }), On(() => {
      u = !1;
      try {
        c.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), c.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_FINALIZE_CAD_WIZARD), c.setCADMode(!1), console.log("DEBUGG: finalizeCADWizard onBeforeUnmount destroying cad!"), c.setTabIndex(1);
      } catch (b) {
        console.error("Error during unmount: ", b);
      }
    }), (b, f) => (O(), he(r(at), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: w(() => [
        d(r(at), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: w(() => [
            r(n).length ? (O(), he(r(hs), {
              key: l.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(o),
              class: "mb-2"
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(at), { style: { flex: "0 0 auto" } }, {
          default: w(() => [
            r(s) ? (O(), he(r(bs), {
              key: 0,
              "tab-handler": r(s),
              context: r(c),
              onNextStepNested: f[0] || (f[0] = (h) => p("nextStepNested")),
              onPreviousStepNested: f[1] || (f[1] = (h) => p("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), xm = /* @__PURE__ */ qe({
  __name: "IPSTLEditCAD",
  props: /* @__PURE__ */ xn({
    isDemo: { type: Boolean, default: !1 }
  }, {
    selectedObjectId: { required: !0 },
    selectedObjectIdModifiers: {}
  }),
  emits: /* @__PURE__ */ xn(["nextStepNested", "previousStepNested"], ["update:selectedObjectId"]),
  setup(e, { emit: t }) {
    const n = e, a = Ln(e, "selectedObjectId");
    let o = pn();
    const l = t;
    async function s() {
      var c;
      a.value.length > 0 && (await ((c = o.contextCAD.GetMainForm()) == null ? void 0 : c.setEditObjectAsync(a.value)) || console.log("Object not found in CAD context", a.value));
    }
    ot(a, async () => {
      await s();
    });
    const i = async () => {
      var c;
      a.value.length > 0 && await ((c = o.contextCAD.GetMainForm()) == null ? void 0 : c.setEditObjectAsync(a.value)), await o.contextCAD.showSTLEditWizard(n.isDemo), await s();
    };
    return (c, u) => (O(), he(r(Pp), {
      context: r(o),
      wizardType: "STL Edit",
      initializeLambda: i,
      onNextStepNested: u[0] || (u[0] = (p) => l("nextStepNested")),
      onPreviousStepNested: u[1] || (u[1] = (p) => l("previousStepNested"))
    }, null, 8, ["context"]));
  }
}), ow = /* @__PURE__ */ qe({
  __name: "IPBooleanOperationCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    const n = t;
    let a = pn();
    const o = async () => {
      await a.contextCAD.showBooleanOperationWizard();
    };
    return (l, s) => (O(), he(r(Pp), {
      context: r(a),
      wizardType: "Boolean",
      initializeLambda: o,
      onNextStepNested: s[0] || (s[0] = (i) => n("nextStepNested")),
      onPreviousStepNested: s[1] || (s[1] = (i) => n("previousStepNested"))
    }, null, 8, ["context"]));
  }
}), lw = {
  class: "text-14 mr-1",
  style: { "font-weight": "bold" }
}, iw = { class: "text-14" }, sw = /* @__PURE__ */ qe({
  __name: "IPDataImportMatchingDialog",
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = t, l = Te(() => {
      const I = [];
      return a.existingObjects.forEach((m) => {
        m.getGUIName() !== a.nameO && I.push({
          label: `Same as: ${m.getGUIName()}`,
          name: m.getGUIName()
        });
      }), I;
    }), s = F(null), i = F(1);
    let c = Te(() => i.value === 1), u = Te(() => i.value === 0);
    const p = (I) => {
      i.value = I ? 1 : 0, s.value = null;
    }, b = () => {
      i.value = 2;
    }, f = () => {
      var m;
      let I = Wn.MATCHING;
      i.value == 0 ? I = Wn.KEEP_ORIGINAL_POSTION : i.value == 2 && (I = Wn.SAME_AS), o("close", { state: I, name: (m = s.value) == null ? void 0 : m.name }), n.value.close();
    }, h = () => {
      o("close", { state: Wn.KEEP_ORIGINAL_POSTION, name: "" }), n.value.close();
    };
    return (I, m) => (O(), J(ze, null, [
      d(r(at), {
        class: "mt-3 mb-3 gap-4",
        style: { "min-width": "50vw" }
      }, {
        default: w(() => [
          y("span", lw, V(I.$t("implant-planner.objectName")) + " " + V(r(a).nameO), 1),
          d(r(at), { class: "gap-4 grow" }, {
            default: w(() => [
              y("span", iw, V(I.$t("implant-planner.objectPosition")), 1),
              d(r(Be), { class: "gap-2" }, {
                default: w(() => [
                  d(r(Ce), {
                    toggled: r(c),
                    label: I.$t("implant-planner.matching"),
                    onClick: m[0] || (m[0] = (S) => p(!0)),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["toggled", "label"]),
                  d(r(Ce), {
                    toggled: r(u),
                    label: I.$t("implant-planner.keepOriginalPosition"),
                    onClick: m[1] || (m[1] = (S) => p(!1)),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["toggled", "label"]),
                  d(r(Pn), {
                    modelValue: s.value,
                    "onUpdate:modelValue": m[2] || (m[2] = (S) => s.value = S),
                    options: l.value,
                    class: "flex-auto items-center",
                    "option-label": "label",
                    placeholder: I.$t("implant-planner.sameAs"),
                    style: Tt({
                      background: s.value ? "var(--p-primary-color) !important" : "",
                      flex: "1 1 0"
                    }),
                    onChange: b
                  }, null, 8, ["modelValue", "options", "placeholder", "style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      d(r(Ee), { class: "p-dialog-footer justify-center" }, {
        default: w(() => [
          d(r(la), {
            class: "mt-6",
            label: I.$t("shared.ok"),
            "data-cy": "confirmMatching",
            onClick: f
          }, null, 8, ["label"]),
          d(r(ya), {
            class: "mt-6",
            label: I.$t("shared.cancel"),
            "data-cy": "cancelMatching",
            onClick: h
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), rw = {
  name: "BaseProgressSpinner",
  extends: Ja,
  props: {
    strokeWidth: {
      type: String,
      default: "2"
    },
    fill: {
      type: String,
      default: "none"
    },
    animationDuration: {
      type: String,
      default: "2s"
    }
  },
  style: Xh,
  provide() {
    return {
      $pcProgressSpinner: this,
      $parentInstance: this
    };
  }
}, uw = {
  name: "ProgressSpinner",
  extends: rw,
  inheritAttrs: !1,
  computed: {
    svgStyle() {
      return {
        "animation-duration": this.animationDuration
      };
    }
  }
}, cw = ["fill", "stroke-width"];
function dw(e, t, n, a, o, l) {
  return O(), J("div", Pe({
    class: e.cx("root"),
    role: "progressbar"
  }, e.ptmi("root")), [
    (O(), J("svg", Pe({
      class: e.cx("spin"),
      viewBox: "25 25 50 50",
      style: l.svgStyle
    }, e.ptm("spin")), [
      y("circle", Pe({
        class: e.cx("circle"),
        cx: "50",
        cy: "50",
        r: "20",
        fill: e.fill,
        "stroke-width": e.strokeWidth,
        strokeMiterlimit: "10"
      }, e.ptm("circle")), null, 16, cw)
    ], 16))
  ], 16);
}
const jm = /* @__PURE__ */ $t(uw, [["render", dw]]);
function Ed(e) {
  const t = Number.parseFloat(e);
  return Number.isFinite(t) ? t : 0;
}
function Fm(e) {
  const t = Ki(Ed(e.hexagon_diameterguide), e.cylinder_hexagonguide);
  return {
    dHexagon: t,
    lCut: Ki(Ed(e.cut_sizeguide), e.double_cutguide),
    cylinderShape: Gl(e.cylinder_hexagonguide) || t < 0,
    lockDistance: Number(Gl(e.lock_sleeve_distance)),
    customSleeveSupport: Gl(e.custom_sleeve_support)
  };
}
const pw = (e) => {
  if (!e)
    return {};
  try {
    return JSON.parse(e);
  } catch (t) {
    return console.warn("Failed to parse attachment jsonData", t), {};
  }
}, sr = (e, t) => {
  if (!e || !t)
    return null;
  const n = e.value, a = pw(n.jsonData), o = Number(a.color ?? 0), l = Number(a.connector_height ?? 0), s = Number(a.angle ?? 0), i = Number(a.rotation_z ?? 0), c = new Int8Array(t);
  return {
    abutmentSellingCode: n.sellingCode ?? "",
    angle: s,
    connectorHeight: l,
    fileName: "",
    rotationZ: i,
    color: o,
    guid: n.uuid ?? "",
    manufacturerName: n.manufacturerName ?? "",
    modelName: "",
    name: n.name ?? "",
    stlFile: {
      fileName: "",
      data: c,
      fileSize: c.length
    }
  };
};
function ls(e) {
  var l, s;
  const t = (l = e.sleeve) == null ? void 0 : l.value, n = (s = e.implant) == null ? void 0 : s.value;
  if (!t || !n) return !1;
  const a = n.sleeveIds ?? [], o = t.id;
  return !!(n.defaultSleeveId !== void 0 && n.defaultSleeveId === o || a.includes(o));
}
function Ur() {
  return [
    { name: "Face Scan", code: 0 },
    { name: "Marker Scan", code: 1 },
    { name: "Anatomy", code: 2 },
    { name: "Antagonist", code: 3 },
    { name: "Waxup-Prosthesis", code: 4 },
    { name: "Antagonist Waxup", code: 5 },
    { name: "Bone Surface", code: 6 },
    { name: "Bone Graft", code: 7 },
    { name: "Surgical Guide", code: 8 },
    { name: "Bone Reduction Guide", code: 9 },
    { name: "Acrylic Flange", code: 10 },
    { name: "Bar", code: 11 },
    { name: "Generic", code: 12 },
    { name: "Movement Scan Marker", code: 13 },
    { name: "Other", code: 14 }
  ];
}
function Nx() {
  return Ur().length > 0 ? Ur()[0] : { name: "Face Scan", code: 0 };
}
function mw(e, t, n, a, o) {
  var h, I, m, S, E;
  if (!e.implant || !e.implantData)
    return null;
  const l = new Int8Array(e.implantData), s = {
    color: parseInt(e.implant.value.color || "") || 0,
    diameter: ki(parseFloat(e.implant.value.diameter) || 0),
    guid: e.implant.value.uuid || "",
    implantConnectorHeight: ki(parseFloat(e.implant.value.connector_height) || 0),
    implantFileName: "",
    implantOriginalName: e.implant.value.name || "",
    length: ki(parseFloat(e.implant.value.length) || 0),
    manufacturerName: ((h = e.manufacturer) == null ? void 0 : h.name) || "",
    modelName: ((I = e.model) == null ? void 0 : I.name) || "",
    name: t,
    nonSymmetric: parseInt(e.implant.value.non_symmetric) || 0,
    orientation: 0,
    sameManufacturerImplants: "",
    sellingCode: e.implant.value.sellingCode || "",
    objectName: t,
    displayText: "",
    objectType: Le._IMPLANT,
    objectSubType: Le._NONE,
    fileSha: "",
    stlFile: {
      fileName: "",
      data: l,
      fileSize: l.length
    },
    plyFilename: "",
    stlSuffix: "",
    connectionSides: e.implant.value.connection_sides
  }, i = Lp();
  if (i.color = Yo(parseInt(e.implant.value.color ?? "")), i.origin = n ?? [0, 0, 0], i.viewUp = o ?? [0, 1, 0], i.normal = a ?? [0, 0, 1], i.tangent = [0, 0, 0], i.name = t, i.objectType = Le._IMPLANT, i.objectSubType = Le._NONE, i.implantInfo = s, e.abutment && e.abutmentData) {
    const g = new Int8Array(e.abutmentData), v = {
      abutmentSellingCode: e.abutment.value.sellingCode,
      angle: e.abutment.value.angle || 0,
      connectorHeight: e.abutment.value.connector_height,
      fileName: "",
      rotationZ: e.abutment.value.rotation_z || 0,
      color: e.abutment.value.color || 0,
      guid: e.abutment.value.uuid || "",
      manufacturerName: ((m = e.abManufacturer) == null ? void 0 : m.value.name) || "",
      modelName: ((S = e.abModel) == null ? void 0 : S.value.name) || "",
      name: e.abutment.value.name,
      stlFile: {
        fileName: "",
        data: g,
        fileSize: g.length
      }
    };
    i.abutment = v, i.abutmentColor = [...Yo(e.abutment.value.color), 255], i.rotation = v.rotationZ;
  } else
    i.abutment = void 0;
  const c = sr(e.scanAbutment, e.scanAbutmentData);
  c ? (i.scanAbutment = c, i.scanAbutmentColor = [...Yo(c.color), 255]) : i.scanAbutment = void 0;
  const u = sr(e.secondaryAbutment, e.secondaryAbutmentData);
  u ? (i.secondaryAbutment = u, i.secAbutmentColor = [...Yo(u.color), 255]) : i.secondaryAbutment = void 0;
  const p = sr(e.secondaryScanAbutment, e.secondaryScanAbutmentData);
  p ? (i.secondaryScanAbutment = p, i.secScanAbutmentColor = [...Yo(p.color), 255]) : i.secondaryScanAbutment = void 0;
  let b = null;
  if (e.sleeve && e.sleeveManufacturer) {
    const g = ls(e), v = e.sleeveData ? new Int8Array(e.sleeveData) : new Int8Array(), T = (v == null ? void 0 : v.length) || 0, R = e.sleeveNegativeData ? new Int8Array(e.sleeveNegativeData) : new Int8Array(), L = (R == null ? void 0 : R.length) || 0;
    b = {
      // implant: false,
      manufacturerName: ((E = e.sleeveManufacturer) == null ? void 0 : E.name) ?? "",
      modelName: e.sleeve.value.name,
      sellingCode: e.sleeve.value.sellingCode,
      dExternal: parseFloat(e.sleeve.value.dextsleeve),
      dInternal: parseFloat(e.sleeve.value.dintsleeve),
      lSleeve: parseFloat(e.sleeve.value.lslsleeve),
      lLip: parseFloat(e.sleeve.value.lip_heightguide),
      ...Fm(e.sleeve.value),
      reductionSystemSize: parseFloat(e.sleeve.value.reductionsystemsleeve),
      rotationAll: parseFloat(e.sleeve.value.rotation_allguide),
      rotationCut: parseFloat(e.sleeve.value.rotation_cutguide),
      originalDistanceFromImplant: parseFloat(e.sleeve.value.hslsleeve),
      distanceFromImplant: parseFloat(e.sleeve.value.hslsleeve),
      drillLengthSizes: e.sleeve.value.drill_lenght_sizes ?? "",
      originalName: _p(e.sleeveManufacturer.name, e.sleeve.name),
      stlData: e.sleeveData ? {
        fileName: "",
        data: v,
        fileSize: T
      } : void 0,
      stlNegativeData: e.sleeveNegativeData ? {
        fileName: "",
        data: R,
        fileSize: L
      } : void 0,
      stlFileGuid: e.sleeve.value.stl_guid ?? T ? e.sleeve.value.s3ObjectRef : "",
      stlFileNegativeGuid: e.sleeve.value.stl_negative_guid ?? L ? e.sleeve.value.inverses3ObjectRef : "",
      connectionIndex: 0,
      // TODO add from library!!!
      referencedSleeve: g ? 1 : 0
    }, !b || (!b.dInternal || !b.dExternal && !b.dHexagon || !b.lSleeve) && !(b != null && b.stlData) ? (console.warn("error in sleeve data, sleeve data", b), b = null) : i.sleeveInfo = b;
  }
  if (e.sleeve && e.sleeveManufacturer) {
    const g = ls(e);
    i.sleeveManuallyChanged = g ? 0 : 1;
  }
  let f = null;
  if (e.implantExtrusion) {
    let g = e.implantExtrusion.value.doublecutmodel, v = e.implantExtrusion.value.cutsizemodel;
    g && (v = -Math.abs(v)), f = {
      name: e.implantExtrusion.value.name,
      d1Model: e.implantExtrusion.value.d1model,
      d2Model: e.implantExtrusion.value.d2model,
      l1Model: e.implantExtrusion.value.l1model,
      l2Model: e.implantExtrusion.value.l2model,
      cutSizeModel: v,
      bottomExtrusionRModel: e.implantExtrusion.value.bottomextrusionrmodel,
      support_lenght: 30,
      supportRModel: e.implantExtrusion.value.supportrmodel,
      base_lenght: 40,
      rotation_cutModel: e.implantExtrusion.value.rotation_cutmodel,
      stlFileGuid: e.implantExtrusion.value.stl_file_guid && e.implantExtrusion.value.stl_file_guid.length ? e.implantExtrusion.value.stl_file_guid : void 0,
      s3ObjectRef: e.implantExtrusion.value.s3ObjectRef,
      uuid: e.implantExtrusion.value.uuid || ""
    }, e.implantExtrusionData && e.implantExtrusionData.then((T) => {
      var C, A;
      const R = new Int8Array(T), L = R.length || 0;
      f && (f.stlData = {
        fileName: "",
        data: R,
        fileSize: L
      }, f.stlFileGuid = ((C = e.implantExtrusion) == null ? void 0 : C.value.stl_file_guid) ?? L ? (A = e.implantExtrusion) == null ? void 0 : A.value.s3ObjectRef : "");
    }), i.implantModel = f ?? void 0;
  } else
    i.implantModel = void 0;
  return i;
}
const fw = { key: 0 }, gw = { class: "text-14 mr-1" }, hw = { class: "text-14" }, bw = { class: "text-14 whitespace-nowrap" }, vw = /* @__PURE__ */ qe({
  __name: "IPDataImportDialog",
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), { t: a } = Yt(), o = n.value.data, l = t, s = F(o.modelValue), i = F(
      3
      /* INIT */
    ), c = mi(), u = Jn(), p = Ur(), b = F(p.find((U) => U.name === o.modelValue.name) ?? { name: "Face Scan" }), f = `${Hi},${wp}`, h = F([]), I = F(null), m = F(null), S = F([]), E = F(0);
    let g = o.context;
    const v = [".stl", ".ply", ".obj"], T = Te(() => {
      var re;
      const U = ((re = g.projectInfo) == null ? void 0 : re.projectFileList) ?? [], ie = /* @__PURE__ */ new Map();
      return U.forEach((q) => {
        var _e;
        const De = ((_e = q.name) == null ? void 0 : _e.toLowerCase()) ?? "";
        v.some((xe) => De.endsWith(xe)) && ie.set(q.name, q);
      }), [...ie.values()];
    }), R = async () => {
      const U = m.value;
      if (U) {
        i.value = 0;
        try {
          const { data: ie } = await u.getFile(o.patientName, U.name);
          S.value = [new File([ie], U.name, { type: "application/octet-stream", lastModified: Date.now() })], E.value++, i.value = 3;
        } catch (ie) {
          i.value = 3, Sp(a("shared.error"), ie);
        }
      }
    }, L = F(null), C = F(1);
    let A = Te(() => C.value === 1), j = Te(() => C.value === 0);
    const N = (U) => {
      C.value = U ? 1 : 0, L.value = null;
    }, x = () => {
      C.value = 2;
    }, z = Te(
      () => o.existingObjects.map((U) => ({
        label: `Same as: ${U.getGUIName()}`,
        name: U.getGUIName()
      }))
    ), X = Te(() => i.value === 3 ? "w-full" : ""), H = Te(() => !(i.value === 1 || i.value === 2)), M = Te(() => h.value.length > 0), te = (U, ie) => {
      i.value = 4, h.value = U, I.value = ie && ie.length ? ie[0] : null, se();
    }, ne = () => {
      h.value = [], i.value = 3;
    }, W = () => {
      m.value = null, S.value = [];
    }, se = async () => {
      var ie, re;
      let U = zn(I.value) ?? void 0;
      if (!U && h.value.length && (U = await vs(h.value, g, b.value.name, !1)), U && L.value != null) {
        const q = zn(o.existingObjects.find((De) => {
          var _e;
          return De.getGUIName() == ((_e = L.value) == null ? void 0 : _e.name);
        }));
        q && (U.setMatrix(q.getMatrix()), (ie = g.toolManager.matchingTool) == null || ie.endMatching(!0), (re = g.toolManager.matchingTool) == null || re.apply(!0, !0));
      }
      s.value.name = b.value.name, C.value == 1 ? s.value.position = Wn.MATCHING : C.value == 0 ? s.value.position = Wn.KEEP_ORIGINAL_POSTION : C.value == 2 && (s.value.position = Wn.SAME_AS), s.value.sameAs = L.value ? "Same as selected" : null, U && (s.value.id = U.id), g.sceneRepaint(), o.context && o.context.objects.clearTmpStls(), l("close", s.value), s.value.position == Wn.MATCHING ? n.value.close() : ne(), I.value = null;
    }, be = async () => {
      i.value = 0;
      const U = g.objects.findStlByName(b.value.name);
      U ? c.require({
        message: a("implant-planner.deleteOldObjectPrompt"),
        header: a("implant-planner.deleteObject"),
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          U.delete(), await se(), c.close();
        },
        reject: async () => {
          b.value.name != "Anatomy" ? await se() : (s.value.position = Wn.KEEP_ORIGINAL_POSTION, l("close", s.value)), c.close();
        }
      }) : await se();
    }, Re = () => {
      o.context && o.context.objects.clearTmpStls(), l("close"), n.value.close();
    };
    return (U, ie) => {
      const re = jm;
      return H.value ? (O(), J("div", fw, [
        d(r(Be), { class: "gap-4" }, {
          default: w(() => [
            d(r(at), {
              class: "gap-4",
              style: { width: "25%" }
            }, {
              default: w(() => [
                y("span", gw, V(U.$t("implant-planner.objectName")), 1),
                d(r(Pn), {
                  modelValue: b.value,
                  "onUpdate:modelValue": ie[0] || (ie[0] = (q) => b.value = q),
                  options: r(p),
                  class: "grow w-full items-center",
                  "data-cy": "objectNameSelect",
                  "option-label": "name"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            d(r(at), { class: "gap-4 grow" }, {
              default: w(() => [
                y("span", hw, V(U.$t("implant-planner.objectPosition")), 1),
                d(r(Be), { class: "gap-2" }, {
                  default: w(() => [
                    d(r(Ce), {
                      toggled: r(A),
                      label: U.$t("implant-planner.matching"),
                      "data-cy": "matching",
                      onClick: ie[1] || (ie[1] = (q) => N(!0)),
                      style: { flex: "1 1 0", "min-width": "fit-content" }
                    }, null, 8, ["toggled", "label"]),
                    d(r(Ce), {
                      toggled: r(j),
                      label: U.$t("implant-planner.keepOriginalPosition"),
                      "data-cy": "keepOriginalPosition",
                      onClick: ie[2] || (ie[2] = (q) => N(!1)),
                      style: { flex: "1 1 0", "min-width": "fit-content" }
                    }, null, 8, ["toggled", "label"]),
                    d(r(Pn), {
                      modelValue: L.value,
                      "onUpdate:modelValue": ie[3] || (ie[3] = (q) => L.value = q),
                      options: z.value,
                      class: "flex-auto items-center",
                      "option-label": "label",
                      placeholder: U.$t("implant-planner.sameAs"),
                      style: Tt([{
                        background: L.value ? "var(--p-primary-color) !important" : ""
                      }, { flex: "2 1 0", "min-width": "fit-content" }]),
                      onChange: x
                    }, null, 8, ["modelValue", "options", "placeholder", "style"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(r(Ee), { class: "w-full mt-4 mb-2 items-center justify-center" }, {
          default: w(() => [
            i.value === 0 ? (O(), he(r(Ee), {
              key: 0,
              class: "w-full justify-center items-center",
              style: { height: "400px" }
            }, {
              default: w(() => [
                d(re, {
                  style: { width: "100px", height: "100px" },
                  animationDuration: ".75s"
                })
              ]),
              _: 1
            })) : ue("", !0),
            Pt(y("div", {
              class: He(X.value)
            }, [
              T.value.length ? (O(), he(r(Be), {
                key: 0,
                class: "gap-2 px-2 pb-2 items-center"
              }, {
                default: w(() => [
                  y("span", bw, V(U.$t("weblink.orderAttachments")), 1),
                  d(r(Pn), {
                    modelValue: m.value,
                    "onUpdate:modelValue": ie[4] || (ie[4] = (q) => m.value = q),
                    options: T.value,
                    "option-label": "name",
                    placeholder: U.$t("shared.select"),
                    class: "grow items-center",
                    "data-cy": "orderAttachmentSelect",
                    onChange: R
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              })) : ue("", !0),
              (O(), he(r(ql), {
                key: E.value,
                inputFiles: S.value,
                dropArea: !0,
                selectFilesBtn: !0,
                selectFolderBtn: !0,
                accept: f,
                context: r(g),
                objectName: b.value.name,
                singleSelection: !0,
                embedded: !0,
                importTmpStls: !0,
                showTypeColumn: !1,
                hideTreeWhenNoFolders: !0,
                showAccept: !0,
                onFilesCleared: W,
                onUploadFiles: te
              }, null, 8, ["inputFiles", "context", "objectName"]))
            ], 2), [
              [
                sn,
                i.value !== 0
                /* UPLOADING_OBJECT */
              ]
            ])
          ]),
          _: 1
        }),
        Pt(d(r(Ee), { class: "p-dialog-footer justify-center" }, {
          default: w(() => [
            M.value ? (O(), he(r(la), {
              key: 0,
              class: "mt-6",
              label: U.$t("implant-planner.add"),
              "data-cy": "importData",
              onClick: be
            }, null, 8, ["label"])) : ue("", !0),
            d(r(ya), {
              class: "mt-6",
              label: U.$t("shared.cancel"),
              onClick: Re
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 512), [
          [
            sn,
            i.value !== 0
            /* UPLOADING_OBJECT */
          ]
        ])
      ])) : ue("", !0);
    };
  }
}), yw = /* @__PURE__ */ $t(vw, [["__scopeId", "data-v-f69e7dd9"]]);
function Ra() {
  const e = Th();
  return On(() => e.cleanupAll()), e;
}
const _w = { class: "text-2xl" }, ww = {
  key: 0,
  class: "flex min-h-0",
  style: { overflowY: "auto", borderRadius: "16px" }
}, Sw = {
  key: 3,
  style: { "margin-top": "auto" }
}, Iw = {
  key: 1,
  class: "mt-1 ml-2"
}, Au = /* @__PURE__ */ qe({
  __name: "IPDataImportWizard",
  props: {
    patientName: {}
  },
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Yt(), a = Ra(), o = e, l = t, s = Aa(), i = F(""), c = F(!1), u = F(!1), p = F(!1), b = F(!1), f = F(!1), h = F(!1), I = F(!1), m = F(!0), S = F(!0), E = F(!1), g = F(0);
    let v;
    const T = () => {
      !m.value && !S.value ? M.disabled = !1 : M.disabled = !0, !m.value || !S.value ? C.disabled = !1 : C.disabled = !0;
    };
    let R = et({
      disabled: S
    }), L = et({
      disabled: m
    }), C = et({
      disabled: !0
    }), A = et({
      disabled: !1
    }), j = et({
      disabled: !1
    }), N = et({
      disabled: !0
    }), x = et({
      disabled: !0
    }), z = et({
      disabled: !0
    }), X = F(!1), H = et({
      disabled: !1
    }), M = et({
      disabled: !0
    }), te = et({
      disabled: !0
    }), ne = et({
      disabled: !0
    }), W = et({
      visible: !1,
      name: "Face Scan",
      position: Wn.MATCHING,
      sameAs: "Same as...",
      id: ""
    });
    const se = {
      async hideObject(B) {
        await Re(B);
      },
      async toggleObjectPlacement(B) {
        await be(B);
      },
      async toogleObjectVisibility(B) {
        await Re(B);
      },
      async deleteObject(B) {
        await U(B);
      },
      async editNotes(B) {
        await ie(B);
      },
      async changeColor(B) {
        await re(B);
      },
      async changeTransparency(B, ye) {
        await q(B, ye);
      },
      async toggleWireframe(B) {
        await De(B);
      },
      async matchObject(B) {
        await _e(B);
      },
      async renameObject(B) {
        await xe(B);
      },
      async changeObjectType(B, ye) {
        await K(B, ye);
      },
      async duplicateObject(B) {
        await k(B);
      },
      async calculateVolume(B) {
        await Ae(B);
      }
    }, be = (B) => {
      v.objects.toggleObjectPlacement(B);
    }, Re = async (B) => {
      var Xe;
      const ye = (Xe = v.objects.stls.get(B)) == null ? void 0 : Xe.getVisibility();
      ye !== void 0 && v.objects.setObjectVisibility(B, !ye);
    }, U = async (B) => {
      v.objects.removeObject(B, Le._STL_OBJECT), v.sceneRepaint();
    }, ie = async (B) => {
      const ye = v.getModalsInstance(), Xe = v.objects.stls.get(B);
      if (Xe) {
        const Ze = Xe.getNotes();
        ye.showTextInputModal(n("shared.notes"), Ze).then((lt) => {
          lt !== null && lt !== Ze && Xe.setNotes(lt);
        });
      }
    }, re = async (B) => {
      const ye = v.getModalsInstance(), Xe = v.objects.getStlObject(B);
      if (Xe) {
        const Ze = Xe.getColor(), lt = Op(Ze);
        ye.showColorPickerModal(n("shared.setItemColor"), lt).then((ce) => {
          ce !== null && ce !== lt && (v.objects.setObjectColor(B, ce), v.repaint());
        });
      }
    }, q = async (B, ye) => {
      v.objects.setObjectTransparency(B, ye);
    }, De = async (B) => {
      v.objects.toggleObjectWireframe(B);
    }, _e = async (B) => {
      mt(B);
    }, xe = async (B) => {
      const ye = v.objects.getStlObject(B);
      if (!ye)
        return console.warn("create dropdown: object not found"), null;
      const Xe = v.getModalsInstance(), Ze = ye.getDisplayText();
      Xe.showTextInputModal(n("medic-web-engine.newObjectName"), Ze).then((lt) => {
        lt !== null && lt !== Ze && v.objects.setSTLName(B, lt);
      });
    }, k = async (B) => {
      v.objects.duplicateSTL(B);
    }, K = async (B, ye) => {
      v.objects.setSTLType(B, ye), Ne(), await G();
    }, Ae = async (B) => {
      v.objects.getObjectVolume(B);
    }, me = F([]), Ne = () => {
      me.value = v.objects.getStlObjectList();
    }, Ge = F([]), Ue = F(Math.random()), Ke = F(), st = F(0);
    ot(
      Ue,
      (B, ye) => {
        ye !== B && fn(() => {
          var Ze, lt;
          const Xe = (lt = (Ze = Ke.value) == null ? void 0 : Ze.$el.firstElementChild) == null ? void 0 : lt.firstElementChild;
          Xe && (Xe.scrollTop = st.value);
        });
      },
      { immediate: !1 }
    );
    const G = async () => {
      var Xe, Ze;
      const B = (Ze = (Xe = Ke.value) == null ? void 0 : Xe.$el.firstElementChild) == null ? void 0 : Ze.firstElementChild;
      B && (st.value = B.scrollTop);
      const ye = [...Ge.value];
      Ge.value = [];
      for (const lt of me.value) {
        if (lt.type == Le._STL_TOOTH)
          continue;
        const ce = ye.map((_t) => _t.id).indexOf(lt.id);
        let Se = "";
        ce != -1 && (Se = ye[ce].imgSrc);
        const rt = v.viewConfiguration.colorScheme.get();
        Ge.value.push({
          id: lt.id,
          header: lt.getDisplayText() != "" ? lt.getDisplayText() + " (" + lt.getName() + ")" : lt.getName(),
          imgSrc: Se != "" ? Se : await Zi(lt, !0, rt) || "",
          isCentered: !1,
          isVisible: lt.getVisibility(),
          isLocked: lt.getLocked(),
          isTracked: lt.isTrackedObject()
        });
      }
      z.disabled = Ge.value.length < 2, Ue.value = Math.random();
    }, P = F(), de = (B) => {
      console.log("itemSelected item: ", B), P.value = B.id, !b.value && (N.disabled = !1, x.disabled = !1, ne.disabled = !1);
    }, fe = async () => {
      I.value = !I.value, v.toolManager.matchingTool && (v.toolManager.matchingTool.enabled = I.value);
    }, ke = async () => {
      var B, ye;
      c.value || h.value || (Ct(), await ((B = v.toolManager.matchingTool) == null ? void 0 : B.registerSTLAutomatic()), g.value = ((ye = v.toolManager.matchingTool) == null ? void 0 : ye.getDelta()) || 0, E.value = !0);
    }, le = () => {
      var B, ye;
      h.value || ((B = v.toolManager.matchingTool) == null || B.registerSTL(), te.disabled = !((ye = v.toolManager.matchingTool) != null && ye.bestFitFlag.get()));
    }, pe = async () => {
      var B, ye;
      await ((B = v.toolManager.matchingTool) == null ? void 0 : B.registerBestFit()), g.value = ((ye = v.toolManager.matchingTool) == null ? void 0 : ye.getDelta()) || 0, E.value = !0;
    }, Z = () => {
      var B;
      (B = v.toolManager.matchingTool) == null || B.removeLastPickedDICOMPoint();
    }, ee = () => {
      var B;
      (B = v.toolManager.matchingTool) == null || B.removeLastPickedSTLPoint();
    }, $ = () => {
      var B;
      (B = v.toolManager.matchingTool) == null || B.removeAllPoints();
    }, _ = async () => {
      var B;
      (B = v.toolManager.matchingTool) == null || B.cancel(), Ct(), h.value = !1, u.value = !1, Ne(), await G();
    }, D = () => {
      var B;
      (B = v.toolManager.matchingTool) == null || B.apply(), Ct(), h.value = !1, u.value = !1;
    }, Y = () => {
      p.value = !p.value;
    }, Q = F(!1), ae = () => {
      if (p.value = !1, !v.objects.getStlObject(P.value))
        return null;
      b.value = !0, Q.value = !0;
    }, ge = () => {
      p.value = !1, f.value = !0;
    }, Fe = () => {
      Q.value = !1, b.value = !1;
    }, Me = () => {
      Fe();
    }, je = () => {
      f.value = !1, Ne(), G();
    }, dt = () => {
      h.value = !0, u.value = !0, p.value = !1, v.nextPrevVisible.set(!1);
    }, vt = (B, ye) => {
      const Xe = qi.clone(B.getMatrix()), Ze = qi.clone(ye);
      let lt = 0, ce = 0;
      for (let rt = 0; rt < 16; rt++)
        lt += Xe[rt], ce += Ze[rt];
      if (Math.abs(lt - ce) < 1e-6) {
        console.log("Adding undo skipped - sum of elements is equal");
        return;
      }
      const Se = new Wl({
        onUndo: () => {
          B.setMatrix(Xe), (B.type == Le._STL_OBJECT || B.type === Le._STL_TEETH_MODEL || B.type === Le._STL_PROSTHESIS || B.type == Le._STL_TOOTH) && B.updateCrosssections(), B.update3dInfo(), v.sceneRepaint();
        },
        onRedo: () => {
          console.log("Matching same as onRedo", Ze), B.setMatrix(Ze), (B.type == Le._STL_OBJECT || B.type === Le._STL_TEETH_MODEL || B.type === Le._STL_PROSTHESIS || B.type == Le._STL_TOOTH) && B.updateCrosssections(), B.update3dInfo(), v.sceneRepaint();
        }
      });
      Se.onRedo(), v.undoManager.pushPop(B, Se, "Move Object", zl.NONE);
    }, mt = (B, ye = !0) => {
      const Xe = v.objects.stls.get(B);
      if (Xe && !Xe.IsVolume()) {
        const Ze = () => {
          var ce;
          h.value = !1, Xe.setVisibility(!1);
          const lt = v.objects.addMatchingSTL(Xe, {
            ignoreScaling: !1,
            ply: Xe.isPly
          });
          (ce = v.toolManager.matchingTool) == null || ce.initializeSTLView(B, lt, ye), u.value = !0, i.value = P.value, Ue.value = Math.random(), Ct();
        };
        ye ? s.open(sw, {
          props: {
            closable: !0,
            modal: !0,
            header: n("implant-planner.matchingOptions"),
            contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
          },
          data: {
            nameO: Xe.getGUIName(),
            existingObjects: me.value
          },
          emits: {
            onClose: (lt) => {
              if (console.log("OnCLose ", lt.state, lt.name), lt.state != Wn.KEEP_ORIGINAL_POSTION)
                if (lt.state == Wn.SAME_AS) {
                  const ce = me.value.find((Se) => Se.getGUIName() == lt.name);
                  ce && vt(Xe, ce.getMatrix());
                } else
                  Ze();
            }
          }
        }) : Ze(), p.value = !1;
      } else
        console.log("STL object with id not found");
    }, kt = async () => {
      Ne(), await G(), W.position == Wn.MATCHING && mt(W.id, !1);
    }, Ct = () => {
      I.value = !1, v.toolManager.matchingTool && (v.toolManager.matchingTool.enabled = I.value), X.value = I.value, te.disabled = !0, E.value = !1;
    };
    let ft = et({
      value: 2,
      minValue: 0.1,
      maxValue: 10,
      step: 0.1
    });
    ot(ft, () => {
      var B;
      ft.value && ((B = v.toolManager.matchingTool) == null || B.setSurrounding(ft.value));
    });
    const Vt = Te(() => Ge.value.length > 0), Wt = Te(() => "max-height: 65vh"), jn = () => {
      s.open(yw, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.matchingOptions"),
          style: { width: "90vw" }
          // , height: "90vh"
        },
        data: {
          patientName: o.patientName,
          existingObjects: me.value,
          modelValue: W,
          context: v
        },
        emits: {
          onClose: () => {
            kt();
          }
        }
      });
    };
    Mt(async () => {
      v = pn(), c.value = !!(v.license.versionType & Va.START), Ne(), await G(), a.watch(v.getState().object3DInfos, async () => {
        Ne(), await G();
      }), v.toolManager.matchingTool && (a.watch(v.toolManager.matchingTool.stlNumOfPoints, () => {
        var ye;
        const B = (ye = v.toolManager.matchingTool) == null ? void 0 : ye.stlNumOfPoints.get();
        B && B > 0 ? m.value = !1 : m.value = !0, T();
      }), a.watch(v.toolManager.matchingTool.dicomNumOfPoints, () => {
        var ye;
        const B = (ye = v.toolManager.matchingTool) == null ? void 0 : ye.dicomNumOfPoints.get();
        B && B > 0 ? S.value = !1 : S.value = !0, T();
      })), a.onEvent(v.objects.object3DColorChangedEvent, async (B) => {
        const ye = Ge.value.findIndex((Xe) => Xe.id === B);
        if (ye !== -1) {
          const Xe = v.objects.stls.get(B);
          if (Xe) {
            const Ze = v.viewConfiguration.colorScheme.get();
            Ge.value[ye].imgSrc = await Zi(Xe, !0, Ze) || "";
          }
        }
        Ue.value = Math.random();
      }), v.startMatchingWithObjectId && (mt(v.startMatchingWithObjectId), v.startMatchingWithObjectId = null);
    }), On(() => {
      v.toolManager.setTool(un.NONE, Qt.SECONDARY);
    });
    const ra = () => {
      console.log("finalizeSTLonSTL"), Ct(), h.value = !1, u.value = !1, v.nextPrevVisible.set(!0);
    };
    return (B, ye) => {
      const Xe = co;
      return O(), J(ze, null, [
        !h.value && !f.value && !Q.value ? (O(), J(ze, { key: 0 }, [
          d(jo, {
            onHideWizard: ye[0] || (ye[0] = (Ze) => l("hideWizard"))
          }, {
            default: w(() => [
              yt(V(B.$t("implant-planner.importDObjects")), 1)
            ]),
            _: 1
          }),
          d(bl, {
            style: Tt({ overflowY: b.value ? void 0 : "auto", height: b.value ? void 0 : "100% !important" })
          }, {
            default: w(() => [
              !h.value && !u.value && !b.value ? (O(), J(ze, { key: 0 }, [
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: B.$t("shared.import"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "importObject",
                      onClick: jn
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                d(r(at), null, {
                  default: w(() => [
                    d(r(Be), null, {
                      default: w(() => [
                        d(Xe, null, {
                          default: w(() => [
                            yt(V(B.$t("shared.dObjects")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64)) : u.value ? (O(), he(r(Be), { key: 1 }, {
                default: w(() => [
                  y("span", _w, V(B.$t("implant-planner.matchingStlOnDicom")), 1)
                ]),
                _: 1
              })) : ue("", !0),
              h.value ? ue("", !0) : (O(), J(ze, { key: 2 }, [
                Vt.value ? (O(), J("div", ww, [
                  d(r(Ee), { class: "h-full w-full justify-center" }, {
                    default: w(() => [
                      (O(), he(r(th), {
                        ref_key: "scrollableDiv",
                        ref: Ke,
                        class: "w-full",
                        heightStyle: Wt.value,
                        items: Ge.value,
                        showItemsDropdown: b.value || u.value,
                        hideDropdown: u.value,
                        callbacks: b.value || u.value ? void 0 : se,
                        forceSelected: i.value,
                        onPickListItemSelected: de,
                        key: Ue.value
                      }, null, 8, ["heightStyle", "items", "showItemsDropdown", "hideDropdown", "callbacks", "forceSelected"]))
                    ]),
                    _: 1
                  })
                ])) : ue("", !0)
              ], 64)),
              !u.value && !Q.value && Vt.value ? (O(), J("div", Sw, [
                d(r(at), { class: "gap-2 mb-2" }, {
                  default: w(() => [
                    ue("", !0),
                    d(r(Ce), {
                      disabled: r(N).disabled,
                      onClick: ye[2] || (ye[2] = (Ze) => ae()),
                      label: B.$t("shared.edit"),
                      class: He("w-full web-rg-wiz-btn")
                    }, null, 8, ["disabled", "label"]),
                    d(r(Ce), {
                      disabled: r(x).disabled,
                      toggled: p.value,
                      "data-cy": "matching",
                      onClick: ye[3] || (ye[3] = (Ze) => Y()),
                      label: B.$t("implant-planner.matching"),
                      class: He("w-full web-rg-wiz-btn")
                    }, null, 8, ["disabled", "toggled", "label"]),
                    d(r(Ce), {
                      disabled: r(z).disabled,
                      onClick: ye[4] || (ye[4] = (Ze) => ge()),
                      label: B.$t("implant-planner.booleanOperations"),
                      class: He("w-full web-rg-wiz-btn")
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                })
              ])) : ue("", !0),
              p.value ? (O(), he(r(Ee), {
                key: 4,
                class: "flex-row gap-2 mb-2"
              }, {
                default: w(() => [
                  d(r(Ce), {
                    disabled: r(A).disabled,
                    "data-cy": "matchingSTLonDICOM",
                    onClick: ye[5] || (ye[5] = (Ze) => mt(P.value)),
                    label: B.$t("implant-planner.stlOnDicom"),
                    class: He("web-rg-wiz-btn grow"),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["disabled", "label"]),
                  d(r(Ce), {
                    disabled: r(j).disabled,
                    "data-cy": "matchingSTLonSTL",
                    onClick: ye[6] || (ye[6] = (Ze) => dt()),
                    label: B.$t("implant-planner.stlOnStl"),
                    class: He("web-rg-wiz-btn grow"),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["disabled", "label"])
                ]),
                _: 1
              })) : ue("", !0),
              u.value ? (O(), J(ze, { key: 5 }, [
                d(r(Be), null, {
                  default: w(() => [
                    d(Xe, null, {
                      default: w(() => [
                        yt(V(B.$t("implant-planner.matchingOptions")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(at), { class: "gap-2" }, {
                  default: w(() => [
                    d(r(Ce), {
                      icon: "pi pi-sparkles",
                      iconRight: !0,
                      disabled: r(H).disabled || c.value,
                      onClick: ye[7] || (ye[7] = (Ze) => ke()),
                      label: B.$t("implant-planner.assisted"),
                      class: "web-rg-wiz-btn"
                    }, null, 8, ["disabled", "label"]),
                    d(r(Ce), {
                      togglable: !0,
                      toggled: r(X),
                      "data-cy": "byPoints",
                      onToggledChange: ye[8] || (ye[8] = (Ze) => fe()),
                      label: B.$t("implant-planner.byPoints"),
                      class: "web-rg-wiz-btn"
                    }, null, 8, ["toggled", "label"])
                  ]),
                  _: 1
                }),
                I.value ? (O(), J(ze, { key: 0 }, [
                  d(r(Ee), {
                    class: "w-full",
                    style: { "justify-content": "center" }
                  }, {
                    default: w(() => [
                      d(r(Yi), {
                        modelValue: r(ft).value,
                        "onUpdate:modelValue": ye[9] || (ye[9] = (Ze) => r(ft).value = Ze),
                        min: r(ft).minValue,
                        max: r(ft).maxValue,
                        step: r(ft).step,
                        scrollable: !0,
                        label: B.$t("implant-planner.diameter"),
                        "unit-label": "mm",
                        style: { flex: "1 1 0" }
                      }, null, 8, ["modelValue", "min", "max", "step", "label"])
                    ]),
                    _: 1
                  }),
                  d(r(Ee), { class: "flex-row gap-2" }, {
                    default: w(() => [
                      d(r(Ce), {
                        disabled: r(R).disabled,
                        "data-cy": "removePointDICOM",
                        onClick: Z,
                        label: h.value ? B.$t("implant-planner.removeLeftMarker") : B.$t("implant-planner.removeDicomMarker"),
                        class: He("web-rg-wiz-btn grow"),
                        style: { "font-size": "0.8rem", "white-space": "normal" }
                      }, null, 8, ["disabled", "label"]),
                      d(r(Ce), {
                        disabled: r(L).disabled,
                        "data-cy": "removePointSTL",
                        onClick: ee,
                        label: h.value ? B.$t("implant-planner.removeRightMarker") : B.$t("implant-planner.removeStlMarker"),
                        class: He("web-rg-wiz-btn grow"),
                        style: { "font-size": "0.8rem", "white-space": "normal" }
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  }),
                  h.value ? (O(), he(r(Be), { key: 0 }, {
                    default: w(() => [
                      d(r(Ce), {
                        disabled: r(C).disabled,
                        onClick: $,
                        label: B.$t("implant-planner.clearAllPoints"),
                        class: He("web-rg-wiz-btn grow")
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  })) : ue("", !0),
                  d(r(Be), { class: "mt-2" }, {
                    default: w(() => [
                      d(r(Ce), {
                        disabled: r(M).disabled,
                        "data-cy": "fitPoints",
                        onClick: le,
                        label: B.$t("implant-planner.fitPoints"),
                        class: He("web-rg-wiz-btn grow")
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  }),
                  h.value ? ue("", !0) : (O(), he(r(Be), {
                    key: 1,
                    class: "mt-2"
                  }, {
                    default: w(() => [
                      d(r(Ce), {
                        disabled: r(te).disabled,
                        "data-cy": "bestFit",
                        onClick: pe,
                        label: B.$t("implant-planner.bestFit"),
                        class: He("web-rg-wiz-btn grow")
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  }))
                ], 64)) : ue("", !0),
                E.value ? (O(), J("div", Iw, [
                  y("span", null, V(B.$t("implant-planner.delta")) + " " + V(g.value.toFixed(3)), 1)
                ])) : ue("", !0),
                d(r(Be), {
                  class: "mt-2 gap-2 mb-2",
                  style: { "margin-top": "auto" }
                }, {
                  default: w(() => [
                    d(r(Ce), {
                      "data-cy": "cancelMatching",
                      onClick: ye[10] || (ye[10] = (Ze) => _()),
                      label: B.$t("shared.cancel"),
                      class: He("web-rg-wiz-btn"),
                      style: { flex: "1 1 0" }
                    }, null, 8, ["label"]),
                    d(r(Ce), {
                      "data-cy": "applyMatching",
                      onClick: ye[11] || (ye[11] = (Ze) => D()),
                      label: B.$t("shared.apply"),
                      class: He("web-rg-wiz-btn"),
                      style: { flex: "1 1 0" }
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ], 64)) : ue("", !0)
            ]),
            _: 1
          }, 8, ["style"])
        ], 64)) : !Q.value && !f.value ? (O(), he(aw, {
          key: 1,
          onNextStepNested: ra,
          onPreviousStepNested: ra
        })) : ue("", !0),
        Q.value ? (O(), he(xm, {
          key: 2,
          selectedObjectId: P.value,
          onNextStepNested: Fe,
          onPreviousStepNested: Me
        }, null, 8, ["selectedObjectId"])) : ue("", !0),
        f.value ? (O(), he(ow, {
          key: 3,
          onNextStepNested: je,
          onPreviousStepNested: je
        })) : ue("", !0)
      ], 64);
    };
  }
});
var Fl = /* @__PURE__ */ ((e) => (e[e.MAXILLA = 0] = "MAXILLA", e[e.MANDIBLE = 1] = "MANDIBLE", e))(Fl || {});
function Ew() {
  return {
    curveType: 0,
    panoramicRegion: 0
  };
}
const Ru = /* @__PURE__ */ qe({
  __name: "IPCprSettingsWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Yt(), a = et(Ew()), o = F(!1), l = t, s = mi();
    let i, c;
    i = pn();
    const u = Jn(), b = ml().isSspEnabled(), f = F(!1);
    Mt(() => {
      var x;
      const A = i.getViewWidget(Nn._3D);
      A && A.hideObjectList(!0);
      let j = i.getViewWidget(Nn.CPR);
      j && (c = j);
      const N = c.getCPRType();
      N == an.MAXILLA ? E() : N == an.MANDIBLE && g(), i.objects.hasCPR() && (f.value = !0), i.objects.hasCPR() || (o.value = !0), (x = i.toolManager.cprTool) == null || x.getPointPicker().pointAddedEvent.subscribe(() => {
        i.objects.hasCPR() ? f.value = !0 : f.value = !1;
      });
    }), On(() => {
      try {
        if (i.isDestructed())
          return;
        const A = i.getViewWidget(Nn._3D);
        A && (A.fitZoomToScreen(), A.hideObjectList(!1));
      } catch (A) {
        console.log("error:", A);
      }
    });
    let h = et({
      disabled: !1,
      pressable: !0,
      pressed: a.curveType === Fl.MAXILLA
    }), I = et({
      disabled: !1,
      pressable: !0,
      pressed: a.curveType === Fl.MANDIBLE
    });
    const m = F(!1);
    ot(m, () => {
      console.log("byPointsPressed", m.value), i.toolManager.cprTool && i.toolManager.cprTool.enableEditingCPRByPoints(m.value);
    });
    let S = et({
      disabled: !1,
      pressable: !0,
      toggleable: !0
    });
    const E = () => {
      h.pressed = !0, I.pressed = !1, a.curveType = Fl.MAXILLA, c.setCPRType(an.MAXILLA);
    }, g = () => {
      h.pressed = !1, I.pressed = !0, a.curveType = Fl.MANDIBLE, c.setCPRType(an.MANDIBLE);
    }, v = () => {
      var A;
      (A = i.toolManager.cprTool) == null || A.removeLastPickedPoint();
    }, T = () => {
      var A;
      (A = i.toolManager.cprTool) == null || A.clearAllPoints();
    }, R = () => {
      c.adjustCPRHeight(5);
    }, L = () => {
      c.adjustCPRHeight(-5);
    }, C = async () => {
      const A = async () => {
        var j;
        T(), await ((j = i.toolManager.cprTool) == null ? void 0 : j.automaticCPRLandmarkLocalization(u)), m.value = !0, f.value = !0;
      };
      i.objects.hasCPR() ? s.require({
        message: n("implant-planner.resetAutomaticCprPrompt"),
        header: n("implant-planner.automaticCprLocalization"),
        icon: "pi pi-question-circle",
        accept: async () => {
          await A();
        },
        reject: () => {
          s.close();
        }
      }) : await A();
    };
    return (A, j) => {
      const N = co;
      return O(), J(ze, null, [
        d(r(Gn), {
          visible: o.value,
          "onUpdate:visible": j[2] || (j[2] = (x) => o.value = x),
          closable: !1,
          draggable: !1,
          modal: "",
          header: A.$t("implant-planner.selectPanoRegion"),
          style: { width: "25vw" }
        }, {
          default: w(() => [
            d(r(Ee), { class: "flex-row gap-2 mt-4" }, {
              default: w(() => [
                d(r(Ce), {
                  class: "w-full web-rg-icon-btn",
                  label: A.$t("implant-planner.maxilla"),
                  "data-cy": "selectMaxilla",
                  onClick: j[0] || (j[0] = (x) => [E(), o.value = !1])
                }, null, 8, ["label"]),
                d(r(Ce), {
                  class: "w-full web-rg-icon-btn",
                  label: A.$t("implant-planner.mandible"),
                  "data-cy": "selectMandible",
                  onClick: j[1] || (j[1] = (x) => [g(), o.value = !1])
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(jo, {
          onHideWizard: j[3] || (j[3] = (x) => l("hideWizard"))
        }, {
          default: w(() => [
            yt(V(A.$t("implant-planner.cprSettings")), 1)
          ]),
          _: 1
        }),
        d(bl, null, {
          default: w(() => [
            d(r(Be), null, {
              default: w(() => [
                d(N, null, {
                  default: w(() => [
                    yt(V(A.$t("implant-planner.curveType")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Be), { class: "gap-2" }, {
              default: w(() => [
                d(r(Ce), {
                  disabled: r(h).disabled,
                  toggled: r(h).pressed,
                  label: A.$t("implant-planner.maxilla"),
                  class: He(["web-rg-icon-btn grow"]),
                  "data-cy": "setMaxilla",
                  onClick: E
                }, null, 8, ["disabled", "toggled", "label"]),
                d(r(Ce), {
                  disabled: r(I).disabled,
                  toggled: r(I).pressed,
                  label: A.$t("implant-planner.mandible"),
                  class: He(["web-rg-icon-btn grow"]),
                  "data-cy": "setMandible",
                  onClick: g
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(at), { class: "gap-2" }, {
              default: w(() => [
                d(r(Be), null, {
                  default: w(() => [
                    d(N, null, {
                      default: w(() => [
                        yt(V(A.$t("implant-planner.cprDrawing")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                r(b) ? (O(), he(r(Be), { key: 0 }, {
                  default: w(() => [
                    d(r(Ce), {
                      icon: "pi pi-sparkles",
                      label: A.$t("implant-planner.automaticCprLocalization"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "automaticCPRLocalization",
                      disabled: !r(i).AIEnabled,
                      onClick: C
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })) : ue("", !0),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      id: "btnByPoints",
                      label: A.$t("implant-planner.byPoints"),
                      class: He("w-full web-rg-icon-btn"),
                      toggled: m.value,
                      "onUpdate:toggled": j[4] || (j[4] = (x) => m.value = x),
                      disabled: r(S).disabled,
                      togglable: r(S).toggleable
                    }, null, 8, ["label", "toggled", "disabled", "togglable"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(at), { class: "gap-2" }, {
              default: w(() => [
                d(r(Be), null, {
                  default: w(() => [
                    d(N, null, {
                      default: w(() => [
                        yt(V(A.$t("implant-planner.cprOptions")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: A.$t("implant-planner.deleteLastPoint"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "deleteLastPoint",
                      onClick: v,
                      disabled: !f.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: A.$t("shared.reset"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "reset",
                      onClick: T,
                      disabled: !f.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: A.$t("implant-planner.increasePanoramicRegion"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "increasePanoramicPoint",
                      onClick: R,
                      disabled: !f.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: A.$t("implant-planner.decreasePanoramicRegion"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "decreasePanoramicPoint",
                      onClick: L,
                      disabled: !f.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), Tw = {
  name: "BaseInputText",
  extends: Tu,
  style: qh,
  provide() {
    return {
      $pcInputText: this,
      $parentInstance: this
    };
  }
}, Cw = {
  name: "InputText",
  extends: Tw,
  inheritAttrs: !1,
  methods: {
    onInput(e) {
      this.writeValue(e.target.value, e);
    }
  },
  computed: {
    attrs() {
      return Pe(
        this.ptmi("root", {
          context: {
            filled: this.$filled,
            disabled: this.disabled
          }
        }),
        this.formField
      );
    }
  }
}, Nw = ["value", "disabled", "aria-invalid"];
function Lw(e, t, n, a, o, l) {
  return O(), J("input", Pe({
    type: "text",
    class: e.cx("root"),
    value: e.d_value,
    disabled: e.disabled,
    "aria-invalid": e.$invalid || void 0,
    onInput: t[0] || (t[0] = (...s) => l.onInput && l.onInput(...s))
  }, l.attrs), null, 16, Nw);
}
const Mu = /* @__PURE__ */ $t(Cw, [["render", Lw]]);
function Ow() {
  return {
    nerve: {
      name: "",
      length: 0,
      diameter: 3
    },
    objects: []
  };
}
const Dw = ["data-cy", "onClick"], Aw = { class: "col-4-no-padding" }, Rw = ["src", "alt"], Mw = { class: "col-6-no-padding" }, Pw = { class: "flex flex-col mt-6 ml-6" }, xw = { class: "text-sm" }, jw = { class: "text-sm" }, Fw = { class: "text-sm" }, $w = { class: "text-sm" }, Pu = /* @__PURE__ */ qe({
  __name: "IPNerveDrawingWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const n = et(Ow()), { t: a } = Yt(), o = t;
    let l;
    const s = Jn(), c = ml().isSspEnabled();
    let u, p = !1, b = !0;
    const f = F(!1), h = F(!1), I = F(!1), m = F(an.MANDIBLE), S = Te(() => h.value || I.value || m.value != an.MANDIBLE || !f.value), E = F(Math.random() * 1e3), g = F("ff0000"), v = (k) => k.replace("#", "").toLowerCase(), T = (k) => {
      let K = v(k);
      if (K.length === 3 && (K = K.split("").map((Ge) => Ge + Ge).join("")), K.length !== 6)
        return null;
      const Ae = parseInt(K.slice(0, 2), 16), me = parseInt(K.slice(2, 4), 16), Ne = parseInt(K.slice(4, 6), 16);
      return Number.isNaN(Ae) || Number.isNaN(me) || Number.isNaN(Ne) ? null : [Ae, me, Ne];
    }, R = (k) => k.map(
      (K) => Math.max(0, Math.min(255, Math.round(K))).toString(16).padStart(2, "0")
    ).join(""), L = () => {
      const k = u.getNerveId();
      if (k) {
        const K = l.objects.nerveObjects.get(k);
        if (K != null && K.nerve)
          return K.nerve;
      }
      return (W == null ? void 0 : W.nerve) ?? null;
    }, C = (k) => {
      const K = (k == null ? void 0 : k.getColor()) ?? Tc(l.settings.defaultColors.nerves), Ae = Op(K);
      g.value = R(Ae);
    }, A = (k) => {
      const K = T(k);
      if (!K)
        return;
      g.value = v(k);
      const Ae = Tc(K);
      if (u.setNerveColor(Ae), W != null && W.nerve) {
        W.nerve.setColor(Ae);
        const Ne = ne.value.get(W.id);
        Ne && (Ne.projectNerve.color = K);
      }
      const me = l.objects.nerveObjects.get(u.getNerveId() || "");
      me && (me.projectNerve.color = K), l.repaint();
    };
    Mt(async () => {
      l = pn(), f.value = l.AIEnabled, m.value = l.CPRType;
      const k = l.getViewWidget(Nn._3D);
      k && k.hideObjectList(!0);
      const K = l.toolManager.nerveTool;
      if (K)
        u = K;
      else
        throw new Error(a("medic-web-engine.nerveToolNotFound"));
      ot(
        () => n.nerve.name,
        async () => {
          if (u.setNerveName(n.nerve.name), W) {
            const Ne = ne.value.get(W.id);
            Ne && (Ne.name = n.nerve.name, ne.value.set(W.id, Ne));
            const Ge = l.objects.nerveObjects.get(u.getNerveId() || "");
            Ge && (Ge.name = n.nerve.name, Ge.projectNerve.name = n.nerve.name, l.objects.nerveObjects.set(u.getNerveId() || "", Ge));
          }
        }
      ), N(-1), C(null), W = null, M.disabled = !0, M.pressed = !1, u.takeScreenshotEvent.subscribe(async () => {
        let Ne = u.addNerveToList();
        if (Ne) {
          if (b && Ne.nerve && Ne.projectNerve.points.length > 1) {
            let Ge = await xe(Ne.nerve);
            Ge && (Ne.projectNerve.objectSubType == Le._NERVE_LEFT ? h.value = !0 : Ne.projectNerve.objectSubType == Le._NERVE_RIGHT && (I.value = !0), Ne.nervePreview = Ge);
          } else
            Ne.nervePreview = void 0;
          ne.value.set(Ne.id, Ne), W = Ne, se = Ne.id, n.nerve.length = Ne.length, p = !1, n.nerve.diameter = Ne.nerve.getRadius() * 2;
        }
      }), u.removeObjectEvent.subscribe((Ne) => {
        ne.value.delete(Ne), u.disableEditing();
      }), u.syncWithContext.subscribe(async () => {
        ne.value.clear();
        let Ne = !1, Ge = !1;
        for (let [Ue, Ke] of l.objects.nerveObjects) {
          if (Ke.nerve) {
            let st = await xe(Ke.nerve);
            st && (Ke.nervePreview = st);
          }
          Ke.projectNerve.objectSubType == Le._NERVE_LEFT ? Ge = !0 : Ke.projectNerve.objectSubType == Le._NERVE_RIGHT && (Ne = !0), ne.value.set(Ue, Ke);
        }
        h.value = Ge, I.value = Ne;
      });
      let Ae = !1, me = !1;
      for (let [Ne, Ge] of l.objects.nerveObjects) {
        if (Ge.nerve) {
          let Ue = await xe(Ge.nerve);
          Ue && (Ge.nervePreview = Ue);
        }
        Ge.projectNerve.objectSubType == Le._NERVE_LEFT ? me = !0 : Ge.projectNerve.objectSubType == Le._NERVE_RIGHT && (Ae = !0), ne.value.set(Ne, Ge);
      }
      h.value = me, I.value = Ae;
    }), On(() => {
      try {
        const k = l.getViewWidget(Nn._3D);
        k && k.hideObjectList(!1);
      } catch (k) {
        console.log(k);
      }
    });
    const j = F([!1, !1, !1]), N = (k) => {
      j.value = [!1, !1, !1], k != -1 && (j.value[k] = !0), z.pressed = j.value[0], X.pressed = j.value[1], H.pressed = j.value[2];
    };
    let x = et({
      disabled: S,
      pressable: !0
    }), z = et({
      disabled: I,
      pressable: !0,
      pressed: j.value[0]
    }), X = et({
      disabled: h,
      pressable: !0,
      pressed: j.value[1]
    }), H = et({
      disabled: !1,
      pressable: !0,
      pressed: j.value[2]
    }), M = et({
      disabled: !1,
      pressable: !0,
      pressed: !1,
      label: nt("implant-planner.finishDrawing")
    }), te = et({
      value: n.nerve.diameter,
      minValue: 0.1,
      maxValue: 10,
      step: 0.1
    });
    ot(te, () => {
      p && te.value ? u.setNerveRadius(te.value / 2, !0) : p = !0;
    });
    const ne = F(/* @__PURE__ */ new Map());
    let W = null, se = "";
    const be = (k) => {
      if (u.getNerveNumberOfPoints() == 0) {
        const me = l.objects.nerveObjects.get(u.getNerveId() || "");
        me && (me.projectNerve.objectSubType == Le._NERVE_LEFT ? h.value = !1 : me.projectNerve.objectSubType == Le._NERVE_RIGHT && (I.value = !1), me.nerve.delete()), l.objects.nerveObjects.delete(u.getNerveId() || ""), ne.value.delete(u.getNerveId() || "");
      }
      W = null, N(0);
      let K = "";
      if (k)
        K = k.nerve.id;
      else
        for (let [me, Ne] of ne.value)
          Ne.nerve.objectSubType == Le._NERVE_RIGHT && (K = Ne.nerve.id);
      u.getDataFromObject(K, !1, !0), u.enableEditing(), n.nerve.name = u.getNerveName() || a("implant-planner.rightNerve"), n.nerve.length = (k == null ? void 0 : k.length) || 0, p = !1, n.nerve.diameter = u.getNerveRadius() * 2, te.value = n.nerve.diameter, M.disabled = !1;
      const Ae = ne.value.get(u.getNerveId() || "");
      Ae && (W = Ae, se = Ae.id), C(L());
    }, Re = (k) => {
      if (u.getNerveNumberOfPoints() == 0) {
        const me = l.objects.nerveObjects.get(u.getNerveId() || "");
        me && (me.projectNerve.objectSubType == Le._NERVE_LEFT ? h.value = !1 : me.projectNerve.objectSubType == Le._NERVE_RIGHT && (I.value = !1), me.nerve.delete()), l.objects.nerveObjects.delete(u.getNerveId() || ""), ne.value.delete(u.getNerveId() || "");
      }
      W = null, N(1);
      let K = "";
      if (k)
        K = k.nerve.id;
      else
        for (let [me, Ne] of ne.value)
          Ne.nerve.objectSubType == Le._NERVE_LEFT && (K = Ne.nerve.id);
      u.getDataFromObject(K, !0, !1), u.enableEditing(), n.nerve.name = u.getNerveName() || a("implant-planner.leftNerve"), n.nerve.length = (k == null ? void 0 : k.length) || 0, p = !1, n.nerve.diameter = u.getNerveRadius() * 2, te.value = n.nerve.diameter, M.disabled = !1;
      const Ae = ne.value.get(u.getNerveId() || "");
      Ae && (W = Ae, se = Ae.id), C(L());
    }, U = (k) => {
      var me;
      N(2), W = null;
      let K = "";
      k && (K = k), u.getDataFromObject(K, !1, !1), u.enableEditing(), n.nerve.name = u.getNerveName() || a("implant-planner.customObject"), n.nerve.length = ((me = u.addNerveToList()) == null ? void 0 : me.length) || 0, p = !1, n.nerve.diameter = u.getNerveRadius() * 2, te.value = n.nerve.diameter, M.disabled = !1;
      const Ae = ne.value.get(u.getNerveId() || "");
      Ae && (W = Ae, se = Ae.id), C(L()), l.sceneRepaint();
    }, ie = async () => {
      if (N(-1), u.getNerveNumberOfPoints() == 0) {
        const k = l.objects.nerveObjects.get(u.getNerveId() || "");
        k && (k.projectNerve.objectSubType == Le._NERVE_LEFT ? h.value = !1 : k.projectNerve.objectSubType == Le._NERVE_RIGHT && (I.value = !1), k.nerve.delete()), l.objects.nerveObjects.delete(u.getNerveId() || ""), ne.value.delete(u.getNerveId() || "");
      } else {
        console.log("finishDrawing - Not Deleting");
        const k = u.addNerveToList();
        if (k) {
          if (n.nerve.name = k.name, n.nerve.length = k.length, p = !1, n.nerve.diameter = k.nerve.getRadius() * 2, k.nerve) {
            let K = await xe(k.nerve);
            K && (k.nervePreview = K);
          }
          k.projectNerve.objectSubType == Le._NERVE_LEFT ? h.value = !0 : k.projectNerve.objectSubType == Le._NERVE_RIGHT && (I.value = !0), ne.value.set(k.id, k);
        }
      }
      u.disableEditing(), W = null, se = "", M.disabled = !0;
    }, re = (k) => {
      W = k, se = k.id, E.value = Math.random() * 1e3, k.nerve.objectSubType == Le._NERVE_LEFT ? Re(k) : k.nerve.objectSubType == Le._NERVE_RIGHT ? be(k) : U(k.id);
    }, q = async () => {
      await u.automaticNerveLandmarkLocalization(s);
    }, De = () => {
      W != null && (u.getNerveNumberOfPoints() == 1 ? _e() : u.removeLastPickedPoint());
    }, _e = () => {
      if (b = !1, W) {
        const k = l.objects.nerveObjects.get(u.getNerveId() || "");
        if (k) {
          const K = k.nerve.toProjectNerve();
          K.objectSubType == Le._NERVE_LEFT ? h.value = !1 : K.objectSubType == Le._NERVE_RIGHT && (I.value = !1);
          const Ae = u.getNerveId() || "", me = new Wl({
            onUndo: () => {
              l.objects.addNerve(K, Ae), l.insertFlag = !0, u.insertPointsFromProject();
            },
            onRedo: () => {
              const Ne = l.objects.nerveObjects.get(Ae);
              Ne && (Ne.projectNerve.objectSubType == Le._NERVE_LEFT ? h.value = !1 : Ne.projectNerve.objectSubType == Le._NERVE_RIGHT && (I.value = !1), Ne.nerve.delete()), l.objects.nerveObjects.delete(Ae), u.removeObjectEvent.notify(Ae);
            }
          });
          l.undoManager.pushPop(this, me, nt("medic-web-engine.deleteNerve"), zl.SCENE_REPAINT), u.clearAllPoints();
        }
      }
      N(-1), b = !0, W = null, M.disabled = !0;
    };
    async function xe(k) {
      if (!k)
        return;
      const K = l.viewConfiguration.colorScheme.get();
      return await ea(k, K);
    }
    return (k, K) => {
      const Ae = jo, me = co, Ne = Mu, Ge = bl;
      return O(), J(ze, null, [
        d(Ae, {
          onHideWizard: K[0] || (K[0] = (Ue) => o("hideWizard"))
        }, {
          default: w(() => [
            yt(V(k.$t("implant-planner.nerveWizard")), 1)
          ]),
          _: 1
        }),
        d(Ge, null, {
          default: w(() => [
            r(c) ? (O(), he(r(Be), { key: 0 }, {
              default: w(() => [
                d(me, null, {
                  default: w(() => [
                    yt(V(k.$t("implant-planner.assistedDrawing")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : ue("", !0),
            r(c) ? (O(), he(r(Be), { key: 1 }, {
              default: w(() => [
                d(r(Ce), {
                  icon: "pi pi-sparkles",
                  disabled: r(x).disabled,
                  label: k.$t("implant-planner.automaticNerveDetection"),
                  class: He("w-full web-rg-icon-btn"),
                  onClick: q
                }, null, 8, ["disabled", "label"])
              ]),
              _: 1
            })) : ue("", !0),
            d(r(Be), null, {
              default: w(() => [
                d(me, null, {
                  default: w(() => [
                    yt(V(k.$t("implant-planner.manualDrawing")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Be), null, {
              default: w(() => [
                d(r(Ce), {
                  id: "btnAddRightNerve",
                  disabled: r(z).disabled,
                  toggled: r(z).pressed,
                  label: k.$t("implant-planner.addRightNerve"),
                  class: He("w-full web-rg-wiz-btn"),
                  onClick: K[1] || (K[1] = (Ue) => be())
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(Be), null, {
              default: w(() => [
                d(r(Ce), {
                  id: "btnAddLeftNerve",
                  disabled: r(X).disabled,
                  toggled: r(X).pressed,
                  label: k.$t("implant-planner.addLeftNerve"),
                  class: He("w-full web-rg-wiz-btn"),
                  onClick: K[2] || (K[2] = (Ue) => Re())
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(Be), null, {
              default: w(() => [
                d(r(Ce), {
                  id: "btnAddCustomObject",
                  disabled: r(H).disabled,
                  toggled: r(H).pressed,
                  label: k.$t("implant-planner.addCustomObject"),
                  class: He("w-full web-rg-wiz-btn"),
                  onClick: K[3] || (K[3] = (Ue) => U(void 0))
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(Be), null, {
              default: w(() => [
                d(me, null, {
                  default: w(() => [
                    yt(V(k.$t("implant-planner.objectsClickToEdit")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (O(!0), J(ze, null, Rt(ne.value, (Ue, Ke) => (O(), J("div", {
              key: E.value,
              class: He([Ue[1].id === r(se) ? "p-highlight" : "", "cursor-pointer flex-row-wrap w-full"]),
              "data-cy": "selectNerve" + Ke,
              onClick: (st) => re(Ue[1])
            }, [
              y("div", Aw, [
                y("img", {
                  src: Ue[1].nervePreview,
                  alt: k.$t("medic-web-engine.nervePreview"),
                  class: "w-full all-radius",
                  draggable: "false"
                }, null, 8, Rw)
              ]),
              y("div", Mw, [
                y("span", Pw, [
                  y("span", null, V(Ue[1].name), 1),
                  y("span", null, V(k.$t("implant-planner.length")) + ": " + V(Ue[1].length.toFixed(2)) + " mm", 1)
                ])
              ])
            ], 10, Dw))), 128)),
            r(M).disabled ? ue("", !0) : (O(), he(r(at), {
              key: 2,
              class: "gap-2",
              style: { "margin-top": "auto", "padding-bottom": "0.5rem !important" }
            }, {
              default: w(() => [
                d(r(Be), {
                  class: "ml-1 gap-4",
                  style: { "align-items": "center" }
                }, {
                  default: w(() => [
                    d(r(Ee), { style: { flex: "1 1 0" } }, {
                      default: w(() => [
                        y("span", xw, V(k.$t("shared.name")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Ee), { style: { flex: "5 0" } }, {
                      default: w(() => [
                        d(Ne, {
                          class: "flex justify-end w-full",
                          modelValue: n.nerve.name,
                          "onUpdate:modelValue": K[4] || (K[4] = (Ue) => n.nerve.name = Ue),
                          pt: {
                            root: {
                              style: {
                                height: "28px !important",
                                fontSize: "0.875rem",
                                lineSize: "1.25rem"
                              }
                            }
                          }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), {
                  class: "ml-1 gap-4",
                  style: { "align-items": "center" }
                }, {
                  default: w(() => [
                    d(r(Ee), { style: { flex: "1 1 0" } }, {
                      default: w(() => [
                        y("span", jw, V(k.$t("implant-planner.length")) + ":", 1)
                      ]),
                      _: 1
                    }),
                    d(r(Ee), { style: { flex: "4 0 0" } }, {
                      default: w(() => [
                        y("span", Fw, V(n.nerve.length.toFixed(2)) + " " + V(k.$t("shared.mm")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Yi), {
                  class: "w-full",
                  modelValue: r(te).value,
                  "onUpdate:modelValue": K[5] || (K[5] = (Ue) => r(te).value = Ue),
                  min: r(te).minValue,
                  max: r(te).maxValue,
                  step: r(te).step,
                  label: k.$t("implant-planner.diameter"),
                  "show-buttons": !0,
                  "unit-label": k.$t("shared.mm")
                }, null, 8, ["modelValue", "min", "max", "step", "label", "unit-label"]),
                d(r(Be), {
                  class: "ml-1 gap-4",
                  style: { "align-items": "center" }
                }, {
                  default: w(() => [
                    d(r(Ee), { style: { flex: "1 1 0" } }, {
                      default: w(() => [
                        y("span", $w, V(k.$t("shared.color")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Ee), { style: { flex: "4 0 0" } }, {
                      default: w(() => [
                        (O(), he(r(nh), {
                          key: g.value,
                          color: g.value,
                          onColorValueChanged: A
                        }, null, 8, ["color"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), { class: "mt-2" }, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.deleteLastPoint"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "deleteLastPoint",
                      onClick: De
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                d(r(Be), { class: "w-full" }, {
                  default: w(() => [
                    d(r(Ce), {
                      id: "btnFinishDrawing",
                      disabled: r(M).disabled,
                      label: r(M).label,
                      class: He("w-full web-rg-icon-btn"),
                      onClick: ie
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("shared.delete"),
                      class: He("w-full web-rg-icon-btn"),
                      "data-cy": "deleteObject",
                      onClick: _e
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), kw = {
  class: "relative",
  style: { width: "248px", height: "160px", "user-select": "none" }
}, Vw = ["src"], Bw = ["data-cy", "onClick", "onMouseout", "onMouseover"], Uw = { style: { "font-size": "x-small", "font-weight": "bold", color: "red", "white-space": "pre-wrap", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" } }, Gw = ["src"];
[...Array(9).keys()].map((e) => e + 1);
const Td = ["NULL", "A", "B", "C", "D", "E", "F", "G", "H", "I"], Ww = /* @__PURE__ */ qe({
  __name: "IPPinView",
  props: {
    jawboneType: {},
    pins: {},
    modelValue: {},
    isReadonly: { type: Boolean },
    warningString: {}
  },
  emits: ["pinClick", "pinMouseOver", "pinMouseOut", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      8: ["Pin H", [218, 101]],
      6: ["Pin F", [204, 70]],
      4: ["Pin D", [181, 43]],
      2: ["Pin B", [150, 25]],
      1: ["Pin A", [112, 19]],
      3: ["Pin C", [74, 25]],
      5: ["Pin E", [43, 44]],
      7: ["Pin G", [20, 69]],
      9: ["Pin I", [6, 101]]
    }, a = {
      8: ["Pin H", [209, 73]],
      6: ["Pin F", [191, 100]],
      4: ["Pin D", [171, 123]],
      2: ["Pin B", [142, 138]],
      1: ["Pin A", [111, 143]],
      3: ["Pin C", [81, 138]],
      5: ["Pin E", [52, 122]],
      7: ["Pin G", [31, 99]],
      9: ["Pin I", [13, 73]]
    }, o = {
      [pt.EMPTY]: [
        [255, 255, 255],
        [41, 110, 179]
      ],
      [pt.OK]: [
        [210, 255, 162],
        [41, 110, 179]
      ],
      [pt.OK_SELECTED]: [
        [111, 215, 0],
        [255, 255, 255]
      ],
      [pt.COLLISION]: [
        [233, 200, 200],
        [41, 110, 179]
      ],
      [pt.COLLISION_SELECTED]: [
        [199, 2, 2],
        [255, 255, 255]
      ]
    }, l = e, s = t, { pins: i, jawboneType: c, isReadonly: u } = ln(l), p = ia(), b = Te(() => c.value === an.MAXILLA ? n : a), f = Te(
      () => c.value === an.MAXILLA ? p.getAssetUrl("/resources/teeth/maxilla_pin-02.png") : p.getAssetUrl("/resources/teeth/mandible_pin-02.png")
    ), h = (R, L, C) => `rgb(${R}, ${L}, ${C})`, I = Te(() => {
      const R = {};
      for (const L in b.value) {
        const C = i.value[L] || pt.EMPTY, [A, j] = o[C];
        R[L] = {
          backgroundColor: h(A[0], A[1], A[2]),
          color: h(j[0], j[1], j[2])
        };
      }
      return R;
    }), m = F(0), S = (R, L) => {
      s("pinClick", R, L);
    }, E = (R, L) => {
      s("pinMouseOver", R, L), s("update:modelValue", R), m.value = R;
    }, g = (R, L) => {
      s("pinMouseOut", R, L), s("update:modelValue", 0), m.value = 0;
    }, v = Te(() => !u.value && m.value && (!i.value[m.value] || i.value[m.value] === pt.EMPTY)), T = () => c.value === an.MAXILLA ? { top: "70%" } : { top: "10%" };
    return (R, L) => (O(), J("div", kw, [
      y("img", {
        src: f.value,
        alt: "",
        draggable: "false"
      }, null, 8, Vw),
      (O(!0), J(ze, null, Rt(b.value, (C, A) => (O(), J("div", {
        key: A,
        style: Tt([[
          {
            left: C[1][0] + "px",
            top: C[1][1] + "px"
          },
          I.value[A]
        ], { width: "24px", height: "24px", "font-weight": "bold", "font-size": "12px", "border-radius": "12px" }]),
        class: "absolute flex justify-center items-center",
        "data-cy": `pin-${Td[A]}`,
        onClick: (j) => S(+A, j),
        onMouseout: (j) => g(+A, j),
        onMouseover: (j) => E(+A, j)
      }, [
        y("div", null, V(Td[A]), 1)
      ], 44, Bw))), 128)),
      y("div", {
        class: "absolute w-6/12 h-6 flex justify-center",
        style: Tt([T(), { "text-align": "center", left: "25%" }])
      }, [
        y("span", Uw, V(e.warningString), 1)
      ], 4),
      v.value ? (O(), J("img", {
        key: 0,
        style: Tt([{
          left: b.value[m.value][1][0] + "px",
          top: b.value[m.value][1][1] + "px"
        }, { width: "24px", height: "24px" }]),
        alt: "",
        class: "absolute pointer-events-none",
        src: r(p).getAssetUrl("/resources/teeth/AddPin.png"),
        draggable: "false"
      }, null, 12, Gw)) : ue("", !0)
    ]));
  }
}), Ri = {
  sleeveInfo: null,
  stale: !1
};
function zw(e, t) {
  return `${e}__${t}`;
}
function zo(e, t = 0) {
  const n = typeof e == "number" ? e : Number(e);
  return Number.isFinite(n) ? n : t;
}
function Mi(e) {
  if (typeof e != "string")
    return "";
  const t = e.trim();
  return t.length > 0 ? t : "";
}
function Hw(e) {
  const t = new Int8Array(e);
  if (t.length !== 0)
    return {
      fileName: "",
      data: t,
      fileSize: t.length
    };
}
async function Cd(e, t) {
  var n, a;
  try {
    const o = Hw(await t.loadFile(e));
    return (n = t.isStale) != null && n.call(t) ? { file: void 0, stale: !0 } : { file: o, stale: !1 };
  } catch (o) {
    return (a = t.isStale) != null && a.call(t) ? { file: void 0, stale: !0 } : (console.warn("Failed to load sleeve STL file", { s3ObjectRef: e, error: o }), { file: void 0, stale: !1 });
  }
}
async function Yw(e, t) {
  var b, f;
  if ((b = t.isStale) != null && b.call(t))
    return { ...Ri, stale: !0 };
  const n = Mi(e.s3ObjectRef), a = Mi(e.inverses3ObjectRef), o = Mi(e.stl_guid), l = Mi(e.stl_negative_guid);
  let s, i;
  if (n) {
    const h = await Cd(n, t);
    if (h.stale)
      return { ...Ri, stale: !0 };
    s = h.file;
  }
  if (a) {
    const h = await Cd(a, t);
    if (h.stale)
      return { ...Ri, stale: !0 };
    i = h.file;
  }
  const c = {
    manufacturerName: e.manufacturer ?? "",
    modelName: e.name,
    sellingCode: e.sellingCode,
    dExternal: zo(e.dextsleevepin),
    dInternal: zo(e.dintsleevepin),
    lSleeve: zo(e.lslsleevepin),
    lLip: zo(e.llipsleevepin),
    dHexagon: zo(e.dlipsleevepin),
    distanceFromImplant: zo(e.lpinsleeve),
    drillLengthSizes: "",
    originalName: zw(e.manufacturer, e.name),
    stlFileGuid: o ?? n ?? "",
    stlFileNegativeGuid: l ?? a ?? "",
    cylinderShape: e.cylinder_shape ?? !1,
    lockDistance: Number(Gl(e.lock_sleeve_distance)),
    customSleeveSupport: Gl(e.custom_sleeve_support),
    lCut: 0,
    originalDistanceFromImplant: -1,
    reductionSystemSize: 0,
    rotationAll: 0,
    rotationCut: 0,
    connectionIndex: 0,
    referencedSleeve: 1,
    stlData: s,
    stlNegativeData: i
  }, u = !!((f = c.stlData) != null && f.data.length), p = c.dInternal > 0 && (c.dExternal > 0 || c.dHexagon > 0) && c.lSleeve > 0;
  return !u && !p ? Ri : {
    sleeveInfo: c,
    stale: !1
  };
}
const Kw = { class: "flex content-center justify-center" }, Zw = { class: "text-12 font-medium" }, Jw = ["src"], Xw = { class: "ml-1 flex items-center" }, qw = { class: "flex content-center justify-center" }, Qw = { class: "text-12 font-medium" }, eS = { key: 0 }, tS = ["src"], nS = /* @__PURE__ */ qe({
  __name: "IPPinPlanning",
  props: {
    isReadOnly: { type: Boolean }
  },
  setup(e) {
    const { t } = Yt(), n = e, { isReadOnly: a } = ln(n);
    let o;
    if (!n.isReadOnly) {
      const le = fl();
      if (!le.cachedResponse)
        throw new Error("STL Library cache not initialized");
      o = new lu(le.cachedResponse, iu());
    }
    function l(le) {
      return { name: `${le.manufacturer} / ${le.name}`, value: le };
    }
    function s(le) {
      return (le == null ? void 0 : le.trim().toLowerCase()) ?? "";
    }
    function i(le, pe) {
      return le.uuid && pe.uuid ? le.uuid === pe.uuid : s(le.manufacturer) === s(pe.manufacturer) && s(le.name) === s(pe.name);
    }
    function c(le, pe) {
      return le.id && pe.id ? le.id === pe.id : le.stl_guid && pe.stl_guid ? le.stl_guid === pe.stl_guid : le.s3ObjectRef && pe.s3ObjectRef ? le.s3ObjectRef === pe.s3ObjectRef : le.original_name && pe.original_name ? s(le.original_name) === s(pe.original_name) : s(le.manufacturer) === s(pe.manufacturer) && s(le.name) === s(pe.name);
    }
    function u(le, pe) {
      const Z = s(pe);
      return Z ? s(le.stl_guid) === Z || s(le.s3ObjectRef) === Z : !1;
    }
    function p(le, pe, Z) {
      return le.find((ee) => Z(ee.value, pe));
    }
    function b(le, pe, Z) {
      if (!pe)
        return le;
      const ee = p(le, pe.value, Z);
      return ee ? ee === pe ? le : le.map(($) => $ === ee ? pe : $) : [pe, ...le];
    }
    function f(le) {
      if (!le)
        return;
      const pe = le.sleeveIds;
      if (!(!pe || pe.length === 0))
        return pe;
    }
    const h = F(!1), I = F(!1), m = F(!1), S = F(!1), E = F(), g = F(), v = F(0);
    let T, R, L, C;
    const { watch: A, onEvent: j } = Ra(), N = F([]), x = F([]), z = F();
    let X = et({
      clicked: !1,
      state: !1,
      disabled: !1
    });
    et({
      clicked: !1,
      state: !1,
      disabled: !1
    });
    function H() {
      const le = o.pins().map((pe) => l(pe));
      N.value = b(le, E.value, i), E.value && (E.value = p(N.value, E.value.value, i)), M();
    }
    function M(le = ((pe) => (pe = E.value) == null ? void 0 : pe.value)()) {
      const Z = f(le), ee = X.state || !Z, $ = o.getPinSleevesFiltered(ee, Z);
      x.value = b($, g.value, c), g.value && (g.value = p(x.value, g.value.value, c));
    }
    async function te() {
      M(), !X.state && E.value && await Ue(E.value);
    }
    function ne(le) {
      const pe = le.stlFileGuid ? x.value.find(($) => u($.value, le.stlFileGuid || "")) : void 0;
      if (pe)
        return pe;
      const Z = le.originalName ? x.value.find(($) => s($.value.original_name) === s(le.originalName)) : void 0;
      if (Z)
        return Z;
      const ee = x.value.find(
        ($) => s($.value.manufacturer) === s(le.manufacturerName) && s($.value.name) === s(le.modelName)
      );
      return ee || x.value.find(($) => s($.value.name) === s(le.modelName));
    }
    const W = pn(), se = F(0), be = () => {
      se.value === 0 && W.showLoading(t("implant-planner.loadingObject")), se.value += 1;
    }, Re = () => {
      se.value > 0 && (se.value -= 1), se.value === 0 && W.hideLoading();
    };
    let U = et({
      jawboneType: W.CPRType,
      pins: [],
      selectedObject: null,
      warnString: ""
    });
    const ie = ["Pin 0", "Pin 1", "Pin 2", "Pin 3", "Pin 4", "Pin 5", "Pin 6", "Pin 7", "Pin 8", "Pin 9"];
    function re() {
      return ie;
    }
    function q() {
      return ["NULL", "Pin A", "Pin B", "Pin C", "Pin D", "Pin E", "Pin F", "Pin G", "Pin H", "Pin I"];
    }
    function De(le) {
      return _e(q()[le]) || _e(re()[le]);
    }
    function _e(le) {
      return W.objects.pinExists(le);
    }
    function xe(le) {
      return W.objects.pins.getByName(q()[le]) || W.objects.pins.getByName(re()[le]);
    }
    function k(le) {
      return le ? !!(le.collisions.nerveCollision || le.collisions.sleeveCollision || le.collisions.anatomyCollision || le.collisions.implantCollision || le.collisions.securityZoneCollision) : !1;
    }
    function K() {
      U.warnString = "", U.pins = q().map((le, pe) => {
        if (_e(le) || _e(ie[pe])) {
          const Z = xe(pe);
          return U.selectedObject && (U.selectedObject.pin.name === le || U.selectedObject.pin.name === ie[pe]) ? k(Z) ? (Z && Z.collisions && (Z.collisions.nerveCollision && (U.warnString += `${t("implant-planner.nerveCollision")} 
`), Z.collisions.sleeveCollision && (U.warnString += `${t("implant-planner.sleeveCollision")} 
`), Z.collisions.anatomyCollision && (U.warnString += `${t("implant-planner.anatomyCollision")} 
`), Z.collisions.implantCollision && (U.warnString += `${t("implant-planner.implantCollision")} 
`)), pt.COLLISION_SELECTED) : pt.OK_SELECTED : k(Z) ? pt.COLLISION : pt.OK;
        }
        return pt.EMPTY;
      });
    }
    K();
    function Ae(le) {
      const pe = De(le), Z = xe(le);
      pe && (k(Z) ? U.pins[le] = pt.COLLISION_SELECTED : U.pins[le] = pt.OK_SELECTED);
    }
    function me() {
      K();
    }
    function Ne() {
      return o.pins()[0];
    }
    function Ge(le, pe, Z, ee, $, _) {
      const D = Yo(parseInt(Z.color)), Y = Ch();
      Y.origin = ee ?? [0, 0, 0], Y.viewUp = _ ?? [0, 0, 1], Y.normal = $ ?? [0, 1, 0], Y.tangent = [0, 0, 0], Y.name = le, Y.color = D, Y.objectType = Le._PIN, Y.objectSubType = Le._NONE;
      const Q = new Int8Array(pe);
      return Y.pinInfo = {
        filename: "",
        manufacturerName: Z.manufacturer,
        modelName: Z.name,
        guid: Z.uuid,
        name: le,
        color: Z.color,
        stlFile: {
          fileName: "",
          data: Q,
          fileSize: Q.length
        }
      }, Y.implantGuide && Y.sleeveInfo && (Y.implantGuide.guide_radius_hexagon = -Y.sleeveInfo.dHexagon / 2, Y.implantGuide.guide_lip_length = Y.sleeveInfo.lLip), Y;
    }
    async function Ue(le, pe) {
      var _;
      M(le.value);
      const Z = pe ? p(x.value, pe.value, c) : void 0;
      if (Z) {
        g.value = Z, await G(Z);
        return;
      }
      const ee = (_ = le.value) == null ? void 0 : _.defaultSleeveId;
      if (ee) {
        const D = o.getPinSleevesById(ee);
        if (D) {
          const Y = p(x.value, D, c);
          if (Y) {
            g.value = Y, await G(Y);
            return;
          }
        }
      }
      const $ = x.value[0];
      g.value = $, $ && await G($);
    }
    async function Ke(le) {
      const pe = q()[le];
      if (!_e(pe) && !_e(ie[le])) {
        if (a.value)
          return;
        be();
        try {
          const Z = Ne(), ee = await o.getFile(Z.s3ObjectRef), $ = W.toolManager.coordControl.getObjectPos(Le._PIN), _ = W.toolManager.coordControl.getObjectDir(Le._PIN), D = W.toolManager.coordControl.getObjectViewup(Le._PIN);
          W.objects.addPin(Ge(pe, ee, Z, $, _, D), !0), W.objects.selectObject(pe), await Ue(l(Z)), W.sceneRepaint();
        } finally {
          Re();
        }
      } else
        W.objects.selectObject(_e(pe) ? pe : ie[le]);
      K();
    }
    async function st(le) {
      if (U.selectedObject && le) {
        const pe = U.selectedObject.pin.name;
        if (pe && _e(pe)) {
          const Z = g.value;
          be();
          try {
            const ee = await o.getFile(le.value.s3ObjectRef);
            W.objects.replacePin(Ge(pe, ee, le.value)), await Ue(le, Z), W.sceneRepaint();
          } finally {
            Re();
          }
        }
      }
    }
    async function G(le) {
      if (U.selectedObject && le) {
        const pe = U.selectedObject.pin.name;
        if (pe) {
          const Z = W.objects.pins.getByName(pe);
          if (Z) {
            const ee = ++v.value, $ = await Yw(le.value, {
              loadFile: (_) => o.getFile(_),
              isStale: () => ee !== v.value
            });
            if ($.stale)
              return;
            if ($.sleeveInfo) {
              Z.replaceSleeve($.sleeveInfo);
              const _ = Z.getSleeve();
              m.value = !!_, I.value = (_ == null ? void 0 : _.getVisibility()) || !1, U.selectedObject = Z.toProjectPin();
            } else
              console.warn("error in sleeve data", le.value);
          }
        }
      }
    }
    async function P(le) {
      var pe, Z, ee, $, _, D, Y;
      if (!(le && le.type !== Le._PIN))
        if (n.isReadOnly)
          if (le) {
            S.value = le.getLocked(), h.value = le.getVisibility(), U.selectedObject = le.toProjectPin();
            const Q = U.selectedObject.sleeve, ae = W.viewConfiguration.colorScheme.get();
            if (T = await ea(le, ae), L = ((ee = U.selectedObject) == null ? void 0 : ee.pin.pinInfo.manufacturerName) + " / " + (($ = U.selectedObject) == null ? void 0 : $.pin.pinInfo.modelName), Q) {
              m.value = !0, I.value = ((_ = le.getSleeve()) == null ? void 0 : _.getVisibility()) || !1;
              const ge = le.getSleeve();
              C = (Y = (D = U.selectedObject) == null ? void 0 : D.sleeve) == null ? void 0 : Y.originalName, ge ? R = await ea(ge, ae) : R = void 0;
            } else
              C = void 0, m.value = !1, R = void 0;
          } else
            R = void 0, L = void 0, C = void 0, T = void 0, U.selectedObject = null, m.value = !1;
        else if (le) {
          S.value = le.getLocked(), h.value = le.getVisibility(), U.selectedObject = le.toProjectPin();
          const Q = U.selectedObject.pin.name, ae = z.value !== Q;
          z.value = Q, ae && (X.state = !1), H();
          const ge = U.selectedObject.pin.pinInfo;
          if (ge) {
            const Me = o.pins().find((je) => je.uuid === ge.guid);
            Me && (E.value = p(N.value, Me, i));
          }
          X.disabled = !E.value, M((pe = E.value) == null ? void 0 : pe.value);
          const Fe = U.selectedObject.sleeve;
          Fe ? (m.value = !0, g.value = ne(Fe), I.value = ((Z = le.getSleeve()) == null ? void 0 : Z.getVisibility()) || !1) : (m.value = !1, g.value = void 0), await fn();
        } else
          U.selectedObject = null, m.value = !1, X.disabled = !0, X.state = !1, z.value = void 0, E.value = void 0, g.value = void 0;
    }
    function de() {
      U.selectedObject && (S.value = !S.value, W.objects.changeLockStatus(U.selectedObject.pin.name, S.value));
    }
    function fe(le) {
      le == Le._PIN ? U.selectedObject && (h.value = !h.value, W.objects.setObjectVisibility(U.selectedObject.pin.name, h.value)) : le == Le._SLEEVE && U.selectedObject && (I.value = !I.value, W.objects.setObjectPartVisibility(U.selectedObject.pin.name, le, I.value));
    }
    function ke() {
      U.selectedObject && (W.objects.removePin(U.selectedObject.pin.name), W.sceneRepaint());
    }
    return A(W.objects.selectedObject, async (le) => {
      await P(le), K();
    }), j(W.objects.updateImplantPlannerGUIEvent, async (le) => {
      le != null && (await P(le), K());
    }), Mt(() => {
      P(W.objects.selectedObject.get()), K();
    }), Ka(() => {
      se.value > 0 && W.hideLoading();
    }), (le, pe) => {
      const Z = Ww, ee = co;
      return O(), J(ze, null, [
        d(r(at), { class: "gap-2" }, {
          default: w(() => [
            d(r(Be), { class: "justify-center" }, {
              default: w(() => [
                yt(V(le.$t("implant-planner.clickOnPinMarkerToAddAPin")), 1)
              ]),
              _: 1
            }),
            d(r(Be), null, {
              default: w(() => [
                d(Z, {
                  isReadonly: r(a),
                  jawboneType: r(U).jawboneType,
                  pins: r(U).pins,
                  warningString: r(U).warnString,
                  onPinClick: Ke,
                  onPinMouseOut: me,
                  onPinMouseOver: Ae
                }, null, 8, ["isReadonly", "jawboneType", "pins", "warningString"])
              ]),
              _: 1
            }),
            d(r(Be), { class: "mt-2" }, {
              default: w(() => [
                d(r(Lt), null, {
                  default: w(() => [
                    d(ee, null, {
                      default: w(() => [
                        yt(V(le.$t("implant-planner.pinType")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Lt), {
                  class: "gap-1",
                  style: { "justify-content": "end" }
                }, {
                  default: w(() => [
                    r(a) ? ue("", !0) : (O(), he(r(Ce), {
                      key: 0,
                      class: "shrink",
                      disabled: !E.value,
                      isToolbarButton: !0,
                      onClick: pe[0] || (pe[0] = ($) => ke()),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !E.value,
                      iconSrc: h.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg",
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      isToolbarButton: !0,
                      onClick: pe[1] || (pe[1] = ($) => fe(r(Le)._PIN)),
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"]),
                    r(a) ? ue("", !0) : (O(), he(r(Ce), {
                      key: 1,
                      class: "shrink",
                      disabled: !E.value,
                      isToolbarButton: !0,
                      iconSrc: S.value ? "/icons/new_icons/ik_lock_28.svg" : "/icons/new_icons/ik_lock_open_28.svg",
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      onClick: pe[2] || (pe[2] = ($) => de()),
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            r(a) ? (O(), he(r(Be), {
              key: 1,
              class: "gap-4"
            }, {
              default: w(() => [
                y("span", Zw, V(r(L)), 1),
                r(T) ? (O(), J("img", {
                  key: 0,
                  src: r(T),
                  alt: "Implant preview",
                  draggable: "false"
                }, null, 8, Jw)) : ue("", !0)
              ]),
              _: 1
            })) : (O(), he(r(Be), { key: 0 }, {
              default: w(() => [
                d(r(Bn), {
                  modelValue: E.value,
                  "onUpdate:modelValue": pe[3] || (pe[3] = ($) => E.value = $),
                  model: N.value,
                  class: "w-full",
                  listStyle: "height: 15vh",
                  onUserChange: st,
                  "data-cy": "pin-list"
                }, {
                  empty: w(() => [
                    y("div", Kw, [
                      y("div", null, V(le.$t("implant-planner.selectOrAddAPin")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "model"])
              ]),
              _: 1
            })),
            r(a) ? ue("", !0) : (O(), he(r(Be), { key: 2 }, {
              default: w(() => [
                d(r(Lt), null, {
                  default: w(() => [
                    d(ee, null, {
                      default: w(() => [
                        yt(V(le.$t("implant-planner.sleeve")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Lt), {
                  class: "gap-2",
                  style: { "justify-content": "end" }
                }, {
                  default: w(() => [
                    r(a) ? ue("", !0) : (O(), he(r(io), {
                      key: 0,
                      state: r(X).state,
                      "onUpdate:state": pe[4] || (pe[4] = ($) => r(X).state = $),
                      disabled: r(X).disabled,
                      "onUpdate:disabled": pe[5] || (pe[5] = ($) => r(X).disabled = $),
                      onChange: te
                    }, {
                      trueLabel: w(() => [
                        y("span", Xw, V(le.$t("implant-planner.showAll")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])),
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !m.value,
                      iconSrc: I.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg",
                      isToolbarButton: !0,
                      onClick: pe[6] || (pe[6] = ($) => fe(r(Le)._SLEEVE)),
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
            r(a) ? (O(), he(r(Be), {
              key: 4,
              class: "gap-4"
            }, {
              default: w(() => [
                y("span", Qw, V(r(C)), 1),
                r(R) ? (O(), J("div", eS, [
                  y("img", {
                    src: r(R),
                    alt: "Sleeve preview",
                    draggable: "false"
                  }, null, 8, tS)
                ])) : ue("", !0)
              ]),
              _: 1
            })) : (O(), he(r(Be), { key: 3 }, {
              default: w(() => [
                d(r(Bn), {
                  modelValue: g.value,
                  "onUpdate:modelValue": pe[7] || (pe[7] = ($) => g.value = $),
                  model: x.value,
                  class: "w-full",
                  listStyle: "height: 14vh",
                  onUserChange: G,
                  "data-cy": "sleeve-list"
                }, {
                  empty: w(() => [
                    y("div", qw, [
                      y("div", null, V(le.$t("implant-planner.selectOrAddAPin")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "model"])
              ]),
              _: 1
            }))
          ]),
          _: 1
        }),
        ue("", !0)
      ], 64);
    };
  }
}), aS = { class: "text-xl font-medium" }, oS = { class: "flex mt-2" }, lS = { key: 0 }, iS = ["src"], sS = { class: "text-xl font-medium" }, rS = { class: "flex mt-2" }, uS = { key: 0 }, cS = ["src"], dS = { class: "text-xl font-medium" }, pS = { class: "flex mt-2" }, mS = { key: 0 }, fS = ["src"], gS = { class: "text-xl font-medium" }, hS = { class: "flex mt-2" }, bS = { key: 0 }, vS = ["src"], yS = /* @__PURE__ */ qe({
  __name: "IPSecondaryComponents",
  props: {
    object: {},
    objectsPreview: {},
    selectedObject: { type: Boolean },
    isReadOnly: { type: Boolean }
  },
  emits: ["changeObject", "removeObject", "changeVisibility"],
  setup(e, { emit: t }) {
    const n = e, a = et({
      object: void 0,
      implantLock: !1,
      scanAbutmentVisibility: !1,
      secondaryAbutmentVisibility: !1,
      secondaryScanAbutmentVisibility: !1,
      analogExtrusionVisibility: !1
    }), o = t;
    ot(
      () => n.object,
      (h) => {
        var I, m, S, E;
        h && (a.object = h), a.scanAbutmentVisibility = ((I = h == null ? void 0 : h.scanAbutment) == null ? void 0 : I.visibility) ?? !1, a.secondaryAbutmentVisibility = ((m = h == null ? void 0 : h.secondaryAbutment) == null ? void 0 : m.visibility) ?? !1, a.secondaryScanAbutmentVisibility = ((S = h == null ? void 0 : h.secondaryScanAbutment) == null ? void 0 : S.visibility) ?? !1, a.analogExtrusionVisibility = ((E = h == null ? void 0 : h.analogExtrusion) == null ? void 0 : E.visibility) ?? !1, a.implantLock = (h == null ? void 0 : h.implant.locked) ?? !1;
      },
      { deep: !0, immediate: !0 }
    );
    const l = Te(() => {
      var h;
      return !((h = a.object) != null && h.implant) || n.isReadOnly ? !1 : !a.implantLock;
    }), s = Te(() => a.scanAbutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), i = Te(() => a.secondaryAbutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), c = Te(() => a.secondaryScanAbutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), u = Te(() => a.analogExtrusionVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), p = (h) => {
      n.object && o("changeObject", n.object.objectId, h);
    }, b = (h) => {
      n.object && o("removeObject", n.object.objectId, h);
    }, f = (h, I) => {
      n.object && o("changeVisibility", n.object.objectId, h, I);
    };
    return (h, I) => (O(), he(r(at), { class: "mt-2 gap-2" }, {
      default: w(() => {
        var m, S, E, g, v, T, R, L, C, A, j, N, x, z, X, H, M, te, ne, W;
        return [
          d(r(Ee), { class: "gap-4 flex-row" }, {
            default: w(() => [
              d(r(Lt), null, {
                default: w(() => [
                  y("span", aS, V(h.$t("implant-planner.scanAbutment")), 1)
                ]),
                _: 1
              }),
              d(r(Lt), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: w(() => {
                  var se, be;
                  return [
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: I[0] || (I[0] = (Re) => p(r(Le)._PRIMARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    e.isReadOnly ? ue("", !0) : (O(), he(r(Ce), {
                      key: 0,
                      class: "shrink",
                      disabled: !((se = a.object) != null && se.scanAbutment),
                      onClick: I[1] || (I[1] = (Re) => b(r(Le)._PRIMARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !((be = a.object) != null && be.scanAbutment),
                      iconSrc: s.value,
                      onClick: I[2] || (I[2] = (Re) => f(r(Le)._PRIMARY_SCAN_ABUTMENT, !a.scanAbutmentVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (m = a.object) != null && m.scanAbutment ? (O(), J(ze, { key: 0 }, [
            y("span", oS, V((E = (S = a.object) == null ? void 0 : S.scanAbutment) == null ? void 0 : E.name), 1),
            (g = n.objectsPreview) != null && g.scanAbutmentPreview ? (O(), J("div", lS, [
              y("img", {
                src: (v = n.objectsPreview) == null ? void 0 : v.scanAbutmentPreview,
                alt: "Scan abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, iS)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(Ee), { class: "gap-4 flex-row mt-2" }, {
            default: w(() => [
              d(r(Lt), null, {
                default: w(() => [
                  y("span", sS, V(h.$t("implant-planner.secondaryAbutment")), 1)
                ]),
                _: 1
              }),
              d(r(Lt), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: w(() => {
                  var se, be;
                  return [
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: I[3] || (I[3] = (Re) => p(r(Le)._SECONDARY_ABUTMENT)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    e.isReadOnly ? ue("", !0) : (O(), he(r(Ce), {
                      key: 0,
                      class: "shrink",
                      disabled: !((se = a.object) != null && se.secondaryAbutment),
                      onClick: I[4] || (I[4] = (Re) => b(r(Le)._SECONDARY_ABUTMENT)),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !((be = a.object) != null && be.secondaryAbutment),
                      iconSrc: i.value,
                      onClick: I[5] || (I[5] = (Re) => f(r(Le)._SECONDARY_ABUTMENT, !a.secondaryAbutmentVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (T = a.object) != null && T.secondaryAbutment ? (O(), J(ze, { key: 1 }, [
            y("span", rS, V((L = (R = a.object) == null ? void 0 : R.secondaryAbutment) == null ? void 0 : L.name), 1),
            (C = n.objectsPreview) != null && C.secondaryAbutmentPreview ? (O(), J("div", uS, [
              y("img", {
                src: (A = n.objectsPreview) == null ? void 0 : A.secondaryAbutmentPreview,
                alt: "Secondary abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, cS)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(Ee), { class: "gap-4 flex-row mt-2" }, {
            default: w(() => [
              d(r(Lt), null, {
                default: w(() => [
                  y("span", dS, V(h.$t("implant-planner.secondaryScanAbutment")), 1)
                ]),
                _: 1
              }),
              d(r(Lt), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: w(() => {
                  var se, be;
                  return [
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: I[6] || (I[6] = (Re) => p(r(Le)._SECONDARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    e.isReadOnly ? ue("", !0) : (O(), he(r(Ce), {
                      key: 0,
                      class: "shrink",
                      disabled: !((se = a.object) != null && se.secondaryScanAbutment),
                      onClick: I[7] || (I[7] = (Re) => b(r(Le)._SECONDARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !((be = a.object) != null && be.secondaryScanAbutment),
                      iconSrc: c.value,
                      onClick: I[8] || (I[8] = (Re) => f(r(Le)._SECONDARY_SCAN_ABUTMENT, !a.secondaryScanAbutmentVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (j = a.object) != null && j.secondaryScanAbutment ? (O(), J(ze, { key: 2 }, [
            y("span", pS, V((x = (N = a.object) == null ? void 0 : N.secondaryScanAbutment) == null ? void 0 : x.name), 1),
            (z = n.objectsPreview) != null && z.secondaryScanAbutmentPreview ? (O(), J("div", mS, [
              y("img", {
                src: (X = n.objectsPreview) == null ? void 0 : X.secondaryScanAbutmentPreview,
                alt: "Secondary scan abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, fS)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(Ee), { class: "gap-4 flex-row mt-2" }, {
            default: w(() => [
              d(r(Lt), null, {
                default: w(() => [
                  y("span", gS, V(h.$t("implant-planner.analogExtrusion")), 1)
                ]),
                _: 1
              }),
              d(r(Lt), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: w(() => {
                  var se;
                  return [
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: I[9] || (I[9] = (be) => p(r(Le)._ANALOG_EXTRUSION)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    d(r(Ce), {
                      class: "shrink",
                      disabled: !((se = a.object) != null && se.analogExtrusion) || !0,
                      iconSrc: u.value,
                      onClick: I[10] || (I[10] = (be) => f(r(Le)._ANALOG_EXTRUSION, !a.analogExtrusionVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (H = a.object) != null && H.analogExtrusion ? (O(), J(ze, { key: 3 }, [
            y("span", hS, V((te = (M = a.object) == null ? void 0 : M.analogExtrusion) == null ? void 0 : te.name), 1),
            (ne = n.objectsPreview) != null && ne.analogExtrusionPreview ? (O(), J("div", bS, [
              y("img", {
                src: (W = n.objectsPreview) == null ? void 0 : W.analogExtrusionPreview,
                alt: "Analog extrusion preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, vS)
            ])) : ue("", !0)
          ], 64)) : ue("", !0)
        ];
      }),
      _: 1
    }));
  }
}), _S = { class: "text-xl font-medium" }, wS = { class: "mt-2" }, SS = ["src"], IS = { class: "text-xl font-medium" }, ES = { class: "flex mt-2" }, TS = { key: 0 }, CS = ["src"], NS = { class: "font-medium mr-2" }, LS = { class: "font-medium ml-2" }, OS = { class: "text-xl font-medium" }, DS = { class: "col-span-7 flex flex-col mt-2" }, AS = { class: "text-12 font-medium" }, RS = {
  class: "text-12 font-medium mt-2",
  style: { "white-space": "nowrap" }
}, MS = {
  class: "text-12 font-medium mt-2",
  style: { "white-space": "nowrap" }
}, PS = {
  key: 0,
  class: "col-span-5 flex flex-col justify-end"
}, xS = ["src"], jS = {
  key: 0,
  class: "flex flex-col mt-2"
}, FS = {
  class: "text-12 font-medium",
  style: { "white-space": "nowrap" }
}, $S = /* @__PURE__ */ qe({
  __name: "IPPrimaryComponents",
  props: {
    object: {},
    objectsPreview: {},
    selectedObject: { type: Boolean },
    isReadOnly: { type: Boolean }
  },
  emits: ["changeObject", "removeObject", "changeVisibility", "changeLock", "changeAngle", "changeSleeveDistance", "changeSleeveRotationStep", "changeDrillLength"],
  setup(e, { emit: t }) {
    const n = e;
    let a = et({
      object: void 0,
      implantVisibility: !1,
      implantLock: !1,
      abutmentVisibility: !1,
      sleeveVisibility: !1,
      abutmentRotationZ: 0
    });
    const o = F(0), l = F(0);
    let s = et({
      value: o,
      minValue: -180,
      maxValue: 180,
      step: 1,
      disabled: !0
    }), i = et({
      clicked: !1,
      state: !1,
      disabled: !0
    }), c = !1, u = !1;
    ot(
      () => n.object,
      (U) => {
        var re, q, De, _e;
        U && (a.object = U), a.implantVisibility = (U == null ? void 0 : U.implant.visibility) ?? !1, a.abutmentVisibility = ((re = U == null ? void 0 : U.abutment) == null ? void 0 : re.visibility) ?? !1, a.sleeveVisibility = ((q = U == null ? void 0 : U.sleeve) == null ? void 0 : q.visibility) ?? !1, a.implantLock = (U == null ? void 0 : U.implant.locked) ?? !1, i.state ? a.abutmentRotationZ = ((De = U == null ? void 0 : U.abutment) == null ? void 0 : De.rotationZProsthetic) ?? 0 : a.abutmentRotationZ = ((_e = U == null ? void 0 : U.abutment) == null ? void 0 : _e.rotationZ) ?? 0, c = !0, o.value = Math.round(a.abutmentRotationZ);
        const ie = Math.round((U == null ? void 0 : U.sleeveRotationStep) ?? 0);
        l.value !== ie && (u = !0, l.value = ie);
      },
      {
        deep: !0,
        immediate: !0
      }
    ), ot(
      i,
      (U) => {
        var ie, re, q, De;
        U.state ? a.abutmentRotationZ = ((re = (ie = n.object) == null ? void 0 : ie.abutment) == null ? void 0 : re.rotationZProsthetic) ?? 0 : a.abutmentRotationZ = ((De = (q = n.object) == null ? void 0 : q.abutment) == null ? void 0 : De.rotationZ) ?? 0, c = !0, o.value = Math.round(a.abutmentRotationZ);
      },
      { deep: !0 }
    ), Mt(() => {
      var ie;
      c = !0, o.value = a.abutmentRotationZ;
      const U = Math.round(((ie = a.object) == null ? void 0 : ie.sleeveRotationStep) ?? 0);
      l.value !== U && (u = !0, l.value = U);
    });
    const p = Te(() => a.implantVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), b = Te(() => a.implantLock ? "/icons/new_icons/ik_lock_28.svg" : "/icons/new_icons/ik_unLockB_28.svg"), f = Te(() => a.abutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), h = Te(() => a.sleeveVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), I = t;
    let m = et({
      disabled: !0
    }), S = et({
      disabled: !0
    }), E = et({
      disabled: !0
    }), g = et({
      disabled: !0
    });
    const v = (U) => {
      n.object && I("changeObject", n.object.objectId, U);
    }, T = (U) => {
      n.object && I("removeObject", n.object.objectId, U);
    }, R = (U, ie) => {
      n.object && I("changeVisibility", n.object.objectId, U, ie);
    }, L = (U, ie) => {
      n.object && (I("changeLock", n.object.objectId, U, ie), a.implantLock = ie);
    }, C = (U) => {
      n.object && I("changeAngle", n.object.objectId, U, i.state);
    }, A = Te(() => {
      var U;
      return (U = a.object) == null ? void 0 : U.implant.name;
    }), j = Te(() => {
      var U, ie;
      return ((ie = (U = a.object) == null ? void 0 : U.implant) == null ? void 0 : ie.diameter) + "mm";
    }), N = Te(() => {
      var U, ie;
      return ((ie = (U = a.object) == null ? void 0 : U.implant) == null ? void 0 : ie.length) + "mm";
    }), x = Te(() => {
      var U, ie;
      return (ie = (U = a.object) == null ? void 0 : U.abutment) == null ? void 0 : ie.name;
    }), z = Te(() => {
      var U, ie;
      return (ie = (U = a.object) == null ? void 0 : U.sleeve) == null ? void 0 : ie.name;
    }), X = Te(() => {
      var U, ie;
      return "Overall length: " + ((ie = (U = a.object) == null ? void 0 : U.overallLength) == null ? void 0 : ie.toFixed(2)) + "mm";
    }), H = Te(() => {
      var U;
      return (U = a.object) == null ? void 0 : U.drillLength;
    }), M = Te(() => {
      var U;
      return (U = a.object) == null ? void 0 : U.sleeveDistance;
    }), te = Te(() => {
      var U;
      return ((U = a.object) == null ? void 0 : U.sleeveRotationMaxStep) ?? 0;
    }), ne = Te(() => {
      var U, ie;
      return ((U = a.object) == null ? void 0 : U.sleeve) != null && ((ie = a.object) == null ? void 0 : ie.sleeveRotationMaxStep) != null;
    }), W = (U) => {
      n.object && I("changeDrillLength", n.object.objectId, U);
    }, se = (U) => {
      n.object && I("changeSleeveDistance", n.object.objectId, U);
    };
    ot(s, () => {
      o.value != null && !c && C(o.value), c = !1;
    }), ot(l, (U) => {
      U != null && !u && n.object && I("changeSleeveRotationStep", n.object.objectId, U), u = !1;
    }), ot(
      () => n.object,
      (U) => {
        U ? be() : Re();
      },
      { immediate: !0 }
    );
    function be() {
      var U, ie, re, q, De, _e;
      m.disabled = !((U = a.object) != null && U.implant), S.disabled = !((ie = a.object) != null && ie.abutment), E.disabled = !((re = a.object) != null && re.sleeve), g.disabled = !((q = a.object) != null && q.implant), s.disabled = !((De = a.object) != null && De.implant), i.disabled = !((_e = a.object) != null && _e.abutment);
    }
    function Re() {
      m.disabled = !0, S.disabled = !0, E.disabled = !0, g.disabled = !0, s.disabled = !0, i.disabled = !0;
    }
    return (U, ie) => (O(), he(r(at), { class: "mt-2 gap-2" }, {
      default: w(() => {
        var re, q, De, _e, xe, k;
        return [
          d(r(Ee), { class: "gap-4 flex-row" }, {
            default: w(() => [
              d(r(Lt), null, {
                default: w(() => [
                  y("span", _S, V(U.$t("shared.implant")), 1)
                ]),
                _: 1
              }),
              d(r(Lt), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: w(() => [
                  d(r(Ce), {
                    class: "shrink",
                    disabled: r(m).disabled || e.isReadOnly || r(a).implantLock,
                    onClick: ie[0] || (ie[0] = (K) => v(r(Le)._IMPLANT)),
                    iconSrc: "/icons/new_icons/ik_edit_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0", "background-color": "#ffffff0f" }
                  }, null, 8, ["disabled"]),
                  e.isReadOnly ? ue("", !0) : (O(), he(r(Ce), {
                    key: 0,
                    class: "shrink",
                    isToolbarButton: !0,
                    disabled: r(m).disabled,
                    onClick: ie[1] || (ie[1] = (K) => T(r(Le)._IMPLANT)),
                    iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"])),
                  d(r(Ce), {
                    class: "shrink",
                    disabled: r(m).disabled,
                    iconSrc: p.value,
                    isToolbarButton: !0,
                    onClick: ie[2] || (ie[2] = (K) => R(r(Le)._IMPLANT, !r(a).implantVisibility)),
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"]),
                  e.isReadOnly ? ue("", !0) : (O(), he(r(Ce), {
                    key: 1,
                    class: "shrink",
                    disabled: r(m).disabled,
                    iconSrc: b.value,
                    isToolbarButton: !0,
                    onClick: ie[3] || (ie[3] = (K) => L(r(Le)._IMPLANT, !r(a).implantLock)),
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          d(r(Ee), null, {
            default: w(() => [
              y("span", wS, V(r(m).disabled ? "" : A.value), 1)
            ]),
            _: 1
          }),
          d(r(Ee), { class: "mt-2" }, {
            default: w(() => [
              d(r(Lt), { class: "gap-2" }, {
                default: w(() => [
                  y("span", null, V(U.$t("implant-planner.diameter")) + ":", 1),
                  y("span", null, V(r(m).disabled ? "" : j.value), 1)
                ]),
                _: 1
              }),
              d(r(Lt), { class: "gap-2" }, {
                default: w(() => [
                  y("span", null, V(U.$t("implant-planner.length")) + ":", 1),
                  y("span", null, V(r(m).disabled ? "" : N.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (re = n.objectsPreview) != null && re.implantPreview ? (O(), J("img", {
            key: 0,
            src: (q = n.objectsPreview) == null ? void 0 : q.implantPreview,
            alt: "Implant preview",
            style: { width: "75px", height: "75px" },
            draggable: "false"
          }, null, 8, SS)) : ue("", !0),
          ue("", !0),
          d(r(Be), { class: "gap-4 mt-2" }, {
            default: w(() => [
              d(r(Lt), null, {
                default: w(() => [
                  y("span", IS, V(U.$t("shared.abutment")), 1)
                ]),
                _: 1
              }),
              d(r(Lt), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: w(() => [
                  d(r(Ce), {
                    class: "shrink",
                    disabled: r(m).disabled || e.isReadOnly || r(a).implantLock,
                    onClick: ie[4] || (ie[4] = (K) => v(r(Le)._ABUTMENT)),
                    iconSrc: "/icons/new_icons/ik_edit_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"]),
                  e.isReadOnly ? ue("", !0) : (O(), he(r(Ce), {
                    key: 0,
                    class: "shrink",
                    disabled: r(S).disabled,
                    onClick: ie[5] || (ie[5] = (K) => T(r(Le)._ABUTMENT)),
                    iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"])),
                  d(r(Ce), {
                    class: "shrink",
                    disabled: r(S).disabled,
                    iconSrc: f.value,
                    onClick: ie[6] || (ie[6] = (K) => R(r(Le)._ABUTMENT, !r(a).abutmentVisibility)),
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (De = r(a).object) != null && De.abutment ? (O(), J(ze, { key: 2 }, [
            y("span", ES, V(r(m).disabled ? "" : x.value), 1),
            (_e = n.objectsPreview) != null && _e.abutmentPreview ? (O(), J("div", TS, [
              y("img", {
                src: (xe = n.objectsPreview) == null ? void 0 : xe.abutmentPreview,
                alt: "Abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, CS)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(Ee), { class: "mt-2" }, {
            default: w(() => [
              d(r(Yi), {
                class: "w-full",
                modelValue: r(o),
                "onUpdate:modelValue": ie[7] || (ie[7] = (K) => za(o) ? o.value = K : null),
                min: r(s).minValue,
                max: r(s).maxValue,
                step: r(s).step,
                disabled: r(s).disabled || e.isReadOnly,
                unitLabel: "°",
                scrollable: !0,
                "show-buttons": !0
              }, null, 8, ["modelValue", "min", "max", "step", "disabled"])
            ]),
            _: 1
          }),
          d(r(Ee), { class: "mt-2" }, {
            default: w(() => [
              d(r(Lt), { class: "justify-start" }, {
                default: w(() => [
                  y("span", null, V(U.$t("implant-planner.useProstheticAxis")), 1)
                ]),
                _: 1
              }),
              d(r(Ee), { class: "justify-end" }, {
                default: w(() => [
                  d(r(io), {
                    class: "w-full flex justify-end",
                    state: r(i).state,
                    "onUpdate:state": ie[8] || (ie[8] = (K) => r(i).state = K),
                    disabled: r(i).disabled,
                    "onUpdate:disabled": ie[9] || (ie[9] = (K) => r(i).disabled = K)
                  }, {
                    falseLabel: w(() => [
                      y("span", NS, V(U.$t("implant-planner.off")), 1)
                    ]),
                    trueLabel: w(() => [
                      y("span", LS, V(U.$t("implant-planner.on")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          d(r(Ee), { class: "mt-4 gap-4" }, {
            default: w(() => [
              d(r(Lt), null, {
                default: w(() => [
                  y("span", OS, V(U.$t("implant-planner.sleeve")), 1)
                ]),
                _: 1
              }),
              d(r(Lt), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: w(() => [
                  d(r(Ce), {
                    class: "shrink",
                    disabled: r(m).disabled || e.isReadOnly || r(a).implantLock,
                    onClick: ie[10] || (ie[10] = (K) => v(r(Le)._SLEEVE)),
                    iconSrc: "/icons/new_icons/ik_edit_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"]),
                  d(r(Ce), {
                    class: "shrink",
                    disabled: r(E).disabled,
                    iconSrc: h.value,
                    onClick: ie[11] || (ie[11] = (K) => R(r(Le)._SLEEVE, !r(a).sleeveVisibility)),
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (k = r(a).object) != null && k.sleeve && !r(E).disabled ? (O(), J(ze, { key: 3 }, [
            d(r(Ee), { class: "text-12 font-medium flex-col" }, {
              default: w(() => [
                yt(V(z.value), 1)
              ]),
              _: 1
            }),
            d(r(Ee), { class: "gap-6" }, {
              default: w(() => {
                var K, Ae, me;
                return [
                  y("div", DS, [
                    y("span", AS, V(X.value), 1),
                    !r(a).object.sleeveDistanceLocked && ((K = r(a).object.drillLengths) != null && K.length) ? (O(), J(ze, { key: 0 }, [
                      y("span", RS, V(U.$t("implant-planner.drillLength")), 1),
                      d(r(Pn), {
                        "model-value": H.value,
                        disabled: r(E).disabled || e.isReadOnly || r(a).implantLock,
                        "onUpdate:modelValue": W,
                        options: r(a).object.drillLengths,
                        placeholder: "Select Drill Length",
                        class: "mt-2"
                      }, null, 8, ["model-value", "disabled", "options"])
                    ], 64)) : r(a).object.sleeveDistanceLocked ? ue("", !0) : (O(), J(ze, { key: 1 }, [
                      y("span", MS, V(U.$t("implant-planner.sleeveDistanceHsl")), 1),
                      d(r(xp), {
                        class: "mt-2",
                        inputClass: "w-7/12",
                        "model-value": M.value,
                        disabled: r(E).disabled || e.isReadOnly || r(a).implantLock,
                        "onUpdate:modelValue": se,
                        max: 100,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.5,
                        label: "",
                        suffix: " mm"
                      }, null, 8, ["model-value", "disabled"])
                    ], 64))
                  ]),
                  (Ae = n.objectsPreview) != null && Ae.sleevePreview ? (O(), J("div", PS, [
                    y("img", {
                      src: (me = n.objectsPreview) == null ? void 0 : me.sleevePreview,
                      alt: "Sleeve preview",
                      draggable: "false"
                    }, null, 8, xS)
                  ])) : ue("", !0)
                ];
              }),
              _: 1
            }),
            ne.value ? (O(), J("div", jS, [
              y("span", FS, V(U.$t("implant-planner.sleeveRotationStep")), 1),
              d(r(Yi), {
                class: "w-full mt-2",
                modelValue: r(l),
                "onUpdate:modelValue": ie[12] || (ie[12] = (K) => za(l) ? l.value = K : null),
                min: 0,
                max: te.value,
                step: 1,
                disabled: r(E).disabled || e.isReadOnly || r(a).implantLock,
                "show-buttons": !0
              }, null, 8, ["modelValue", "max", "disabled"])
            ])) : ue("", !0)
          ], 64)) : ue("", !0)
        ];
      }),
      _: 1
    }));
  }
});
function kS(e) {
  var a, o;
  (a = document.getElementById("sidebarContainer")) == null || a.classList.add("hidden");
  const t = document.getElementsByClassName("mainMenuTabs"), n = document.getElementsByClassName("show-horizontal-bar");
  t.length > 0 && e !== vn.HORIZONTAL && t[0].classList.add("hidden"), n.length > 0 && e === vn.HORIZONTAL && n[0].classList.add("hidden"), US(), (o = document.getElementById("wizard-container")) == null || o.classList.add("wizard-hidden-padding");
}
function Nd(e) {
  var a, o;
  (a = document.getElementById("sidebarContainer")) == null || a.classList.remove("hidden");
  const t = document.getElementsByClassName("mainMenuTabs"), n = document.getElementsByClassName("show-horizontal-bar");
  t.length > 0 && t[0].classList.remove("hidden"), n.length > 0 && e === vn.HORIZONTAL && n[0].classList.remove("hidden"), GS(), (o = document.getElementById("wizard-container")) == null || o.classList.remove("wizard-hidden-padding");
}
function VS() {
  var e, t;
  (e = document.getElementById("wizardBody")) == null || e.classList.remove("overflow-y-hidden"), (t = document.getElementById("wizardBody")) == null || t.classList.add("overflow-y-auto");
}
function BS() {
  var e, t;
  (e = document.getElementById("wizardBody")) == null || e.classList.remove("overflow-y-auto"), (t = document.getElementById("wizardBody")) == null || t.classList.add("overflow-y-hidden");
}
function US() {
  const e = document.getElementById("menu-type-combo");
  e == null || e.classList.add("hidden");
}
function GS() {
  const e = document.getElementById("menu-type-combo");
  e == null || e.classList.remove("hidden");
}
function ul() {
  var e;
  (e = document.getElementById("mode5")) == null || e.click();
}
function cl() {
  var e;
  (e = document.getElementById("mode4")) == null || e.click();
}
function xu() {
  var e;
  (e = document.getElementById("mode3")) == null || e.click();
}
function ju() {
  const e = document.getElementById("btn_w_l");
  e && e.classList.remove("btn-clicked");
}
var WS = ArrayBuffer, dn = Uint8Array, is = Uint16Array, zS = Int16Array, Os = Int32Array, rr = function(e, t, n) {
  if (dn.prototype.slice) return dn.prototype.slice.call(e, t, n);
  (t == null || t < 0) && (t = 0), (n == null || n > e.length) && (n = e.length);
  var a = new dn(n - t);
  return a.set(e.subarray(t, n)), a;
}, Zl = function(e, t, n, a) {
  if (dn.prototype.fill) return dn.prototype.fill.call(e, t, n, a);
  for ((n == null || n < 0) && (n = 0), (a == null || a > e.length) && (a = e.length); n < a; ++n) e[n] = t;
  return e;
}, HS = function(e, t, n, a) {
  if (dn.prototype.copyWithin) return dn.prototype.copyWithin.call(e, t, n, a);
  for ((n == null || n < 0) && (n = 0), (a == null || a > e.length) && (a = e.length); n < a; ) e[t++] = e[n++];
}, YS = ["invalid zstd data", "window size too large (>2046MB)", "invalid block type", "FSE accuracy too high", "match distance too far back", "unexpected EOF"], gn = function(e, t, n) {
  var a = new Error(t || YS[e]);
  if (a.code = e, Error.captureStackTrace && Error.captureStackTrace(a, gn), !n) throw a;
  return a;
}, Ld = function(e, t, n) {
  for (var a = 0, o = 0; a < n; ++a) o |= e[t++] << (a << 3);
  return o;
}, KS = function(e, t) {
  return (e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
}, ZS = function(e, t) {
  var n = e[0] | e[1] << 8 | e[2] << 16;
  if (n == 3126568 && e[3] == 253) {
    var a = e[4], o = a >> 5 & 1, l = a >> 2 & 1, s = a & 3, i = a >> 6;
    a & 8 && gn(0);
    var c = 6 - o, u = s == 3 ? 4 : s, p = Ld(e, c, u);
    c += u;
    var b = i ? 1 << i : o, f = Ld(e, c, b) + (i == 1 && 256), h = f;
    if (!o) {
      var I = 1 << 10 + (e[5] >> 3);
      h = I + (I >> 3) * (e[5] & 7);
    }
    h > 2145386496 && gn(1);
    var m = new dn((t == 1 ? f || h : t ? 0 : h) + 12);
    return m[0] = 1, m[4] = 4, m[8] = 8, { b: c + b, y: 0, l: 0, d: p, w: t && t != 1 ? t : m.subarray(12), e: h, o: new Os(m.buffer, 0, 3), u: f, c: l, m: Math.min(131072, h) };
  } else if ((n >> 4 | e[3] << 20) == 25481893) return KS(e, 4) + 8;
  gn(0);
}, So = function(e) {
  for (var t = 0; 1 << t <= e; ++t) ;
  return t - 1;
}, bi = function(e, t, n) {
  var a = (t << 3) + 4, o = (e[t] & 15) + 5;
  o > n && gn(3);
  for (var l = 1 << o, s = l, i = -1, c = -1, u = -1, p = l, b = new WS(512 + (l << 2)), f = new zS(b, 0, 256), h = new is(b, 0, 256), I = new is(b, 512, l), m = 512 + (l << 1), S = new dn(b, m, l), E = new dn(b, m + l); i < 255 && s > 0; ) {
    var g = So(s + 1), v = a >> 3, T = (1 << g + 1) - 1, R = (e[v] | e[v + 1] << 8 | e[v + 2] << 16) >> (a & 7) & T, L = (1 << g) - 1, C = T - s - 1, A = R & L;
    if (A < C ? (a += g, R = A) : (a += g + 1, R > L && (R -= C)), f[++i] = --R, R == -1 ? (s += R, S[--p] = i) : s -= R, !R) do {
      var j = a >> 3;
      c = (e[j] | e[j + 1] << 8) >> (a & 7) & 3, a += 2, i += c;
    } while (c == 3);
  }
  (i > 255 || s) && gn(0);
  for (var N = 0, x = (l >> 1) + (l >> 3) + 3, z = l - 1, X = 0; X <= i; ++X) {
    var H = f[X];
    if (H < 1) {
      h[X] = -H;
      continue;
    }
    for (u = 0; u < H; ++u) {
      S[N] = X;
      do
        N = N + x & z;
      while (N >= p);
    }
  }
  for (N && gn(0), u = 0; u < l; ++u) {
    var M = h[S[u]]++, te = E[u] = o - So(M);
    I[u] = (M << te) - l;
  }
  return [a + 7 >> 3, { b: o, s: S, n: E, t: I }];
}, JS = function(e, t) {
  var n = 0, a = -1, o = new dn(292), l = e[t], s = o.subarray(0, 256), i = o.subarray(256, 268), c = new is(o.buffer, 268);
  if (l < 128) {
    var u = bi(e, t + 1, 6), p = u[0], b = u[1];
    t += l;
    var f = p << 3, h = e[t];
    h || gn(0);
    for (var I = 0, m = 0, S = b.b, E = S, g = (++t << 3) - 8 + So(h); g -= S, !(g < f); ) {
      var v = g >> 3;
      if (I += (e[v] | e[v + 1] << 8) >> (g & 7) & (1 << S) - 1, s[++a] = b.s[I], g -= E, g < f) break;
      v = g >> 3, m += (e[v] | e[v + 1] << 8) >> (g & 7) & (1 << E) - 1, s[++a] = b.s[m], S = b.n[I], I = b.t[I], E = b.n[m], m = b.t[m];
    }
    ++a > 255 && gn(0);
  } else {
    for (a = l - 127; n < a; n += 2) {
      var T = e[++t];
      s[n] = T >> 4, s[n + 1] = T & 15;
    }
    ++t;
  }
  var R = 0;
  for (n = 0; n < a; ++n) {
    var L = s[n];
    L > 11 && gn(0), R += L && 1 << L - 1;
  }
  var C = So(R) + 1, A = 1 << C, j = A - R;
  for (j & j - 1 && gn(0), s[a++] = So(j) + 1, n = 0; n < a; ++n) {
    var L = s[n];
    ++i[s[n] = L && C + 1 - L];
  }
  var N = new dn(A << 1), x = N.subarray(0, A), z = N.subarray(A);
  for (c[C] = 0, n = C; n > 0; --n) {
    var X = c[n];
    Zl(z, n, X, c[n - 1] = X + i[n] * (1 << C - n));
  }
  for (c[0] != A && gn(0), n = 0; n < a; ++n) {
    var H = s[n];
    if (H) {
      var M = c[H];
      Zl(x, n, M, c[H] = M + (1 << C - H));
    }
  }
  return [t, { n: z, b: C, s: x }];
}, XS = bi(new dn([81, 16, 99, 140, 49, 198, 24, 99, 12, 33, 196, 24, 99, 102, 102, 134, 70, 146, 4]), 0, 6)[1], qS = bi(new dn([33, 20, 196, 24, 99, 140, 33, 132, 16, 66, 8, 33, 132, 16, 66, 8, 33, 68, 68, 68, 68, 68, 68, 68, 68, 36, 9]), 0, 6)[1], QS = bi(new dn([32, 132, 16, 66, 102, 70, 68, 68, 68, 68, 36, 73, 2]), 0, 5)[1], $m = function(e, t) {
  for (var n = e.length, a = new Os(n), o = 0; o < n; ++o) a[o] = t, t += 1 << e[o];
  return a;
}, Gr = new dn(new Os([0, 0, 0, 0, 16843009, 50528770, 134678020, 202050057, 269422093]).buffer, 0, 36), eI = $m(Gr, 0), Wr = new dn(new Os([0, 0, 0, 0, 0, 0, 0, 0, 16843009, 50528770, 117769220, 185207048, 252579084, 16]).buffer, 0, 53), tI = $m(Wr, 3), $l = function(e, t, n) {
  var a = e.length, o = t.length, l = e[a - 1], s = (1 << n.b) - 1, i = -n.b;
  l || gn(0);
  for (var c = 0, u = n.b, p = (a << 3) - 8 + So(l) - u, b = -1; p > i && b < o; ) {
    var f = p >> 3, h = (e[f] | e[f + 1] << 8 | e[f + 2] << 16) >> (p & 7);
    c = (c << u | h) & s, t[++b] = n.s[c], p -= u = n.n[c];
  }
  (p != i || b + 1 != o) && gn(0);
}, nI = function(e, t, n) {
  var a = 6, o = t.length, l = o + 3 >> 2, s = l << 1, i = l + s;
  $l(e.subarray(a, a += e[0] | e[1] << 8), t.subarray(0, l), n), $l(e.subarray(a, a += e[2] | e[3] << 8), t.subarray(l, s), n), $l(e.subarray(a, a += e[4] | e[5] << 8), t.subarray(s, i), n), $l(e.subarray(a), t.subarray(i), n);
}, aI = function(e, t, n) {
  var a, o = t.b, l = e[o], s = l >> 1 & 3;
  t.l = l & 1;
  var i = l >> 3 | e[o + 1] << 5 | e[o + 2] << 13, c = (o += 3) + i;
  if (s == 1) return o >= e.length ? void 0 : (t.b = o + 1, n ? (Zl(n, e[o], t.y, t.y += i), n) : Zl(new dn(i), e[o]));
  if (!(c > e.length)) {
    if (s == 0) return t.b = c, n ? (n.set(e.subarray(o, c), t.y), t.y += i, n) : rr(e, o, c);
    if (s == 2) {
      var u = e[o], p = u & 3, b = u >> 2 & 3, f = u >> 4, h = 0, I = 0;
      p < 2 ? b & 1 ? f |= e[++o] << 4 | (b & 2 && e[++o] << 12) : f = u >> 3 : (I = b, b < 2 ? (f |= (e[++o] & 63) << 4, h = e[o] >> 6 | e[++o] << 2) : b == 2 ? (f |= e[++o] << 4 | (e[++o] & 3) << 12, h = e[o] >> 2 | e[++o] << 6) : (f |= e[++o] << 4 | (e[++o] & 63) << 12, h = e[o] >> 6 | e[++o] << 2 | e[++o] << 10)), ++o;
      var m = n ? n.subarray(t.y, t.y + t.m) : new dn(t.m), S = m.length - f;
      if (p == 0) m.set(e.subarray(o, o += f), S);
      else if (p == 1) Zl(m, e[o++], S);
      else {
        var E = t.h;
        if (p == 2) {
          var g = JS(e, o);
          h += o - (o = g[0]), t.h = E = g[1];
        } else E || gn(0);
        (I ? nI : $l)(e.subarray(o, o += h), m.subarray(S), E);
      }
      var v = e[o++];
      if (v) {
        v == 255 ? v = (e[o++] | e[o++] << 8) + 32512 : v > 127 && (v = v - 128 << 8 | e[o++]);
        var T = e[o++];
        T & 3 && gn(0);
        for (var R = [qS, QS, XS], L = 2; L > -1; --L) {
          var C = T >> (L << 1) + 2 & 3;
          if (C == 1) {
            var A = new dn([0, 0, e[o++]]);
            R[L] = { s: A.subarray(2, 3), n: A.subarray(0, 1), t: new is(A.buffer, 0, 1), b: 0 };
          } else C == 2 ? (a = bi(e, o, 9 - (L & 1)), o = a[0], R[L] = a[1]) : C == 3 && (t.t || gn(0), R[L] = t.t[L]);
        }
        var j = t.t = R, N = j[0], x = j[1], z = j[2], X = e[c - 1];
        X || gn(0);
        var H = (c << 3) - 8 + So(X) - z.b, M = H >> 3, te = 0, ne = (e[M] | e[M + 1] << 8) >> (H & 7) & (1 << z.b) - 1;
        M = (H -= x.b) >> 3;
        var W = (e[M] | e[M + 1] << 8) >> (H & 7) & (1 << x.b) - 1;
        M = (H -= N.b) >> 3;
        var se = (e[M] | e[M + 1] << 8) >> (H & 7) & (1 << N.b) - 1;
        for (++v; --v; ) {
          var be = z.s[ne], Re = z.n[ne], U = N.s[se], ie = N.n[se], re = x.s[W], q = x.n[W];
          M = (H -= re) >> 3;
          var De = 1 << re, _e = De + ((e[M] | e[M + 1] << 8 | e[M + 2] << 16 | e[M + 3] << 24) >>> (H & 7) & De - 1);
          M = (H -= Wr[U]) >> 3;
          var xe = tI[U] + ((e[M] | e[M + 1] << 8 | e[M + 2] << 16) >> (H & 7) & (1 << Wr[U]) - 1);
          M = (H -= Gr[be]) >> 3;
          var k = eI[be] + ((e[M] | e[M + 1] << 8 | e[M + 2] << 16) >> (H & 7) & (1 << Gr[be]) - 1);
          if (M = (H -= Re) >> 3, ne = z.t[ne] + ((e[M] | e[M + 1] << 8) >> (H & 7) & (1 << Re) - 1), M = (H -= ie) >> 3, se = N.t[se] + ((e[M] | e[M + 1] << 8) >> (H & 7) & (1 << ie) - 1), M = (H -= q) >> 3, W = x.t[W] + ((e[M] | e[M + 1] << 8) >> (H & 7) & (1 << q) - 1), _e > 3) t.o[2] = t.o[1], t.o[1] = t.o[0], t.o[0] = _e -= 3;
          else {
            var K = _e - (k != 0);
            K ? (_e = K == 3 ? t.o[0] - 1 : t.o[K], K > 1 && (t.o[2] = t.o[1]), t.o[1] = t.o[0], t.o[0] = _e) : _e = t.o[0];
          }
          for (var L = 0; L < k; ++L) m[te + L] = m[S + L];
          te += k, S += k;
          var Ae = te - _e;
          if (Ae < 0) {
            var me = -Ae, Ne = t.e + Ae;
            me > xe && (me = xe);
            for (var L = 0; L < me; ++L) m[te + L] = t.w[Ne + L];
            te += me, xe -= me, Ae = 0;
          }
          for (var L = 0; L < xe; ++L) m[te + L] = m[Ae + L];
          te += xe;
        }
        if (te != S) for (; S < m.length; ) m[te++] = m[S++];
        else te = m.length;
        n ? t.y += te : m = rr(m, 0, te);
      } else if (n) {
        if (t.y += f, S) for (var L = 0; L < f; ++L) m[L] = m[S + L];
      } else S && (m = rr(m, S));
      return t.b = c, m;
    }
    gn(2);
  }
}, oI = function(e, t) {
  if (e.length == 1) return e[0];
  for (var n = new dn(t), a = 0, o = 0; a < e.length; ++a) {
    var l = e[a];
    n.set(l, o), o += l.length;
  }
  return n;
};
function lI(e, t) {
  for (var n = [], a = +!t, o = 0, l = 0; e.length; ) {
    var s = ZS(e, a || t);
    if (typeof s == "object") {
      for (a ? (t = null, s.w.length == s.u && (n.push(t = s.w), l += s.u)) : (n.push(t), s.e = 0); !s.l; ) {
        var i = aI(e, s, t);
        i || gn(5), t ? s.e = s.y : (n.push(i), l += i.length, HS(s.w, 0, i.length), s.w.set(i, s.w.length - i.length));
      }
      o = s.b + s.c * 4;
    } else o = s;
    e = e.subarray(o);
  }
  return oI(n, l);
}
async function iI(e = {}) {
  var t, n = e, a;
  console.log.bind(console);
  var o = console.error.bind(console), l, s = !1, i = ($) => $.startsWith("file://"), c, u, p, b, f = !1;
  function h() {
    var $ = p.buffer;
    n.HEAPU8 = b = new Uint8Array($);
  }
  function I() {
    f = !0, A(ne), Ke.c();
  }
  function m($) {
    $ = "Aborted(" + $ + ")", o($), s = !0, $ += ". Build with -sASSERTIONS for more info.";
    var _ = new WebAssembly.RuntimeError($);
    throw u == null || u(_), _;
  }
  var S;
  let E = () => "";
  function g($) {
    if ($ == S && l) return new Uint8Array(l);
    throw "both async and sync fetching of the wasm failed";
  }
  async function v($) {
    if (!l) try {
      var _ = await a($);
      return new Uint8Array(_);
    } catch {
    }
    return g($);
  }
  async function T($, _) {
    try {
      var D = await v($), Y = await WebAssembly.instantiate(D, _);
      return Y;
    } catch (Q) {
      o(`failed to asynchronously prepare wasm: ${Q}`), m(Q);
    }
  }
  async function R($, _, D) {
    if (!$ && !i(_)) try {
      var Y = fetch(_, { credentials: "same-origin" }), Q = await WebAssembly.instantiateStreaming(Y, D);
      return Q;
    } catch (ae) {
      o(`wasm streaming compile failed: ${ae}`), o("falling back to ArrayBuffer instantiation");
    }
    return T(_, D);
  }
  function L() {
    return { a: Ge };
  }
  async function C() {
    function $(ae, ge) {
      return Ke = ae.exports, p = Ke.b, h(), Ne(Ke), Ke;
    }
    function _(ae) {
      return $(ae.instance);
    }
    var D = L();
    S ?? (S = E());
    var Y = await R(l, S, D), Q = _(Y);
    return Q;
  }
  var A = ($) => {
    for (; $.length > 0; ) $.shift()(n);
  }, j = () => 2147483648, N = ($, _) => Math.ceil($ / _) * _, x = ($) => {
    var _ = p.buffer.byteLength, D = ($ - _ + 65535) / 65536 | 0;
    try {
      return p.grow(D), h(), 1;
    } catch {
    }
  }, z = ($) => {
    var _ = b.length;
    $ >>>= 0;
    var D = j();
    if ($ > D) return !1;
    for (var Y = 1; Y <= 4; Y *= 2) {
      var Q = _ * (1 + 0.2 / Y);
      Q = Math.min(Q, $ + 100663296);
      var ae = Math.min(D, N(Math.max($, Q), 65536)), ge = x(ae);
      if (ge) return !0;
    }
    return !1;
  }, X = typeof TextDecoder < "u" ? new TextDecoder() : void 0, H = ($, _, D, Y) => {
    var Q = _ + D;
    if (Y) return Q;
    for (; $[_] && !(_ >= Q); ) ++_;
    return _;
  }, M = ($, _ = 0, D, Y) => {
    var Q = H($, _, D, Y);
    if (Q - _ > 16 && $.buffer && X) return X.decode($.subarray(_, Q));
    for (var ae = ""; _ < Q; ) {
      var ge = $[_++];
      if (!(ge & 128)) {
        ae += String.fromCharCode(ge);
        continue;
      }
      var Fe = $[_++] & 63;
      if ((ge & 224) == 192) {
        ae += String.fromCharCode((ge & 31) << 6 | Fe);
        continue;
      }
      var Me = $[_++] & 63;
      if ((ge & 240) == 224 ? ge = (ge & 15) << 12 | Fe << 6 | Me : ge = (ge & 7) << 18 | Fe << 12 | Me << 6 | $[_++] & 63, ge < 65536) ae += String.fromCharCode(ge);
      else {
        var je = ge - 65536;
        ae += String.fromCharCode(55296 | je >> 10, 56320 | je & 1023);
      }
    }
    return ae;
  }, te = ($, _, D) => $ ? M(b, $, _, D) : "", ne = [];
  n.wasmBinary && (l = n.wasmBinary), n.UTF8ToString = te;
  var W, se, be, Re, U, ie, re, q, De, _e, xe, k, K, Ae, me;
  function Ne($) {
    n._webidl_free = $.d, n._webidl_malloc = $.e, n._emscripten_bind_VoidPtr___destroy___0 = W = $.f, n._emscripten_bind_zstd_version_0 = se = $.g, n._emscripten_bind_zstd_malloc_1 = be = $.h, n._emscripten_bind_zstd_free_1 = Re = $.i, n._emscripten_bind_zstd_compress_5 = U = $.j, n._emscripten_bind_zstd_decompress_4 = ie = $.k, n._emscripten_bind_zstd_getFrameContentSize_2 = re = $.l, n._emscripten_bind_zstd_findFrameCompressedSize_2 = q = $.m, n._emscripten_bind_zstd_compressBound_1 = De = $.n, n._emscripten_bind_zstd_isError_1 = _e = $.o, n._emscripten_bind_zstd_getErrorName_1 = xe = $.p, n._emscripten_bind_zstd_minCLevel_0 = k = $.q, n._emscripten_bind_zstd_maxCLevel_0 = K = $.r, n._emscripten_bind_zstd_defaultCLevel_0 = Ae = $.s, n._emscripten_bind_zstd___destroy___0 = me = $.t;
  }
  var Ge = { a: z };
  function Ue() {
    function $() {
      n.calledRun = !0, !s && (I(), c == null || c(n));
    }
    $();
  }
  var Ke;
  Ke = await C(), Ue();
  function st() {
  }
  st.prototype = Object.create(st.prototype), st.prototype.constructor = st, st.prototype.__class__ = st, st.__cache__ = {}, n.WrapperObject = st;
  function G($) {
    return ($ || st).__cache__;
  }
  n.getCache = G;
  function P($, _) {
    var D = G(_), Y = D[$];
    return Y || (Y = Object.create((_ || st).prototype), Y.ptr = $, D[$] = Y);
  }
  n.wrapPointer = P;
  function de($, _) {
    return P($.ptr, _);
  }
  n.castObject = de, n.NULL = P(0);
  function fe($) {
    if (!$.__destroy__) throw "Error: Cannot destroy object. (Did you create it yourself?)";
    $.__destroy__(), delete G($.__class__)[$.ptr];
  }
  n.destroy = fe;
  function ke($, _) {
    return $.ptr === _.ptr;
  }
  n.compare = ke;
  function le($) {
    return $.ptr;
  }
  n.getPointer = le;
  function pe($) {
    return $.__class__;
  }
  n.getClass = pe;
  function Z() {
    throw "cannot construct a VoidPtr, no constructor in IDL";
  }
  Z.prototype = Object.create(st.prototype), Z.prototype.constructor = Z, Z.prototype.__class__ = Z, Z.__cache__ = {}, n.VoidPtr = Z, Z.prototype.__destroy__ = Z.prototype.__destroy__ = function() {
    var $ = this.ptr;
    W($);
  };
  function ee() {
    throw "cannot construct a zstd, no constructor in IDL";
  }
  return ee.prototype = Object.create(st.prototype), ee.prototype.constructor = ee, ee.prototype.__class__ = ee, ee.__cache__ = {}, n.zstd = ee, ee.prototype.version = ee.prototype.version = function() {
    return te(se());
  }, ee.prototype.malloc = ee.prototype.malloc = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), be($);
  }, ee.prototype.free = ee.prototype.free = function($) {
    $ && typeof $ == "object" && ($ = $.ptr), Re($);
  }, ee.prototype.compress = ee.prototype.compress = function($, _, D, Y, Q) {
    return $ && typeof $ == "object" && ($ = $.ptr), _ && typeof _ == "object" && (_ = _.ptr), D && typeof D == "object" && (D = D.ptr), Y && typeof Y == "object" && (Y = Y.ptr), Q && typeof Q == "object" && (Q = Q.ptr), U($, _, D, Y, Q);
  }, ee.prototype.decompress = ee.prototype.decompress = function($, _, D, Y) {
    return $ && typeof $ == "object" && ($ = $.ptr), _ && typeof _ == "object" && (_ = _.ptr), D && typeof D == "object" && (D = D.ptr), Y && typeof Y == "object" && (Y = Y.ptr), ie($, _, D, Y);
  }, ee.prototype.getFrameContentSize = ee.prototype.getFrameContentSize = function($, _) {
    return $ && typeof $ == "object" && ($ = $.ptr), _ && typeof _ == "object" && (_ = _.ptr), re($, _);
  }, ee.prototype.findFrameCompressedSize = ee.prototype.findFrameCompressedSize = function($, _) {
    return $ && typeof $ == "object" && ($ = $.ptr), _ && typeof _ == "object" && (_ = _.ptr), q($, _);
  }, ee.prototype.compressBound = ee.prototype.compressBound = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), De($);
  }, ee.prototype.isError = ee.prototype.isError = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), _e($);
  }, ee.prototype.getErrorName = ee.prototype.getErrorName = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), te(xe($));
  }, ee.prototype.minCLevel = ee.prototype.minCLevel = function() {
    return k();
  }, ee.prototype.maxCLevel = ee.prototype.maxCLevel = function() {
    return K();
  }, ee.prototype.defaultCLevel = ee.prototype.defaultCLevel = function() {
    return Ae();
  }, ee.prototype.__destroy__ = ee.prototype.__destroy__ = function() {
    var $ = this.ptr;
    me($);
  }, f ? t = n : t = new Promise(($, _) => {
    c = $, u = _;
  }), t;
}
var sI = iI, rI = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!#$%&()*+,./:;<=>?@[]^_`{|}~"';
function uI(e) {
  let t = e.length, n = [], a = 0, o = 0, l = -1;
  for (let s = 0; s < t; s++) {
    let i = rI.indexOf(e[s]);
    if (i !== -1) if (l < 0) l = i;
    else {
      l += i * 91, a |= l << o, o += (l & 8191) > 88 ? 13 : 14;
      do
        n.push(a & 255), a >>= 8, o -= 8;
      while (o > 7);
      l = -1;
    }
  }
  return l > -1 && n.push((a | l << o) & 255), new Uint8Array(n);
}
var cI = 'v7#aSXi3XB6yVnyKMN4c9y}4NTtUHvlhIiyubH?,cwrN<b!/_>%C?,WrJ:2#VbTPN5K|Zy/CqS,O].`p|qnZSnxP2}T}/s)lzu/FZb2{k>qj:^|;6W8XmJt[_,O9/8,<qJuCK@f8I3Dd=;PK?]bmp:{pV|ndGKih6>.PUxV)D9I5djQ=v)dQc]xSk1h/lrI5K5IlpK4[^ujw]U?a<}/IK6G((^g<62N9:@%xF;A!s~>*{7.9wV*#B^nR[3gc;m0Lnw:@dUh8+)8TQKdMc.YUIVT%Mdh^OVE=YMv}P&cri%<Qi{zji_F:D2G9$7ktvk5Te1QeJSJjE8=O,35Up8k5vV26E21{Vs+gE$Vsw&@f4jW%x6,<_{H{{+X%me8v>$PV4W.y;QeRg9@AZ.<Ek:QrybTek[5Un.<;qD4}q&K!g_vfohjd2D{:VK,yNel?pP~&@7ZQ=Gx7&Y@|yC1YQQh3u%X#C%?3xfZZwKE;s6MaeF3o>S)1>r?bO`@6kd4iF{cYiszQQnak``^^<2cn6Kvw/jvs*g/0T1Iq#%2&6=Ix0M?6DY9bN{Qr+|j{bHs|C[OZG[0T9]$Dt>f(nmUb+d$%6Yahrqvb89t=(lW>,5Oe0h7M=+~cR68+8=%YrJ}ng71=lm;99,$,n5$GEwMkEIT]$Se$*fKwdv+c>:[lYU65+]|:N4z$~7K,H/n@HP{jF`Ke{N%My3q#q3peR&DW(A.Yk*PJaHMNbgP:R8r0N.X3!YX+@`xzJ@^ie6Q0iVdP,dRHV6a.Ppd;X0rqwk//Sky(RoALnb3hD4in&X@qT1B}`oQf7X(*b=$7*K{6H0+lXYF]U$Rs;bk7DP146H3{,`1bM11$/eIq[3(vEIoZN^YwfV;R|;Vy{N^23o}&u[RoI?bx#7}PJr;2x;$crYKJXACJrkPrG_$a9vU4Px@322hz.%$v?38a7lO9:w18=O".cyyRM*Xl8=1{wHb9T@77.98jXr]VDWwF:U$Dc3eavdeV1o)/(XCYcP6B=/!l=9vx];$=Z@XK#v0K<n|]O)Wl$=^cn|xJ!zGHJ8EU?blAPrQM~EggFfYV^1cm6M{r_+FvMv.r"AX;30.rag*!W5P7xiuf,9wi!a;[{m,ZMDw)!X{7Heu_UWJ=5QodkJ,hSn][*L;4^qNUZJM{R7^qdw[rfr=Ezy62*CDm5GxMX+!e"Zd0,R_rk{h*_r$`c}Lb`]{0v4Qp*^`pl[T$QO<^=]5;Tnr8~$g^Ah+*7+sKy+H:BPy/c^l$MV*lUG<7xHGM3TfrA=W9dm:DsL,/JoB3C6>^2:,0Y~e9/RzQ,$LoS5x<U8(?GITk1Gkhd=NM@P.5Y0&QKkt^"<Tn0^A95<@[_StqW(wf:*!?1Y"g..8CGlP1<|rk=s6#z_e~"Z&KklOv.IhD/x*^*azUZ8ykU%l>ueQ8WIe7)D12Gx>[vqDg0,_t8pMTZ^1NV8@Kc:Ya=OZ8qOweKNL/BvmIi_YY"8l#5a}dv)gD<7h4X6}?.>Fvj.2.x;:#fi]xN|m=y~Z71&C9[`"U5HQmL>>X}Dq3ug6#o9d!zUtYcH?b|QTIOgfVW<5("fMplfczN/SqNnH]G8w}KxJ+vUym&O~PTId()9D1$4thx,/^aac/zwOX#dRE(p[ovIySV.}g!%oUZ6pzYa2d"|S/}k+dtR"pj4LonSi<lF,=aYrH?cF0S$wORnk{|%ZoDdK$@OJ6E;Q>z;iY<@zJ<sVWW$zJ!{Fv;QFqJ@kH5$/u0[X`FlP1^Ph_!80/TNM2.)|wR&!]6@RVzr8@Lpot6vEZO,[)i#FURXgj7{d`Z#>^<V+mW$)Yer/]nLpiz:n0}QA6kkT8.]+]@Dcx.avUcxr5GxPSGWsXPZc9*Rw2or+6yHV60^SG]Zk7R}nlM{l)6Q9.8ghYey3oXw0pVh*f.xMnMTP=CX#9H`EUa,?{feY{Bhb=De&3*wey$!Yg_%k(>7d`z0{w:<{<`q<nUbM>~Zn{erp>Q_OS>.To9>Y(jV;/29$7n0}|}?e:Zg4x;|wCX]~*~|AyW8KFJje[u~O_5hwraoPqK@oJ1L[yp+<7{z{N3:@bL{iuucG9|:;KWpOpAq5j}0Zhps@3xrm`p7:8u]02V@8bLgOT?b/_a!r/45${Q_u~:8!%sU05xKYkah/gY#N(`j?gPpeXR%P78zor{4bpa&s3:!p@1Q:RD?Xl}d]lo}R~#iG4o:UyC7Y#@+>{=Ui]>>XlVe87]^%{_<,?1#*FI>YYDX4L.EG4$IXO_[ILp@v)fr)HetHRS@eWKC{Q*/zl|bm7mj>sEx*(pL_Q8PUg+v;<aMjs;R0sl+aBG45,DF&^%{TJV<HfvYdcyP8BC.DS,Kf&%&Nkts}tEs4X6.Erwe/Ag:E8?8#]l$B/Br7GPSIgG`Mz(eq/f>8,Mh8;`KHxhN!HnrU]A;t=@MZl;4/Ih%b#"(=Yk=)bZ]Lm^2+*g|TIwa_%O6NFFSVOK]Oubg$%xmb&li)mjFf60EUm}q32S=m=MFNg`n0%UlZp"ps62]t6Cx_.]#6?^qBlU,/)INg>sL].=&TlA~v?T}Fvk`o;m=p@mtZf)g1L~q[w7[dY8&)K],3*f]F/_](`;+XN?%F:w]o:D)~^h{8]^]K_Ld2"jtmo0w;aYN<a.<z![7sy5_q&5n5KC++d@g24fLCf(gW$68).fvVfZ8Q)A,EChnY{FTBh$,u,m;u;Ikv^q8*zA|)S_lervQ$)u3(%NJ{657fmc9x#s^.[:e=hOuPdW}_LfE6B^V$,6Gy57<Lz$vedrVEVM/{ww6gVC`"U|gN{)]^pp;GoNT9a%pW(J$f_IZa0C78^E4C79gQpiy{ZC6<^33%vi.[?QK]}`@>m?NW_)/tQEl@%2<.#16p5<lws<r^<^i?NhQ;<zV>,5MQnQhy3*ex)A|P}:I"pCP63+v72w[u9z*VK$/Rnc^m=FLp$.Rx</#_N}VTE"W#%r3ZmLoF%x=Yp:lGjtT9n{qq=q=W3R;mPI2;$cn?{$R|=a1|maH:pW>Zj2iU:"pPSI{HpAlZZ3@sG8^WnCpWs"68wU[i)H_KZragp7a]m`{,EBo=@l!?odq.[(pm8H:)|zv/F6Yb7N&pu0_:`+)T!e$Z6lS|Y"?Q2JC@Fo6v&6Yi(IIw!My2{3tJ.EB%[^p,[7"sJy4"Ha8""/6oXe[5=/$@pkqod_u?pDFWd5=q=cF9,),AH_[@hJ.2=8=q=TUvI||14JK5.N)L?@qmQW.XN"8Ea(7pmn]k>5QmW`GJ?lriW{zoqG[=&s3n3JCk/|ONwKQf2F4*C4S_:(b`fhHa;RnR<C@Gor8K3R##,MqN5Zal!|`rHG<qoXYR&Jp#va<7`Pb`GE>O%^$y^rrr^UsV3>c<^?PA)I5s>^oi/<Q@ui8E@$bDc~%<`q)KlDh1@uwb/NyhF3EXB6t|f7eClFLmI3X9!W5rUqXra;$(CN)b=MgyYxmr}br;{HTa^2$QO`abCY0hqB4@>j>(o7D;/`Kq%1P]e0hxKaOf4+l6#9!s^Fqs65lOX6P62el2T!,mr4QXQMds6=#n)J>@kMTm>YmpFs/Nan?TiqpW.b8x5cbU|VTY|wH$RM+1KBZk7r^,Q<fun(q=)T$OU7H.5#<];l[y}[rMMQ6V:[#`>jmj}2>{8Fha.Ppi{JNC_oy1TRW]4[UBFMIC@~q&y2|JVPVfBPRpAf*BBDEsQ6&d~qI]>ytTC{IMk^3>JuI^>1tfCrJWmg$A^q_:(VBAFEu1)oBJGpZfDGh)$>h!t(CNLDv`R6}`9@(yB*CIF$UVB:VA<|>pt]BxHgoS:?2r_=(iB4FTL&Ov^:&rI_h&tCD!IyOVNH"N%)1MB;adSMR8Ftg}I*kQ)ZZ?#UU+ks"$bqaq1,uJH~1!kp"_fJ=*,qX)*3P_gASJ./hEG1#ooj/cuzSTPq1vukG~19kl"Ijkwh=vXG>hBVH0CdX+XJJHi;?JBoa{m*D8_JYdPRH=iey?#3N{Z`$"1aRufTNRam:amB[c@!C.1qdhu~>yr.[M@5d4dCM;L)Wy&3wB+v=|fRu0nC$V&v{]Kv.~NHaR0l^5rMz;VpD^Z|l=Mf#*P<0{,JuXw!!mB*Frf`#%P{M$P1*5xwPdq`EV@zjo;>k9Rm#Q1$f{2YX`F|w!I`w?TC2$f#L&Pt?`hFD)X,u_qt)tC+$?StDCCV/%To;4V53P5umHNDM0qrEd0jdg>$Lam}kESqkjG<eO%qi|4#L(j!*V+cUgn%j.f}0w3wc_v4XSh]T/Z)kJ6"Ou&J~h0Kf96^]S~Ae/"C7%7+8>)l,a.jfMRE?*7=^02B8?b<ZO,udh_>7Cv_HCV>{WpOE24KH;6|,;#x<gEW8g`p;FKrmtn`Sh:1J38xiYV"%QO!8+#<]^68?lw`I(oq;Mgz}8@J/MeN53$<`E@V@wQ9qfhXZ5_v!?k5l=*ESqkX:9o1PLqq=r6$omX,TszM.eXmZ&ZiQCN9acRuLy9]OKhl6ITn0qwzoXU?!~dnc%;]P#hch8zu&>M>d2Wu!Io8Wu!ff54b[jj8=0JElp;@x*d0bjl3cx7E6|(4%)wV3]5n<tKz,a(+{wE%)RTnOsz{<mz,&WURPV;",xH*c_VG$eWts$|^<L9.qb`<{I=|x#eK#)?<b6lUlIkablmCW.|m!t2C)/G0Vcwj`syI2ge6psfB679x<K.>b9gZYio50`VF]*BVk(wab)D1dh2{%L2].,5=&=4k;<gYUjYvv.n:n~@&UZ0wH.5p{F6ty%{2.n(*1YVuVvyNDT]+b14A19hj%P7|YJFk@8R2Ie5QPGD`gq!BPh8:@RsS+ej8XE*O8LpKWx_uz@H=86n`k!6[(^d6%2c%PheDMVTRT[^VK?0<7,5,ZQzf%U0QfldO5qO7dM$CVzOHxgG6g%Pi;N.Pyd;9.Av|o2</JC;8FD4Dx9]8a@C[c*M=1]y2iB[rNnEVDx3hetInSZ<x4NyZ3HF8:dkWnU)e[LW=|tyGYiG_a?y%R:d5/qN]DJe^g[6,E,TAUwU{2"oyYvwz%]8|cdH1c/[fPOQX.dU}lg:].N.*gnkm;8Ln$=l0eDaXD1@(632;5y41aMyozDNksyV#*XD+)hL10IU/;|LLRmx)<^.[7)*Ja_lh_]5n)rqOd^e|FVXCljkBc0q]h;&{)cmkdLy#v^GCc,6/;Hb>OXE)Pmc8Y|8?SE8J$w]G!/z7{d,Y<Jo[zqe,u5zpP1QQlq0nqF!u+Av"v*5bZHwG!~gN}:eb>.+:jMavO}/dz=fH8G:MWS1;8<f3BCN=_npO5PnEMQP#*TfNW5by{V+zUNJ=iymMTg<9aAuqH9wZ#*fyGC8nBI2&l3_?5Y0jQ]I1@n:8du.;qgr{R8?}kxz}b%r9erXxp#Fji5*AzC("74=b7MB|K+O;lal@XuCjGi*ds"q+F{E/}6%<)O<6gR+lTzrDe!F{Eb&gI:?&r%Q3*q|nhRx^_?&gI$~`fHd.dp2FYz}A]a{vG{z(S]S"C*T(!L`(]$PheY,pv95/j;O|dHU*T5bY,L94{O8R|PbvOGN3{o2O^{ShNud<6bZ@]R53c.d6LvyiSCp~juvcDqXpPlN0Z%Zb,<S3h}anfn9mj3NURPe%YB8LN1:u1@LGGhZv`g{eQv_sMNR)L7L9LBw&+lN"Hoi$GERy19Fe:}kMI"X)6dMgG$G81J*.07[~I`+11XjlNQSgw;a2i$Glq@)$s^_#G^yo7bLv#bLEU>O;[lB*N27eQH=`{28F#S>hwQ`/L<IBw#aE~i!bQiGVGct?/CSn`{.u2f1u)Nb>rlzT+.M`cy{:qVhymn{`3QvFI4aE4T5R*9*?7AH&Z]]bO5DM?pE%xv7.G$88Qn#&+,Zm0^6OF35GQP}F,wL<avn+C?$)@ek$QS%!_Y?64=rB~m:|wmQl&X6fyJaYec1pe,Sj2,=0S&%o]npO5PnQ7?c3N1v~1X)#UGGcY%_:Q4{v`;);6*:SZ:q2lJ$+95#g1va=a2iaw%,#)"j]8<6Jb@7{0a{TR.s=):6*PBmPtB?S+Y~3B!97Oi~BTuDIpilm459Z$zJl[64m}?]:;092?U|k>zrX_IrL<L@+&U>(@DNJ4|0%ZCj9Py`iltEadf3eYFS@e(VrXX98r%*oJaObZ[yeQblYg~.f3L9|w$i0un/W)1TtO~JKq<"B{a13j#:[GW*I6{ZjNv2YW;W.|sen67mux>[K=$/]TbRVU||DGPlsS{?)Z:F(%n1R1,a7I9|TJQF]8#>oJR:Lhb(o]nxtUC>K~U:tdbY%_n9OE~b.dCX}]wHQ>vO2z<{4S9ef!iUI=L2q;WjE81=;0/)P[0!,1WZ0e7C@yja<`>+@?K)q#!"l;IsWCPA/aMg7ATn`I@S]C&f(@2EVX]C4Lqu/FK)HDHIh(x;*K9QH@>|<SYpmy0e%@L:(rMq+274qHZKedt~3>5e`1a#V.4f9T<r&KA[i`x0*rqYoPTkaPQ[;/]eOyyl@&f28:pV{al+A(E$6eL/+.fV}}Jf^U,Yf%*HciMB}T7(?L*6t]^{2aCJYNS]7=XaaVW6#q^|U>Vq]_~H;/B+/I"Hn;Wj04Zd+lg7M)],hCM?lxhe>T0pI+Fb#%0ofd0ps6|d3L{yja7}6a+5jr>z7*0vZ|wzD/UlHL;E/n+CZ&6uM>sBwAF4$`@A|1#K1OaV/kp&Cvbw$ax&)T[vri>maFsk//5k.IOCJlr,SJ!{D&`=%z$yri>m"*>]Kxu,*!lkR6<>Wo09eZlQIURSvSO}>+5)=wl7Qj>:[Km7~&(^2:i7LN78/fB8v7NQh@D6@:aH+scoWQ]|LJ2NjW#/U8rX!9yPd1.lKf;%lP!,yxca!,q~6{TpgOxsFP14~7GrX8L`~8nZ2$eFckF1`bxn,@1kJ$gtp#70va91R*ZxTxu,4/kN(EGgu=,sZ&qmG4:qMM*:9+WU/kRrvEKFUDQ|S1n5w48V6zTA4_L?Xl<(+^%{]O=$;<i5]w&S%bs]jab(6frJxLxMnKo}PrV{[{f{|$~vvyx|mxn=:H/kOf_O7%2p&//*uoK]cO0Yh/p=M0Cah0*#R,(A?UD7"b^S<lBWE|_8F}5[74&KzTc#J#F{oy79b.E_$qZagf?|2=GPXC~&~+SZj8F8"bt)N{rUdUc[k>6Q1DW:Qm){o^e(9]`=t[,S&U^fWVf3ra.lsR={+p~!>*)l~_b/e,8od|rm2kH]q&3WY6T@B;D]c(<6Z^.+d^d6"7Y5GPkji[[!2zI#>^=yl/!ZD)!Qk4f:m5j]J[yrrEBopu2.dU)Z>MXymU/Nc?dkY9$bHV3C|UD&Y0{zxgld}:5on[eIOdx5K|b51/0h>CTk"?(g~8d.q3XUv)m_1Y`&ZUbU;<KQ^`UO3X;J,<i<l/c6?S7a`0_aPa8|!|_8j%&3%0QqQr*g[#=;{<_la+nyuJyf:<MP34$}f9C:k>`q[06;HpC>F@o]<K,^Odva<["0/=E4BOBR4|pfrYIqH`^0vQ]}grj>Ot&sXOO]o57/w7x;.xq$K$@^ek:XK?)le9@#1u!~:8,<>xon)lV.Od`=mS36L%a%^gp+1<5/PeGY7)}=|me=y`)bikA/cM.[uRZ^Qu5Yz/4SSraoep6O6$7!H)J"9r2aM,?fi4ChuBv5|Ov#LTJki^+:7ilC$?7ZtYH@r^8{0!7mX>}|s3`=ulXmTVyG`}NYAV65ou&swTM4~+Ds*.GQl3(&^ob.Y]$`Z"F_p,:?znotpuqDd=xwmw2oS?]n?o|U^ChxFk8cjSm/pVmq%?G}N%OU+4Sx1J|TRJd1#p[`IJgEJbN82=zUL/uo^Ul*OPRnhyLD&J6#PCh8wM%p8xN%,pwFakjo.P652]<9O/m[OUbl#oHKE/ku5<0+NuQ<kuw3Uebz1|,9yKuYre#~G}NnbQC>Y%sF^l`Uz^Y7Ey<<1s;#zxM6).1K0$oeDihx7[;&,lK)zXmSCy[70M]/Q()q3{gW]v7[&tpYok50T#Cxc.bnxkr<)K;hcE149[^pSQ&6/V7D]XvY6[]7a3aBy48=WV,(KCIaUEE!b/)="mquv8<`HbcH<kVhr}dpNJ,XNzw36}c;>m?Nj[vAQJd1Wk:bxcP,G92l!X%`+L,.{YU.xfY8aPZ`e%kJh).*Lnhcu21@HLgu|o#oPa~%M0(49V@uGkXM%K5gK__y=>H8L_A|C+w,a(%*T4,6JLV$a8e<;)?[3o6Mw|hv13a3&x1OvR.[t;gpr%oXmxe1LNOSV=8lPb$#:)YqMMd[9NRXzU*P^{{%d6UyZ+h04Osmj8nV6@rUY5vfac*P_{3eUZwfP#[n}P@.hcuOGN&b)b*YO5%o.VZ[?%@.<`&sC`#,3T!;3#}w,<Xg,U#vDG}By4tOS:U!Ka+Pa$B5#+#l"XvYdcmgqIXJ%_xcZ>6/KWmQgKB$@`L?7m4`VlJ@y5qpqVi4{=zwAkIO~U`N=Iv}Fv0ec]!pa0LuC"i~o,0kZK=TG4`z}pPHmz6.}>JQ!#H*"(r}%%H,(b&^@8h>"r=.O@{4lU.=ObV2%Zq5LUfbS(ER>+zq735;y/bI$Hdlad2YQ[v||9v=`o1lA_j~`UX++`%v>IXFvfGq{Y;I^P3SM6^?O3fduTQVx(uGfB_Gou[((u45oPdOzjuT|}Dg?+CJ{QX]Nm6[+|r3[B1UzoUR=$2n5>M6Q)i6@bf>76_ejkEhMe/IH8uuDe:&BPb5BPH%BPB%)DJ#b]Iz*!Bg4HC4Ds5_A8wb!TEj+K1/"zDJ(22y@+"db0K4Y1V+iY7#jy{=QA!rm^qU,SaKDBh*zlI}r}|bs3!2|BeW+sXAG9fCcrc3#N>K!C16IT9:kV7;+tnLF=_,k5EBb?X`uOCh>)t@FvJ{>Km]6v[1i<?IBo,E<XcxB7g&[d8R)[|i[i]2Nb16=qF/vIHSM+e;=6)gH7e9x?7]2Ciri(99]r%2$6&F7*g}Bl55QOLtqD4n8ZIV,>&);v9X$>|4>p1|9>&BYSQq3(sj?90t0yOk`6>Lh=v:CB4@QO`6D2w8uTr?Y3<aDcwkU$v[GoY*f&|0ZhX13#N1U;x`WZ(w?KZV2|"^D3}yLA56fN)*&YMcGv8RC2=NpN=^cOdk.]!+GC}W]V_A5}ln5qxt<H?NnvZw<KO^FIVwHJ~ZFXEVo1nxf6kZ+VE},%)Gj]C~Jxa>/rUSM<I?U}>]SDMXi9nT2,!v~jm6y9YO$qPrALHsDTnE@>l!s{%38H{Uw2.Bw1TpZhb//&Gd2x&;pxhyB]Edu.v.r|0c,bL8=Oah~&@p#p1`>^]2rst3Y@`6{`s3Q@AWA,#m1.09XKn0.ykCx@{@rk^i{nc5wo)!Q.R4@xd7(52?p%),gvK+5M],*b/^<1Z@0$0e^"_{*84c>{6U7{mE_=VEpuYNK]V1$sIT"pieQ#T*W..N`zXrYQ0!Gk{_Elk^Sx_/x24v!CVC.et{K2[h^n+*9f3KG]K2`"!Kk1jLW!^4TSP!E:.i_yh`#Ws3d~DV?Nxs+1?E,>vsCBh*1lXr[<{%>ZVs>g()}]V*)t"M?Tf>]`fN6<9(,Yi;k1]./XOk=+m<k7d3R+N,Gd#LAP<!ZG)x%xb0"Uzjqu%9QUy<Wt&lQUx<Wt~YBj:X<!k!]6HP,$TWahBRvq/c~@S:J4cm8&Oz6,^b6,uaZmoN!,wHUsIWVKS%Jt@be1)as%@il0.B,8As3i$,Bnwzm]S[!Cw?q86NZ^gfZx"UT`os_=mjH%IUA&6{l.39=)8)E*5v6K=iUw?7[8.h9n=>=:aCz!ain/{wcUi]$R_7Z?$2/`QPobME]gq1=D}#K]u|(;.b>txj$pXQQ[#t0xa8nXR_l~|FHG:bs3).5cCAJPX$NTf_F}6K`QXgN+W*.2qD6p:h[;A#k[_UbrTC"pJd6A+3:,FjNDzvZfu)@.8BZ3eN7}n#"jc~M+rIFLJK$^iDs1`rc#+pk.}Yp.B7}ZLg3@(RHSw>ddU%5"=d{u4<K_3fXnI]2|c;P5L^M`Y<9`psctxg]o1c5GVn6Q55}5dr#oY4XN1vPruMbd~]Pb9Sa^$K<7yPRGAJKlVh!y7{^4HyZVeU4(Vr|>7l:N0k0<P[{4[6N(nT9nf?%l2/o#L5)1.SwQPqGzvrlZ[E]l7mNYq3U6rYmF1i3UT+>@^[9<29En^X)/(X%7_U^ibt<?XlUB(b1?XlgUU@,y8QiS;D;P_cS31/.zY0[zv#CNX2[5tlM6KWT$h+1712_]^SBpaYa5|(P_Ivq2t0f]s&}M&ZZ7sNnQj;viCdBrNxg2j&$UZQaXl,B7o,(d3h^y/IIq.+SP3G(]<stS3U~O=6H[S+4{H539p}|j1qwVhsHdcOfQrZfR*k$q5L+:K0ou<CnC1dHCZYedB8omVXCd54]4aOVcu844%0QDxQH6e&:8bX4wHUnO]C5OVX_8TO@v!F>E+mQj:7xj}7jf%uV5VT_ZzP81R*WKjlka<mvhR`<^QGMTn/+vCF&N@Of)R@jXBF%y6o}J{ZFqe0`w?Rm[86;5$Z7LzLxQI0(VhO[KMb3ZVcouC2%RG9pO_Lj{=B9^a/drLK6Y~pMp.|o8(!P8L}oEWl4:cKi=`2]7a>%$>TFe^gM^r}4oEKxmFLqsah/rkd#x=@gC9f/FVX]C&N,TGZ)@@tT_il}ys5gj+%:gJ6.lzI%v_L$9Ye|<"7u8]kMoSIiNkq&%gK`7MTq<vk6|GeOd5@~U;I,+kGQcE6&{pzmQv_C{?q<{,Fvrg<^.28w%tLqu^_+V{/xvJ&#yGHqd7M5+hYeX7,pD!MbJYD.TLpSGB$^C.KT,`Z.fL[ym7:6`fx`0g0G:pzDd,*v.r,(dB844)$F0{WB;"0C2h*c:O]G1)Ddq~P@)z$4yjR9g2:x$Ki)@k|nhRx^_?&gIMb8c<ti@&Z"q]CCNvOYbsOKVDT&Zq4g0]W8ku`aLEdVrN6V:QNIyy%%ZK=Z7J6{S/63|7qY,*/LH2&]+w.}Vw>`V?gM6KWW<^hX[Tm;@Y<GNB~M.ced.rmCe/F^tG:^7m>2alQh3X{t`%owPy!0tyvpIQVa3sLY1%Z]^h@_#fj[)qr=nHLYhpu))hW[.A6hFhxlR7*wINiyuPG!Y$I;iZxGRa)HDfMhxlRYer4T^9={4WpBw0iYdprPBIFeDifa!nfzZBZ}Y0cFKqjwGlZT.Na_l:V7BcVH36MI[R54jA3iYWV8gb!p7(i[i]l^v.E$y[y`JHgbvi(h2bI=hGH+Jp8x=H:`knE?1v!BR|+VH^C,TEW!%HlEO$b[IpOJ0)OozHNC~fH49n]2:>&$Y1`3Zo*#oxLCm,Ls5}4#>/gwpATS7s1&~NHcF/i,3j"L#:db8$xS7QN@&XaqN9^Fd#*.z1buOb25RTa&dS2|ZKBNic.ims@6WgT#b9UsU#YDSuSHE8NG,fZ8^^LyZP`gj#7XXAG+kaiDPv0:06xo,U6v+UlLa=4:IzC]2T7biFa8FMaoTyvizqZ~Piu$M64SEsi:k3Hq7#OCdvHU!D6;CH6&2w5ZYWB6oyiMB<y#XhzGH3uAMZhNM_,Pzk)bXO5FZuOXKY^J5sOuVT{N/|c>8P!:Xt)9R1c%uiiqB1N?t/JIzz)DXTPA<5Bz&G%Yn796KmUblX3:XMrU)b6O#svP584&+U}Qv|!g`l?=.Rugjx?+5G640zy``R5pO]IO0X34D]2TO8t6wi@VgYoQaI!O,BlHh{mj2q7Dl(x|fW+$Y>gE~h8sS/6CJF6yofhoG+5ozA;{dV84uN!fxL3C21vAKNH.5mwq@&gbwD.BR@eHq4h|YR,N<DigMvSB8B;Z9;OCLHU1/$Y)q9LEUR]$xI$5#FNUGnJc@#vY0f[):zcb7.z8^mGM3XXS|83=&>XLlAOmd0N)72S;+dUtOozqzS{8R>6rV?!^P/(ucwn;N>FuI]gbtii8BU($v<klPV9Q!!o4HBi;{aSCL4CWl2e2i$G@J8{u1@jlNbR$BY&eGjsR~,$A*Oum&rvoQ($wk);o;MzL+O4e<2ghk[+R*Pvs%UE[hS:a?jx:}pPrsOxf|1J@M=QP5rL;V3x+9"cDlhKZ&sUZ&t~A(Khi6uVc>tq~jRr}f>i$Gfcf?A~Rg<Efm(FSNA/zQmEh<M(,L67`iUWn<9d9&{of&oS)|DmQN?QkI8fa9]38jfr3qt*6()@bMr2=>EB{nO(6:n0k1a:8laj[&o3dNE=P4CxYtv>HT;.Z]=pw%UE[hIu|`CKK[(@8{I5GI5._mS.W}e8|,X*H(+O`Owhe}v]AI8vj8=R:/dr]`cQy^5bZ>A#Fuy5Kp$=zC$pY^R1<60/4^vped]+mc(M(qi4}1q~!;*^>mr&W{np8o,&k|*`vYr}~=p_OuZ:j<53Z;*^>mZI^ep2LgK,Q4FIcW^.:$sV8&Wy=^<Mp{Oe0b/GTe0b/GTe0b:z%ZKY}dK;fp%XeRW)vOR,rUszjQsb%dKe{/gQcmK>bKg*KlN&c=b.EcS/j%5>3~Ldj3J]Xagca^bVLn{dHKaIm6bCASM?LoK4pER_px]xLdjewX>^B;30q8<mf7$RmT0NZxmR)mO.32oDIS4/;)jyo%~5DiDdkQnG=Sd)C]FeKf>gDJ~MP.KXb3DdK!Bknb|<Ac*Vz}~UN:+m&xdi9,JX=[[_Fkfq+dc]MfTWRkoUy^QxG`r/W#>^I[X`#LC<vJdyDhspw3b"rpHS]U4_BFKK]^bHw~S@(K1)$idb+PQu(|%/KtXYK^/.aRvU4,R[GH:`k<Ok@Zs[E;+MYJjdR37or~zNz2|q[VgFrdn+sVZ[Zgf%N(X+0e7}A]:r$rMMpg49#7:6pPg!jJ4bvcpJ<?Xll9skB/?wx;!)wJO<%m>1Kj:FXaP+ixMw+cT@|O2=n^M,?|^MoVxe78QD2xs3.<PEk:ro^kW.^qdjo}9V>f3ht{(dC.Tos{x5P]6j!0]x+cWQ8SMa_4M3XmkXcJg9EayDp=6t8xcKsmh(BbilhlJ|7(0vkX<$F?X}[xm0D#mN?Vn0o0TB+$bch?~;Uu5kq8|5Qe%^$pm~hJgHHdp}xE^CfK7`z_$/O3B%6?9)AH_BUsS_9}s}h~[{SV4nY*e[044QeUj2>@Fi)[AXg?90xnj.RQ`QckO~!qX77?FDDc5eKz9eXG_[pV}yy#<R%vTP;I}a9`7n9+PL$CPG^F`*=xsi}Uj82GiIxkU`TJan=NvAf1FC%VZ_5Wv&6((!JVfBrd^6yzgOQ[nR3K+U|;:^,>pR:YnXES,>O3|86"~i!j;$P7CBrcnoF>0ESuB+%:_sS")%0wQ_W(Z+]4y[C%zUz(A~z2$qZ7i(@7!Sf4Z8N`sHPdy+>w#ntb4L[8*7AGZ25w8MC"tB<ovv,:moK85Dm_paOPBcD{s]zYiY8+E:aggHH7m<Q0M>{8C"<*JoCpLr}qZVHAk8Tm^[i{$27W*yOr"O1e8j:bm_}Tk_BPhMUpZ^nxHzknS5`As859+>U59,Pd{nVhugh6Fl4q?[vTE5@`P5JV$OZxjHNZQGZxJ`vly/X"{N6Ro]9?T^XC3h/3:>9?7(ef(yZeM<@["M"Su`5.25Yg50llJ/+`jX}X}GOcb8N[<SYWyW+*/@jn"T1/Mc|<I7|A^L#A5a%p$r;;h=Y9"60%4/B+cPY]S^4,a(_*nYZE*xbzeN%oaX!;TVHnhcOAvbH7m:.)ibHq$>rNOws:R/+HRzk@4;Nyq%cP5P_oldUM]7;!NJ[,ZF/9Ms"l5*cPGI>*wHe57GF}9Sc.cm[V~E|%lH8d";gt%bhJGWV$s+^"8S[dH`Opi]7+c%c7[Y1;vW@HX6<Ee2RgU&7d1+9{b7Nk6DF&25,Y=@*`uW{NTVl:W{4<{a1({YwDy27+q@1q0/J<OW~Z]`"2:Vg{S6ax8+Q`LR_S]CFmHLpFrCFj?m)UZp?tYZmNPwHme.@?C2N|0c.=4d>!p~L2=|0cSr{:YDmY_UEa(bRr]Y6HNk2$|lPwR$#d{n{Ifwua,3(O`aZKI<8gN0wq3p`7Coaf;8|1<m/^2Kf&E5V%lqwG!%LgMpM%]^9]Qm?ld+"*MjG1Bkn.JsXp+tC7(^9]>:cR7V^I/3v#y"(aMBLCw&7&m;^2uA)~4KC@1P5=a3(oMM`O^{e[r7xSx;q5&U#4>=7%wYgT[b79p#x,n_pbliy<LQ]oO_*la8|*$4h>`Uup,$w="96t|%cvR2?*?CG4HNu2IhB"D=k=2+_EfWb;hO8Y.V7d%^wcyG3)~MfxXOPv}Z=F+H(IG4=;OEvwm}7QYaHrBvw[JYX0_{y*uwx,i6?k;hr3br&,6Y"|yBvsDJb?S)hDR0=psCL.|>sGiRz"`U5}{qr3[/scsnAl:pa#P4Vnf1J8`$5>s}l~NkY1a#>^;Id8MwT[TaV9*VUsZ3+*5cXK5PB[A&gyH5$VqYM#{^Lz#Ky{M<4C"=:$x(h4!6lJg2u^@pZaE5]#C3IvQ=>85DL[4%uU`n7YurUp7/a5,^rm/Tm<Ap`+SoJ|6h3wL=RUS/DWz}Prn>bnMTew~<+ObAxmxWM7@ALt+h5FlBt[QJ}__5X3=TGieOyo.&^p/bfk{^z(oAL[pt@&bC7m/&l7t*f?%Uhro)YYZJ(*`FCZS:V.x?i5~B53~9[NmHKy_epG&<Nag[PtrMzXK^WOg^%YvGE)?m47.bcHqhn(3UI#Fd).]k&oXK?=yQaAtp>Oz6j70fF%x;DzXbB&LrqUukcDE?p?YhAdGiM:~i%&_;mH&1E{F~FPiRKlo^Q?j=#}5$_Cd5KWMfx(,=Od6Z6@Tp:m)3kD%eX7#ccp(SAxx@)HKW]e+9buXuixS.I?w<jg&a8VUs?;VFFL?9Cfx`TUmSb<7n(_hw?{2xLHh]F00K?V,J+lS?.7.DwqW1CPtX6P#{35"I6Z"RHB,_v_awbp.+(2rwk*8])o~0!HD4!]FID%V>mHo(:f">P:/jv%,cy]+h@^4]ERe=awbp{>B>,.:sNeEjXcx&R,dr{5dD7Y%.cU>^cU;.*I~:0v`GRa+Z;dT_B?FcK2TSo@gbil^OQ,HN(3Ac=4Meclg&??:8b`Z7]RdmB7HFA1SMMDyV8vqgrU,5vYTm<e[oOH!Zv=HOndD;X0"&;HMkz/1mn#"%s`[9iykp5py(con6BUrP,`?mL{9v948/~Aop}/J8"7FrRg&M9rA>8);]Z7C9%lAV5HPm:TgyB:~^uy9SrkvKvvgv]4H^jB4+iONH1w*ltarZkK*W2JM/xc@7c7)YRhy2|q(r{6oU58iAyr.kY%G37t?d(=w`)dQh!YawR$[{s#>^%+<C|,/F2w*=0j^NaR!Ym+p4*aRe@avs$G,=?x%G,hk[$:ywnL"|cSTl@<FrCx2@zp98e:"5I(dl%nY;8${#2/G8MYql=hzvhVP/T$E{7h{^UqRSrrP#Cj.Zmf@GK}~MDeAP2Jrs7:0~%^|cMaWJA93MZ4tchT]2(:3ca7vxk1sj`bfRPTl6/V&rRZvEcG>V7ohS@91Qf>aT:X$V_*n)EbU/g.JgAxZWk~REz<9v#)/mK)6,SxPE"|X8i$n6:wPs>p}Qk7)DS#Hv!?~^ea3K3$;5m4;0"&<UKz(wZhrk+;G[p5k$rr!aajLTJII=<])K>=wXN^_64G=+932YLV3#"H(+9viL`4"%w0+eLTcv=;c6%W9KNz99E+@qJ?sQV5M.oh(!}]OFLg8S=sFLE#+@%jFuZ_jWE/YkY%];sSI;7G|r!iF@oG:]X("KAf?"aKQ3j1OYt<p%A>I;0+bp7qR.#]$,vVW*Z$wo@`L@(r>I,6h{7QU^B!tj@=eF|%jo:xg*tg2R4$GCxt=U`]FBevD/AH72tgXZ]vqZGm52?/3mFIj2r{N@UH*pRaOygof}2Yz5`1w`&Pm!g/gV%fc6FFrdQ7rU9]+hZ1S#~$`s2$UaxV,/TB^fYBeOE/gya<${%fVquC}=vMt3&BoYE~|:J{=p~$S>e0qDb>y!&MgS`o:3j[!q_Uy<lp#2_xY?N5bYT0#fkSb2k>]+03mIg>4$Jzi%%#3gs5A5*q,XKeo;UfKfSiPH?JCza$0wX<I<MbZ`?kc$A5Y3p3H8/l:pBVOw5a;[y,LnRTUC(l:iZsBUkNRD.jx<[l"_aYXY{?CUvi73K822L>JTW#a?wa91N51>tqqgjyh6E2J+KrDgE|O,LBX6&f6n;7<PdG9d5YpS"LhQkz&6T@ww[9aC7N;w"0y4qHS.7Efi*^T.x?$9p#bDNxQ&Y8df55_r@LJ]wHcLc#.:e/7}f&S75:<^33B%SEn1d./9x3Ye0(5Mz!w]`P?uYWi7T9%?T9C@kvTB3"5dyQ7}M9Ey=k=%izM9R8z(b+M^{aH}wO%x)?`"q#a.*^FaDDhp3HHrd=b;nW0W%J~(_WdLKV<EeCB5%(!Zy<U8OM8j,Egr)zDsEs[_Kb(8uy+4GSY]rKah76_8H#,O!YGQ2%NH*YBYd%y&s~ip87vB;dGi,/4l=;qf{?IzU,RpWqSRv[f<#kA~Sgy<,b0|7ahO:@rY.K`TG{%>Hiyw@:=ea2]om2;unk.]NmB<U&)5U#k?RW*__)}uE=KWz$U6so2vejuT%PUfL$VsQW~]r1q8jRnT{zvtv:_lle2&lKhK=sFmOf)~a"(w1p24dR=]X>S2TZR>omPm)]!B+iIIdSZpEXY`oUKZy,s2RL:Dw1Tp1V(b%|Oyvmr}e278a1a_d/T!_iU%avQC#jWyBb%$p#LK!DBH0S#*1Jqd=VK43CV6kYL8Ae$HBWMeTqi}WZ3Jqd(3?VVy$om/8P`WC.!*frtqD*A`91H#RyE[sk@.DV];U?M?y^JVrE%k8=;_~_91B,<u*uM{@UZ3Wvtj5GIHX1e1BHGR[)*9)/6?fD`WSaP0aJHR;,uRruASBJWJSApnBA6Wj?YYRDa7h@OW*BGOSOwO:+G:rX"t:W(F@vkX#*[F$AOC%I!SC2wDvDj`b1;mbS+5T.rx(w{TTCf<0`F^LyOX/Fc7P]Mi0^*}sezx!/05RQ&:%~1hmn~D&zaVUcJGx>*ROiJDggGT2cH?:%940Hx)I:%/CK##VPj+,;^rwi10Mm.A)(3!4au%9BMbMq:<_6$MK*/Xld)xA:>a.wD9w}P0lNyuCVdet}8}gN?7Q?pwOvDa7Byv3dK.O!]e<&L>B$dX32EFWFr)N@Nmw;G4~zPyu)*7A<R)aZmtd(.nO98c[87rZVz7^1aP7hkrFUbv]O;9_)?D8Q2hsb|Dv}+i+y++;]`K4B!Lzn~qvsXB;Cqka*!+TEJBs%:3g"cg83UD:3ntf*dc4u@b_Nt"ltv<[?d1Z$X^DrZc<V+.2sm+";@OQ8tEH9h2hTi?[P<Bs3]Tp`nakXxjgd7:,7,jPIPZJe83(g?,<Wt}Du|Bw{W)Fs$28P?!y}:Joj8J*VC|NC^0N$]bm]Y_V~2jt?|3:JBSoXER%$)BYA5<Bh65B98pyz}6!0360zBV.=*AsqU#g&RKkJV@8FZ:eL`_(hvp6[`^9LH{kvy9%8e&:C(L[p+U:#cCX]>8Ts4@(fbn+6p]+}!xD:fo;_@8j"#;Y2`^}f,BnpepM,~!wP+?z%$[@]QivCL/y!>OoqKDN,ckQ=75b%/nxGzZ>(yTnQ@D@XpoH,Vo9FJ#|{)z`%KCd1[N5DT.MWXVcd4q}glbsX*5*1Zhv1*i[*B/q.j_=^E^ysC3GcuC"L.c0N;&9K6e`iiYB0QuvWq@x4g!bVfa|hpK.W>|YR/q&k~o>^tt+9pIwi_V9zY"rZe#rau;!9#($(|3)qY`}VTiCxCE9Mi:7;%7Z8dG4V(f;]yE.:]:D]?Knf&JL_/H7X5Lc?/rrdv_Y7Olalr7,/;/HBd4i`@_PBpqH#@Y2y8cRI*wDCneS>[B>m}]%8{s"T~C_bi)ww;f}|bT<9_g3`Ot/NUXV|RH(fV}QK{CNN9?Q%}(pcTv$EtIV=.}x|A,IJiL})ddbWk:0%&DV=6|t&ha?h,}M8+?40t>x#zOfN=[RFgc6PP/R.Vh}+qz";00RY}O&?rEDS`.VbnOr)xNVB%/w8+BCt:|"6(6xq}sl,`&9MjDTP:hK*S5kpP1g>ps>lUS6`v}V:XC6UBo3qWQ71kIt)tq@tBna__tT#G)XJitP$QcmH&=GJ)k$#j+v=+[ro~GQ>67_}gKMQvsisYFq!_8N!^l#Ou|+pEKXgObQX;,Vs<PA$F@mIaB<TG^zhL|_3}&&fJBWTXkPC>=!|0RP:6KV%eYFaXST<yLeSfRRGw07YSEAY.@(=}T*ndY}qU}5CApz_chU9Wf8y|n&`&q>U#JO^G:Pf;c~P0(=?{.x|Q2LIq&m/fSBy?mk|IyUOPy}hjb@dmi/entd73fco8CHpTsMg&wQ3V[c1n_BW}RwBz~h~gsit8v+2sli%jeYD:j`o|;FFknU3JAl^O2`iEk:x`qtCf3d&F+VCQpsNRZ=:>>QxAH,Js=qD?tdF3Q2:.KwD+W96H:(W:U$fg!1(V,?)W>6iL1]Cx?FXg7"`Tohrm`L?!4>:#x=c,nV^@B$jRCUX|YT.O@k1K?OeG3%*NHT_9J#f#2z:Cc|,+#Qd(!+Rd*%T{,00kIOmDUKtj`juH(:_LDeK[t_MEq":[CTf|PcVXN,DFcUT6nEGF)b|N1DZmCcw+u#_mgM2_y>7r)5sv&f>Ilhy$#orJ1?%2N<t[dYKM{kX:lXH2mw85&?wB9uzlz6;$RzyiVzL+cApX`^vn<fF+bgs0&cmKfJNAnqa1;5E,4(b{YToMnZ0Y_;Y]pLf9LEErj,=NwZW*6@Ykmhk7@|p%(~QS#s`2hO2Un*NE&7`B!G>lhDPwyen^Z_I{!a(=apiFzX0pV|OI;i+r7$MZ7wZ)!0i[MtUP2xbFl8I|/6hyMW4^Uw?##d.}ixmweT3Uhv/1]Cl6TK}7jw;u_53b{!h=Vvyh?EO!%D8N)`1aYPes^2y)wUU/&2@!B(f0fo7^Pe#&d(olJC2?un.&@jK=4"Xf#YIxd?!e%k|jR|HBEsD6w]hT4[/c{Y|30pV`hB$Qkb0x|w&*CIbc73$EFe<PqpT!Q#kYHR}tBQ^)gRIg(7;!twd<&,,.M>oJlM6n<H)Pc8d}q_/`_#u[%Y{Qnjl4wjFM%yHbMD4]~dp``A+J*TWC?<5@oieS&yBhjZ]x<=|P+Gx?}zLdfHSqT>."%_Id9WpY>yr3[kYuf/Du=Z/_^fttARUIw.O4U~$qZ$$e0k^T8uFW9R#$Hf;]I82{l)CPCgG|}(}c%PVKg1]|gw{yb$<0GmTl^MpFPB_w1@Q>Y;kKTT_lkVdlZp}>?S&}{W,RgSLi5/}GW>rv.3pT:y[D6cxB^%(>faYPl#s"dw#zj|M$wJ,k]4tWk=rz&c?qW=3:sYL*:$FY!eP.AhQ&<o"!lk7Qbqe:,Sf)VF8=nW;hPld)86D|lH^Qi*>(@m.*8_RVTJX`pTMv~0^g&H2Iw}%,#Kz452jH8O_j5|Pehrx$@c&;InyZT(;dj6fCeM<Ogw%_&Ie{1`fHR*o6MqNZ{N}1)T{WUV!{IUBIRpHVY7Y3G_/w7gqG),jN|Gj1*bxhoqd:)n*uvABb^|b,E1_H$0~{mcWU#:vFU&~5juF6}BhlD&7N%H6F1(&a[(g+,2F{!A_b6oJDZsE&,hNyweJ9fyJa5F,QL0k"+e4}P%`m^C^q%swp[~KK`QYrh{>3;xfKJmk=.nf^lM7Ff_|~>c+.t0Lvs_"8g}(#fov3YG;^t2xSU*(M%$DMsY`K16DaEGn`y`cWLu1)r)I=BlanxN7)eSX(7WODvfu!q@B/2@z^Fq~Kj`KkN[8cI*)[>!^d;ai){_g#Q%h[[>6a@f&%vt!XV5t:p`:b5|S2SBtaexY6_<4bx;vOvaJ8XIf&#{t7S`lK7Kf$_sw_D&;Ng#|PeJtdhl8vlJUrO`B5:hd_,(E/or<iS|e[JB":V#:vSg0D)O?fi}2xVc8wEv!cO18"7|S.cZIE+R<,=^nopT;6&)n^;44gAFh8*#Rd0C*y8TDI~%BzJj%1]+3Y?:D>yP7u34SEI,1i.vU_;/n|mzJR(B(z.5)BsFJGeN*2.f9EuX<ogL~wlZu)Oc]F%LAs>*v{`)`"vg{)hRS{c"g4[hW8P~i*,aqMn>;"DP;[J$`MB(EfB7]o3&YG@]H#v/2;Fa3v/w]p^LDoDk@Qzp{*H4=Xr+e.veiZ"U~[=r>d.0[TQ*HThGMx)NTSrT^XbqOh1crymK`r9Me/=$*^mPC}OJh3hYdy;=#6XT1R.Z!jG|@93hpx,2+1[vPH!xBpYPi55!oNFMjOah4LuNzxJ.U679q/p.M(sHMpS4AY]Ph*Z3i#$(7GN?k{,Mk&u}m/MgI(=ZcC;mm*Uye]KZ@J(l+`>mN:M$G52I|F!S%d4Qkk>`X4BNcz1ND.X"kS;^EmDV^8v#Ws_A?EvP&A,rcqiC&{LsH>kSM;b,Vom|P{[T@[P`}+evT#UdOL[1I>*Bxi%d`.qKib11FVihg$?50,1#H+zWw_s7[Xq`YxJx1%w1L,Mlzi>D"7m?3`[P;Bgn&CJ6J@&x4PXwz@Ps3*gpc&+b*[eC;[*66cq:Py((<f]vulGKv/yC^|{7d>oX<fczhZ|{lPN8[cjX)I22g$OV`R{!5._HUY0/S<ZOwk4[cLeB6T7UV5*8#u,b!roFh2UE.`&v}Co9Bv{8("<I*tK5Ne{7zZ6#(>C?hw2:#@:6;?[t;#%`IhHLkH$=8{a)dA~qF{C*eXpJ0#QEv$F:+/p56RN^|+0X$m#B<DJ<Z{jBfcEH*9Zj(yG>)tuWlUZgzbppMV0*FjQUkN$k*aE*Gm}Wniv!,[;),@*V{EE[pLwJXa?&>Kpw*JI%8[5Q?MOB10C[ki!7@,}:)uCGhIENvMDp!YXa87VD.0*f96>!IU~W:iM]orzE]Yms*R*?9i$zX2bZL]_0ioj3Di*sqwCEUE*v/nQ^8qy}+=urUj:r!O3u0MrJ6~P#nhz*EYTe]MdQGY]vsX|=[cvjQIjD/3UbMV(1o(V[n(m=Pe|xW?r$sju,UA@{4]d!lQl&.*a,j?H5jV>^O)a+5LIWKK0Z{ma[)D&,{k1y0$qo4yXD$PMDt=#Q~wx"gcBw%h0O2#IPFSE]}lhEiVmP~3FgURQ}N88kH11?/;zLtK2^FY/]UN=xn/2XJKD!1G!C!fj,zH5G,c91&Dm`j_3t]=)*[?h$Yqto&aWA[CfpF0dsYFS=F0Z$z%0Ea6:u0%wcs%%_xSvOEu#)x#DLn8Y2QOQ4:~Oxc/+#,2&pj~+dX#eEB#/P*3i;.3DR|H0@S@ejK|q1~X="K__,#JCBU)pH,mq{Wn4Ge[7yznG4O|PX7!b!znD|SiLe5]?3t[g+XXkO%+$[Te|~xoa<53)tmD)r~k_CVo:Ot>o3btX>eM[w^H;7s?>0/y1M?.<1>uuEo:cnWQSjJ,!ldS@^)soo[PBinsR{~X[anj]nns@~VkL|h}S%f_$$ra5~<slVsFI#toHL_[mfhB_IG]7,&vjrO.cBE4R128<,/_xLFa3FQBIiQBb{BLo7(6lG,;63Hi9!tRC^ulU)wT(UD"o;O1ixt$c_GcGo6OdWBEW$%X<0_iOuPi(R}%RPc$5BsiZx+o;[w#^@`z%U]Q8aqR^zIEe#*8a*DJprNN!%lM7IS5QC;CyP$m}151K,wy[~lI<XNO!{IF+V1P5+=3PS,SLmH.@sNU,cKE*/(ARK5SM,O|2]Y.|OY,%Du*hgZ;*tV4fB_uPZhL>YYfY9a>P0<P"f6d)!c***]dJj5hhx+,HiM(RVDfe91PTdbOaY><5ChA&K[zzHHS+A/l`E)(<C2dn5LvN~ehu:4.Y5JRTvF6>a}(.Z4]85@r[ni$@k#s([og?O7uxSoiT7Lyto}K[h*#DO6tkD_su]YJh5;#yp7lg5ETKg2joYD$EOS:8N=mnvj}5V&W)YVWi6xi|/mQf3YzMD)k;@j+wk+rWBrWFB9"iNMmv&oBB4N<=kUksa.3k?P7oYU|rJsQ^UIo?8M`[jy2sotk.W*fS*fx.FDdKPP=T,xOl)=21Xa,j<vI#q}c<*LSAa.%3iD6LA?0Xa*lX+PE>.}?VU:]i^Q[7{nK4poFqKuUa$9Yy$VB4Xuv$xdcH~_v.;C3?]uJI6bJ0&?EK6*:/q_+Q&5Sm(qjR6splLI)BN=w)}x9tG=SkutI;FI:p$GoFcc%CVc~>os}ekB/C(;Dp3rD;a0ru;`sE|Pu3XztBO%HXyz(.(R+UvvFk*14P9532/C"5SaP(QaVYk5eDU?wy@@c4r.+V{r(YdS5`t0c3E]vL|IPe]J[YUYvS2EQciC}sqLDepv&bu8{}Q#>XbuUa(80u0EQi"Tca"D4rans^E:pLRbXYgzvLsKGZ@1rc7Z(Ky7!c;g><<GN_yu?6k/",ruF^{a=BpDO&J$x:!t/[<)J>8|0%,,D;C?[`372X)YlNLfqzO=TYMUn!QuJh[V|X_WB>Jy&LGNqD0IlsxlX`[$3:@;9D)%}0mjn6AhYOYba$N`~pYK!@d9wkXYF7BQV#;Xo;Se10Fwr|,zGzAJwKvnCT4HWHFw3add54yzdurC/U*UYdy*BZK6V!R@zbzbm#iKVsK[N@T;Gb>5FeAs+NtJ{325|`Ct*G#Xp_z$5VO+wF(a9?2>ngE{2^s<"B4r"`cYy~>Wi!P0NkLlHw@^x{&>ozV0Y.O0jf)IZt/?p#yFwv(s8A^fzM5?wpt`Mkoe39RkdDHwq!M(kp,tF!.@Bl6kmIV=]L~:I13m^zuI9&rVKPN@.@#LUy[}i#YM"Dy%T&YQH?nbz8vk|j~wjp:ka?~$(sAsbe)GP3"PU!DC`O!Cu_`?1*w#/r7Vnaf:oJgV80GbZ.XIH:{z8ut.y;3Y~#1a2cMZ%2qP@NU/zNHyro"y_#/`1*lWy`&u5d,B2i5bo]E>21}Q]H:JRp[=,"OK4Go!=|S1r1E!B78Y$;n}`D%Eu}aU1`4!]<eS`bB)i&}2!s8%$3`#T)*wYHF(b:4X&M[w9~LsIy&YAO`Ek_xll:wprT_Tk,7:nIT$eGKzpVC[GBH}#*vI%a=?1uc|~Q1P3f<E8tKyi?Sf&$vL>d*Rktq<"gYL!qpp9:^Hlz<_+:oxY=$dK9p@jUD~,zXE0a+39F`TQlc#r2&@m:Y*D)!8jf7``hZ9`f>VVvzMb)OH:Se51~*8s7UM#Y"S)pcnv/Qvt%Gs}4{5}O}a6K9KdJ4#r(6NF7v_K?#cJEUcdTdu[*6p_^GtymX6l^A4`94/%*n8U(&!Pxq5G+$sg0UizPM}YAWkUZ`c{ffe3CJ:GC#kN7Jjas+O*@7vP&M=]<f%!/9lQRLG+KQ2R@^iSvW~gZF9qZ"Ip75,,4:1IU0!g#(`G_lW[EW.>IZeE$}{[YG4TLXGLvXL6]Cc>b!tOtbNw;GOo!tQic4cl"%xWY}#2ZifkY6~]=R}glMG[Gy5H@{?%91cgyVa.=+05KEZDeX>qGN_O%.t<Og[E.M}vur3vB_vY..Rm:EkPrd{_(ix=L6*t*fvqrN,u,voz<AE2VmZ5r#;7YD]iz"Y@PV.jqKD&f@0.n1lKz[ogP#%phj7&?*S4cYU@&|)}*/]y9Q$QhU7F]G@},*H&*M&xWcfz?uca9H9I]Yb*Y;~e^,WuN%b}gd9Y=>me>>xuXn[a?(Kro}Oc(X3.Ej4qvj(~+$v$v")/+}jw*Z^mvA[>)tMD9nP+7&]K}A3sPw8(=HBM<vuF*HfrXR,zm)Xd&r$=(SPVgMAuZWj4)$)cls662h2z;q?Mv>TT65Y;z*xDbN!51rl+?5N0TO[J"w1~,foiuON>@KvOLTSv;*rZ!&qzhCj?KGl1!;A}fgKx#Gj~4vcne^l"Hzj[yB1L+jr?4"u~8U@sf@$:4w"+1/FO>qFFZ}[<W+h!|y&eyUH(zGBkQ}@B)bdP4g}*NEWague!$!"Zt(K&~=dtgAgxIt(|d>SAgv;OCcW6+/rk=JHue<GnFkWXPQ.:|6tjFtB[!Dbldz~_f3cnn]CL^Fw}&Wzp>]e0ay6g*eoB]T$.pBPr!N&e?clB/Q)R#lYqdK?Em4GeEsx7Y]#}a2?jHk+w*.];PxYTSW[N0ypYp~sC2s^,zcZ8zlZjQ^G,18u3.#}M|!~GPZa#0jBZa%JLF(>`}HVM<lnA,X2$H;OXjFPy0k2%dXXF1!H+U$z;?6H?+l2w=TMQNxJ4$1AX+fJQ;2,Y0X$q/C;o^q7WL#[,sVZ0@5;]IkD/t@)LZnqGJDQce|fgvW+hWWtr>$1i<5egU5e$ZaR84JCQIT6/o.W=7N^=/6+U^BGL=h90N~k^1|pcAm@FY)R7@?gH(MyGMnrqJ[$wXY4/}(o?X#@A.W7Dzf>Je!08UL0?SxyrqCw1OUDN&O[=%VP@][DPL+i,T~8~rBi$6qzJw4l8pb(8<E(N%PXZy!%$:m8;!f)Y]%Z<F1a`JHHx`}J@}A,D.I/Zq>*i.TPf|famJGym1hU]l1$;P)7N:#]Km6qbG:23lW*Hz?LuL_>Ta4&r]Y,9HV:*e*0~gSMmWN>1r[UW_$fY<70b/qX&aomXu/Fo)wiCsrXPaOF5oo#Pw<WE^*P#Fob~);,Fvp+#eURf9Ng}{emK8)i/FEw*xYmR!(3<]u?9xu35}e#o85N_2xq%WZk*&W+h+L:0,(y?@?r*0J!K}UVzK5FDQO]@5If=F{h}`rEF)?./OrDfem>zX6etz.t3ih.kd#&tJyS2)MCt>@1WX[m/o=b?/6V<vxw1>zt/[/RRF7Wpe"/44H//rLB:=Q<7(wUHB3CIF?OT2cEUN;D{u=nQVH4;aI[nU3&gQ7IFZv@8b}WT7|R^VaayY6d~Gc?G*+~:$/5<SW9>>Z|^{k"L>e7=T[7h6aW":[|oTP)M_N=kSz95Yzwfvg.9gd/~E[mOsBvLsi4B+Q1kNlH(i_B};8gFP}L$~5@vD*ok%n?:TD[L{#aly&q`2R2:|r}@iOUo$EsuBo0gZC@9/L|&^bV,>*Rcoe2GFDF|g4.0p?"fjPmp<T1f9TlejY}Rq~yAQyq@).T[inI]+aq4W$y#tdf{E)NT0&)Wjb46<Ev%>wF!bBn/0"R^!r1qr=(I_mesKqY[:Pa"6XTLP1IWQ>.R6_YPfI~_bx9loqYNSE.F|mOpW*HbWu~6+_7>gw1]UyqgYD7C7x9:uD^wFU.]#_6yj%$6;XT;:Y*ds40~)NLCX^CvR`sD9365PMPM~)./AD*+B:P4I1|T35H*J|T2NVZEQtl0{OH6e#uSeT>mh]h^[KS=*"K4XWy}CP!%BEJ(4F}cjcgLOeGX%z_@nA.k20^B9Y_]BZ;C!6U{n8wCUyYS0&HYSDur@4:Gl.7(r1YX#bF=vP#O7<u(i=,J::"XG+u|FLbEU:T7Fg5.3HQ]yMtjId+eNKUw199Mgwy7~WE}:mX=(6>|Y6EBia:LePNqCItbKXzE(;C.u~@M7IEq_v`$(J"Unr%aQsISEV]+Y2+}zv*B&IfK|3ASE"w@%[c<%U#N>_wV92EJJN4Ojwl*>95;(}/eC7N<oPsb)Uk4gW1!3En?u&a={2ZDB%{O)0vI[}v{(l4l4k9}`h1*.@8}nSW_0SKK0Ow5hoU(ZM^a_TVEI/OnIO!7RM}V!&=>4+sUEA1|OkBs/J<RbUT5!kzx7eTu{P7=fWvQKFBHQ8$Jv"iJog`z}R.kGs<QXuez33f!/RUFQD&u1<0r]7p>H2ogbU05Z9md"&gfw,HjOI|Y9$m3o;UEUTBrq7^EoD6773vhC%&7sT("@~p]rL^x8`EvAB+6*W0aM[<H",UR:0DEvf]?29i0YO9h*0%dkZiiKm}hxKf#KowVg<#F<*_sW9Z*mn4Jtf&_L#><5^*~KgM|}KsTw6ibI"dLC&A|xZQUgiPY~;eGcP0T`!@3>`4OeXT*f!d8y1mcvux(%U7ah#:Tl#zy7M{MW~Z(Z|{L8&d=,Mr]N9R~rK[;}ey4]khd)iw(aU{y!@q<d^v?PI4|w:jzFPm<Gaw_0*`[j^}YlcjYvWNt{HGEWl|F$DLpzH3d`IH*6$n;Xnfa1/UFnO&qKBw63T+I0o^3&]Gy6h}&DAsnttg2,//!))MP2w_s>7[@x&QW$XV$i"LL>4_6;+:{/a:v>&R&#Lm#{"w@nlpj|~fl=,exBD<tG4p"MrbGRe2p:,Qm69{/A%:1w.H^|V"k5z2"8Ac%Ds##DY&E7&9B5vNwL/JRFnTPa&2ynTGVLBgY6oL,GcBh)mOfKVFAI<&0468[I{3{6[$hAZG4h"_:}(Oc+<qlDs,mL3.xbdxdHrXx~A~kkWdQd]8XRhgG]0"$H]K$[?,#uw_!I0F/uW<:9c(iWV^x^pr?!tp_m15Zqv4Hnk9<D7ABzU1/Vs"=Q34_x|Lh>*)S[$DVMl3(i_T:ix2LYW$OFMq+[TQhbh;+SKz%az*VQ,]dh2lZN/>_>eKq~>Wuf^J>l9_fk1z?A_x{1vl/WdNP0z6G`u"=SO^8Bo39yu4fyTCPLo%T0F:{Lt*CIk(P"xl~B;|i.V]A@=U;%]SjE*P)>C5DULnrdR+PNN`#a?E)XeqoEIZwB@P3rbnq)0UANl25u15*$#swY`Bv)?DKMl;YWr[J8ox+CBYbB=a7w[(xY/GbliNQNhBHR?F?S?*;(ul25qd["gK;ckee|DGd0C$F@J$r*{_C:!i)l^M`/W`9?/eXBSP%z4PIBHgZmu^gRPd&jZLA{^nJXR!qV:[`NS?Q&*7WQH#.Auc{vMFsF)[]1i4$7vf69`?)H,M~L!E6`q`aFd04H6SH*~#eIlcREjzj6uY|frf2H.VVm1{UlEp|vxeXo3z7FPK5M+b:p;8X[C&NoEK>0!zoz!z6uM_}k>M(C&DVRgjo,2M5)TDGC_IGaBp}!t3^Fu}|>!tbKggOxV7I0FZKZRk#|a(Aba<TRKO]Z,wr>B?S!R0=K7u`W1PbQ3MP0%tV3Tj5*~Z>IHt,H?X7x<~x^~N~Jd7dKYXuP4H|<&%_k;}T7~agl@tN&NuRfkO+E{6JEl(BRr2T)5RN>1kCThV?{2dYccu]WcBirk).dPn_hIVp1bB>2hDWs+JkMT_NJ+;"04Cl`T![evMt}^eGJ)r!K56y/z7"lI.kUlEr>?SNRyJD=6fp>9<,Bpm/9h#]BU<.*[!A<$@cA[LP3l+yz9fs@k43b/o*??N|H4!EZqTA;5<sinmo$0Hp0y@=YSGl;*~R^et:V?4c#H#8=@+)QgviPI5(a%qfXv3O^r,!r/az8ExCqc+7Xz#[nx!R1OE2D5`X,~FG+J20hmp"%DGU?_r8ls8M<>ujVYoHhYos)*FkyjG8L[QBF~}5I<MNM?F]i0,)!Dq[5ppN~0I3bUE0FyV`)2XDd}umA#E,O>|1]^$e@[B|9t2`<Kt+J+TvzH,^K>)Xe(cZ*?#l3O"Sj:=vyP*(BR2RSw`^cMdtJ(!U(6)&O+/4eH>I,+|H2qK+PVb(b(Gi]kI14wd"{9b>9v9kjmKLId.T;o|FBBy#w/rdIy5U|Lo1Y,[C/^kSg><cb&YZB^xKi,5)Cf5(kZwVoRrV#`5Zubo]n4%CWCOj<~+;$ii6I#Ma^ct~Sq,DTM#*EnrziNTWnVx#jsDL=)#;"eR0f20Y4"V2(/v9@9VHv_=NECM*2yX4kleim%hb{*e}+U`C<]Q;Ij9Q?lcNPG1laOe5jc|fxsN=4Z&UX2P)?%d*7[k[+ii!`U6EL_y}Iy2#/gS{pas0|n(r@6l}=z3Rx^B/"B1QHdDJ~qO"whsk4S{Zj.iX_Ez<H:1t2T=v|E*K[S|p1|~8cp)>YL$.2WdQQF(_^=r&9n0q=re/6V,&h#B(6Ny7/sZ>_$g_5w9;"`2tbeNTG88+YvS^[1;ZFP{S*?H,Z~Q@[$UV|mG6(G$*t9#2,7Z8N/So/e%RO{!AS~&}ad[R:JP"~|lmbFwKW(o`kL(&]W,i.hZ}l;cfPVWKe,>igaC7%N2PljieJ"*r<LP5WL]fsGlSEV@numxrG_w0%4)O*1&|bm^b!H5*>qSr#_2>=24Kz%gnRRzol=GckwIf=.Fvpmyd/&eV*BKl1=7C{^F3(H_pp2Ll~MViQ8t4&#x+[`U{]$TXd/W?JhmiPl<u$`36Yd<Xb}dCoTb~VB=a/|~v;|?(]+`%@G%[eh?~wUUU;^.ttWInBn9orBcIf0Z"G6zW7`c{crKrNZ(>sAzsDx67tiZkl7Pkdwxi&N*f*D+w,#Td$p{2]L&[C3J<VI6)C]^Fb{,Nx/xb/%.x@H.!gkq1rmi`=,FB2Bw4cET:)E&>*D_#7zQt*MD1{!hbkt?LjM[I76d6Nf+uHQN+|4,$WX&dFk}B~PGA&]oIUY"!`w,[=qwN:WH,rKGwvQvWW=stks1g<RWhUL5*ov^IJd%NN"9n$Yhd]7B4EYhHGZuD*6p@l`U%U~.9xg>/C_Hzzqq[NS!N,@5c.d&|(beVi>P*qR=q:q7ZZ]qo4xw0#x?MD!([m5p+:oW{eK0EfC3&afM=ygR+`Pj5q6k7v7CPW~DG.t)aCR`l$vD>VoA|0vUl72nhB!WFSF5l_y;bi[o+j39i?w`MhP,JHZqG}YTwYT+"qw=y:L0`BDRuoeyZ+E`$Kokmk2X:NeBj]ed3ZgNFByej#2S]`PUq4Uw8uV*=~H`V4$^VOGe!!dvXqLSO|^%[{F<]?|4Ys/6+1>KU<n=$7=CxF{+SK(tzPX7""1{2>Rd0|W:X@2W;C}YDaNtYWQY`:sJaxaOjl;,}Zgj#RsXn|!};.KQ<(K|FdUc+4$~}09f.q8O?Ra:H^4owG%ny}qNb+KKtBBo33UVe&21Al>CeGV91ggtAOd1#TkYm_H[^R,eTdf[srlU8F6aV]UFU~QEYc7ML@ZiK3a?,F6bVdVXKVD&l0@}bT(vZvvkwbyE4_Uu^wYvbkk:,TtR5HOA57zPCgnf9~[YSGgp~}CdL&X&,r[vT575Avi{>/).+L*!iy??:LmE8>k)Gv1u`4nl]|K/`D:t"_>X+)uPF4GY^sW%JqEPgT56wO}fT|iubv*~TiW<;~JCyGKY$[(#:a+bUC0J;1t]|]vh^R^b;W"e#7s1NSHBND+!;7PZxz#"<Qg=@r^viY!I#m%ZZSoc{jfnvbozwBs}o2m`I04+q&wsbMOu5,{4I0KI29Lop0m?LJK~44W3a@Mo&a[lP!`8dRWzdO7rDb,PhHLfhkW)ECE/Sr.fd*>~]P9`,<o0s;uS"LI<Yst;w!pG?+ZpJ$x3dtD3{<$N0_UwDNP(sI1MYG1ll7l.O##YEO<7>gZiHHt1_t&e>+L**i$mAD)e<vZUD`y#?Z2LR8Xp[*q<:0LS`(.>v0aYkce4OW~=m1eKz1?[~4HF.y/$cve[SCeCI6=12[+z?.R9hATn)g:~U?Hujtl+iv>]X3?Wc#0Q8[)(69`@(}lt)G_G5=Z2/f:R=Wkan{!o}rJl]Nq6Pv+4>QGP;4YH05K[%G:lelGabZ{K4jI:>zCKZ_P]hyR2]NN]01Pv1SbRC{lNFw5+xof>J7@Ye|1+/t1:$,"_oiac+n}~{LF(VFslZ2q%j/h%Nh}1wE}b3.d)kybEv&26a/(4%$WUd[j@})vyuG_:fvWOX]4,qPmRG5&?l]BliS>wO|J19bIE8CI6?:=c;NFZQNm)5Bf`Z/Z#.`(0gcDHM@:gl3_ZD?/70lx=&::cD=OMQgoSHk9ygqTL7OX+6UTt$Q#q;J:b&Pgaaw9l/KE9pKsE8|70+8~FrG~|i:eankwiOGh@~%Vl=$&~(;oGo$D}dIQ_fu@I4LS})1";)Q,0Kmzm54[/ma5le`T/K.SW5h#!<o#f5y)HUN?JP3}0k2]SN|I+M?WN!^.f_H~.z$>yT;@{|p2CPYtS~+}u*EE}:6O,a,eBrB:,fJmx+ZDc}nb,SwM<7u{+I<{ui04J)TtYS{&S68VM6F#0?TxEV!e2;lOGotD6?ddyQfkA[g}vA/EES7kfbqC+SNJ]?E?r1Pv6.w<l4"FMo`KH/^|]~W9"WYJK!~tp#,Dz_R7C,64YT[]m@]isGMaVZ<pW$m=lm*(S|p=Akk`,Z5][:yu5=X6w:3d99VMo*fohf/|#Nl7yD:vQc;KE_Cv>cyX.cWm:bI>ZZP.`v>PeeJvGHonY<$YR:pISru7OSsVp%qbi@Vl?B!|JWbdx(SMmc%EfGEPS/,Gq{px3[9_Om%C1m5C|!6@RR&=n$J2|5vmU}0R$"+Xz=41N(K|9P;A&$s.>t=QZu<3_ut&E/$Oahnmf77co"[]^mi_AmZT+SR&W}$_v|1%pmay^xG,1f2Zq#aw=opk}?9>oTczlhb+bp>O)":i8+fIFv07dMPNs0,AeHrn2(Pt#gKI_`tt)*LnD(*=h:zv0uQ9)0C<R@,o__BCZOAbC:$Y;v4gG?~E,IL+!M?3ZyBr4Y#;n2GDFD]&(ArqiG8zM0HK4.+R/&oMY[K)zIRsn)bKDz2&FT%2%/o<)~hOfTrgDM+Fh_N4N_P@<Ddc<qDL*87M)dn6Ek6&_[YT{~xq?qM<NAmq.MkeLl{FC`3)k0@:n}6$"rZYc%Vgj7Js2^uh,0Z|hm*"L#TGvqI$e4tWt!YeruSn0o5jKO9R$m7Wy[j#vzXKZ?oT/#:dxNMi~cqF)e>Ym;=b"L)z$ow~S,wx{znOOrJAB,HXyK8PC:kL>.I7w#UhdY_BVP|<_m3(w%rY1L+9kAISg+t[ZST?:BxWRfcdNZBDXOG0~)mxbZj1S<_!}!7oTy1NiJdzju=d#Gm)|.t"Y^VT8.xZvW9nD=LqR`86^qecZQJ@sQz:w48W[+.:"f3{ZtMEVm|davr$:/1X)9<KzL|x,RsgP3.tEOauKn~$6:>.hdTqh_yS*4pb@D}W_NKB6.?fMfcj77<@!5;<:Nh<s;]YHnTHR7/n6S#AB;,VKU3Ixvg&!tb9z2@VZsjU`5_/muYXqD=66v=|r$M#0~0QSIk#v#8#rQWx4uUw@6|$$WL0~mk+MsVbDEF%G:^loGhyqfnJFt4dn`>No`~^/.eJQ:rzhDrXB0)$|oR6/NS%bFFv5_6[{|[RvN"l#IuEXVXiFQK}CzxnuiKp?:81QtZHXZP#|cm,~|HuB8R/u)87^`0:XZkOQ{b|8m[G^zz4DjaR)Zs0f{6)l04O.P^(N)qN=0lO;a7F[IVf7r]bTkaO.I`/(}}hw={p*z^coJlt@Q_K_pAhyxqP*f2d:rzpye@tU>YBB(mMNuc{uo^(=2R^K]?VdAY:82>l)cmN+DN,B#3Hd9iFo#CUedB"L[{L|jC=fC~[M7W7Kt^ZI8VE5S/A"J6#8]phpF3Ji^i@3wK+ujIc)nKub|AIu,HpT0J9`[M.?J8}XAo]e=kYGeV3bj9z`ii~}<=^h}e*W{;3RguK@J?E)L.=v2INjf&iY]uW@x&X{5C>a[#$h<d/hIk_7pRU*E>1ffV_5qZw%BxK7b)|f%X3F2aTL]lk[l{YV:Y<Zj!PogLp}{VLK=LxT.L6*MRy44MxEi@35hAGn80g0Z}3~Aa&^ni|9~A}i{*_GT/Ejo+N>V<^1k2@1xPQG`j0[i2`~sppdjmp>e&/[8MBNv`;e.,?tKm/iFwYLMC(wFS})#(2cVE01wgfxJaG6m@zUU~+}$IMNq8H@G&2OY<];uWmo8R2hMmg|yKl|445q~.pNLkFrM3$Pcjv7#/.zdfeIwnG.z:nGw1+9Arf)M<A5%Z}cFNLBRvPCV%Et.OhjN1@O.GUeub5Bh/#]dMhah!(okB""&eHLzlNr7e4z2fH5xXF!uO47yI$0L"z2*_XIYpLWQ_BqXM8!ft]1vMy$q!3V]Ny%Q`{#Mao$+7>$5++H{P7,KcF_"GyK9tEu#56"#,QgUCzb*F:m8jjD(Ds+ER}4C{/T=.guh,y8;Q1ilw$WW$Q|oag!^7b|TSKPk=lNnw[J4|i1`aQk>TJT/eNTM3[nL*qqamQSm*wzi%JM;1Z+2!Ola[}@bPqGzoo]}c,ak4>2oHDgw/,D~TR,zoE}d]$M(M$cN7{AlH+~]rYz<^qMLS]1R4T(="L,N0/zMWyvQu3pI59Fi%>5+z$tsT>K7|rNte`,l&=;&^c87#+F+,!N"Y@(jh&:CN[x}dfh,hiR7$(JT%g6<SN,@sh~^O_V;8{{r4>~H2z^0SY59GJEMWRrJ"{=CtVI0h}/"cjrm>Wb$Wu}hS(D@m$NdHd3#mBBq!*d0`sEwK,p11!(K=k=$N+s9]BZjp2k>t~kv_?}*3%5[]>s&Pv?"{P9iHFe1D?%LJ{_STi>BoVnEPxB6%JjJn]Ud0eQxaDl1_7oCqgLu%8*sLyR{*1`/[nUk.An#e[/z;r3.F+ja85EQSWke#PN:if),1*NL,RDN%lE^LM;f60+FXUoM|;hZI##eR6[QAz;)nkRXOtmn2QbNr8^5IKj~6`!k1+&}}hhjw9{32x:4wvvdHaliI{m^ZS%Z^4Dp+L2)<3{R}<M(rstCV;>*Bkgh[uWZ(k0M|ny_.ekZiMy:.uV915Nce[.P!}y6A"4!9W^<54:Fx}@C(Gu&wXs1yjZ1^~4pWl;Jb&Jn*,+3YWoULyRAeyFb?tKQD"l,Q~Uwy>+6U?aF9c!!W{|aB32[&+B@/Z59d6Q.C&;g4Mi2LqI0Kz@#uk42=y6b]JZ8Kxd,3{yQo,yMyYa.pIZ0cc+y4z10yM+qc"J@@P68uS;}"_^D]C.E<sLV.~Vy/eG#D]JCmH;_HxKsUC?EyT?WptV0sJx*0:8c]gh_v5:hgn*j8W8k=fjCi[BYn$qH2FouZ?LA:5`$[iSNm&w~II)IWX1?s.CNR{awtKO6S{RJH]Jy6B*.S`ouZ36I_@S6:|Ql)_4?YtDR)BYd}9ZGbzE^W+Wy"c"gjpZpu>Tv2C!$BhDlg(T?U"t<BZT%{*8nEu{aCPO2D`ItVzp[>gK8*cA/u1nOf=Y5[<LaLG<3xvbM~|{X7nGF_]YCWrYkL4|94"qlepwCngO_@t[]]hRN%yb33YS>g#3hCL3xw?gz9@7~M*<MwEk%hJLFNlpI;_D<z.9HZr;:@DxAwz((>Siqc!bhX+$="cM,CjFmqKEuQ_)&XX+uUdhT`k!Bamz.R$P{{b1stot>xV$$!^hm^0WT9U+;w`dC|`<psBY1BWV7!.ZfzG~[0?+yl;g*RI[E#JC8U&S=C{2NP5rAwgZU+,J(>6qC6:VLeA:^:YM6o(vk6iD8bn109+:N_T>OaqEHxrN2EC1{Kux./AhwzG`kG<k+K}?UE#&GnAiRf|K3+>c_86CXt]?Y~Kr?Tmjd?uSwC"LZ^bK8.?Ty_*^_LqPlde%<WvO!>[6hp[Q.8^1CwX{4i8k7ic_PMy*)=Jc)xPFUuvq$zybv5rE1{~9?O"9LASTzYnFT<O2!c|a8.kx"{iCrGS3wxcL%/}BcB/$P&MHs,)~4*TOm1J>Ak7L}/ew~E:=IaedkxsIh/Gn3&]29jvZYf?Wx$t={Y*(F333ZEMXG6TdwQ*.R/b|ZDTXsA&qx(=xbAJ[H%9@d;xg0;6`0BCol~%d=}jfZdl=E,4hRaFX+X)>6/t9`lwEOCk8d)VfCA=%w[<TybY[l<<ZNZ2]J1gaE{8A9cn#4dj|C?!mYJyHh7U[bcvbB~P2it{:{y%N#0QGeH=tw4Jy1:?2QLUnjTj=YK,U2+`)]Nl_7P:lB~p5G}PB(O=*.KE^a,6<j?Yd;.vYq(SsW$!x~Z"tFK,,X)AFV"AY=ayrG@.pq1fsU@n1lt_y5=m{Cp{sRMhK"`<pMoOf9m4Q6n4S*O[H.%#|`Wz+TIQGof8YDHHO%9p+[qUgM[n>8feVfrg1ES>)W7i;+QdcKa$nmCj{_k!&TF_AEQ@8t(@e}jhao<(?Pg2g"K{Y4i@@$Z`2lrW/>n{D_HVsJ^QJ+U{WJ~e%HwLHwdn@j0[NwgE34?l*]bx}<}:<1D8XC2w}$w<D_?IV@)N>,Pr.s/{D[)mrvTJ.MB4?Dzu;#CMmC5</I*S8S"+57zUVSJ(|jdH.l43in]kHbahw_+;+"F;Qo<!zK^%~#2Hx_93v!R$OKp~DPD%EHn`]Z$H7AXT?J@z~>]:S}sXJG;b<pE3XI8AG8%xcQF07$=$nM3CMK*X*L$1Mf5pK3o(JT3Qo0$17vL23Eo!nRWp@e[?xY"$Ng@s2A}nS;b}i5Jl}::uJ3[Xh~EPN;nQ,6S_t|RUc(*5]R7M66KO4/+jDG>bS:s6aVy.6fQDNeMFh=H~d1@.2Et7T"0^/];P1=sBUgEmyvPt9YUl6ab%Oj5Z7sZ]4DDfWC]"x(b1e]UI1y.g@cL+)fyJZIY=X?!D0?SCKfj9xTokQu[Too{:]MLfInV$!]cEm_tO#]OLQ*j}VdW_Y6%ybnKI#ELS7}6|WkQ)`BR,Qf9Sc9k!ujUeF?7UW+pRfsO:S}~lO+{w+YbV3%*+`mQQn3Mf.~{s9&[Pp<amVlMUY1!;k^NtMRv$:Z,Qg|z7)mL1DvJ"(9l[j2mgV!!rA%J!g4n4=0jdg~7iI7g$4xIo5r_47F"hm(;dyuuMf:s})3m@l%^C1I.[W!;2[^?AL;6pqsBsz]Z,Y8>(&$[[Rd.oYU(4UuP[%A;60O+tP5NO4fH:s~3[p)e|`I2_pKV+YN5(lka0_/(o{?*%!!ZaY0/IL6?|,e[rq@{S:~yLKZ4(&|1$etK$Jb9>P}YC0$)RZ~T`BKR4^n^D#Z/z]1DKu9C@"jSXrkoT/O5o~X@Bi"o=i<opR<We0r=sfv"c46tq`8pjZvu3nqF]q9Rex_hW!!d8QVM~CUk1pP)U!W;UJPuKV1(#q986[GlbyX>Ly$ht6k?RP~(5ewitLh7?V`;&#%MD&35NMO]nE,]@}v4K~zj)~+d*7+U:`Hv,Cw*~0D%es!K7F58e|?ejKNh,}8N!HemG/nuIvIbrZ=`z=e[U(Q+Ck+n>[0ii*L|f+vl>Q`Lc>55c}(,Lb~MH)vE&~hvG9iGJG0F@}8^%T.rz0TRs1g5iEy/}8+nlhLHAHM3.W:~G8,3s(=G2$HX&P_H1n{@vuO,Z_4:beM$ftV,[4&wuP3vui^E]{iHs>>w0RF:iWX~`TcIL/[zBW+XM5NIyuecYg_S&u{Lwe(U?/,n;y,gu`8BADhV^4p2v>h9D4]]d/w)S@l1_,mxW(KM_6$h(|II2nn_}SkWQ=]|v<LULLn<Exq<2&lmf|DZ|/x<zxpzC*zXUieW`ivJA:,k#0!SDEyf~=BvBKO^gn!D9&=eg*scHD#u@%KcX*VRYXGAAB9^ScM_K<<~o<$h(uM(.8$L.+nL2ZMc8Mc!*[cdSi9mPDu^$=3("xEjJZZ>QvE[d9UZ%R3)j!WgZhva2Xk0R831a2VyFDx+eiQwC{RkLuk,T*&MmJ0jW_]mrhnAP]GqL%rrwP)LFYYB,e]{>(&>GWJkO_1g)HD4LKUt:tFlRQLQ=[SR.QSA4j.7fp!gV7FLf,<P}d.UIu#N&@T~`1d92ZmDvjCDGiF5RSzD8KTO0b`j2n51LYm"&TDwK0Suyu0"2j8;`2~1>vCshWz`:6DKWR_)l_;#d~#{n4p0oyjB<|?;@GujP<SHNQ=#t;a$H=:5TYAM7LJ2ORZC%RO>@.tVWsD&pxs=OVE2Ez.Cjv!UV}K5Fmy$df(p+XMik/_<j>>XV(w>!Q6TqW<.Ysy~4+!nhlSmWo^ZD3YVq2&ck]}bw[~8wfI[}[Zx44[578PPgOH6Y0DdDdvO5QH6Y0(d&YvO}So5qc,ZGNY3p&4vd`nUe5Q0GghxDnDJVkX8jdPP%+wb%BH]>PG6u)6.rQ}1>GJlQ@)WH`wD?w|EObdH=iv]cLF9aY2zVw0K7`OZ3Y)K*dvwT_ZODwZODw[mkR!LZx8S1cwB4LmS1ozrX|=0KUxGCO<@4Y0_^V(l8ceCbY|>*]u]!{a$eI%99o5j$n4ka^nqjMTRou05RXq?}b[aPm(jDO&q|F2w.iLhS4Q)*]fh(D|WPZzZ;|@c5/Bd]YvO*Gwcz/E5J5wy]#]*h}5`A7l#8:QahOiZv]_duF6$<|RPs9_4)rJ6CQc61a?Ta.rGd*CwshObFQ1#ulQ3e<w__6eIv3)|FJP>%w"_sS,?JRXf5Sg7g2n52bKfH9[woes{DaebKYTk1)f{+B):YiB`Y.jR^r^Xo{[2Hntr8[CJ/{3PBx.l<TC$eIJktSFa"3P+C#x;#j~1{jrZ&JfVL{a>_8x`*2[W&}6gj.q2@}%>&>e&9cpP@W#0I:w,.0Zn?<y@7{m.ohk.Bya#c>/?Qrw^XoN(S~.&/|u}r|?)HTD}c.XFKPcz,xl,ng6O_Li5,YF4RTr9Fm.#~._<tx=gn{`p9z+qXUZt?Sq@~dejv!%EBe:/G#}x@qA3*#@t7zU;ik>&{FxiVZ)F.2"rm.?tqe<qd601F}uK/0R1q:%lp9jP{?]P*loQCp<{W]hkpb]SM`z*!naxNIH9GBh.p78@B:8Pd[9%uI9:g^GT0*~*E*S8U!V!LKr[/W1PjVskwJI8Y/eavEi.h|+EPIC<v0.`Kv({4+g,k.9j7VT[~$2o`{"@KkG||:4,D~r{c2L``h][IYr9iZ9f$)kKWfM6"^8#jATHOlN3l:t1ca%Mn{^F7@ENEFyb+2"5#OXCoPPvg``0KY:%f)TX>[WF%)_Lf.Zq#lL[d4TdaC!9n:>*?*.2ZUrOefO5`f)l~8vy?F7*pdA9NLY9l{eI50Sk]~iib+qTJ6C{D"ysx2bYvWN@EtgOKA$vPAH91Y.vY0VfO5GGAPhm0O@bD]e9TYY7<0EGt66D1RT+V2zAe2Nb0GHaH"wooutzJbPaH5+]e6MYf2Y7mGQ3ZOq6nTJ{oAG"jyGSuU2R/Uk.!Xj%(2T!<;Tx#IFEb&AO$>k0U^*}5qSm>$Y.7g5S,!rmbFVc;eL245E6Ehg0l?O`%W+dbUbNDGl&/@OtLNU1k/DVlVDTL)WR?;$3I]U#n::6J:L_[xN,!;20kq=m8b1TvVQ^Iu|K;*"K7!Ln4bS3K[FsC06OjelQszUWMbS3Rbuy@8ldWc=IF9$OKp;6n59A)|Nd_&tb8[C}.o.=>rGSoGP]76*];v*0wc06fei.(tALGl;;t5nTerl`&o+mV43oozqOMI{{Msbf|>|:5|+EE!WSXQcE.QH!?XO54(8WjH.E>$^aDNnCSJvK$K%w:6#of<Q(q!7hNH&JNF:Y{*6Fjg)xU2.z;.FVG3av391><lcm+>7o{Vn?LrcU9!#KN0*9pk2.dUV6S}eUfUe;9.v/viX7bOKmx1KhPdhS9FL5/R"[2*`|CbPd=[N;d3rxcc(~Z?pGi}M;HscgTY=fgr8*..k1V6Esp>@%8,;(76|cyfi,Gre,Zm>pB9`c^V,<e{*Cy3Mu[K_#:mVETwvQxYH#fi<D{7KF75F)ry/bHSdRB`>fFI+9e(+m1DG9H9=;k{9?|npFwnu8QJmYHc]4PIz:aEc5s%4TqY+;cqmrkw4y3xpK8tC=~RWgw`}!j(b,,tYF9Q!nv;>=h$<^>zno+v)KY15[MnTxHsBx^hIz5XEI6$TrTg"Kqh#n0TBck?IuM7bHOM}2hNww49:dR+|VJS6ptP|Yut5P@&S2eqq<4L7Bc;Y$3?KGU{=7CMm]B]3N23voXUMpJTBnb9s5}:Z=`|1l0ScTnA"kVhM23wiM|U6Q|`S^yJ"Jy|@&(2_3)nd.ax,031yP#"04{WJoYYon++kH.wAVPfjqlYhJV?|8!A4NNJ7I|,&3nNMOG|^ljk9^zqQxeq|Av5Jup;JteqWTBt.c7q~C$#}#9:`0GQ>$!<|vmpw+Cq8cA=d$Q)ei,n?<*1QF=_*RFeLPTNPH3cHs[d~*E1[{WPC?&(icWyEJq@A,~lGtbg6#1)XH)B;*_lHqTg{"C*~.ZwHQ1GQgQi+WP|z;goYJ=B$aj$n?a|pZH_rB8X)i~DDju^{tupIk)@($@2;P|B@:(?[JF:[:i<,7pV{CB`S_D]J>P_WKX8BdMqRy([y5ncw|YIpFQ5~cu|KJ>avn!}!Hl>FU>{k;v|NJfT%1D?#}eK2L%<ffC_$b5`;@ap<XXtlreG(l[0TSgUww`6n0KI5+W<fZy5Ou^JCsU[C.vp|o~ChvC<5.)F=*d=bmjJd(XtI^nFYXRFLbLu2EXx>{1oDt>X*/7*>0,G8v[Co0L1hF4Dd%o5h;}l:|,&l~_3|#^}o}}nnZ5(UT6s{f.[@[&{O`^UbB(cDlEJl=:Lh_%.gYDOT_7hybxX%k4~W!gp*)G|p_=TOkQT`iqTAhWs~Cyf4&bE!vUN"Esk#}H/Y$5:4Hsu(kHx9X0r.ZLxp.q{,{a5^|u[=%@WwB:+@VVG%To[GQKSE[]Hqn(2l7~>3$fEI&~uK*wtg*S08d#twV)Ti}9U_Y#S:_0e)1%lM^I(WB)BQ66*ab.r?]*{@+ko40soY%D?lzD3897S^lEg]Vr%*sC3,=P:X+w`;Hr_a^{a;/l?bm~,Dgqr%#AGUkWhkh|8uD7DW=*|02CnH`3M*]9Qs&)s}*zlNGDO7c60f!Oul<K+#21mMgPEgFP(7@5.{ZcptlxBEccaM9o*QTIqJ7|[6=)r(2MbMR+E4D8UvX1UoCdIsNLwDP$Hj8$H}=Rk>Lj=>;Ph(JdgOq_=o}tM)uLoHF_8&`sf5_Se*`hC)oCj=]&]a4qrQ6V[kVv+kH4o&Ln.8DVX$D<"yDgFD6}6]YP>eh1tr>1owW!7e&*{J[SYTxw53YFeuOc@E4|S^eV(H~U6$7Cr!&+g|a5gkj:g+d(8uHheN.KxA[c6T6KD1b<[&g[xcYy=C~:/v&6Znn1av/;uqt<(}J,dzC%~$q%66p%`K9T,4ZXiA@Q()BuA#(JA"|qkK;0;32Khlc<e^pIHT+E1MK~C=Bo&JEa&vGc8N[mt5(Wp"7N[ot#(H,8etnL/OFJG,.cl4NrV?@WK[6k1DVNmW/wD!;ZjjWjnGTce+&[ww4!!372rbrL>sv9Jp0[Ov<8(*i*2{*}~y:xr(&,%G!H*y6x#1:0u_=_U~%[sa*&Emg7~O8T}d$uI8IdbgO,lCRISH^2oqb1.oD8SFro#9v>N5PZAtDeaJn{y|0TJ*r_lc}IO]cNkG|(5b<}7:*us3[%5+Pm1,kO[V}uoO$O}c.~Pt/Gnl]`KXU2]?WQfF2;;Jw%n>`&qh`OpU[fV11Gomi}$`*n{v*p_e6XQbjv&Qs=)g7<VUWz4h|e._(@H0_T;ggYY,T}6/)VI_JM(p~*/*fogO5X_a=%DK,"{WPOGoY!Jr_gL&u(6oQr;3N}bem5lTbwi9*HR@@F*ot"_d;JB+HFaKa#r2kb4d;??SvuigsT_4f58TCg41mgL&mh9~_h4a/d;4)|B>)Tntm&nY#?nk2Zc4/QS)=<E,VgiD1o;@(w#!x`gkJ6_RtDW/hH>=YJ|YSJa,I|s70V,iy%Q@isrVV!&SM}FBx,0FEA42)D.0voZXN"4AW=kYu?(ZL_q"K?t_L7Wh}ujc.OphFHv]LajqV=FBlml7X`8&/A]A&D05Iala?G6({$mA:eI|`B(#&t5#Q"W]s]n4sJcb/U"l*oYujFZRVBFqCT?jZhzdJ[BSi5YvznU+!uIhg}I@u:LkLPc6&;k^8lko5$j<$a~Nghmz=1>KJr.rMd%Rq{?%YJftsyr#{@]UE&J9D4n/eJ=?zHaTyKm(aKUz!|ZvO%_?MadL{<u}MyuccL[{><0Y>_o%3c)$In"T2Lo[[+J%,_/`iZ;9s>^mTw%s$4UfYmf&#r659wT>,[?(r~@P.p:FzDxGnk{{+6)"!pv9G.l.aw]g|O`Hq3Ny;QYL)#rCRo>hbEv^2<VEzTha1y/rYhVhlD5n)n?skb[B@uNK#vrKNV#5/@b7<^iL49/&f<XNK?J,ivT*a0Yi$5x{VYU(KR>t!ev>F?|).eTVEwIhHN{4tW|_Qp_DZR1n(,D32K>gCENyN3JvpPf]i3R!zlDk.(nz[_rSw_+y!eU&B13QQYj^UR=fmz[|6xfGVGd<l;1fs~}G*<*;$!B2jYxYg]}29hw:m^x:6kxrVU&a>:M+_](%u9JZ06KVZHQ~.4%gD&ooy[Z|04$oE358`ZHIFRxNCs(4ymyfsaGP7#<=N8_#:3[&i!a]+m{nTL@nLR5bc=M$;Fo8V0b$$NMqS:,a;>Ka^JQg.1&r2iSKBY+3&35hb}_p}tvFo]R5<j$gaehi)5(R5Y`Us*)#Wm/nSOF"Y8jI>1F!m+KCKaOjiOVwFK93r"E^?};a.?T8%OR2QNKtv?xnB3|E0dt^"FHuCSoWuEK[4cSEyHbZ9?hET:X0H>xuJU*7gi}+>&(3(f[$=|v!n{wi=mG[Yhy|HG+2)NQ"h(nRu5.Yv*)bUP9~!($hW1P~.4Gi=Fc5lf?o$<LpI9H8U]4:<b|7#H9[fx>UdKg(oraQ>op/oraa@t}la|4d[4u,pvPiO]9X#YSW&hoG&p2`p_VukH*9BVZ~th&Jl_}(=qGXsSkq=R?j8OuUr7d>;b=Z{LNU]][Clrs=oo]U8<eV=4/Xay[zeJnb[&q]S}qUcab#o$:+g*W+]o]7o[iDh3yt,,5Yh>`Wn<s_6I:t!6/TKlJE1uOe8EJ5;;<MHrR[.%/S6ajk`(X.rcs.*{whB9r9@r`tc]_9k#8eqgOB9E5{">^(qfxj:<^Xf0/Bb^pf9T[X9NT<%B;HUav=]=v<=xSD~G$pU]6<ngi=O+NC:7)a@v8*&e*QGn!&kEbM8M2Y5VGF)?s&H?wP8g*rO5_*E}=Zopt},](^Ye*EfjEo&ve((M4~BlV~C|!RCVW~N1Vv1$OwPIu]3`Hqgoll!aas8R1}ls5:g_5~B5;fY3pYF(74?yMonXxTMbR;Zwrr=(zpt`8E1/ao7!#alZ9&5;BB_zhFf*dc[`f)lFd~^%%Mdq3Yk&ZW7<d,5z<}m5a)K~Mp$!%]Up$hMp9xv4ncpbovb/D=FPuRR~E*U$E)Ay/ZuB<fXH+}BZOw$%^9cSu>yr[w,O|aMKDh#|N7P0pRyz5E:v=gKbb~EdIxwibi=;u1wl&mJ0%2A6g6pG9P"D/UP$%w;11`Kl"XE%TPLoC}4`hKVvz&$]#,hQ:u.sB|"{GR>_oSkOErOnr<da*y$hMOeuCn=s2AZhF^t%_|Q6l.I~BVtjhXXg1I.)k+hRN*B>)3_C^GOqtY&xCB!DaZ~HHMExr#{Gi>JQ>_DycA_?>nnC{PyV7xMyMict>{cm^#UME!6ZdQT18m;zl``Y_pR~zWe.6{9X#{HB`~."J*/oI|=&tmz]4"/!2&mr,7Xv>KEB:63Mxgm~7,[r:%mba^e^N?|ck]`m8(,u>PC6X0(6wf]AWjk}ete02i.Lnn*apY/pt+PnS3v}e~.4I)Gs%%p+0LjuKyJLkpRDt.n&2{VxjMl((EUgO(1[u,kr@_LM^O9=`drWyZT|27Nfdd(B&NDm{<"R8,T(Y(a<j3V5BTr&jb7Fm;zy4h#ZQ=4Heav|zCw=L.B1rrns.Bd!qpTjY)$cGvoI`n_Ul}HX5Vo~w0{BlFb]Nox,b:#t9qZ$Au3"eTdgJeHVkR0UEafXI?D4%rcA^J#Iacs1uNqDs>@;h?4Vo=EM^7!A2yUw3mw0Tmtp!S}2G}>L^@(8nm{(`(FM+/OvT],}iyTu"#<h%f[n2X$uIrK7"Xo%gq4qc~ix!|m>SUGlFc[`t(1VSseINijac$x>2~gnW0B`^,?20=5`x<xG]NzX(MCPr;M7iOh|T3vO8k[_8ii$Tuo|B+}4}ZBKWlnOI"o4i~`oG5"0?gS(pY?RQ@s=)pL~?a|gl4KMmg/;JI|B6a,5$3Nl`8C|WVPJ49Pn?TCunPf<)QxTZMRd7)Ve;gz=@{eMF(cyt]iIf/jV:=E%`)9ETYWMJ!ZU|(OuT`9`fLQ$"WjH4I]KpKLbxwqDbc[]rG|$6N_iqGc=3+j{.=qQ1`#Y%Kd<gB^:0*=x[Q.1[e1>6SjX8ZsE2gc7M$bA1BE!d}`&W^Md?{iN]$k^[50bebFJM8:da~d=zW7kd)`0}Fq#wQx?yFT<X24c~m|R#6S_+_i,kx2mIRVr!N_bJIp%(f[R3s2{jwOLl3NCxToo.FdOW5$V.?$x>V}Dh0rqn@Xd$U#0mL{Wx3?ywP:rsjCh]3Y6,"[1Inl)Fm2V{=;j&!9ZabYU*n>h[1/iC~ioJYc05;Ru5;UxY7+CdOx<SYC{,mhy|^rUg,iPpDP{ZHV|%wY}y(U6KG0Og%?PJ>Tl:^?4Qep2xxPtQWT()Q<8;+^rNI&nX=A*Dgs()51DTj)xs9@rmW(q[Z!R<x8UFKG>|LfZ(H#;^,FO3a=x/1&,!_,Q3!ZMPi(j5u5YJSJ(}c9;>?{O?/aSNbp`6b[s$qZ5(&`NSt#M7((s7:8~3a_#PnSYcrom2EWdk]P37d7W?=p_EsBNu=yFT/yG^e;4mze4O9F+D2:32Or?0dUN.Vdk^n87u7vxSdmJ08`w^S0WV/ZcFh]4+|VMOX;<Qnp:lEbxv`4]}B0cebN(q%gCwF2$>N$C0`m*x^qi!{@q>)j4h(n.X5PjeRkBX7v#cg1tCbuZ^1h`:5I?@?{r$l:Zl{l{d3oo*>pQ]$on(+(DIKq8~0!4]ISG^ES}d?ie5SN*AQP27p~{k8X"t:S9P,fsOuN+sT6T6[bVktgK2^<U.XU#]r1}ar~3xO1cvX[:@/0ubihx7u;Ds}x7T8[U!p<+m*/^;p2!RnQ27bU:;7o1+h66MkpWVLlT>l+xiABaF)1*m%,p+v!GlGs[*|nS=Ei)M{?[7jNz$!Y}#Xp,i=QRn&l9d#F.SaLead4YWdkU)ot)K>UE1y1fVVXd,w%X8(%i6"xiq~@uYbNE,`MC<)&;Ry%FzHQgQVc`(V|*gPjhg={AqCM2IuCnuH;}v_p.Q:ZG>9sTL*28:ab]m.&q9&bf4T@u5FvS}}mK5RkI?,v87L?@HTkXy!E{2;&%cYi`)n{_b>%^O*|*<b>SfX>H=#c%C2nAB=&buLkUJ*%L}?>V=NXx2yQO<5w{@mIH^EutS50`>59E25Db0u;SYP1B*P(6^`xVI#I0I&}@KBw<($9*7dLke@3;HC8~fB8,l=;rzS?l1Dk%GPzvTmj_a6`KT+2vovJUtf{o2K&/QE?dQs?Xo49Zm4]yGn.<^:2>f9k0(LK4Cx30~!vsK,8@Kl&EO!2TISJw5:*nc$=@0a{jRF)g(zzb>9:R!TI,LjBt8<)0P%?F_A7X$*]LTI9VUhqH#ng+7+)Ns?L:N}v`f_dzs@5k15mc6G,8aE/:w``If,bRy!k^}#Jj5{mHB+LlviX7{(xs@L1zglpz}>!{cOM@w&&{rnfafEW%PnQ+0RMm0=5LHKlN@_WJ&Wn_Gq56J+~a:?#oa&YJMUb&YCRIp+2WRvOBWO=if4T%OA/@Vxq8NT@@r9yoU[Y}`y&3w(_bgyrT_,&V29{4bb^t5>|Hg|&@#t;`fr;`fo5N=s`n#Kk>B`j,xHl~:_f{f)l~8?Sw;y2GVDeuliRk2:x/e%;+:*cHJ5w2Q1.]]8VXUP*Eh{rkj(6jm:,)]672ufHN}&:J,YLP{u#Eg7S/Fd,rVNa#WFMa3I82m3T<8HCN9Rz%ZpYHn1ok&"O%Sh@HJH;02JbRm/`)2GnfUcpL31T~0&1#}n#xP~|q{.c{1_|A7Dj"^6yhh>_#7Z>WnJ#!K+`>TA0xHIUd.4UNe4w<y"m|%b;ZjTn""[!QLE*@!TmFjT>":~`Ln9QQYSthU>l>8UD`(/hVOrv`Q+Oh5m2vEh<cdxbxTcNBsi.K_sgz<[{*f8A^7q*xoguRrbC0}RoLzQW&*)B9z;)a1]/@R8,8CZy!vW70`2L6u)Ez~6Rk^LMZX01V2ni]1)r2rx4kgY4uK{Ncmnd|frCz5*%RKyJ"yFdD=Vwyb*%OvmY6:G5K`dSh?fHdR#*X8Q`1r}*h7Wx%Pv_@8_?v+K|*p^q>r{_]V<!Gc0eJ[L2Jn6gKq)vj`5qsMBadeMaD]456Z2rE^)Q3T5JpLJZH[cl;q>Yk?N5:Wu>6r<s$rTTb~x+W[a>jfUO]`hHW6GZH[/[`SO50ct1.^gygvz!mx&+nEsUZmY]Eb|1sk`3k(b;GDx3A.o,02DS_+S2/Z)_JB~b|>2R6J50|>iV#qr`W&>q_l>Imv?gj&C=[NoxXJjsuo27M@O[X8`{^j>E{@B[fwLsc1Q1|K]HX}DLA9?z^GFJxqpkKkq<lFSr;2Ee>HdqZWc#h%ppsHc&iH|$}gKoHw047<YMSogILE|<KS1^!g[}t,l`$}b=zJj:wy.mLx(wXT).CGPkrY^[(E%fRPQ.xvsoTgX=+*qMISM_GD;ksTHwPYj^cy+.TodB"SZR|3]nrY;pG!E}D5#r4]#QFE!Wk37U0Y]q2Wq&ll<8MLuJ;*0@r<Jfz?f{{Dy$K[6oj.uz*kqiR}`S&3`?kf5?GT^)^]e;|K([`2VOa[uSC0!N(p0o12)p<g2<P#[or=&Ntvx2F2sR4l1!%}5=:maG5yTPV,a^Q?cl0Y1KR63Ya;fYspa5GxAy($y<68>*#?:.$UE.U/43A7KJ55LB[#97B$LqOg/np:"k5)((m3ep?gL29;K8<.&OI47Nt$wf<zP9n&PE_!*VEV/5[?DuTlu#}o/P}%H;l..b^S2J<3+qj8*VjV:z$8Fz4uU__{"^sH)Z;<Ya&PpjN3H[GK=z}66<+mGoJcN;|q]n,52s~;pfuwg>X5)pnH^.WM>n=vf3>f&2I%nNZ5^}Yy&.l8!Owm9$6,8]`<wV@xbZYvBcu~"}3Uy<g~zL*:Eyt&pE`"}~K6x+5bM7*j)y%)l4GHnInZa~o_Y+%_:j0v@qK{U;we.a5}Vvqt^i$,^[/i"%)Kj+9GJ]DWD=hmb+`w63,&M2Mh@b<ZYvk~*U.eRt<:EyE#IqC0meaULjh[{3u^bbcWY%>x*q83KI9usQIUNh#_.x:v+l|^6p/]sv[dD*_%")giM5)7VZW!21Ml=v1}#v[LwLXwZ8*+Nhuz`S_WH.;+L)SS!s/C4MnT;owrIoGX{Y$2Lo8a6=S&kB2q9WV3/et+_R)21^0YjvC>HM()^}B~5.g^?.{mBHrHiOt8Yvm2WLZ.1nvQJ#z.U4O3CVbUz$(c$WPoG,bdz!;KShz!]_D#OZcF8b12jbJTq#%g>JveFc"0;e68:TSM5PqdU.<da@o#8#FTSr||)].;LpIOXamQ=fXEZ&hb{6K:XCC9!7h/G!GmcNTqKTR>/OB`KSAqXY#Je7%*^]7R4:}]({lS#nNO7tGkv"gvkRk_D|hryrtsFaOON$L9)0c=nEKqQxr[G+BNUG<8P"cu)cRUu}l=%DB>*2Z!OX&uIIz*[DtiBiZTa9IQKR##]qgBm5GufG)X<DhWpXa/_2Bdz:?m~k$nOpT)7#zl>zM;e%K|5lOu|kx>dUE<F!N;R]6dzfW()/PH/&@S=k9Qdng7`xWw{x,QXyyf4p9>S7/)<L/WgZTh%6+(cU/.2Zxb]^%@8X35Q0W5)/FZ%Y?O_bM18`J4<RZ,X{{E{yVt2RL6x*|:Y%#kA}VlAU5fe3iYqlDe)N0v(/BeOG}8?zokvXcJ63E[#{fb+*.)@*x1Zaq5/DM%TfQbyo2.BCCW^lCWlP]5(:=77jgU"2a{r;&(xZAOBlo8.Pjh5?Dd,ZbKR0_68b<<zZF6im32H6zT`ixkoH,!8+LVbOXx[|qqTU+[#cJZ+YhQT8,2@|***q6wPp,qQZA/_3,[$]kQT3Sy.,u,26J,8GHSwrgvyu8B2jjy`H&0,aoPMj,&UY_4hx/R2U2&MM+acT^MLPzmIf0ul+N6E2FvjlCRu&9bO5oB%D~Y44FdrVfPl[8rA432%!OpR>Q!1Js*a.=8{Vk?))NkiD6Yz6MTX<PVKFZmHNeLuXs^8%FRncc[N@m7HgfV&Q#qK2]XrC1rjBY+!F1vafYmG2~O83L1i4$e8LpX.]`Hf;:+:ZS179K[.|k.Mo{VSb^Omv|4j&~3Mg/n[$Y:43k}~S{Mn.InOIAWilvLTYRT@54{.bg9&YSU6o0Opy5Z=&#7EKO^U97Zd(,{g:q~E~`:6%d>i[_|@sVh]oZVdCM`#`/:Wr~3?ci3KU?kZpF`9r8YyuOHAz4ug@hH=Q,r/`~[d.N[sW:|psQqXpE:|Z:N@fzUs5VS+Mk5xVB>^OsVxbtU:NCJ=<Dr8Ke.VwB}>5_zs.YGKgj]PXj7;)%yq0B(L~`fgB>%+__#,y&Bc5GBbDmt`94uy:;:(?8/tREoJ1EI$F<.&#:q8TJy>JS?KCu[Z3N>42bbF`n(W`J@`=T,:!wqSy+kwZ%:20*2K*^qjqqgGo=XNK|;z<MAdzchl9KropcK|/{2>)V!|1X.W.v0ZVZWG|@HmkQq+*2h]8k,Qkj&Ng:_Mf~g?b1,X$n8FeN`r^b>ISb&b=ib19eWEJRhF=iwO9o?12<~@z~tO_|q$?:.6$X%J9v}r;(mfi_mv1*+*jR(J9pih4F>rzTwv(6sR[,}U2:|%&,{9C7f@%x4f@gy7^@MW_OL0rDLV4N<hC<`c<UuDa.|.5L@YnNKAuJ/z%Q8CmHm;07G4P&0c;(?;4+Sm&Q(Y.M<W9O/(?t<|vNoJY^wdGDJtvnvq!*Jv2*_~Ur!*nab6G|$.@?KrRVfqWZn@_a<Mm`i%?g^302V!|leiEv|O<KW+m:s%2mPIS002`Jqr5t:|pQ8P8k5058hTorokWt>sOM32^_<t`02r:r0~`@[.*22n,uIH&`/uI*I;GkPFiNh]`@d]if5"/A`="~KOtmw@03&83^%Vwg6QIXNQDq?!mVw:|)$=M,,`<^dnpVV##<]L18uG>QU@CJ9Hu$.+FGd12y,u>I8r^p<zTz4N(s3"r=jyk}3E.{&2D`8Hr"8jqKKP6ENF6k.@sDsOp>fOp>#4k&~|?Be@_cNG/Ban!=i0rL`DqL`}b4Kd,=e%:6)ww0_6eHWT}02LloJ%PJS*sgGdN01#}*b"<$&_SxChmv|M(m(~,zs^Da7uDnUhqTUU|KcII;v3ev=QGDrZYDfdT^MXFuv9GC7qy|1%E_2Qp?O!F{gkqwN]+Q#q%aNZI|D+dA{V|[?"2@#O$Z3JyaJ4#sfLzL0kxd^1X2dsq5vr+ub6dn~PaCV/F6omo:Y_tK+bH:XVPnQSkZ.1Y|JqBEIB@MLU:d5+%?ox8FxzdS:?YXhuQ8I;&TqGX=NW?ME9YS6vvQPnfbY)K50=5}o,iLPLJx[(@^o^8<HA[[W:z;%kcl0:0T0@,Mh`D<E7wUkZ2`2kBft1];[CiG^4O_BLxzdfT4uWK?HKgRoEFyNzs__N#3{&7`SEGp]V({SS1uL))&|2a4js}To@pWYk11Jqr&,tQ!%Zm1)zvP:X%viIu/i"*vY?vgDbB*&0L$:$!Zu~PH;6,VoLvVaDn"0b4`FcKw>M={P:{gMagBxOv69.w;aC!*&phC5"^{.)/H(K^;@y0K:V(AcJu!z:n!7>kUswJ1n~NL#3:B<CdwrXIEGUh1ZK|;8QO(m"Q::V#k|pE0^Uvm4Hvn*nE?_2El;h|sm1=eF["Kz$q|uP:Ki._&mxTjgor])FR*JrH#vrtoJgCUN<mT&XJ{$gwIQSvB*VtDMHBZiYx%W)1h99uC}FPm?KMo=y0)mtT7}biE_X&vEH`haQv5L#Wrv:?$Qd$`Jc0CYqzIB~&j%_PiN:r&8Qmeb<zA;UXLw,=kwca#vX,R>[O*3ahUe:@1Q,i~k*:vEP`U_bbSg!G;*.6}kj<hrsJq+960GRk?a%M:hkfBs??q~~Z@5k.8o`=nO"d&wDN+ZJY}PNHT2YYqLj]VH<7DNGN1wGEe7(=qdyZwQb8THw?J%gN[E[>iA*MI_Jn<{,GKn_6o&7|~f:jWSx^8:}s]2<4~^<vn[#:/TmrUb$&9opd_C`8:)^Zp!b1)4frY~SZ]r#&h$77I(eqU=9}f0"VKT/0IY*Z%q8X%ZCPbhU;#uUt)~_8&!}P[#t;*#O_NMcg)l~8*@_8%cMaBsO:96qOT@KFuk?Iz9Prn:i&QL(I25zIJ^Fn8t_(iP?6[v+#(ZVX]C4Lqu!c>C%+PrTP&ZbXhz3fcX}OoJWJ*<+bp;7LmZxLTDG5K;:9B.vM,lEWNS,rS}``LgIrbbk4FxrxK+MmVETw9s%_6Yey3`(r//`+B~UM<Ly<r.z;dT.`>%]lj.?t9G?$AGv|*d5([wnNpy:BS!D#3br+IoE9w`mW0fmTN:@)gy(b#gw.YvBWH+p+pU/>,OIE{B)R.S3Lh/Yhz8.}G&G`p;PEEcNqD"A9V_otEX(IP#%gA^!i4X{C={7~~P6]te&A|lC)rWH<:SJ^jB3DZc&SkU*RJ]QxCs:4JO6JRn?ort[>JB_1@{>h.ZGTCG(lp|J59G4^U%ghey4yzYAqO=efxyMh`m2sI!Nq_i8.4+5&osCh+d;sXp3TdqI=)SZ<3@N=Gg)B_[V:jmSMG`s>]Or2t5X`Y0MavO1yI|"ZLw.Ky##92IaE_`,j^zc>xXOQ?d:cs>niIVDf[5tFc*MgPE%:2f%+HqmjJWP68m@dt0ZTo><x{{i}Nh".vE0aH^.j:#v0@$T,@Vqvtm.Ka^Iu@|gLUVkpGXrT/FC8u]nzW8THy?vKpId@v6zjwg^x%D0/=8)VPF`!sxSSMx2^c.@e,.%l__~v,_?>?,3sIH2IsNyFM#W;!?qcM*^R?pU(/w!>j{X/:<3Tz}Mi`6tKy{Ua4,age5WxX9|!oX|J4;aM;`tSBck[bVSK7]s>_lH#4aKd.It.dN+nv2<=[OFUc[^Lk[iQbf[{c(s^Py99Dhu[Y!^<ehp8Eq{nmIRk0o!CA)N>o^/Py})3n{MT+VW0viB&Nm5:,/&=@6R"pv/q*w|EZx}CbY&y~dIe(g4m5cEwKrFf%S[Gvp4Qz>{Rq#/FbLi"?j$Ar68FRt8MbBJoeu&"nL!+lleKc{xN{8#v9_Y:Zd/]&Z]Vnfgti#bzVkECQeO[6>eaGk}U23z]b>c8TOzUkNc@[#y}:yusQq1Z1caO8:xOXzK5/TUX`c4k1q+i7dX+^K<?AF2jf5O]@m%vHo27p%s=zoAO<URkHDblDnUmLaw}3F?CD6FaG!jOZx)5[6RPquOG.&K|aV{/73O]<18&9|0]_8gYi_oj44xxg1*Vl+=+uHGFofNO?)synfx9`VFeZ`uGuo!Xv?YeyZqx$HXajPi.KoLqZ%]2Y!wLg&e&f#i`5CNkG%n2]?{ilKd>6;GTc*e1RS`n.y8=/@*qJ#d;$NFy[Gf5mmtm>4>n(Qi/R*i6Wk?6hwp.4va*iAzWxpwQf2Ch;95$`][2D}.|D4hi5?Mb=0se?;yIWP[J?2|L*<nz"M}Zq5V7YHsVCb]|^RKH.3bX0&Pn#`W^J8~1^1SO&hg3G2YsDsY3vM;I3+6+*5Y0PwP3ux)o6M@rv`Yze/Pn&0/)CJ}M$b*[]Lo0wo&2N}~2bOYgT]q:<KxqQ@qFwg3N?$O{r9O5g>y2R&uRO3G%Y.VR1Y4"DrRVKs?3D48`xPvcw7[4b31qu_>xM$>4V$%rma5lH#w7%2t)BWWbC{C{"OR3VL!H.2a5oVBkG`akik.o67t.C`ld4:7u/Blr?8f>uVz$7[*<nTti3+%jsbzIKkG:&lTeF]~kI`>qG#IGfO[cObl@Zp8VLz9a]/k.>[g%M[{d8a?8+%39JTa1A6ef`fX8U0!vBzC+^RO0pUydz&c@gSZ,%rkxh:=iK{Rlu.6fT5&lz`1JBMQDmZe<!qg51ZvZl|{z^f9Q!s^N,gKMaN0?3,S17LG[v<e3$9iYctfIqWWIJCFeb%k./Sg<U9STYy[DV9odm,wTYpkFlB&us6U610S?cQIj42h%YrsEbBvongR}.Q8as[OMe._3_=g~b.&jkyCU=Ly<l.kVo[|}<lH#la%&]k`6xKDT(n;eotUzt)4CB*24p.zQm],u?`m9nZwz<B84X_xRE*l7(xwHJ%gf&$OkzTSD:2r<1[B#RNs:Zme@S8S6NK"IiVMx^}T]PsR[<^H,x{]w;j(gJ*%8>Hnv^Z$BQ3Ekja`n#{8w~^0pRd7on7a1$/4CT}%D&>`!^z/fbbr*slD!Xy8:6ZtaI{qLqu5VH6_oC]RTe)w%I0xz@m]K^Ee:*m0O^EC{F~#/s%YzKm`;:Q*b72<*beqWLP(5sz,iWx2xMvF)CqpR>!W%5Do[=gD4JqN,RI}yN,}8[n.0[[Hh.243|xxIrJ^`QaV0|oW5W%x;`5tk6H|Dxx%Gi0bJl:h)8#!]qYjoQFjc);k7GUCwCN7Ne{!{;v#m>XvEG|k/|>:EY;t7ehe!Yx$h;nTkFLQ7"^Pnxd}/ntNLl+GBQD"=xQx=v:+^.]%=vKjX8GpZPvNfMCowOc:by"1Wa4*h,^JEq}FE`#8"L`|hEMK02G1(MHdJ@tTq8MvDw)ZT1<11`6UY$Lx55X<,nUeVuIy)d;@(:Q^iMj58NY9]fwd;3AQ}4W9]?Y9]vwd;MBVf4F]i#a1xBcbSz~S/Q}.W9]AZ9]kB58o1d;GDVfjU$G&5ME;Bwn4[xd:CX)p4(T3e#DUM$[W)/*MqW5epbWb[2y;o.}(VL/5<i2gauD~y0*Q`={}N7aaMqM6Mj[DBFKnOaYU*x1DD$1@kX0vvV/9LADQ:L%&|8<y{y(QTBoNB<z*koI22CCpnc#cXw"QV[|I@;6%G=TZmJ5G[LZgml,?ZAP{,xEPToj~7b#*M{p)x^Z`N7NoE22p~1kLYh4JMqtlD<Q,rS!aPd(qBi`D?m.x|/p(1)V!=x=sRanwa(1`ST<jGsRy0NpQ*1A}N@,P:`A}nY*KB(1L@iB(1;@6B0O/*4sbS^pk4W%QB*/5=$t{@MGpRs[;,ru)7epzDuJi)oyupQg>{!=UpfETB5!z37NzWCti7S/q*2Gu7LC:"5WW|^X4IeR(m+OrBQ??hhQ(j.w;a>aDHB&?n@/`(!2eH3^6(qI0:/nPg9nuB,VSOPV/JnSuqkcLD^NcwA0q6X)t#RogLquld]Ol0cSMYYS2"M2v4UDh1}Y|$r#RoVJ*&{"=+:i"*^}Fj@V`Bqs}ziK:)/Qh|5eVNGBq!cu7N}^F%!,0;^JU3wpFJ[39t}k.kw_c"y//nyS8L$bR=PY}5AM.n}FP31K,?E1cdZwR6"<Kw:(9[t/U6FqfKfm?&+Q4EN?v_fv{@Bf@,fx,]Yf^w.n1ABc3LyG^B;[4!xd#<4EaDql]i"A:T=(sCGfq&ap]#^/Ta2[&ibD{P&x<EVf!zTGO)(jH+YG(1A[yC9Xro<fpRByb/5=~A&B94VU[4VUx/UMCwp:^hQTL[u2{@^kquCn=C(A]#ttB_mC7U.wILl3Hf!/yAdwrx/&r,u{y)5<sn~S?R=?`I|H1}7#!:vr?{/_y)Zs}B&)Fc7l%xy5anjxd;VeI_WfR:>Q/*tjz;nEk4?I!/8/9G;3n#Tx=NtRtj=*kqFX;QMqH4Sk{(#9]Nb4Txm.*xW3oncwj.@!!mr7/Ei7&WjvuLqa#iDulJ!<s.@GEi_g$2rvd,n{V}8]qSKk?SF5;S%xu*EE^iiR<K&oEe(?0U#d+rixa8`S~DdF"Bw!Tf(NJ)dZIIaC#twB&RF`m.<Zu[c`U!eml7Y+5jv(,K/w{$[k]l5oM<;2WJ1wh@{ibFFTz/8`2oDQ""7%F6nN(1dp6,nN(1dpcTB&Ah%G8=gCa;Hy_OtY`Iq#%Yw9ihnEhq#fF%2A*=/oj83EE*8wQY5IV"YOEoWtE6/E<c%pTP?Ro7p"+FmU0sBJLE&$tx4mqK}ZcCKxHFCcuDXA{lrq.?o}1=|Hc_CE2ub%U!,tMF<=WdP]FvT[TI`JH_9KX:9v6B1rY:#Rj|M(v3TX9er8W$@8~f)1<0gN0hq3B{}/+l,LJSY,XN8R:,gYnkUM~Y|o)Z~Nml2JI[oth?_"2=6Cl1w7NKH:Q5(d^e#LpG;olliMYAAAQYFAy"VBSwHHjS3ZtSnFKA>WLga3ww_MnG?c%*4ICAAAAAAABt?j6kAA_D`h.rK[];*D"Tc,^puxtL[T!IX~rU[s%=WhUCB,Oo@h&X[eO!iw5g/%<R7_rVw08"|Pf][X18Or0BPyo<^6{7kT92eR1M7E5~A4KpmL#tr~BU.S]?zD[aJJ~k<69q6iy%JV%LYj|p_&q2Eh!_P_=4gtkz,m8@1vdk6i{~5@;x2vx!.Li8MPJ5hkR;6yo8&3AsUlR0~#}_{@czy~Xo%D2W`W|d#?]&1l`i]WwI^h)od}wWZh+Vd$V6&SL%#[!$qF*1@.nOVd@:=y%wmI/pGuI8w|=pc2f%CwEk};jSCDo?7O8I3cD&{#8@A7;4<vQJ5D5"]&"bs@?!AcOg4Z)+|:zZPWA?`@(7W13aJ/A.I_f[R5t4+j}@/`&:C;h(N]fNOEnLt/xcc2>t@;~YpyB*kv#2!GP.EwEii]Aoi=bEG40xGN9IBqm)wXX=+TM]t&NfH<~YW0VyY;41qs?N?WE%eYfMm`&iGv2rp(^NfrYjK#/QI4uKPB=7}9qXnDIbeBUA}3l_(079ixOWR>Dh=rSNTO_h/f;iTr@D7LEF@P]sNkKC1;dvA^Uk+_&];6Jwhm|h8O0<v;7z;5=o4BM=<wNM*nwasav%9>[OaB2V$LD>oB@:Np_}{4byafEu6(3t^]`2%A{]m3hB=ud+U[3Kx]DO_dd5XmtJvh2J+[dW.DDeFbw3DI@S]M2:q#`lgJWK5N=2b62uo=Nx>pjLfZ%wUZOSx!"FxJf_;;89q9![6,L#3AQ=(yl;~Z22|]Ef8Jp[jWy5i6X7nK+OS]E8M/B)zw~4l>MR.Exn%nzIdHfz8,)]][r[RcpBflTVhoRsvz,XLxB+cg[H0=EzghS)^k/llwU:RfY6FxP;}2k/lFj|pQgvxv#]SPhu1=C@yc?%wRM_)vw(=V>=JW.tGQ_L*:pc`c[_.:s0F^l>X~]C:p<OghpGS28g~m,D}E5L5tYk[bXjt@D}0x|;Sk(K6:lq{:|NAwC5u0is0xi[rip,"xP605Iu=C>b}V(%yMyS0k+[+a$41|zBKgd1Uk}@?nss{^usJ%PX+(UwHR3?_`=7v{MH+YX;zOv|<rAE=VqFg0_Gbl]A=dbhN@TV_@ph)VrLhJ:fFaoNq3?GGiPrZX|J:=`E%BQ<0,9Ou@%=PmzcVx@$hRPLlEQuhl4EjpP"Z~>HX0`<qL3x<m#rq2Jz#1GbofN29%AOp}>Cx1MhrxTPZGXL;vP79excw0zkhsdVh=sFlB)SdyP.AD0q$zgIk;7Y@?DL>6`L^x@H?w1LW.b`a!|8"C!r?CpolIH]kL3JyyBcQYS89*s?jb_51xM)ZV1C4faw.fH%(WbWos9?/$3K?N=+CLG}wb7o^|I:0%=R*x&ELoeinok+3]Y$zSKa_UH8IF$qX}[jX5ZBY&3W0KX2y<e<MD6/O3q`BuMkt7<NCF@cKpC7<FL&UbVbFm0]OC$fAtK=8#HhgrShcqK>"bRiAmVcN_pHN.*n~&ZQC4f~*W&r)c]KhRl$Pw;1&&lRk9y,Lu;YL%8gB+#MfBxub:mIUsF2GD:H6Mnkz|sP"7W`S!_DaHf5yNG6u{EEIT#tUJ>qJ_4TxCar9Fu[f6jyz.n}IOn7GmbS@*$/::,]tH:`XhDMe&sfo;:uqN|BNp@D|xONpe[e$gyK|1a*ED=.|G0jNd::QxC,epFcUK)*@x+T[TyOB(X{cg$L!0TDrq^B^:!5O.IeQln<Gm+7^%;&mHgDvoU&<HZjK=.kiyB?fplv*`7XV^Dw,{/h,|UBu](&8@4P?_;XsZIhm_o3h~"A.^xLs^D5,7:Q{DaMpD"EOJ1%{y)8FwcrWauUbqU/%>Ma,RP0USY~:^tboW2.|f79Db<{A@_.m&[iz2V"OQs~:1{:/o9=peHanjfM{vvGB2pw5aH7}FIQjGa83+B[EW#uo1_+!L{1$lE+Sq/4p)TuS4#:qR*x1h|Nir/>B;~*&lxG]>/!,H5LoPGSL09sT("N{Yi(<MWVfs;VcJ,XHIfxs/b^N=ko{c"EGV&nk65bYydD3)S,`V>+oSP(bEcE]w5eu>BvK3ZoxLTxXJ3<2pjZM`OP*kj@Je#kNc.:LNZ#&`k^rb"?umi!6ajXy;VcDQf`_7H;6=^_6pre*iJdv^0gA+Da$|.sy=1G`*|(%{N|;pN{Hb+7_W2T4LBqLaJ/|kMRS3GX2WB}7CiI[|RK)Sc|U*D81oobB9"0u:b%>dcg_L~EXp>|h,JH"({+$q#xM|q^D$:2#1|VksU>IJ9@6[`/VG|[%rfiBU62N)/"X.<QamHn(v.k&|>!;,a.6=1}FF>O.v*QdOp.U+/aQ8V9V"X@>7(lH.u=Q~&_6;KRmCPv3@?WHfB1eLC+kXdBdv@VW~zg8v%BI2vQPsG)QI]QQCDz+rPV,|i9V3qo20mj{Z|LKs.H#vUg_Fu$oBS.5J`=PQX%@[A|%d54m=m{wnfv!IsCxVF=6y4oT5$YkLmxtug/<8I`vY4YkflR(vnreeMSy7X/}`+~<&{@`kA%m#.R+cwaXQ<(wZM]!nnn:9U+2M:,badya(M4O##{$G%G1nq"L;SZ{Hcv]zUE|%$<x]&}Dv"<VqTgN|8HX!HqIG2NN#,f`h:1&j3$X?*&]g,>C2sAo(.1a>%=~NMSSbh/TxG.(o]Md)yXEv:vGy!OdO@~IJ_7}g&m7k63Vpz@FM&@{U`<]QlM<65.^~338?&4ug<+nPub/@.[wrk(N?=XAzE>tAlbAZX1O,*[uDw{}v7U/6:vY.a0))A9BNWg%s2`q:qMLpI]]h{jmNchI_:SPk*URYI>YM&n1{o2$8=s`*k;Sj!sp/FQN8*~.kpptf}wH=@?2&6y1m9x:n~MYHe)X;rRMNL"S$Jz=OtebZg(Z91(<.Bz1n*%BqD@<=7LE4YNh@TZfZ"L6qLb%B2B!L_m$1]jmTF!e)+gL*eamZ7ad"Hl?Y,Yn)1HJWK@2JZ]5kry=Vv/IkhHPx55>:K#}(v?!$"L"#P.:xTV^,]?5g?g?mCE*[iLaPV:w8:X.v[8^qG<$6b6PfNw5z<(Ka8wKtWRnr+jMHEdf%nLuQqF1PA=#*JmgZV`&c=V7in57F)Tof?.*>9!!/EXIW<&/lX4n*owZSz+.h%BT+h]S=57[uA[:}O(zRc9B#r5}cSlIo7bD3OzizNTCZmK:70rpxbVdlz.nU=EiWvOA*ix^EYfSSB<#>$^/0~8<z|TqyJ|4P}D"HBt&mw/}nnwWnGP!glbM5EvYxy?oGPv[nz>`HLYttPbG)Zo10rE_;[o$k4e/DOP<r?ZV9FIa%+cILVd=L>gRbY{oYpOre"_IB>N,;V:`(Ku]eEx@cP7oD$VLaXer"<W~jC3ZS{#[(?,]v%/~#elG;[n&Mvi[8|/GH2U#s8,hlHZJ@<xyl_)QPh[}Y`{t513$0T]=5YIb%UhX4]4%8Ic+/$PRta3GPTbJ_bf8zYu_L9xpw@z"hH:UkUEv#B*,R9H%wt11jZ8~GVo4+ef9$h#Ul|WGw}e?.XHkfweL$x>M2fE+l#&,d=btsOZ|8)B;*1frH"w*.3"qmmo8z3Pz@5gWOCIm{;6G`/u16IujWbPcE^"Cuv.HVMCmz/36]|Ih:@pZ[Za1.~p7%@gL#&o(H*Q[$QZ#D/RZsz~:0"N]*c8Kekls}irsPIuZJ>6z/Rb)LucSMp8f/!i*^]Qc[[O:1RE}sd}1<5=]Tl24/++Ie*b%#5&lLF"&tg6:htHtl8ffc5MntDHp)8K{]FTR_S{5H$L*N6$P8{xKP/39zbLY4#o2!{O~"!kyDS/=[3y`N_4/%sU<<A8N<1<S]OoV==H~f]e7mEEe&|a7|og0w(U:wV.QY&|YVa93p#t=2JiyXTnZMN,o9yD"eZOD>[La#I)ucU]>^]$*J*f1jpc_M[vCNZfJ$WG^Q"<o<J`*%>zdFVu$eW!i6}6Pd}ssN5dxa/j#H![+tLP*tmx4AX:5Ce;iISmw>iKGjx#lL]f}0i/_L`Bu;ySDTHx{VO]S>eGbRdT.BhH/o%MVxVtH?$?>y~wnN&swwA8R!"[(q5:_}d/x34cl$iTsQ`}l~eCDn.+h@dE1zP%Sm"{|H{tFCm$N#X|SbQFGa,pS<"w6UWIDBx`W/DIgv`gJ3K|q_S]/sFA;G|msNSkyJ=;I1vB[]^EQPJr3<4*]EmGXkHEC"}S<oAQZI<s}}zr2`~!{?Qtn/9QrLc|G/,g/,p;a(gg&1)0"D=^4G@0:zXL%5=JH6,D?Ft*jT"8xKRiz=LH5%[jrT**B8jQC:}i>UuBP=(!Z8+(,j_rlIjFEMwVdj_le%ZT*E_x[D{2C0V+4Sr&.fEX=v|8c|1YW^iYdRizuHDV?:;T%q|bZ76Y<y"8_07KL@6J++)M&J>+]x4[Sm/W@l"0RbqKzcwb=z}iq@_i18=?}lR+]Bbh8mOu(anb6p`Hp&d(Q#KTa]iz2Z8VV!N@7HT1Y/LF6^8o#LyZp6N{)zE`8MO"_`OM=a$G|*v|G>]J|nNaHSds:kx){ki8Q+1R.JI^IryQ4QdGE#Mxs_3vg_{5ejp.hTj8RhfFvLr,9^.jg|QF{u~kXNqjU|ZURuB);QGjfLt,46/)*Cu+$rV"VLU5U2,fnv0PdOY0#h!)0D{|30IinKF9,/zqUyDbdq#D8c]b+@>;&TMV=7Mb,gSd,tK@3wDfj0oglAebT@^.nf+&_ptm#`]1;t~lV<(|Xoe/jJr:b%(<mkhG)I8NFHD94=#/#I?>X@>6`Ja9+@m|Jx5tl$yXggN#+87U}8ZikCE)i21Hx){M,hy:YH+nL!uS6omDT82]:5rj+0ji:$goXVD16@r/#ZN:s;h6O&bAu1rTGt.n~PD&C!AG/$n,jo#:.S9_EySDem?N)tnja]X/6"f(#>?RmHAuo~axLp6x3).is_dW1uA7W^vu_,+6B?P7q_|T&kaPm<_ug?%7T~ul&Y^*K%C2e%=l;gF?VIr#DvDps,^_&Q_R+f*jw%UI=r=s;&Y!C*Vum#;xBNFg6[$1_2e098l|0gG2/(DWZv]|s#x8#ex3EO)@FD{F;L5$I]@U3a~AoJqYNdDq$o_^U+:d:j!xo{D5^(HMQ]`#Tb[V/e4L>(~N%2OV^|MTB6;JI7grMGHG;G;ZV@L6bp*#saVTwEt2G_<dxs"|}bZD^;~.hIvnSnf}{q]VluGkdfAb}6vbDJi#PwweF]_j[&jjuATQH:m,Fw*z%|0Oag>Qi7CPDyc5pU3qMO,:J|!VOTg>;imP$V5c+zA4!imwd[.+H3xexX>UAc.nx9V[zz6Cm;hcc]4rdJ8z"|%$4uhr~Vqt^M?#z%F81cw8N{yORwc%Aq1B[piQ6z4S+}5;>bB!mG1WI3uYaLo*3`<oP"wDetfoFX|6QMp,?cIvl1jbr`k*7S~v54D,H*uFd(6WJ`E__y".[6FO|GgNvTf:)1M{[0Mnunk=,ty&]T4bM(PZfq]c$ZAZ+.R`HtXOKH_l<;vRCDMOUYE$cyCo9ZzL[L>*bHwr>V,q~Ow+j"Bq.0f:nNQ,k^CMOhr7&uo7f:^%D!0}Rza]v^C!A2sP?KXUPo.Pp{*YhryPq;_8G%22CE:qqx0E|Q.)TK!WCC3RCW]K$<H,m_a(.?azRuCn5+X99NXObaB/`W3q07$Ama/$FY`X;t|G9vlv^$F^dqGf"Iw<O?6+LG,DXm]Ua=|v[=fc,xI~/WW[o)Dvi>rX34*dALKc>1ht?s1ybYx{w{JLQDd~=_A`KH&66(<|9sL(*G9m+qw9D)icT=i.^iiQ?f|uC_{<fHG9o>T=c*U]p7sHXB/b@J=;4.#I!rsXeoyi;MxBVD;/2]k_/Z19x=MG+{xV*Erd%F$h?nTGt#KDY/lpFXclL3h{;MuR:Rq!Z?##!l(B}9<2mxzBAHa./dqa^|rc{Io=.q)Qm%4pizYTJ9JOOb6<d.0#rGto9#Z}$CXjwExDTu^pURJy16!Wux0M@Uw.9,)_1!OZ+b+][?d&;;u.(8<k1Xp&1fU1*Yowr;BX&:4/^GP}a7!{zIaSPZ#1T3@^=kXFo5`5sCqP(L;*vs#!)%(S9B_,oHt,BNF@i~smD;Oub?.jciH*E9b|z+zo~Xhq2bB)1)Ht}*wr1=Uwc)xj],ljlhNjL`q$NJ_@dr<~Sz?(UR+$zSs1s]!|#ZR|wXe:q4F`4bCoEzK@V?WhJDLeh]{0ZFyBTq*upaDv^M/pObbvuZy|NkYd"w+zmlLeVJNPNH"5wRv2H8dy^Un/0[3/k$mX/jV~HO?)ROq40Zix0=ip%OcLvmQqopo3}#2MrFu!9>X9&b173"c]sin#oBEKL;(OqM$apIqMG;UMRu&nqQ=i56roWlLH$v9`iaz_sO`%=$wdv/CmcuqK(y/T0wXxY%lFHnmt(d]ngQr5@j9&8z.s:NLK{sw]NTu3gw9TWdd_URmQfs[DK0{P`[bNB%nk5A.q^oq=D}q~gz#]J_L#GJsHcrh9/~NB8Q:+cN0VdjX+58G`fBY6o2OVfYGBS$!D/ls7[Z@uBpU.|trrv#n<gQ&~o.xpob?4Q#ZhPhu59ZLO07),+<ix);qk&xQPt[6konUh9Ej|yn{RqtJsLYH*}}{}$WqJd{z}]_Jz7GE}pS,!TO`|]bt?iWJO1t/F*cvmKBAn!tF`]cFwRw}pn>n;]$C9zK{sg8,8sq$K=;QS?7LkL&Ya?]$Tvw,#KC^ibNa.Vgs827>PKIhv=,oi~^,7G{xrRTL*<{2Q9H)hc`nJkU0V&YNC0~MN}v!E)Mf_$4>!zx@lZx>>"[6],ZOz?$eEw3L^K3:wU(siHB9%AED}(2emTIDs}O,MI#fVtU8;L7=%5:.AM/LXwiw])W5TVxSPQ:^fyg48[?u/oPF=nCU,6*u(cR!^1qx_)6d/w#p4+6RZB3`21g?SP[4x}jQNXv}He:k&9mJ`F+sKyk^u?b*+9[UT4e+FVRtY>m/IkG<ZXM5e2b9t?[jaq!vrR>{;iAVU0/<`s`&Y9I8l3Jf5]<{d{a):UlnHsg$5<S/;Z@+z7L9rt9DSYi>h,b_SMhjs7$5Ga=J_"M/6~fj8UEVyRFTW!,t_*(z]=_;.b0hJnUv|,Z95=aZ;}v>EAQ)]^YwIjKd;;~rjrG"SbarRrNILkc0maX(PrMMzs6`+yCTK5us%6xfJ7Gslv,bZ?IS;c]_XaNuEe5hcD2mP.M@W|AUBO#83yvC*+ctG`<;+"ng(JmQ&9dr[g}5#3|o<IX6J9`@_**(^F3ix+uu[cMcw#7_3gh+,@K3Z_3L!7jiTE&^P1B5kH@|0`7F2JO85Z7E|@`3H.IVzGL}LkkxM<:wFLK$>VOOh8_*o6D(`vv1wa~}TF5C4,GSFAy&?8PPCV>]I;=t>$[JJc@<;Rmc[aTO?e;/xaS.HrfV.=4c_20`/5YI1%3H5F;uhvq#epo7=T"@nAr5y?hO[?z=vPjaopkTM8)wiqT<9Xyym9d},"88W?/ZH}~+ze.x<j*(HndW8j!+&xLCt5dAnl2?I!l!4;yFHdsRh8DJ)p|3Y;{e4sE_p&>;oL58NVTf;!PS3Qj6vMwNS=YH8V6v`u8<FhRkGW&_W[&L+8x%jQc&07UFZIvKWzt&jkK{w<gAizcELhM!T6j_0ARN$nYj2Nra8;Z`FY~]:Vil2DA!+`h@WWQ"4aI9tws]HtkpRN_wz%Z8`DyLM&G]WehjUV?aH{~66e=R)#kwopgL/0v<@o~~?a0]pyniKFKu7sfMiF.dcq%Uv.2bhjFYM"ATfCAAvhHaAeThcjfSH?p.lzn+fIOy*ev4(:V:VZoTF^fQ`!2)0xZjvEwZoaafT"n`1e6p7(.mb%H:j%Bl{H``Xb#<sqRRuP6YnS(Oa8zfKvk8$]b9O2!AVX{`X/2Q?jkmp]fr@adyy3[hTCBV7ARFbqYR~7d*+|+2+rR"#wr_r;gKk+b,BxA)LVV&yGIrg498?oC2RL9.3[@##rBtMn[%RRCgzoj6Rk:zED?80,LXMV|U/U+^F+l4=LAGNk=P5V5?+?luC;*QPIT#T*<iXOp!t9?Hc5OV5:TkH,j64^P}fykjUS+{LUm}HC}XOg6|;_)7i2[7x`3XFoJnPrvaYscQ&^3JHv<OQc4=`Z4xpramfGM"@%%^3)<RLMm9|ZY_|*"(,>OP`qve8CLG%dsBRpjZmQO!ki}pSF9|I|8i3#E=V*r:0iGt}V~UtR(:Qxs7:eYLp3?<Z@8<.PJ_~ERr=v$QpvjB(hH8p5w"Hlco+QXE~>R}^O9uxM2!~RVBeea0R>rXi%nx53()#x~00cMfBsPnUM9h"nGKgsO[7j$>wBjKCTR,<6,*6zQ_3}4dgGri.zjCsFbZ&,eG7lvRQ9Pv6%}N!y.AFV=I41/^dS|10P.cMe+48}F~&L:4aOM=>5p8GQ1|,a@HY#iAhi&b1@s7k(h4%!05[ub0}W09K1KUG>Gu3AMSJJXd7ak}cA]&2NuRFZ&FRTlvVt;OUMG+~"y[FRN6dRLv86($2c@.#z#54rTid.d)}X*P#mu:o3FrkQE<ll5W[J!CNv|SBTUC[/2]b(z<S}ZNdPode)%<FPwqhNE8;iBNdd_f!{H;;plEdW86qYR<,+I1Kb^q4%12=TnzKPqB=54"TBNX)y+Q2a=l9!,uf?}Z6=f2M|Wx;Q_:e(Ki9&P47w:CkeEAB6#C^zJbS&V}6c[5W`KaK`?_,muSdX;mtFnP{ddc8_$?<sa{UI7z76DAcMcGl,`k#0O)eb,,Qd}z_gpkVjH1r*Ix301N@sl7+:4zoPurxl(uG;efU0HRG^*LJ?88ScKv{gzPB&Rg+k@ik.&{cAIi7^K,B{d/Fao$2MSFbNshLcU]VG6V:#]<7qwHWZprGMb$`Tdis/5dHL|6Ci@Dc`lc0lt8[6&rY`|oo)q;6Kwc.(t"|Dn$pL|X2Oii?omL_1+7`|Tur)HM|g15/|C*o=Hd`k4yxX$lbS{[O@oo0_5bW/NNS.1^.6h3Y"z`5`(BW`nYWdcMrsG2ii!M/BIBi2;19Rwq[qDXYnH(YjzV*P(LQSpg@*:jOdN@vBEk[*aKJCH}e(o"<I}amAp0$[S+dmlfsX}@t"[:y{b29,nM)4:mN}31%FPu1YaNY]R?P8yTu+>_U#{yI^^vz}|/,y.k`]KA1TQ1cn20K5qAZr,wD(>5`Fvb~~)tYhkW?.)Z*=aog~xDY?ttq`T#afQdiQ@=|lDNGV)#fo,x4s(y0Z*gI]N=YX1`ZOTx5w;opu/jA981iE%p?Mco+CrTPkB+)`#k"J{()u8%jS.GA2kRFB@Yk04Ac:cUX210Y_+UCy4e}~h*uK1H;;<]tB%h_$@{e>@{$;ji73*76U8}=)`B)f*>gL:x760_!3ZCOB1(Ip)1~"SZbM/@MJ4NS/|wV#4s+ip{$+U4N,^.mEr&taC*5`~1cBRFaEK<=`GI7vJEBI2So4PM!LS5%Q3gOyjf&[dAHTWif~^p=6:~F"M<wK.]R@u{CjD/b[W/QBG.lQ29G({fRazKg=vrz_E;ZtM;%`}`MJ=1%&qote^{+6,aa4,3nA.Q=y<MDHn,XN*A*{&{^;(jv*n]24#[C[JxV%+:rSo&OtWeCcpeUhAr2%3dYbv4L"xAR>{VR+~`liFYIw3o$F7P$r0Fg^2z*ZDNU{)9;UCM*}AR?U=SV1.MN+T_=e?8xT~yEd,8|Hzt2?p=z.kaMad3s:XjcbawG|g1=p;73NOS/cw4IjRY1LK]JUGS.iNtO3*Ou32M]*$/i^zNtpw7IsvJ34U0cYCm,Zz_9/fH9.acBZuHM(%GL~"<]kpwWdq4wbx]M`h!2enabcTsQ2(%nLTS(dtpNefC1K.#tE6/1|19^d9SsZW@84cIGlo3r/OAByqFdc6mk7Zjs,Gfk_q,Rq/VMCtgtW.STZT{}&CXV%(*)w#C16X}B5R+kohW4W5g__wa*tn:ex<`Tq$^pIyEVjCuN>W)~b1v,sabz](tOv?/9r{bX*Oer6[S@F(1A3P.ROYq/&FBhIpnHHk^]wdjDOXY[7O"6PSX=>^~0acT/kKCP4%(XcMVC]B6)~Tp60:0~!L:A?=hcC%v{j;>~#pRF=Pa1,hrT.3IfT~AS1i+<woy`6vj&Y?h[nXrX8ZOX*o1,B2$2f>g`$dgR:]~@%QpjpH/&XTogtDYo#BCyh`ujBCl4e0I;iaH%LpD0t95tC(4G=Dy)koaElj6,Cdyn:_fMXd7R{X[*Gc$Mn+!5SYEvU`mQab|7y[_>Va~&i_$iXx<a.M%Ot<oIh^^^`>E2gFoBd|R*"tnb{x0YPar1$L/prqMdE:|){B<hL09"w7e3Di9i.+?arfOPJ5x(Iq$(z?;;7Vo~"j=s_w|rDN2BJ1~tZ_|2$r?Na+9PE?.$W05i^:Q?NW8_>dRk/_$%r.wwTVWcBB4%yCk#oVT}<AmE65@Oy0P}A/CP#1/Y"J_(@OtZHzvU?5Zs(:Bxwq^dC+<<~}$$yJ])I[D{Zi]JL=kNfi1xVJx!wao/j%Qe@dCoGF8@+f]u==Q]S@oAD>>sQzQ5je[1f_.!rN"d7bVS_(PI(/6FteXsF_KCPsGb*H},gv[HPw=r;XlB]%##d$IGEtnu_baw~#Enr?b.%=0U?Kh2<Q&mOk|lw?c^_:$5tc9@SHBuGa1ooZw9F^QMc2&y+b[kdzhXWthr2Lxo,=&NIFEQe<e?;`>H@LfQYB!fQW;)im{=Z:(hgr/rBv9c|+K}$9Xynj(cR;Hs?p5.|)+/8~BudU%rj{K7kCt"db|Wl8Sz;S"Q5z)$#R.qk!`#_yk[B*uR2:.U`dZ+v[=gBj](2BnTP.@8>}`hRgYbu1rfB`]CeQX`UtiUYbx/wfaX1j.A%^XB~roki[^z!jXuaL%7wwg:*"?`IW[J#(L&UROA)~<(fj4}Yezu=$]EZ_IL&=<VL32Zf|J%kW~/A[DOxR]Z3D2`A$#3[Q`J|<Ue$n+SEhM3$K0Q1d?2:9]cnWT)*|)8a*Lh{oP<{y[bKxtAk8PQ!q[PjM:@(Ym:^=4bz28:tW*}Fq#D)<YC!I.r@w5f<GwDEfGCUrz(iB4:X5lanNIKaC/]d`S|NU_a9ci34!?*)6$Yb_qJ9(Sp;^AG/@[j.0^.h6*m?2&#w>MlqV)20|5KJgK=D"@RcIWTDK=CxbWiCq326#`&.:e`/hU97``*W3V&9R&id,Mp^<Fj=$r}N{urj*[Cr+z]C<ym#|cWHYF}WKc8eP&v~6^q[B{Oef?s_<xt.O[;Z#R7AD%J[w8<bH[7De~%"l#eRY|zK,f8&ia")]Uq*|m4>?;M;$*{E5J<79b&V<cd,}FwF;Qucgkc&)MnW=dM{T7pp8b2FGh|aJsewhp<_$#@aRbW35CkYpL,SH|,b>uz@>$hPnq|mHRb>R|D+Q|t4K&%B)gPWca}W0Tyk=*Ea(oKd[;@7>Ay|&GuHNl;M&y%_=JMtzNR.jx1Bj?c#dUg{r.9{}vfeTcKMVp_NcEWRicUdXdS}e[8^q]+d$l;=>5DIeaU|D/:rtaVgSoeATSXO]*T6j!s0cDvF619Jc_~v)gO9Bh|zwClM7%"8KQ%^RGd77j/]SrT/y}%|jK;Ddz`mDHe$)7}cO2dGv!u?@OCqSz|z4RM}tiSBsJ]<7C;(o&U4[fI;xXa,QZY6%1dQ79/*4i.9#%5:MR&eC%8Up%9nz{wYtY[ZkGL){<{{tCY4Un/;%,W9,XE6YTZHbwDEq8Ki1dinYjx]fF~0Eu1aYEm*4qp92IH_zc"i>pxu18m.bn/eNxzHie^@M9;yFs<mKiClsuHmX;VjB#nf&7Z,6YO)1)nips2XrWBg|<oLX/t0@*$b%$Mj*,Qd*vMTP>P##%jyRfM.v2xf7A[<9UB+([&kxX?<Lw|!K}S]XGkJ=}M.MG8!i{1XdGJ&2v>j33MWV?QuK],^%lB`K=C73Mos}>9uo:+/wD%zK@Dy2exlMx@6>N?8?t;/5T+!W<b#mY$"2&LgxR$}>^l<O/lA3I6,r#ax([SfPIQlGUV#hLmu$&3@!`z7C*6XzK.fD)w6}g256euk,Bugs+LoRKF%9cU"IZ%zE/BD0AYII_^Z2J31U*TuJ4>@WHv1W0n$MUdx1M}pa=]O!>1L9r=Hfz9P7*w[AfF6fGJ.PLKwX=,hS,9{!lKj/#kcGt,g^f@T:*fx}?}[y<msv1,`@TDouG>Alb,AF0#MOg24UST~dMQoE7Mld"Z3][Ix!=lvA@lqK402*H[Rw+{o^GOrA,M9mgF/FbLq{;NRv(:%]62U2EE:FW0|W{hi6MHs#k)LT`ZZJj4n33IcipUD_vA>zE=I:m/$>YA2bbDo.Q1+i}C3#ogIGzOJ8),~s2]}SN8hS"3}mvQ8iPoC)Z1ikyaI!:Y+=g`bVzxe8^&~dMy*T:h3a?(Y>d&cdWm**VK/UUuq=5R+feILytlg*".sq==~dh#^q2RO+_O|aZTjs<!sA"vrPV]Nh.|21>)2_NXPf7Z9!>Q056Z;?.Pg^mG.gr9M}VR}U[Ryyqi9+3tRy`KQ+Qrxt>KX(b~vKRwsaI>NH8h%;3%g_}[SdYL8VktgT/?km?>%#OC/038w;_BgXPG(H6lCV=1T,>UeR[:CYWd~1c~f;*j+aJ;1_k?HGD{n(f+z.n!(z~geilP8TLO{O0ncD8|gO@;mfGiv7Vl%G"c8@5i()Le?z5w%VAc<2&OzjXL.lCJ6D`b/EH7HS:cz:J`Njk>wX`C@q^((VPpacV6J8{lWpqEpw?614(7{DzY>y6Fl0|`.<@6nseV(u"D3cssn@/t#}]EfB:DfNS",Kfl9KzKG5!AI,(~|._LTqJ&wFT<z_QMX=*_uD|dv]Z`}.WpkH]{=OPG$JW4(;[t%0f+b28g2L[[dh"IB!gwoyRIZl(*(#EHJV4WvuL<RnWnq02fW}X~nR#j,i`{@HSTfX;ghWZ4bu$1r.9@&eZc*;ChdJhNv}h8Ud9~v/r:q|/YaFa|?Qajmq[BEM$toUW?+V]G;Uwwq^Fei]t0g7`74,A*.vx7D()*ib|J%5YMbX3?>2MX4[PR0I{u[%6[@BdFu_sI7!cGUD7oe4;^dk,qw5<SAGB5]YxxjT&9|PkH.}Uz2,?L[{Xg[m}5u%+loDf__(V<"WkK*9bSg:NR6u+:c93(Pe[o`yQ&26S)SDD=F0!eH9o`}4Tl13c>K1}Jkw&nv)EJ)GP&nSJmf}Yib7<uK2A1j>gVw1Fo^/TiZz4;O*<cNHEvJ8D!"[O_=Jhnl=2h5tF8I_f2:N,M9?gNJO&$G#}AF0zkyqB^9L@imLD%22:8sS:y[*uAa_uc5_.P"9v_V]VANW(%jiiK}M@WS?<P^:MD>M*`t+*t/*lhi^Y6O]FfSX4VJc{k5v@O#t5mcaEst}&@c~@A"#^Lz*3EN#[bvd[8xL_|dGKP.4Pki8Qly&ybv5*e#1o72QxbK9mT/%aKn,YOaZT$QmleaLM&fjlbfD,jB(Vh>SVp(lsMLE%Pg5CR_D7a<4=JjiQltcB_2J}82Ga!~4LTS<l]>1RqdIUqKpK&V3}}Ocu>B#sIlHY7E(>H|n&s]u2GBW=]/mxaM~{1f%,sW_tF>{iZ$<?Z,$[u#0!vydT7}9nH0tXM/pr]P?npn3~@e$d~*@|R?#=yWxf4hFBAzRbYZ+LJ!iwF&3Ng)&/GGny}lt#C2k2&EY,f`hLU0t,$~!>8VenB!d#[4m`WT<J?s@p*O*Y[>_442pr3YtZH[Le<9fbT3^7HbZGFKlGF<PGBv`jO4Bev=[S{E%&qgRkMTto_I~k[.eIa5Ih]=z#|(Mi<W+;y}64635gB^+62V;@T<"DQyvdp4u=D3E0Un2p)e|[>BfS=.vys9FgQi{!*5Hh?Vwo(q&Yy&*a]&kt)pa9;LPCHMnhn;|,G3#~MeHX(Kb@H3Qy3CVnY8u$)T:J]{zQ5u&LEp!v"*vVzlc$Fe03uj=&OeNq4*TU>W?9/GWTn1O^Po>E7rsMdq1w49i]pMZb1QMAyff|X+fc58u1F^CwFWfYYLkQu3".0EB0n*9P"GTIJny8OK;GPM^fd|}}P0A^htToRz|j7UJiRdc,3$7_.kMi)P.yry_/w?Rq|;uS;J{C^uw&Q?,9hq3z9ttic8Z,bb82qntz:/>L:1)K<:!(m7@RE>v2gUbUmEef7cb>X]dB~^yV:,qs?^1Q!]H=$oD<";e;Ap_+az3.?#S[CBG_He*yy:5aklDy<J#Qr+1yBo4.;1FSKvBmUsqx~M}_3:R"$;sAe94f@]kU}=/Wp&J/X70PjeR_Fyw{WE9wXa_(jU,2|dFRp8N:M/Q_enr|vU@T5YxoR@|<yZ#|7V_LN:?GACbT"!.I=pz6Kn.6M^K=;TAE?%yZ`=X5aDrpG_FzbvsYMZ>F#E(KI5~z%q)FJ}_u!VcNcZ(aC8@IZZOWHc3$=(noZV^moU%wN]#)c.`oX&M4,oC]*_(o_)/{5E@SDk~"N.T5OoGDy2w*x6XC>aEL9r~fm:_"Q::1Q=hiL_RNDS>Q)cD4AgLf^~`CQHOwiNEda{*`^XgotjK,Wx+^rvZtU69xTTzhf<ziM`WW&)p_^u~Ynjx9JS&7,9.G=hR@Xs{WXCbAt(_6GS,[H|ErLx<BYLg)1"Wv.nbg4;Zakqf4CEdV=<=f;4K86F|G!`pKL/N_JaofZJtHrmGz1/$:KNQX&G""$89PnsKPMGT,=JfEuB03heMrDGnt[SM,~eYknunB78k^Jj.[{D?onf+1xmcO*cX^GzxqQBg[[Qu:.oiZC5{Sq/;mgsecVr8SNj@mc=1EUW:;f_T+M]e"?$oB@@w{`!+L[!TpC1nZ<!{>j0JID+dl~HxUEqHz~qy0ws/X!vRqty/8xt_%Ov*,*"oEpo;fOo`^,2E?Hwe6=J=dJJ>9n8a)n4G=Hx,m8|X*Rfgq<e8ED]Oy%Zl`W~W$aic/"?=R@|0enOP(d1U!/wDP;7u7M[6Wp~6Mfi0Rv0wd6q+eh<]}nJ/DW)y@&^35Zb%Xf1&#[9[kwbO4?DK#DlueOMy38RiJ{#G=BcXpzo+LI&CW{Z2JGY_Wc/u|L_j{;|Qo,22~rFM`I.N5`.QHrQ.|(Wn+T<.KH2D*u3$]toi[vh$Hf616Oe!:S$Y+<650%@xPb+ZK:`]Dzhls)y{~A?<CPN%FwzT;D_`XORf&TG8T5)3Wawul@#M[zo+7<*VQ}]t,Ptu!,616#BP^58cgwu9@(w#I_s{tjG>,>I`coUI5x#,p{$u~qZGAsb(8G_uQJ>/?K|0WtUK}]wu1se!vvR_`*86~Y0pClpxQ~W<uI6`fV1Okdek&V_9N=`uop=7(vNO]2.Z22g_tRtk_[O$T5V!06])L/SWmQ*M5;*iFK7nh#$&O:0OUlaCG,YUHM>eJnt?;f8!aS/,QJN1{EYf%%6y>ig32:LXZg<+64;QrK#q}H//)["c40P+9EgGRGnTF#O65_1|"]iM]1Ny`dXJ/i:X2+Dr8=rduPbUq8o0X=GRLaR;MIaGXDcP`H!H.iTqe[Y!Tx!zO<]T4SQx#XDNsd4v7SWtIx6!|=qRw+5&QcV910Vqw1[lLjfuF;VJT2r)o)Wp]7nlrGaIE<F)xPS|kUKFnx4.[+S$7d5v`P:J"}P<3+4c4^4oYpa`GFEp=QfgzS]/eXcX]p$Dx[gmwF3d[n=cIXo!XyyHC51,mEtNiP;*iT>@kDC8+ecNaVCG2#WjQqr,Toz#"xO6%$Hn`nDl>_@!oLkg7cgahDAU][Ep0zFs1#{cr[_Y[g@!+K|<wzh>{e}Rmky%fe1p![=uq,u~HPD8Aw#vvOj79`JL=qSoGs~MB7]68TiOXUBc6JU;6TGv*f#SJhNA8XR2k`j}8P>0g18[|[$Y_,b3={bD[tx_gt{S4Dy7QpslaWAKaJ|SFxC;x=t53]rKhZZ`QU._+Rl2!mw^(mM7*tj?|Nh.kygkM&F3*^!f,:%=,@n/mVWN"<GeD3bjm0&`bWzon84BnJytk=TJYcQ`0Z4J}n4Lntk/:jS?5Wj[o#zE/ZlN/9>gnXYa1tefZo$Fu7i_KCeq_k<y31vtjQ,ylz!Gx3P].|@=L?<^+rBY7BGbHdOnMlXzFt<`mCLHj0abQy?TMRg8bQTQTO"$*;j_GA`56GzL$p$I,&f:wn4R0@>_H&!XF9~I^C7i>6nHk7twkOd.4u6domCF"Bu!mdZ{(oa7C8]#6IdhDZXToBpauFXjOKNG5gR44KTO0YYMM1H[Mdk<ea2<nHeP!O~y(HpcJHBZkRX|CZ@u0f)E6z#(<u>X(QD[CCctt=o1dlOx*ZJ$v>#vCnr{dl}Dny$Q9)[U]q3]#oBF_2cH~`FFBma+M7d>e^v$U+H"uo_i+j/jVVtL:AiX`N>PhMrZIT2UOzm0:pd|+gGY3xPiy]5?7ag/VjK06N#14z~WT@~NQQ)g;MCWdDd$8G(B50Dy)I+n:U2Kxh?0I^"l~P;/G^.w=JT[ALE{!P@4&q9v}OtF$[Vylr%#]Z~39SOaDSdUt#qx)z[nJglt!TGRJReXWq/4"pNPmc?b?P28CAfr"[ol[(eL("GI](1RYx]CHWp@ZZXJJQ"]28"ngYQJaBiq(FA@tqY*$+gpu~M5ON1/6f%T|CgzT&8mF2gC!;F%PD~}LnO]_l"3?IkJfBZFLH2_TgoKomjiKX+U3BoWlgfZ9I9u{cW[xE3:.4NFXb.kz,hjHCQ0[d8+auL%cyY"!sgV#]Hc,UnpN2&38~7^/dib!U34|#R:Xqs}FLSo/h1lUXYF1r"Mp[XVWaNeCl2F~Tde5VN.WD7k+z&Lks(/"9]qP7Z$2j8o5btf8HAtDs<;{X:cPbPd&AG|OSy3fw]?skWv;^0nVr%n]5Z`daQ%%_xj^)rT^^S1v~}?/Gh`#;"%L:h/uEM4p9qxV=Df|?yO!GR32>e?(]l~j[5u|i$CGC~^`QlC^QFS.W,s3/n~;6AkZaoetpoym!%IF3}LYtE].m<tEQ8!/T^WO#^uK)i|_<A$aiDHias7_$M&u`a&je&r]TQ*}Rcv>Qf;}*jsK5dj0f|}S6vA*q9@v"HarJMCF!}u;8`$sagsTkr)m52%=m`~u(.p7N:D!qfw&aQYjdR>Anpa?TQ%$3xo@.kpx2CafT75%fi~P$b%+vn%AN9{087)k&3)#}y3n_HsAxV{Y$ZNkX/a+_bT%NaMKYJ:{;+Ci^[wU.Xvr}3)WgK&ci#E*3ySY?+i}YA*Jbv~<:??RP9_&I*aNNZUcaTGd^OQMB"mbuDp!pl~EZGHrur4PK%C?Ns*&m.xz=jv](00=:DJw7Wch~Oqb[:3)SA{~GbC}P2h#g@_H.u]EAT%T5Z:a+j*L`Xg[ZhkYuL#^/pTvFWIQO4(+1((PPr6;}_R}P97OQ6VtXOEI1{1U]G5gRjv83[Z+oFOJ}U~uCVV?0|)&z[X=D7R+o7e:57Dml/t.Jj#4xZv@6;~q8;puhA>{]QT#L",KJhZ^Yy[PD:T0Fk]x^jo>Z^V"ps`hW/~aT+#`;,|,&{hTeGXiV1R`k68IRFZPkZ|)*<&sb/@lh%]r[54:uV/>#AL_BQCDNKFAFc{36|Pj31/wxx*BRNfV{C53Opa1DrZTxr%3R_h62L](:X[kHJtPXmChRZ{K&~~iu>+&`$hL+]4#cICAH2"5_,%lO975q|Y>%Hlh7G/pgD6@f.?Dpy[b&0sho,K#CD0_LfQuQr~p1bEM(Vrf&7}BE6:Ye_VP7MB5~H%O3gpcED5I,rEH/6)XA^5Z7z)xYE^raekj=o@`B@S[7b{evDo09_iD)`haSAk1D#>.(#X`S@0~{&li1!ewy?fpJ{;Z!i)!<#81T0M@/#Cizh%t0pp:b^U_cQ?HXV/ZeKzq}e<l?7yfSK%7EF4]:Zk+knUD|"%g|1s;$<h}?s?!v_oJPjN1S=Fv,Mex7QIJ(UhAA79HD]b*/qzUb"m`FS&!(^9EA?i}6b4Z8bm3Yt~d`/KlVh/V3815BSax"Z76,.zM#f"t_E)uZyO_&~kovv%:p*Efyzj5SGZdZvM|^kKTZf.YN90ieeHYs2b/uQ2AHH0L6,8Wpo[b)WB(("Al52X<uc]aAgN{=&|Rs~m)w2?Ky)$b%jc~s`{AG0O(@6~+6[mJYzg*cjWuwS6w1{42jc1}rY#[@j/_EwWqZdrnWK[*Fu]w,67.25EA6JSZIVr*}^`c%I:IYu}myrB49k5JHx[EIq^0xfl4$3@YV*ycrU+JuyMKsE2>P!n{DRQnUU2MD(X9Vlc~B[3W]baP!6wIf6X!akG%(?xdJ^N4Izl8PXgR#_+[1;.IM*jbRP%z`F>O#!c?QPq!UB{PqJvGGrPq`pfFWFv_|r(;:):36zfJ)QU%=)$23*X(d+XUW!7ihT$UT9P_r__,sN%n+&{>fbk=x]17$%Z?zJ#aho#TF@qj</Y?5K`z]{(ujp4y<@94Iz0SY:1HE+NoXDW,)P!svl]#ilLP#&Rq&Qyd8Ue}28bVa(y#E0j}UXqOMR>cT2q;xWGRM,n&B;]VfCVp!`U#jG2]ssJtq#a,$q]%9e~qr{gg@gSI7<17!KrxyX.0q=U([x~};aQw6uHOCwou##t=uzg3mqHx]2/25!_d3LEmczaDIAb,{36Q?2h#$6?NU~Ci/+?$MT%N#HrwJal1#7x@{Pg:Y47es1rbJA#00*@K]c{Q^c{W470,%O|Q!9y2<hL#v9C]rIV3H_wxTreHr^<Q:tFB/9ck0I{]_{;Lwsrct_s<s[n,)J$."+},QC*a[ZdHDO,E4wa/KNC]R4isAfC24juX>;"&NFIcx+wClK/KU&A^%[uH..l[vL()JrqEI02C80qWvyLL7+J,MSMiCxW%**s_N.PV>D6K@Pd;pT;"OxtCiVr_D4xod<=.pSh=gHHN&qK+EV+DL8PlkWDx+7`baUM6G05v~9:*%E*`f8rX:`Fs,v2k/0s$;IG;}]#Fu9RCge#S`LgSRc(qGl/OKjt6!+R4!aJHz{VMhRq@{{aBb42bSwr3VrN>q,Xyxc/!^vSa}%o%*@`w/rF>.c{&i)+xd:LQr4p35ne?Mvyb9$3msIp:8#"buyrkpBz#MyY[i.g"CbBu#8U{>ITtA1OL29E"K2691%&7.LmBtuPq`D2N$e(/m;MUHWy)U@@ZjYsI=$y>tV1WU7@BJQBun$=+%7UC(&5uxqR5y?}=UC`$32RXunCBN:pr]x2<**mcJYyKtIms?/}:~8%3nuw]JEo(l.&AE=r?8<ldnsSWuL7L!;o~Mq6Y703R$#=W(R~#/H5m7t{>dpP=S3Lk|M{FA=`c<S{_v,pOC1p8,c{M~;hY~F.)h@<xT(C60bE23d::}/g^uP41YJ#HP?!l.voFN!?8Jr~qX?Fz2{r8xA+/6e&UP{ifA2+96B@<K+eBrC]:7+?@3,FBLw3Ts1TTyb?rG1$5q9eY1}|Umi6"fN7*.QZC~4fg`pttJFHSbACIy0W%?ut#^%eYpPUj?FhH(g4a/yL5|>6uNr.=<WhN}HbxBZj`u&IxQis`oa0uQC}1jx#H{#:|6.T,G|)fSiEup#6Og,zYmDt4sX@>+,gv8=9VOiJCVw>HUXLIqTC5[A4=LcqQjM/vop(MKK_C2O#o%A[&#RVFIf+0t0Mc0K)e.4Jg:Iz[mGG;Z,o$2M!gg:iq_5O1.]2O6<0I=B."_~p83&zT$Ip}K)@rrr7$],fc4@Q<qXg~TE0oRAwH2Vq2*vL;VaGZR5bv|.j6<[,;/^WyH8.8,@K(2IMRDElg@K@:)Z:Ik6cr3.2q96H8"o8E/t8&Yu&kR%ls(%_SU=Q)sob*K=yw%)?QmbhdD+p9kNdtfcXmy)sc8G/:]u:;G8]Vn%:(ZB<A{f`c?Csa=]IqYG^q^M,c(9*}"V{!wNgZ@R!!*Ne6mHZUI+~Z4l>z+0%j^gWx}"}n=C}F9{qcg~Kt&+vo/~r:S<DsV|Af$[)3pe?wO)/!9A^)$:.XuLhJ53/2.qK^1VcW/TXy(n5v?(JNBBp>9V`EoZ@2ZdP",29P^4u&XTisRuP"J[<~l]X[c"XY~*_)NM|p*`}^N+y4%T|:<<5SYTlhDS)Zrf]mI#TVjh^kwU*=uo@HU|G{@"!1<q>CgM#nIcFa}#Vll2ig@MMPx!D@%l*5=Wec8e*.oI>he0L>t@MoRQE4FL~IoQ"g]#e3>Gsk*E+4@`=/JgjRw7(KH)_;uzB;xs,nK~`HdBqobe>WJWpE8}Ug|G(5kpAVy+a+)>99wllJ/+v7SwN9}~e|ysl`955)YcV2%mWx2bl&4ZD{#:$CxY@6!JLFQM{`%fJ]n)i`3p{0*%2,gDa:m+|s0H7}{1}T(_}=Whw4[Hu6apW$|}*n*BZpOuGJo8b.WDeBL7GxwIbonjt(r1/MBV8szL#YgoGp=:OII?_HNG[QgkpUK5cM,7;}{9U]Q:$orDKS5s*o/x++^f>|4MYp%7+cyNv7J@;r:+WL"NV/U/_q+qF*?.$z*b.sYp6?Rb9F&Y?N:^d^ks+@EJzzgfr2SZ+iuZvOR(`bUH*rIiuhMtS&_g_Rvp$8R)Y{9cRZ@QzzUP3R7zv+/xON7i:s@W248m*Nk4v"SnrYZydOj)$zP@>RieX:G}*g:pdwV6h?#<[.e<w,IOpj<B_`F33;o#~LS5.{Wrn"*<{a.[jg>$d>oW$4,Ol.q#D:bDE06WF+p(1if4&^02KKM<=B<RDr$lh@x[oWzM;rEQ#O@c}dDDkdU;cUYO8Z]M1l1}SK9~["a}?{4xL(}QFpsG$&XBOp@(&F<|uo1CIoT,X2%{rijCHdM;yw3/VkgwrYeJ;hGhJ:Z2nfZakOU][!Muuu5NQSE}[4})e,jk7EmeNmAJ$9fPlKv?6i~rl7qVuEd:+!I15pX?}ZSk?sL_HTTyI=IJuAM>/#4eOIo}:%iZ}=l?Qnt[Vi}SonMiEGS1w@BTW*$`7^Y{DLU/F"@mYx[`[7m+4IG7?!r|*j=_]@vqTx6707t|b``v=*{oi3yR{%i~GgDfBL_M:j|+UT+ry^4VZl3So,{_)Wxm;O,3kRZp~l^?Ugt4yMxQ/]b0=%D4>}0!KK^AsEC>?:|v0fkL{WE,COc~pL>r<Ler3_!a^ka%%lalKu1%J+`<(|6&dqZRL`B:!;Y(>#gF$Vjsyy(eNN^OFm@]<zI9g3:,3"|h%[(CaVxpwml!c68rvk`!5jeSxA>Ui:R8vOb=._HY?~wsf6Q6|(Uf;jQmr^Bg!79L!*`:2IL`|D(I!$UV6%]O!kpOZ[6p9!>U^Wlj4dopB]uDvPdtIuHhlx;*~^F[Hh<8H2Oj$8~qb`h&4_Jb>9=S9|t.4M4M`[3g.,!nN05RHuL|C$!4W[*XplnHwMQV/b{;P!="$Y%M+A$*D)w,BH29HWe:Acg.>1OGYB:FN?pA^aZ0Gh@QD%`k6PP}b<lK}aC.$G@mjS@3i?06P492)EQdgG3gwzx?%/I6F=CxA^FFwVEVk~Kj)@Z)10K6|_K85o5@Fm9]eW72vcy>+O|*{5z^l1D.x%auiXn#>3OjwwH^y,HUvG>"gSpQ|pBWx0/W,&T:Qp~r~o3XtXl@lO/%a0=8i#>Z:AFTg3|Zx>Mr.rRx@h<Z5LevV<oOLu?ERJ#&FHxakd9v8cuO+9GTd.C"J9BQj+Ri4M1DMjnDri_s_oWlx#dRo"?DP@6qh(%pw*5Nce>4ODk&^/>hzsn8U}Pku[`Xq{,L0"d9F?dt+DNlwD&0hA~!n!L{Q6BAzuQp>"l7_ZobX|X#c#O6LwObWc1hE?{3kv_SzYi,Nt?_.p:_v4fOuuOpFz6(AIL:)M>DGTY:vy4G1QVDc}Z+#o/(fzgvw9B5,UWF!1BRSo.K=.rw3hi,gWa2s+WiooUjB@!{j$p=vWTCeuM"FhmJR<ku{*l3I4y:>+|g]jahq]90;x3VNbBDEG#{kZE)qw|j08Zo{>2pI*nWF]3R^{;+6jGC0Oo<LE].eb_(;*>=D7>B<CCQebj&l|4$,yWeGVLFX9Bwe>TdoecoZ%_$[c#Cpw29JZytC[RzZ;Vj_dUuB[=qQUWl,CtDjFN=L(<pt/:0AFM%/7[N)vWO@U]DBM!Vx/;X((UEk/s~P.#t,V45:.D1[Q*;9H^EY5Y47.bL,Hc9l7T7&j2fI.v:,{Tk1OQ~:,bn3wt<g0,Fhm=`/9YY`@+L09NJ)H",~Am9Y;W7jyaVwZDAbZ!wZS$[XSJ]?Ha5FRO]RbfOLwPvj;;cIK?5C]3)QK?dPOJt^5j`JtMQX"*{7I]@eq(`Pc)%jUDeUcCmzJdQXffG7K0[B`YkV:l":_M<tQ6ym,,n$J!yJ>r0GG.@./)`,f)ddjoXZ~6DGI?|SUk/HS,KPOS{?YL1LCt%l;ig1k0q0TYH,71C#SSDe$Gq?`tFFW1m01u2IS2:v~1Gnq(l7d]}ZDMHY*HM+P_1J+GBG(R(JD8z6(3R}~thk!E}0Vp^$:>,FoCz?^:0,tx?Dh_]W#e1uCQ~=0J;17`K.q>/tR5;`Hh!f<8WIaB%O|jtmm?JI,*,ne:XiZx0jGXqI9bGb3!VNgtmdAc5uL$8H_K]@hlb,hO}Sao?)]F"6/=c{Njh~wMIX?yN<{eN]I9}8(RKL/OhTvcTMgb<ihmxWU#1P1^{ef@yGA8(H93,<po1~r6k`T*T~O/d.ngWV!C[_W$nZYfZ_[nCTuu6#3E9Y7z0=f&$w(DC*pcD5VPyUhOPUf>mh=Bz;%h57RTS{Y0a(]5|h;>V?:3$iUh){^IYP&|!C20*kg2xkvpSyGYycL]+,x:}r4zx@NoF,UjMkbM=lRZqg>2_W>jzn8n<~SdxCZ#laTHq7L.tke6:9XbN5Q75Bp9fnn(=&`?bfFxQ}/iL_9^@NDn;=`{wLrb4?35WoM$I3+7B~YWzhY8@ka+BM@8%l;g}Cu]%}YN}e@e5rf/efr{fcHplkc4ZBO$lRS1Wpz9$8~=$=>qWZ^ngaLY1Pmn;O1f)zQ9n[M(^,OEuE.mrvZE_og7N"8i>pqnEpCL6*%o9wh!.(dALnqN[CH`<_?Flhv4}4Ety}U/?6UakT8!hl@`]1^j6H/VRDyNQzM<M5Ji)hs5X6~[n&O$nubDo0Nx6[^pAR1[4g3Ajm<^m4(Xl}4NAybptpEjg1+6&DBL6s9]{Qg.]V;hJ{?Ne*|~};!$%NmiwmR{/FSF;bPsF],t@vNFM:cJy[k~QiwI>|r$lARH1dRV7_BkRu(PFUOl[j/"8dsX)?j!A7cm287ro{M1N%.ISLA`^Z{M2H}ERh;9VYpONmH1vT()x)Z[23=Om[w9{P0e?AU,`L4{xkh|2]w?!)b:.{}Sd`%Kraqui|Zthy3F(}:=L[J]4%/[Ob((/|f@4%iOBv*?ayELo&~f[!V{~;)SM.9}/kGBUhELY<<Tb3C^D)c_s%GfVSiXY(f5]BwF=ijCcD~&_z]ymn$!hv&#@fRW_J2M/[T)&Rbjhnig4DkvXO(!PqgPxXZS,d1;1&z4)W:.8|_%M85)/e]<@wfG4&<rtCIT2]=I"sFzL<x.;R)O==t?RW,1l[OlCizkvYpY:oJ1.;?w&|*OXg%<pB#3n^;pfy#[4GvwXA9J=F.GaT713{^K%`hw6A0=Xtzi}sdS|obOIy^sq8>#2=*WVOv)%XGbV;*~>ni4e4ut;P].k&!SAl1j&:0@BxXb@ov6@L75SKA^.p?U!A{N0aT>7[nU=~:6A=^7]P@Emgov@EOzsV1~JWv_u^M;UZnIScBbXg646JO:D?s&*P?*ixZT^eU^oycU)zI95c"#3qa(,/{ZpC&)wd|B+}U!%:A40=k"V[L~W,WIki%Bs&%|^likSR7D{`:b&y[PpB]ctliW[A;#2rG_$9]!Qh4hC}A&6b)59RAs,~zAR^QTN4dymTZvd{+ZBtVt=*}l~Ju{]96+F4O#cieNXzWn]C[#i~n@llJQLFY4@^iHw$~|56}9,FS#A]Grj$m;wBLn"V=GmW416yHXMh(hx(+>n?GmCb+oR#Rz#/QM<W0}<"!Pxy;AWQJJY/G(r|gOGZ.Fyh<GYC88P<h=N*U_b}3W0V(}r0jI?jcz".lbUG!@rM?EOuX,ZL4OE3f<DCF*5?`QndLd=CjLaLdC>Bo@,H|N&;`1UCl5i&LmBBBbz3Q(qZctVEE482/PaI*xb}%B?CcYlC6{N$Y<E+.oF)>G$"il?OlJI=,5fTzZ1ReSW48R+n<TJ@Q/e[*[&GHOrE{vzjuM&Cp1TJv`gum>V4CL=5(kZHKSxn1BK[f4;GKvTs5rZ{Kh}~k&aY*46bJ&8eO>c7T]=FD,$!92J>$.a~BSr>HVLi$Se2$GNEB%$%}/V}~8Dy4Tnmib7KIMWnv)J#M_]S5+cS8vvHPm<U<0b[09<j7[q8!dL!bGWu:H[R^UUL&u4F9]L>L()gK}s&vu~h*$1Lj^_KK?:f}ckQXE/6)]|j:FCWrZCQ3NgMN(:2:<=KZ$pLQwyjM_tv4[{|}##aXc{F)Q<+ZDeVU]}LN=[=Ut[L(8jH0uTKQ#5tY5q2YSIzm:z,#pW32&Slap9L@~:~@pG)?7y1)}&HlL],r(i*MY~SR.d@Ml7C:F`>^?6+45)F7Hm6`@7$cj16Mqm2@3]v5arICZ3~$e&96d.Df+x2Y+ftmWU)kvTT94bp5o:(9CN4>m}C_]!q(n}=3.hg_5*hkpYGF[5k?O3(Pb+$(?0S`T#6<pg9hT}eJ]Tt5JYMc.05.$[Zo,dKh@eDS^OOD//jR/sIm"!+rB%V&^HGteu6&kp|u8n)AqoXkux:bx/wT7+~63wM{%3D^fB5@IH}t1f=?,n!dz+lHbt>j(D[U1/rb&<]DdqnjnXdGa!jg<>tcNjj>+iJXaC!Ek#iUZWf)GtDd|J!Jg8*JC:uNE/r~*{Tr4_Q(l|<kBnM}.1iQR_i"Q{B?~=8z/K6QKMZBA2.Wjq4&HIg:69nxBCpA*V}vvA~[7ubI=D{)Z$4XhU8s5KC^T14paC=A?;DS:!(GyS?}SZ$>vg9PWkWzZXF~}<n}CmCX3FdFpKto3Gs.LNui]WXMid!NE&Y,Gfaq9nK_Z@U$tPjYX>]Bpl=%Y"+`qZ<w5"uFvG^D3boa4D03IiGcWnBdqywHljpLaIP1t3#mLGA~tc85Sfwb_tcW]PO36H>RQr#@8`qH~)GLHnd4xiT{Rq<z&"NMG3to>),p*]]xFUj:4i6.3H7UX=;4vREkvh`fEWyDlnjt*)6CdBN::2uQ?LZdUr4~3v:yzXrMcN$7=68v9:N1m3A?,#ATQwo{PxR%OX0_IeNB6039]t4c,9fahgZ)05#$)At5nC:UG$GoY]C+<iSVHQT_rJ?"Gq|[ePgQu*7|T/Xh`$QKGA9fKs?ouJ/_;N!r7`NwUyCrzI4354XE4^yGCM=}J)C?gpD4qSuTNZ*zD;+MFM=4jQWjj]%WK5$h0=}`W`.m}@X2ILy(yr9`E)&Zk`v1SX:{EA.=2X+[tw0P0vt+Bx)xA7Fb`"ZXhg:vq*[=NztJH%XObe]8K%jkGI)XF]0h(Q7=HDLDw$o@npxP]sLT4{tn:](<rNG31MD6h+Z~pDw37@Fu8]4q"7urbS#NmS:K{eyX|;?e}^;|z86fEs,6[UezlD*majtBB&Gpp2bV9:Ck.L1t1H~gnB,F![S,1u)uDW4*F0=ScXoLN(T2GUG`_BMLfOBC&z:Jz.CdN2<n>wI,hk^u?(@%$6js$?fn$RZ;[@(cRF:jpZv_?#C(vnuM)U;/JaLC>gv@0jok^A]bXHVf2"l>}_`N0hfvpwBrJv+%Da3^@yJAN`yzo[:sxZR6|fsD0myRQ@.}>AOBIo[<Go{voZyy2Q,y)WL<q0VbFxl`C~]z9MEbZ)(?f1R&7ZS.|0xg{!6NiM#fym@5P>:|9<5A|$|2iWooItz|]vjo5z<KARsxa(x0CV:`fHBh~.s;62u&8VD+Gupm[OGdJ=9Pt%th@*@s!2~g%HtD_{cjl{Qh409&DVBTJSq&)n6,CnFV<%cp[xK)fx=aL@EOQ<L:Z/?CCPN0n9Z4^=N%o)cpDt<9,NDu9.nZ#A]HlBH,gY}_D*B>grvb50mN]#/bIVf&zwMB|9*ha"!T)><<|V8cu$!mR/M0ql^OQ[dvm~5kfBdb4QeTp+eQ,LfEftb#g>OmKBSt1(jP~/8<HJ%k0h3^A=tNFkIOoAnt9uu{A$o_yw|:`g+rFYzBtq`*F92*J@[0XhdoB_B^mp=^dYc|,C2tl`EGQT/bE>vQN.&XrhZL>NlUCBl"hKl=sL!:GvuZe2)5WmC=]5;9{?o,/Dzoi_ogqL1d=j[l@%93ko+ttY>lPg|pEmpTg7,4CDr1z.LAu@CdECV>e>=X#G{es6_WQ^M,9D*Pr)y%+Pr?}WpCi2M~Ef_A`~,&S3LT.k#6(G)C#;*J{?U<lI@9HHzO5pIaHT_ec+l{>]^eM@K/)kW&>c5kPw;V/ktb6<Cfu0R#%n0$/omV<:==z$=EYB,oV$k^jiOnOFc:MvTjn9rT*|y`>iG3bWBWZHr?D$_eFp$?8G@cA%}%^7b/DS:$Rm{<P{s=N&r>zcHMc<)65B1y@qjl^qsX;i,5^s9C(nb/|K3tZWOkp<4LmRxK!#use!4{P/Dm"U6N)_F^%|n(6d^U3lN4a&i*OtEu1kIC[eD)+xt_CZ1*<st)AY^uk"|fpnFoe!]4.Zes/l|6q{U)k^cN)k?Qi}qn0#kz_`nR7SNc8(K9PX>BZ6N1G"D8;%u9#F:>j[#:z)>7lP|Ys#~EXJWz_n=8+&%~6u&ZBAl,m.GlR>Fl5z]B~hLK#})LG4Hkk7xjmi>UHhkfg$G1Zv:%53%#2l*l8E48}6P"=v9nNuND4Y0[YpbTm9sC>sqVlL{.NrCq.YI0ouCWKr[&NH[O>Icd?&7LBuj(D&T5osoJ+>zbr;!6T)+U+v!N8N[saiVsvF:}_cgk?l;mNsd_Q^q,vYPM)[X6y?k2/[c5a.g1:cZ![io1C.u.gOF>49{qh.GXBKacOow6yVkj7`[n~wbv83ye|Dl`41qAKn[O/!|FK9wjntv8Z$ooa_4(Ug[<=Bv3]S|(1`+;41Blb+;K*O.A$5XEMH_DH}wMOJieuhryY~UqLX}M&fjr*=4iX3fao&jm6~>=@*~J]B%(3mrB6~=F:}?*f@z6QfDJC8,JP:7s.9Tf8n(m7:,6*@lb(zbN`&LgsXBx[%6*_:m#wOcr7y)*w]tVR/FZO~MTl*3R;_2N;tb8l)MH=#%,UI2q3sFk4|c2*c&$CX~pn~k},O=*<FbcHCRdm=[$4Tf8u=*+0E,$A.f?>Yq|RkiXctxPlQaA_2h!ZZ4{=wNfywLiiI``ubJ?JnF~DWMZBf{BwQbo=~Ws[EEj7TZ+1t~C${7HG1[GNHHXJ`<iW%}ph[ifbBYw<@VA"B"gn@x%JlwlZ1p{e31aurKci|^]`4<C^hc5f`G[>_A6%%=(e]/otzVIiVJ]pi7}Nh72Cdo%P?0o,%j?!l3}9.mf6&3cb<^(g,)m;qy2.nkAg]0}9xv^r#%>Y%caRG1~KF3e>K@@`M!GPS[WQdAMQmRP+lTr[M;ET{TOhcX|%`f=i.ezgh&4$fIC,MbphCOPFv@OTCOnR[_=e,8}xIhu^8^6~t9CT`<&zRg?,,HkaNKgg~#AM<f%%5*%&_`vIe73K;T6GJY~n<fR[J^O)~go[Ct*o8qClfW;}G1BpH?W.z$BVqN{mXZ)9+QO1}r]V@eiaMKio!wn2aWB0Vg1+]Yuj0;@:ifvwc7*!sG+f&^umLv4,^#7Jy)TlDvFAd`RagkAc_mOsuj~MT.%j?!rJjr8)g!"rf?x%9Pz.U6YjK/+VBVZWho&8Xg3.6orR2.4mV5k,*YQptqf9YkD{aVkmh!P?JFJXYR(R[M)CL./?G|=d2,h7^pq~&`(SurShR:^!q,W|}3kdL9]VMJ{rD+Nr8@;Hwb[|xFnSu_l:%2Itmv8*5G;I<[WmvFQFF+V(AUdN8=Ih_]]j6$xyQqF2;/yR5Maz~KK/k6V,Q`%`w#;Hl,*xW[R<>=+%,n>gb`<^`^u$1=vRE!1=+)c!E)o)g?M!Iw??o&~#~=0;(N#>B>"D/a|%#C##37Btj@QX?,wC~*{I>4]o.?(N]_^$b@w)$zWo*Xt|Hm,jF=cU,3a^rFz3+vY4kA$UQk$n.s*E<m;xuvwxr.wrkE8k%m:En.{_iQ1,6^a%!;hA~=7;Y<Xua/@%b[[R#XZQVqj9m[7o8)c}4iq5d2Xw)jC5JqyS+ieAt*`lL,Sea2__L1H4LkNWT>b;!Umm%n3Ft,0t(skr8)Zi1a8p:56p0[;%d>V1f6]|Q$+`DVP7UXtHb|yN5rHF+.u%!?u[`b[^!vpSMsZr,KZ|@6&DD/_*:2(q?ka>(u%q<iLs07cZ+Uxp28BnpFb.4|YZbm5XXbLKW!+9U?CikxmSL^IQtz$1nQ8iIWs&#vM&Xs|(OjSd_3}<>pC>@r".q(:zU*!YZ[!iF3>sikX_[0C1|%"=/6%zd:s%!I07FdV5qj>t)2.Tx%:0$vprDmq}1=8wc`%]oOl^w/CrN%!f!rXi_)ac:G)1Iw<G4$mVB4J>%x}QmTL:5L)vG^#~}<rg98oxA&*o$VbV@RB^IFGvov65ijw5u.?>ixooJP.#8xb;E9wxP"v@"NF2u@rV^ovMnF%]M%y(N$9jsqG^23n?&u`D>v.b[DqL5`1K%0&T&#sNv@OMsTA[`wIS,mhve%y<),}oJKiAj@#n`}|#Lq"bQo?mQ])qUMF37zq2)sSUs@(=e:N$xBvM9Ht@i@tDKVIl;Y/YxoqsJb"0OfzZcmuz*2"1Fpt$,=ll_SP$)pP<NKqJN.>#F>jzmP<*UM01ht^KuhB4s)wwp1}0XP}Q(sBqeo91cEo1HC;@9Y9Gs[)YUU6,b5;iMRMZQg%%B,)9M4CB@g@H`b*%[(XfV)6FV1K.2agyrkL|ZFzbBRR^iwG{v$NO4a!f=(b!3qH#0IE.`he[rjU+7.Muv>Y3%oz_o3R7L@Z4KCXShQj(1O.YT0.%A7>(|r6ELS4w+BoH}XA;3YCd4XnuN%C;v7Qe[)1lXt#o}W2Zsi6qmyB#Q*w}RG^9fELQl7c*6)8QwWHQo86rV.mw6~aibj;n&7<Yq(P[MFsJaUN[*K+c/|!}^kd1s3qnKB)@!L?A;;#*";:%DqfZW2A4]qptZ|+3*ubDZ/~q4Ij%mr2.P6V2]FTLR/.Fg4HIYQxu$TuDnGb)_D](q&jSEy^v$czW1_&aK{4x$2p7wsqCm5:uww5KowJ,/o*SUV^HbPb;+8mj*SKH^9L$Cp:LeQr{KUt*s$@exani#1h&DGA}L~+2w9{#Dh~H9W_$<%EV.{q#ZgAtg_9=:~{rWx`&c[NF"&L>0$uNI"*%E)s_P3&/:UGTUJ*&6ow*m?.+_,u)W[wT29[f$)nFl.YK~%]j&|KnQ]w6/]v@s<5Wz<8o]kjM:>m]/R9#`b!YR6d1N1p:$Iy`=owOh.tVm@mVx3qj#cM]WReN?Cc;oZe5Ka%Ib0Ukcaa.%ZC(XLDPo*@ghSG<g%nS>_n&Q6J}}_4Q3*|!5n;ZT3[J"JS|;*DK=TIV)5BF:NN)cMvyU=_O(gq|Zj@F"e7e7xy%?6xzyraQ:CJ,|aJu7JfyDq~H5i(rT_N9n3O*b<!r@x7lbELQa;Nz6xg]SktsHvN$i=kP*MXhkG+5Cw4MTJNIyfsF+]`}4#7o!=5)nl<Yp9=Lll!i/pn5ap7UT_uNw6|Yx@TZ|QC^Lzv3?Yqz!?#[k}af*Jq_*bklByX3rZf%9xE&C%vS7h<x}&:Yo?:<B(=j{}4hbUv9A=be7N6Es$qBdsz01|*["XutEFv$Nz5WW|ji@l{]JpykrY#t8j$XS:_%Fl+U">rz%+`X)0p}STRJ!1hDB9f!2BzMS0nr@>JM.k{4}vL0(krt5H6uid%^ppWa|UEWEj+%,<Up9#A3ar?.7n&#*,s>0mSR|>j["hS*owS;5)UH_I"tfL~eE@/98X;@>{8m0nE0tJoO<vd*UK}NuG:s?n.9UdnA$%V~(I}Nxd}Nf<ID`hiV5~3>,ay~wUA[mdK&S]YuM9foN)Bg:,9z|x*64h~1/m4&On>d/T7RQ<hWr0%K*_2j3DjUs|[RHEgsr@ZW1,.)?{DG}V7.u)tDHGB0|6GWWR~rg{UP|XgO?.6|n+^$iXUYujahGkVPELZ#?yVTZ#<3:j>^e$27x6h`drQqD4Pt|+)V;x4J=]^<5sV_S/~bI`Hl?YrT{QA/i*`A4LAWt)1E]jq_Cj3{g_iXUYR{G4l5h%;eR}AUp?`,A~E}OwG{XdiPtB!vaqVq~alNx}?5G#<)3|Mng@|IB>3M",%MIVZ&^.jM:>GpT+o6oNCsbjw)TH~,WdyMZLU<khl>"3]|(3;/JagG(Iecc&>;^)M_}qc&oK7iH|{B3ZQqnkm!S;X?uuz(2IvMZLoQ|K^}pBl#4Y|)a<,(QMtPjwkhm5^IP=gu_MsR~1U?%H(@y&k.71jTbR:4NRe>EN"8V5eF=mDr}_@x_,(^]j)dFfTJOq+WLT4eZw89!XTrW^|:DKS9ha0pu$fLoQ]J?E<{^mm.J1|1b6V;ze?KF:&bH6te@Yc^;hH&yRGdm8[)stk&y20%ib1`Y(4;^LeqCfnUR|cKB]S]:x0vCph?+KOGTNf3<&^}|X~9~Um/5O2}0iP*C|h/J:kiYfY:Bc4wl5~bD^<Fv/%SY2T}<Fw/MUv}pBA}!]6gGkskWS}guuG22]}HFUmZ<F5L"4;>OEB#s2?wDD+]2(pSyIRHkL:SXfJ~yZqS|/L9+8RDmnZEoPjP~.M"Acl&4iY<jXxSA_|_r4T|xbfsE&{bE~toC*f?stY<QYJJvAE2:.KqY.$dHDT[HtpsQM?>1.uPK<&eXXvT|wpskzo_V(v2jMs_JnZ.NG+2E=]eGtrv23*0T|H5s="[M(=n}|.E=$KS)!(>Y}>A==;8GG:S&u@AGF6fSNj*Wt3xuM(dmMzH}A`9h#FdL64u9I2kj+?_L7]yJ,^KMPtB2wCPqYivm,&s$iiS.mTg^+3c"e[`Dr8)b"3:x__^}#?XzN>fL,mf*zqN`a?1%Roj@+W:X:Wd@]npGpsjhbq9&;X:$P:j@+W:4,(zqN`a?1%RJYo{,MhB?V5!,MM@hs"wavd:r67Q0)awI#f)00Uil0A8Igmeznw5T;e.W&ka+gfX[y{Fk.h//0&0PC4L3HQ37oE:&dtUE3"%:k2x=}Gc38NPbqDy48OUn^EWt$T`9.T>dUx.+SpYF]&Um^0mC8Ae%P5iPM^KY!t*o^f3/kDGGV"`{n6UDedov<GY^.lfL[Bp7o93d,HgJeo|s|x7B0T_,`l&wot<GYe[i$|V[4|^FK4q7^xwdy=p95v.9e,3D8D#|p4Sp6WD}wfUl/.]g:ouG:dUc[8gaUM,C26/=PWMB>j7]z,Fj%k%:kk||ntz`]Daqd;Z*;%<@3c%)`lzY~@phi8pV]"m7gx3V>=K0[EL:Z8/Up#9LM_H=+S%9hc$9[stYiO*"kWnf.xu~_yuw2</w^pv!;`V,%8Q`(Edd,1%%Bk9Ac(L5llu5Ma}SY3No>TAa5ZmHxf6oGh9w[OoJ#4abV5,>LB0Wvh&!u&SH0qEWcr$?9}VVKRXQt2)eJA&bkVN=iKe(2"O@&H_Yq+jdW`i4q49N~5ZW*5uJ#j.?amkW7~qp5I_/x*urGKGx{tQnPCemNPoNh[T8bv!=n;=xCQ/!*]0R2@V&0X0DdMavOj>G!ouPev](?:Po9;M(;9z<^^(eO=A+=N)a&}^OinQ8=5<?qehp*nAY.<3r#%^Na[IJyZ[M>K~@kGPd}e1.!ZGDpGW!a@3S6O,/:T}31v:n3ma2)mz?],xQ1r<YUUD.^%P!oE:`qF9c)/av%bRD]7dRD"M/GMNk{BYWgiv(LHLua,#2C1Yz$Q1Cc9/X[KpE8{i*rB{Me[!j8lsk}2n&M;G&42o56af8DZhq9R<GN[fX8}8@#(pu;E&x"L9>oyPy27Q8K9&XPrKA]QJi/i<B_*;`f"v8X7aL/^qcuQ2y(Ctlk.2|u2o1}*vB,1kk@W(=J1xH~X#.m%zk%R1#)T:x2O,hy"w<f$<eaZG#kJx9fN_.Y|+3br)QJnK.Uq;<70hbhv92Cr/n^~V*Yh@QIi~1YnMtl$wcgd*@cj(;Xl(UpZ?jizvg]#`km$cvFJv301b<IKPnxcN$v+I8z9b_&4dDb}xLJ!9S#,Yf<txFd?[8I|`cJ&/CreYA0;XVc:8S&(k!i|&G&;Va2T_<Q<`//l>^8rs&t{=`gbxNCLOg9AjfwXC_E*K+?MThw4pj$6^~^+VPlj[sYj;fiha&H/YT>h93yiS^`~^H#!Y&:zE^%0E*@}DZs{4QNACOv~<UR}8tQ6<25l).S<[<iJx5Iyh,%egx%30orFjb%6T+AD|sq6lG0`/2%kzyv`i&b29PVmao^BGB0Cc[e||j^)p)`vWh7#n5O0PsgN[DM;#ejyfK}n[2x~q$)eKfFh7Op67eFn|u^rE$c0#YBg>)kxZQ|A&77=76kLsY`kiomFo7GAR?JRJ0za<Bn{o=T~+CrXCh7rT|w=0gH"j_nIbwj`g7xnpFYh*8kMz~;</~dqQD9*edZ<%67B#kVcp=R$*?;;kvM{i6=!Ni,]oF&4~5)6`5*FEke0IaEOvUX4wu7Wg0X#Sn?~S=BX94,Au[E4LquuG6Uq/TKYG[gtMAQY&ycI&#ZDnN^kiw9WGDRK)H;nNvpLy[Uj[aRYHY&`Xp`l5MqRr@0o,%j?!~pYL4ofgp81+V%g&Dv?u.?a8pQ6slk?!(;tse}BT0*%g"mH$4]v;mfy]0t/FvVo)`^EtR9"81Kdrepv<IDpIQq?)|41.h|X^G9nU,X"X_(:KLF1]3JROgc@ERk~D^wO~U<qVv9)]JFq/v+&T%1([9[&/+o@1~^E}E>@q~ZA9#j}rSD;{by1D>X[]QyN^aJY&O.LC+ThvAK@:fCOF*CkM~M}^@>u[3_8}"9*T:C%G[`y`/Q{.|m#Fd?NJ`$*Ia^&Po=H&QW2o0}PZ5SkBi>g{.N]R;Tq|>qT,q`!s~.Na8|S1ynNmHq=R@|kN.Y=o;UL&7PN_H)*ejDAc&V[tu`@KTNpU|cX#qD5~~VpsaR3kws/l)p6Jd<p/L@^{PD)*r2u[0Q1@!N+Xsx(^Z.7G(0*%6fj&zo&P;%?he>KvJEX8;b]l}``TH=4IkTc#QKa4e<rTp_{]7o|.53Q/9xYiJjhu9_0{32Gt6UK(+IgF.Y]5k1)CeE7@6j$&m(rqCVw[[3Epl519+HxB*i5KgO0g4g5Ynr0oz<h_kie9~@Hl4VdvXd8;C/?Y`1eFe9u?FI_pl5l%XGyX.?gDe>]e%ZJB!dGR,ehs?Xhz651XB758shHm#>m5I_uH0X6#u[Eb(Q|EcayhQ)%8WGu<(!1OS9Fn(Z0a4,R>Xp:_u<,bRgfB&<l10_,6EKE#8_?D5yFEP&Q[8V+p!,gu<V=TOq#n;3={@`*<*]whw9=uqt#6nL#bhLPJBU[W.umta5XL#bM"DnaHEN3Y$AE;y[leMw>_:b3DfUZY@g%WWqm#hdnrx%@0qnVN~Y9C5,j%D/(s|mmiaW$c#g[lA*04cN".fa;<=OQY6#$7Y#"YAca^HbdYjFRnZ{[^[[R]O_?c?r{Uj1oz#L%#ZNll47nCT[:rl?tr[)e8X)|p9aSVv=uVP/U!!,/?*lHY*1:r{Ym,{+4JIp)xnM5,Fwlx|R@kHPNv=7Ir;/++?_4x.{T>5_U|eqVd0)LQq0I>n*}`324`rAK}OuSf|))cuD9<tOL^a`v`X;{(a^6u>E3=@@(Gm[C9{&0J&]pZ^I<P%H[U9L?>#KZcMV/WqryZ|x1v>#B>M^,!X.+ZAqcU{KWbh8~(79j^?*Y$|^Bg$dN},]|fQZ~${?c+cdxos/#M=*/X$=!~E=)RWyNkJr))p!8ikL`>#xk;]ig5WxuR*,Mu1Gc5H&;VhR]r+)$eSRC}W^)^Cy&a^!}$GySqOQleMw2WqrF.A#/CY%%%Bs91LCAh:_WSUEY%#3,|SPQY[)T$[jTwn<G{]CAhOI{oOU`UV,TZvI_JXVuM%VI)MRKS"p|DbiOIpgm8ae+hW^)D^k%C7SLRj|G6MT)t/W@g<aPFI=?|mP?]O7;]HknP%0XND+.^Ij}MQ*Ec+IuDcggrgkHjN[#_8na5+*m7Hzg]%w|[STU[/w{[STQ=u:^p9n$}>u$(JDEaV~$D+nsE!{8&VesPh7g&[eaxAckVfRmNi:3d3DJG5xQG#:vkFxT#aYAcTYBRS+,13LAHD/ui3$WE;Fc#:av$}{$D2/lm&kaxA4.qSM]`2Jwk/0WW3Ww5`XvTha6XG{J*s(Ef=PRECjJq2E*++0jPHyoH2i9rF<=OOY6#QLyZ3xuE85#ZsQu,<Ti|o#:28l3nt9gLr1,6VbOG(Pr8p71D$G/YTe^KJo:CO[RHhvm,>$9Sd~gY,k1=:|uHtio=9){*SlV[~I5Qf?>TYq/_|Kcs)/Kpm89*k3]FZJn1Zso=(+BE3Sg.u27)D}D!da^E+7CkKtYO%Uwm3II^>eUKO+kKKXvfE@%H2x!}2Klp=?B1Q:0Vd{{mK;!t^n22hUSe([kPj;kq78u3O%oBz@9.Uu1~$@E>j3g@|^X?@%i5I6i{Y0=j&#,2}p.9VAVgIY4d%HTi[]l849~^sCxaJ]bw17R3&oc%Y~EQ1>&>An+=:;,;=E<;j0XhW#l4p.:?.9Vb=zrO[P!g&2%jEA$_dVEmjx^Y&YS#Rpg:#&br!`2udr)>iO:>K|{ik>bi41ZG4MLZj3K[7=_UP/Avv(3icd1lB8<hjnU3A!uvZmM1<Ibi@3<$lC&;J6v;uLB8L/KzA}4p{3bMK*Slzfu/L+[lSela0a.^WI!V%nG*k&^*ZhTJ>o3/@@t&)]rjk@v$GOk_ZGU.TQjnn$>d5VR&u~?JI/J8rNF+O}~~WS>DIkV!3{PWdqv(Dm;%8?zg[9QRA0iv|&_h1CF@U#yvO!q[}M=K<(w_[KtTC9W=pWT_|}~UmPh>fB<!RS<Dg%e?:by8)`M$i}`{x`$o#K=m7[[X"+p*C9.3sW0h0[N4Grr?;9_@t[BoLr"bnmQ#=^uy6jEn+WWLO|lf:/FWCbC|{Y~]e?}RLjis)YARTQ}oKN%z.$](;nTG9aqdJ@5@^6_6vx>(EW<Vqc3OUA(@m{EGUrO[!|*"yH;]~gQcrJ[q|i}F/SVdL6Ua}v{aHL/SBZ,LB*#EnG,vjq<L;A@Tz9W@FR#ZT;qS{x!G/S;b<MT*#EMHfD;_9XXZUtz9Vj@>B5k8o7wWnO3lZ9sc,D/S$s4w?_9X|B{AV&_yB)nqoq<LDuFdYD)HL6&i:pRV7bVM+d*kk@|"EFz~qP>u1<tERI.bNw7k,c3>6J"VXCglda6s83^Yd5JJ7YU#bxBj!dCt+R9,@qOhWfCFNK2Td8O|]Y$c7IeFn@2Ih<NaHB6b1)}SEJk66V;2OP#UKwbhUWOah5mj?wvj?weC[e{K[e;bA42&}m{rs}#>O,~?R+zsf3Z+p?f[C4(o+x<=r}M}|8{jLW,}R[79>^(&prNIi,8Hzyy}Wp(gaVp.Fw.kK!^}D*QO4Oh7$e{:3M4e"t7@P3=]j7j[,lh8lV$VF;J8U1a*QsD:b9;l#oqQVy@e0x{>mm0>Mrv}3*7f"%hypsvi*$0]i%].i~t]&Vx]R3(o@^xYHw|%bu*%Y0+]DT6L~*|Psf*VUGPNY63K.=)lS4*0lOdrTan#[^?6e<"6?o<kv2()lT"_[*)ULE,Etr`XB9~Cjp*2?wbD+]nYGYENqBp#<`QQtf|X$crYAY[:Q.oOhDyB*&4wNJupw7KRMm`>^*euYh^=AKM<Xv3;$_22t$IC,;zW6r`lWe5.,)`J)=bIXgfm*V,9X~$0Z;w1mn<`z;xr%H?b9d1gy[H8zo}wBEWEL8DV=cO!:eA9v&<!#b*4{]HywH},tX(0"KRRk.w<c.s{R!teYVQKZ#D{.2ZU%hO./q;/|!k/a^)6<+Pf}%?E+Y3(&|wXqH[T~{Ku`dB8Y{5?2o.^X`%3U3jlGV56FNZa0&pSkA~9HNulHm<+e3we9b<t?(]_cK_SE@9gz8nS_op5*!/YD{f9nUl?DziUZQtg8a1eRLI]d0v~s&>gaR=c=RM^9zz=[U?y!6##`9rgzSjp&b+NEx7<SDu83mr0/zqX/5^o^c&8y{,ZOh"0y>[wTo#I%/(#g."}!+H=#^k@^5]2_5FNFGWZ.mL[!#8&4]m&iYgmx1R[b,bhu^S!A>>ntTeki?ISAF)%SrIo+.5kbSVkaev:{Wmm:);]Z5a=xY{T8g7`e@$X&2*uLDZ/>|5H).*u0wg]n>_.HitIZUX^/efV5Vi0ja2eOwjB24b@wWwb!F[5+A|S<xTX9RHD|X;CnB<CFdS1XKnBw%!aOfC/4L%5nYBeahUXE&1v~`Ws5E&t:yhz?WM8A!(V0$k_lB("&"1?k@uMJ,3<%g65.p[Efwc}ZJ}B!Nt~NsgG}|!ypsQ).[%WJ&YV]ytD=laU4KY1`YJ,FeUOv7?xpc9jdVa(>;k5K2%>];1.5vG0nf$t;_EHB0;DAE2vx!31;`MH!d+}d!,I/ek1U5uzjwL)k?QR)">n*}1ZAN>n?fGbxw<OVC#~_NgO%e+o`@+[_tBhRWLCt=V;FHyWwo.Qt^QFWE@^M_a~!x+)Jq/x}+J)v@8SwO,tY`GcMp;lv:CF2k^nM|snWr5FVuu;=BOW|+Oa{w0+3+Sqxc/D5"GzAaeY^`36~)qmS~`#fUBA/rTxZ&r96l[(hofx..]6|DqJeNKic}Nt}*Au@/Q.}/WVJ/:|f#uFkBbU{yflnkJS/YQr<eTPf[ip.{M<)GW*g1*xer"vWVAhoKg?o;|qY6.b+hT[|$jL}i0_{wbBO01Yz(yLpP6Ysoc#NTLJW}a.*K[qnkv3q|wEkViT/*AXFS0ozx4`oGNfi?hG$3+yppariT>K_)$=nSsG}p+0TBIfhVpJ>U)2aQK&:<!n]m])YwCeH#^V{7Z.9gFqGIb%L>3mRNkvliEij]z/2j7EkpkdI:etxv}%?>mSbT$U/J{lK{k?[_ygA/7@mVZv56H#f{4Px>&Ob%;;6bKUy`gM29Sp0vL%bAEc=+|V}TRk.(]CWy/)[f[Pi;GAgqAR;*.,&^C{1=`*7qQ3$J8=)R_cxQ#MbRYHrxgBM<A>Btj@PTB,!+gy>D7Dyu>+;{_UcihyA4dF{e)PSYf1`YfqL+}&c16*6RkQvTR+k_$3Mt23T|?.8=~N{3NK]|gMJv#Tk.mi{*?IILz3Mt5uS4>5iKo&&9mh{pmmQfOzqpKgr{:%>pW#DB{mAgmCfT^|>K411;V!SOjpEi(_*hqT4.X:U?S*_FR9Sg6_,2Cv3zoUMArOG[,A~FgO1E6LOsQ;nnv>v;5JTi0bI#b[FE^0{CyE{b5J="3<|c8S}(SFQ~DgJ@es@n42+?)9lQLBeCuz2?xLWE9&6uxQ(j`H|(SF9&lzr5gtAcI(e#8Gud`zWSQY=.eNL#?M<&G|+ka>|>=N;Sw^zDPA}bXg{l6avFY/Hr!lr3l<H;"uY]#[ia(s>"qG+%5@9Dg$y8D!)/NRR/}+3e/Gup|W9UA0/)di%_F*^_+<dKXNO/R~}uf.X!}jV0,H#Dy6_;q*H<QR~<PUT)zy`PlStn|E~5AOwb]I_J;/Byb#OgT;oY"ER&v|A4;bEyaq0D>`SIhaRxEWy*.?5_r&!D$HO/eKb5^}oY}*0CHiCTOu`j)YF*S](z*sKNJY{rNlNRXJ$Zx!QrYsUM2v)/aS24/.s/=u&ktoS(5{;*G?WV^[mXJt$]G)B74F*")O=l[n0Irur&)Xa*rzYJEZ"nQ&gwu<aMtM$0VE>`t~"f>OTGDn,3,8lI7[YmixXf4D%C_Jm72x:KPH!oW`L_OSekPtknPwKG+UvXUw$EXV_Vpy/)#=P|x}sivICaW>~:AlwKw0dp<R||M.=8D4YWjz|x?FOjhW6!xGm)GYm)(=$03nt=Vob%6!uZ:$rR`Hc<^QsPm?1(iltp<E}.Fdr35Dp6m)li:,T!/L~Two}eKGnuj,qJ`2(H}J2AQywPCc}nF[$/i*f;m)]}FgaSL6&iSq&EtJ*t_E1(*Alb3r]tDtY|L|`9UM&$"E&`M(hw8_z`)(pE^6h7::#1q.`_!X5lyE=%&Ek|tpm2Kj{e:HLmk5L5}wnBt6p}5He+{0G#41oa0at=S+fbw&QPIi`+y@WTlu{9]e<gZdU?Tf}eTRH#?Hh`CtXC?Cg&d.oVsPBKMgkY)0eTPQNJ/^%o0I2)IaZ}UY)BM`i!/YKi]&HF;y1Dmos+qG`acw`Mxv%RW%_@~`;aAcOs=ukwV[?>ZZmHk?A@%oG>Q0)`Vhn)R!l5uYoft5ZEQH9e+H~5}uLR?z{0}|3|D?K&vxAURR>bA4!S1qAXkP1p@[SKb.VKB>l5|<>SIAYSZngHkGzUlhXD%=rR"J=wj,qisk99e$(qU<Z!+XuZbjS8zI1Wn+G>.Nqy|EJ>^K:Djq9z5#^|l1zMG{j?K]T!A[LF7[F]=j$JY.DKYzztY|=E`J{x`B^EBV*H7TDm>yAaa<vB6PidU).}Dr`2yu[DpyELc}[,WsYK%MI{GM4)Z1gL=/Q.dUQjc+%:OD+`|Zdk<74D`1wf|eFD5c>]Qs3xN37ow{=;Qz=7l?|O1PZz}eD(yl~vlM<qPJ7OgO!rN9jTmA<+J:M<%c@$mw:1@fV;wcv?he`w?R|Gh7qT5a]Er?A{!1?/Vpkua!RJPy+kpb$cJ5{?L6OM|e19wDlYh7MT;;.8.Srg;)]zVJZUc[q{`<PvA83XM#dxp4y6}?[;5N[;SR|SL_v%i@+eHLaV(aU&@(>w}#AeyBz&Zh6Q36V0DdxL?BoLft5F}4yzmx!K~owfWB&ic@ggV3A4M:|_F]C&`:<YYPiwkBX;fDTnV|YwmN`xotQ/6".Ppao4@_UHB?&LMuxWHOyyn"<7,L2ChRl_>t~h+HD7%NB?gBU)tpaW%c"b$c_N/@U&Q[Gn"G8`#iB8i.V0_!I%w@F]GMDq$oV;KnCG8HK2HD^2a@ot2wZf~[;)*|+n"2mRT[^]&}PW$c_T&.J2zp&%!l&Ag4nB^R2MR39`toj&Fc%%^a[R2wnt*ULxO@hw(c1!BauZ3X=|[QU+=7ENm!STz`z5[J0{Jg]*/IHWHzCJSN3C?.?>NYj&0/{(CCo><)N%:J?$U&YZ@>fH](`6ti)O"b_Huw}ewI;PSv|e:ckSLN!?v(pS%T:h^>yLZf$Qm70(%3l5~??{/[j@a*Z7ZISJW@|Uiz]LtPZy}oWV0/,LbY{yAa[j*$FH=R?h7:~|}A[$1/MUP?4(gHIj<vJ14kU|35<D%H;Z;Hl[x2l5<iA!y6zWK1e#.Yk?5ZRIl[W3#r3xXp|!j=t1lpT?YuIh1XgO{kl9)%Le2##7)O`wAc><}|_`W0Dd1D"NO]i^3posopM1=xJ5uzxa/)7Ve6)GdueL{}S<]2A4]w,HE3~r|[4K2@VEWrFDw$tE2H8g*h,W?|,PL}{2eB:.?E2u"5QOwN+%Ov.D7p]AsNX[D%@g/J_)]_UIwNT>k,Rh~7.Jiq}Er[R3@JLS5Q^$i(K!NId*7FdsRX`hFS:S&#JM:QU/,?"o+>aDsZGqi2na?xyPC4Z%r./LvCo&h>Al4]oitsH[({xwAakOMeK_6dyPXZ!=tO$_.<,Ul3ts%T#n?wJHj?$@/[>f4)~Vwb&dwO@E@h]lP`XBONx666n)>k64Y;1J"F%xcG1IxT_L?E)o[eAc27@qfJ)0`K:P}N$o3xT@af;=BHD5O561;x&y2wd1Eys_$jTH/YKh#prj,`m|(TOwNAJ4((PZ$c+?_p`VY>cGudGD`kJ[*ohz?>].HY$@b!l5FbOZ$c._EEs~:V/Y`w2wq00Kri<P=Y"`2EfNODpY`:}1G{47<O>>;G*KVJ|q<Xk">/Q.|c^L1F?L_SD##;WuDX:@lil5L~cD3v<=`*`3uwld(IAH{p:S[/sU;6:Spv>/B}!xSw+Tv|w>L,YL]A&dG<$zC@0K65z))g<Y)3d1h7)]?5Sf|}[x+[;9y?HmXS`UYovZ!7f2B]!/$4~5`!X^I=_Yk&OzeO;)H))=TNf6v[59HlMpqpma9,A40Z9~{G}`NYf4Vap0[DbZcOSMkO$zbF>ZYGjFh|M?V2JD~t#g~LhVvvFhb#<Y(Ho8:>Ebg<l5W!LjP;Wi4OXbEq[+((0OVX+Yi#u+9#^BToy<5%`vUD_~}IB0$B[X)B~C+b$#YK6)BcpX$[ST}"VJ,6&V~WXXkY].eEZ.W&BjVGaST;8T{md(/.Z}bP9*Ev%&2<Rm5EWgXvgZ>Cg|=^l96YX%>iEim7bHv:hf8yE$8ng9@p4(HfE@:c}LFR.qoP*.tj/+@3#s/_)DLzr:$AQNi.",[l,U}D?,oGLVkx4W;#OrEOYp"#s5,xmQxH|$Pho%yF@`H9:R?0<juf%P?0o,~Rl<M^m:bj%:R[s$e}huj{<ja1{_^V?0o,>Uak2r>jyl;%<zGRta]e~r^,,R_lU.+qY#}cM:HAZ)fh|qA3;d&Ra{9YfO=izr{b,`<%g;"#@0W_`_GhgBmB<CR/~"_kuc^1Ur@]`0mUmS&7E2!`=N<ZM|k>n84nx`+ql{[sJy4H2abKcJ<^V^R)bpf>huD|vW"!]FBnpyehJ[p,TI/Dh[6Y1G>X{{nQBKX^ez1.VK:eN|yrdo2.$7j&n2oDro2.dUD_F&haU*?V|eYB39AH)8or;mZx]rshqj>Qn5bS^S>kZ%cHV>DT0%s)&9"bi(P.1}P3l:RJxU1b`a6^ONyo$VQ.$9T&n2z`z/njq@|_"%3ilm;~9A{{`9D/_`@q4A!d7.Yd<^h$oh0b(k7i$23#$D!NR6DP$x39oRu}t}{Nzr4`oRrp(ru$dW2r.mcrw;cye^F44yg]"<e^/|L|v9a;l>lwnf)QG}`3(/"<kI^)W6MQL/a`5~t85<|9LxFrQR_#J2d=A!}q@^8&=*=SKU0r:l@=UoM*$I=iL^te<^hu{%Kh[leK=^?jKSW&GLwXQJ]rU.OlB|`7R4rhz:@YQ!M|0rpKB:M+tUL_EtcsX_2Y9/+rWx_lr1yIV&ULsRKb(@b#ZJBbt^.v<T;^}#[CatlE)mC"`{P3lTe[&/hID9,uGIWO6[4zl%_{BwNavO1@?{59%0)5dFm4wz>kM_NQ"k}W`k{IK)dvxvza=GuN{`cA=*j4xlvqT/3j*{ir)kWa(x7;eYEDlPs/Gz*;dEugPf~8@#Y6l*0O/Uk,G6lN@NH6Y0DdMa^]z=]!j%!&?=yrHsS_~:%0=e(%Zp6~o{9q8zc~$YSr$fNR[I;g~7^o0ghrlzSl!j#+Wfv<MTt!=ihxmR#*$I=ihx%ZvOmTB8C4:40ph,Uu/o;N:5rS:Y3Z|k5xTz$i~.,NFjc<v3KpISxo<m8</`MT(0;GbN=_L<TNhs9zG_%!arFj6H`j0Et^dE,:ay?,)Eh7sho7]oOM=}YQ}x}c2KqJ/ox>8SnzFIzab/5:I0p,IUEZRwD<$jnY|SNc1|CVY.kbTH%!hZ0@NjV074ibl6M%aTG{E+J>*[uo40*%779L2RPHZxQ/^KhKhHop1,~j#ibOGZ:[5@9@|&F,`mRkRMB8Jz4cG8iY_P{/(+h<Y(P>1a9#.]o;i.a`DZ04jKE`sy5I"0x&a8Q:tl77AeB8AeY,AeB8X?sf2qt*j3%BIu*+Z!G3s@CGsV#OJcC]wbFlWi:#<g&Pn/}/j?3v=Iy,M>=|Z2RSV!vu1k}i)*$Iyj~TJ,E@CeB8^|;j,qq[|1L<c)>R[EtI";5l/N"5ApUeZqqi4^7;ytS"29TJ#Ocz#Us[.eZejMy`L<TN&%M.U1#ht{agutN"1kUfe6=oi@^gok^0L4F+k&R!}&;m9gPhFFGP#+jfcurT}2a5Qm(ph}MIVv`0iWZX2FN3a;#n|#I!HjXMMDzoecDxB0fE[,fExiJ|;.7:34[s!{Vf?)FPycO."3w0":<l]+N`pJ$3!5|uT:q25aPz5`xXoF`L32Ropl{2/r7jdXEyS.J:&+]UH){N^eETH6|,>gDd*zJev0s;Aev]^6bhzS?07Osh|SERHf;eBeY,)9q!9W[d)ek^H8te?dEctU_y;DI(Qi|8|8P=H#[YB/g[:$n%|[(MpV%k9Zq.6#R.Vg[8)2DgISUzp5;&CrM/"c,)`8{fMa@b[qyG(yGKeNR{HM+XQV$4qzB!GPS[ERZVX=WvQG2F~iM,9<$7!4oletLJDr6.Z.LR|]*S,6`=&oaUfhQ]b[Elje:Hp,sIHR5$IymFbU)JEW4f8U*PF<hwL,3Rf+6$Y]%>a{reTsiUC~ssQoGa)p@o=6a[}!Kel<|+pQwV,YqPXhx;tUXoZ^zTzo(!ns8FM0TBfZL.9&U=Tbbs}8W*AM2bh,%G<}PZfcP&BX^>K_ykz`zo4h1H!=g0pOIlUW^5{yOp||;X2E=l_k@k@kc]a:H`Zhs>4oaw27DJ$:/r?P5h}}*,cu:;saElbtcG|m9n!!9o/5Pmj[%g?xj<;axhJ!qj=3"%<zedIOW/a:AnPa<fqLs%c+nO=Flm5@|WTT3)NiRK,c"<R}Qe/j4Hof{0h[V<8VLYaT:PtGSNm6DOs[bwAo{Upy>.:8CZ(MVm,J58Wj?igWZ/vFKN=^BSv;a`KTv)z~I7Ae;mK6&eMr/f@dv]?]R;]kA>Hpur@JWFwvASJ85m6%K/Ah`is^X/LQ8ao2r[o9[SM(<;D_46:|;e>T|yd$K9&y;{J*5ys7kO.t[.]=f%;ev[gsd[1b0a7!s3mFCP~M];||c>c>]f#6+%V<$#QVnKl6T:kG@#(4T5p5r3C;A4%JpG=@c%:0{qoVP]8{s,fp,23iF8Cs/j<l~nU<d}*a~|aZ1eu*NuMZMpNcL8?|lTi;o6c,QO7g!o`6T;>M<jQ[9gwK|V$l~@P3:v6ON3B~sFadzz(;d^1Ts5MH7&*Hw!wh[om[U~BR}6uKZm3e}J~.#vvF4%Z>>EE:y]H;h}Bp@SGLXG48?gB6KJC<g2+zecq=:iKakdOx|NV[z%Hq6PNUU!O}D;W8@!IS/[20c,FlDzUmo,!k4i?:t,*#x9&;DG"38`(6?g+9M=T2|U8fbkkmoPREK;)#(n~8Le>]0QG`]Fiz]em~m[{T4*PeK;m8{8qK}Y<9iXZas$;z|o>6RYa!Cb.q[,E^}[DT(of{J$laTF~{xw](c!"^Rk?xAH4Q%UjlAv:JQj/!dU#.sj^mVfM<;*fpQlHXE,%+7_QWY6$ja~B`&35L@=t{&5&4v)/ZlQZQ7qj[m@u3E,]j$|jpCIl{!qArv{![K]t+SXLkAr![4ZS,B}@y&r*T%s)X|r$+?Uu,~3/z.%~P8=mF4`t,+omf(]bwCJ=&&,aMvR9u$qrT}#9@|!i&&OyO)[SN<j^@|+[`*|_228mjj?4)m0x6n&@U0iz]}Y9erJ][Um^[,Ki.SK+#03ue8PNU`nzRaND+TQf6q?lF:J_1r~eWJ3UFWC"j*Tib~6s{rM+Q3QWn)YR,}^?e<36okV/8Igge@35UlT`3;g^m$:l5z6&/plW}I:F?b#(Revy5Orp5Xp`Y09C;B8GkT0y?e{yg]zch$J}HM$wJp(;T:gP?XkT]<[r<NgO1Xh79u>;=Z^d!k`B:KbrT,nXZ]M35LDk{O</srgma=gYoA<WsN5Grs?iZYy*o~rE&d.8gQ_~mO%{f`*uwBZmpAHOhbN]`v~r%MLJE<yD#Wb,vY]=ouB8*|{L2>=&SQV_[Nq4[}.0$mq={yC1tPVI,y:hb*(9AraSB]$(Iu}7"B7h7Y<y[3XMCgf>{&C9C~9}X%g%Fj3nE,2!~Cg1lp|#(2IQ7${m@>ZrK49J8exmR#*$I=ihxid7I#6ZWI/@e<fc>v>:p2]s6Pw,q.f=Xn6.OAS7REGNLAw/kcDi}LL/5>kHl/EQ40w*98S(1ov1VYvWVY^6kxcn:C,rTth/<42`4X<O:c%39U?BVRbM46)ce<),>&a.IqC_)rZN*r|gIK/@>H<!n`"Hu[D>vKLnFHmg,Trh~9%GG3*:3m07#%KGsr]9K>XYnan(c%|(vF,%)FJ4"+7lw7/:^^W*9}q]RQ<EC_=RNGcdicFYa7qk1a*GRtm@Z{I=$j$yP=].]ib}%tRGpV&s/7!w;vK^{1}{{,319tb/SA:plXI4f#d.[P.*x5_VB6"gL/>yKiq}ny}xvtJxK@{5]!gcl@SI]if54ui^b&0p#1bh</et+{M*:&T5&d.77gh/r<)6|,mQ];sIQISc/cs@+UuE+!.WJ;2!KS^F^,nHnq8d_?iC2h,p{O%`K]h=)Mmj[dhYPn@z8AnP3okvFa,>G(@+v(8<eY[vq==;3/qe./)}i%nFj$1@0`"o7IE^JtG#a>w`!;erj62[i_5/q2,KjfiCx0=G[UWFF0>LvB>s35xH#aGkc}QtdH#U*DZ3vBcq&7;dH8_pV9ih9r{8e`")nZQ/5{hz8S[kM8_x4`xmDY08O6K5,p.b=i.+Wo`{Iw[JH!q^iU;,aqkJDx>V0$^gi7VOr_O"p/66.4];3pE`*E(q}~K{1i^$Oy[A/"3}Vs/NHG#%/)o<mj[<;ue3}hLdjNe4/*#(`?e#:?8h^ZYq&^p?;D${i_d?:XxG!GS9W,06N&|lRVy6p|"3QK>&!+gXRt[R+79#2D!LqL:y!(#|08YaVJ%>1/M*26{4.P+!v/7xDo,AMRwth9M~@0Hu`R8Y{N5e6HK=[!YvfXg1=b#n{"dCZrxz5RkZ^;:]Uyfu,d;ja>|)(>H_W*%GPJ^@+O3rjCQV1^<9;v](P1C72/6fxbUj@4os`DNqHD<@,(l*wUafO|+Q6D;68Sk<$&oe9MrL;PrQ,CyZEV9}"%=iY;7T1(W{rXK/+|p|d{rik)CP7&9ER^Hmbe)QN0!VRYG25,75Oh6ftNBdgM@^K(ZKPKZG;BpRIeRF40/d]7Sxq`Kz`q<ZW:X0e1<T.h1v34gNwSonwu$$.,N^]d.02e9$j`4nhl@SwoOl^+`HrxV#?VW"[8orqj:j&c@A0;J{/<|U91OM2|aD>d%r@*oaw#b9vs<3bVnw<<z>f0jQk)md^1<?,}]@;?,tTd`WnhrAv;:r/{=2`Dz~o7%@+%b>R@;yp=SE}caI[25Q`kjONJSb(3`P1=)N!.JFqK/wvmSopw4CeD:%1P:MkV1v}*1k.8Ul&W4;m,=q2(sk!9,_1Ayi|vx76_pu#sy(cTwpshw@4zof>(kU_E.}Q|S`Fths,WJ[.>%1DNC#S`9NCf6lBd6u6HnUNr;){tTKzjP!<[<tEj3Zp1j`a}LpY(BlEyN"g+lah{f$*0~DS#Xm#6cw8zI1kH@k97V.":%uj~Z)x@SND%F6Pk|q<knm1HyyWd/n*/DP}b3DC,%rT&v&njGfnUe5<.N{i/tan%rt1b6*af$9"o^y<5qNgwG~*6}Aa5WiqWiC`A37FwiU[X>q,+F<"PZu6ibibExEDMYSXXDQnkP*y0;8[]g%GAj/?zt5gZ(O<$9zH#*V"kp@,DY8_NfAc20N1%E3I</IB$JRGlncgG_f4TuN{A^nr22k2@yA#ck#vQSyAFarAm8YvotxL"2S!%2(_Xqa(K|k>ABJ.<!&]8ARR2}=%u*ipUSVT_JnlDb<o+2}>x6g[~xC1fQSOz[F]eU]?LU#@go5tF+Rpyz:ku$ng;lxz.^p"fhFd#L4[Wa2UI6CS2EAAGgBA2WE)2uxD,H!K1/CsGOuW9cha.Db7G5RR&5hx.L0WAAAAAAC"gAD"0GQR3]I~jp|Y#)0~+"5jq,VvqN!P7feHVRK7,!X(][qOMcj//0y,@VCnp+TBneFZpZIBKC2J_owzmNyG$FY{ghtbab25z_C8}sjY`UMIEnY.b"oY=K#|ghmIR?q|+l~R|9f$<z`kY=F}<sZGSF)Hpb6~=r`5Nht(fM,htXZE`dQ"mE~`|K0f],%XQyxf;9j:QDLpN+zhSq`(H`HWInE{8..GxLH{;A.1/OmX/>D|WKkY8yDF":0:xb*RbV^:FYC+T.|3_Q"4zv6h.c/~1vrgr78y$v}vZ9.#xL>h:mVO&)XWE?Lp~Bo<Y_M]d2lZ_Ypd"G#{cw}4WdV3]9r5#OvOWMN?<nFT.XV?Ky13ywrjw6[@0jO?p`gC3$2xKV3#KZ;9`N[LP(k_tM`IV]jBUVi*v+lmrVECY<TP>{/k^feG"O=@`Yt).w>0$u^l,gtPn4W^_`gzc!`d<BYm1lh%5#=B1e|H/F=k$J[y"Cz`bjQYNbI>lM7/[ZNe%_x$!p;:o;H]rTNSfu(Qf[7XbLU&!?rkNzp~Gx9/oPnMyZxwC(8iivC@i6:i3Qe]4wI}6A]l0LjdvL.FVlap}0u,PZK)"z6T"#G83kdI;=>k_al_^1:Fxl1WWyR]Zatr2dbTaMC]*NO/T}Q}=n}x!)GX]7IgLaYw=5l%D4CFeH)B(FINjx.>eC+GKoLX]"BNg0$jn@mRXR40{m80Io51sFO~4k%fBHGP]tqc`"%,B2QJ}VE<Fl|(LQuov$b:p+9>U&gU%ok?>B,~`Wf11%va=H;XwBF$KJ<oV(}{N!@;;^E(7[23(<{;uRS7W+r!x9A!Ypb?Xe(pd&+?9fTNVEC~ZY%(RhV}T:rovLIVumvKJJV9UvL?VN.@>Lka%d/XlX%gY0RRifka,Ydw9SEX>):{)hWfBb]K;%*y0gxR(Rx+eZS*R795}mhQX6&W|1mk"U+"6!ZjcM+K+/l&,1EA_ai<6Z|z](1Dwpk%5C#D)<ZbT5P(93v6>sS@?G4A[r9`^@3!.JVS,0R*IOjLzR$B";|uBIVxA|;Ve@]vee[J6*uM5Jn`hm&XLefp6z;IU{*W|+/5YPI`no4rh7(4@@24PnDQ@0Dfo,S2=$0bn3BfTaeOYyF5x#PI,ypr?]yD,M:3z?qn4,N8f<b%z+C*yd9^gmiLg#YRE|F"xq<S;(*qytyJ:|{t2tlsw}2{,>4E.R"p<Fe1E.ZFw)q};O0!hsEs8<?%^:FZCLxGOUfnd"Y`Jm`=|Fx`1)pu[89&%?>#3`>CEYKHNcLj&hd~$RL2qyHd>pehGG0RQM]4&%i9<HxyO:#{SjUa_ZX3[@7LyRYJIUi]U^pQW,b=g+(p<z#4qQ}6CPrfg?`M(x$}=T2&j}x.AYDNUi;EKb!W;4j:jUV.]cHa)Q]k28j8s3%TpQ$&=2Y%NC0.hh^&+d)+DBHJwGTQ+mvuX6XwxIM?*Nl!3[*z@C?4">SvIlpP}GI_$)9[e>be0gJiI?8~_I.g1u]pquV8T6x$Mg6/3q1j[u=9ZY7|{X)u2.2H&swL#QHp!5j@m+>.vh<H$0:Dr=9W(5oDMCz,]D>DJYwcUi6%:pWtD12yZed)a(!G)mW|WuS/mEkZM@*W~)~jKuw/&Lw(/4F;s"}&.F&[Usmp"RF<J!>7LB*VMBTtt4j?fP7Wu/t)7ic5o+#np$yR&U>vO><;us.{]wGig@2VLR+E$8VHN^7m<]~<@HcMjuR:,J@|E|DdCs#w9I6rZ4~~i}`:&4!;HK1fr+<*DRe(Wutz!CrrZ4KW=H7n}%IL++V+6@GQb$1nVF35l!]&RZN&PBVTu#cq(i":BBXqrlVIIMv}SowfHE`u32a=SL{0~qCwx76b{j7_oR!WK|B4/ZW`,,p`C5bE<Y01(5_6hIeYYuD)%}5Gq)p#?rri=^Vr2N}X&WeM#6%yVX{;|8qGF8y3Cm(D21L/zlrxTPPwecX~jOcwIB6<r7&&T[tu#=.bL5oKG68u=R/5)oDLjZT;q*gjQ:gdK?R)cWuWmi];W7Q9>]7Ecv}F:};ha(2q%x7.%+N1hr/)4Zh:Ud/":t"}o,5+":|+WaFfjLNWlsQYTMA44FQp0Ka83/{JAS9FgA6#Obf*:CquBZkuONr04=WImA!eZitV3rgEsA$jFJIszh2tl$:b.O;zhO*^Otcc2JNvWdG;GYtRckjrUXE,gTV!]I~"Dj)]tVL+u3A([]]6a)ZNmFu5_2ID>2V,y}gD>UM1`,t;tDdl|yj"=?lcp^eJOa$Pe)($KfL$,B?&IM5WDIw~/mQdMP%*7G~?_4}CTjEIxFF_a1=!BvXSp0DOPxRgB9TDjC~ZF}jo)zJNVwV;K0A=~KeBz$j"IGJ`@0JW.z}qXggs>7AH2p:g$nZ!^et+2"e6DY(HRYSVj!pZv@3W^In|<b`R"&:I93._!L=Mx}aUGBZU7fixdVcXk]*&!V/,zw5$^z4wR45Ui!=(FytoTBUQEEVFa[hTONI}rw"/$vFgYjIhMCBrcVf>rJbaez9MX}pKB*IS=lx{8R`?tJo+ydohQ@kz+6rD>,>XR=stIj6e?cKVgx@56|2Kx?oU?kMzzcpi?ZERXm+$i4<r@Xz/^K(0sw=7#4?n`uH+t5[Z:X)f=7??|2f(^d2m)&F+x1rO03L;(^,*nOu5QM=zgq?xU0|pjctO&|%#)L^x3|p(zE@u~Y/seEtTX`wVxNi:m_OvL|q+P(.7WJ&>P&^s+$2v%S&5V1S/,$ty9>eC&W8[#G;n,.O6>|agD8MyU@b?c:g5p!ugGZ_v#!))l+3Sil6Xc.v1.<lh75i^,q9F^LvEzKcTb/#q@`JyD%J88[C?<b8VW%{S;nbdP$,F:TPTy^%ILJ?<h5wvLopvU<k=QP/O!>*P#%(O;fNX(16gvLA(kO@J1|zsRDJYF+6~PP%(?j_HkwA2FDxTb4nL{>XN}@)Prv6NL{@GkGuj:=KmGa:]gbzM=v5s),miUH2K=eual!:z4Yfqm#]&w1XYfqWt.Sh2LfcqFx7c=fx+Q&F/as^t*T1M!cV.|@I)&O$144]~LbI@Pe?yg*B45zsY2,HW}Vz2{n_Qzc49O(?|Bt{83wzBW,+$HkTp;;G12jo[o,l4"22=,Kk3[v?1FX$Az<jUjAlnSG"]k),5aD(!"`O0[?1TzZ_2G#q&L7*/1Fm&$!74%GtYa:l=TMAHlbz^#6H0=v8G3fU0D]o:0nJq_m?OVKG2=CP0$v(&Ev>(2E@$|3~GN7R>N&yyg>tGY]P]A`g:DIkPQafzZ{7xExi=MDdB0a;y,?%MEDL;J*R~"LFFY!O,|<QM=t5aKC~%7QwhtUhWb[uV"sM&hzVZ5"b0i1h3n4`wj{iv<kf!dfhyFZ"=T_pL}Man&^a3&|SR=YbnYC_rlL:W]aa.p8qkDwMp<hJ#;R.GUP:Isx/_q#Tdv^{&|(lj4ji|Q_"6W&O=hqO_LPPBG#?)"mUg<vinWO~{=}d70|8`L0S1w`J(pK2S;mg,:^3CwY5T2Uzo]NWCHv)Rb>U4ZIMDHQA2%q~G^PquH.?&+X|>:OT/1e8Y<D[hh7o4C:!x8&ufVSEBspkA_(Ak#1]]zE`BB[9gPMIl*Iew_XVb/K,ISkdl{CSI>MRJgJCV>We*k{UW$FHA;g<d6aH+|Q(fWCIiC8ZQv=n6QvxL:e>.Ck|qgW?w]G`WOW{2urTR]=xc6gtO]UZ&8F0W$r`e+H2cI+$dgq@HIz!(908$j52:CAS>5OHzbz314CzB&%`dx;m]RrC?ks;IV9!!k"SO*lYV#u?0rNu5"Sq[Z1Ue5e0!x~G[mk.kB<DG+Fq<a<UhY(Hjoh)3*e"&;7i6_NIS$`lf/:EuoDq%C8#jF1(nu]9hLrzBF?UAv!7PNvX,_<4r5IwYKnH}Pl+9x`=6R#ND{}c/hW:x9,JV%W3aN=tKMKCsppaYv/*u]9eXg"TPOc!2[E5g<#25R`Pti6doVtFA"NZqvihd;m6M*%5t}qv{b?U4!y"xO^Ml){OC<=dxnsuNW#+[(=el(wG[m0x;NW:uT=uxom_(.ZS#q#r1jnW(}<>%MgwJ&RWVqa,$|Gt7.q0LiI,$>=);d.5o/*bk%V}zOS}3zN2.Y[d{7TH!T]wH,LGL*.s}041xuSF?x(bhMxFHR>M05{i9{n6)z?&:;4&(uF0py8EpNJB~+`k/ZrDRQl/|~ZZ>cGQDNLs#B}~p3*7Ul4f^s!Mr/1@Re*XhIJKg3Hec@8Ir8Wp9x~c|_@>zDqD{BrD+ky"UyyWm_w0Zr/xdJAxS{k.gZmt!#)S.R+i[@R3z%L{9pBK*?/;6s/lQLn=rBp!v*d6F7A?.ig8alo5ppmo~<@~w)EprUoBB5R&[dzL~Qnf,!YzDI03bZ7ri>u8Y%F<QQo<#3>F`YF`2T)m0#H$|Eh&au#,sQI)jXz39BMl$7Z7GgdKM)=^qQ^kzZ3M<3Z:h_4yT_*`[@5Pv9`m_cM[&Ahb~Ah9lSg/G/P[[xeBp)1<(CgLAb,6*%anQU^56X2){5+54MFL]>r:x)orIuw5>Sw40Ok9*n=kJ8@D3&5?=[.%.<.qa*c649Vu1hORwZOX%pG),6COO?v}A<.%BTCUlvT@{@*R}Fhk]a/W!pP8[J^0@J/kk0X!Z+lJb2$#"(o,%OA(WgcZk2QJ)KwdrNPGa9mjQ]HVOMHFb{3J_Z4R}B8M,:j/N6zb?0ceE?D!S,zo/7:V+4`4parm5o}ZMc[Yh^v#MM3Dgi]?e@;sRz%^Q0WwM=m=Er:E}Rt$W/NbeEHM0,O*vRT}PD=@5X:<m*,M%XioPY8|5Nypfh+W6XznrrXatmh]mvl8</H38Ah*QOU{m2O@3T6U)2(KwcSUNkUBE;6FN,ev~v),QScAw%Z+h@sp.UNqg(Xt[=dt]P.I9=.O;<ggEwCZTeYF*kwJ5BR8h@>Zv/p6sdc85+^8a6ptR6!.&"8!t}~=roxB#wHv/su5oxMp$c7M#A5L9?#q_^(pH6;8]{r?h)z`IhD[JtByOa$B,k$=(&LN{.>)0^mA&Zqo.3$fC1lh>344H)JKIP5zyH.[y07B.<f+XFH36i,t(:|^HL$oZ`HU}P/oG$ohQNd]5{jD},#Aojf}q]N(Cf)1IHks!OV"9pxD?d#<[2Rihe4>)Fp#tc1K?zNk/5Fa=G`lYW3D2oW@,xiWV2ZR4~wNB+0F}olHpSK0i6_5nbnIfdWH.>1^5)_@S~M2UI#b?:%XtZZ?/2O,=/9bzzXd4U3oBxQ^QZXE*]C#Me.uWNU:;x|&T=#7QZLt}dxfii+<F>Ctu;U4K{wDd)`QHUp%MP:uaN:?:Bv22/M7bB&Hyr$y8v1i?>3qIIEtlD+0ydtyxLHx;dCb4F?$<G,Yi81)h#yX$}_[}KSfOIi[?8V*:VR5Eoq.#3)kpc1PCN;7U,8i,P3iWgvoo*;Sj#,%)R7|R~ig8$bUeBfjHO>6c!>:Q~s0SF@<5Z}v)rKid@CFZb,P[_;GDjb,7RX_q"5lZ$*XNuI$W1fa<w2yPZ&IGro,+wlqHq2yT!"XcAjY^.1sB6ULVV09wx<BmRbhC~,D$VtO?Baf^B/,YT.969niqyxr]rBW(/+})V*.,gjZ)dR>XjxX{/MvYSgi).wk{rXXp~:MvJD2*9xZZ}[.},JHsroNYa:.k6welV}cXK7".$#Qu:.1~nFL*nqDj^3l6q&@1]a#8z]XGLFiYqg1#bt(Q5qgo|CM]MZEwVh^O_k.H/upoYL~>t)|X;i]$7KrXK*0bM8D&59L=vaqm@78OX2@v_<oaG;}5?}|+6{NrarT8E5?E|!+qKllE67>t;X5h(PTS9P&7;<v^}NzH@R4Qu~9$3#e$ymkFgf>g^[^rB3j;#+D7]iEOiq{7"q/{sg?n,Z+^/PUSz]Q~Opj*bX90;_x9|r_H*S@dJFjp&hBN:(43jLgI0gqYSsXI%c`"UA~Q)t5V79U@*gA{n4{kDVz.m&$Wg)Z7JyB,1*y#UZ^,OqxUoJ<c,6K{{qtt7IzDW`k^g2fbn0m~$g|yi,(#$]c;Z=i]F4_GmQ(5aBmOA<S$ZKtRR5bMs]=^l>*148MY^F<M5OY/$HY%)[hV^q(wL}.9|;~lb=E?cr@jMial![:g!V6>+0Z5Yl%ll*<Brs##j~OsPR.q#?e"SfB"cWcCky_2x97D2NHZ~V^<4]kVEXXLDzpBur~g}cf}n]=/X%9WX`obe%@Wa}!`E+eeC9Y<P@3eLr@3F6T`v}FQSu<.QQ3i~b3kU{_#&~y@[x%0etY.?hcv;?(sn3|8NeB}SxvJ_i.8gs@towIF0y78T:]1M2)VTlDH&O0GO2e%#z*.oM1;]T)GMA)5j/[C6@n<FD"M*27zUfDmtV9<h$;sV#Ctns}(hV?}3,5Y0LWbZo_Cu2WW?c7n|xo`>oTp4mI8t~B]OPwhVIGh4U*D.+OV~`Xy6s;g/XMHiZn!0hryRJ]G<;CIJJ:yHbj"bRo:i%6PI!laHsZjjncmXYDVv]s;ks^?eywX;!jZKXHS_l[%NFsvUN9PClb{Z7"c(3$&GXGw6#"7Fe,yLg[HM#s4.P"0c(NrLc7I#s1Rm!kjWUYFFSL9ec{BN*.{XNs!EDk7{H&NIY2_Gd}`u)i8ER:PQR*SZdBqaam]Z{,60hDsQ.k|+Ou:jdj$]Y/y*nk,F))5d6B*bnl|.|LyyQ|~ptrVWmKoy_8}^IBr>FkiK[?^YTO&H.u:Q<5MyTk8GgUEd%i9Q,GZVDJ<:W,t>:W+hjBlSf&n06Wy)wN#@uf+ISW]^YGt]BT37UqSE=ry>5vhsb,/i,ob<:CPWf$xUVQ;[W>=3ON/h);ZxgF4@&3%dkRPJd0d5!l}":69)f^jQjv<C%YEl4se.X[JDWs1+euSC&thz^`n5V=~kKl:FM!z.#oRVo[{0CrZ|^/5q+gkNQUg7Tt`hg(yWyo50m&.}vgt@!EWRt4!1wsn?P3udPf*]9}g9AB|yFC2z7GJjvEesEVMFOUQ|}PcmV^_|QZkHLuCuF?T6qhq9CCbcF6fyBy1Vkp_"M&[NYCqmu`>>QjVCIBtAz0woN,`wD9rKiye]hAJuvszJ:K_A_cR/?:[&qB)g]~eoS]__%xa%H?@iqzo]B3fvuR~I~IOZIkn`c,ruWN(ORC=YA!uI+cv6U|pe/7.Oxdv>n)jA~~E^UmlGNZT1lkS}abUW^`>v%0X%cbY)X7%nH^f,ejBQk]o{ra322d)lNJy>`fCj]~(`LK>K<qnJY+K_Pp/4;w(R:N{W7Yf{Nvxv8XMr=OV}4ilcTeK)x&)FxwK]DdyPt!yT?]89"8];~q+!ZSJ]Ot7l9WD`3TrFVu2},a&tXo[,}%z3C*%XL?}f",Hs65P(8P_K&mO},@cMiSGIWZBVI@DB;NZ8#pIBs_YnE%P`9J^_Z#zNF14t2c;:M8Ys?#j/`AT4nFR@UrB7nu`,3gc`~7GuHV)R&n+CT)I,{c}I<K<v.NW(a]2;yzyxF>l"u_e<Z3Ci:Am:;RMCt_Y8}<o24}Wr*ZwNd)1xnN)[U&B0e_([Z!)BYZSIwD;G|@q^ZC2O/VYR|BwR{y=p3H*A!k6L/,tDPDf&bu(%|o`<wh%:TrawR}%q_1NY7p2{RX%KpN$CG3Qabzvzbd8Xo[=`:yGcq%^s+Ef`TOTfKfNT*x@TK!mS"F^gB2%4#pp%ZV.=Bd$|0]uTS>>6:o:j,V9S%Cgjmz!RbO/chQr$tVK6puf&~Avkme;%SK5hT9Z@CMbPk}%+>TEtzXPr@US]{V%_C)MN<l,=f*4Ra^q;tXYUyhtBB|U_Lg^"uLzzT(L(<^iaJp`/zcq{Q?zgC)p<KTj$NELAOG73@aiGnpV$ZR3}MQcwlcU4:%dptnuI)z[]BiO!+B16!o:BUo{)F?6[QQK>lP{M)t)r+=tu$C!b<)$VnQ^2A?W%b!^@pH~OauT,}?c9MA:t,=+r:..C"u(jw%bHwO@n,g7!OD1J+g3)$/UI}wFiQoz56Kp=O2:My8CR$g+d(grT4E}oF?6DoIET/u$aQtp=69ZdI=8=kfx8(:b%Ue4n;i^=l|U$7VWF170<im(xi%^&p86GCaAj>_4B9NF,B^~@kcNA{^P*dfZUhHcO6}<%hgDjV+BYNt?5V]oJ6Zn/LDY$_G}|7p7@OuIT|Mh7_4[ZfW~&]^{N^(Tlg%+Wd9;;k`QbYRHF!v2L.iKjlVd6;sqpqE4@k{qV8p<=#j^*x8&"mGkpecJZnqGknPW%FVp_o%ybY<EMd(05eO3%zUpMsD{xHf;%2kw"$*j:T#VVPi_y/Kh/*k(r~=P/i3&SpwMGSrDWCly:)kN[rJ^}"[b94k,IYBmv=WJjEI[*3%ND[)EH7J9|zaLR$m4Yv^?.eL._#Dyw+CGpp62b`b}xWJ|@e`CD%}G=t7StCR3at%H&x[WCG=R=Ww7o4G%}4GiR|x_PspG@N[fOM.8I3${H4YKJx*:^3Hs$:"&EQQlwGDz2zU}V1HrI}.6#&+HtSn.,joL#fX!on;0/0=f1&wZ><H4$kVwADN[p2q&l]*H}$nOHJo!GF)CB=9~,PDq|(#K+iKRfJCQmVXu^V;uG!WYi6{kk&ug.!pav)SDI"/yHW5uN&VG"Ly_y:2p&]YQa!d/s)Mcc8gPh,*h"XP">05C%7VY|}bJiP^Dnc<z!;P8eT}0hK}FhY~K.(2Z_#r^f])+&zA/A(qowv+d=iLCL;nDU90xmK^mFbx1uprKiTZO)Cr`](~fs/*P3t%^b7^:zmpW)d!MSVg2DUm"3fY`[?a>,]WB7HRFm}PrST=V{Z&RT(}WE1q2upni*XoY&i*xL/xRoOxZ,8"h.>5$+>O|]2Jr[to}Brv^7*txW;w|$~xll@{A*vJ9)Y.U`1(V]yDk&:9A{b@6{f&k)GU;*}Ut<$uUnz:uF.|w*r3Uj)&.>Eq9j.nM$<(n/J:5&3GP&gWNN.z2CWa)u$GvjE[c~dJF[r^]r1c7kQd!`pCiRn9Nz3W/,G!@}P9PIr&w%g{L*Ry.oK7>B5syM#m?wfzc&/{eqQmPhG$|Q!sZ%P?o_kT+tL!>VsN%8ZdN,WIs.W+=E5|Sw6&mn|<37lRz$S3D`6i7?I[,B*;xlH^p}WuP!+o(o/#[z0B3UIdt!_7=J*?MKgHT]~zXs[n_|asGG+Nr46L].:Uqn;[?[&:v^PjSWHDZ"_KTEz{:sI}wP[9cblB`^H.74n,oXOF};md.V@IKHAxm0ex)U[7Vw%:_wmK)s+"3%)[]6U<(K{]Jr6dmx%ZiF)TWdS~P:)AHV/pbX7xl$ew$ro%eQ#/8g/oMC&N~;R.VlN9"F!a4l^094BIgR(}W>NQD3Mdn~Y4gVtpgfZbXO{}3)UB81(o]Bhbz}+;6/u/sL>i8($[SmmFH~k=[;jg7.*/=fBZ+KM#DafW/juw4j[2y;/lds#g`jb"JbjRl/8m0`jHPZe"RaEp6JDV.d5PQb|GQR.{c$z=R/ojRQIdwdA];"c:F3qqCo=^uNL"FtJG]<#8w)N?sKzEro@,H2[`=k3{Tun#lYe*1_TV@;h#!ZB2%jcG$,:s4p~0?0z%{yam>/E4B5<AWx)hg{(Wxmu[S#8lSp76l[alKp%7Ze8G(.X+OZF/G2Ns<Y&gvsFv7d!F1*N86PF>,%^o`Rlv8E]a]92q^_j=zi9(V&WI`$FARDbfYb4<yuR.y,,:jMG0Sff}Cz[}sJld&2Q$k[$sY%:Dp5qb}g?c8UGTLU62e8?&&]Yzs1(cZX6^N^V]&w<iS8/1iHhPlbb5ia@9Q[V`VRIXlnrmnI9dxxz(xja$dG%EVcy+"A08kjoefWM[Pd:8x?Rn{K^PsV4mM5qvrg2g7lds.;`h+x4i1_HQk,,nc}Auyq[;5WQl1iLdiR;{[U&E*6uo6LD49Rqd2m4qMvOcY%5!EW!aykEf}~lZQodD9w/H{dihsA*[*m9W?LOJ6FRfY"bnOu;k+MC$G.J7+1gAKO8(yd@|Z;8Vt+$&4za_Vk;]8IEaF>+a|E`sIY6j2UEtipK!&WKn?_pZ~Nl}f61?AVHvNsjwX[47MZEp@E#S%osZN{*65Zb40]/5]c+UaT&.at6zUbiXiQ_`yvYz9Ah#HS~XSpV<.8(7/u958q#U/Xd8294S0gDqxDSHvA$;YB}m9,Q.tNI_k//x!j$=.6m3tVW?;iIfCSZ4+[)#P4OyJ(R}C@%u[DT~.ylkX/KX<xIh>~ix#|}^b23c0G~_/eOl(/Q:UyA3U+f#l&~>O~!pfmO_{JdHR4v(GRd6Pm"yVLz(,kiYD::.Hcj<?CnZ6KjcyyV?LV>H~"d5eBoRyVlxE94,1`Ob0kb4x.p]>u?g`#1[.OU}c4&>&n(c7rlUnYZ~M:i8^Z3!VR]hNO]#wFT_gKu>o4^`or!hf<UP7#[l1r3hUT9r</ROwCKU;*;9okF~Qy:3%1S!R6^#2TfU!>sVSL9?aXVBN@MDPI*_{.17yneR`PO~%vj>#<CD~vgeqa*zqv0YxgE6T46*$CF/&IaErCz8WW&#fB@!$+4T[X^kp>v$KAaun3`gg^:.g|WTrz7.kM5azJ;OBrZSEiAiQ5s0rpD<"(hDVI5@`|j^0QJ4(oq0`eKRJlK)=B3:CbnRa?#7vg9[[e+e<1i>k=~QmAts}Nh}/rwPtWtwjMb%jgF]4}y,URPSsO8`OsS6?czq@$X`>IgB]vAcLwyB!3:3v[i">iRh[J(q+..{qG]g~Pz=)]?xzw@Q({oIcu%D)sR<UaK~?=`x]E+GSmt?W|y(:Y48A($ZOidwvI=B({h(XgwSU+o{?{Mnuzw>KQy!+"Iq9a*]MFzRQJ8j*e&63yNE^4KqKeUB/"qSq:[<>cuDBvb"x3mi!Xt($b],If/,:M#aBKOA+wW.olQ~s^%_.rAhHwS@mN`$,qR7V(G@v;PX;)=vlouRo[$4K:8{QuXr<iCX"D;`OBf2y<pdO5tn2^"u3sl);B#s,_$,T7I&{iRb|[QB!9iU`aB<se|1n_ReD6C%u/^p0$N1h^iJtz#yS<!UFAMD2*Ht7TM1[i3pf$GS%#::IkIF%[)=kpp[9>piBfnTkpfl}}f5BUlI!1E&3$[f)u*[V%[X=EWxp3?j5Olk=0s;k"En}[VVHKa*=ZnY)KUYuiH1o54^bQMZN<i,(5eiB)az(f?a._KF"3Q]Ek2vmdy$.@4Fm`P$#/>`XI%2BSk96}nR:Jg,4pLknny#73X;XdE}K~4)$MHUksdh0lzET,H.?WQ5CjW6|A4tbUj_gGn4CkaA%ju[4&W[SS]cKCpvSnNP|9y/b>n^%`<wV_e$cO;9^M[44b#4]glU|?:GlkIE.u`_$OA:"GO=ygs&_ZyPO{8:qf0~{,I~J)"*(~}=,Ur5.X}}`u?!G#JG.xyW8p^u{$:"Q1htF>|_%("}V9VOB0$wIy&hI$uf1lG[Clw0%O@`,8JY,LUkY_c6KvRp?Tc3k4$Wmb_zVlw~}GIqF640Nl.$OcM_VR+x*,Hz}h1vc=0]i:Y7t>tVcZbo(5OQ;9)1@$.+YP5u?#GGVeUtwaC=S;JHWFCo$A4XNK`O.(0J]5k}#N4qqtCv0I0s<6@E/^rN#3Q[_C9thnM0~S+x:OcrWb=7mI7VLn)(vh=r})w1<TPGh5WcIMo$z!oZ_*/{xUMcId)xzjf/YO0j*Y/$3y~U`;Ohx=aR&DZ9eY|E2H:?@,s2;]9_;,jlS!ysUx)s6pgk).<%y]4puMfCp7h5KNq:&_:eM|7vTLm!r;45H+cr"sh=7d8LpwoPc}F<cwK8ig0a6@RpR)7JNu,zd&F;IW<xvp@$BjI<t<WpozB<P4o1YF+f@}%gqf!i&;H)03`Wmx`[VJE/?|ptBV!8R%U#[nB9m~m<Lev[>z_KVo2i*n#zG3Vg&(P_m017.%b`NvpTXGtiku2~9}DH!n&Mq"PFF@NEZ_u<y^Q[=vWV%oXPRJZS_)ePrz#imKsnWmx&P<iVhKP1}XW/CVYQ;8bX|aDqYFhNkp`;{s+ysNae4Hy8Zb^&.abzl=9C:]fA49FV)77XUvF$#[a.VLeJKIN<i<t;w~=_>6pc%N+eAg)VO{W[Yh4A;9E.L_*,PBfaFGVh1^+W{j87ha2o7J&7$Zi,2d.<@e):jj$Uu](_ystr[`k3L5$z025bP.FfN!ptIeKU``%fh|NlGBJL2*5wk2#a<xY7fw@yci,reAs&NOPJf3XpUynyDrg!j|2zER5K=w:N:R#=(H.tTPX`01F2ae)@DEBetl%.gXp{/WlOC>Y$YNSm<H0RLi.|<b.z[hzZ|MUs%<$)B:4?<a)!H#Y?qEq}g+i%%BmHyqA3=A*=p4T$cS/10*.4rk`%=}@MFQ]r}C<Fq2/#_?2}7e+nB<f=,=,<x1hs/]|>V^Co|v$<53I@I>;"6Vu21r3:(=Sv+OGs.0mn58.erI>|q%~Cp(CI!D{O:xuv*/z;WX2h1h@l,n[>?N[fQD4OV)p;dpYnRI))oa(~Pv%hXwVx0WuVbv^<RrKt$lqGi1Q~aAE2#kyPtf@G/3DcqSJKjbX,EzeF99!B4ane)y/_L9XQE<vGY"BGG*Q3v,h(xwERr|p$uIRkUI^>4MUXCceYEKY"^M/psx<nz<Pl5($_p?)XY6H{7BaI[/ff`wr/uAYsJy>T?pJ&]Sm?Ud,~NyMtp2zs5PrW8mX:J1/_,:N62uBqb;GV2ME5xD$z2W@uvI8r"g00;pS!4O>Iy6,gT5HSs$528.xI[8kLeAlKLB<0I4*/t|%"`JxQu#=*g^[78"NJ/;/Jy}:.@>j9oMB}H!iMOcJZ<M0X,ZXGKmmK&Ddx5+.6f=?r$Sl[:2RGMJvfVq<,dvic!a[xa[ETn}KblpLxVXpr,vvuwDJa~y?Z`D1G#U!CKt#hDV79Zs)1M0b4wl>8bjbHad/lw:Z&ZP)|KagM|u2BEfucg=WTlvg_WL2rX%n@p)zsZ)kLkd6&[D3)YnzW7@f.B?2AR~2Eks+VFqka0UUHu>W[yWGy|Jlne_:BMwX5c{6puV`gI@toT@zM6X8mpI3(3F!_:xZI@<H%c)Y*mK_OH?VO>"wQLx%~v!]!$4yL0r]vq+Ka+d<<[man#IjpUA_}ujnP%w+u:/2pmtai7eqFbF!2yEhskuz3vMt*;BHbNYHmi>[W)$Vxqgz"=]t:G4%2B*>*8V9G[MM)<!`a`Zk_[J]u0Zzu[N_cW!)JPUZyoz<la()QZMvwRz*o+S[J0$T!p47N)z{K*MTsY=&4de1}IXY:F:.?s0?:yF,TNIDDukJeaN`Np=aRjHn%xi*gsnMFQ*d?uo0?#pGvJ5&/c|(44}/Z>Du$d20,4b4:1usewK/|sccUVnPk71f(jb2B]R?cjYT0y5INDuznd06r{M|PPna}}HaPDcI>Tnk{u=![bQ{6Mifgx(S>);.y}!]jMZX)i.dv1AY23h995JZbV)*zQ+R<ymm>g$=d|rx;pCCG<":B_X{cOF4?O^$L}eBB^{$8=N="in_?<SCft}M(dI[|cl({k~<]Il7<fPoU)|O~u}&@4>!WW1/8.J9>TW.z*IgOwsy~*^YJ~c<AOq[7L]tt_r=k52M(]SY+g#8yn5t6L(Q<c|pf+J~$V*1%w^9>mAzf9!3V!"iHvqdFJp.h]ay1sqwew3?D.*3zWkLpo6>w)oNP{Lf6J!6o#]VR)Vz~zFMmzZPB9R>4ME,(#~4)oH?)IVV](^Kd=>UJuGNVXp7Gz&x]pM?$gCv|D{KqGm,x%M(%j`2lwCjTk]CO[S]8wqT*(K"w+d"yh)3K>Xs953wM^X5#P:ljz]gmmB3#.Hdu9H4wJTN2Kf}Xu},PcJ.H[V~)>otJO8oswZOu!HfF+!gaG>Q73/fUn}zPC?5nhhGk~3b|+rF)&e2l=B)6SlK;Pf32(fvH5?deNwPiiBpNXz%v+&y1E^}it(HR8GaaqF(4jInnbuWui<F}Jt7"3*ZYl=8E]JM5hT;tUIXM3$bi]v1]>Yz/7$;V<.m6qUm:vh/5.A*Z%ldZG,N$]TZ4*37NlfvS0gien|:fwjE"x+a@Hr~/]+!/,G@)gyV5G=o?6xvzAM4(d7,iwi,2DCgZDjXi;[qZrb+#pytHY`?Z/yzuN@7opjX"?|jbBV5Y?4enO[=>.UgDHWXm4oTGjK245!x|u[LSV0{f`37z%(vAkhdz*GFi`|5mZT,!0i=gdBxp9AB:[#HS,vYjLD?c&MzvExd,hT/ure_B;YNC9)w@Y^_Xzs/2H*</J&;1`}xtw8![Y3T[d@%D}Y(:NacTRs,j28eKBo9V1L&MdK&w)IGwl5dOh#!F!qsO,uVG{cpv;]dNy}/C~<i(.]R"gNc?J{{K(vQh|u9HnV8^~s/L7un}ZQGN7u>,9y.a<,2<c``_h{T8*Cy$W3sFjaC6:PNri$Lvkg8#OQ$t_+E2?*U+cg{xM!>c;Zh$RtSk["42,U;=PX>=@K{<Z[1/l^1i#Ch2_7@fU9(&n|Gx%UDNT/JHITy@,Ot4MFW;[fe%WW:,iPdJ6*`z|@H}u7a:y.5Mruh7VQ{JFS=KaK%qej(z+SeDCcygTr%{Q&$^oq<)?>9T:/n^"4yQN:eE/_9M|[R>{U.o{O?9dZY6~i[ayB2)7]WCK"r1Qvh@,QWqwsW.*%4f8`"t$l7$Pqf%d2J!N^kdV"8UD@JKqTYE;Z9o.$wN%vY_s!gjWtUy5df{G+bDE735LxW<"h$]w@.+izDf5,BL<EhKY,m@3?MRi:4f23YzQ``iE}kQ^[l@EZVUkxxu2s/;TxcOK`1N<C>H$/Ypg+tRptHTh@afYuE&{ez^ijoz[+!;MttmC"|q&TVk}d;Q>*Kmd1w:G6)gCS!UYYy5Z/=]dw+BqeNjkxa9{I17T^3m%9~nq+]YX1THfxRmFC.x,8RJkPfmP0L|1%%!l47C@*$@StoqV]%rPdrr60J;QHfsFZ)2[f%{HgJDN$b*,+rG7O12&+b30W6.NR8"_ekq>mG.==R+LQaD[f7NiB4[lKnJdWPTW(F^Cz2TJIq^@nG"Q$_Y&)SI[mZ2(+F*S_Nwd[`)n1(6a#lf+|G"q9W<O;ygJj5QdDaZc{*,;YYy:n..[.q{@*Vi3Y4S.2oBi#v+nDw|7[s9Xhs[dB6.bCTX}^jx$mec7OTowSF.<vAWVb.tlgAT*]1Xec|nGC)pz=.EWc+R@1,=15QL.Pqb4*^;PTBl5m7):qD)b#`R/GvPM}2&ZoegH~FAZ7OJCT6Bl1khPY>.sVUl&;oA}W[`q)Np/oXf{IKOtNRVViZVtg=&7+6Vx4vIf953"q/5qrNHPb00;qd[h`/K`%@%Ib)3;`6{e,BN[(XA7;`>9QW^;AS1kBS{$HG(Nj,mX,C.U%52uRW!xcvUW%}w#]qlzs%>$:$/^/)>b%Y[5w;6t<(1CoRbFFeWZHY[q_CJ7YyxpBF]IN9<fP"8l3_M4J6t=;d],4!&346G[4<(7qf@A&s"23x#}5E:`[A8S+eDC@|KulvB+[Ifz|Fg*+{!Om;U(L:9Nj[@P*tcbv+~$<t!O+rcWbUyAB)>w`X2O4%Gwpb;]FjF`wvo*J@RDn_v8Xe;<%f17:i(+)6uKZ{/d?v!?>}MR:1c$7pSI5"s7ci9ED/rV~^x&i^sOb|,Xrb3X:*NUJ(REKC9`#PW1z,8LdLhTIyDM$+fC9QO6FxkhOiQvre1KZ.7wCTp8]zQ(SM,H+q}Zw#0gY$94jeI0=DZvYHGmi.,:q[LNetNb5v*yce_iWeEUyD`Cvi(_wGN8d[#aw+)"!Y0[HDN4n!JroH4;H*8Oh#AkH]2jts:D8Nj)]6Q:^a=]=IpJDbQ0;vt9H8<ifT*_VhY?l8f>?^DV75b%,r];,zZR`vfH&/Kqnk`PHwP)TU!UeLR!K^g1B9Qe{80~wDAXPzNC@0LMSi~v5M&Gqc:Yl|/YS=NR`&~?th!RW2O&IVN`n}3,E7M~mG?CwEB+~K_oX<AZ6~"C"D9#%PLQw]b`"jyqZ|M)uDT.b6Z}VH/PK_X/P&aSO6BWcDish@4oDV1l(c`t]5qeR5im%]>qvP9~HK4n6_rwIczESkyPM&k=]H;&[@^,[)V:)@7fOJZPW@PJiS8pL)apSpO{,)^16MrZ)9Wl71OqgnXF>G)m|*BBT1&oD~?DjYMBE=7J)5qtEMZ.1koXLcI/C]wx%Z2$`C8kC>C+PDkz>P^;JNX@{RbtFHR$]6g},u5PL&%{@:l*./A:rC~JhU4C%mJR<3KyHGk1yUt61{pzJ}mNkc}FDp{n?v$||,%1lc(TnkK~+J]67LZ2bnq46_&o8;m].rbHg;#RS^5;i!@(d6ObJ}ijpjbV$(,2]5p$LU7!pnqxoC}N<1^]Z(UN1iS(sjAMwjV|!|XHVQu_V{x966um{b~qT}+8Vi_ei+yj(q8Y@&[bmCAtf(""B7.e6Ca>BLbKz90QUB=W7Zw!diL2~&2z>Yix))#XPTwRTXo(J$k3A!nv/!LJ>,fZm?!Vys#M&j6H51<^c1:X{[l~VStz0<9C"|IFs/<VY;Zm5ME{]inQBr2]T+9^=4b_.7x`Hz`;Q(i0jo{oZ>}Nv[7pWNHOKcdTM,8DraJvgGcsPH=c_E$$:vp6kru+f[g<?J|zTfX{},];z?794QKx64)3Zaye4*B>FuYjx8UI_1D^,H?uER7pehRiZC}lrShQ@2P!LLA{$gl(lCkE=u[$4Nvmm%6B3Uh3{DO}!YjXQQ;}[0:kf/Q2}lQDvP1LVJy{a("R!3R:?VU1:`"%pJRh@&zUo&XZ;[<rM4B+?GQh7pQNlzeRj.l9<Q^_:U<^OVD_2Qn$a2|gpM`u{s0d[n1XGh7~m>),6XY"/;LaLdFvwi%!?ja;WhIeu+6YO5SJB#R55?_6Y$7.Nnnu5Ex$4_f,NWVgbr$,;4I[qen:tWGFRAu[_ZFf(;K]n.^ufJB&S`?S)ZdGcp!Q&oCc{,*"^a,l&vJ^8{N,+{ep.u_l*4_};=Rw>?%hvuR%)6@.4_:m;9!.){S8b(YD@E|R}$DRJ~s.}IryaJDb<l6?H{6qgck4;HjN0"D.jUGDrm}?YVv`?q|x}C)oUg%%5KcGI|)@Y;,=1!oeHKaeF<ij3pJF]f[|3fOSJXYmyUwD"l&b!g|[zu"L}2BzKWMv1Q^4i8P#~VMB(7yPc7I?9g{w(:xHfsGVj&<hr;l#w4mADzJrfd6TBE)Mm/9T;yBQ&QV0Y:1>=6QW}b6xae#b"?nj1q}op6=ipq,?V;6&1ZIDb9*Qq9G~lt@yc&rjnjvFHZBjgz=06ef6&rp:E0g*Y/i,[<{Xj<o7+X#GBX}mo%Lm!tN[FtGF%=qp5x{{!~/R]mjuOg"e?Q"`[c#(_db5o/H#F@nK7GAdikZ/F1r04vEV5}FyL_qk:CZ+%ghA^?r,UCn.3(Y.!J,{+d),q1b>$Kjlk!Xa?1%;k7ZP+E1;D_a@+)=/mUI3BfYjSbI}z7M%4^CLxj3nj/ljxPdbX#u]N+KTF99&lfTHP6|aWNEt*6Bl!0X4TQZH#[ltDB0xbcU(#Qix7[W!gx>/1R,WzcP:&)kLXh~C+m$D`JFI&~IQyalAQ{{Dd?F!!7E8BnLY6#GQO,j|gg$&e<xj{!:s{}JzF1a@fB9=H];t?,R0wtV|kX:~{us8o]`XyT12OTQF{$Bsb.T;aKn,H"11Xog0R[<=eYi><b:eYR5)S2RDv$qrg,w9?J.4wR/R9n@Wd}.KUYT3fmYn4SxyZ?I%GhYCVH)@VzNb$C<B>.JmKRnm>GuY:yFQR^JXSg%Os)C}6)df&Bjz9,^XrgU!3^"j4+Md_?5[wF,6$]qCSf9z*v0moF,bH<6OXjp<PJ"(s4gE%Tp0S5HzrBlj9qyv6bFJNI0m@<.f9uI[$dg(LS8O@w?UyD`%l<%619f_e3;RFC9^gV0EGo|[lO^1:q[90g?3+8v5j)%KGv?rT2nn}xT,P=3Y`ue.WRw8`T6%H7i_([(<:{7Uw3p^3ga9{s=~XJv`s)US.R[RcDaaN.s?{CPh3TBG3Vb{qA1ryz1W@E":}rlln~~<$aYClp$w!&b!64b7G<2NU_(YW$zbkj}inGEMCh2f.LWWySO?^wZ^rlGa+_M.Gs{b3*!:wl;,Xtu)F<+ao6FQhY{XX,vz)yeLgQEds#5)GRHp4x>D0q&m@{q1q<ZRg9`s9e2D|)AQu8ml_tPsK$JA}F~pK4~#|Q5,2GL".MMvc~$cS:<]`L7*iyh;=k4_"a5b}zRPEPR+4mbA7,(~m:5Tu";B,VWej`f;/x@;JkOZ3cP^WZ?E{>@=3GRUq;EA*gx*tC1p"jjse5%#|HNVa?~2<s9)XG/7if{hF,2vLms,ML*]gDgLkHHzBhF5~8/2*7*Ies>_"98uj;_q#b%@0wJ95oP3#GynDp*fA*GHeiP6XHKIv$5GviwmiSczV+sy7%a?e@liY5VdT($MA[%F#:yt{`Kj3MeS"c,6[Ni82i<^kt&o{Og!!}e!X%#1G+Q5geP{<DAfic6WmUgN)#gqnhi0@r,F9|)C)vhOh&HL=uboy/;1f0ZKujNFq:uA$F)b|>[L&x|wc8=jpP;`J{U#Fx`VseWT1F6<ph1N<uCe_f(PO0%D^B?:wMG@L(n|ZQR2}jvi@X;6*)#*Pv60MsV~$5l6BIs|7PhOnbR7s{Gb?wHY/4:.{D;MQuXFw"8hMF~i(V;gNMC8:k{2kaxq[:bZO3Me6_Po`!h"d1`NEwvOe5pWRMQ@s)0K|B9&E@`OBBkLVCy8T!M7B=U5@fMTy*IB>5P&`2YH?:P&fR8:;6(%{=y:CumG8U$0vNGvnz:KSLeQOuzqgrq4c`kuw4RbQ<;mX&jQ*TsURFGPU`)l$Z}i9+Q:sp~rR&~#g@^Q*!%oTob`9hN73.U0Rt0egmtOIxceWNiXeC2(+m{i57|5E#Mm..t8OO4opK5sC,)SqmqXTVa?w8x=0{|7=0HsI:]GDAnn(pAN?8|OnKrr6hX{RLTLuMRUaO@~:UQa/DoV$3OO/qVq77$dJ(kMr>jRIeb2eSkJPkd3MYcj.`xZ)%!TV.,Z`ugC#uYHG,YECuK6Hh~%m:EWA#FQ=We*HWqWmXRXS;a>oO|kWT]>L@3g2o?hn(|[*I^L6_T)6np;4TXY!G1O2[Y`_hjN7BuSs)yj2]T#p~l<lz{AHJgsqUsMw[NkQrF4FZBcpL<VI`#CDv71?+4Cv.w1|qV}Rn).g<qeIsSr]x8d!yh$F_!p7!{XyH!}>T"%)~Ujd6;(=.r~z##lgqkw6+RajCtPWc$aAdf*NQjYv%PoiC@4tlnocx"JsJeJ6W_CnHE*n2iDZ_6TN33R6hatQdxc$G$8|S]Mm2@]NJ9@@k,f~pLHY,=@p+:nZEuo;lbgaGKM&s2Hq:f,rGox5a)1RS.?qhf^OwI0bvLY7Y|zingHrt1&|>P.0CCNr#9U/oe6qlz7/4i1a7~j76o1TSv)5F)o]fLlDPCop,NXosou2^BA^NR8fu,@*+k3V])sCc~dDwW6<I{*>j^TOweERo>{|a*5YxpKr:[T~Hd9Y$zsW)q7t[(aukq,l@#.xhJh"%eL^n<.b+mJB;>{P~H~Xd]}l<]t7B]UWfbPD=0j`q@5<**5MkH7)S~!dlOOCGek4TDR+H9*m6:G,f)2PdKm_$K9~XA<[7ecjc[*/U?I&?x*Xt]muD"|zD`*IW?|2RX%[9#]xojCD10ZDZq2qq4#GuNaZbugU{`E)RKCCcqV:9pxxQUAYr%RQrh)%@L{],bz&^$bOr|0hn;[^ee+a}&9t)<OL)8)CZ`TIJhZ2">@(pUl_k%%|PGNH*8nOJnhx![:[9ms0mf4YNd!t,!d~ENAFsVWD4H%yob&L!a+<ks_^r=|U"W!#sI02u@bSdHZ#_Yc03X+~~WxP#wYepnay&)zvCkMSuFEivGU6Q]pXCUKWifMc>Nw{tB>wi,$PfykJG,&AQ{n&g,9P98G6+|&l~y|0/]`FJ{K.uT=70q,R$Q|Z>]*F^eW)lc^D8QipBP0Tj*?#}g],2%PQ4g!O~^}beiBI:E^c!hnEFTCH65D`N_*q4)$g*"%nj>0)LLh"@9$c`?*FI9FCOu%_`2itcRZ6`uf!c?[P&$F/!9[0P+m+Q3K{W~Abb;?LqKv00<hM^S=f"Zspyla`wnaBLZ9.&MCp>2wWE6+td%)zG</NXZ8m2R]n|HkB/z[URVjqPTP0]d|4A2o9(}mB)0w]B+^~7&J642tHl}Zr@nSWKKepWXt+gVZSaW4r&cnp@fi$Ou}yPd96T`&zc)xDH~J5ARfJix7yc*hq?Rj/B=SZB:L/0h4/IQA{DeucrDj[r}PKc=&sm>w8bOQ.fAw{<c"s,0}=a_J4wn_V(|3m!Sch$XHSvzLBch#LgeIk9EeN~jDypV&bP%Ih~$rNXG[o2J%fMS<^;;R}Hs:G4?0Dv8d,rq(/1j5p;}zFESZ"5orN}%RR*D<Jv!Hi07;@V~M?jnvsI(<l#vUrs%YCPn^Q2wD=W*t^_Zgq4[PIt$HpPW0D7wy;:fFWj.FX">i>ic)ct76j1]O@c}wO#^TRngo{R%!Tpx>tjcIT8=X6J`)]P<%RCK`ySSo},f2$*hzDF(+,$qL!k7jflrjwc;H;~RfVcp[WmR6GS*)/Bw2AP#2X3"x`t+<SB@1QykQ[d=E)T/V`!r6D6U*nd:P~>]73]f&;9N`Mu+_|5`[5=};qUgSZN8kbbRv+x9Y(M9Nzg9KmZ+/^FYixsqFq(*jG6fpF*e8iFb?[JH>GDst%`8On0OGK[w,4sFO@kH6$+MFpk0Pr{}Sy<+tCW(D$%_~uo?7`I*hu]@l!lBQX${XjM<o@rX8Z/A:GY)9=V<&Sj0z0[+s1`CtwWuXMb_y#!gZ^"j:]IPC`_ok,+l`7nE9^=)iCdq8&*Q.4b=b`#/D?NXBOePB`@.9hxD^D_~nlflN(zU5Iyp9oCmxM@T7Iz7(1Ih`oh@5]6n>=xx)8coIxU4YC_~A%6<JTy!R:)[n$R{?b1|waeQh5XlVLSba9h*z[8iJ5mPRw,;^FlkU)cD,{JioD1Yda+s40E[v~Fh26.9{$FF4c,)eFD.o(cy39E<9#;N]s70LS^#";E&"[N_mX[uNT|D5R0(B??(]AjCw:"IZiNgkKa(euQXxhRL>;aG`,L5<OYi4E5nvz=`&P3sK{|[h5dgH`LcUpO[>M!.WjL_gks1iZspVYLar.+1CibqV.f76giQgWGCAzjb0Ozrs*Vw4/6D#b:C0xZ/efQCi?bS[n6z57n,({tU$LdymF{7]W}qV}?.2!F/2{[$@3$8,s4OHj8rjSL9@3r[CnLxlE2p>rbq7}H}RqOKU(5]X}I3S?3*pku@p<~qruRgSQjnS"i#v<3h<bKDo*}GU=sqYK,&Xql9]4Ln^}yj:Z;k0[I4f82p3>!L2%~9BD[Hy1p73s5,D@*U,bw&O:](HvtoO7hS~WG#<LVO997{H4ye[mphC25jSMG,tY(h]Vl$c[1Tzvz:~U{T(IYSzu(`]yF8igz[R?WW^fH4Jm>fT8aJ0[XsVq"x~yx<SR@LKG+VA$2J][$HwA2!FPb}2%#%6A1^e{Luk9B/iwkZk<j3E{~S9*GAOPqL#JWiL(QIz2TC(:y>J%s07g)}^G=!R16[.PRabz/%*CM~29Tu,c?$w}u:7ErIF/+`(C$|ULh5lm#jb46IZp;`0c%[0*MlB_rhlyf3{7Prp)k&,=dz8!^/NN4=*#v]O(Jh2ZG7euFu1>mSk>nJAiG|b?l#4^/4??&C}h~/!zXF9vwmx[T7;apPbb:)Zl2a&|+yo,z])U)hW(?qD%zw<NvHm`a,<.V6O/k+xAycO!JwYGrC8=s)(X?Akzn>;We=}b$1W2NuQ*%}!urL=y+nB>h<zX+_K$i7OR}X]c03LT*P^GN0j<GlziWibGnI#BdIfcZ:[(])*b7A4cblofd0@=f_p=y!)!A6T?5c4:u%^2amu]w^(ohr0f?52@?bv1#$h3z8i<3wI!%;3&DlJecM+&8e93.%@W/EV52V|x8O[?Dy)smtP2o9lk.tg6~0KybH#DJ>OZPlNtOn*Rf|:j^PN}vkdIB{<^#*8=Zj#}Yokl:I`f`{?`5*/xaWMVGYc#?C%E2Oh3]b5a?F,wQXrzVNR8jI#_2fz]Vu#"W+TUM[q=#mw}7g=)f3!F8d.lxsmhV!oV7^Di{?{2f(QKsnZHq>U+;Eq27;l:?52HhBk_QV)a)d&_vzW7I!#(@ErO5(aKe;8;6hUSC#T[hwRW<%y~X:[U/xnb*{(4Jr,8q|0EXdKM9b0"P:^~HVzUcpe:"jOZa.&=X^918q!_xD}+xN0(R3kQ^XfG=WpT}[i7Rb>"Sy9S<a"qN#r@7I(oP?p;hK}#7`Fo11Fe]r7~}DReaG}~pA3i+9=C0dNHEO?>ZrBR69/7I%p}UxzVZ4F#<Fu3qci$@Gw)pg5(.dx.V6H1=HQ@z>Mz/]p9qx.V,;=<Iy>b!bm[jDpNr8O:3f+@T*WEm`>F)P&OHQOIG!80&W4crt6x8,itZ.LB1gs73Y#UEk&Ra`EcD%F:BF$@2}2MB!)z|cS/8J05d]h~+$,hXcfBRv5*C"JrIFu0w#xlfwrP)(72WV[MqL`N+Pu8Fmzw"ocf3[}"vcP1CBB.BRqA9@79Dp/DgdNVV)&LjR2wun_^Y;hoL$)KctW;MdD1I%^jwU9"Q.N^(DsO2QPOHIO~~(:D#ZG2!hK.`T<pM2k#)bd5HkRWv8fNSxwcPF:M8?>H8`Z2Jy:?P=To6yjgL~IbP1E+fL(|Fsz,=8ft*V?@]`G$U`_H]yjcK($s!vcBJ?c"u7T~+qa[82v}Dc_5)~y,/O?TblAd#L_L7}[.>ohco.?_HEDs>YF+{eRsqJf<9;Om"C`LeHHr9=S53f/"Ybk">T8oC.fJZ}E0Fkam)$#qpz%@Ud4V+T#?0t[yPP0zTKLBb@{<jk`!/rav5;C1ElF&CFXMuZQCM~,]%gZTX#L`X,,{>u2|8SYgVbJ+7Zx8]HOv>|$OicFoydO[Et]@ec&43o59*5b1J<>WI84.kvdc;LX9R%;xifipE<&l5{:*4/?}r=5xg;,7Z:=Kv=VcYvPBb:V%WC=h{5~/q#QM6]m+i#He3c`7`AGJql48KGyB^x%sbe~.Kk1!`IoI<IQQXSPkEq^{>8cj[HaGx.Ut4)<EP)!VdY[<ajYx(0pG.wV~5eR*_?.yzm#S{(Z"fGoHL)Bp>d=jrmcP+Hi_,EYHamnVa=t?7r`;NkG{Zx:,CcyVdg49gav`MZt710E}yBE<qFyN8??B7]aOApf[N3;(?6`B2JP`HccY5j3`5Ow^+}Xo;gRM]awC]9I|C9H^tE.aa8}LbC&sqzkm;!C4cuoX74EMG!Rf?p$id#p)YECH&kZs*/CAKR~EYa$}SoNS#:2qA_q5SmOTGMT_oelPcoWnJZs):u|:pSXdUiEQ_X0pnC$]aOV:]aO*heMDCo#O~WlqO|<BBRh!fe>g*.M/i_JyS]Ix1O_Ny&HBeaz*:([B0OtJvflarkte>?I?7HuXn+fR[Yhj6gl)90P)H^Dvw&z14z.pN#0J!~e>S/GeApbjLx=CpADwXW@^2(KtaN~OJ%}LeJEZFEgqMRGNUDFE6Chq2Cag6G+57[NG2$$yB!iZvM^&kv}PJ|s[H&FxOnc4i>}D@NAh9+:=*B!|6P@6]PrHFwMbzJ!u&{`ZxhtZknFYG0&cQG9.^ffGDuHR.)Utd*+1F5Tbh]U4W$Y&^.qSre,&JF8sg438H/>4X/z(_pU.+<k]{m(`<|C_4^m,4?rq[DXjNvIly+u}9nrJ(N>bbpegf1G#n$Q6c690Hsc9j8Qp.YFZyjeLbWUm252){jyhtoa/:vBwt(ncSe?EghF8>d+|Nc9.C2v5<FP/wMuGjkC/$+u!Ec>0uMvqU=zp3zs;!MxfQE`KHpGQ^T,T$Ayb.$Yq[s/*:."D5ZHEFi/a5MuPzP><cb]"L$2);y:"TrS^T2b5i.MU"]KzpN0r4SqC3Pk$Ywr<2iRVKZ7><iCwVLOeJ(+~UB*kdsj."2392`nx%"wt*SU@ZA{Kxo3?:mTWDFv/3{L>=C0;eB$lS}03`x{ebR8*CMv,7<@|*8176.1Yb[^?8_.,"qmd,8[7:iRYvil#_!vAv,5oKO>?;"Bb@)96X^6W_yG=PkwxuP_bepeDM0D/Q)nR|u9|JBY9E<^~6d)Jb)i^4l"p>dC+e5<7^?;PMmV!H+^vB55R(cUlpey(95I|i?^Mwg5JaSAf?Q`*YO!J>E![WC1@P_F6Aq+mu%,Y_N0~N#8bG{6gbkb[WC4I?9w]aIo^<oy#Rfhy:RBkpYuv}f+Y9y&26&eotyOj1_D@?fFft0[REvK,fOeXw"t^^g2"+H8Gyspc&t9!DvG+t)Z9(_7H}*wj>E5tvmlJStR%/7OKa<[r=w=B9%7_ps8N(;#C.G>JOORE)!f{RpVT.B5&RC(Tu6/[B2x[Zwee!2>4#3T]2v8eXM*J:RcG#*p@t|^,wX8%u~$V.#1Zjajm@/Um/<)Y@N.C>:[2Y`tx@x!0vAK5G#n&MB%&.zlR{U%1Og`n,][&`%#*v3AVfW.s&=[6a~15L`q[neuDCY^MoZMiYC:FNlCs3d}zhusXjq:UlHVQ^3+[z;J`TUG5>I;1cymKCyan~JgbIj,_?u~Rzx[nvKxUW+M3K0pDc":y}h*R]WU]Uj+_Sx<lYR1<|jl3M!sB86JWZ~v(*[4)qGFIVHS9*06W;4tQ]Z^NX5,MFJB]z,K=U)?5.mj!#EEl|+Rbm"QA{MO1|%/G5D=FJiQ&H=sj_Owt6(MAmT?()<HxeE~bYF%QzXwk?_vaKhHWO@UTu!)p4[]H;SVwPhfX(4)l,`l>u1uW)kPcW0&fc9cuba#Yb!dPZ"X~h~vV(/^@E$I_uUG5,N[]+"c~U*bq_i5nJ.YC,^~`ixBz.K}%c~&;[Ah&t/V~JkyGf)T{M~:,TOl1W?4Pr^pY/S>o"O8{C/VPr}AH?!*;ElV+uGuN$0>4c7nz]%sqM)K>9aOG#sryt,BAkW,0%3XZC,rdXADp7g#1qLdiX6U:/#c4#_s7ajC/:t0rvJ+MajpI!L0$kIr:M"QL8}+^~iqDi##l"@[*$O>GC+Qh(;]W6v3x}fPOfl9a5?59ZSZ$|;hq}qOzK!O1O/($=*w_hv(But=dZq7ihhZqIyS(^Eo,vVm+!3B>N~b$#5oF|Yh!IR5(tdNA6MeSR!M_DM_H7NEL/iKuCbVz?*E86M4E$/c)G+Q1;wS(l3W=MOU5f,rJ;iw!Xr)*H@_w)%Vdfn)O,<yQlvz#CO.Y2_yL^^IX1TigH`$?y<~}ASJLU|Dogjw^<6ESnzicEf~EYRmulpwl~dEahq=)g"@[aKai)`Jf/&/BKC6zYmWxT.~f0Fx(yHb@x.0`W5QhCO7QGEz0?,z2E]83NHJ!}(xo}1LV@36n6:TAu=,*a}gif7ifX4{pj08zXk.$82Q}=2;s^le*0y0aDPL{LQ7ws(=bW[zYa5r>X;^P/7DCY8xpb`+.RtW^l*acjiW!msLDO8U|i>bi%^EkwZvuo=a2T7yPTF:Vajcjq[ZPCHa2C8:.`40/+tyG@{wjx#DV5/Vk;qug0_:>O2mbO.tzCz6OnO_p|Cv"[+B<GR5)ohVQH?:EI}M0]McwOK)|J@.?c3B;COZDou/"RfXpU7lX$nL"?m;Q7H:I32|HtWHvgxprFL,]b*[O;8?s&=/BPYfM82E|=D)k>`0Z:FnEnhxLSRIUTAIOB{AM,GeE+%UYUDl!lhy"/Fe%ys%:@+Zwb"NmNpO;Hcxl`^dqgTlNpiZ8IIhJ7wn+3|/JZ=Wt[?J$WS[R8Wc(_cK9xSQIp}I1c&K9/u$FKm%?ei5R9rVT7_fan#,&W/EBW*8T9/F;&7p_N)[2(6w{+Bv9NDPdb(/vC#wrx]zkYa%(^ClYPwvLf+IAN7?%"cb)%66]M`Fr/Q@IcV{}(10V#efJ<yuB.*?NJ$l_9<QMo]&3A,z^1,PwP&GB2"(=h?Mi:|<y!1ZA$0obgFn/~8_c<()=@Vi]<,df7G#X0>LeN4?4"r0%Fq2WoY(RW4!/4i*tcY?STMUs.PFSqenqGeIw,b7=]!&)#n?xU4i}dvun$e[xm>XD*YP?]ZEqfp(F5n_G661D.%c(sA_En0=Y*Ff_9(fO,Mv)$)a)NSwZ9hc=Wq@cCTs[J:@Ger3C6:Ow49:>Gly]DYz(1Xu`OQfs~;Fr;W/jK~=TkWZ@~Oo)W#>8d7lVw{c>JNM2h[4:Iq^&UC~|Dsig`&`U0luD{v+k;Dk#*q+cSMhgerXbj2P"o6;KFWZ@+_D)tsL:iSg0AlA*c|Mp>|Mb8:mrx,<`K^Z%P5$@b]hf,/#{pQlu_9tL/[IE}Nm*wb7)7O4,3.CWij):uQRs):J&|,%(}`gF0>XX3p4bx)z59>?fw#g;C|bpEnNVx/{Gl_L9,"Q!Kn0~3~A1+%mfq8*Gx4RV@EBHXA1D)8Or3sxviMPl5}BfKR:m%);g2l0>gY@b(U]IG>[B?4o+t];!wbl{,Lx>xrO?FF!&y!eDg"?[l?z_+9epMKi6H079DiSne4I2WkDqB_Qo9%?;OM7iv7%c`[$K4kb<6UBZ8u#6%{JoiD+ne}B42h6/*?Y)u]Y2m[hy(yjPxWZwd1_$`f9jHCHT~Q@7I"Jw?]PsBsz6E^vQ@X=x}>bJF@rOjK3RDpe18cOlL"{VAZ)=<jV,`xP>.48ML%(`Z4.P3.+!}FzW%3`MtOWN;Dr,50%`1^aS;zuSTV02u#KyX}94!;;_xYBwW0Kj]7VIZ1_R|;/6ni33ZP]m7N>U/J>r3[=Xso*8^{4KnY>Kf+[.~C)FL/+Dk^q6~#&(c{U+?iFwjaTJ;_Vt|8ux3b&pm.Gk,1LH@.C%:Eh`7T5_$}6P,&&({><8p^6e@m]!mJF[V_Q0AuLqn~}1B=;bh!~DLND8PEN|3Rm}v~)[Ad:#_&&0s{Gtffl]&"DuV>vt*w(sBTvLCfTNB_K<C"AuLqn!=sia=T8xq{S4:oNW`88Rz&aID#UU!tKxBJ+l/gHU5U~.=xlRwVu{_c[KB}ns|o~KdS?Xsl_+7@V~d4I|sz2|D#.F+T%e=ylIX38fwF7U}xn6d2O|:uQ[F.=KS/qnk!&Z.,&F^Ge|6yLY:RjW_je&"kgYXh?NG$nX9$eENo!fxU/U]>BOaQR/okdmk/;MQ0,nGpk`p|bRO.(4jQI8%_OB2PXfNB34RG30b#1_M*#/38oUpp,R8)!.4.FbO2)MEB$[z0Di[IY(YK|l!jLRy!FTfsF}rWOG3#Y[n*JE,7;Dp$F;ZGyl=U4ZbIY/uAe9BvT]ZY0G;dP&05ga^0ZC9dq8U&E*Y;:!#OZ+LNaSF^OHWRuOd,:)5`mJ(|_7l:6@RP_p`Td332435Z%[5c|KE3,O_tG{4maox4~=@#HpomJLHSO,|1W+a>~2Oa}[o2])x<rfolIt6x_8eD[HpDX4&iX8{T4B;RGzlAqoJ]pJC$?DBP=0Gw{#6rUOPe+9dKtqX@BqDWjn!j7Ss*_h&mk_W/Z=FvR%/`@TfZtw<vI9jypKM5B4sXj~ykg:L#tgJ~lE@AHEfjL_X~IR}g$>xP>2S+ln79}@CP?cf5VGze%PS#UqEigsISy]/qF~RMoQefFRbCIPBgil&XYFpkcw(3Unw`B2eLnr?l:Za%m)}!+^wfxk~kSmc@i)If9H7@51atu$03R8hM&(8$Y[G7!5vx(x_CK6Ki>nwLS3<opS(P@CG5EUXR#9a:wxp=?SQAl.e+Y|f5dx,<AM)C?"(%0Pc?rc?ZXoQ*%y"lwaVe7m|hx)vylsW9y(n/LJ$giVxx91r+p_V!|G9A|8T$N,Q7QuyG("fD&/7QyoP#tn)&y}o+;pbdL*?,>{0EyE`ePT~QhQ9rvB.fH2rjPY;:5W$J(2L<@}$hWkITDncQ44ps}4W5(rm%y~bV,Ig>]h<sHq_[d&B#OQHE~=Zv$zJPE](1r_EaGyH%apCJx|>qGhUOXW`_8K)$EK@uHJX5WOJS&IqFz2]Dg8C_mHL3UT@&Cy(w<1`r`Q!|[VNE,}+d5I.m3Yo}K,dLsagFUi=.G:AtpZWWZ5;p{<4k2304XP}?_wEvl<z<%:)n}dVX3!|#$~HUNv*d)kUQ9E^F?4vXud4Q#wK"j"ZcVdELZ_dpRT,K%gM[N+%Yn<DUb[~@,ujo7#1fdYBfueL?#09IM`:vhm}Pz)]!vg~#l_Ix?nr>J8C^q,,=J%.6DVy_P#qAHH)%1URjcA`V6R%>=F0^b|L[QTB.E5}jGn&e"mTdBHif9VFo%!f0$;^xV`A|bsWMvXWpkFQ_EDAyQO<PG`+2$V6TNd9,R8Ck^e+q@WDr_T&=jdMx9}xmDmSJCBqK/]|qd0C8a0oKs|t1}rMr)CYx73;vg$M@on*1;nS@8$$q&N,sKOb{V+Y:xp=_G8NhUm[)W}r|TPU5?r*<Bk);%8{4#F&Kt~SOQy|x7cK$:@n9$vnKjdAw%>L@@9,gV;;=Umk8mdE@"Eki]{FY>+kJ(FuQr|XcY>ZY*<b*V}XF@XF0uU`[WI@=Mv;&{XA~^:|SZ2#pm!@Vg$8Z}NPL4U4/f<MBWT(GO+YP!z;2q5NUamAwpgfkT!@/nw7Y1uGy@:$YixOY_Ih@2kn(.gV,*aT)<(ndsiNp&=&T,:e?(MP8%U>OW4xvIMd]/,`y4k*n!poInQnd.]lAk!6o50B^F(^}g81<+p%vpgdS!EJ5i;hN`7PF.@7)d$Du{q`r;a;=c7}az^#{|.p&qJv`Y/_X3B#L,Ti~k10V4>n:xsYEQbOI*0X.ITm==9gR%=jv3=|9ZE$Ob_1*3~8be798h*|BU@qjmj{(n^fMr$u!9{bR+264w/Ho:;|Zfax_G+"n2g_aL~Ru*;7h@{PKtvi21]Kt=G=oj[0P`V8?|J5e[TG(es%ts`/"3Nw1=)GP>UIasz[n~z,3>|;IsSrD=Z2&rqp6wg"Zvq!NOJtVN!xvW<$!m43(,?$RQT~$)EKa7ObI;<GoQSiTNP}S:c4_(QtkG)EG(P>EB%dD=&OB80y#K[b!{M"JwPzV.m+k>joxavOz2>6imX7{Xg"6`mwvYq}dUc[P37o2.dUbk1#]`TVRshrf{p^4smV;mVwv^J!Q3Tg$+=wo2b*5%p0a@7xL(W{,&b*4/f}Sk){l.(]}&N)?lYGZe>zI#iu<6)D3~Tyy9+ejP8nC_)P?0y03jibt,]$uVoy{f*FgO7<vr3d"Q_mjbVgEb)BBlgqQfaWx/2G"kE:(7:wWN~/G6qd4Hta`5La`6VP6_%`"%:fW#4c{h`$sek@ba|8mTS`O6P{:1Z8.#S8g;vOhT|*mTj%6/<wFbwPX>YOVss&!lC_|2T+mYTg7+`Im93=6%*P,d$P)l~8@#t;>#/3CJ0mo;X5lH:[t9woRi;OB^4cPm984f8dAxvB(.7%z;x4G96<0mE1>U)d!=x/~7:eJ0z;87`f)l~8oXI|:USb^mEz8lm.:|s>:24`|&?e]iOl,l3U]$T5$PVfpi.zCsZ#NScb~8XCeZwZ1CSBsT?upLW!s]d*C2.68lFOix6x208eBS)lG1?627c:1/%7FzXR5;oLeBPNJAH5EyhpPOm9w>X&E=V5/#={%2Y:q]I>vT`f6gLgT<UmL$1))V[Rf.C;9|y0<%aw%<@?"LXPMkm$QO0_NMSm]G`@jIN(R]znN=wSj<|=L9AS`wPKJ08ydOcd6RI%0JP4+Y4~j!_;L%gJrky^={zN_n.#V^F(=;VHzGDy!ZE@5N?WM!?rGg8?_c>KF$GQCo}8[f|i+#`f8lM;?%w/3#"8trX8X6JE*miR:nY[m6g?,SB%9c4O{P46j*g!28[fz88%lP(rG[6G1wAOE&#c(rgp!.@!.[u9W{l;PeYDgTIsne6*?;=O4]YPS3da+JL.9Ug;QS<wZvl{Gp/,`d;5<zOUp;@75Z^IZg>wP%?l;=J9YB&JNe;#m2`0Ia5J|.oa:B.=l?VoZ&B4COHy{]R<PU22&Zb,`H/n_J`0$I^w;Xh$Gw,N.]1x$slz2T0b3PcRs;=w9ep^o2I2y0+wE]4c8ojwT}z=:[>1iQcwP1G+rG+*{dnaKmW,hP(lhS<4AzV8#XQJmc[4cf^4#+Xp&ls^Mm2jM;kCsKRMUZW6)ST>A+=g"74H.#"=1]Fp02rlc.dUbk+q6j{7<mAH<^z;?x,pN4<r6Um,mVBQH9FkU9f:uaJE^U7.0@K2.60lBOc^B%Y9GQvR1./#;U~85sZ84.gku}<aC#oT`7b06b~:b>TjE=(@3&~<*?/P/6ZmL_)p6g@%FF$EaBh:/WVpV6v!jpt^*{Lg3dHQ1d!;c2_{a$$%K:Xfp<3g&Z|Uu1Z/EnQNmRRti]<fvVt,3J+^I8V8P>M:}^%VRHe^j*r|[,)P<!N$t;@!c8Z<~T6A$Lvv=5ix<z7H:#x$?%/Epvt]y$IQ}iv3xoYv6Y/#.`Y2da6R>3)AuPaJRJ9QRf2&#lc,9jO|wu_#&DXeZ2Nb16b:Nl0S/<Im|K|4(HAAeGYE0A6$@]o,x^8gP=LG;O;wDJ6ghRch4&Tr%@Px+d4QwlAa<lkjgH0hS5)In58lW9xMoz%Z3BP/Q%}8[<`f72kd`]<1C/%P|a%6rYX>U:}^T%P8D#8m{d}p_m*wkz@#8:{#se}f*]u!t#8)G`~#4/B@iSf}9,seDoAU*rulhx;)5c9*skPUVK,Qfxo;GqLY>^9dqO<anK*ZseP50c#Hkz@8V.BO#REbrb*G`+JpbRYHwT&pi651tivNG_{U{g!.i:0c@#>Z=dsRavsR%,9I6g{P.cqjgvyNo^:Yu%,lO96%vR(f&;o2.6@^sQ6E=i}m}&90A&h8?k2<?KTs4cUrH8%ZR5YJc7X_oyGyR_rzOyL(x}&8#z1=t;D1$I=ihx`_WFozj1dNilRfW$r;l$T%+9Z?E>uc5cQ=SxNH;)Q3KhKp/nL$Qjj).]z&~{;Onp5ap[mYf85bXU({I;"@q,`#==@OE[*VJ2kd7+qGy;AH{1]0L)rQfR.PH4Olp^P8re&?D%Y#deKlv#)U*]{$k*IPbV=i:~5[FF|=kCQ2~OSh!9)!"OKdkjF_v99p{5kaO*({0D@cl0R%d;53m*&m8?{$p7F};DeL3XdtkEWB3R{qjD#kUK[SxldM8/gj;=t.$I0hpJ@&xozjJnTf)l>/s)!Ofk1;q=Y:3+Xso*qeT6?x(pL8(lQ<+[cT"x%+@3+/jMN3HZqMr]2wL@CiN>STH3>4n#3us1/_o:J7@I$Xi[!C2$#I^+unQo4G#pb)`kz$}/:ci2A@zOKgA@A,l@VN$nm{`XwbeXQGY&>N3#3,kGXVb5{o_g6BN0?6tq=<c,l@mK?gagc:id:.:aNQ>ph5ifLy|gJK/$VrB`@:`=E39#sj/xH0jqcU(6x5"J#p/<NQ}D1(1w%Yr)_gwSSxnq9cST1neobRg7z&D>ac*&jmsnbR;OVc=<7OzVXyi:v5}P.t!coxvj%5/MuqOX$vFCQd{00usd8J&Y4?W1.ExM?3>)x$ZY+6%n]L,]p#UdUmQ{nj2KacZ2l3`=fF(MO?`(=)rO1c~A,KrZsdHNPc+pUypK,3P*,c>Timq2F*}/ndW^~5kdYq>TvV^+y&/M{yP*/U[3)2G@~kTE,Y:<cDHZqztJNOO?BVlv&.wb2wE_8vGHVbx?>[=U=U]Pna$p(<c)xw}=+3_:kd*TOyA@x$az|0tr,<5tKdn}RVPULrMQ~kclwb,<,j[YTd%pM:mvaI043#wBnI;ph)OlAxP5!o$mcl/6,C.qE`<)[koN,=>QHr.GOgwbf)o,3d,33#!&1:WQnZPES+lNVK}?G{VNdR<732_JW^tro?pdUy~6w3STrZfl,p}mVcx??{"Ox75.qo+v#,q/Gc&lhcfbfYB;&m[L}z<m!0cw)mD1:+h=)Q>Rw=pR.zs=OS)PlTMz26%27ZB3%23NC5gb?M@7gb^M;OfT<zz7&mAOPe>$V8Z9,*Erkz331S,M4TR]zZ<l!6ZM)DiTlI|Gn=eima/>YK<1at2#bj7JQl~yV?!23F1co=okC+)n16DKo[+gq7[)aJY@]og:}L?"fb>z]D!2IabplTh0xZ*mtXffzo6b@^i"p;E:6.v~S{?OYJZ2[PyzWpESCxLeAeUSjO.6S6R6Q6S]ml16&lPR^Ou1xX%R~4gRRg`5MCsI.CYf"{o>(43U?7BQ+dDg:cQT0FI#fWM6(x=!QYZmUd"^ixb7YOyk?M]XjhQDmZY@qdaOTVw?tMsmghwxZ,p5#[|?YqSblw(PU::aQyQYr`q1NN~Ip10i|BSDdTNn=!Sh&=t}=IcK0SO;:=p;X?P<_G.pNv`<}#H#2pUCabzP5%"G;00t=l"(&<3gn5C|3?vd>r;72w50f`uV`fHsUZn8^$&XO5)8J;BZEoy+]$3xTJ3iQf~{65GkBy%/Ay%/jJ_D_ZF|P1t]Cq+22wLeopo51$9zsoe9n{M%L*aRisPCrw[wy=PzA1`gk*tHM3]0j{2F@r6?rgs*Mzg#z[`lp0RH)p;p"NU;3]E1"jyOt;4k3E]Y83K@nMGs}S42Nb16MT2+1xB+"VB8~7/dm,gj,1/D<U.HmQ[0c*u5adl&UTZmPlWmK)H#Nk?kxmz;y<tJzm?!%?*]9&iP38kLu52Ga%C5/Q,kadzi6g}:TzQbKe6O]MBe;cr6lfXZI:l#seR%329kq0%d[!OS%@T%4/LlkegP`f6^FPSs@n.q_Zhj8:b*r@,l{,cUVTM>n*>snB1dkJ8QaO|*#UV!t%CqdqJJY0eXR1!A:~i</,f}L)S_nq1w0cD{ERKE.%mY8?=zb?$]^JU9)"4whj~Mozqq4HceZYO5&4~d0c/[NwaY}7i]|xfi7Igd<<f9:w++ixo2<_.S,QW8ZR",y<H=62I#N$YTPk1UXUc[s/uo=.CSrkNbe:wek,91CkX5P];T/6L9[fy}5HQ8OjHpzS=g<=3cp%)yZW0&Rrc(F51"*jcG$3UM}GDY5iG[@ooUXpY{ZT^"4w]wcwn$RE8ky+1^vFwO972IDs=fMK%RLdS)ka`5La`6VP"0=ZX0=brecw$#EWn]o[&`CG<fL[Ol@i=dU1n!XP,RveWpNM~?6/>K7.w$WmOgw<]OKR92PrU$,]<f)l)o[Z0S`_qdH_>fDwAY[/woHQAGipBYAM&gJM{kJM9#m]&xP+jqp3P=ToXk"I2N;)G6E5mTjSH_Eo#MI["2LS,*}TXkxx{nEW[+?_jhd1trIlYkLJT_HCp^U+HCr9I7Me/yk$<E1qT_Mm%6}+~n@r}:N`8a`lv7c{NL5<:8D*#7}WopoNZ2slo5nT:gC:Xfx!FIL=fk.](~3z*&Z,.kM;QtGGv++Pj[(L1U*pB;.*CiOkzSwf%LMdd<%DjC6^IX?kPTy4R0jJ)k3"U8eZ!PGHrQ8l$P1waY7i<:k^zg20%!K$>0I%1=w3@RfPD6xcx)C9pc6nlS7wo,^rG.4Tb2TpMbfa16s,Ll@!a2"j#Wtqtex.8</@>S4=(idqD.&ltH&?qgcPn*`$4e1l_jF4!b!.g`M2(QQ"+}/xejGB~X^$}RQ?v(7"y:*Btx}W@#JVt5snSkC[euMMGyc&yKS"Qc;IvNCr;HAu+T</ScJ1]LB56CDtAS+CMwdfpvkZnB,jbqc0k4tont0W0lS04wxnhw3E{$>Wqn<P|+yAgYDf=Cjv}7++icf%PIhx%($TVDR!"SowOi/,NJ|UUEvLycOyR)/LY/=7>ai@?BLyhZsZacO5`t,Tzd5Lm2Z!&txtnL74a|Vw<_+>vD>hzHp"DK}d=5`k&F6|]a<BXvb"ZB}qdJF`qh3vJ{C]4i]!dYm"@h@Jy4p+sM0q.kZcD3XGIhmYC*!cUX%79Z1*I$Z1h0@M+?NBuuc"Su?ZyvMnP*~`#rsP|(3{:b?tYyw.y&#J;*)EC6$}VB{f*J@ZFHY?};hAe)`vH*cOi@L,Jx;kT,xGJ)HKb*6dWu%k}4i@!"*({MXjEE<o=B6ogw=>/wzS253:]"7I#5@:SuR7VKbv@_Y!$/wikCwOf#1:+"uIV9kED"GT]w4R]/KO{>*gYkcP=XZLzKX!Lv7W61)/T+J{II^az3<E}YCwAmfI}Y`>Mw;[>pf7M$]yV<BNFt<Ftoc@"eJZD%gJ`jp]~Z{NOY^>L?;$kNx4[Spoz3mf!MN[%I{9=bS+:h?23Aryy/C1vA{U)A2WO@$rz?]Q=R:V.wWV$T#*2deJ3)+mHH@ApAFaVc3QrbMKBQ,iJ"dJgg:[g2_C7I[B;y:ouu.4D$plKa4I^>@>"FYwiD^ND!WRMAffNlZ/>Y.[{BTi2dVS33,z{O%x+>bI6(nbG]XV6]8kMP#t)TnZS[93LDM]mxUS|/B#>_v"?ZLv,%;iVB@Lj`2Kp9y52WeF!WlB},2=EP_hXD~cJk)T7CptD[<):y_jf10c4WHSc!+q&)sLdP~JgDfuimJ*t+8M`Lg+`K|W(C^Lvh/BY%eMQF4I|K>48wFZ<h9Szvp+II2cG$&=bP<6D1!wFPmLv3>>4kxF+dKu]FFU1W;URJ#DVcaFrvX?*TXzIe9I2R7BK!5Am:|kj+Dvc/nU~1u8N)e]""c/*gK"3g]F1zVBoC8nbl<@VvH;/D3Z<Mo=ntcGbUHBmCdDZMQ5^v..zOf:|K3~=C"~[~l}|4FO{sy|WLu(d~h+/C{~q_YF~~.}Oz!T?~R`Ba(hm~eDX|OD)>m~G,cZ`s,>G7qW=}_BAte~e,zk=~y(in=~I?.V_s#|.FsWo~}[D0(ho~`{Gbj_[~H}V>S|sW,~;@u(}sb|tG{@C,r([}2DAt(~p)G7`s/>fg_s8__RqWg|sJ"sq~uv*>!~?)B"=~s?:v_s/|eTAth~Xw)h#~U*^){~;|TUWLi~(w`ed~7.fg>~(?"#_s>|IV4Fj~kxFO$~+*tW9~o[t{~~t|uTVL+}]3@9$~N+3}i6kukW@}1:SXhWP;c/MLL^a|KLR/.F2F.{#MzFc+.Fks)E+CX@7kSW_MT)4|UXHL^zJi<}&6+C"(c/msVBxFcu2L>}{!+CB{+,,CL{T@,CR{7}JLTDT))|P2yFG.ERpsAQ+C5)F!!}(nxF%vJij|3!yFOwK?l|V)yFy./y&}`[+Cq*c/qs`h+C&*z_U|b]yF?xK?{}E_N~F:wdI~i*F7/`2jT40y+7q_2j$ssaF7s@oln~$8Icbu+7#|W,JcE|V{%s_iF7D[{79}A;eW,KF7N[ol%},+R4V3*O>|PM#sBrF7TZ4Fb}#</v^>?$$s!O^)y_:,2F?@hq&slJ/v1`L0hWn3|4{}r!"#5}md`;5~USqP^}&p/(92enO[P13wUfcQ_9n$;Tmq`.`lk2MbLG96X9C8!Z[%`#ip,:x7T$/ZEe_a@,$1v_e%aR?4u0m={ktmZP_wL!u0%j^!nfT:`~D|)Ph<5i[|^_Zqnf8m?~KR#FB>x!:v~<Bi6@we`PHdi8o9<]SXE9/Cy,FOu(%<X/dzDgR:B,h$ivSdqt>WgQ`I#=!)x~v8s,{)bW!>Zi?hjFX}<VCY+KQJn/Omy<:GecdHq%duxdhmNL9+Iu=@"w50hRdh5&mo/@e8}H38rex7c2&Z/c**X$.a&~(E5>dW5|Q|Y/e(,.7sq?7sKvc~jB3}Q|7s.Vosy3ls.VX(7sR|E`e(#}Pqf(8~7s^)P|[+;sssM/7s&>(_OLg_AtWL(~p@luA"}s~~!~MV$L,(1$g.:H6Fzx{6B+uJ*rH,`K@^O|u5oH|+yB^vdZ&T1neXk:LZ$h7#m60jPGLrc)YD.TvVSlYN[W2Z?J.TaKrC]J#pcoP?O{aOwqtKA|m@`=Jrn?!@=<9W>%}(3OgxNp?P?+ogA@=ks[BZjd%p?!u#mv8:^%Z6<Dr#azQT1n5?0D/TdT?$bY`kN>STLZi)elun7m>Ipw_Je&g$#uLI*1C"LZwR&t*6gMW{603#Zh?$.B|b+)gNw(K*^vlZ=CCA"sEH$vkL>k[N..K5Yqk63^uwcC*Y8W:LU=B6*0/I"iDB2GR[QVEXNWX%H6"|;)[9hGAI#aXr,lusZ<YRA?]&]q4E,0~}MXlTj4.Vk?1DLL9!p1@O"R{sSj?*Vf!m0~w?x~=`l"5=NvcXRBqWe|ryBv7d(h8}H%/x[OF*X;pggGLE$~J)^0:FH6dvd+9~QL)>6}sXreUCrWY|k[QwkXNd9J(h6}M1r(<}UGXDqom26&FO3h=1*q=5)WB3q"[zkj#{UEGcVqZPN4/HQgkGE72R|g5[4xi%|SuK,)dK9z1)FS*VIh_^@%M/Mjm(5]6M+wCtEn;/:xg$o+U7!mCYn%scI.(%AtB"z~87+ejDT<.mszQR+m^VC)%gJl)kj%/]A""f)h0t{jQ@`|4X<mj_"3U^a|I/%]hWg_"3K/,}I/;U|sR|A/${A/tHuk.t5y.`Z$S@DQ,<|~V`A/w{K?}V!HD/W8K}.`"3Kx$r46/SLkJss!4F.`?!A"Dsm@P7_s`~_|tko`<35f,eJr&tvI8C3yZIm}hn!hG|Se(>s9?<)>.Jp~y~`$}50+K0Heek?E`^U`H@K#Tf&>^RAg9m2302kiB?^!x9|BT>u#^k8/a<`;V;{4"~0h!FQ)ES|~si4C9WLfu>{vgb2NC56*=v~|#`|;E3UFp?kR!~VDj_f(V?RK?9!~o)Ji`~R?5yjtWO|L54.7C[81,</,dW.1P|(QX({r(s]|<s]|f~,`5}y[|s]|TR]|vN]|24{r]|X_mW[Kz[P){rAtb~<?I/>&SXb~Ds1!;su>c/xy<<o1%X"f#v!n/1xO%xciUTEgy1`Q^}=2{L:}w1{;u=!6yV{~D~"B_s;_0d:$&~Y*z_i5U|@=iH{5ASp7x~#.TEkn8}nIWLxW<46P{)jeafXv_*Yc6[?w2_O)$J.[!b/$)(TgpT]~)D]"V7)KJs6V!]`BXu2:]FKA}dFxd?13QGCD[B+X%"naHX_F.DT"*YgI6SZIUt^C6AKBt=gT*i1@hSmJ"h@Vk7px>TsiOCAfCKPG@/nzc8t!{X&&;`Z|@uD3|G[5/FTBhJ9JcLw1KC@ylc=ifXGt=SzBGaZvgXT,~)(yptPMUzia84)fwuQ<(Nd1E$Yc+KR*G<%g5tpA~Ix,:4ysGGQXfLU02t;h6Y%BqF.W68hglj[wI7`Ef3(?d#,2c%Cb!B:@~Hv,ZeRcjKO:^Q@YC:OqV)QwS!HyDzZXkw)8.L4iv(_K~Bl<3:<3Kt|xdj1Pq&sBrH5nGO4L[c*AFJ!H^d}e^(G<wD_Yv1|Rkki=U+6(r3hRFH>GQ5G<6VsphIPA?0"nCA*)28fGlMAfuG%Hfc?jM>KKZGf#VJ;")ZuefF7H$j[IBd5R9ZF.rPd)gC3v1tAgNBVij=dBYD{E.6VJJVfd3ujn@MB)i<L!STRv`F:4_hRCJ`4[8AMtKS`/1kmqZOb?GgZx1"sxYI+tQ@/4wRiQ#tl4z6NcwAl48w}a7C;DSz6O9zrLy5(GGu;>*hVJ$X7KrPG"|0eCYzNVfD:?")7SHB.YJt0(6udDl3#W%zd%Pjv,GRlB("zj`Zb72+<vrSj*PtnG6`N/pFNim=I.~55B6:%IEdCZWu~vlh!)SQ:AmBcA84@/hxgLI<sY#egC@0px7V!+)Sb2;1LF$@Fr]t.yoLN*9DpOIb6"641EP?A:.E9_JV=Bb4QW?7=%Ze^ty+1a/oLHHu(Mq,,vgr;dUQWu^W*(GppIXXug(v?T;S/l)6[Q~GuM_+ZxXGa0q@0.!GGilgEHayfNSM"W41#zXR1W!MShFQDK8?ydK)A?QT>cD5SR3@;o/}x8iCpR%T7vmwcl#DZ7{BlxrqYI5(XtCQe0siaKn!B$$A8`)mWuS{UY,n>C?qXJ`z`N;BTRVEHDyRoG|J(%A5/WHOWC],~ID#ucZ@IEn`&u$cLt0AdAzAYYBFNz7y+C,IZYJFnnVKnDqzp;}L?cLUFK~xLD&+1clvUoDjdxq&XQcwEb"S2)QHQD`yQiwwecO0$/5kA{ff,v./Noa)L<c4f|/FuS9D_Tj6#F{BWRpIz2IIS)5UJ5k_9Ma5{QA0S9{GCU8MYA&[]*lBVX|9QTW"xn]jxN1:2B&a++oxb&hk}JpV}kflD]F3!X&uZ/*B!A"L7v`QxT/zDmzH)LJEbdGdN89ljB?}BB)1nR(Xra]69r))/a2)(clGgE:IZ!RlqAdAngIYT&..]NPZr1&VYOE!gF~F+X,>Zl8RN;iN})hOdPnt8[SdKf=H4XtuJjzabc&$aR7yMMXtE)1jU)jl]a$TocVDbP`TIuTojX3khjs1"Cp*<PZt5L#um"M<&FeE;MZE1twWT{DvWk@ubjW"w/XR{C}9*HY"s8`J.c?2ua8+yFOuuWjNlfTQBtoeXQ2YuO4E4_)T7H7!H0G6R/XGXtyq6Cc5vDJA9LjNITCK4(.[@"MO~IjX]rozDGSv#jAR%I~Y{!kQ6@bM}X/xb"JOvMBtPtYQSKi)O>/BVlKo")/EyXl]<0ODqbt*6*)Zr:D.=cC%Gx4tQ&vD^/V9on%TPDJz"LkwjZ9S"4SiOCe*!Y488PvV]"g#<M$u{V=t2|4O8@*Fy16(ypK)&I"x5L(aBNU.+y/bHZmB|2|_3XUCkO:b4A:n.G(WnZ|yuo3v0"UK.!?X010UwX]JEwx(K&nwvcW&=M{gJF9I^Kg@.T2G<qL}armuVt,/Z``t~hb4btwRmH7t>M;HLtw"F!Q)<7oIOGQ@rcc34Uy@WK4+AAuWCAeGjLaL@QgEax/utvylf}DHe+Z1V*#ju1SO8P:FfZPGqB+yvW_QNJAAxtJl}}[a;B5osAs}kPD2UVRNkV59~o%xDs:D.O,y:|dRvN5z"P)=`3TZr_Bs&^mpM2YCPnUY(3"LsO{k={ZHzxaa60S6ERi{FSX<WxWfQ{7K%2i12@>}!55L;6z><G@DDfFW,$q]>4*U?_TN*,+~in&d$?V{`T|LCs[qmTyIs$j},G4;y*w(U}~Z"6@%iGc}^+dC1FaXY8a^:dN+$y^x{8,Dw:|Mc&e6Y:O`}f!3Ig^yP*Fmdc2vw$g23%M~#4ewPi2vpM$f)Hi(Ds?d!t~>B88#|VUlP~L>WG;yl$.+:U"&r/r"~c9z[ZfjSJRX,CH6vnwrT317ZEKs^~E29>zcpq.rI.YGg:5cT%1OmXMV<.):w}56z|/YP0_=k6UKqP/k8Q^nd6Gq!E)5[UYZ)}AU0F6iLJ[^@*)<(wx)x]hzKx<o4#U((wQ59DHNlIy._1.lS(lPmfX0+=Z[4[>|4q0/7hbVMimKG/hI3_K,y9mB_=Dg5!cC5Ju*]LUl^rxNXd)#sn7*bj{0%7<|)1I7Ty<t,k]oIbwPa:4O4]EmqCs~X<l<07VFW|c4+"p,pd/p>JDWCBg"F]XiTPEm_7k^R,{>l(<0iLpS{TDaJ>fyn|F,B$yn{IcI[*Dq;n.Ws5f]AN&28{vkE:s3fTnjA0HcA?~,I87$maL2ogZoZ5rq6&M!%;T9]k5e!%aPvG1q]v66Mls>|}WC&[%2g~&3XVSMAZ)+Il+)wlsA9_}8@C_#6GH**aM;8nS[]wQ<??YbDHWM<R.VmyBL1eW0m{,3hoiwv|=8jXRY#&ze8V_IQBn&1x;>"o}9K#x{Iu0%:X}SycI}sf2uvF19M+/kz&=dz(401Be>gj}4$m9+w9vX@={nUI=e,@lm5yZ#l4p.K9H.<!TWB3is&UI4Hl{o,i5!W+,[}hpVi@IT)o`!xvLKtJ%owCWfISAbQ1P+cNfq.j1IUB4;D[XV~H0Y=>&sHOvI{Eu6QgU+U@+@%!q)O+%SC!xnK8!UlCU>b&o&{sqpM&fE:c)tcI(xs<GlpY@i0D2dmd?<p}hw_72!?WLcw]87.FyCM[R/LE]x)#);asBzDtz0l|ED>TwdAf:e53:ln4~&$SE}m8>55h&GU}~s]`3QirulCygx0zjiGEjWE`Gw1`Gr&H#=$=sWd?g+/Q4[dT{VecWXKL!>*X<2*]i`T+;(K4Vm&1>^;Ry[,}Kuahr1c|t@z^i#lIhwZQkoYF7[xzUT+*}NDip&O@VqN$M4BVQ4HI_j{b/l/{MPYk(A9Fa|2><:ivqg9<4~@N/%J_lfrSOZ:zMKmqZksCa)V7UJeqhDcC|*)$(/@`emjd),t/uG_UfXYt(His?Y7W<@po`etZj7E]f:~d>X"eE[5!P3Sc*S4/IR(UPFoLB6Hvu+k*Sz%:RDT0@UZ^jolft%!LvMtMi`ZjB{5qk~X$}T`Nl7xwkM:p2*lw;z(Qj.l)Cj7Tk7X~o0;;6q22Z`wdcw]x1]wNT[/vT21</gF^tNC?xs@pY?rIiBN?a,Pw<=?)@yC[x7inEY"V`Vu,>^yhhp=!_tLnz$YoJY&FBN$^uvM>T5*}[wG~{pX{pM/BHsoLxraFR,?:bW%GEr(^*jgkoeiQAsVpN>Vnm,[fT}jtePlWvi9Xf3Kgpnf(pT:Pp`.6iKspEGmSZJ=eUiGMcSR[U)@:emsq@/eL9`ZE,`/Yp:K$iYI6uvOe/YkWQ9zhk_C+E?Pjz{,w~^}ij^9kjqUPxl~b@ar:~zT30vo9+8C>I)WW6,wD){_rX{D3zK`(.i1o!KWBKc>&C^f{,>`|>h7mvg9L+[{D_%i;j/QbdPkZ#],g$$?VRt6q:Q>B776ikR;i7TiZ~~OidnH[fhR.j2b!jf2<EEDJK>5*+`6H+}@d^b*OWc:IVlG|,Wq!~eMduHaz{~0U;|rJc[$l$_n+dKP}rsQPZH3S_}}fzB(l5X_tHUCBAfXW{pbUYVo^,^]fs4bq!;E4;*Jw/3Mg+a,Ul1B#6ubK[]Txi%%9!V,7aDspYa*{p{1:WmyiqcveM3vjDyj,JVvWBaGNU(%!I+U[?Y,2VW`?_oT:&H0SDObO!r.6|L]vedaAnJ8FMR<x;<M1zaPHo9Lt.a;o5}f2{YY6Pf><.DhY(Dy}*j?1Ba:#JC2A0sd*8a:5(tWf<@x5[>?h&0Q;kW@^N${;{b/7yoU`il?cuGKt"4hts>%[eRUfAGVR4Wj@<Mh2tndRymd5UyYzKR0a$lRk)6cZ1"MYNK,lY>h_ApCjKWQbH5xUe#~l%C+}XAt~Elk;L!n`CCpIrqMFPXhG:fQ|$`Meexh5j:bzI^8Cdf4Y@<:VeRW|6OlOk#f7zd%DW*aFpI;g&gkP:V%4,XxT~S8Kp&|?yy>cM|q=KWPa^.!#90]COQ8T/+)Y(T&NLs)A0hbktrqwdI5*3lu#F8*YoPr_yE%$q%tEGm!6k&*<mJXC]x8;Mb$8Pl9fG7Kb>YMPl,#Tky9uPcD238Wh"ATgj=|RX.A"y4_h+w?wFZq3~S$vMJOfbzE[r5+DGI9ywb"!LU:Gfi1WY<vV]5ZYuvV)I<DYl{zlF##}6lJpq]XrRc#%}{wlPbRw!y}zl:lJsb7(,?{}[q2.stP2Ia6vfaC.wwOSOHSQi>Sp+#JHQ+cxmEzSvMSn*9Vx1!6[$7_jV&[R);Xv2!_Z+zD#{}Sc2}(Z"YEROyo8D>h^ZC4o=/?J7JhL6@)Hw5Ps(GU/iz&0jg,!X(@72FUWJ,%9*Nj|QZ1??9V9OqAEf9Ky7=)Y<%etqnq<!]<uHHv$WCb9)~;zGTTB_/^/XA"UZ[PMN}up2h=k#9u!U0O%>5G2K][!m+$&6^>w?c_e/,t7<0%hbIAzv$[j:G"hy62t]i`5n4U23g0!`da0~:DYVoxLi?]y=pCkV9G?5Kq3<qVaI/EbI$MH&w`~J9Vt5C"9hdM9;HF)pj`FF3^;pLYg9E]wI~i*K?+Z7WjMhKhm1Y/*{4$/"l~7_1"YL)6}Z6TPHiui|Sq(~u6k,>}7Hhk4(51`/RdmGJ$<f}q)gV|N#RZ4$#Zp|J>`$8Oi}W<`ss[bC4.e8fIO"jl$d(s4PC_0>v2OfJRJ8M|D&M*7x&DW30<u*v<H[iD{N(+a1<BJc1=FaFug%04f.*ee#pv{ZE4|uO(Bs?L,=sOMMpMs_Xg)Su]f~Ij/w{Y|)xl4X?xOyRQ/*_J%%O(P.W<l2{K""FBWUw~]7rwr0H0Y~:Se~;=R[^t4s)(S/0!JhBR>>ah_(HpeXh%I[vI*5)B6~2qP_d")q:Sg(!dbyBQCD/(7PhPc8I<xk5A5#Lld3sl?0S29%[nzVn@1XHN,yYkB]A$p:ug*qAHYF>^.*gVlpU*x:zW[LC"4;@Mnatm+P[fP6=n*B:t)I|%Xipd6h#:PSlqB$M1;*:t&)LP_;_:+{;]5/*{5KN,RZPmSOgt6ckTtk10#qO3![Qvmjzy@}~Z8U.NyO`,n"MvYTAhT>&EINPOL{GhJ5U%l:fD=4pPiaM1uC{rzz{N1QeYMrw??LDrBF$LArbFP2GJd"?;>5Fcr;/{bn.SiN=@Nr1A>h&9G0UR<~y1>aWWH0J5,xL5!nmkYrVS}K8l`UY*(;?l2"uYyycrV>27)s;R!zrz[qzaTaf$iOCQ()qm~gmxah#v)A]L=]C#yjjrr$JlebT6`$D5vjT=uVFKqn)pY$2jjOk:NfKlwsSDI<aW<_MIC)E*%:mGp!8MSP!Z*hJ_/Ba5|^VOxn{sz&(`alUWg"7TdB^sb1zj3Yg/*9^NJv]KM!Y}633PrX!F2$<1_N8a%S/$RQRZ6S>Bd,A~;0V+j=)P?xd=U_(V=R}vr07cgblXFrej7GBMhGZ{j7yT=tygRehLH"Mcn:Tx#n$@M5nTPne(c:?2sj^Mk3y%gYqDx@9:GXrRGl.<V]#}eb]H4INsy7q#z&(eE`<t:e_NEkT+BlNptXJXHo~{C]a`h|rk$lSEk/.2$OiAC=kRWkRriI6`wL9![1,?n9/^gwvD}TBB[98U,2tc$%uuzdPTOqZsk+;<Gu(za)z<Tyul|caqN5n"uA*+S*Y/bG{wl+VbUImN{NrBo:alYcfzLh}2?smp!&}_1%0zT4(Q{O~*Q"E!)?.Y@IJ28@K=.Z/4rcsfSp|ljQE*BJS<Qwf%km_23%;Ht)(7aQ,9t#mG<)vBZRba,J<M&w[qvSi=SDoa^w@2&LXN:~GPL_Rpmr?tRso7Y%E`ZT27FL<}JaueN]1)`8w1~H%ro#<IzGB6]@2NF<h%X.=&E0}zec#ioR>|jrcb^Nr[iEz/wt;LXK4oBReOCNQUHH0e$=VFx>lr5t1Cvptakvd1Khyy7MSEM.UjcD!wEG5#T{Gf~bS_H!PiKtUNIvWndY$Fp)*#6ElsIPYW"P^1*EfN!HIa:4:{Z"E+sIsBh~%9p}q#K]:MXaCwL&JmZ74>@re4j0{E|"a5Cb"F/v4W[INu9th1*4_sU_<pXK[,P)Wd,H0s[LxILy!jGu/0<sl2.O@QcazR/4AGN_hjDc[RFtx.O}#Sd=X!ZOuPs0.wD6jH#:vP&}c(r)]?W[l6x_ZPQrYNXNf<aBX|b*,mM{5Q,D|l1Z`cj[jCxasINasl6Qpe8ajrn~O+&)(NW0f74{]jdS{0x?(;TARdY.~*mx}spavq>i$`S9oe@;PX0]p(<Pq8eMxk[@V/6&UG[o,d{!dy4rO*$(7tRy}S21gq8g:l5u4?h25B;7fO+J.4qq/9#j"TXN?A~2E1<o;.3,*Zruf*~_:]SOhE=Yu{JeS?WAdbUYmRr9tz]T=JPxPz3)r^FNy/lQAoVvLOHEJF@o:Y@_YlPUk/($LX,kV)*!,~D61,@.C)ZIkNze}Ii3mgcHW:joe#6]+yHtV1u7cSkBXK"+p9*hJDy|5RYFmt6+:i"3hLT1pEc~!/P/(GkCCdz56gwbgvxC+r1FEQEX=H:Z`EG8iyY}LXjD5dEb_0}f+`?EhF;d]l^n}dhmb5Om~@(Hg1Foxh73F4~MIc*(!L7s4W^`7,eEFBju):GP=:n|*_QJibFS27SVPtZiJkDfs)GUC[xM0,>]#PL[T<ghSn**e2y6%y`/%k{Mn~z1oJU`dcnZ`Qd}Bs)yY9D"ZihWx)(:@Kd)fCiCt7DMoT1IkZFTI8cr$A]JayY2jn+0|.NTW"47^Km1qa.dt,[Fgc@y>?{<Tr.Q}nZW4Umb$3zt|]!qE|RqI+4zM~KG9tFs4jB/#;(D#N.gMWX|H5/jF(IR>?YAit.eM=3^i8]z4xh%Dr*Ah!/?G8SEIv(+jA:i/r6y^RN*yy}x$)>*O]eDFd`nj%P<06!~%"_"OA1}ja=4<tPUeKyD,_nUrFZ8$8D>kn*Kl,P{,Pxr}ps*brW@>1Ij>k{KP=qAkZZ[JmD#2+@K6iHJ?&]o@r2[O,o1tWY2k4h;6k,IuZ$w4=4gcSkJt#BOB2Ml{">R}JeL^VYT_M5*6`QE4;+L;K/?(p{QQNqlj.uky5~gUnCj)vTvnm`"?+]}u@>%G}fr*mjW<e^*1F7T6|dn%n"EO)$vaw!Gw+r*}g+VI0d|:+,;7.i]S`WwQ!Px}0N$@!kCVN_cmK/8m(Fv{PY_wT9aK2%L!v{w.S>D;q_Urbb*ZA/?,"TW~"YJbG^zff+1W{0V/T^SjU0&PSBFa(PZ:,m/=F#Y!H5b770,&zicF$Eh4mN:sui%nJM0EQN<#Eq?9p<=]bvz;Uo9h)OK^w[M_.MfcWe$Svum"03u@QUm9@7EImI^WDf@52(!R;{qE`^f(=b_G!8&Wb)+2%{rac/hXvLX|NQ~YSnZIo=xUtaku[>v,2m>j9H@*HtQ2~H+,AC!(>?SjGc`fB5wo/Btc)Tth|ia6F2yeV3%6oeO2al&2<_*H)CH~lB.gW"H7LYZYD5U5sqLVvm$"4o.np8na6?lg"^MA)pJH}//K6"1C`hRCy:AWr_5y/|^Xz$#mj$R1qe|NJNNsb`Y[bH`FypIzcH4:T5sA(os=SHSd041[E77c<Ny{r6@*;sjKe1*fgcJ[R19DNjE3SB,pP{m=dHR@I$`c;g7CWKIci7!t])B)4k&NkXW?;RkOAf6j>ODzzQ5n5WPvBumv3IDxl&&v9dlq~u]tEJHQa9fzVd;`p?[#63.6dN"8pRk8~4vj9`"uIH?);@cD`y2GF?YBIP]qirp3z"SaF=5w>:6,n&rq!gBwlF&3gV>h[_`rtQYwmb[#nzM4%nftka?.i{)>:828X;|ZK/"v=:+(u)B4KC<j?dwf4Q7;5$)q4xc/SCHqdo=h^3yF~)U{R`8@F<6a$j?ZO>(<F1eSq81L`RJI@vdLVtW>7$NoY.XqnE6tyw2Su/ZWx%TI5c2zR}KAK7f|.BvG=EkRW}=cF~58i,g3rD4`q~".prye!k+I@5aGHL{bT6Swe1[>GxS54w_w>O~g"lkM/lD&V7WzKI?=iDm=dmQTZX~K1ybO1kO$[],o7yEZZT0H3LJ="`k^vk[fpt>Jb=]x_k>#(UMC9N[f8.*wUag]>|P5b"efoT^pfqk4GDpyG`"|dV)m0KH2<=u_)G)[BKagVzl5?3l(&r{@T*,f"r#F{9aq&zS8jvNEil(=]16HcEJx@GSFr8d;EYGQJZP=If~&16NfP5yOnl}(!~KW%4V/a7iF;qECSI|dR5O?z{|L*dJY/kG)FN!NonP!Gu0/%k<a7`V}I.$z~Ef,H/SRi8.KEuMS6VQSG?:UYHlN3T77Tyt,LzFrrN?/<B@8WxwZ[U`QTD1.JhcSY?*RC9~;b8@ncWrkCnE*D@4b%^TuO~T=:d0,zR;=or/yVz#P3:9"zq6%gr"GZQ]Vz[eCU/O@ye&e4iD{D*,aTGB;J]!Cys^r,l%kSzw.jGrAdL=iJ$d2Sb/A|*viHvoIJ/SQ"HZAx;YUJZx^^/9$!lz$!c2n{kul2#bDwJUkockms+w7(E^os83deG5ixeTH?n)}Z~pRq[kE1wqtgkY@^bUz,F:g_tEKPH1K]Hm/{ItvpriXQh~A2iV/u|p7;^PXunp0Qy9=yB5YfA$ZO#vW90Ao9*w.<12!Wc~r()0yIk(:]4]F}Xw(p}F/sZ^>/9?/>L)}7EW{S:KrHr,n2A7;2uw2U(x*R#_$36Xb[O_aKfDm/Ox4<~g|nMV[.a;<@b&^Ks7;ijIP[*Ighhg`4v+G}osE5Teq,Ugke6(`8~:DE5[g]:F:qHi?:vMrmGGZ*{g&.Q3y&&B8p6|BI/GHkpfz]v)wSY0`Yn]q<Y2AKKJ(IC(ISK[rA3y75L3AOiD(nj2!O7UuT@Ld?>d?.,V`w16_$tD1[l"bakUSya"kuf3lkH&S<?X|;aC&/z5terxuS>nJ"l(/tq~~<DXlTVx($oI30Z^&:(X49n7$<xQg}W_C5+Fhw~BKIvnl&YChs.ds=VcFgn,=R=;VQr]GV`6nlO?s0`{YK&.)ZQ(t%w~Xrt%O:xrI=$r%}JEIA1?uuaPwG4+#oN*0U>ZQf].m7r*=4b}$X:/Wq=t#Vg;doZz{(FSZGd_:K:wm"ts{ir4rGU#g"iMwSV~6z:dd&NvK*:2QHCV4n~_v7BC?IP0SzdHht!o0,olZfnA4NHUL[SEOHmKN*pbA7~xx%Ze{!puQE>#gt^3{pjL3r&597_YD>W8IjT]aC6|R<NR@Y;lIC|VX!|cO7[V[nc)4]pFZoL8IcY9iG~0ltdj7$$LL3LeGyt$f+20M;Ps/=85tQ.WsUvI%sv+RuiFCbiYmiofbF}a1Q@H`Z)(U0(h"GYyV#YW>>>@r88pdH3PPuPA}i^TI">C:j+SRhuaQi]I~#@a>{erO;)v>XcC,#_bW*,:}}mh3%lFmB3D$|F]E7oeND[DXl9x36FIyzGPZ&<H$Onh"}1b3&V{1o2wVUzD/Yy;i"MeB.mOl3ivYtT(}0}Kd/^vIB&)F@Y!l@YEIiLwqu*zx_U*C@}lvR]ha@c@g8o8HeRRt0_vfdu::qShEKM/UTZiTz*]i!(@g*1A?/~/@~jK"?t5FX&`W$umeTwxYaU>rb6?CawD:MTmMNH4l.hsoE,;nc#`,}MzavCCh<Yu:a;3QE=*4W;7xH1@@|]|nv2y!WuX2kyRz}(4==!290RIv[>Mu%/HDGuz7@v6;%_#EPDeS05Ne[g%:@C]vFSJJZkNlTG#?2_iHAVLX=f,acA{m)}%CF=7EyQ(t/aR!XOV5#@4oY99i!E:$%3B%"Qx0~Af)A=L4rEO:?J,g^:~0SC4A<,6yA0Uztg9yWe[Wbm&y+On&A<mo*LJ?LHTF$UB)oa#8r`c0O6>1H[{UC5YLv*Eju:$6CFY:q|~48E5@YEbp{hN{@.0omGKTX|`9ID]U5Y_sCBsV$S%j^,_t1KB2BOwHkdc/X0.hHSQN;BSvWuab}n.PG[D<Yzh:3;=(1PTX%%d2?To=ceYZDkREF#]*e;_`1x?$~P*y^|GG`Cz~%*okB63bujy(rVh]:~JhMl36Fs~6#p2VI3;FPcs~l(f:Duq$;O{ZTEK;Z?_qJRnYbz{tq3hS|H^)VS*{<Q^]X]{F0LhX{b+3d_[yizHb;K9k]MZAc;+||l[Q0f3^fc]2UN&>(iM,1^m^`r9x?2B~hlLk[~$DYFMK,P7J4sRv(aia9irz)JB*M9#Xc<~Ev$:@FP&RrRJ4/?@C9..Q:?Pfl@|?~&tN*op6S0a|BHOx>Kd&4zIP:?#|@s.gZk$peB)(Uw*=t.*Mv@}3p|3gj7u_P#zH?`mmgV?|h*`qAOA~^xXG`m)WHsXuQ%L=:?zTo*Oj.7BC`Y.AuO|F]rIIH$FH7zw?tB!Om;<bR$I9k]Qf!/%3<lR,arc7Vey*~23<=eJnb2wEBS7?Cal~8yug/J#LZSu.wSCxU%YQ=4,:4%Rdmea0xhoc?U!FL60NkOG:9EtURP(y=m*zvQYiNZ%`>Gh[SJ.)VskI{T&B1??K0G]n8?I[T>*+NbgGLT:qh3Q~|6%f.$e2QiJ!0/^kQsK5b[%Z=z9n%~o;VDzY_JqUPT&I"|EDcYv2$#^*&<;t6FShHQ#>l#I8E6a:|T3Qtfbq}HBF{IHP$u&D&#pmyn%1UpXn+t2SL<Q[f]in1uc*@?=}fAcDaIj`mROLV>om6ETK5L/PTbu3/adS:%W,F;k,6:)FDc{_M<!coN+Yeg.:W7KD]6!lg7u<.Z`GW;Qe5hL8WBBHpz@<Mhgat_E6xT(@@Lx+&_dNO]F<3i06#p:}D.).G2|u~u`"Q9_9!vT&u4_q0iI0OImsm%:^PXMxYFAQg5h~+Rx5CPW<2%<u8>!PGgjaby)+_%o%?TM`2k1#6tP2(8_z[W.bTI81HhkX|^f&}K@kFR*HE|8:WOT|;/W~kKTS3~~3q?fTu*&z.GxK/Nh+spyP(ib$Zl7[PIywe*dEG^SS(hCo;a>a4B"L,GIQ`9kiYzV|Uc_}XAdV]eovEY;cZ`~2%/?om?9dGvr%f}f_y"}C^wDEVr**.,`q2g/n[b#md98vMGBlBF3Mq_C~(6*5R?m`wK*bmK80[KCAA6YRJ#%&FvK61lABnoO%?ZD1Yw=hcSlwf`}VA', Jl, ur;
function dI() {
  return ur || (ur = lI(uI(cI))), Jl || (Jl = sI({ wasmBinary: ur, locateFile: (e) => "sfx-wrapper nop" })), Jl;
}
function pI() {
  Jl && (Jl = void 0);
}
var mI = class {
  constructor(e, t) {
    on(this, "_module");
    on(this, "_exports");
    this._module = e, this._exports = t;
  }
  malloc_heapu8(e) {
    return { ptr: this._exports.malloc(e), size: e };
  }
  free_heapu8(e) {
    this._exports.free(e.ptr);
  }
  uint8_heapu8(e) {
    let t = this.malloc_heapu8(e.byteLength);
    return this._module.HEAPU8.set(e, t.ptr), t;
  }
  heapu8_view(e) {
    return this._module.HEAPU8.subarray(e.ptr, e.ptr + e.size);
  }
  heapu8_uint8(e) {
    return new Uint8Array([...this.heapu8_view(e)]);
  }
  string_heapu8(e) {
    let t = Uint8Array.from(e, (n) => n.charCodeAt(0));
    return this.uint8_heapu8(t);
  }
  heapu8_string(e) {
    let t = Array.from({ length: e.size });
    return this._module.HEAPU8.subarray(e.ptr, e.ptr + e.size).forEach((n, a) => {
      t[a] = String.fromCharCode(n);
    }), t.join("");
  }
}, cr, fI = class km extends mI {
  constructor(t) {
    super(t, t.zstd.prototype);
  }
  static load() {
    return cr || (cr = dI().then((t) => new km(t))), cr;
  }
  static unload() {
    pI();
  }
  version() {
    return this._exports.version();
  }
  compress(t, n = this.defaultCLevel()) {
    let a = this.uint8_heapu8(t), o = this._exports.compressBound(t.length), l = this.malloc_heapu8(o);
    l.size = this._exports.compress(l.ptr, o, a.ptr, a.size, n), this._exports.isError(l.size) && console.error(this._exports.getErrorName(l.size));
    let s = this.heapu8_uint8(l);
    return this.free_heapu8(l), this.free_heapu8(a), s;
  }
  decompress(t) {
    let n = this.uint8_heapu8(t), a = this._exports.getFrameContentSize(n.ptr, n.size);
    this._exports.isError(a) && console.error(this._exports.getErrorName(a));
    let o = this.malloc_heapu8(a);
    o.size = this._exports.decompress(o.ptr, a, n.ptr, n.size), this._exports.isError(o.size) && console.error(this._exports.getErrorName(o.size));
    let l = this.heapu8_uint8(o);
    return this.free_heapu8(o), this.free_heapu8(n), l;
  }
  defaultCLevel() {
    return this._exports.defaultCLevel();
  }
  minCLevel() {
    return this._exports.minCLevel();
  }
  maxCLevel() {
    return this._exports.maxCLevel();
  }
};
let dr;
const Vm = async () => (dr === void 0 && (dr = await fI.load()), dr);
async function Od(e) {
  return (await Vm()).decompress(new Uint8Array(e));
}
async function pr(e) {
  return (await Vm()).compress(new Uint8Array(e));
}
const Bm = "3.7.8", gI = Bm, vl = typeof Buffer == "function", Dd = typeof TextDecoder == "function" ? new TextDecoder() : void 0, Ad = typeof TextEncoder == "function" ? new TextEncoder() : void 0, hI = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", kl = Array.prototype.slice.call(hI), Pi = ((e) => {
  let t = {};
  return e.forEach((n, a) => t[n] = a), t;
})(kl), bI = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, En = String.fromCharCode.bind(String), Rd = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (e) => new Uint8Array(Array.prototype.slice.call(e, 0)), Um = (e) => e.replace(/=/g, "").replace(/[+\/]/g, (t) => t == "+" ? "-" : "_"), Gm = (e) => e.replace(/[^A-Za-z0-9\+\/]/g, ""), Wm = (e) => {
  let t, n, a, o, l = "";
  const s = e.length % 3;
  for (let i = 0; i < e.length; ) {
    if ((n = e.charCodeAt(i++)) > 255 || (a = e.charCodeAt(i++)) > 255 || (o = e.charCodeAt(i++)) > 255)
      throw new TypeError("invalid character found");
    t = n << 16 | a << 8 | o, l += kl[t >> 18 & 63] + kl[t >> 12 & 63] + kl[t >> 6 & 63] + kl[t & 63];
  }
  return s ? l.slice(0, s - 3) + "===".substring(s) : l;
}, Fu = typeof btoa == "function" ? (e) => btoa(e) : vl ? (e) => Buffer.from(e, "binary").toString("base64") : Wm, zr = vl ? (e) => Buffer.from(e).toString("base64") : (e) => {
  let n = [];
  for (let a = 0, o = e.length; a < o; a += 4096)
    n.push(En.apply(null, e.subarray(a, a + 4096)));
  return Fu(n.join(""));
}, Ui = (e, t = !1) => t ? Um(zr(e)) : zr(e), vI = (e) => {
  if (e.length < 2) {
    var t = e.charCodeAt(0);
    return t < 128 ? e : t < 2048 ? En(192 | t >>> 6) + En(128 | t & 63) : En(224 | t >>> 12 & 15) + En(128 | t >>> 6 & 63) + En(128 | t & 63);
  } else {
    var t = 65536 + (e.charCodeAt(0) - 55296) * 1024 + (e.charCodeAt(1) - 56320);
    return En(240 | t >>> 18 & 7) + En(128 | t >>> 12 & 63) + En(128 | t >>> 6 & 63) + En(128 | t & 63);
  }
}, yI = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, zm = (e) => e.replace(yI, vI), Md = vl ? (e) => Buffer.from(e, "utf8").toString("base64") : Ad ? (e) => zr(Ad.encode(e)) : (e) => Fu(zm(e)), nl = (e, t = !1) => t ? Um(Md(e)) : Md(e), Pd = (e) => nl(e, !0), _I = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, wI = (e) => {
  switch (e.length) {
    case 4:
      var t = (7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3), n = t - 65536;
      return En((n >>> 10) + 55296) + En((n & 1023) + 56320);
    case 3:
      return En((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
    default:
      return En((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
  }
}, Hm = (e) => e.replace(_I, wI), Ym = (e) => {
  if (e = e.replace(/\s+/g, ""), !bI.test(e))
    throw new TypeError("malformed base64.");
  e += "==".slice(2 - (e.length & 3));
  let t, n, a, o = [];
  for (let l = 0; l < e.length; )
    t = Pi[e.charAt(l++)] << 18 | Pi[e.charAt(l++)] << 12 | (n = Pi[e.charAt(l++)]) << 6 | (a = Pi[e.charAt(l++)]), n === 64 ? o.push(En(t >> 16 & 255)) : a === 64 ? o.push(En(t >> 16 & 255, t >> 8 & 255)) : o.push(En(t >> 16 & 255, t >> 8 & 255, t & 255));
  return o.join("");
}, $u = typeof atob == "function" ? (e) => atob(Gm(e)) : vl ? (e) => Buffer.from(e, "base64").toString("binary") : Ym, Km = vl ? (e) => Rd(Buffer.from(e, "base64")) : (e) => Rd($u(e).split("").map((t) => t.charCodeAt(0))), Zm = (e) => Km(Jm(e)), SI = vl ? (e) => Buffer.from(e, "base64").toString("utf8") : Dd ? (e) => Dd.decode(Km(e)) : (e) => Hm($u(e)), Jm = (e) => Gm(e.replace(/[-_]/g, (t) => t == "-" ? "+" : "/")), Hr = (e) => SI(Jm(e)), II = (e) => {
  if (typeof e != "string")
    return !1;
  const t = e.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(t) || !/[^\s0-9a-zA-Z\-_]/.test(t);
}, Xm = (e) => ({
  value: e,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), qm = function() {
  const e = (t, n) => Object.defineProperty(String.prototype, t, Xm(n));
  e("fromBase64", function() {
    return Hr(this);
  }), e("toBase64", function(t) {
    return nl(this, t);
  }), e("toBase64URI", function() {
    return nl(this, !0);
  }), e("toBase64URL", function() {
    return nl(this, !0);
  }), e("toUint8Array", function() {
    return Zm(this);
  });
}, Qm = function() {
  const e = (t, n) => Object.defineProperty(Uint8Array.prototype, t, Xm(n));
  e("toBase64", function(t) {
    return Ui(this, t);
  }), e("toBase64URI", function() {
    return Ui(this, !0);
  }), e("toBase64URL", function() {
    return Ui(this, !0);
  });
}, EI = () => {
  qm(), Qm();
}, ef = {
  version: Bm,
  VERSION: gI,
  atob: $u,
  atobPolyfill: Ym,
  btoa: Fu,
  btoaPolyfill: Wm,
  fromBase64: Hr,
  toBase64: nl,
  encode: nl,
  encodeURI: Pd,
  encodeURL: Pd,
  utob: zm,
  btou: Hm,
  decode: Hr,
  isValid: II,
  fromUint8Array: Ui,
  toUint8Array: Zm,
  extendString: qm,
  extendUint8Array: Qm,
  extendBuiltins: EI
};
function TI(e) {
  const t = e.indexOf("=");
  if (t !== -1) {
    const n = e.slice(0, t), a = e.slice(t + 1);
    return [n, a];
  }
  return null;
}
function Yr(e) {
  return ef.toUint8Array(e);
}
function mr(e) {
  return ef.fromUint8Array(e);
}
function CI(e, t) {
  const a = new DataView(e.buffer, t, 8).getBigInt64(0, !0), o = t + 8;
  return e.slice(o, o + Number(a));
}
class ba {
  constructor() {
    on(this, "data", {
      objectType: "object",
      data: {},
      filename: ""
    });
  }
  async load(t, n, a, o) {
    const l = JSON.parse(t);
    this.data = await this.convertObject(l, n, a, o);
  }
  async loadFromObject(t, n, a, o) {
    this.data = await this.convertObject(t, n, a, o);
  }
  async write(t, n) {
    const a = [], o = (f) => f.objectType === "object";
    let l = 0;
    const s = (f) => {
      const h = l;
      return l++, `./${f}.json.data/${h}.bin`;
    };
    let i = 0;
    const c = [], u = (f) => {
      c.push(f);
      const h = i;
      return i = 8 + f.length, h;
    }, p = (f) => {
      const h = {};
      for (const [I, m] of Object.entries(f.data))
        if (o(m))
          h[I] = p(m);
        else if (m.type === "string")
          if (m.data.length > 128) {
            const S = async () => {
              const E = await pr(m.data), g = mr(E);
              h[I] = "base64zstd=" + g;
            };
            a.push(S());
          } else {
            const S = mr(m.data);
            h[I] = "base64=" + S;
          }
        else if (m.type === "bin")
          if (n) {
            const S = async () => {
              const E = await pr(m.data), g = mr(E);
              h[I] = "base64zstd=" + g;
            };
            a.push(S());
          } else if (t != null && t.dataWriteFunction) {
            const S = s("%FILENAME%"), E = S.replace("%FILENAME%", t.filenameWithoutJson);
            {
              const g = async () => {
                const v = await pr(m.data);
                if (!t.dataWriteFunction)
                  throw "data write function not provided";
                await t.dataWriteFunction(E, v);
              };
              a.push(g()), h[I] = "binzstd=" + S;
            }
          } else
            throw "data write function not provided";
        else if (m.type === "binoffset") {
          const S = u(m.data);
          h[I] = "binoffset=" + S;
        }
      return h;
    }, b = p(this.data);
    if (c.length) {
      const f = (I) => {
        const m = I.map((g) => g.length).reduce((g, v) => g + v, 0), S = new Uint8Array(m);
        let E = 0;
        for (const g of I)
          S.set(g, E), E += g.length;
        return S;
      };
      if ((t == null ? void 0 : t.mainDataWriteFunction) === void 0)
        throw "main data write function not provided";
      const h = f(c);
      a.push(t.mainDataWriteFunction(h));
    }
    return await Promise.all(a), JSON.stringify(b, void 0, 4);
  }
  async convertObject(t, n, a, o) {
    var m;
    const l = [], s = (m = n == null ? void 0 : n.mainDataFetchFunction) == null ? void 0 : m.call(n), i = async (S, E) => {
      if ((n == null ? void 0 : n.dataFetchFunction) === void 0)
        return Promise.reject("binary data files not provided");
      S.data = await n.dataFetchFunction(E.replace("%FILENAME", n.filename));
    }, c = async (S, E) => {
      if ((n == null ? void 0 : n.dataFetchFunction) === void 0)
        return Promise.reject("binary data files not provided");
      const g = await n.dataFetchFunction(E.replace("%FILENAME%", n.filename));
      S.data = await Od(g);
    }, u = async (S, E) => {
      S.data = await Od(Yr(E));
    }, p = async (S, E) => {
      if (s === void 0)
        return Promise.reject("binary data not provided");
      const g = await s;
      S.data = CI(g, E);
    }, b = (S) => {
      const E = {
        objectType: "object",
        data: {}
      };
      for (const [g, v] of Object.entries(S))
        if (typeof v == "object")
          E.data[g] = b(v);
        else if (typeof v == "string") {
          const T = TI(v);
          if (T) {
            const [R, L] = T;
            if (R === "base64")
              E.data[g] = {
                objectType: "value",
                type: "string",
                data: Yr(L)
              };
            else if (R === "base64zstd")
              if (o) {
                const C = {
                  objectType: "value",
                  type: "string",
                  data: new Uint8Array()
                };
                l.push(u(C, L)), E.data[g] = C;
              } else {
                const C = {
                  objectType: "value",
                  type: "bin",
                  data: new Uint8Array()
                };
                l.push(u(C, L)), E.data[g] = C;
              }
            else if (R === "bin") {
              const C = {
                objectType: "value",
                type: "bin",
                data: new Uint8Array()
              };
              l.push(i(C, L)), E.data[g] = C;
            } else if (R === "binzstd") {
              const C = {
                objectType: "value",
                type: "bin",
                data: new Uint8Array()
              };
              l.push(c(C, L)), E.data[g] = C;
            } else if (R === "binoffset") {
              const C = {
                objectType: "value",
                type: "binoffset",
                data: new Uint8Array()
              }, A = parseInt(L);
              if (isNaN(A))
                throw "failed to parse bin offset";
              l.push(p(C, A)), E.data[g] = C;
            }
          }
        }
      return E;
    }, f = b(t), h = l.length, I = {
      loaded: 0,
      total: h + 1
    };
    a == null || a(I);
    for (const S of l)
      S.then(() => {
        I.loaded++, a == null || a(I);
      });
    return await Promise.all(l), I.loaded = h, a == null || a(I), f;
  }
}
const NI = new TextDecoder("utf-8", { fatal: !0 }), LI = new TextDecoder("iso-8859-1"), vi = (e) => {
  try {
    return NI.decode(e);
  } catch {
    return LI.decode(e);
  }
}, OI = (e) => parseFloat(vi(e)), Ds = (e) => parseInt(vi(e)), As = (e, t) => {
  const n = e.data[t];
  if (!n)
    throw `missing key: ${t}`;
  if (n.objectType === "object")
    throw `expected value, found object at ${t}`;
  return n;
}, qo = (e, t) => {
  const n = e.data[t];
  if (!n)
    throw `missing key: ${t}`;
  if (n.objectType === "value")
    throw `expected object, found value at ${t}`;
  return n;
}, $n = (e, t) => Ds(As(e, t).data), DI = (e, t) => vi(As(e, t).data), tf = (e, t, n) => {
  if (e.length !== n)
    throw "length mismatch: expected vector " + t + " with length " + n;
}, AI = (e, t, n) => {
  const a = DI(e, t).trim().split(" ").map((o) => parseFloat(o));
  return tf(a, t, n), a;
}, ku = (e, t, n) => {
  var o;
  const a = (o = va(e, t)) == null ? void 0 : o.trim().split(" ").map((l) => parseFloat(l));
  return a !== void 0 && n !== void 0 && tf(a, t, n), a;
}, wo = (e, t) => AI(e, t, 3), Gi = (e, t) => ku(e, t, 16), RI = (e, t) => ku(e, t, 3), MI = (e, t) => ku(e, t, 2), Vu = (e, t) => {
  if (!t.length)
    return;
  let n = e;
  for (const o of t)
    if (o !== t[t.length - 1]) {
      const l = n.data[o];
      if (l !== void 0 && l.objectType === "object")
        n = l;
      else
        return;
    }
  const a = n.data[t[t.length - 1]];
  if (a !== void 0 && a.objectType === "value")
    return a;
}, PI = (e, t) => {
  const n = Vu(e, t);
  if (!n) throw "value missing: " + t;
  return n;
}, nf = (e, t) => {
  const n = Vl(e, t);
  if (n === void 0) throw "int missing: " + t;
  return n;
}, Vl = (e, t) => {
  const n = Vu(e, t);
  if (n)
    return Ds(n.data);
}, Rs = (e, t) => {
  const n = af(e, t);
  if (n === void 0)
    throw "string missing: " + t;
  return n;
}, af = (e, t) => {
  const n = Vu(e, t);
  if (n !== void 0)
    return vi(n.data);
}, Ms = (e, t) => {
  const n = e.data[t];
  if (n && n.objectType === "value")
    return n;
}, en = (e, t) => {
  const n = e.data[t];
  if (n && n.objectType === "object")
    return n;
}, va = (e, t) => {
  const n = Ms(e, t);
  if (n !== void 0)
    return vi(n.data);
}, Ha = (e, t) => {
  const n = Ms(e, t);
  if (n !== void 0)
    return Ds(n.data);
}, At = (e, t) => {
  const n = Ms(e, t);
  if (n !== void 0)
    return OI(n.data);
}, ui = (e, t) => {
  const n = Ms(e, t);
  if (n !== void 0) {
    const a = Ds(n.data);
    return isNaN(a) ? void 0 : a === 1;
  } else
    return;
};
function Zn(e) {
  return {
    objectType: "value",
    type: "string",
    data: new TextEncoder().encode(e)
  };
}
function gt(e) {
  return Zn(e.toString());
}
function lo(e) {
  return Zn(e ? "1" : "0");
}
function Io(e) {
  let t = e.join(" ");
  return e.length && (t = t + " "), Zn(t);
}
function Ps(e, t, n, a) {
  let o = e, l = 0;
  for (const s of t) {
    if (s !== t[t.length - 1])
      if (s in o.data) {
        const i = o.data[s];
        if (i.objectType === "value")
          throw "write error: expected object, found value at key " + t.slice(0, l + 1);
        o = i;
      } else {
        const i = {
          objectType: "object",
          data: {}
        };
        o.data[s] = i, o = i;
      }
    l++;
  }
  o.data[t[t.length - 1]] = a(n);
}
function xs(e, t, n) {
  Ps(e, t, n, Zn);
}
function Qo(e, t, n) {
  Ps(e, t, n, gt);
}
function el(e, t, n) {
  Ps(e, t, n, Io);
}
function xI(e, t, n) {
  Ps(e, t, n, (o) => ({
    data: new Uint8Array(o.buffer),
    objectType: "value",
    type: "bin"
  }));
}
async function Lx(e) {
  const t = new fi();
  if (await t.loadAsync(e), Object.keys(t.files).length == 0)
    return null;
  const n = [".prinfo", ".mobile.json", ".pr.json", ".stlinfo.json", "erp"], a = Object.keys(t.files), o = (l) => a.some((s) => s.endsWith(l));
  if (n.every(o)) {
    const l = a.find((i) => i.endsWith(".mobile.json")), s = a.find((i) => i.endsWith(".erp"));
    if (l && s) {
      const c = await (await t.files[l].async("blob")).arrayBuffer(), p = await (await t.files[s].async("blob")).arrayBuffer(), f = new TextDecoder("utf-8").decode(c), I = new TextDecoder("utf-8").decode(p), m = JSON.parse(I), S = new ba(), E = {
        mainDataFetchFunction: async () => new Uint8Array(0),
        dataFetchFunction: async () => new Uint8Array(0),
        filename: l
      };
      try {
        await S.load(f, E, void 0, !0);
        let g = !1;
        return {
          mobile: S,
          data: {
            filename: E.filename,
            patientName: m.project.patient.name,
            pBDate: m.project.patient.birthDate
          }
        };
      } catch (g) {
        console.error("Error parsing mobile.json:", g);
      }
    }
    return null;
  }
  return null;
}
async function Ox(e) {
  const t = new fi();
  if (await t.loadAsync(e), Object.keys(t.files).length == 0)
    return null;
  const n = [".erp"], a = Object.keys(t.files), o = (l) => a.some((s) => s.endsWith(l));
  if (n.every(o)) {
    const l = a.find((s) => s.endsWith(".erp"));
    if (l) {
      const s = t.file(l);
      if (!s)
        return null;
      const i = await (await s.async("blob")).arrayBuffer(), c = new TextDecoder("utf-8").decode(i).replace(/^\uFEFF/, "");
      return JSON.parse(c);
    }
    return null;
  }
  return null;
}
async function Dx(e, t, n, a, o, l) {
  const s = new fi();
  if (await s.loadAsync(t), Object.keys(s.files).length == 0)
    return !1;
  const i = [".prinfo", ".mobile.json", ".pr.json", ".stlinfo.json"], c = Object.keys(s.files), u = (p) => c.some((b) => b.endsWith(p));
  if (i.every(u)) {
    const p = c.find((b) => b.endsWith(".mobile.json"));
    if (p) {
      let b;
      const f = c.find((v) => v.endsWith(".erp"));
      if (f)
        try {
          const T = await (await s.files[f].async("blob")).arrayBuffer(), R = new TextDecoder("utf-8").decode(T).replace(/^\uFEFF/, ""), L = JSON.parse(R);
          L != null && L.project && typeof L.project == "object" && (b = L.project);
        } catch (v) {
          console.warn("Unable to parse .erp file while creating project metadata.", v);
        }
      const I = await (await s.files[p].async("blob")).arrayBuffer(), S = new TextDecoder("utf-8").decode(I), E = new ba(), g = {
        mainDataFetchFunction: async () => new Uint8Array(0),
        dataFetchFunction: async () => new Uint8Array(0),
        filename: p
      };
      try {
        await E.load(S, g, void 0, !0), E.data.data.LOAD_OBJECTS_FROM_PATIENT = lo(!0), E.data.data.SEGMENTATION_INVOKED_BY_USER = lo(!1);
        const v = [], T = [], R = `${a}.mobile.json`, L = await E.write(
          {
            dataWriteFunction: async (H, M) => {
              T.push([H.slice(2, H.length), M]);
            },
            filenameWithoutJson: R.slice(0, R.length - 5)
          },
          !0
        );
        v.push([R, L]), v.forEach(([H, M]) => s.file(H, M)), T.forEach(([H, M]) => s.file(H, M)), T.length && console.warn("There should not be binaries in mobile!!!");
        const C = await s.generateAsync({
          type: "blob",
          compression: "DEFLATE",
          // Enable compression
          compressionOptions: { level: 6 }
          // Optional: 1 (fastest) to 9 (best compression)
        }), A = (/* @__PURE__ */ new Date()).toISOString();
        await e.uploadFile(
          n,
          a + ".zip",
          "project",
          C,
          (H) => {
            o(H);
          },
          A
        );
        const j = v[0][1], N = new Blob([j], { type: "text/plain" });
        await e.uploadFile(
          n,
          a + ".zip.mobile.json",
          "mobile",
          N,
          (H) => {
            o(H);
          },
          A
        );
        let x = "New Project";
        const z = E.data.data.PLANNER_PROJECT_STEP;
        if ((z == null ? void 0 : z.objectType) === "value" && z.type === "string") {
          const H = new TextDecoder("utf-8").decode(z.data).trim();
          H && (x = H);
        }
        const X = {
          erp: {},
          extra: {
            erp: {
              ...b ? { project: b } : {}
            },
            latestProjectStepShort: x
          },
          format: "json"
        };
        return await e.uploadMetadataToProject(n, a + ".zip", X), !0;
      } catch (v) {
        return console.warn("Error parsing mobile.json:", v), !1;
      }
    }
    return !1;
  }
  return !1;
}
var bt = /* @__PURE__ */ ((e) => (e.ImplantPlannerBase = "ImplantPlannerBase", e.WeblinkViewer = "WeblinkViewer", e))(bt || {});
function fr(e, t) {
  return `${e.name}.${t}`;
}
function of(e) {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0");
  return `${t}${n}${a}`;
}
function jI(e, t, n) {
  return {
    dataFetchFunction: async () => {
      const o = await n.getBinaryProjectFileFromZipByType(e, t, "bin");
      return new Uint8Array(o.data);
    },
    filename: t.endsWith(".zip") ? t.slice(0, t.length - 4) : t
  };
}
function FI(e, t, n, a, o) {
  return {
    dataFetchFunction: async (l) => {
      l = l.replaceAll("\\", "/"), l = l.replace("./", "");
      const s = a.find((i) => l === `${i.name}.${i.fileType}`);
      if (s) {
        const i = await o.getProjectFileFromZipById(e, t, s.id);
        return new Uint8Array(i.data);
      }
      throw new Error("File not found");
    },
    filename: n
  };
}
async function Ax(e, t, n, a) {
  const o = new ba();
  return await o.loadFromObject(await e, jI(t, n, a)), o.data;
}
async function gr(e, t, n, a, o, l, s, i) {
  const c = new ba();
  return await c.loadFromObject(await e, FI(t, n, a, o, l), s, i), c.data;
}
function Bu(e, t = !1) {
  let n = [
    Ie.SAVE,
    Ie.SAVE_AS,
    Ie.RESET,
    Ie.LAYOUT,
    Ie.SCREENSHOT,
    Ie.W_L,
    Ie.UNDO,
    Ie.REDO,
    Ie.SETTINGS,
    Ie.INFO,
    Ie.HELP,
    Ie.EXIT
  ];
  return e === bt.ImplantPlannerBase && n.push(Ie.RULER), (e === bt.WeblinkViewer || t) && (n = n.filter((a) => a !== Ie.SAVE && a !== Ie.SAVE_AS)), n;
}
function $I() {
  const e = document.getElementById("mainContainer");
  e ? (e.style.setProperty("background", "var(--p-rg-component-background-color)", "important"), kI()) : console.error("Element with ID 'mainContainer' not found."), lf();
}
function kI() {
  const e = document.getElementById("wizard-container");
  e ? e.classList.add("stl-wiz-padding") : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function VI() {
  const e = document.getElementById("wizardTabContainer");
  e ? e.style.display = "none" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function BI() {
  const e = document.getElementById("wizardTabContainer");
  e ? e.style.display = "flex" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function Kr() {
  const e = document.getElementById("toggleWizardContainer");
  e ? e.style.display = "flex" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function lf() {
  const e = document.getElementById("toggleWizardContainer");
  e ? e.style.display = "none" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
const UI = { key: 0 }, GI = {
  key: 1,
  class: "m-flex-v gap-2 flex flex-col h-full ml-1 stl-picker-layout"
}, WI = {
  class: "flex flex-row",
  style: { "pointer-events": "auto" }
}, zI = { class: "font-medium text-4xl" }, HI = { class: "m-flex-h" }, YI = { class: "m-flex-item-center" }, KI = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, ZI = { class: "m-flex-h" }, JI = { class: "m-flex-item-center" }, XI = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, qI = {
  key: 0,
  class: "m-flex-h"
}, QI = { class: "flex items-center justify-between m-flex-item-center" }, eE = { class: "ml-1 flex items-center" }, tE = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, nE = {
  key: 1,
  class: "m-flex-h"
}, aE = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, oE = {
  class: "flex flex-col w-4/12 gap-2",
  style: { "min-height": "0", overflow: "hidden" }
}, lE = { class: "flex items-center justify-between" }, iE = { class: "font-medium" }, sE = { class: "ml-1 flex items-center" }, rE = {
  class: "flex flex-col w-4/12 gap-2",
  style: { "min-height": "0", overflow: "hidden" }
}, uE = {
  class: "flex items-center justify-between",
  style: { flex: "0 0 21px", "min-height": "0", "max-height": "21px" }
}, cE = {
  class: "font-medium",
  style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
}, dE = {
  class: "flex items-center justify-between",
  style: { flex: "0 0 21px", "min-height": "0", "max-height": "21px" }
}, pE = {
  class: "font-medium",
  style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
}, mE = {
  class: "flex flex-col w-4/12 gap-2",
  style: { "min-height": "0", overflow: "hidden" }
}, fE = { class: "flex items-center justify-between" }, gE = { class: "font-medium" }, hE = { class: "ml-1 flex items-center" }, xd = "height: max(3rem, calc(10vh - 3.25rem)); max-height: max(3rem, calc(10vh - 3.25rem))", bE = /* @__PURE__ */ qe({
  __name: "STLPicker",
  props: /* @__PURE__ */ xn({
    stlSelection: {},
    selection: { default: () => ({}) },
    implantList: {},
    selectedTooth: {}
  }, {
    showSecondaryComponents: { type: Boolean, default: !1 },
    showSecondaryComponentsModifiers: {}
  }),
  emits: /* @__PURE__ */ xn(["implantChange", "stlSelectionUpdate"], ["update:showSecondaryComponents"]),
  setup(e, { emit: t }) {
    const n = e;
    function a(_) {
      var Y;
      const D = (Y = _.sellingCode) == null ? void 0 : Y.trim();
      return {
        name: D ? `${_.name} / ${D}` : _.name,
        value: _
      };
    }
    const o = t, l = et({
      listStyle: "height: 20vh",
      manufacturers: [],
      models: [],
      objects: []
    }), s = et({
      manufacturers: [],
      models: []
    }), i = F([]), c = et({
      manufacturer: P(),
      model: P(),
      abutment: P()
    }), u = et({
      manufacturer: null,
      model: null,
      implant: null,
      implantData: null,
      abManufacturer: null,
      abModel: null,
      abutment: null,
      abutmentData: null,
      scanAbutment: null,
      scanAbutmentData: null,
      secondaryAbutment: null,
      secondaryAbutmentData: null,
      secondaryScanAbutment: null,
      secondaryScanAbutmentData: null,
      sleeveManufacturer: null,
      sleeve: null,
      sleeveData: null,
      sleeveNegativeData: null,
      sleeveManuallyChanged: 0,
      sleeveReferenced: 0,
      implantExtrusion: null,
      implantExtrusionData: null
    }), p = et({
      clicked: !1,
      state: !1,
      disabled: !1
    }), b = et({
      clicked: !1,
      state: !1,
      disabled: !1
    }), f = et({
      clicked: !1,
      state: !1,
      disabled: !1
    }), h = F(null), I = F(null), m = F(null), S = F(null), E = fl();
    if (!E.cachedResponse)
      throw new Error("STL Library cache not initialized");
    const g = new lu(E.cachedResponse, iu()), v = pn();
    function T(_, D, Y) {
      if (!D)
        return _;
      const Q = _.find((ae) => Y(ae.value, D.value));
      return Q ? Q === D ? _ : _.map((ae) => ae === Q ? D : ae) : [D, ..._];
    }
    function R(_, D) {
      const Y = [];
      for (const Q of _)
        Y.some((ae) => D(ae.value, Q.value)) || Y.push(Q);
      return Y;
    }
    function L(_) {
      const D = _ == null ? void 0 : _.trim().toLowerCase();
      return D || void 0;
    }
    function C(_) {
      const D = Number(_);
      return Number.isFinite(D) ? D : void 0;
    }
    function A(_, D) {
      const Y = C(_.id), Q = C(D.id);
      if (Y !== void 0 && Q !== void 0)
        return Y === Q;
      const ae = L(_.uuid), ge = L(D.uuid);
      if (ae && ge)
        return ae === ge;
      const Fe = L(_.stl_file_guid), Me = L(D.stl_file_guid);
      if (Fe && Me)
        return Fe === Me;
      const je = L(_.s3ObjectRef), dt = L(D.s3ObjectRef);
      if (je && dt)
        return je === dt;
      const vt = L(_.name), mt = L(D.name);
      return !!vt && vt === mt;
    }
    const j = Te(() => {
      var _, D;
      return g.getScanAbutmentListModels(p.state, (D = (_ = u.implant) == null ? void 0 : _.value) == null ? void 0 : D.scanAbutmentIds);
    }), N = Te(() => {
      var _, D;
      return g.getSecondaryAbutmentListModels((D = (_ = u.abutment) == null ? void 0 : _.value) == null ? void 0 : D.secondaryAbutmentIds);
    }), x = Te(() => {
      var _, D;
      return g.getSecondaryScanAbutmentListModels((D = (_ = u.abutment) == null ? void 0 : _.value) == null ? void 0 : D.secondaryScanAbutmentIds);
    }), z = Te(() => {
      var Y, Q;
      const _ = g.getAnalogExtrusionListModels(b.state, (Q = (Y = u.implant) == null ? void 0 : Y.value) == null ? void 0 : Q.extrusionIds), D = T(_, S.value, (ae, ge) => A(ae, ge));
      return R(D, (ae, ge) => A(ae, ge));
    }), X = Te(() => {
      var _, D;
      return g.getImplantSleeveListModels(f.state, (D = (_ = u.implant) == null ? void 0 : _.value) == null ? void 0 : D.sleeveIds);
    }), H = F(!1), M = F(!1), te = F(!1), ne = F(!1), W = F(0), se = F(!1), be = Ln(e, "showSecondaryComponents"), Re = async () => {
      te.value = !1, await fn(), te.value = !0;
    }, U = (_, D) => _.find((Y) => {
      const Q = Y.value, ae = D.value;
      return Q.id === ae.id || !!Q.uuid && Q.uuid === ae.uuid || !!Q.s3ObjectRef && Q.s3ObjectRef === ae.s3ObjectRef || Q.name === ae.name;
    }), ie = (_, D) => {
      if (!_ && !D)
        return !0;
      if (!_ || !D)
        return !1;
      const Y = _.value, Q = D.value;
      return _.name === D.name && Y.id === Q.id && Y.uuid === Q.uuid && Y.s3ObjectRef === Q.s3ObjectRef && Y.name === Q.name && Y.manufacturerName === Q.manufacturerName;
    }, re = (_, D) => {
      if (!_ && !D)
        return !0;
      if (!_ || !D)
        return !1;
      const Y = _.value, Q = D.value;
      return _.name === D.name && Y.id === Q.id && Y.uuid === Q.uuid && Y.s3ObjectRef === Q.s3ObjectRef && Y.name === Q.name;
    }, q = (_, D) => {
      const Y = C(_.id), Q = C(D.id);
      if (Y !== void 0 && Q !== void 0)
        return Y === Q;
      const ae = L(_.stl_guid), ge = L(D.stl_guid);
      if (ae && ge)
        return ae === ge;
      const Fe = L(_.name), Me = L(D.name);
      return !!Fe && Fe === Me;
    }, De = () => {
      const _ = h.value ?? u.scanAbutment;
      if (!_)
        return;
      const D = U(j.value, _);
      D && (ie(D, h.value) || (h.value = D), ie(D, u.scanAbutment) || (u.scanAbutment = D));
    };
    ot(
      () => p.state,
      async (_, D) => {
        _ !== D && (await fn(), De(), await fn(), await Re());
      }
    ), ot(
      () => b.state,
      async (_, D) => {
        _ !== D && await Re();
      }
    );
    const _e = () => {
      W.value === 0 && v.showLoading(nt("implant-planner.loadingObject")), W.value += 1;
    }, xe = () => {
      W.value > 0 && (W.value -= 1), W.value === 0 && v.hideLoading();
    };
    function k(..._) {
      for (const D of Array.from(_))
        Wa(async () => {
          const Y = D.ref.value;
          if (Y && D.target && D.source) {
            const ae = D.source(Y.value.id).map(a);
            D.target.value = ae;
          }
          if (Y || (D.target.value = []), D.invalidate)
            for (const Q of D.invalidate)
              Q.value = null;
        });
    }
    async function K(_) {
      se.value = !0;
      try {
        if (!_.implantId)
          return;
        let D, Y;
        const Q = g.getImplantTreeById(_.implantId);
        if (Q) {
          const { object: ae, model: ge, manufacturer: Fe } = Q;
          if (D = ae, u.manufacturer = a(Fe), await fn(), u.model = a(ge), await fn(), u.implant = a(ae), _.abutmentId) {
            const Me = g.getAbutmentTreeById(_.abutmentId);
            if (Me) {
              const { object: je, model: dt, manufacturer: vt } = Me;
              Y = je, await fn();
              const mt = i.value.find((kt) => kt.name === vt.name);
              if (mt) {
                c.manufacturer = mt;
                const kt = mt.children.find((Ct) => Ct.name === dt.name);
                if (kt) {
                  const Ct = kt;
                  c.model = Ct;
                  const ft = Ct.children.find((Vt) => {
                    var Wt;
                    return ((Wt = Vt.value) == null ? void 0 : Wt.id) === je.id;
                  });
                  ft && (c.abutment = ft);
                }
              }
            }
          }
        }
        if (_.sleeveId) {
          const ae = g.getSleeveTreeByName(_.sleeveId);
          if (ae) {
            const { object: ge, manufacturer: Fe } = ae;
            u.sleeveManufacturer = a(Fe), await fn(), u.sleeve = a(ge);
          }
        }
        if (_.scanAbutmentId) {
          const ge = g.getScanAbutmentListModels(p.state, D == null ? void 0 : D.scanAbutmentIds).find((Fe) => Fe.value.uuid === _.scanAbutmentId);
          ge && (h.value = ge, u.scanAbutment = ge);
        }
        if (_.secondaryAbutmentId) {
          const ge = g.getSecondaryAbutmentListModels(Y == null ? void 0 : Y.secondaryAbutmentIds).find(
            (Fe) => Fe.value.uuid === _.secondaryAbutmentId
          );
          ge && (I.value = ge, u.secondaryAbutment = ge);
        }
        if (_.secondaryScanAbutmentId) {
          const ge = g.getSecondaryScanAbutmentListModels(Y == null ? void 0 : Y.secondaryScanAbutmentIds).find(
            (Fe) => Fe.value.uuid === _.secondaryScanAbutmentId
          );
          ge && (m.value = ge, u.secondaryScanAbutment = ge);
        }
        if (_.analogExtrusionUuid) {
          const ae = g.getAnalogExtrusionListModels(b.state, D == null ? void 0 : D.extrusionIds), ge = _.analogExtrusionUuid.trim(), Fe = ae.find((Me) => {
            const je = Me.value;
            return je.uuid === ge || je.name === ge || je.name.toLowerCase() === ge.toLowerCase();
          });
          Fe && (S.value = Fe, u.implantExtrusion = Fe, Fe.value.s3ObjectRef ? u.implantExtrusionData = g.getFile(Fe.value.s3ObjectRef) : u.implantExtrusionData = null);
        }
      } finally {
        await fn(), se.value = !1;
      }
    }
    const { implantList: Ae, selectedTooth: me } = ln(n), Ne = F(), Ge = () => {
      var _;
      return (_ = Ae == null ? void 0 : Ae.value) == null ? void 0 : _.find((D) => D.tooth === (me == null ? void 0 : me.value));
    }, Ue = () => {
      Ne.value = Ge();
    };
    Ue(), ot(Ae, () => Ue()), ot(me, () => Ue());
    let Ke = !1;
    const { stlSelection: st } = ln(n);
    ot(st, async (_) => {
      if (G) {
        if (Ke = !0, u.manufacturer = _.manufacturer, await fn(), u.model = _.model, await fn(), u.implant = _.implant, _.implant) {
          const D = await g.getDependantObjectsForImplant(_.implant.value.id);
          if (i.value = fe(D.abManufacturers, D.abModels, D.abAbutments), _.abManufacturer) {
            const Y = i.value.find((Q) => {
              var ae;
              return Q.name === ((ae = _.abManufacturer) == null ? void 0 : ae.name);
            });
            Y ? c.manufacturer = Y : c.manufacturer = P();
          }
          if (_.abManufacturer && _.abModel) {
            const Y = c.manufacturer.children.find((Q) => {
              var ae;
              return Q.name === ((ae = _.abModel) == null ? void 0 : ae.name);
            });
            Y ? c.model = Y : c.model = P();
          }
          if (_.abManufacturer && _.abModel && _.abutment) {
            const Y = c.model.children.find((Q) => {
              var ae, ge, Fe;
              return ((ae = Q.value) == null ? void 0 : ae.id) === ((Fe = (ge = _.abutment) == null ? void 0 : ge.value) == null ? void 0 : Fe.id);
            });
            Y ? c.abutment = Y : c.abutment = P();
          }
        }
        u.abManufacturer = _.abManufacturer, u.abModel = _.abModel, u.abutment = _.abutment, u.sleeveManufacturer = _.sleeveManufacturer, await fn(), u.sleeve = _.sleeve, u.sleeveReferenced = _.sleeveReferenced ?? (ls(_) ? 1 : 0), u.sleeveManuallyChanged = _.sleeveManuallyChanged ?? (u.sleeveReferenced ? 0 : 1), u.implantData = _.implantData, u.abutmentData = _.abutmentData, u.scanAbutment = _.scanAbutment, u.scanAbutmentData = _.scanAbutmentData, u.secondaryAbutment = _.secondaryAbutment, u.secondaryAbutmentData = _.secondaryAbutmentData, u.secondaryScanAbutment = _.secondaryScanAbutment, u.secondaryScanAbutmentData = _.secondaryScanAbutmentData, h.value = _.scanAbutment, I.value = _.secondaryAbutment, m.value = _.secondaryScanAbutment, Ke = !1;
      }
    });
    let G = !1;
    Mt(async () => {
      G = !0, l.manufacturers = g.implantManufacturers().map(a), n.selection && (await K(n.selection), await fn()), BS(), H.value = !0, await fn(), M.value = !0, te.value = !0, ne.value = !0, lf(), VI();
    }), Ka(() => {
      Kr(), BI(), VS(), W.value > 0 && v.hideLoading();
    }), k(
      {
        ref: ln(u).manufacturer,
        invalidate: [ln(u).model],
        target: ln(l).models,
        source: (_) => g.getImplantModelsForManufacturer(_)
      },
      {
        ref: ln(u).model,
        invalidate: [ln(u).implant, ln(u).implantData],
        target: ln(l).objects,
        source: (_) => g.getImplantsForModel(_)
      }
    ), Wa(() => {
      const _ = /* @__PURE__ */ new Map();
      for (const ae of X.value) {
        const ge = ae.value.pId, Fe = ae.value.manufacturerName;
        _.has(ge) || _.set(ge, {
          name: Fe,
          value: {
            id: ge,
            name: Fe
          }
        });
      }
      const D = Array.from(_.values()), Y = u.sleeveManufacturer, Q = Y ? D.find((ae) => ae.value.id === Y.value.id) ?? null : null;
      s.manufacturers = D, !Q && Y ? u.sleeveManufacturer = null : Q && Q !== Y && (u.sleeveManufacturer = Q);
    }), Wa(() => {
      var Fe, Me, je, dt;
      const _ = (Fe = u.sleeveManufacturer) == null ? void 0 : Fe.value;
      if (!_) {
        s.models = [], u.sleeve = null;
        return;
      }
      const D = ((je = (Me = u.implant) == null ? void 0 : Me.value) == null ? void 0 : je.sleeveIds) ?? [], Y = X.value.filter((vt) => vt.value.pId === _.id).map((vt) => ({ name: vt.name, value: vt.value })), Q = ((dt = u.sleeve) == null ? void 0 : dt.value.pId) === _.id ? u.sleeve : null, ae = Q && (f.state || D.includes(Q.value.id)) ? Q : null;
      !ae && u.sleeve && (u.sleeve = null);
      const ge = ae ? T(Y, ae, (vt, mt) => q(vt, mt)) : Y;
      s.models = R(ge, (vt, mt) => q(vt, mt));
    });
    function P(_, D, Y = []) {
      return {
        children: Y,
        name: _ || "",
        value: D
      };
    }
    function de(_) {
      var Y;
      const D = (Y = _.sellingCode) == null ? void 0 : Y.trim();
      return D ? `${_.name} / ${D}` : _.name;
    }
    function fe(_, D, Y) {
      const Q = [];
      for (const ae of _) {
        const ge = P(ae.name, ae);
        for (const Fe of D.filter((Me) => Me.pId === ae.id)) {
          const Me = P(Fe.name, Fe);
          for (const je of Y.filter((dt) => dt.pId === Fe.id))
            Me.children.push(P(de(je), je));
          ge.children.push(Me);
        }
        Q.push(ge);
      }
      return Q;
    }
    const ke = {
      width: "13.7vw !important"
    }, le = F("40%"), pe = F("calc(100% / 3)"), Z = Te(() => `calc(100% - ${le.value} - ${pe.value})`);
    function ee(_, D) {
      ot(D, () => {
        var Y;
        (Y = D.value) != null && Y.value ? _.value = { ...D.value, value: D.value.value } : _.value = null;
      });
    }
    ee(ln(u).abManufacturer, ln(c).manufacturer), ee(ln(u).abModel, ln(c).model), ee(ln(u).abutment, ln(c).abutment), ot(
      j,
      () => {
        se.value || De();
      },
      { flush: "post" }
    ), ot(
      z,
      (_) => {
        var Q;
        const D = (Q = S.value) == null ? void 0 : Q.value;
        if (se.value || !D || !_.length)
          return;
        const Y = _.find((ae) => A(ae.value, D));
        Y && Y !== S.value && (S.value = Y);
      },
      { flush: "post" }
    ), ot(h, (_) => {
      Ke || se.value || ie(_, u.scanAbutment) || (u.scanAbutment = _);
    }), ot(I, (_) => {
      Ke || se.value || (u.secondaryAbutment = _);
    }), ot(m, (_) => {
      Ke || se.value || (u.secondaryScanAbutment = _);
    }), ot(S, (_) => {
      Ke || se.value || (re(_, u.implantExtrusion) || (u.implantExtrusion = _), _ != null && _.value.s3ObjectRef ? u.implantExtrusionData = g.getFile(_.value.s3ObjectRef) : u.implantExtrusionData = null, $());
    }), ot(
      () => u.implant,
      async (_) => {
        var D, Y, Q, ae, ge;
        if (se.value || (h.value = null, S.value = null, u.sleeve = null, u.sleeveData = null, u.sleeveNegativeData = null), _ || (i.value = fe([], [], []), c.manufacturer = P(), c.model = P(), c.abutment = P()), !Ke && _) {
          _e();
          try {
            u.implantData = null;
            const Fe = _.value.id, Me = _.value.s3ObjectRef, je = g.getFile(Me), dt = await g.getDependantObjectsForImplant(Fe);
            i.value = fe(dt.abManufacturers, dt.abModels, dt.abAbutments), c.manufacturer = P(), c.model = P(), c.abutment = P(), u.abutmentData = null;
            const vt = await je;
            if (((D = u.implant) == null ? void 0 : D.value.s3ObjectRef) !== Me)
              return;
            if (u.implantData = vt, (Y = dt.extrusions) != null && Y.length) {
              const kt = (Q = u.implantExtrusion) == null ? void 0 : Q.value, Ct = _.value.defaultExtrusionId;
              let ft = dt.extrusions.find((Wt) => Wt.id === Ct) ?? dt.extrusions[0];
              if (kt) {
                const Wt = dt.extrusions.find((jn) => A(jn, kt));
                Wt && (ft = Wt);
              }
              const Vt = z.value.find((Wt) => A(Wt.value, ft)) ?? a(ft);
              re(Vt, u.implantExtrusion) || (u.implantExtrusion = Vt), re(Vt, S.value) || (S.value = Vt), ft.s3ObjectRef ? u.implantExtrusionData = g.getFile(ft.s3ObjectRef) : u.implantExtrusionData = null;
            } else
              u.implantExtrusion = null, u.implantExtrusionData = null, S.value = null;
            const mt = (ge = (ae = u.implant) == null ? void 0 : ae.value) == null ? void 0 : ge.defaultSleeveId;
            if (mt) {
              const kt = g.getSleeveTreeById(mt);
              if (kt) {
                ne.value = !1;
                const { object: Ct, manufacturer: ft } = kt;
                u.sleeveManufacturer = a(ft), fn().then(() => {
                  u.sleeve = a(Ct), ne.value = !1;
                });
              }
            }
            $();
          } finally {
            xe();
          }
        }
      }
    ), ot(
      () => u.abutment,
      async (_) => {
        var D;
        if (se.value || (I.value = null, m.value = null), !Ke && _) {
          _e();
          try {
            u.abutmentData = null;
            const Y = _.value.s3ObjectRef, Q = await g.getFile(Y);
            if (((D = u.abutment) == null ? void 0 : D.value.s3ObjectRef) !== Y)
              return;
            u.abutmentData = Q, $();
          } finally {
            xe();
          }
        }
      }
    ), ot(
      () => u.scanAbutment,
      async (_) => {
        var D, Y;
        if (!Ke) {
          if (!_) {
            u.scanAbutmentData = null, $();
            return;
          }
          _e();
          try {
            u.scanAbutmentData = null;
            const Q = (D = u.scanAbutment) == null ? void 0 : D.value.s3ObjectRef;
            if (Q) {
              const ae = await g.getFile(Q);
              if (((Y = u.scanAbutment) == null ? void 0 : Y.value.s3ObjectRef) !== Q)
                return;
              u.scanAbutmentData = ae;
            }
            $();
          } finally {
            xe();
          }
        }
      }
    ), ot(
      () => u.secondaryAbutment,
      async (_) => {
        var D, Y;
        if (!Ke) {
          if (!_) {
            u.secondaryAbutmentData = null, $();
            return;
          }
          _e();
          try {
            u.secondaryAbutmentData = null;
            const Q = (D = u.secondaryAbutment) == null ? void 0 : D.value.s3ObjectRef;
            if (Q) {
              const ae = await g.getFile(Q);
              if (((Y = u.secondaryAbutment) == null ? void 0 : Y.value.s3ObjectRef) !== Q)
                return;
              u.secondaryAbutmentData = ae;
            }
            $();
          } finally {
            xe();
          }
        }
      }
    ), ot(
      () => u.secondaryScanAbutment,
      async (_) => {
        var D, Y;
        if (!Ke) {
          if (!_) {
            u.secondaryScanAbutmentData = null, $();
            return;
          }
          _e();
          try {
            u.secondaryScanAbutmentData = null;
            const Q = (D = u.secondaryScanAbutment) == null ? void 0 : D.value.s3ObjectRef;
            if (Q) {
              const ae = await g.getFile(Q);
              if (((Y = u.secondaryScanAbutment) == null ? void 0 : Y.value.s3ObjectRef) !== Q)
                return;
              u.secondaryScanAbutmentData = ae;
            }
            $();
          } finally {
            xe();
          }
        }
      }
    ), ot(
      () => u.sleeve,
      async (_) => {
        var D, Y;
        if (!Ke) {
          if (!_) {
            u.sleeveReferenced = 0, u.sleeveManuallyChanged = 0;
            return;
          }
          _e();
          try {
            const Q = _.value.inverses3ObjectRef;
            if (Q && Q != "") {
              const Fe = await g.getFile(Q);
              ((D = u.sleeve) == null ? void 0 : D.value.inverses3ObjectRef) !== Q && console.log("WATNING: Selection of sleeve changed while loading!!!!!"), u.sleeveNegativeData = Fe;
            } else
              u.sleeveNegativeData = null;
            const ae = _.value.s3ObjectRef;
            if (ae && ae != "") {
              const Fe = await g.getFile(ae);
              ((Y = u.sleeve) == null ? void 0 : Y.value.s3ObjectRef) !== ae && console.log("WATNING: Selection of sleeve changed while loading!!!!!"), u.sleeveData = Fe;
            } else
              u.sleeveData = null;
            const ge = ls(u);
            u.sleeveReferenced = ge ? 1 : 0, u.sleeveManuallyChanged = ge ? 0 : 1, $();
          } finally {
            xe();
          }
        }
      }
    );
    const $ = () => {
      se.value || u.implant && !u.implantData || u.abutment && !u.abutmentData || u.scanAbutment && !u.scanAbutmentData || u.secondaryAbutment && !u.secondaryAbutmentData || u.secondaryScanAbutment && !u.secondaryScanAbutmentData || o("stlSelectionUpdate", u);
    };
    return ot(
      Ne,
      (_, D) => {
        _ && (_ == null ? void 0 : _.tooth) !== (D == null ? void 0 : D.tooth) && D && o("implantChange", _.toothId);
      },
      { deep: !0 }
    ), (_, D) => {
      var Y, Q;
      return O(), J(ze, null, [
        H.value ? ue("", !0) : (O(), J("div", UI, [
          d(r(tb), { animationDuration: "0.75s" })
        ])),
        H.value ? (O(), J("div", GI, [
          (O(), he(au, { to: "#aboveRenderWindowContainer" }, [
            y("span", WI, [
              y("span", {
                class: "font-medium text-4xl",
                style: Tt({ width: le.value })
              }, V(_.$t("implant-planner.selectImplant")), 5),
              y("span", {
                class: "flex flex-row justify-between",
                style: Tt({ width: Z.value })
              }, [
                y("span", zI, V(_.$t("implant-planner.implantPreview")), 1),
                d(r(Pn), {
                  modelValue: Ne.value,
                  "onUpdate:modelValue": D[0] || (D[0] = (ae) => Ne.value = ae),
                  options: n.implantList,
                  optionLabel: "name",
                  placeholder: _.$t("implant-planner.selectAnImplant"),
                  class: "w-full md:w-56",
                  style: ke
                }, null, 8, ["modelValue", "options", "placeholder"])
              ], 4)
            ])
          ])),
          y("div", {
            class: "m-flex-h h-full overflow-y-auto",
            style: Tt([{ "pointer-events": "auto" }, { width: le.value }])
          }, [
            y("div", HI, [
              y("label", YI, V(_.$t("implant-planner.implants")), 1),
              y("div", KI, [
                d(r(Bn), {
                  modelValue: u.manufacturer,
                  "onUpdate:modelValue": D[1] || (D[1] = (ae) => u.manufacturer = ae),
                  model: l.manufacturers,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: M.value,
                  "data-cy": "implantManufacturerList",
                  filterPlaceholder: "Manufacturer"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(Bn), {
                  modelValue: u.model,
                  "onUpdate:modelValue": D[2] || (D[2] = (ae) => u.model = ae),
                  model: l.models,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: M.value,
                  "data-cy": "implantModelList",
                  filterPlaceholder: "Model"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(Bn), {
                  modelValue: u.implant,
                  "onUpdate:modelValue": D[3] || (D[3] = (ae) => u.implant = ae),
                  model: l.objects,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: M.value,
                  "data-cy": "implantList",
                  filterPlaceholder: "Sizes"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"])
              ])
            ]),
            y("div", ZI, [
              y("label", JI, V(_.$t("implant-planner.abutments")), 1),
              y("div", XI, [
                d(r(Bn), {
                  modelValue: c.manufacturer,
                  "onUpdate:modelValue": D[4] || (D[4] = (ae) => c.manufacturer = ae),
                  model: i.value,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: M.value,
                  "data-cy": "abManufacturerList",
                  filterPlaceholder: "Manufacturer"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(Bn), {
                  modelValue: c.model,
                  "onUpdate:modelValue": D[5] || (D[5] = (ae) => c.model = ae),
                  model: ((Y = c.manufacturer) == null ? void 0 : Y.children) || [],
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: M.value,
                  "data-cy": "abModelList",
                  filterPlaceholder: "Model"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(Bn), {
                  modelValue: c.abutment,
                  "onUpdate:modelValue": D[6] || (D[6] = (ae) => c.abutment = ae),
                  model: ((Q = c.model) == null ? void 0 : Q.children) || [],
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: M.value,
                  "data-cy": "abutmentList",
                  filterPlaceholder: "Sizes"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"])
              ])
            ]),
            be.value ? ue("", !0) : (O(), J("div", qI, [
              y("div", QI, [
                y("label", null, V(_.$t("implant-planner.sleeves")), 1),
                d(r(io), {
                  state: f.state,
                  "onUpdate:state": D[7] || (D[7] = (ae) => f.state = ae),
                  disabled: f.disabled,
                  "onUpdate:disabled": D[8] || (D[8] = (ae) => f.disabled = ae),
                  class: "ml-2"
                }, {
                  trueLabel: w(() => [
                    y("span", eE, V(_.$t("implant-planner.showAll")), 1)
                  ]),
                  _: 1
                }, 8, ["state", "disabled"])
              ]),
              y("div", tE, [
                d(r(Bn), {
                  modelValue: u.sleeveManufacturer,
                  "onUpdate:modelValue": D[9] || (D[9] = (ae) => u.sleeveManufacturer = ae),
                  model: s.manufacturers,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: ne.value,
                  "data-cy": "sleeveManufacturerList",
                  filterPlaceholder: "Manufacturer"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(Bn), {
                  modelValue: u.sleeve,
                  "onUpdate:modelValue": D[10] || (D[10] = (ae) => u.sleeve = ae),
                  model: s.models,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: ne.value,
                  "data-cy": "sleeveModelList",
                  filterPlaceholder: "Model"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"])
              ])
            ])),
            be.value ? (O(), J("div", nE, [
              y("div", aE, [
                y("div", oE, [
                  y("div", lE, [
                    y("span", iE, V(_.$t("implant-planner.scanAbutment")), 1),
                    d(r(io), {
                      state: p.state,
                      "onUpdate:state": D[11] || (D[11] = (ae) => p.state = ae),
                      disabled: p.disabled,
                      "onUpdate:disabled": D[12] || (D[12] = (ae) => p.disabled = ae)
                    }, {
                      trueLabel: w(() => [
                        y("span", sE, V(_.$t("implant-planner.showAll")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])
                  ]),
                  d(r(Bn), {
                    modelValue: h.value,
                    "onUpdate:modelValue": D[13] || (D[13] = (ae) => h.value = ae),
                    model: j.value,
                    class: "w-full",
                    listStyle: l.listStyle,
                    disableScrollIntoView: te.value,
                    "data-cy": "scanAbutmentList",
                    filterPlaceholder: _.$t("implant-planner.scanAbutment")
                  }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView", "filterPlaceholder"])
                ]),
                y("div", rE, [
                  y("div", uE, [
                    y("span", cE, V(_.$t("implant-planner.secondaryAbutment")), 1)
                  ]),
                  d(r(Bn), {
                    modelValue: I.value,
                    "onUpdate:modelValue": D[14] || (D[14] = (ae) => I.value = ae),
                    model: N.value,
                    class: "w-full",
                    listStyle: xd,
                    disableScrollIntoView: te.value,
                    "data-cy": "secondaryAbutmentList",
                    filterPlaceholder: _.$t("implant-planner.secondaryAbutment"),
                    style: { flex: "0 1 auto", "min-height": "0", overflow: "hidden" }
                  }, null, 8, ["modelValue", "model", "disableScrollIntoView", "filterPlaceholder"]),
                  y("div", dE, [
                    y("span", pE, V(_.$t("implant-planner.secondaryScanAbutment")), 1)
                  ]),
                  d(r(Bn), {
                    modelValue: m.value,
                    "onUpdate:modelValue": D[15] || (D[15] = (ae) => m.value = ae),
                    model: x.value,
                    class: "w-full",
                    listStyle: xd,
                    disableScrollIntoView: te.value,
                    "data-cy": "secondaryScanAbutmentList",
                    filterPlaceholder: _.$t("implant-planner.secondaryScanAbutment"),
                    style: { flex: "0 1 auto", "min-height": "0", overflow: "hidden" }
                  }, null, 8, ["modelValue", "model", "disableScrollIntoView", "filterPlaceholder"])
                ]),
                y("div", mE, [
                  y("div", fE, [
                    y("span", gE, V(_.$t("implant-planner.analogExtrusion")), 1),
                    d(r(io), {
                      state: b.state,
                      "onUpdate:state": D[16] || (D[16] = (ae) => b.state = ae),
                      disabled: b.disabled,
                      "onUpdate:disabled": D[17] || (D[17] = (ae) => b.disabled = ae)
                    }, {
                      trueLabel: w(() => [
                        y("span", hE, V(_.$t("implant-planner.showAll")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])
                  ]),
                  d(r(Bn), {
                    modelValue: S.value,
                    "onUpdate:modelValue": D[18] || (D[18] = (ae) => S.value = ae),
                    model: z.value,
                    class: "w-full",
                    listStyle: l.listStyle,
                    disableScrollIntoView: te.value,
                    "data-cy": "analogExtrusionList",
                    filterPlaceholder: _.$t("implant-planner.analogExtrusion")
                  }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView", "filterPlaceholder"])
                ])
              ])
            ])) : ue("", !0)
          ], 4)
        ])) : ue("", !0)
      ], 64);
    };
  }
});
var sf = typeof global == "object" && global && global.Object === Object && global, vE = typeof self == "object" && self && self.Object === Object && self, Ma = sf || vE || Function("return this")(), dl = Ma.Symbol, rf = Object.prototype, yE = rf.hasOwnProperty, _E = rf.toString, Ml = dl ? dl.toStringTag : void 0;
function wE(e) {
  var t = yE.call(e, Ml), n = e[Ml];
  try {
    e[Ml] = void 0;
    var a = !0;
  } catch {
  }
  var o = _E.call(e);
  return a && (t ? e[Ml] = n : delete e[Ml]), o;
}
var SE = Object.prototype, IE = SE.toString;
function EE(e) {
  return IE.call(e);
}
var TE = "[object Null]", CE = "[object Undefined]", jd = dl ? dl.toStringTag : void 0;
function yi(e) {
  return e == null ? e === void 0 ? CE : TE : jd && jd in Object(e) ? wE(e) : EE(e);
}
function _i(e) {
  return e != null && typeof e == "object";
}
var Uu = Array.isArray;
function js(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var NE = "[object AsyncFunction]", LE = "[object Function]", OE = "[object GeneratorFunction]", DE = "[object Proxy]";
function uf(e) {
  if (!js(e))
    return !1;
  var t = yi(e);
  return t == LE || t == OE || t == NE || t == DE;
}
var hr = Ma["__core-js_shared__"], Fd = (function() {
  var e = /[^.]+$/.exec(hr && hr.keys && hr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function AE(e) {
  return !!Fd && Fd in e;
}
var RE = Function.prototype, ME = RE.toString;
function Fo(e) {
  if (e != null) {
    try {
      return ME.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var PE = /[\\^$.*+?()[\]{}|]/g, xE = /^\[object .+?Constructor\]$/, jE = Function.prototype, FE = Object.prototype, $E = jE.toString, kE = FE.hasOwnProperty, VE = RegExp(
  "^" + $E.call(kE).replace(PE, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function BE(e) {
  if (!js(e) || AE(e))
    return !1;
  var t = uf(e) ? VE : xE;
  return t.test(Fo(e));
}
function UE(e, t) {
  return e == null ? void 0 : e[t];
}
function $o(e, t) {
  var n = UE(e, t);
  return BE(n) ? n : void 0;
}
var Zr = $o(Ma, "WeakMap"), $d = Object.create, GE = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(t) {
    if (!js(t))
      return {};
    if ($d)
      return $d(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
})(), kd = (function() {
  try {
    var e = $o(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})();
function WE(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var zE = 9007199254740991, HE = /^(?:0|[1-9]\d*)$/;
function YE(e, t) {
  var n = typeof e;
  return t = t ?? zE, !!t && (n == "number" || n != "symbol" && HE.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function KE(e, t, n) {
  t == "__proto__" && kd ? kd(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function cf(e, t) {
  return e === t || e !== e && t !== t;
}
var ZE = Object.prototype, JE = ZE.hasOwnProperty;
function XE(e, t, n) {
  var a = e[t];
  (!(JE.call(e, t) && cf(a, n)) || n === void 0 && !(t in e)) && KE(e, t, n);
}
var qE = 9007199254740991;
function df(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= qE;
}
function QE(e) {
  return e != null && df(e.length) && !uf(e);
}
var eT = Object.prototype;
function pf(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || eT;
  return e === n;
}
function tT(e, t) {
  for (var n = -1, a = Array(e); ++n < e; )
    a[n] = t(n);
  return a;
}
var nT = "[object Arguments]";
function Vd(e) {
  return _i(e) && yi(e) == nT;
}
var mf = Object.prototype, aT = mf.hasOwnProperty, oT = mf.propertyIsEnumerable, lT = Vd(/* @__PURE__ */ (function() {
  return arguments;
})()) ? Vd : function(e) {
  return _i(e) && aT.call(e, "callee") && !oT.call(e, "callee");
};
function iT() {
  return !1;
}
var ff = typeof exports == "object" && exports && !exports.nodeType && exports, Bd = ff && typeof module == "object" && module && !module.nodeType && module, sT = Bd && Bd.exports === ff, Ud = sT ? Ma.Buffer : void 0, rT = Ud ? Ud.isBuffer : void 0, gf = rT || iT, uT = "[object Arguments]", cT = "[object Array]", dT = "[object Boolean]", pT = "[object Date]", mT = "[object Error]", fT = "[object Function]", gT = "[object Map]", hT = "[object Number]", bT = "[object Object]", vT = "[object RegExp]", yT = "[object Set]", _T = "[object String]", wT = "[object WeakMap]", ST = "[object ArrayBuffer]", IT = "[object DataView]", ET = "[object Float32Array]", TT = "[object Float64Array]", CT = "[object Int8Array]", NT = "[object Int16Array]", LT = "[object Int32Array]", OT = "[object Uint8Array]", DT = "[object Uint8ClampedArray]", AT = "[object Uint16Array]", RT = "[object Uint32Array]", Kt = {};
Kt[ET] = Kt[TT] = Kt[CT] = Kt[NT] = Kt[LT] = Kt[OT] = Kt[DT] = Kt[AT] = Kt[RT] = !0;
Kt[uT] = Kt[cT] = Kt[ST] = Kt[dT] = Kt[IT] = Kt[pT] = Kt[mT] = Kt[fT] = Kt[gT] = Kt[hT] = Kt[bT] = Kt[vT] = Kt[yT] = Kt[_T] = Kt[wT] = !1;
function MT(e) {
  return _i(e) && df(e.length) && !!Kt[yi(e)];
}
function Gu(e) {
  return function(t) {
    return e(t);
  };
}
var hf = typeof exports == "object" && exports && !exports.nodeType && exports, Xl = hf && typeof module == "object" && module && !module.nodeType && module, PT = Xl && Xl.exports === hf, br = PT && sf.process, pl = (function() {
  try {
    var e = Xl && Xl.require && Xl.require("util").types;
    return e || br && br.binding && br.binding("util");
  } catch {
  }
})(), Gd = pl && pl.isTypedArray, xT = Gd ? Gu(Gd) : MT, jT = Object.prototype, FT = jT.hasOwnProperty;
function $T(e, t) {
  var n = Uu(e), a = !n && lT(e), o = !n && !a && gf(e), l = !n && !a && !o && xT(e), s = n || a || o || l, i = s ? tT(e.length, String) : [], c = i.length;
  for (var u in e)
    FT.call(e, u) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    YE(u, c))) && i.push(u);
  return i;
}
function bf(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var kT = bf(Object.keys, Object), VT = Object.prototype, BT = VT.hasOwnProperty;
function UT(e) {
  if (!pf(e))
    return kT(e);
  var t = [];
  for (var n in Object(e))
    BT.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function GT(e) {
  return QE(e) ? $T(e) : UT(e);
}
var ci = $o(Object, "create");
function WT() {
  this.__data__ = ci ? ci(null) : {}, this.size = 0;
}
function zT(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var HT = "__lodash_hash_undefined__", YT = Object.prototype, KT = YT.hasOwnProperty;
function ZT(e) {
  var t = this.__data__;
  if (ci) {
    var n = t[e];
    return n === HT ? void 0 : n;
  }
  return KT.call(t, e) ? t[e] : void 0;
}
var JT = Object.prototype, XT = JT.hasOwnProperty;
function qT(e) {
  var t = this.__data__;
  return ci ? t[e] !== void 0 : XT.call(t, e);
}
var QT = "__lodash_hash_undefined__";
function eC(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ci && t === void 0 ? QT : t, this;
}
function Oo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Oo.prototype.clear = WT;
Oo.prototype.delete = zT;
Oo.prototype.get = ZT;
Oo.prototype.has = qT;
Oo.prototype.set = eC;
function tC() {
  this.__data__ = [], this.size = 0;
}
function Fs(e, t) {
  for (var n = e.length; n--; )
    if (cf(e[n][0], t))
      return n;
  return -1;
}
var nC = Array.prototype, aC = nC.splice;
function oC(e) {
  var t = this.__data__, n = Fs(t, e);
  if (n < 0)
    return !1;
  var a = t.length - 1;
  return n == a ? t.pop() : aC.call(t, n, 1), --this.size, !0;
}
function lC(e) {
  var t = this.__data__, n = Fs(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function iC(e) {
  return Fs(this.__data__, e) > -1;
}
function sC(e, t) {
  var n = this.__data__, a = Fs(n, e);
  return a < 0 ? (++this.size, n.push([e, t])) : n[a][1] = t, this;
}
function Xa(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Xa.prototype.clear = tC;
Xa.prototype.delete = oC;
Xa.prototype.get = lC;
Xa.prototype.has = iC;
Xa.prototype.set = sC;
var di = $o(Ma, "Map");
function rC() {
  this.size = 0, this.__data__ = {
    hash: new Oo(),
    map: new (di || Xa)(),
    string: new Oo()
  };
}
function uC(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function $s(e, t) {
  var n = e.__data__;
  return uC(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function cC(e) {
  var t = $s(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function dC(e) {
  return $s(this, e).get(e);
}
function pC(e) {
  return $s(this, e).has(e);
}
function mC(e, t) {
  var n = $s(this, e), a = n.size;
  return n.set(e, t), this.size += n.size == a ? 0 : 1, this;
}
function yl(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
yl.prototype.clear = rC;
yl.prototype.delete = cC;
yl.prototype.get = dC;
yl.prototype.has = pC;
yl.prototype.set = mC;
function fC(e, t) {
  for (var n = -1, a = t.length, o = e.length; ++n < a; )
    e[o + n] = t[n];
  return e;
}
var gC = bf(Object.getPrototypeOf, Object);
function hC() {
  this.__data__ = new Xa(), this.size = 0;
}
function bC(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function vC(e) {
  return this.__data__.get(e);
}
function yC(e) {
  return this.__data__.has(e);
}
var _C = 200;
function wC(e, t) {
  var n = this.__data__;
  if (n instanceof Xa) {
    var a = n.__data__;
    if (!di || a.length < _C - 1)
      return a.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new yl(a);
  }
  return n.set(e, t), this.size = n.size, this;
}
function _l(e) {
  var t = this.__data__ = new Xa(e);
  this.size = t.size;
}
_l.prototype.clear = hC;
_l.prototype.delete = bC;
_l.prototype.get = vC;
_l.prototype.has = yC;
_l.prototype.set = wC;
var vf = typeof exports == "object" && exports && !exports.nodeType && exports, Wd = vf && typeof module == "object" && module && !module.nodeType && module, SC = Wd && Wd.exports === vf, zd = SC ? Ma.Buffer : void 0;
zd && zd.allocUnsafe;
function IC(e, t) {
  return e.slice();
}
function EC(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length, o = 0, l = []; ++n < a; ) {
    var s = e[n];
    t(s, n, e) && (l[o++] = s);
  }
  return l;
}
function TC() {
  return [];
}
var CC = Object.prototype, NC = CC.propertyIsEnumerable, Hd = Object.getOwnPropertySymbols, LC = Hd ? function(e) {
  return e == null ? [] : (e = Object(e), EC(Hd(e), function(t) {
    return NC.call(e, t);
  }));
} : TC;
function OC(e, t, n) {
  var a = t(e);
  return Uu(e) ? a : fC(a, n(e));
}
function DC(e) {
  return OC(e, GT, LC);
}
var Jr = $o(Ma, "DataView"), Xr = $o(Ma, "Promise"), qr = $o(Ma, "Set"), Yd = "[object Map]", AC = "[object Object]", Kd = "[object Promise]", Zd = "[object Set]", Jd = "[object WeakMap]", Xd = "[object DataView]", RC = Fo(Jr), MC = Fo(di), PC = Fo(Xr), xC = Fo(qr), jC = Fo(Zr), $a = yi;
(Jr && $a(new Jr(new ArrayBuffer(1))) != Xd || di && $a(new di()) != Yd || Xr && $a(Xr.resolve()) != Kd || qr && $a(new qr()) != Zd || Zr && $a(new Zr()) != Jd) && ($a = function(e) {
  var t = yi(e), n = t == AC ? e.constructor : void 0, a = n ? Fo(n) : "";
  if (a)
    switch (a) {
      case RC:
        return Xd;
      case MC:
        return Yd;
      case PC:
        return Kd;
      case xC:
        return Zd;
      case jC:
        return Jd;
    }
  return t;
});
var FC = Object.prototype, $C = FC.hasOwnProperty;
function kC(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && $C.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var qd = Ma.Uint8Array;
function Wu(e) {
  var t = new e.constructor(e.byteLength);
  return new qd(t).set(new qd(e)), t;
}
function VC(e, t) {
  var n = Wu(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var BC = /\w*$/;
function UC(e) {
  var t = new e.constructor(e.source, BC.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Qd = dl ? dl.prototype : void 0, ep = Qd ? Qd.valueOf : void 0;
function GC(e) {
  return ep ? Object(ep.call(e)) : {};
}
function WC(e, t) {
  var n = Wu(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
var zC = "[object Boolean]", HC = "[object Date]", YC = "[object Map]", KC = "[object Number]", ZC = "[object RegExp]", JC = "[object Set]", XC = "[object String]", qC = "[object Symbol]", QC = "[object ArrayBuffer]", eN = "[object DataView]", tN = "[object Float32Array]", nN = "[object Float64Array]", aN = "[object Int8Array]", oN = "[object Int16Array]", lN = "[object Int32Array]", iN = "[object Uint8Array]", sN = "[object Uint8ClampedArray]", rN = "[object Uint16Array]", uN = "[object Uint32Array]";
function cN(e, t, n) {
  var a = e.constructor;
  switch (t) {
    case QC:
      return Wu(e);
    case zC:
    case HC:
      return new a(+e);
    case eN:
      return VC(e);
    case tN:
    case nN:
    case aN:
    case oN:
    case lN:
    case iN:
    case sN:
    case rN:
    case uN:
      return WC(e);
    case YC:
      return new a();
    case KC:
    case XC:
      return new a(e);
    case ZC:
      return UC(e);
    case JC:
      return new a();
    case qC:
      return GC(e);
  }
}
function dN(e) {
  return typeof e.constructor == "function" && !pf(e) ? GE(gC(e)) : {};
}
var pN = "[object Map]";
function mN(e) {
  return _i(e) && $a(e) == pN;
}
var tp = pl && pl.isMap, fN = tp ? Gu(tp) : mN, gN = "[object Set]";
function hN(e) {
  return _i(e) && $a(e) == gN;
}
var np = pl && pl.isSet, bN = np ? Gu(np) : hN, yf = "[object Arguments]", vN = "[object Array]", yN = "[object Boolean]", _N = "[object Date]", wN = "[object Error]", _f = "[object Function]", SN = "[object GeneratorFunction]", IN = "[object Map]", EN = "[object Number]", wf = "[object Object]", TN = "[object RegExp]", CN = "[object Set]", NN = "[object String]", LN = "[object Symbol]", ON = "[object WeakMap]", DN = "[object ArrayBuffer]", AN = "[object DataView]", RN = "[object Float32Array]", MN = "[object Float64Array]", PN = "[object Int8Array]", xN = "[object Int16Array]", jN = "[object Int32Array]", FN = "[object Uint8Array]", $N = "[object Uint8ClampedArray]", kN = "[object Uint16Array]", VN = "[object Uint32Array]", zt = {};
zt[yf] = zt[vN] = zt[DN] = zt[AN] = zt[yN] = zt[_N] = zt[RN] = zt[MN] = zt[PN] = zt[xN] = zt[jN] = zt[IN] = zt[EN] = zt[wf] = zt[TN] = zt[CN] = zt[NN] = zt[LN] = zt[FN] = zt[$N] = zt[kN] = zt[VN] = !0;
zt[wN] = zt[_f] = zt[ON] = !1;
function Wi(e, t, n, a, o, l) {
  var s;
  if (s !== void 0)
    return s;
  if (!js(e))
    return e;
  var i = Uu(e);
  if (i)
    s = kC(e);
  else {
    var c = $a(e), u = c == _f || c == SN;
    if (gf(e))
      return IC(e);
    if (c == wf || c == yf || u && !o)
      s = u ? {} : dN(e);
    else {
      if (!zt[c])
        return o ? e : {};
      s = cN(e, c);
    }
  }
  l || (l = new _l());
  var p = l.get(e);
  if (p)
    return p;
  l.set(e, s), bN(e) ? e.forEach(function(h) {
    s.add(Wi(h, t, n, h, e, l));
  }) : fN(e) && e.forEach(function(h, I) {
    s.set(I, Wi(h, t, n, I, e, l));
  });
  var b = DC, f = i ? void 0 : b(e);
  return WE(f || e, function(h, I) {
    f && (I = h, h = e[I]), XE(s, I, Wi(h, t, n, I, e, l));
  }), s;
}
var BN = 1, UN = 4;
function Qr(e) {
  return Wi(e, BN | UN);
}
const GN = { style: { display: "flex", "flex-direction": "column", height: "100%" } }, WN = { style: { height: "100%" } }, zN = {
  class: "grid w-full items-center px-2",
  style: { "grid-template-columns": "minmax(0, 1fr) auto minmax(0, 1fr)" }
}, HN = { class: "flex items-center justify-start" }, YN = { class: "font-medium mr-2" }, KN = { class: "font-medium ml-2" }, ZN = /* @__PURE__ */ qe({
  __name: "STLPickerWindow",
  props: /* @__PURE__ */ xn({
    existingSelection: {},
    origin: {},
    direction: {},
    viewUp: {},
    tooth: {},
    implantList: {}
  }, {
    showSecondaryComponents: { type: Boolean, default: !1 },
    showSecondaryComponentsModifiers: {}
  }),
  emits: /* @__PURE__ */ xn(["onConfirm", "onReject", "showWizard", "onImplantChange"], ["update:showSecondaryComponents"]),
  setup(e, { emit: t }) {
    const n = oa(), a = F({
      implant: null,
      manufacturer: null,
      model: null,
      implantData: null,
      abManufacturer: null,
      abModel: null,
      abutment: null,
      abutmentData: null,
      scanAbutment: null,
      scanAbutmentData: null,
      secondaryAbutment: null,
      secondaryAbutmentData: null,
      secondaryScanAbutment: null,
      secondaryScanAbutmentData: null,
      sleeveManufacturer: null,
      sleeve: null,
      sleeveData: null,
      sleeveNegativeData: null,
      sleeveManuallyChanged: 0,
      sleeveReferenced: 0,
      implantExtrusion: null,
      implantExtrusionData: null
    }), o = e, l = t, s = Ln(e, "showSecondaryComponents");
    $I();
    let i = F(!1);
    const c = () => {
      var W, se, be, Re, U, ie, re, q, De, _e;
      const M = p.objects.getImplantObjectData(), te = M[M.length - 1], ne = {
        implantGuid: te.implantInfo.guid,
        abutmentGuid: (W = te.abutment) == null ? void 0 : W.guid,
        sleeveName: (se = te.sleeveInfo) == null ? void 0 : se.originalName,
        scanAbutmentGuid: (Re = (be = a.value.scanAbutment) == null ? void 0 : be.value) == null ? void 0 : Re.uuid,
        secondaryAbutmentGuid: (ie = (U = a.value.secondaryAbutment) == null ? void 0 : U.value) == null ? void 0 : ie.uuid,
        secondaryScanAbutmentGuid: (q = (re = a.value.secondaryScanAbutment) == null ? void 0 : re.value) == null ? void 0 : q.uuid,
        analogExtrusionUuid: ((De = a.value.implantExtrusion) == null ? void 0 : De.value.uuid) ?? ((_e = a.value.implantExtrusion) == null ? void 0 : _e.value.name)
      };
      n.updateLastAppliedImplant(ne), H(), l("onConfirm", { selection: a.value, implant: te }), l("showWizard");
    }, u = () => {
      l("onReject");
    }, p = pn(), { existingSelection: b, origin: f, direction: h, viewUp: I, tooth: m } = ln(o);
    let S = o.existingSelection.implantId !== void 0, E = m.value && p.objects.implants.getByTooth(m.value) !== null;
    const g = Te(() => ({
      width: "98.6vw"
      // marginTop: menuMode.value === MenuType.HORIZONTAL ? "6rem" : "",
    }));
    ot(b, (M) => {
      S = M.implantId !== void 0;
    });
    const v = Symbol(), T = (M, te) => {
      var ie, re, q, De;
      const ne = { ...te }, W = { ...M }, se = (((ie = ne.implantData) == null ? void 0 : ie.byteLength) || 0) + (((re = W.implantData) == null ? void 0 : re.byteLength) || 0) + (((q = ne.abutmentData) == null ? void 0 : q.byteLength) || 0) + (((De = ne.abutmentData) == null ? void 0 : De.byteLength) || 0) >> 10, be = async () => {
        a.value = ne, await A(ne, !0), await fn();
      }, Re = async () => {
        a.value = W, await A(W, !0), await fn();
      }, U = new Wl({
        onUndo: be,
        onRedo: Re,
        getMemory: () => se
      });
      p.undoManager.pushPop(v, U, "Change implant selection", zl.SCENE_REFRESH);
    }, R = (M) => !(!M.manufacturer || !M.model || !M.implant || !M.implantData || M.abutment && (!M.abManufacturer || !M.abModel || !M.abutmentData) || M.sleeve && !M.sleeveManufacturer);
    let L = null;
    const C = (M, te) => {
      if (!M && !te)
        return !1;
      if (!M || !te)
        return !0;
      const ne = M.value, W = te.value;
      return !ne && !W ? !1 : !ne || !W ? !0 : ne.id !== W.id || ne.uuid !== W.uuid || ne.s3ObjectRef !== W.s3ObjectRef || ne.name !== W.name || ne.manufacturerName !== W.manufacturerName;
    }, A = (M, te) => {
      var U, ie, re, q, De, _e, xe;
      if (!p) {
        i.value = !1;
        return;
      }
      if (m.value === void 0)
        throw i.value = !1, "stl picker implant tooth not set";
      if (!R(M)) {
        i.value = !1;
        return;
      }
      let ne = !0;
      if (L) {
        const k = ((U = M.implant) == null ? void 0 : U.value.id) !== ((ie = L.implant) == null ? void 0 : ie.value.id) || M.implantData !== L.implantData, K = ((re = M.abutment) == null ? void 0 : re.value.id) !== ((q = L.abutment) == null ? void 0 : q.value.id) || M.abutmentData !== L.abutmentData, Ae = ((De = M.sleeve) == null ? void 0 : De.value.id) !== ((_e = L.sleeve) == null ? void 0 : _e.value.id) || M.sleeveData !== L.sleeveData, me = C(M.scanAbutment, L.scanAbutment) || M.scanAbutmentData !== L.scanAbutmentData, Ne = C(M.secondaryAbutment, L.secondaryAbutment) || M.secondaryAbutmentData !== L.secondaryAbutmentData, Ge = C(M.secondaryScanAbutment, L.secondaryScanAbutment) || M.secondaryScanAbutmentData !== L.secondaryScanAbutmentData, Ue = C(M.implantExtrusion, L.implantExtrusion);
        ne = k || K || Ae || me || Ne || Ge || Ue;
      }
      if (!ne) return;
      const W = Qr(M), se = mw(W, m.value, f.value, h.value, I.value);
      z = se || void 0, se ? (E ? p.objects.replaceImplant(se, !0, {
        disableCenterLines: !1,
        ignoreScaling: !0
      }) : (p.objects.addImplant(se, { disableCenterLines: !1, ignoreScaling: !0 }), S = !0, E = !0), p.objects.selectImplant(m.value, !1)) : (S && (p.objects.implants.deleteByTooth(m.value), S = !1, E = !1), p.objects.unSelectObject()), !te && L && T(W, L), L = W;
      const be = (xe = p.objects.implants.getByTooth(m.value)) == null ? void 0 : xe.id;
      be && p.objects.snapToObject(be), p.sceneRepaint(), i.value = !0;
      const Re = p.objects.getImplantByToothName(m.value);
      Re ? p.objects.checkCollisions(Re) : p.objects.checkCollisions();
    }, j = async (M) => {
      await A(M, !1);
    }, N = (M) => {
      var ne, W;
      p == null || p.undoManager.remove(v), H();
      const te = (ne = o.implantList.find((se) => se.toothId === M)) == null ? void 0 : ne.tooth;
      x = te ? (W = p.objects.getImplantByToothName(te)) == null ? void 0 : W.toProjectImplantParts() : void 0, l("onImplantChange", M);
    };
    Mt(() => {
      const M = p.getViewWidget(Nn._3D);
      M && M.hideObjectList(!0);
    }), Ka(() => {
      const M = p.getViewWidget(Nn._3D);
      M && M.hideObjectList(!1), p == null || p.undoManager.remove(v);
    });
    let x, z;
    if (o.tooth) {
      const M = p.objects.implants.getByTooth(o.tooth);
      M && (x = M.toProjectImplantParts());
    }
    const X = (M) => {
      var ne, W, se, be, Re, U, ie, re, q, De, _e, xe, k, K, Ae, me;
      if (!p)
        throw "context not set";
      const te = (((ne = M.oldImplant) == null ? void 0 : ne.implantInfo.stlFile.data.byteLength) || 0) + (((be = (se = (W = M.oldImplant) == null ? void 0 : W.abutment) == null ? void 0 : se.stlFile) == null ? void 0 : be.data.byteLength) || 0) + (((ie = (U = (Re = M.oldImplant) == null ? void 0 : Re.sleeveInfo) == null ? void 0 : U.stlData) == null ? void 0 : ie.data.byteLength) || 0) + (((De = (q = (re = M.oldImplant) == null ? void 0 : re.sleeveInfo) == null ? void 0 : q.stlNegativeData) == null ? void 0 : De.data.byteLength) || 0) + (M.newImplant.implantInfo.stlFile.data.byteLength || 0) + (((xe = (_e = M.newImplant.abutment) == null ? void 0 : _e.stlFile) == null ? void 0 : xe.data.byteLength) || 0) + (((K = (k = M.newImplant.sleeveInfo) == null ? void 0 : k.stlData) == null ? void 0 : K.data.byteLength) || 0) + (((me = (Ae = M.newImplant.sleeveInfo) == null ? void 0 : Ae.stlNegativeData) == null ? void 0 : me.data.byteLength) || 0) >> 10;
      if (M.oldImplant) {
        const Ne = () => {
          M.oldImplant && (p.objects.replaceImplant(M.oldImplant, !0, {
            disableCenterLines: !1,
            ignoreScaling: !0
          }), p.objects.updateImplantPlannerGUIEvent.notify(null));
        }, Ge = () => {
          p.objects.replaceImplant(M.newImplant, !0, {
            disableCenterLines: !1,
            ignoreScaling: !0
          }), p.objects.updateImplantPlannerGUIEvent.notify(null);
        };
        return new Wl({
          onUndo: Ne,
          onRedo: Ge,
          getMemory: () => te
        });
      } else {
        const Ne = () => {
          p.objects.implants.deleteByTooth(M.newImplant.name);
          const Ue = p.objects.selectedObject.get();
          Ue && Ue.type === Le._IMPLANT && Ue.getName() === M.newImplant.name && p.objects.unSelectObject(), p.objects.updateImplantPlannerGUIEvent.notify(null);
        }, Ge = () => {
          p.objects.addImplant(M.newImplant, { disableCenterLines: !1, ignoreScaling: !1 }), p.objects.updateImplantPlannerGUIEvent.notify(null);
        };
        return new Wl({
          onUndo: Ne,
          onRedo: Ge,
          getMemory: () => te
        });
      }
    }, H = () => {
      if (z) {
        const M = X({
          oldImplant: x,
          newImplant: z
        }), te = z.name;
        x ? p.undoManager.pushPop(p.objects, M, "Change Implant " + te, zl.SCENE_REFRESH) : p.undoManager.pushPop(p.objects, M, "Add Implant " + te, zl.SCENE_REFRESH);
      }
    };
    return (M, te) => {
      const ne = Lm;
      return O(), J("div", GN, [
        y("div", WN, [
          d(bE, {
            stlSelection: a.value,
            onStlSelectionUpdate: j,
            selection: r(b),
            implantList: o.implantList,
            selectedTooth: o.tooth,
            showSecondaryComponents: s.value,
            "onUpdate:showSecondaryComponents": te[0] || (te[0] = (W) => s.value = W),
            onImplantChange: N
          }, null, 8, ["stlSelection", "selection", "implantList", "selectedTooth", "showSecondaryComponents"])
        ]),
        (O(), he(au, { to: "#belowRenderWindowContainer" }, [
          d(r(at), { class: "items-center" }, {
            default: w(() => [
              d(ne, {
                type: "solid",
                style: Tt(g.value)
              }, null, 8, ["style"]),
              y("div", zN, [
                y("div", HN, [
                  y("label", null, V(M.$t("implant-planner.secondaryComponents")), 1),
                  d(r(io), {
                    state: s.value,
                    "onUpdate:state": te[1] || (te[1] = (W) => s.value = W),
                    class: "ml-2"
                  }, {
                    falseLabel: w(() => [
                      y("span", YN, V(M.$t("implant-planner.off")), 1)
                    ]),
                    trueLabel: w(() => [
                      y("span", KN, V(M.$t("implant-planner.on")), 1)
                    ]),
                    _: 1
                  }, 8, ["state"])
                ]),
                d(r(Ee), { class: "justify-center gap-2" }, {
                  default: w(() => [
                    d(r(la), {
                      id: "btnApplyAddImplant",
                      label: M.$t("shared.apply"),
                      disabled: !r(i),
                      icon: "pi pi-check",
                      onClick: c
                    }, null, 8, ["label", "disabled"]),
                    d(r(ya), {
                      label: M.$t("shared.cancel"),
                      icon: "pi pi-times",
                      onClick: u
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                te[2] || (te[2] = y("div", null, null, -1))
              ])
            ]),
            _: 1
          })
        ]))
      ]);
    };
  }
}), ks = Qh({
  id: "ui-state",
  state: () => ({
    stlLibraryWindowVisible: !1
  }),
  actions: {
    setStlLibraryVisible(e) {
      this.stlLibraryWindowVisible = e;
    }
  }
}), JN = { class: "card-wiz hidden" }, XN = { class: "grid grid-cols-12 gap-4 grid-cols-12 gap-6 flex items-center justify-center" }, qN = { class: "mt-2" }, QN = { key: 0 }, eL = { key: 1 }, ap = 1e-3, tL = /* @__PURE__ */ qe({
  __name: "IPImplantPlanning",
  props: /* @__PURE__ */ xn({
    isReadOnly: { type: Boolean }
  }, {
    showSecondaryComponents: { type: Boolean, default: !1 },
    showSecondaryComponentsModifiers: {}
  }),
  emits: /* @__PURE__ */ xn(["hideWizard", "showWizard"], ["update:showSecondaryComponents"]),
  setup(e, { emit: t }) {
    const { t: n } = Yt(), a = e, o = t, l = Ln(e, "showSecondaryComponents"), { isReadOnly: s } = ln(a), i = pn(), { watch: c, cleanupAll: u, onEvent: p } = Ra(), b = fl(), f = iu();
    let h = null;
    const I = oa(), { menuMode: m, lastAppliedImplant: S } = Co(oa()), E = /* @__PURE__ */ new Set();
    function g(_) {
      if (typeof _ == "number")
        return Number.isFinite(_) ? _ : 0;
      const D = Number.parseFloat(_ ?? "");
      return Number.isFinite(D) ? D : 0;
    }
    function v(_) {
      if (typeof _ == "number")
        return Number.isFinite(_) ? _ : 0;
      const D = Number.parseInt(_ ?? "", 10);
      return Number.isFinite(D) ? D : 0;
    }
    async function T() {
      if (!b.cachedResponse)
        try {
          await b.loadSTLLibrary();
        } catch (_) {
          return console.warn("Failed to load STL library for implant step", _), null;
        }
      return b.cachedResponse ? (h || (h = new lu(b.cachedResponse, f)), h) : null;
    }
    function R(_) {
      i.objects.replaceImplant(_, !0, {
        disableCenterLines: !1,
        ignoreScaling: !0
      }), i.objects.selectImplant(_.name, !1);
      const D = i.objects.getImplantByToothName(_.name);
      D ? (i.objects.checkCollisions(D), i.objects.updateImplantPlannerGUIEvent.notify(D)) : (i.objects.checkCollisions(), i.objects.updateImplantPlannerGUIEvent.notify(null)), i.sceneRepaint();
    }
    async function L(_, D) {
      var Ct;
      const Y = D.defaultSleeveId;
      if (!Y)
        return;
      const Q = _.getSleeveTreeById(Y);
      if (!Q)
        return;
      const { manufacturer: ae, object: ge } = Q;
      let Fe = null, Me = null;
      if (ge.s3ObjectRef)
        try {
          Fe = await _.getFile(ge.s3ObjectRef);
        } catch (ft) {
          console.warn("Failed to load default sleeve STL", { sleeveId: ge.id, s3ObjectRef: ge.s3ObjectRef, error: ft });
        }
      if (ge.inverses3ObjectRef)
        try {
          Me = await _.getFile(ge.inverses3ObjectRef);
        } catch (ft) {
          console.warn("Failed to load default sleeve negative STL", { sleeveId: ge.id, s3ObjectRef: ge.inverses3ObjectRef, error: ft });
        }
      const je = Fe ? new Int8Array(Fe) : void 0, dt = Me ? new Int8Array(Me) : void 0, vt = {
        manufacturerName: ae.name,
        modelName: ge.name,
        sellingCode: ge.sellingCode,
        dExternal: g(ge.dextsleeve),
        dInternal: g(ge.dintsleeve),
        lSleeve: g(ge.lslsleeve),
        lLip: g(ge.lip_heightguide),
        ...Fm(ge),
        reductionSystemSize: g(ge.reductionsystemsleeve),
        rotationAll: g(ge.rotation_allguide),
        rotationCut: g(ge.rotation_cutguide),
        originalDistanceFromImplant: g(ge.hslsleeve),
        distanceFromImplant: g(ge.hslsleeve),
        drillLengthSizes: ge.drill_lenght_sizes ?? "",
        originalName: _p(ae.name, ge.name),
        stlData: je ? {
          fileName: "",
          data: je,
          fileSize: je.length
        } : void 0,
        stlNegativeData: dt ? {
          fileName: "",
          data: dt,
          fileSize: dt.length
        } : void 0,
        stlFileGuid: ge.stl_guid || (je != null && je.length ? ge.s3ObjectRef : ""),
        stlFileNegativeGuid: ge.stl_negative_guid || (dt != null && dt.length ? ge.inverses3ObjectRef : ""),
        connectionIndex: 0,
        referencedSleeve: 1
      }, mt = !!((Ct = vt.stlData) != null && Ct.data.length), kt = vt.dInternal > 0 && (vt.dExternal > 0 || Math.abs(vt.dHexagon) > 0) && vt.lSleeve > 0;
      if (!mt && !kt) {
        console.warn("Invalid default sleeve data for stepped implant", { sleeveId: ge.id, sleeveName: ge.name });
        return;
      }
      return vt;
    }
    async function C(_, D) {
      if (s.value || me.value || E.has(_))
        return;
      const Y = i.objects.selectedObject.get();
      if (!Y || Y.id !== _ || Y.type !== Le._IMPLANT)
        return;
      const Q = i.objects.implants.get(_);
      if (Q) {
        E.add(_), i.showLoading();
        try {
          const ae = await T();
          if (!ae)
            return;
          const ge = Q.toProjectImplantParts(), Fe = ge.implantInfo, Me = ae.getImplantTreeById(Fe.guid);
          if (!Me)
            return;
          const je = ae.getImplantsForModel(Me.model.id).filter((Vt) => Math.abs(g(Vt.diameter) - Fe.diameter) < ap).sort((Vt, Wt) => {
            const jn = g(Vt.length) - g(Wt.length);
            return Math.abs(jn) >= ap ? jn : Vt.id - Wt.id;
          });
          if (je.length === 0)
            return;
          let dt = je.findIndex((Vt) => Vt.uuid === Fe.guid);
          dt < 0 && (dt = je.reduce((Vt, Wt, jn, ra) => {
            const B = Math.abs(g(ra[Vt].length) - Fe.length);
            return Math.abs(g(Wt.length) - Fe.length) < B ? jn : Vt;
          }, 0));
          const vt = dt + D;
          if (vt < 0 || vt >= je.length)
            return;
          const mt = je[vt];
          if (!mt.s3ObjectRef)
            return;
          const kt = await ae.getFile(mt.s3ObjectRef), Ct = await L(ae, mt), ft = {
            ...ge,
            implantInfo: {
              ...ge.implantInfo,
              color: v(mt.color) || ge.implantInfo.color,
              diameter: g(mt.diameter),
              guid: mt.uuid || ge.implantInfo.guid,
              implantConnectorHeight: g(mt.connector_height),
              implantOriginalName: mt.name || ge.implantInfo.implantOriginalName,
              length: g(mt.length),
              manufacturerName: Me.manufacturer.name || ge.implantInfo.manufacturerName,
              modelName: Me.model.name || ge.implantInfo.modelName,
              nonSymmetric: v(mt.non_symmetric),
              sellingCode: mt.sellingCode || ge.implantInfo.sellingCode,
              connectionSides: mt.connection_sides ?? ge.implantInfo.connectionSides,
              stlFile: {
                fileName: "",
                data: new Int8Array(kt),
                fileSize: kt.byteLength
              }
            },
            sleeveInfo: Ct,
            sleeveManuallyChanged: Ct ? 0 : void 0,
            // Do not carry previous drill length to a new default sleeve.
            // Let sleeve initialization apply its own default drill length list.
            drillLength: void 0,
            drillLengthMm: void 0
          };
          R(ft);
        } catch (ae) {
          console.warn("Failed to step implant length", ae);
        } finally {
          E.delete(_), i.hideLoading();
        }
      }
    }
    function A(_) {
      return _ === Jt.MANDIBLE ? ys(i.settings.general.useUSStyleToothChart) : _s(i.settings.general.useUSStyleToothChart);
    }
    function j(_) {
      if (!_) return null;
      const D = A(x.jawboneType)[_ - 1];
      if (!D)
        return console.warn("Tooth name not found for id", { id: _, jawboneType: x.jawboneType }), null;
      const Y = x.teeth.find((Q) => Q.id === _);
      return Y ? { name: D, tooth: Y } : (console.warn("Tooth with id not found in implant planning model", { id: _, jawboneType: x.jawboneType }), null);
    }
    function N(_) {
      return (_ == null ? void 0 : _.type) === Le._IMPLANT;
    }
    const x = et({
      jawboneType: Jt.MANDIBLE,
      teeth: [],
      selectedObject: null,
      objectsModel: null,
      objectsPreview: null,
      implants: [],
      warnString: ""
    });
    let z = 0;
    const X = F(i.settings.general.useUSStyleToothChart);
    p(i.settings.onSettingsModified, () => {
      X.value = i.settings.general.useUSStyleToothChart;
    });
    function H() {
      x.warnString = "", x.jawboneType = i.CPRType === an.MANDIBLE ? Jt.MANDIBLE : Jt.MAXILLA;
      const _ = s.value ? Ta.NO_EDIT : Ta.ADD;
      x.teeth = A(x.jawboneType).map((D, Y) => {
        var dt, vt;
        const Q = i.objects.implantExists(D);
        let ae = !1;
        Q || (ae = i.objects.markerExists(D));
        const ge = Q ? Ta.SELECT_ONLY : _, Fe = Q || s.value ? Fn.NONE : Fn.ADD;
        let Me = Q ? pt.OK : ae ? pt.TEETH_MARKER : pt.EMPTY;
        ((dt = x.selectedObject) == null ? void 0 : dt.getName()) === D && (Me = pt.OK_SELECTED);
        const je = i.objects.getImplantByToothName(D);
        return (je != null && je.getColorOverride() || (vt = je == null ? void 0 : je.getSleeve()) != null && vt.getColorOverride()) && (Me == pt.OK_SELECTED ? (je != null && je.isSleeveChanged() && !(je != null && je.isInCollision()) ? Me = pt.WARNING_SELECTED : je != null && je.isInCollision() && (Me = pt.COLLISION_SELECTED), je && je.collisions && (je.collisions.nerveCollision && (x.warnString += `${n("implant-planner.nerveCollision")} 
`), je.collisions.sleeveCollision && (x.warnString += `${n("implant-planner.sleeveCollision")} 
`), je.collisions.anatomyCollision && (x.warnString += `${n("implant-planner.anatomyCollision")} 
`), je.collisions.implantCollision ? x.warnString += `${n("implant-planner.implantCollision")} 
` : je.collisions.securityZoneCollision && (x.warnString += `${n("implant-planner.securityZoneCollision")} 
`), je.collisions.sleeveChanged != null && (x.warnString += `${je.collisions.sleeveChanged} 
`))) : je != null && je.isSleeveChanged() && !(je != null && je.isInCollision()) ? Me = pt.WARNING : je != null && je.isInCollision() && (Me = pt.COLLISION)), {
          id: Y + 1,
          editMode: ge,
          status: Me,
          hoverIcon: Fe,
          toothName: D
        };
      });
    }
    const M = F(Math.random()), te = F(!1);
    H(), Mt(async () => {
      await be(i.objects.selectedObject.get()), ne();
    });
    function ne() {
      x.implants = [], i.objects.implants.forEach((_) => {
        var Y;
        const D = (Y = x.teeth.find((Q) => Q.toothName === _.getName())) == null ? void 0 : Y.id;
        if (!D) {
          console.warn("toothId not found: ", _.getName());
          return;
        }
        x.implants.push({
          id: _.id,
          toothId: D,
          name: _.getImplantDisplayName(),
          tooth: _.getName()
        });
      });
    }
    function W(_) {
      var Y, Q;
      if (_ && _.type !== Le._IMPLANT)
        return;
      const D = _;
      if (D) {
        const ae = D.getImplantInfo().implantInfo, ge = (Y = ae.sellingCode) == null ? void 0 : Y.trim(), Fe = ge ? ` / ${ge}` : "", Me = {
          objectId: D.getName(),
          implant: {
            name: `${ae.manufacturerName} / ${ae.modelName}${Fe}`,
            diameter: ae.diameter,
            length: ae.length,
            visibility: D.getVisibility(),
            locked: D.getLocked()
          }
        }, je = D.getAbutment();
        if (je) {
          const ft = je.getAbutmentInfo(), Vt = (Q = ft.abutmentSellingCode) == null ? void 0 : Q.trim(), Wt = Vt ? ` / ${Vt}` : "";
          Me.abutment = {
            name: `${ft.manufacturerName} / ${ft.modelName} / ${ft.name}${Wt}`,
            visibility: je.getVisibility(),
            rotationZ: D.GetRotation(),
            rotationZProsthetic: D.GetRotation(!0)
          };
        } else
          Me.abutment = void 0;
        const dt = D.getSleeve();
        if (dt) {
          const ft = D.getProjectImplantInfo().connectionSides ?? 0;
          Me.sleeve = {
            name: dt.getSleeveName(),
            visibility: dt.getVisibility()
          }, Me.overallLength = dt.getOverallLength(), Me.sleeveDistance = dt.getDistanceFromImplant(), Me.sleeveDistanceLocked = !!dt.getSleeveInfo().lockDistance, Me.sleeveRotationStep = dt.getSleeveInfo().connectionIndex ?? 0, Me.sleeveRotationMaxStep = ft > 0 ? ft - 1 : void 0, Me.drillLengths = dt.getDrillLengths(), Me.drillLength = dt.getDrillLength();
        } else
          Me.sleeve = void 0, Me.overallLength = void 0, Me.sleeveDistance = void 0, Me.sleeveDistanceLocked = !1, Me.sleeveRotationStep = void 0, Me.sleeveRotationMaxStep = void 0, Me.drillLengths = void 0, Me.drillLength = void 0;
        const vt = D.getScanAbutment();
        if (vt) {
          const ft = vt.getAttachmentInfo();
          Me.scanAbutment = {
            name: ft.name,
            visibility: vt.getVisibility()
          };
        } else
          Me.scanAbutment = void 0;
        const mt = D.getSecondaryAbutment();
        if (mt) {
          const ft = mt.getAttachmentInfo();
          Me.secondaryAbutment = {
            name: ft.name,
            visibility: mt.getVisibility()
          };
        } else
          Me.secondaryAbutment = void 0;
        const kt = D.getSecondaryScanAbutment();
        if (kt) {
          const ft = kt.getAttachmentInfo();
          Me.secondaryScanAbutment = {
            name: ft.name,
            visibility: kt.getVisibility()
          };
        } else
          Me.secondaryScanAbutment = void 0;
        const Ct = D.getAnalogExtrusion();
        if (Ct) {
          const ft = Ct.name;
          Me.analogExtrusion = {
            name: ft,
            visibility: !1
            //analogExtrusion.getVisibility(),
          };
        } else
          Me.analogExtrusion = void 0;
        x.objectsModel = Me;
      } else
        x.objectsModel = null;
    }
    async function se(_) {
      const D = ++z;
      if (me.value)
        return;
      if (!_) {
        x.objectsPreview = null;
        return;
      }
      const Y = i.viewConfiguration.colorScheme.get(), Q = {
        implantPreview: await ea(_, Y)
      }, ae = _.getAbutment();
      ae ? Q.abutmentPreview = await ea(ae, Y) : Q.abutmentPreview = void 0;
      const ge = _.getSleeve();
      ge ? Q.sleevePreview = await ea(ge, Y) : Q.sleevePreview = void 0;
      const Fe = _.getScanAbutment();
      Fe ? Q.scanAbutmentPreview = await ea(Fe, Y) : Q.scanAbutmentPreview = void 0;
      const Me = _.getSecondaryAbutment();
      Me ? Q.secondaryAbutmentPreview = await ea(Me, Y) : Q.secondaryAbutmentPreview = void 0;
      const je = _.getSecondaryScanAbutment();
      je ? Q.secondaryScanAbutmentPreview = await ea(je, Y) : Q.secondaryScanAbutmentPreview = void 0, Q.analogExtrusionPreview = void 0, D === z && (x.objectsPreview = Q);
    }
    async function be(_) {
      _ !== null && !N(_) || (x.selectedObject = _, W(_), await se(_), H());
    }
    c(i.objects.selectedObject, async (_) => {
      await be(_);
    }), p(i.objects.updateImplantPlannerGUIEvent, async (_) => {
      const D = N(_) ? _ : null;
      W(D), te.value || await se(D), te.value = !1, H(), ne();
    }), p(i.objectImplantLengthStepEvent, ({ objectId: _, step: D }) => {
      C(_, D);
    }), Ka(() => {
      u();
    });
    function Re(_) {
      var Fe;
      const D = j(_);
      if (!D || s.value && D.tooth.status === pt.EMPTY)
        return;
      const Q = i.objects.getImplantByToothName(D.name), ae = i.objects.markerExists(D.name), ge = (Q == null ? void 0 : Q.getColorOverride()) || ((Fe = Q == null ? void 0 : Q.getSleeve()) == null ? void 0 : Fe.getColorOverride());
      Q && ge ? Q != null && Q.isSleeveChanged() && !(Q != null && Q.isInCollision()) ? D.tooth.status = pt.WARNING_SELECTED : Q.isInCollision() && (D.tooth.status = pt.COLLISION_SELECTED) : D.tooth.status = ae ? pt.TEETH_MARKER_SELECTED : pt.OK_SELECTED;
    }
    const U = et({
      origin: [0, 0, 0],
      direction: [0, 0, 0],
      viewUp: [0, 0, 0],
      existingSelection: {},
      tooth: void 0
    });
    function ie(_) {
      var Y, Q, ae, ge, Fe, Me, je, dt;
      const D = (Y = i.objects.implants.getByTooth(_)) == null ? void 0 : Y.toProjectImplantParts();
      if (D) {
        const vt = {
          origin: i.objects.scaleVectorFromImplantPlanner(D.origin),
          direction: D.normal,
          viewUp: D.viewUp
        }, mt = {
          implantId: D.implantInfo.guid,
          abutmentId: (Q = D.abutment) == null ? void 0 : Q.guid,
          sleeveId: (ae = D.sleeveInfo) == null ? void 0 : ae.originalName,
          scanAbutmentId: (ge = D.scanAbutment) == null ? void 0 : ge.guid,
          secondaryAbutmentId: (Fe = D.secondaryAbutment) == null ? void 0 : Fe.guid,
          secondaryScanAbutmentId: (Me = D.secondaryScanAbutment) == null ? void 0 : Me.guid,
          analogExtrusionUuid: ((je = D.implantModel) == null ? void 0 : je.uuid) ?? ((dt = D.implantModel) == null ? void 0 : dt.name)
        };
        U.origin = Array.from(vt.origin), U.direction = Array.from(vt.direction), U.viewUp = Array.from(vt.viewUp), U.existingSelection = mt, M.value = Math.random(), P(_);
      }
    }
    function re(_, D, Y) {
      const Q = i.objects.implants.getByTooth(_);
      Q && i.objects.changeLockStatus(Q.id, Y);
    }
    function q(_, D) {
      var Y;
      _ === ((Y = x.selectedObject) == null ? void 0 : Y.getName()) && D == Le._IMPLANT && (x.selectedObject = null), i.objects.removeImplantObjectByTooth(_, D), H();
    }
    function De(_, D, Y) {
      i.objects.changeAngle(_, D, Y), x.selectedObject != null && x.selectedObject.isImplant() && W(x.selectedObject);
    }
    function _e(_, D, Y) {
      te.value = !0, i.objects.setImplantPartVisibility(_, D, Y);
    }
    function xe(_) {
      const D = {
        origin: i.toolManager.coordControl.getObjectPos(Le._IMPLANT),
        direction: i.toolManager.coordControl.getObjectDir(Le._IMPLANT),
        viewUp: i.toolManager.coordControl.getObjectViewup(Le._IMPLANT)
      };
      U.origin = Array.from(D.origin);
      const Y = i.objects.getMarkerByToothName(_);
      Y && (U.origin = Array.from(Y.getPosition())), U.direction = Array.from(D.direction), U.viewUp = Array.from(D.viewUp), S.value ? U.existingSelection = {
        implantId: S.value.implantGuid,
        abutmentId: S.value.abutmentGuid,
        sleeveId: S.value.sleeveName,
        scanAbutmentId: S.value.scanAbutmentGuid,
        secondaryAbutmentId: S.value.secondaryAbutmentGuid,
        secondaryScanAbutmentId: S.value.secondaryScanAbutmentGuid,
        analogExtrusionUuid: S.value.analogExtrusionUuid
      } : U.existingSelection = {
        implantId: I.lastSelectedImplantId,
        abutmentId: I.lastSelectedAbutmentId,
        sleeveId: I.lastSelectedSleeveId
      }, M.value = Math.random(), P(_);
    }
    function k(_) {
      const D = j(_);
      D && (D.tooth.editMode === Ta.ADD ? (o("hideWizard"), xe(D.name)) : (i.objects.selectImplant(D.name), me.value && (o("hideWizard"), ie(D.name))));
    }
    function K(_) {
      fe(!1), k(_);
    }
    const Ae = () => {
      console.log("Not yet implemented: switchToMandible");
    }, me = F(!1), Ne = ks();
    Ne.setStlLibraryVisible(me.value), ot(me, (_) => {
      Ne.setStlLibraryVisible(_);
    });
    let Ge;
    const Ue = i.getOverlayContainer(), Ke = et({
      top: 0,
      left: 0,
      width: 0,
      height: 0
    }), st = () => {
      const _ = Ue.getBoundingClientRect();
      Ke.top = _.top, Ke.left = _.left, Ke.width = _.width / 2.5, Ke.height = _.height;
    };
    c(i.getState().canvasSize, () => {
      me.value && st();
    }), eb(Ue, () => {
      me.value && st();
    });
    let G = null;
    const P = (_) => {
      kS(m.value);
      const D = i.objects.implants.getByTooth(_);
      G = {
        implant: (D == null ? void 0 : D.toProjectImplantParts()) ?? null,
        position: (D == null ? void 0 : D.getPosition()) ?? null,
        tooth: _
      }, st(), U.tooth = _, !me.value && (me.value = !0, Ge = i.layoutManager.getCurrentLayoutState(), i.layoutManager.restoreLayoutState({
        template: Ve._STL_PICKER_PREVIEW,
        presenterWindow2dLayouts: {
          [Nn.CROSS]: Cc._1x1,
          [Nn.TANGENT]: Cc._1x1
        }
      }));
    }, de = () => {
      me.value = !1, Ge !== void 0 && i.layoutManager.restoreLayoutState(Ge), G = null, H(), x.selectedObject && x.selectedObject.type === Le._IMPLANT && be(x.selectedObject), i.objects.measurementsObjects.get().forEach((_, D) => {
        _.annotation.owner.getViewMode() == Nn._STL_3D_PREVIEW && i.toolManager.measurementsTool.deleteMeasurementById(D);
      });
    }, fe = (_) => {
      G = null, _ && (Nd(m.value), de());
    }, ke = (_) => {
      if (G) {
        const { implant: D, position: Y, tooth: Q } = G;
        if (D && Y) {
          i.objects.replaceImplant(D, !1, { ignoreScaling: !1, disableCenterLines: !1 });
          const ae = i.objects.implants.getByTooth(Q.toString());
          ae && ae.moveTo(Y), i.objects.selectImplant(Q);
        } else
          i.objects.implants.deleteByTooth(Q.toString()), i.objects.unSelectObject();
      }
      G = null, Nd(m.value), de();
    }, le = () => {
      me.value && fe(!0), Kr(), o("showWizard");
    }, pe = () => {
      me.value && ke(), Kr(), o("showWizard");
    }, Z = (_, D) => {
      var Q, ae;
      const Y = i.objects.implants.getByTooth(_);
      Y && D && !((Q = Y.getSleeve()) != null && Q.getSleeveInfo().lockDistance) && ((ae = Y.getSleeve()) == null || ae.sleeveHeightChange(D), Y.updatePosition(), i.objects.checkCollisions(Y), i.objects.updateImplantPlannerGUIEvent.notify(i.objects.selectedObject.get()));
    }, ee = (_, D) => {
      var Fe;
      const Y = i.objects.implants.getByTooth(_);
      if (!Y || Number.isNaN(D))
        return;
      const Q = (Fe = Y.getSleeve()) == null ? void 0 : Fe.getSleeveInfo();
      if (!Q)
        return;
      const ae = Y.getProjectImplantInfo().connectionSides ?? 0;
      if (ae <= 0)
        return;
      const ge = Math.max(0, Math.min(ae - 1, Math.round(D)));
      (Q.connectionIndex ?? 0) !== ge && (Q.connectionIndex = ge, te.value = !0, Y.updatePosition(), i.objects.checkCollisions(Y));
    }, $ = (_, D) => {
      var Q, ae;
      const Y = i.objects.implants.getByTooth(_);
      if (Y && D) {
        if ((Q = Y.getSleeve()) != null && Q.getSleeveInfo().lockDistance) return;
        (ae = Y.getSleeve()) == null || ae.setDrillLength(D), Y.updatePosition(), i.objects.checkCollisions(Y);
      }
    };
    return (_, D) => {
      const Y = $S, Q = yS;
      return O(), J(ze, null, [
        y("div", JN, [
          y("div", XN, [
            y("div", qN, [
              d(r(Ce), {
                class: He("btn-wizard-lg"),
                label: _.$t("implant-planner.switchToMandibleProject"),
                onClick: Ae
              }, null, 8, ["label"])
            ])
          ])
        ]),
        d(r(wr), {
          jawboneType: x.jawboneType,
          teeth: x.teeth,
          useUSStyleToothChart: X.value,
          warningString: x.warnString,
          onToothClick: k,
          onToothMouseOut: H,
          onToothMouseOver: Re
        }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart", "warningString"]),
        l.value ? ue("", !0) : (O(), J("div", QN, [
          d(Y, {
            object: x.objectsModel,
            "objects-preview": x.objectsPreview,
            "selected-object": !!r(i).objects.selectedObject.get(),
            isReadOnly: r(s),
            onChangeLock: re,
            onChangeObject: ie,
            onChangeVisibility: _e,
            onRemoveObject: q,
            onChangeAngle: De,
            onChangeSleeveDistance: Z,
            onChangeSleeveRotationStep: ee,
            onChangeDrillLength: $
          }, null, 8, ["object", "objects-preview", "selected-object", "isReadOnly"])
        ])),
        l.value ? (O(), J("div", eL, [
          d(Q, {
            object: x.objectsModel,
            "objects-preview": x.objectsPreview,
            "selected-object": !!r(i).objects.selectedObject.get(),
            isReadOnly: r(s),
            onChangeObject: ie,
            onChangeVisibility: _e,
            onRemoveObject: q
          }, null, 8, ["object", "objects-preview", "selected-object", "isReadOnly"])
        ])) : ue("", !0),
        me.value ? (O(), he(au, {
          key: 2,
          to: "#stlLibraryContainer"
        }, [
          (O(), he(ZN, Pe(U, {
            implantList: x.implants,
            showSecondaryComponents: l.value,
            "onUpdate:showSecondaryComponents": D[0] || (D[0] = (ae) => l.value = ae),
            onOnConfirm: le,
            onOnReject: pe,
            onOnImplantChange: K,
            key: M.value
          }), null, 16, ["implantList", "showSecondaryComponents"]))
        ])) : ue("", !0)
      ], 64);
    };
  }
}), nL = { style: { flex: "1 1 auto", "min-height": "0", "padding-bottom": "0.75rem", "overflow-y": "auto", "overflow-x": "hidden" } }, aL = { class: "text-lg" }, oL = { class: "font-medium mr-2" }, lL = { class: "font-medium ml-2" }, iL = /* @__PURE__ */ qe({
  __name: "IPImplantPlanningContainer",
  props: {
    isReadOnly: { type: Boolean }
  },
  emits: ["hideWizard", "showWizard"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = F(!0), { watch: l } = Ra(), s = pn(), i = !!(s.license.versionType & Va.START);
    let c = et({
      disabled: !1,
      pressable: !0,
      pressed: o.value
    }), u = et({
      disabled: !1,
      pressable: !0,
      pressed: !o.value
    });
    const p = et({
      clicked: !1,
      state: !1,
      disabled: !1
    }), b = () => {
      o.value = !0, u.pressed = !1, c.pressed = !0;
    }, f = () => {
      o.value = !1, c.pressed = !1, u.pressed = !0, p.state = !1;
    };
    return l(s.objects.selectedObject, async (h) => {
      h && (c.pressed = h.type === Le._IMPLANT, u.pressed = h.type === Le._PIN, o.value = h.type === Le._IMPLANT);
    }), (h, I) => {
      const m = jo, S = tL, E = nS;
      return O(), J(ze, null, [
        d(m, {
          onHideWizard: I[0] || (I[0] = (g) => a("hideWizard")),
          onShowWizard: I[1] || (I[1] = (g) => a("showWizard"))
        }, {
          default: w(() => [
            yt(V(h.$t("implant-planner.implantPlanning")), 1)
          ]),
          _: 1
        }),
        d(r(Be), {
          class: "ml-4 vertical-padding gap-2",
          style: { "padding-right": "2rem !important" }
        }, {
          default: w(() => [
            d(r(Ce), {
              toggled: r(c).pressed,
              label: h.$t("implant-planner.implantPlanning"),
              class: He(["web-rg-icon-btn grow", r(c).pressed ? "default_cursor" : ""]),
              "data-cy": "btn_implant_planning",
              onClick: b
            }, null, 8, ["toggled", "label", "class"]),
            d(r(Ce), {
              toggled: r(u).pressed,
              label: h.$t("implant-planner.pinPlanning"),
              class: He(["web-rg-icon-btn grow", r(u).pressed ? "default_cursor" : ""]),
              "data-cy": "btn_pin_planning",
              onClick: f
            }, null, 8, ["toggled", "label", "class"])
          ]),
          _: 1
        }),
        d(r(at), {
          class: "mt-2 gap-2 horizontal-padding h-full",
          style: { "min-height": "0" }
        }, {
          default: w(() => [
            y("div", nL, [
              o.value ? (O(), he(S, {
                key: 0,
                isReadOnly: n.isReadOnly || i,
                showSecondaryComponents: p.state,
                "onUpdate:showSecondaryComponents": I[2] || (I[2] = (g) => p.state = g),
                onShowWizard: I[3] || (I[3] = (g) => a("showWizard")),
                onHideWizard: I[4] || (I[4] = (g) => a("hideWizard"))
              }, null, 8, ["isReadOnly", "showSecondaryComponents"])) : ue("", !0),
              o.value ? ue("", !0) : (O(), he(E, {
                key: 1,
                isReadOnly: e.isReadOnly || i
              }, null, 8, ["isReadOnly"]))
            ]),
            o.value ? (O(), he(r(Be), {
              key: 0,
              style: { flex: "0 0 auto" }
            }, {
              default: w(() => [
                d(r(Lt), null, {
                  default: w(() => [
                    y("span", aL, V(h.$t("implant-planner.secondaryComponents")), 1)
                  ]),
                  _: 1
                }),
                d(r(Lt), {
                  class: "gap-2",
                  style: { "justify-content": "end" }
                }, {
                  default: w(() => [
                    d(r(io), {
                      state: p.state,
                      "onUpdate:state": I[5] || (I[5] = (g) => p.state = g),
                      disabled: p.disabled,
                      "onUpdate:disabled": I[6] || (I[6] = (g) => p.disabled = g)
                    }, {
                      falseLabel: w(() => [
                        y("span", oL, V(h.$t("implant-planner.off")), 1)
                      ]),
                      trueLabel: w(() => [
                        y("span", lL, V(h.$t("implant-planner.on")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : ue("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), zu = /* @__PURE__ */ $t(iL, [["__scopeId", "data-v-1f293ca5"]]);
var Sf = {
  name: "SpinnerIcon",
  extends: sa
};
function sL(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Sf.render = sL;
const rL = {
  name: "BaseButton",
  extends: Ja,
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPos: {
      type: String,
      default: "left"
    },
    iconClass: {
      type: [String, Object],
      default: null
    },
    badge: {
      type: String,
      default: null
    },
    badgeClass: {
      type: [String, Object],
      default: null
    },
    badgeSeverity: {
      type: String,
      default: "secondary"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    as: {
      type: [String, Object],
      default: "BUTTON"
    },
    asChild: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Boolean,
      default: !1
    },
    severity: {
      type: String,
      default: null
    },
    raised: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    plain: {
      type: Boolean,
      default: !1
    },
    fluid: {
      type: Boolean,
      default: null
    }
  },
  style: ab,
  provide() {
    return {
      $pcButton: this,
      $parentInstance: this
    };
  }
}, uL = {
  name: "Button",
  extends: rL,
  inheritAttrs: !1,
  inject: {
    $pcFluid: { default: null }
  },
  methods: {
    getPTOptions(e) {
      return (e === "root" ? this.ptmi : this.ptm)(e, {
        context: {
          disabled: this.disabled
        }
      });
    }
  },
  computed: {
    disabled() {
      return this.$attrs.disabled || this.$attrs.disabled === "" || this.loading;
    },
    defaultAriaLabel() {
      return this.label ? this.label + (this.badge ? " " + this.badge : "") : this.$attrs.ariaLabel;
    },
    hasIcon() {
      return this.icon || this.$slots.icon;
    },
    attrs() {
      return Pe(this.asAttrs, this.a11yAttrs, this.getPTOptions("root"));
    },
    asAttrs() {
      return this.as === "BUTTON" ? { type: "button", disabled: this.disabled } : void 0;
    },
    a11yAttrs() {
      return {
        "aria-label": this.defaultAriaLabel,
        "data-pc-name": "button",
        "data-p-disabled": this.disabled,
        "data-p-severity": this.severity
      };
    },
    hasFluid() {
      return hi(this.fluid) ? !!this.$pcFluid : this.fluid;
    }
  },
  components: {
    SpinnerIcon: Sf,
    Badge: nb
  },
  directives: {
    ripple: jp
  }
};
function cL(e, t, n, a, o, l) {
  const s = Cn("SpinnerIcon"), i = Cn("Badge"), c = ou("ripple");
  return e.asChild ? St(e.$slots, "default", {
    key: 1,
    class: He(e.cx("root")),
    a11yAttrs: l.a11yAttrs
  }) : Pt((O(), he(Ea(e.as), Pe({
    key: 0,
    class: e.cx("root")
  }, l.attrs), {
    default: w(() => [
      St(e.$slots, "default", {}, () => [
        e.loading ? St(e.$slots, "loadingicon", Pe({
          key: 0,
          class: [e.cx("loadingIcon"), e.cx("icon")]
        }, e.ptm("loadingIcon")), () => [
          e.loadingIcon ? (O(), J("span", Pe({
            key: 0,
            class: [e.cx("loadingIcon"), e.cx("icon"), e.loadingIcon]
          }, e.ptm("loadingIcon")), null, 16)) : (O(), he(s, Pe({
            key: 1,
            class: [e.cx("loadingIcon"), e.cx("icon")],
            spin: ""
          }, e.ptm("loadingIcon")), null, 16, ["class"]))
        ]) : St(e.$slots, "icon", Pe({
          key: 1,
          class: [e.cx("icon")]
        }, e.ptm("icon")), () => [
          e.icon ? (O(), J("span", Pe({
            key: 0,
            class: [e.cx("icon"), e.icon, e.iconClass]
          }, e.ptm("icon")), null, 16)) : ue("", !0)
        ]),
        y("span", Pe({
          class: e.cx("label")
        }, e.ptm("label")), V(e.label || " "), 17),
        e.badge ? (O(), he(i, {
          key: 2,
          value: e.badge,
          class: He(e.badgeClass),
          severity: e.badgeSeverity,
          unstyled: e.unstyled,
          pt: e.ptm("pcBadge")
        }, null, 8, ["value", "class", "severity", "unstyled", "pt"])) : ue("", !0)
      ])
    ]),
    _: 3
  }, 16, ["class"])), [
    [c]
  ]);
}
const dL = /* @__PURE__ */ $t(uL, [["render", cL]]), pL = {
  key: 0,
  class: "text-xl mt-3 mb-3"
}, mL = /* @__PURE__ */ qe({
  __name: "ImportObjectsPreviewList",
  emits: ["proceedToImport"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = Hg(a.importObjects), l = t, s = () => {
      l("proceedToImport", o.value), n.value.close();
    }, i = () => {
      n.value.close();
    };
    return (c, u) => (O(), J(ze, null, [
      r(a).hideHeader ? ue("", !0) : (O(), J("div", pL, V(c.$t("implant-planner.selectObjectsToImport")), 1)),
      d(r(Ee), {
        class: "flex-row-wrap grow gap-6 col-span-12 justify-center overflow-auto h-full mb-3",
        style: { "max-width": "75vw", "max-height": "80vh" }
      }, {
        default: w(() => [
          (O(!0), J(ze, null, Rt(r(o), (p, b) => (O(), J("div", { key: b }, [
            d(r(ah), {
              item: p,
              itemSelected: p.selected,
              "onUpdate:itemSelected": (f) => p.selected = f
            }, {
              default: w(() => [
                d(r(Pn), {
                  modelValue: p.typeCAD,
                  "onUpdate:modelValue": (f) => p.typeCAD = f,
                  options: r(Nh),
                  optionLabel: "label",
                  optionValue: "value",
                  class: "w-full mt-2"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]),
              _: 2
            }, 1032, ["item", "itemSelected", "onUpdate:itemSelected"])
          ]))), 128))
        ]),
        _: 1
      }),
      d(r(Ee), { class: "p-dialog-footer justify-center" }, {
        default: w(() => [
          d(r(la), {
            autofocus: "",
            class: "mt-6",
            label: c.$t("shared.ok"),
            onClick: s
          }, null, 8, ["label"]),
          d(r(ya), {
            class: "mt-6",
            label: c.$t("shared.cancel"),
            onClick: u[0] || (u[0] = (p) => i())
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), fL = {
  class: "flex text-4xl",
  style: { flex: "1 1 0" }
}, gL = {
  class: "flex w-full",
  style: { position: "absolute", "justify-content": "center" }
}, hL = "pontics", bL = "upperjaw", vL = "lowerjaw", If = /* @__PURE__ */ qe({
  __name: "TeethLibraryPreview",
  emits: ["confirm"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = F(), l = F(!0), s = F(!0), i = Te(() => l.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), c = Te(() => s.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), u = t, p = () => {
      var N, x, z, X;
      u("confirm", ((N = v.value) == null ? void 0 : N.label) || "", ((x = v.value) == null ? void 0 : x.modelName) || "", ((z = v.value) == null ? void 0 : z.guid) || "", ((X = v.value) == null ? void 0 : X.pool) || ""), n.value.close();
    }, b = () => {
      n.value.close();
    };
    let f, h, I;
    const m = [], S = [], E = Jn();
    let g = [];
    const v = F(), T = F(!1), R = async (N) => {
      await L(N);
    }, L = async (N) => {
      if (N) {
        T.value = !0, f.showLoading(nt("shared.loading"));
        try {
          await j(N);
        } finally {
          f.hideLoading(), T.value = !1;
        }
      }
    };
    Mt(async () => {
      f = a.context, h = f.createPreviewContext(o.value);
      const N = new Lh(h, Oh, Nn._3D, {
        background: [0.24, 0.24, 0.24],
        toolbarDisable: !0
      });
      h.addWindow(N), h.setLayout([[N, Dp.fullscreen]]);
      let x = N.getMainView();
      x && (I = x), g = await Ap(E), v.value = g[0], await L(v.value), h.resize();
    });
    const C = () => {
      l.value = !l.value, m.forEach((N) => {
        N.setVisibility(l.value, !0);
      }), h.repaint();
    }, A = () => {
      s.value = !s.value, S.forEach((N) => {
        N.setVisibility(s.value, !0);
      }), h.repaint();
    }, j = async (N) => {
      h.getObjects().stls.forEach((ie) => {
        ie.delete();
      }), m.length = 0, S.length = 0;
      const x = N.modelName;
      if (!x) return;
      const X = (await E.getCadLibrariesFilteredListByType(N.pool, x)).data;
      if (!X.length) return;
      const H = X.find((ie) => ie.fileType === "xml");
      if (!H) return;
      const M = await E.getCadLibrariesXmlById(H.id);
      if (!M) return;
      const te = Dh(M.data);
      te.Teeth_library.guid;
      const ne = te.Teeth_library.teeth.tooth;
      let W = "stl";
      X.find((ie) => ie.type == "xpd") && (W = "xpd");
      const se = hL, be = f.getEngine(), Re = new be.xFileUtilsWasm(), U = [];
      for (let ie = 1; ie < 9; ie++)
        for (let re = 1; re < 5; re++) {
          const q = (async () => {
            const De = qi.create(), _e = ne.findIndex((Ne) => Ne.number === ie && Ne.quadrant === re);
            if (_e != -1) {
              const Ne = ne[_e].transformation, Ge = new Float32Array(Ne.split(" ").map(parseFloat));
              qi.transpose(De, Ge);
            }
            const xe = re < 3 ? bL : vL, k = X.find((Ne) => Ne.fileType === W && Ne.fileName === ie.toString() && Ne.subLvlOne === se && Ne.subLvlTwo === xe);
            if (!k) return;
            const { data: K } = await E.getCadLibrariesFileById(k.id), Ae = new Int8Array(K), me = await Ah.fromBuffer({
              context: h,
              fileType: W,
              intArr: Ae,
              flip: re % 2 == 0,
              iXFs: Re,
              skipCopyToWasm: !0,
              ipOType: Le._STL_TOOTH,
              ipOSubType: Le._STL_OBJECT
            });
            me.setMatrix(De), re < 3 ? m.push(me) : S.push(me);
          })();
          U.push(q);
        }
      await Promise.all(U), console.log("parseTeethLibraryObjects - Done"), Re.delete(), h.sceneRepaint(), I.fitZoomToScreen(), h.repaint();
    };
    return (N, x) => (O(), J(ze, null, [
      d(r(Ee), {
        class: "flex w-full mt-6 p-dialog-header",
        style: { position: "relative" }
      }, {
        default: w(() => [
          y("div", fL, V(N.$t("implant-planner.teethLibrary")), 1),
          y("div", gL, [
            d(r(Ce), {
              class: "btn-wizard-md",
              togglable: !0,
              toggled: l.value,
              onToggledChange: C,
              "icon-src": i.value,
              "icon-src-height": "24px",
              "icon-src-width": "24px",
              label: N.$t("implant-planner.maxilla")
            }, null, 8, ["toggled", "icon-src", "label"]),
            d(r(Ce), {
              class: "btn-wizard-md ml-2",
              togglable: !0,
              toggled: s.value,
              onToggledChange: A,
              "icon-src": c.value,
              "icon-src-height": "24px",
              "icon-src-width": "24px",
              label: N.$t("implant-planner.mandible")
            }, null, 8, ["toggled", "icon-src", "label"])
          ])
        ]),
        _: 1
      }),
      d(r(Ee), { class: "w-full mt-3" }, {
        default: w(() => [
          d(r(Pn), {
            class: "w-full",
            modelValue: v.value,
            "onUpdate:modelValue": [
              x[0] || (x[0] = (z) => v.value = z),
              R
            ],
            options: r(g),
            optionLabel: "label",
            disabled: T.value
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _: 1
      }),
      y("div", {
        ref_key: "vtkContainer",
        ref: o,
        class: "mt-2",
        style: { width: "60vw !important", height: "35vh" }
      }, null, 512),
      d(r(Ee), { class: "p-dialog-footer justify-center" }, {
        default: w(() => [
          d(r(la), {
            autofocus: "",
            class: "mt-6",
            label: N.$t("shared.ok"),
            disabled: T.value,
            onClick: p
          }, null, 8, ["label", "disabled"]),
          d(r(ya), {
            class: "mt-6",
            label: N.$t("shared.cancel"),
            onClick: x[1] || (x[1] = (z) => b())
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
});
var Ef = {
  name: "EyeIcon",
  extends: sa
};
function yL(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.0535499 7.25213C0.208567 7.59162 2.40413 12.4 7 12.4C11.5959 12.4 13.7914 7.59162 13.9465 7.25213C13.9487 7.2471 13.9506 7.24304 13.952 7.24001C13.9837 7.16396 14 7.08239 14 7.00001C14 6.91762 13.9837 6.83605 13.952 6.76001C13.9506 6.75697 13.9487 6.75292 13.9465 6.74788C13.7914 6.4084 11.5959 1.60001 7 1.60001C2.40413 1.60001 0.208567 6.40839 0.0535499 6.74788C0.0512519 6.75292 0.0494023 6.75697 0.048 6.76001C0.0163137 6.83605 0 6.91762 0 7.00001C0 7.08239 0.0163137 7.16396 0.048 7.24001C0.0494023 7.24304 0.0512519 7.2471 0.0535499 7.25213ZM7 11.2C3.664 11.2 1.736 7.92001 1.264 7.00001C1.736 6.08001 3.664 2.80001 7 2.80001C10.336 2.80001 12.264 6.08001 12.736 7.00001C12.264 7.92001 10.336 11.2 7 11.2ZM5.55551 9.16182C5.98308 9.44751 6.48576 9.6 7 9.6C7.68891 9.59789 8.349 9.32328 8.83614 8.83614C9.32328 8.349 9.59789 7.68891 9.59999 7C9.59999 6.48576 9.44751 5.98308 9.16182 5.55551C8.87612 5.12794 8.47006 4.7947 7.99497 4.59791C7.51988 4.40112 6.99711 4.34963 6.49276 4.44995C5.98841 4.55027 5.52513 4.7979 5.16152 5.16152C4.7979 5.52513 4.55027 5.98841 4.44995 6.49276C4.34963 6.99711 4.40112 7.51988 4.59791 7.99497C4.7947 8.47006 5.12794 8.87612 5.55551 9.16182ZM6.2222 5.83594C6.45243 5.6821 6.7231 5.6 7 5.6C7.37065 5.6021 7.72553 5.75027 7.98762 6.01237C8.24972 6.27446 8.39789 6.62934 8.4 7C8.4 7.27689 8.31789 7.54756 8.16405 7.77779C8.01022 8.00802 7.79157 8.18746 7.53575 8.29343C7.27994 8.39939 6.99844 8.42711 6.72687 8.37309C6.4553 8.31908 6.20584 8.18574 6.01005 7.98994C5.81425 7.79415 5.68091 7.54469 5.6269 7.27312C5.57288 7.00155 5.6006 6.72006 5.70656 6.46424C5.81253 6.20842 5.99197 5.98977 6.2222 5.83594Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Ef.render = yL;
var Tf = {
  name: "RefreshIcon",
  extends: sa
};
function _L(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.77051 5.96336C6.84324 5.99355 6.92127 6.00891 7.00002 6.00854C7.07877 6.00891 7.1568 5.99355 7.22953 5.96336C7.30226 5.93317 7.36823 5.88876 7.42357 5.83273L9.82101 3.43529C9.93325 3.32291 9.99629 3.17058 9.99629 3.01175C9.99629 2.85292 9.93325 2.70058 9.82101 2.5882L7.42357 0.190763C7.3687 0.131876 7.30253 0.0846451 7.22901 0.0518865C7.15549 0.019128 7.07612 0.00151319 6.99564 9.32772e-05C6.91517 -0.00132663 6.83523 0.0134773 6.7606 0.0436218C6.68597 0.0737664 6.61817 0.118634 6.56126 0.175548C6.50435 0.232462 6.45948 0.300257 6.42933 0.374888C6.39919 0.449519 6.38439 0.529456 6.38581 0.609933C6.38722 0.690409 6.40484 0.769775 6.4376 0.843296C6.47036 0.916817 6.51759 0.982986 6.57647 1.03786L7.95103 2.41241H6.99998C5.46337 2.41241 3.98969 3.02283 2.90314 4.10938C1.81659 5.19593 1.20618 6.66961 1.20618 8.20622C1.20618 9.74283 1.81659 11.2165 2.90314 12.3031C3.98969 13.3896 5.46337 14 6.99998 14C8.53595 13.9979 10.0084 13.3868 11.0945 12.3007C12.1806 11.2146 12.7917 9.74218 12.7938 8.20622C12.7938 8.04726 12.7306 7.89481 12.6182 7.78241C12.5058 7.67001 12.3534 7.60686 12.1944 7.60686C12.0355 7.60686 11.883 7.67001 11.7706 7.78241C11.6582 7.89481 11.5951 8.04726 11.5951 8.20622C11.5951 9.11504 11.3256 10.0035 10.8207 10.7591C10.3157 11.5148 9.59809 12.1037 8.75845 12.4515C7.9188 12.7993 6.99489 12.8903 6.10353 12.713C5.21217 12.5357 4.3934 12.0981 3.75077 11.4554C3.10813 10.8128 2.67049 9.99404 2.49319 9.10268C2.31589 8.21132 2.40688 7.2874 2.75468 6.44776C3.10247 5.60811 3.69143 4.89046 4.44709 4.38554C5.20275 3.88063 6.09116 3.61113 6.99998 3.61113H7.95098L6.57647 4.98564C6.46423 5.09802 6.40119 5.25035 6.40119 5.40918C6.40119 5.56801 6.46423 5.72035 6.57647 5.83273C6.63181 5.88876 6.69778 5.93317 6.77051 5.96336Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Tf.render = _L;
var Cf = {
  name: "SearchMinusIcon",
  extends: sa
};
function wL(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.0208 12.0411C4.83005 12.0411 3.66604 11.688 2.67596 11.0265C1.68589 10.3649 0.914216 9.42464 0.458534 8.32452C0.00285271 7.22441 -0.116374 6.01388 0.11593 4.84601C0.348235 3.67813 0.921637 2.60537 1.76363 1.76338C2.60562 0.921393 3.67838 0.34799 4.84625 0.115686C6.01412 -0.116618 7.22466 0.00260857 8.32477 0.45829C9.42488 0.913972 10.3652 1.68564 11.0267 2.67572C11.6883 3.66579 12.0414 4.8298 12.0414 6.02056C12.0395 7.41563 11.5542 8.76029 10.6783 9.8305L13.8244 12.9765C13.9367 13.089 13.9997 13.2414 13.9997 13.4003C13.9997 13.5592 13.9367 13.7116 13.8244 13.8241C13.769 13.8801 13.703 13.9245 13.6302 13.9548C13.5575 13.985 13.4794 14.0003 13.4006 14C13.3218 14.0003 13.2437 13.985 13.171 13.9548C13.0982 13.9245 13.0322 13.8801 12.9768 13.8241L9.83082 10.678C8.76059 11.5539 7.4159 12.0393 6.0208 12.0411ZM6.0208 1.20731C5.07199 1.20731 4.14449 1.48867 3.35559 2.0158C2.56669 2.54292 1.95181 3.29215 1.58872 4.16874C1.22562 5.04532 1.13062 6.00989 1.31572 6.94046C1.50083 7.87104 1.95772 8.72583 2.62863 9.39674C3.29954 10.0676 4.15433 10.5245 5.0849 10.7096C6.01548 10.8947 6.98005 10.7997 7.85663 10.4367C8.73322 10.0736 9.48244 9.45868 10.0096 8.66978C10.5367 7.88088 10.8181 6.95337 10.8181 6.00457C10.8181 4.73226 10.3126 3.51206 9.41297 2.6124C8.51331 1.71274 7.29311 1.20731 6.0208 1.20731ZM4.00591 6.60422H8.00362C8.16266 6.60422 8.31518 6.54104 8.42764 6.42859C8.5401 6.31613 8.60328 6.1636 8.60328 6.00456C8.60328 5.84553 8.5401 5.693 8.42764 5.58054C8.31518 5.46809 8.16266 5.40491 8.00362 5.40491H4.00591C3.84687 5.40491 3.69434 5.46809 3.58189 5.58054C3.46943 5.693 3.40625 5.84553 3.40625 6.00456C3.40625 6.1636 3.46943 6.31613 3.58189 6.42859C3.69434 6.54104 3.84687 6.60422 4.00591 6.60422Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Cf.render = wL;
var Nf = {
  name: "SearchPlusIcon",
  extends: sa
};
function SL(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.67596 11.0265C3.66604 11.688 4.83005 12.0411 6.0208 12.0411C6.81143 12.0411 7.59432 11.8854 8.32477 11.5828C8.86999 11.357 9.37802 11.0526 9.83311 10.6803L12.9768 13.8241C13.0322 13.8801 13.0982 13.9245 13.171 13.9548C13.2437 13.985 13.3218 14.0003 13.4006 14C13.4794 14.0003 13.5575 13.985 13.6302 13.9548C13.703 13.9245 13.769 13.8801 13.8244 13.8241C13.9367 13.7116 13.9997 13.5592 13.9997 13.4003C13.9997 13.2414 13.9367 13.089 13.8244 12.9765L10.6806 9.8328C11.0529 9.37773 11.3572 8.86972 11.5831 8.32452C11.8856 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0267 2.67572C10.3652 1.68564 9.42488 0.913972 8.32477 0.45829C7.22466 0.00260857 6.01412 -0.116618 4.84625 0.115686C3.67838 0.34799 2.60562 0.921393 1.76363 1.76338C0.921637 2.60537 0.348235 3.67813 0.11593 4.84601C-0.116374 6.01388 0.00285271 7.22441 0.458534 8.32452C0.914216 9.42464 1.68589 10.3649 2.67596 11.0265ZM3.35559 2.0158C4.14449 1.48867 5.07199 1.20731 6.0208 1.20731C7.29311 1.20731 8.51331 1.71274 9.41297 2.6124C10.3126 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5367 7.88088 10.0096 8.66978C9.48244 9.45868 8.73322 10.0736 7.85663 10.4367C6.98005 10.7997 6.01548 10.8947 5.0849 10.7096C4.15433 10.5245 3.29954 10.0676 2.62863 9.39674C1.95772 8.72583 1.50083 7.87104 1.31572 6.94046C1.13062 6.00989 1.22562 5.04532 1.58872 4.16874C1.95181 3.29215 2.56669 2.54292 3.35559 2.0158ZM6.00481 8.60309C5.84641 8.60102 5.69509 8.53718 5.58308 8.42517C5.47107 8.31316 5.40722 8.16183 5.40515 8.00344V6.60422H4.00591C3.84687 6.60422 3.69434 6.54104 3.58189 6.42859C3.46943 6.31613 3.40625 6.1636 3.40625 6.00456C3.40625 5.84553 3.46943 5.693 3.58189 5.58054C3.69434 5.46809 3.84687 5.40491 4.00591 5.40491H5.40515V4.00572C5.40515 3.84668 5.46833 3.69416 5.58079 3.5817C5.69324 3.46924 5.84577 3.40607 6.00481 3.40607C6.16385 3.40607 6.31637 3.46924 6.42883 3.5817C6.54129 3.69416 6.60447 3.84668 6.60447 4.00572V5.40491H8.00362C8.16266 5.40491 8.31518 5.46809 8.42764 5.58054C8.5401 5.693 8.60328 5.84553 8.60328 6.00456C8.60328 6.1636 8.5401 6.31613 8.42764 6.42859C8.31518 6.54104 8.16266 6.60422 8.00362 6.60422H6.60447V8.00344C6.60239 8.16183 6.53855 8.31316 6.42654 8.42517C6.31453 8.53718 6.1632 8.60102 6.00481 8.60309Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Nf.render = SL;
var Lf = {
  name: "TimesIcon",
  extends: sa
};
function IL(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Lf.render = IL;
var Of = {
  name: "UndoIcon",
  extends: sa
};
function EL(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.77042 5.96336C6.84315 5.99355 6.92118 6.00891 6.99993 6.00854C7.07868 6.00891 7.15671 5.99355 7.22944 5.96336C7.30217 5.93317 7.36814 5.88876 7.42348 5.83273C7.53572 5.72035 7.59876 5.56801 7.59876 5.40918C7.59876 5.25035 7.53572 5.09802 7.42348 4.98564L6.04897 3.61113H6.99998C7.9088 3.61113 8.79722 3.88063 9.55288 4.38554C10.3085 4.89046 10.8975 5.60811 11.2453 6.44776C11.5931 7.2874 11.6841 8.21132 11.5068 9.10268C11.3295 9.99404 10.8918 10.8128 10.2492 11.4554C9.60657 12.0981 8.7878 12.5357 7.89644 12.713C7.00508 12.8903 6.08116 12.7993 5.24152 12.4515C4.40188 12.1037 3.68422 11.5148 3.17931 10.7591C2.67439 10.0035 2.4049 9.11504 2.4049 8.20622C2.4049 8.04726 2.34175 7.89481 2.22935 7.78241C2.11695 7.67001 1.9645 7.60686 1.80554 7.60686C1.64658 7.60686 1.49413 7.67001 1.38172 7.78241C1.26932 7.89481 1.20618 8.04726 1.20618 8.20622C1.20829 9.74218 1.81939 11.2146 2.90548 12.3007C3.99157 13.3868 5.46402 13.9979 6.99998 14C8.5366 14 10.0103 13.3896 11.0968 12.3031C12.1834 11.2165 12.7938 9.74283 12.7938 8.20622C12.7938 6.66961 12.1834 5.19593 11.0968 4.10938C10.0103 3.02283 8.5366 2.41241 6.99998 2.41241H6.04892L7.42348 1.03786C7.48236 0.982986 7.5296 0.916817 7.56235 0.843296C7.59511 0.769775 7.61273 0.690409 7.61415 0.609933C7.61557 0.529456 7.60076 0.449519 7.57062 0.374888C7.54047 0.300257 7.49561 0.232462 7.43869 0.175548C7.38178 0.118634 7.31398 0.0737664 7.23935 0.0436218C7.16472 0.0134773 7.08478 -0.00132663 7.00431 9.32772e-05C6.92383 0.00151319 6.84447 0.019128 6.77095 0.0518865C6.69742 0.0846451 6.63126 0.131876 6.57638 0.190763L4.17895 2.5882C4.06671 2.70058 4.00366 2.85292 4.00366 3.01175C4.00366 3.17058 4.06671 3.32291 4.17895 3.43529L6.57638 5.83273C6.63172 5.88876 6.69769 5.93317 6.77042 5.96336Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Of.render = EL;
const TL = {
  name: "BaseImage",
  extends: Ja,
  props: {
    preview: {
      type: Boolean,
      default: !1
    },
    class: {
      type: null,
      default: null
    },
    style: {
      type: null,
      default: null
    },
    imageStyle: {
      type: null,
      default: null
    },
    imageClass: {
      type: null,
      default: null
    },
    previewButtonProps: {
      type: null,
      default: null
    },
    indicatorIcon: {
      type: String,
      default: void 0
    },
    previewIcon: {
      type: String,
      default: void 0
    },
    zoomInDisabled: {
      type: Boolean,
      default: !1
    },
    zoomOutDisabled: {
      type: Boolean,
      default: !1
    }
  },
  style: ib,
  provide() {
    return {
      $pcImage: this,
      $parentInstance: this
    };
  }
}, CL = {
  name: "Image",
  extends: TL,
  inheritAttrs: !1,
  emits: ["show", "hide", "error"],
  mask: null,
  data() {
    return {
      maskVisible: !1,
      previewVisible: !1,
      rotate: 0,
      scale: 1
    };
  },
  beforeUnmount() {
    this.mask && er.clear(this.container);
  },
  methods: {
    maskRef(e) {
      this.mask = e;
    },
    toolbarRef(e) {
      this.toolbarRef = e;
    },
    onImageClick() {
      this.preview && (Ly(), this.maskVisible = !0, setTimeout(() => {
        this.previewVisible = !0;
      }, 25));
    },
    onPreviewImageClick() {
      this.previewClick = !0;
    },
    onMaskClick(e) {
      const t = jy(e.target, "data-pc-section-group", "action") || e.target.closest('[data-pc-section-group="action"]');
      !this.previewClick && !t && (this.previewVisible = !1, this.rotate = 0, this.scale = 1), this.previewClick = !1;
    },
    onMaskKeydown(e) {
      switch (e.code) {
        case "Escape":
          this.hidePreview(), setTimeout(() => {
            Bi(this.$refs.previewButton);
          }, 200), e.preventDefault();
          break;
      }
    },
    onError() {
      this.$emit("error");
    },
    rotateRight() {
      this.rotate += 90, this.previewClick = !0;
    },
    rotateLeft() {
      this.rotate -= 90, this.previewClick = !0;
    },
    zoomIn() {
      this.scale = this.scale + 0.1, this.previewClick = !0;
    },
    zoomOut() {
      this.scale = this.scale - 0.1, this.previewClick = !0;
    },
    onBeforeEnter() {
      er.set("modal", this.mask, this.$primevue.config.zIndex.modal);
    },
    onEnter() {
      this.focus(), this.$emit("show");
    },
    onBeforeLeave() {
      !this.isUnstyled && dm(this.mask, "p-overlay-mask-leave");
    },
    onLeave() {
      od(), this.$emit("hide");
    },
    onAfterLeave(e) {
      er.clear(e), this.maskVisible = !1;
    },
    focus() {
      let e = this.mask.querySelector("[autofocus]");
      e && e.focus();
    },
    hidePreview() {
      this.previewVisible = !1, this.rotate = 0, this.scale = 1, od();
    }
  },
  computed: {
    containerClass() {
      return [this.cx("root"), this.class];
    },
    rotateClass() {
      return "p-image-preview-rotate-" + this.rotate;
    },
    imagePreviewStyle() {
      return { transform: "rotate(" + this.rotate + "deg) scale(" + this.scale + ")" };
    },
    isZoomInDisabled() {
      return this.zoomInDisabled || this.scale >= 1.5;
    },
    isZoomOutDisabled() {
      return this.zoomOutDisabled || this.scale <= 0.5;
    },
    rightAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.rotateRight : void 0;
    },
    leftAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.rotateLeft : void 0;
    },
    zoomInAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.zoomIn : void 0;
    },
    zoomOutAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.zoomOut : void 0;
    },
    zoomImageAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.zoomImage : void 0;
    },
    closeAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    }
  },
  components: {
    Portal: lb,
    EyeIcon: Ef,
    RefreshIcon: Tf,
    UndoIcon: Of,
    SearchMinusIcon: Cf,
    SearchPlusIcon: Nf,
    TimesIcon: Lf
  },
  directives: {
    focustrap: ob
  }
}, NL = ["aria-label"], LL = ["aria-modal"], OL = ["aria-label"], DL = ["aria-label"], AL = ["disabled", "aria-label"], RL = ["disabled", "aria-label"], ML = ["aria-label"], PL = ["src"];
function xL(e, t, n, a, o, l) {
  const s = Cn("RefreshIcon"), i = Cn("UndoIcon"), c = Cn("SearchMinusIcon"), u = Cn("SearchPlusIcon"), p = Cn("TimesIcon"), b = Cn("Portal"), f = ou("focustrap");
  return O(), J("span", Pe({
    class: l.containerClass,
    style: e.style
  }, e.ptmi("root")), [
    St(e.$slots, "image", { errorCallback: l.onError }, () => [
      y("img", Pe({
        style: e.imageStyle,
        class: e.imageClass,
        onError: t[0] || (t[0] = (...h) => l.onError && l.onError(...h))
      }, { ...e.$attrs, ...e.ptm("image") }), null, 16)
    ]),
    e.preview ? (O(), J("button", Pe({
      key: 0,
      ref: "previewButton",
      "aria-label": l.zoomImageAriaLabel,
      type: "button",
      class: e.cx("previewMask"),
      onClick: t[1] || (t[1] = (...h) => l.onImageClick && l.onImageClick(...h))
    }, { ...e.previewButtonProps, ...e.ptm("previewMask") }), [
      St(e.$slots, e.$slots.previewicon ? "previewicon" : "indicatoricon", {}, () => [
        (O(), he(Ea(e.previewIcon || e.indicatorIcon ? "i" : "EyeIcon"), Pe({
          class: e.cx("previewIcon")
        }, e.ptm("previewIcon")), null, 16, ["class"]))
      ])
    ], 16, NL)) : ue("", !0),
    d(b, null, {
      default: w(() => [
        o.maskVisible ? Pt((O(), J("div", Pe({
          key: 0,
          ref: l.maskRef,
          role: "dialog",
          class: e.cx("mask"),
          "aria-modal": o.maskVisible,
          onClick: t[8] || (t[8] = (...h) => l.onMaskClick && l.onMaskClick(...h)),
          onKeydown: t[9] || (t[9] = (...h) => l.onMaskKeydown && l.onMaskKeydown(...h))
        }, e.ptm("mask")), [
          y("div", Pe({
            class: e.cx("toolbar")
          }, e.ptm("toolbar")), [
            y("button", Pe({
              class: e.cx("rotateRightButton"),
              onClick: t[2] || (t[2] = (...h) => l.rotateRight && l.rotateRight(...h)),
              type: "button",
              "aria-label": l.rightAriaLabel
            }, e.ptm("rotateRightButton"), { "data-pc-group-section": "action" }), [
              St(e.$slots, "refresh", {}, () => [
                d(s, bo(Cl(e.ptm("rotateRightIcon"))), null, 16)
              ])
            ], 16, OL),
            y("button", Pe({
              class: e.cx("rotateLeftButton"),
              onClick: t[3] || (t[3] = (...h) => l.rotateLeft && l.rotateLeft(...h)),
              type: "button",
              "aria-label": l.leftAriaLabel
            }, e.ptm("rotateLeftButton"), { "data-pc-group-section": "action" }), [
              St(e.$slots, "undo", {}, () => [
                d(i, bo(Cl(e.ptm("rotateLeftIcon"))), null, 16)
              ])
            ], 16, DL),
            y("button", Pe({
              class: e.cx("zoomOutButton"),
              onClick: t[4] || (t[4] = (...h) => l.zoomOut && l.zoomOut(...h)),
              type: "button",
              disabled: l.isZoomOutDisabled,
              "aria-label": l.zoomOutAriaLabel
            }, e.ptm("zoomOutButton"), { "data-pc-group-section": "action" }), [
              St(e.$slots, "zoomout", {}, () => [
                d(c, bo(Cl(e.ptm("zoomOutIcon"))), null, 16)
              ])
            ], 16, AL),
            y("button", Pe({
              class: e.cx("zoomInButton"),
              onClick: t[5] || (t[5] = (...h) => l.zoomIn && l.zoomIn(...h)),
              type: "button",
              disabled: l.isZoomInDisabled,
              "aria-label": l.zoomInAriaLabel
            }, e.ptm("zoomInButton"), { "data-pc-group-section": "action" }), [
              St(e.$slots, "zoomin", {}, () => [
                d(u, bo(Cl(e.ptm("zoomInIcon"))), null, 16)
              ])
            ], 16, RL),
            y("button", Pe({
              class: e.cx("closeButton"),
              type: "button",
              onClick: t[6] || (t[6] = (...h) => l.hidePreview && l.hidePreview(...h)),
              "aria-label": l.closeAriaLabel,
              autofocus: ""
            }, e.ptm("closeButton"), { "data-pc-group-section": "action" }), [
              St(e.$slots, "close", {}, () => [
                d(p, bo(Cl(e.ptm("closeIcon"))), null, 16)
              ])
            ], 16, ML)
          ], 16),
          d(Yg, Pe({
            name: "p-image-original",
            onBeforeEnter: l.onBeforeEnter,
            onEnter: l.onEnter,
            onLeave: l.onLeave,
            onBeforeLeave: l.onBeforeLeave,
            onAfterLeave: l.onAfterLeave
          }, e.ptm("transition")), {
            default: w(() => [
              o.previewVisible ? (O(), J("div", bo(Pe({ key: 0 }, e.ptm("originalContainer"))), [
                St(e.$slots, e.$slots.original ? "original" : "preview", {
                  class: He(e.cx("original")),
                  style: Tt(l.imagePreviewStyle),
                  previewCallback: l.onPreviewImageClick
                }, () => [
                  y("img", Pe({
                    src: e.$attrs.src,
                    class: e.cx("original"),
                    style: l.imagePreviewStyle,
                    onClick: t[7] || (t[7] = (...h) => l.onPreviewImageClick && l.onPreviewImageClick(...h))
                  }, e.ptm("original")), null, 16, PL)
                ])
              ], 16)) : ue("", !0)
            ]),
            _: 3
          }, 16, ["onBeforeEnter", "onEnter", "onLeave", "onBeforeLeave", "onAfterLeave"])
        ], 16, LL)), [
          [f]
        ]) : ue("", !0)
      ]),
      _: 3
    })
  ], 16);
}
const Hu = /* @__PURE__ */ $t(CL, [["render", xL]]);
class jL {
  constructor() {
    on(this, "CAN_USE_MODEL_PRO", 1);
    on(this, "CAN_USE_ENCODE_CONVERTOR", 1);
    on(this, "CAN_USE_BELLAK_ABUTMENT", 1);
    on(this, "CAN_USE_DIE_FIXATION", 1);
    on(this, "CAN_USE_TMJ_DIAGNOSIS", 1);
    on(this, "CAN_USE_ITAKA_VERSION", 1);
    on(this, "NA_ENTRY_LEVEL", !1);
    on(this, "VERSION_TYPE", 32);
  }
}
var Df = /* @__PURE__ */ ((e) => (e[e.CD_VIEWER = 1] = "CD_VIEWER", e[e.NORMAL = 2] = "NORMAL", e[e.START = 4] = "START", e[e.PRO = 8] = "PRO", e[e.DOUBLE_SCAN = 16] = "DOUBLE_SCAN", e[e.CAD = 32] = "CAD", e[e.SUBSCRIPTION = 64] = "SUBSCRIPTION", e[e.READ_ONLY = 128] = "READ_ONLY", e[e.PLAN = 256] = "PLAN", e))(Df || {});
const wl = new jL();
function FL() {
  return wl.CAN_USE_MODEL_PRO;
}
function Af() {
  return wl.NA_ENTRY_LEVEL;
}
function $L() {
  return wl.CAN_USE_ITAKA_VERSION;
}
function kL() {
  return wl.CAN_USE_TMJ_DIAGNOSIS;
}
function VL() {
  return wl.CAN_USE_BELLAK_ABUTMENT;
}
function BL() {
  return wl.VERSION_TYPE;
}
J0();
const Bl = (e, t) => {
  const n = nt(e);
  return n === e ? t : n;
}, UL = [
  [ve.eRD_CROWN_BRIDGE, "weblink.crownBridge", "Crown & Bridge"],
  [ve.eRD_DIGITAL_SMILE_DESIGN, "implant-planner.smileSetup", "Smile Setup"],
  [ve.eRD_BAR, "weblink.overdenture", "Overdenture"],
  [ve.eRD_PRE_OP, "weblink.preOp", "Pre-Op"],
  [ve.eRD_DENTURE, "weblink.denture", "Denture"],
  [ve.eRD_IL_PROVISIONAL, "weblink.immediateLoadProvisional", "Immediate Load Provisional"],
  [ve.eRD_MODEL_BUILDER, "weblink.modelSetup", "Model Setup"],
  [ve.eRD_MODEL_PRO, "weblink.modelPRO", "ModelPRO"],
  [ve.eRD_ORTHODONTIC_MODEL_BUILDER, "weblink.orthodonticModelSetup", "Orthodontic Model Setup"],
  [ve.eRD_BITE_SPLINT, "weblink.biteSplint", "Bite Splint"],
  [ve.eRD_TMJ_DIAGNOSIS, "weblink.tmjDiagnosis", "TMJ Diagnosis"],
  [ve.eRD_INNOVA_IMPLANT_CHECK, "weblink.innovaImplantCheck", "EasyCheck"],
  [ve.eRD_GUIDE, "implant-planner.guide", "Guide"],
  [ve.eRD_ANALOGS_MODEL, "implant-planner.analogsModel", "Analogs Model"],
  [ve.eRD_BONE_GRAFT, "medic-web-engine.boneGraft", "Bone Graft"],
  [ve.eRD_BONE_GRID, "medic-web-engine.boneGrid", "Bone Grid"],
  [ve.eRD_BONE_FROM_CT, "medic-web-engine.boneFromCt", "Bone From CT"],
  [ve.eRD_TEETH_FROM_CT, "medic-web-engine.teethFromCt", "Teeth From CT"],
  [ve.eRD_CROWNS_FROM_STL, "medic-web-engine.crownsFromStl", "Crowns From STL"],
  [ve.eRD_ADVANCED_FEATURES, "medic-web-engine.advancedFeatures", "Advanced Features"]
], Rf = Te(() => UL.reduce((e, [t, n, a]) => (e.set(t, Bl(n, a)), e), /* @__PURE__ */ new Map())), GL = (e, t) => {
  const n = nt(e);
  return n === e ? t : n;
}, WL = [
  [0, "implant-planner.stumpsTeethLibrary", "Stumps Teeth Library"],
  [6, "implant-planner.stumpsWaxup", "Stumps Waxup"],
  [1, "implant-planner.parametricProvisionalWaxup", "Parametric Provisional Waxup"],
  [2, "implant-planner.scannedTiBaseTeethLibrary", "Scanned TiBase Teeth Library"],
  [3, "implant-planner.scannedTiBaseWaxup", "Scanned TiBase Waxup"],
  [4, "implant-planner.scanAbutmentTeethLibrary", "Scan Abutment Teeth Library"],
  [7, "implant-planner.scanAbutmentWaxup", "Scan Abutment Waxup"],
  [26, "implant-planner.locatorOverdenture", "Locator Overdenture"],
  [27, "implant-planner.implantOverdenture", "Implant Overdenture"],
  [8, "implant-planner.abutment", "Abutment"],
  [9, "implant-planner.abutmentWaxup", "Abutment Waxup"],
  [10, "implant-planner.manualImplantWaxup", "Manual Implant Waxup"],
  [11, "implant-planner.mockupTeethLibrary", "Mockup Teeth Library"],
  [12, "implant-planner.healingAbutmentEggShell", "Healing Abutment + Egg Shell"],
  [18, "implant-planner.healingAbutmentEggShellWaxup", "Healing Abutment + Egg Shell Waxup"],
  [13, "implant-planner.shellTeethLibrary", "Shell Teeth Library"],
  [19, "implant-planner.shellWaxup", "Shell Waxup"],
  [14, "implant-planner.denture", "Denture"],
  [15, "implant-planner.mockUpSnapOnDigitalWaxup", "Mock-up/Snap-On/Digital Waxup"],
  [45, "implant-planner.smileSetup", "Smile Setup"],
  [16, "implant-planner.scannedTiBaseBar", "Scanned TiBase Bar"],
  [17, "implant-planner.scanAbutmentBar", "Scan Abutment Bar"],
  [20, "implant-planner.inlayOnlayVeneerRichmond", "Inlay/Onlay/Veneer/Richmond"],
  [24, "implant-planner.modelSetup", "Model Setup"],
  [28, "implant-planner.eggShellPreOp", "Egg Shell Pre-Op"],
  [31, "implant-planner.thimblePreOp", "Thimble Pre-Op"],
  [29, "implant-planner.guide", "Guide"],
  [30, "implant-planner.meshLabelEdit", "Mesh Label Edit"],
  [34, "implant-planner.libraryCrownBridge", "Library Crown & Bridge"],
  [36, "implant-planner.occlusion", "Occlusion"],
  [37, "implant-planner.biteSplint", "Bite Splint"],
  [38, "implant-planner.waxupCrownBridge", "Waxup Crown & Bridge"],
  [39, "implant-planner.modelPRO", "ModelPRO"],
  [42, "implant-planner.teethLibrary", "Teeth Library"],
  [43, "implant-planner.bellatekAbutment", "Bellatek Abutment"],
  [46, "implant-planner.tmjDiagnosis", "TMJ Diagnosis"],
  [48, "implant-planner.teethSetup", "Teeth Setup"],
  [51, "implant-planner.overdentureOnScannedStructure", "Overdenture On Scanned Structure"],
  [54, "implant-planner.innovaImplantCheckFromDenture", "INNOVA Implant Check From Denture"],
  [55, "implant-planner.innovaImplantCheckFromBridge", "INNOVA Implant Check From Bridge"],
  [56, "implant-planner.innovaImplantCheckCompare", "INNOVA Implant Check Compare"],
  [57, "implant-planner.innovaImplantCheckDirect", "INNOVA Implant Check Direct"],
  [58, "implant-planner.tryInRxGuide", "Try-in/Rx GUIDE"]
], Yn = new Map(WL.map(([e, t, n]) => [e, GL(t, n)]));
var Qe = /* @__PURE__ */ ((e) => (e[e.eDI_MODEL_ANTAGONIST = 0] = "eDI_MODEL_ANTAGONIST", e[e.eDI_GINGIVA_ANTAGONIST = 1] = "eDI_GINGIVA_ANTAGONIST", e[e.eDI_WAXUP_ANTAGONIST = 2] = "eDI_WAXUP_ANTAGONIST", e[e.eDI_MARKER_ANTAGONIST = 3] = "eDI_MARKER_ANTAGONIST", e[e.eDI_DENTURE_ANTAGONIST = 4] = "eDI_DENTURE_ANTAGONIST", e[e.eDI_FACE_SCAN = 5] = "eDI_FACE_SCAN", e[e.eDI_MODEL = 6] = "eDI_MODEL", e[e.eDI_GINGIVA = 7] = "eDI_GINGIVA", e[e.eDI_WAXUP = 8] = "eDI_WAXUP", e[e.eDI_MARKER = 9] = "eDI_MARKER", e[e.eDI_DENTURE = 10] = "eDI_DENTURE", e[e.eDI_MOVEMENT_MARKER = 11] = "eDI_MOVEMENT_MARKER", e[e.eDI_UPPER_GENERIC = 12] = "eDI_UPPER_GENERIC", e[e.eDI_LOWER_GENERIC = 13] = "eDI_LOWER_GENERIC", e))(Qe || {});
const zL = "medic-web-engine", HL = [
  [0, "upperJaw", "Upper Jaw"],
  [1, "upperGingiva", "Upper Gingiva"],
  [2, "upperWaxup", "Upper Waxup"],
  [3, "upperMarker", "Upper Marker"],
  [4, "upperDenture", "Upper Denture"],
  [5, "faceScan", "Face Scan"],
  [6, "lowerJaw", "Lower Jaw"],
  [7, "lowerGingiva", "Lower Gingiva"],
  [8, "lowerWaxup", "Lower Waxup"],
  [9, "lowerMarker", "Lower Marker"],
  [10, "lowerDenture", "Lower Denture"],
  [11, "movementMarker", "Movement Marker"],
  [12, "upperGeneric", "Upper Generic"],
  [13, "lowerGeneric", "Lower Generic"]
], YL = (e, t) => {
  const n = `${zL}.${e}`, a = nt(n);
  return a === n ? t : a;
}, Pl = Te(() => HL.reduce(
  (e, [t, n, a]) => (e[t] = YL(n, a), e),
  {}
)), KL = {
  0: It.eOT_UPPER_JAW,
  1: It.eOT_UPPER_GINGIVA,
  2: It.eOT_UPPER_WAXUP,
  3: It.eOT_UPPER_MARKER,
  4: It.eOT_UPPER_DENTURE_MODEL,
  5: It.eOT_FACE_SCAN,
  6: It.eOT_LOWER_JAW,
  7: It.eOT_LOWER_GINGIVA,
  8: It.eOT_LOWER_WAXUP,
  9: It.eOT_LOWER_MARKER,
  10: It.eOT_LOWER_DENTURE_MODEL,
  11: It.eOT_MOVEMENT_SCAN_MARKER,
  12: It.eOT_GENERIC,
  13: It.eOT_GENERIC
}, op = {
  0: ut.eANTAGONIST,
  1: ut.eGINGIVA_ANTAGONIST,
  2: ut.eWAXUP_ANTAGONIST,
  3: ut.eMARKER_ANTAGONIST,
  4: ut.eDENTURE_ANTAGONIST,
  5: ut.eFACE_SCAN,
  6: ut.eMODEL,
  7: ut.eGINGIVA,
  8: ut.eWAXUP,
  9: ut.eMARKER,
  10: ut.eDENTURE,
  11: ut.eMOVEMENT_MARKER,
  12: ut.eGENERIC_UPPER,
  13: ut.eGENERIC_LOWER
};
var Ga = /* @__PURE__ */ ((e) => (e[e.eP_LEFT = 0] = "eP_LEFT", e[e.eP_FRONT = 1] = "eP_FRONT", e[e.eP_RIGHT = 2] = "eP_RIGHT", e[e.eP_TOP = 3] = "eP_TOP", e))(Ga || {});
const eo = {
  0: { label: "implant-planner.leftProfile", iconSrc: "Head_Left_128" },
  1: { label: "implant-planner.front", iconSrc: "Head_Front_128" },
  2: { label: "implant-planner.rightProfile", iconSrc: "Head_Right_128" },
  3: { label: "implant-planner.top", iconSrc: "Head_Top_128" }
};
function Mf(e) {
  const t = [], n = FL(), a = Af(), o = $L() == 1, l = kL() == 1, s = BL() & Df.CAD;
  console.log("licences CAD", s);
  for (let i of Rf.value)
    if (e == pa.eDESIGN)
      switch (i[0]) {
        case ve.eRD_GUIDE:
        case ve.eRD_ANALOGS_MODEL:
          t.push(Ho(i[1], i[0], !1));
        default:
          continue;
      }
    else if (e == pa.eSEGMENTATION)
      switch (i[0]) {
        case ve.eRD_BONE_FROM_CT:
          t.push(Ho(i[1], i[0], !0));
          continue;
        case ve.eRD_TEETH_FROM_CT:
          t.push(Ho(i[1], i[0], !0));
          continue;
        case ve.eRD_CROWNS_FROM_STL:
          t.push(Ho(i[1], i[0], !0));
          continue;
        case ve.eRD_ADVANCED_FEATURES:
          t.push(Ho(i[1], i[0], !1));
          continue;
        default:
          continue;
      }
    else {
      switch (i[0]) {
        case ve.eRD_GUIDE:
        case ve.eRD_ANALOGS_MODEL:
        case ve.eRD_BONE_GRAFT:
        case ve.eRD_BONE_GRID:
        case ve.eRD_BONE_FROM_CT:
        case ve.eRD_TEETH_FROM_CT:
        case ve.eRD_CROWNS_FROM_STL:
        case ve.eRD_ADVANCED_FEATURES:
          continue;
      }
      if (n == 0 && ve.eRD_MODEL_PRO == i[0] || n == 2 && ve.eRD_MODEL_PRO != i[0]) continue;
      if (ve.eRD_TMJ_DIAGNOSIS == i[0]) {
        if (!l && !o) continue;
      } else if (o && !s) continue;
      if (!l && !o && ve.eRD_TMJ_DIAGNOSIS == i[0]) continue;
      const c = a && [
        ve.eRD_BAR,
        ve.eRD_DENTURE,
        ve.eRD_IL_PROVISIONAL,
        ve.eRD_MODEL_PRO,
        ve.eRD_ORTHODONTIC_MODEL_BUILDER,
        ve.eRD_BITE_SPLINT,
        ve.eRD_DIGITAL_SMILE_DESIGN,
        ve.eRD_TMJ_DIAGNOSIS
      ].includes(i[0]);
      t.push(Ho(i[1], i[0], c));
    }
  return t;
}
function ZL(e) {
  const t = [], n = Af();
  switch (e) {
    case ve.eRD_CROWN_BRIDGE:
      t.push(Sn("From Library", ve.eRD_CROWN_BRIDGE, We.eWF_C_B_HYBRID, !1)), t.push(Sn("From Waxup", ve.eRD_CROWN_BRIDGE, We.eWF_C_B_HYBRID_WAXUP, !1)), t.push(
        Sn(
          Yn.get(
            20
            /* eRT_INLAY_ONLAY */
          ),
          ve.eRD_CROWN_BRIDGE,
          We.eWF_I_O_TEETH_LIBRARY,
          n
        )
      ), t.push(
        Sn(
          Yn.get(
            15
            /* eRT_DIGITAL_WAXUP */
          ),
          ve.eRD_CROWN_BRIDGE,
          We.eWF_C_B_DIGITAL_WAXUP,
          n
        )
      ), VL() && t.push(
        Sn(
          Yn.get(
            43
            /* eRT_BELLATEK_ABUTMENT */
          ),
          ve.eRD_CROWN_BRIDGE,
          We.eWF_C_B_BELLAK_ABUTMENT,
          n
        )
      );
      break;
    case ve.eRD_IL_PROVISIONAL:
      t.push(
        Sn(Yn.get(
          1
          /* eRT_IL_PROVISIONAL */
        ), ve.eRD_IL_PROVISIONAL, We.eWF_I_L_WAXUP, !1)
      ), t.push(
        Sn(Yn.get(
          12
          /* eRT_EGG_SHELL */
        ), ve.eRD_IL_PROVISIONAL, We.eWF_I_L_EGG_SHELL, !1)
      ), t.push(
        Sn(
          Yn.get(
            18
            /* eRT_EGG_SHELL_WAXUP */
          ),
          ve.eRD_IL_PROVISIONAL,
          We.eWF_I_L_EGG_SHELL_WAXUP,
          !1
        )
      );
      break;
    case ve.eRD_BAR:
      t.push(
        Sn(Yn.get(
          16
          /* eRT_BAR_CUSTOM_ABUTMENT */
        ), ve.eRD_BAR, We.eWF_BAR_MANUAL_IMPLANT, !1)
      ), t.push(
        Sn(Yn.get(
          17
          /* eRT_BAR_SCAN_ABUTMENT */
        ), ve.eRD_BAR, We.eWF_BAR_IMPLANT_LIBRARY, !1)
      ), t.push(
        Sn(
          Yn.get(
            26
            /* eRT_SCAN_ABUTMENT_LOCATOR_WAXUP */
          ),
          ve.eRD_BAR,
          We.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP,
          !1
        )
      ), t.push(
        Sn(
          Yn.get(
            27
            /* eRT_SCAN_ABUTMENT_IMPLANT_WAXUP */
          ),
          ve.eRD_BAR,
          We.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP,
          !1
        )
      ), t.push(
        Sn(Yn.get(
          51
          /* eRT_SCANNED_STRUCTURE */
        ), ve.eRD_BAR, We.eWF_SCANNED_STRUCTURE, !1)
      );
      break;
    case ve.eRD_PRE_OP:
      t.push(
        Sn(Yn.get(
          28
          /* eRT_EGG_SHELL_PRE_OP */
        ), ve.eRD_PRE_OP, We.eWF_EGG_SHELL_PRE_OP, !1)
      ), t.push(
        Sn(Yn.get(
          31
          /* eRT_THIMBLE_PRE_OP */
        ), ve.eRD_PRE_OP, We.eWF_THIMBLE_PRE_OP, n)
      );
      break;
    case ve.eRD_DENTURE:
      t.push(Sn("From Library", ve.eRD_DENTURE, We.eWF_DENTURE_FROM_TEETH_LIBRARY, !1)), t.push(Sn("From Copy", ve.eRD_DENTURE, We.eWF_DENTURE_FROM_COPY, !1));
      break;
  }
  return t;
}
const Ho = (e, t, n) => {
  let a = "/cad/addreconstructionpanel/";
  const { retValue: o, comment: l } = Pf(t);
  return a += o + "/" + o + ".png", {
    name: e,
    comment: l,
    imageSrc: a,
    reconstructionDesign: t,
    disabled: n
  };
}, Sn = (e, t, n, a) => {
  let o = "/cad/addreconstructionpanel/";
  const { retValue: l } = Pf(t), { retValue: s, comment: i } = JL(n);
  return o += l + "/" + s + ".png", {
    name: e || "",
    comment: i,
    imageSrc: o,
    reconstructionDesign: t,
    workflow: n,
    disabled: a
  };
}, Pf = (e) => {
  let t = "", n = "";
  switch (e) {
    case ve.eRD_CROWN_BRIDGE:
      t = "CrownBridge", n = nt("medic-web-engine.reconCommentCrownBridge");
      break;
    case ve.eRD_BAR:
      t = "Overdenture", n = nt("medic-web-engine.reconCommentOverdenture");
      break;
    case ve.eRD_PRE_OP:
      t = "PreOp", n = nt("medic-web-engine.reconCommentPreOp");
      break;
    case ve.eRD_DENTURE:
      t = "Denture", n = nt("medic-web-engine.reconCommentDenture");
      break;
    case ve.eRD_IL_PROVISIONAL:
      t = "ImmediateLoadProvisional", n = nt("medic-web-engine.reconCommentImmediateLoadProvisional");
      break;
    case ve.eRD_MODEL_BUILDER:
      t = "ModelSetup", n = nt("medic-web-engine.reconCommentModelSetup");
      break;
    case ve.eRD_MODEL_PRO:
      t = "ModelPRO", n = nt("medic-web-engine.reconCommentModelPRO");
      break;
    case ve.eRD_ORTHODONTIC_MODEL_BUILDER:
      t = "OrthodonticModelSetup", n = nt("medic-web-engine.reconCommentOrthodonticModelSetup");
      break;
    case ve.eRD_BITE_SPLINT:
      t = "BiteSplint", n = nt("medic-web-engine.reconCommentBiteSplint");
      break;
    case ve.eRD_DIGITAL_SMILE_DESIGN:
      t = "DDSMockUp", n = nt("medic-web-engine.reconCommentDDSMockUp");
      break;
    case ve.eRD_TMJ_DIAGNOSIS:
      t = "TMJDiagnosis", n = nt("medic-web-engine.reconCommentTMJDiagnosis");
      break;
    case ve.eRD_INNOVA_IMPLANT_CHECK:
      t = "Innova", n = nt("medic-web-engine.reconCommentInnova");
      break;
    case ve.eRD_GUIDE:
      t = "Guide", n = nt("medic-web-engine.requirementsGuideHtml");
      break;
    case ve.eRD_ANALOGS_MODEL:
      t = "AnalogsModel", n = nt("medic-web-engine.requirementsAnalogsModel");
      break;
    case ve.eRD_BONE_GRAFT:
      t = "BoneGraft", n = nt("medic-web-engine.requirementsBoneGraft");
      break;
    case ve.eRD_BONE_GRID:
      t = "BoneGrid", n = nt("medic-web-engine.requirementsBoneGrid");
      break;
    case ve.eRD_BONE_FROM_CT:
      t = "BoneFromCT", n = "";
      break;
    case ve.eRD_TEETH_FROM_CT:
      t = "TeethFromCT", n = "";
      break;
    case ve.eRD_CROWNS_FROM_STL:
      t = "CrownsFromSTL", n = "";
      break;
    case ve.eRD_ADVANCED_FEATURES:
      t = "AdvancedFeatures", n = "";
      break;
  }
  return { retValue: t, comment: n };
}, JL = (e) => {
  let t = "", n = "";
  switch (e) {
    /* Missing or no sub-type
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_TEETH_LIBRARY:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_WAXUP:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_MANUAL_IMPLANT:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_MANUAL_IMPLANT_WAXUP:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_IMPLANT_LIBRARY:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_IMPLANT_LIBRARY_WAXUP:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_MOCKUP:
        retValue = "";
        break;
        */
    case We.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP:
      t = "LocatorOverdenture", n = nt("medic-web-engine.reconWorkflowLocatorOverdenture");
      break;
    case We.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP:
      t = "ImplantOverdenture", n = nt("medic-web-engine.reconWorkflowImplantOverdenture");
      break;
    case We.eWF_SCANNED_STRUCTURE:
      t = "ScannedStructure", n = nt("medic-web-engine.reconWorkflowScannedStructure");
      break;
    case We.eWF_C_B_DIGITAL_WAXUP:
      t = "MockupSnapon", n = nt("medic-web-engine.reconWorkflowMockupSnapon");
      break;
    case We.eWF_C_B_HYBRID:
      t = "FromLibrary", n = nt("medic-web-engine.reconWorkflowFromLibrary");
      break;
    case We.eWF_C_B_HYBRID_WAXUP:
      t = "FromWaxup", n = nt("medic-web-engine.reconWorkflowFromWaxup");
      break;
    case We.eWF_I_L_EGG_SHELL:
      t = "HealingAbutmentEggShell", n = nt("medic-web-engine.reconWorkflowHealingAbutmentEggShell");
      break;
    case We.eWF_I_L_EGG_SHELL_WAXUP:
      t = "HealingAbutmentEggShellWaxup", n = nt("medic-web-engine.reconWorkflowHealingAbutmentEggShellWaxup");
      break;
    case We.eWF_I_L_WAXUP:
      t = "ParametricProvisionalWaxup", n = nt("medic-web-engine.reconWorkflowParametricProvisionalWaxup");
      break;
    case We.eWF_BAR_MANUAL_IMPLANT:
      t = "ScannedTiBaseBar", n = nt("medic-web-engine.reconWorkflowScannedTiBaseBar");
      break;
    case We.eWF_BAR_IMPLANT_LIBRARY:
      t = "ScanAbutmentBar", n = nt("medic-web-engine.reconWorkflowScanAbutmentBar");
      break;
    case We.eWF_I_O_TEETH_LIBRARY:
      t = "InlayOnlay", n = nt("medic-web-engine.reconWorkflowInlayOnlay");
      break;
    case We.eWF_EGG_SHELL_PRE_OP:
      t = "EggShellPreOp", n = nt("medic-web-engine.reconWorkflowEggShellPreOp");
      break;
    case We.eWF_THIMBLE_PRE_OP:
      t = "ThimblePreOp", n = nt("medic-web-engine.reconWorkflowThimblePreOp");
      break;
    case We.eWF_C_B_BELLAK_ABUTMENT:
      t = "BellatekAbutment", n = nt("medic-web-engine.reconWorkflowBellatekAbutment");
      break;
    case We.eWF_DENTURE_FROM_TEETH_LIBRARY:
      t = "Denture", n = nt("medic-web-engine.reconWorkflowDentureFromTeethLibrary");
      break;
    case We.eWF_DENTURE_FROM_COPY:
      t = "Denture", n = nt("medic-web-engine.reconWorkflowDentureFromCopy");
      break;
  }
  return { retValue: t, comment: n };
};
function eu(e) {
  const t = [];
  for (let n = 0; n < e.size(); n++) {
    const a = e.get(n);
    t.push({ id: a.id, name: a.name });
  }
  return t;
}
function XL(e, t) {
  return e.find((n) => n.id === t) ?? null;
}
function qL(e, t) {
  const n = /* @__PURE__ */ new Set();
  for (let a = 0; a < t.size(); a++)
    n.add(t.get(a));
  return e.filter((a) => a.id != null && n.has(a.id));
}
function QL(e, t) {
  const n = zn(e.getContextCAD().GetXAddReconstructionObject()), a = (l, s) => {
    const i = eu(n.GetObjectOptions(s));
    t[l].items = i, t[l].selectedItem = XL(i, n.GetSelectedObjectId(s));
  }, o = (l, s) => {
    const i = eu(n.GetObjectOptions(s));
    t[l].items = i, t[l].selectedItem = qL(i, n.GetGenericSelectedObjectIds(s));
  };
  a(0, ut.eANTAGONIST), a(1, ut.eGINGIVA_ANTAGONIST), a(2, ut.eWAXUP_ANTAGONIST), a(3, ut.eMARKER_ANTAGONIST), a(4, ut.eDENTURE_ANTAGONIST), a(5, ut.eFACE_SCAN), a(6, ut.eMODEL), a(7, ut.eGINGIVA), a(8, ut.eWAXUP), a(9, ut.eMARKER), a(10, ut.eDENTURE), a(11, ut.eMOVEMENT_MARKER), o(12, ut.eGENERIC_UPPER), o(13, ut.eGENERIC_LOWER);
}
async function xf(e, t, n, a, o = pa.eNONE, l = Rh.eNONE, s) {
  const i = t;
  let c = !0;
  function u(N) {
    return N === Jt.MANDIBLE ? ys(e.settings.general.useUSStyleToothChart) : _s(e.settings.general.useUSStyleToothChart);
  }
  const p = u(Jt.MAXILLA).map((N, x) => ({
    id: x + 1,
    editMode: Ta.NO_EDIT,
    status: pt.EMPTY,
    hoverIcon: Fn.ADD,
    toothName: N
  })), b = u(Jt.MANDIBLE).map((N, x) => ({
    id: x + 1,
    editMode: Ta.NO_EDIT,
    status: pt.EMPTY,
    hoverIcon: Fn.ADD,
    toothName: N
  })), f = (N) => {
    console.log("fillTeethOption", N, N.size());
    for (let x = 0; x < N.size(); x++) {
      const z = N.get(x);
      console.log("tooth name:", z);
      const X = p.find((M) => M.toothName == z);
      X && (X.status = pt.OK, X.hoverIcon = Fn.REMOVE);
      const H = b.find((M) => M.toothName == z);
      H && (H.status = pt.OK, H.hoverIcon = Fn.REMOVE);
    }
  };
  let h = Rf.value.get(t) + " " + a, I = nt("implant-planner.selectOperativeTeethInstructions"), m = h;
  o == pa.eCREATE_WAXUP && (h = nt("implant-planner.createWaxup"), I = nt("implant-planner.addWaxupInstructions"), m = "Waxup"), m = e.module.xAddReconstructionWasm.GetValidReconstructionName(m);
  const S = zn(e.getContextCAD().GetXAddReconstructionObject());
  console.log("xAddRecon", S), S.PrepareDialog(o, l);
  const E = e.getContextCAD().mPrevReconstructionType;
  i == ve.eRD_MODEL_BUILDER ? (S.FillReconstruction(), S.FillAntagonistReconstruction()) : ([ve.eRD_ORTHODONTIC_MODEL_BUILDER, ve.eRD_BITE_SPLINT, ve.eRD_MODEL_PRO].includes(i) || E && [
    ve.eRD_MODEL_BUILDER,
    ve.eRD_ORTHODONTIC_MODEL_BUILDER,
    ve.eRD_BITE_SPLINT,
    ve.eRD_MODEL_PRO
  ].includes(E)) && (S.FillModel(null), S.FillAntagonist(null));
  const g = {
    0: {
      visible: !0,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    1: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    2: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    3: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    4: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    5: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    6: { visible: !0, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    7: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    8: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    9: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    10: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    11: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    12: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    13: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    }
  };
  g[
    2
    /* eDI_WAXUP_ANTAGONIST */
  ].visible = !1, g[
    1
    /* eDI_GINGIVA_ANTAGONIST */
  ].visible = !1, g[
    3
    /* eDI_MARKER_ANTAGONIST */
  ].visible = !1, g[
    10
    /* eDI_DENTURE */
  ].visible = !1, g[
    4
    /* eDI_DENTURE_ANTAGONIST */
  ].visible = !1, g[
    13
    /* eDI_LOWER_GENERIC */
  ].visible = i == ve.eRD_TMJ_DIAGNOSIS, g[
    12
    /* eDI_UPPER_GENERIC */
  ].visible = i == ve.eRD_TMJ_DIAGNOSIS, g[
    6
    /* eDI_MODEL */
  ].showImportBtn = i != ve.eRD_MODEL_BUILDER, g[
    0
    /* eDI_MODEL_ANTAGONIST */
  ].showImportBtn = i != ve.eRD_MODEL_BUILDER;
  let v = !1;
  switch (i) {
    case ve.eRD_CROWN_BRIDGE:
    case ve.eRD_BAR:
    case ve.eRD_PRE_OP:
      v = !0, g[
        8
        /* eDI_WAXUP */
      ].visible = !0, g[
        9
        /* eDI_MARKER */
      ].visible = !0, g[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = !0, g[
        5
        /* eDI_FACE_SCAN */
      ].visible = !0, g[
        7
        /* eDI_GINGIVA */
      ].visible = !0;
      break;
    case ve.eRD_IL_PROVISIONAL: {
      g[
        9
        /* eDI_MARKER */
      ].visible = !1, g[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = !1, g[
        5
        /* eDI_FACE_SCAN */
      ].visible = !1, v = !0, S.FillTeeth(), f(S.GetTeethList());
      break;
    }
    case ve.eRD_DENTURE:
    case ve.eRD_MODEL_BUILDER:
    case ve.eRD_ORTHODONTIC_MODEL_BUILDER:
    case ve.eRD_BITE_SPLINT:
    case ve.eRD_DIGITAL_SMILE_DESIGN:
    case ve.eRD_TMJ_DIAGNOSIS: {
      g[
        8
        /* eDI_WAXUP */
      ].visible = [ve.eRD_TMJ_DIAGNOSIS].includes(i), g[
        2
        /* eDI_WAXUP_ANTAGONIST */
      ].visible = [ve.eRD_TMJ_DIAGNOSIS].includes(i), g[
        9
        /* eDI_MARKER */
      ].visible = [ve.eRD_TMJ_DIAGNOSIS].includes(i), g[
        3
        /* eDI_MARKER_ANTAGONIST */
      ].visible = [ve.eRD_TMJ_DIAGNOSIS].includes(i), g[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = [
        ve.eRD_DIGITAL_SMILE_DESIGN,
        ve.eRD_BITE_SPLINT,
        ve.eRD_TMJ_DIAGNOSIS,
        ve.eRD_DENTURE
      ].includes(i), g[
        5
        /* eDI_FACE_SCAN */
      ].visible = [
        ve.eRD_DIGITAL_SMILE_DESIGN,
        ve.eRD_TMJ_DIAGNOSIS,
        ve.eRD_DENTURE
      ].includes(i), g[
        7
        /* eDI_GINGIVA */
      ].visible = [ve.eRD_TMJ_DIAGNOSIS].includes(i), g[
        1
        /* eDI_GINGIVA_ANTAGONIST */
      ].visible = [ve.eRD_TMJ_DIAGNOSIS].includes(i), v = [
        ve.eRD_DENTURE,
        ve.eRD_BITE_SPLINT,
        ve.eRD_DIGITAL_SMILE_DESIGN,
        ve.eRD_TMJ_DIAGNOSIS
      ].includes(i), c = [
        ve.eRD_DENTURE,
        ve.eRD_BITE_SPLINT,
        ve.eRD_DIGITAL_SMILE_DESIGN,
        ve.eRD_TMJ_DIAGNOSIS
      ].includes(i);
      break;
    }
    case ve.eRD_MODEL_PRO: {
      g[
        8
        /* eDI_WAXUP */
      ].visible = !1, g[
        9
        /* eDI_MARKER */
      ].visible = !0, g[
        3
        /* eDI_MARKER_ANTAGONIST */
      ].visible = !0, g[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = !1, g[
        5
        /* eDI_FACE_SCAN */
      ].visible = !1, g[
        7
        /* eDI_GINGIVA */
      ].visible = !1, v = !0;
      break;
    }
  }
  if (n != We.eWF_NONE)
    switch (g[
      2
      /* eDI_WAXUP_ANTAGONIST */
    ].visible = !1, g[
      1
      /* eDI_GINGIVA_ANTAGONIST */
    ].visible = !1, g[
      3
      /* eDI_MARKER_ANTAGONIST */
    ].visible = !1, g[
      10
      /* eDI_DENTURE */
    ].visible = !1, g[
      4
      /* eDI_DENTURE_ANTAGONIST */
    ].visible = !1, n) {
      case We.eWF_I_L_EGG_SHELL:
      case We.eWF_C_B_TEETH_LIBRARY:
      case We.eWF_C_B_MANUAL_IMPLANT:
      case We.eWF_C_B_MOCKUP:
      case We.eWF_C_B_DIGITAL_WAXUP:
      case We.eWF_EGG_SHELL_PRE_OP:
      case We.eWF_THIMBLE_PRE_OP: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !1, g[
          9
          /* eDI_MARKER */
        ].visible = !1, g[
          7
          /* eDI_GINGIVA */
        ].visible = n != We.eWF_C_B_DIGITAL_WAXUP, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = n == We.eWF_EGG_SHELL_PRE_OP || n == We.eWF_THIMBLE_PRE_OP || n == We.eWF_I_L_EGG_SHELL;
        break;
      }
      case We.eWF_BAR_MANUAL_IMPLANT: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !0, g[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, g[
          9
          /* eDI_MARKER */
        ].visible = !1, g[
          7
          /* eDI_GINGIVA */
        ].visible = !1, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case We.eWF_BAR_IMPLANT_LIBRARY: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !0, g[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, g[
          9
          /* eDI_MARKER */
        ].visible = !0, g[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, g[
          7
          /* eDI_GINGIVA */
        ].visible = !0, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case We.eWF_I_O_TEETH_LIBRARY: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !1, g[
          9
          /* eDI_MARKER */
        ].visible = !1, g[
          7
          /* eDI_GINGIVA */
        ].visible = !0, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case We.eWF_C_B_HYBRID: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !1, g[
          9
          /* eDI_MARKER */
        ].visible = !0, g[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, g[
          7
          /* eDI_GINGIVA */
        ].visible = !0, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case We.eWF_C_B_BELLAK_ABUTMENT: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !1, g[
          9
          /* eDI_MARKER */
        ].visible = !0, g[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, g[
          7
          /* eDI_GINGIVA */
        ].visible = !0, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case We.eWF_C_B_HYBRID_WAXUP: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !0, g[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, g[
          9
          /* eDI_MARKER */
        ].visible = !0, g[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, g[
          7
          /* eDI_GINGIVA */
        ].visible = !0, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case We.eWF_C_B_IMPLANT_LIBRARY: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !1, g[
          9
          /* eDI_MARKER */
        ].visible = !0;
        break;
      }
      case We.eWF_C_B_IMPLANT_LIBRARY_WAXUP:
      case We.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP:
      case We.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP:
      case We.eWF_SCANNED_STRUCTURE: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !0, g[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, g[
          9
          /* eDI_MARKER */
        ].visible = n != We.eWF_SCANNED_STRUCTURE, g[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = n != We.eWF_SCANNED_STRUCTURE, g[
          7
          /* eDI_GINGIVA */
        ].visible = !0, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case We.eWF_I_L_WAXUP:
        S.FillTeeth(), f(S.GetTeethList());
      case We.eWF_I_L_EGG_SHELL_WAXUP:
        g[
          7
          /* eDI_GINGIVA */
        ].visible = n != We.eWF_I_L_WAXUP, g[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = n != We.eWF_I_L_WAXUP, g[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, c = n != We.eWF_I_L_WAXUP;
      case We.eWF_C_B_WAXUP:
      case We.eWF_C_B_MANUAL_IMPLANT_WAXUP: {
        g[
          8
          /* eDI_WAXUP */
        ].visible = !0, g[
          9
          /* eDI_MARKER */
        ].visible = !1;
        break;
      }
      case We.eWF_DENTURE_FROM_COPY: {
        g[
          10
          /* eDI_DENTURE */
        ].visible = !0, g[
          4
          /* eDI_DENTURE_ANTAGONIST */
        ].visible = !0;
        break;
      }
    }
  e.getContextCAD().mPrevReconstructionType = i, S.UpdateVisibility(), QL(e, g);
  const T = await Ap(s);
  let R = "", L = "", C = "", A = "";
  return T.length && (R = T[0].label, L = T[0].modelName, C = T[0].guid, A = T[0].pool), {
    setupParams: {
      headerText: h,
      instructionsText: I,
      reconstructionName: m,
      selectTeethLibrary: !0,
      selectedTeethLibrary: R,
      selectedTeethLibraryModelName: L,
      selectedTeethLibraryGUID: C,
      selectedTeethLibraryPool: A,
      dropdownItems: g,
      teethMapEnabled: c,
      maxillaTeeth: p,
      mandibleTeeth: b
    },
    smileParams: i == ve.eRD_DIGITAL_SMILE_DESIGN,
    productionParams: v && o != pa.eCREATE_WAXUP && o != pa.eTMJ_DIAGNOSIS
  };
}
async function eO(e) {
  let t = {
    0: { label: Bl(eo[
      0
      /* eP_LEFT */
    ].label, "Left"), iconSrc: eo[
      0
      /* eP_LEFT */
    ].iconSrc, items: [] },
    1: { label: Bl(eo[
      1
      /* eP_FRONT */
    ].label, "Front"), iconSrc: eo[
      1
      /* eP_FRONT */
    ].iconSrc, items: [] },
    2: { label: Bl(eo[
      2
      /* eP_RIGHT */
    ].label, "Right"), iconSrc: eo[
      2
      /* eP_RIGHT */
    ].iconSrc, items: [] },
    3: { label: Bl(eo[
      3
      /* eP_TOP */
    ].label, "Top"), iconSrc: eo[
      3
      /* eP_TOP */
    ].iconSrc, items: [] }
  };
  for (const [a, o] of e.getObjects().images2D) {
    const l = e.viewConfiguration.colorScheme.get(), s = await Zi(o, !0, l);
    switch (o.cadType) {
      case It.eOT_TEXTURED_LEFT_IMAGE:
        t[
          0
          /* eP_LEFT */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
      case It.eOT_TEXTURED_FRONT_IMAGE:
        t[
          1
          /* eP_FRONT */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
      case It.eOT_TEXTURED_RIGHT_IMAGE:
        t[
          2
          /* eP_RIGHT */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
      case It.eOT_TEXTURED_TOP_IMAGE:
        t[
          3
          /* eP_TOP */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
    }
  }
  const n = zn(e.getContextCAD().GetXAddReconstructionObject());
  for (let a of [
    It.eOT_TEXTURED_LEFT_IMAGE,
    It.eOT_TEXTURED_RIGHT_IMAGE,
    It.eOT_TEXTURED_TOP_IMAGE,
    It.eOT_TEXTURED_FRONT_IMAGE
  ]) {
    const o = n.GetImages(a);
    let l = 1;
    switch (a) {
      case It.eOT_TEXTURED_LEFT_IMAGE:
        l = 0;
        break;
      case It.eOT_TEXTURED_RIGHT_IMAGE:
        l = 2;
        break;
      case It.eOT_TEXTURED_TOP_IMAGE:
        l = 3;
        break;
      case It.eOT_TEXTURED_FRONT_IMAGE:
        l = 1;
        break;
      default:
        continue;
    }
    for (let s = 0; s < o.size(); s++) {
      const i = o.get(s);
      t[l].items.push({ id: i.id, preview: "data:image/png;base64," + i.preview, selected: !0 });
    }
  }
  return t;
}
async function jf(e) {
  return await eO(e);
}
function Ff(e, t, n) {
  const a = [], o = (l) => {
    const s = (i) => l.includes(i);
    switch (e) {
      case ve.eRD_CROWN_BRIDGE:
      case ve.eRD_BAR:
      case ve.eRD_PRE_OP:
      case ve.eRD_IL_PROVISIONAL:
        switch (t) {
          case We.eWF_C_B_HYBRID:
            return s(20);
          case We.eWF_C_B_HYBRID_WAXUP:
            return s(21);
          case We.eWF_I_O_TEETH_LIBRARY:
            return s(22);
          case We.eWF_C_B_DIGITAL_WAXUP:
            return s(23);
          case We.eWF_C_B_BELLAK_ABUTMENT:
            return s(24);
          case We.eWF_BAR_MANUAL_IMPLANT:
            return s(25);
          case We.eWF_BAR_IMPLANT_LIBRARY:
            return s(26);
          case We.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP:
            return s(27);
          case We.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP:
            return s(28);
          case We.eWF_EGG_SHELL_PRE_OP:
            return s(29);
          case We.eWF_THIMBLE_PRE_OP:
            return s(30);
          case We.eWF_I_L_WAXUP:
            return s(31);
          case We.eWF_I_L_EGG_SHELL:
            return s(32);
          case We.eWF_I_L_EGG_SHELL_WAXUP:
            return s(33);
          case We.eWF_SCANNED_STRUCTURE:
            return s(34);
          default:
            return !1;
        }
      case ve.eRD_DIGITAL_SMILE_DESIGN:
      case ve.eRD_DENTURE:
      case ve.eRD_TMJ_DIAGNOSIS:
      case ve.eRD_MODEL_BUILDER:
      case ve.eRD_ORTHODONTIC_MODEL_BUILDER:
      case ve.eRD_BITE_SPLINT:
      case ve.eRD_MODEL_PRO:
        return s(e);
      default:
        return !1;
    }
  };
  for (const l of n)
    for (const s of l.materials)
      o(s.reconstructionDesigns) && a.push({
        name: s.name,
        productionCenterId: l.id,
        materialId: s.id || -1
      });
  return a;
}
function tO(e, t, n) {
  const a = [], o = n.find((l) => l.id == e);
  if (o) {
    const l = o.materials.find((s) => s.id == t);
    if (l && l.colors)
      for (let s = 0; s < l.colors.length; s++)
        a.push({ name: l.colors[s] });
  }
  return a;
}
function nO(e, t, n) {
  return [];
}
const aO = {
  class: "p-dialog-header text-4xl",
  style: { "justify-content": "center !important" }
}, oO = { class: "flex flex-row-wrap grow gap-4 justify-center mt-4" }, lO = {
  class: "wrapper-element",
  style: { "z-index": "1000" }
}, iO = { class: "ml-2 font-bold text-xl" }, sO = ["onMouseover", "onClick"], rO = { class: "flex flex-row-wrap grow justify-center mt-4" }, uO = /* @__PURE__ */ qe({
  __name: "ReconstructionTypeSelection",
  props: {
    context: {},
    preselectedType: {}
  },
  emits: ["typeSelected", "modifyType"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = Mf(), l = F(null), s = ia(), i = document.createElement("div");
    Mt(() => {
      n.context;
      const I = document.getElementById("commentContainer");
      if (I ? I.appendChild(i) : console.log("commentContainer does not exist"), n.preselectedType == pa.eCREATE_WAXUP) {
        const m = o.find((S) => S.reconstructionDesign == ve.eRD_DIGITAL_SMILE_DESIGN);
        m && h(m);
      }
    });
    const c = Te(() => n.preselectedType == pa.eCREATE_WAXUP ? "Create Waxup" : l.value != null ? l.value.name : "Select Reconstruction Type");
    Te(() => l.value != null ? "text-2xl" : "text-4xl");
    const u = Te(() => l.value == null ? "col-span-12" : "col-span-3"), p = (I) => {
      i.innerHTML = I;
    }, b = () => {
      l.value || (i.innerHTML = "");
    }, f = () => {
      l.value = null, a("modifyType");
    }, h = (I) => {
      l.value = I, p(I.comment), a("typeSelected", I.reconstructionDesign);
    };
    return (I, m) => {
      const S = Hu;
      return O(), he(r(Ee), {
        class: He([u.value, "flex-col"]),
        style: { overflow: "auto" }
      }, {
        default: w(() => [
          y("div", aO, V(c.value), 1),
          r(l) ? (O(), he(r(Ee), { key: 1 }, {
            default: w(() => [
              y("div", rO, [
                d(S, {
                  alt: r(l).name,
                  src: r(s).getAssetUrl(r(l).imageSrc),
                  "image-class": "large-image",
                  pt: {
                    image: {
                      style: {
                        background: "transparent !important",
                        maxHeight: "17rem",
                        borderRadius: "8px"
                      }
                    },
                    previewMask: {
                      style: {
                        borderRadius: "8px"
                      }
                    }
                  }
                }, null, 8, ["alt", "src"])
              ])
            ]),
            _: 1
          })) : (O(), he(r(Ee), {
            key: 0,
            class: "overflow-auto"
          }, {
            default: w(() => [
              y("div", oO, [
                (O(!0), J(ze, null, Rt(r(o), (E, g) => (O(), J("div", {
                  class: "item-element",
                  key: g
                }, [
                  y("div", lO, [
                    y("span", iO, V(E.name), 1)
                  ]),
                  d(S, {
                    alt: E.name,
                    src: r(s).getAssetUrl(E.imageSrc),
                    "image-class": "small-image",
                    style: { width: "100%", height: "auto" },
                    preview: "",
                    pt: {
                      image: {
                        style: {
                          background: "transparent !important",
                          maxHeight: "17rem",
                          borderRadius: "8px"
                        }
                      },
                      previewMask: {
                        style: {
                          borderRadius: "8px"
                        }
                      }
                    }
                  }, {
                    indicatoricon: w(() => [
                      y("div", {
                        class: "w-full h-full flex flex-col justify-start",
                        onMouseover: (v) => p(E.comment),
                        onMouseleave: b,
                        onClick: (v) => h(E)
                      }, null, 40, sO)
                    ]),
                    _: 2
                  }, 1032, ["alt", "src"])
                ]))), 128))
              ])
            ]),
            _: 1
          })),
          m[1] || (m[1] = y("div", {
            id: "commentContainer",
            class: "flex justify-center mt-2",
            style: { "min-height": "20vh", "white-space": "pre-wrap", top: "auto" }
          }, null, -1)),
          d(r(Ee), {
            class: "justify-center",
            style: { "margin-top": "auto" }
          }, {
            default: w(() => [
              r(l) ? (O(), he(r(Ce), {
                key: 0,
                disabled: e.preselectedType != null,
                class: "btn-wizard-lg",
                label: "Modify Reconstruction Type",
                onClick: m[0] || (m[0] = (E) => f())
              }, null, 8, ["disabled"])) : ue("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
}), $f = /* @__PURE__ */ $t(uO, [["__scopeId", "data-v-401810ef"]]), cO = {
  class: "p-dialog-header text-4xl",
  style: { "justify-content": "center !important" }
}, dO = { class: "flex flex-row-wrap grow gap-4 justify-center mt-4" }, pO = { class: "grow" }, mO = {
  class: "wrapper-element",
  style: { "z-index": "1000" }
}, fO = { class: "ml-2 font-bold text-sm" }, gO = ["onMouseover", "onClick"], hO = { class: "flex flex-row-wrap grow col-span-12 justify-center mt-4" }, bO = /* @__PURE__ */ qe({
  __name: "WorkflowSelection",
  props: {
    reconstructionType: {}
  },
  emits: ["workflowSelected", "modifyWorkflow"],
  setup(e, { emit: t }) {
    const n = e, a = F([]), o = F(null), l = document.createElement("div"), s = Te(() => o.value != null ? o.value.name : "Select Workflow");
    Te(() => (o.value != null, "text-2xl justify-center")), Mt(() => {
      const f = document.getElementById("commentContainerWorkflow");
      f ? f.appendChild(l) : console.log("commentContainer does not exist"), console.log("reconstructionType", n.reconstructionType), a.value = ZL(n.reconstructionType), a.value.length || i("workflowSelected", We.eWF_NONE, "");
    });
    const i = t, c = (f) => {
      l.innerHTML = f;
    }, u = () => {
      o.value || (l.innerHTML = "");
    }, p = () => {
      o.value = null, i("modifyWorkflow");
    }, b = (f) => {
      o.value = f, c(f.comment), i("workflowSelected", f.workflow, f.name);
    };
    return (f, h) => {
      const I = Hu;
      return Pt((O(), he(r(Ee), {
        class: "flex-col col-span-3",
        style: { overflow: "auto" }
      }, {
        default: w(() => [
          y("div", cO, V(s.value), 1),
          r(o) ? (O(), he(r(Ee), { key: 1 }, {
            default: w(() => [
              y("div", hO, [
                d(I, {
                  alt: r(o).name,
                  src: r(o).imageSrc,
                  "image-class": "large-image",
                  pt: {
                    image: {
                      style: {
                        background: "transparent !important",
                        maxHeight: "17rem",
                        borderRadius: "8px"
                      }
                    },
                    previewMask: {
                      style: {
                        borderRadius: "8px"
                      }
                    }
                  }
                }, null, 8, ["alt", "src"])
              ])
            ]),
            _: 1
          })) : (O(), he(r(Ee), {
            key: 0,
            class: "overflow-auto"
          }, {
            default: w(() => [
              y("div", dO, [
                (O(!0), J(ze, null, Rt(r(a), (m, S) => (O(), J("div", {
                  class: "item-element",
                  key: S
                }, [
                  y("div", pO, [
                    y("div", mO, [
                      y("span", fO, V(m.name), 1)
                    ]),
                    d(I, {
                      alt: m.name,
                      src: m.imageSrc,
                      preview: "",
                      "image-class": "small-image",
                      style: { width: "100%", height: "auto" },
                      pt: {
                        image: {
                          style: {
                            background: "transparent !important",
                            maxHeight: "17rem",
                            borderRadius: "8px"
                          }
                        },
                        previewMask: {
                          style: {
                            borderRadius: "8px"
                          }
                        }
                      }
                    }, {
                      indicatoricon: w(() => [
                        y("div", {
                          class: "w-full h-full flex flex-col justify-start",
                          onMouseover: (E) => c(m.comment),
                          onMouseleave: u,
                          onClick: (E) => b(m)
                        }, null, 40, gO)
                      ]),
                      _: 2
                    }, 1032, ["alt", "src"])
                  ])
                ]))), 128))
              ])
            ]),
            _: 1
          })),
          h[1] || (h[1] = y("div", {
            id: "commentContainerWorkflow",
            class: "flex justify-center mt-2",
            style: { "min-height": "20vh", "white-space": "pre-wrap", top: "auto" }
          }, null, -1)),
          d(r(Ee), {
            class: "justify-center",
            style: { "margin-top": "auto" }
          }, {
            default: w(() => [
              d(r(Ce), {
                class: "btn-wizard-lg",
                disabled: !r(o),
                label: "Modify Workflow",
                onClick: h[0] || (h[0] = (m) => p())
              }, null, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)), [
        [sn, r(a).length]
      ]);
    };
  }
}), kf = /* @__PURE__ */ $t(bO, [["__scopeId", "data-v-a87293d3"]]), vO = /* @__PURE__ */ qe({
  __name: "ReconstructionSetupDialog",
  emits: ["confirm", "reject"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data;
    let o, l;
    const s = Jn();
    Mt(async () => {
      o = a.context;
      const { data: v } = await s.getProductionCentersFullInfo();
      l = v;
    });
    const i = t, c = F(null), u = F(null), p = (v) => {
      console.log("Selected type", v), c.value = v;
    }, b = () => {
      c.value = null, u.value = null;
    }, f = F({
      headerText: "",
      instructionsText: "",
      reconstructionName: "",
      selectTeethLibrary: !0,
      selectedTeethLibrary: "",
      selectedTeethLibraryModelName: "",
      selectedTeethLibraryGUID: "",
      selectedTeethLibraryPool: "",
      dropdownItems: {
        [Qe.eDI_MODEL_ANTAGONIST]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_GINGIVA_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_WAXUP_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MARKER_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_DENTURE_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_FACE_SCAN]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MODEL]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_GINGIVA]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_WAXUP]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_DENTURE]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MOVEMENT_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_UPPER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_LOWER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] }
      },
      teethMapEnabled: !0,
      maxillaTeeth: [],
      mandibleTeeth: []
    }), h = F(null), I = F(null), m = async (v, T) => {
      if (console.log("Workflow Selected type", v), u.value = v, c.value != null && u.value != null) {
        const R = await xf(o, c.value, u.value, T, a.preselectedMode, a.preselectedWorkFlow, s);
        if (f.value = R.setupParams, R.smileParams && Am() ? h.value = await jf(o) : h.value = null, R.productionParams) {
          const L = Ff(c.value, u.value, l);
          console.log("LibItems", L), I.value = {
            materialLibrary: {
              selectedItem: null,
              items: L
            },
            color: {
              selectedItem: null,
              items: []
            },
            presetLibrary: {
              selectedItem: null,
              items: []
            }
          };
        } else
          I.value = null;
      }
    }, S = () => {
      u.value = null;
    };
    ot(f.value.dropdownItems[Qe.eDI_MODEL], () => {
      console.log("setupParams.value.dropdownItems[TDropdownItem.eDI_MODEL] changed", f.value.dropdownItems[Qe.eDI_MODEL]);
    });
    const E = async () => {
      console.log("ReconstructionDialog proceed 0");
      const v = zn(o.getContextCAD().GetXAddReconstructionObject());
      v.SetModeWorkflowName(c.value, u.value, f.value.reconstructionName);
      const T = (j) => j && !Array.isArray(j) ? j.id ?? -1 : -1, R = (j, N) => {
        const x = f.value.dropdownItems[j];
        v.SelectedSelectionChangedById(T(x.selectedItem), x.visible, N);
      }, L = (j, N) => {
        const x = f.value.dropdownItems[j], z = x.selectedItem ? Array.isArray(x.selectedItem) ? x.selectedItem : [x.selectedItem] : [], X = new o.module.VectorInt();
        for (const H of z)
          H.id != null && X.push_back(H.id);
        v.SelectedGenericSelectionChangedByIds(X, x.visible, N), X.delete();
      };
      R(Qe.eDI_MODEL_ANTAGONIST, ut.eANTAGONIST), R(Qe.eDI_GINGIVA_ANTAGONIST, ut.eGINGIVA_ANTAGONIST), R(Qe.eDI_WAXUP_ANTAGONIST, ut.eWAXUP_ANTAGONIST), R(Qe.eDI_MARKER_ANTAGONIST, ut.eMARKER_ANTAGONIST), R(Qe.eDI_DENTURE_ANTAGONIST, ut.eDENTURE_ANTAGONIST), R(Qe.eDI_FACE_SCAN, ut.eFACE_SCAN), R(Qe.eDI_MODEL, ut.eMODEL), R(Qe.eDI_GINGIVA, ut.eGINGIVA), R(Qe.eDI_WAXUP, ut.eWAXUP), R(Qe.eDI_MARKER, ut.eMARKER), R(Qe.eDI_DENTURE, ut.eDENTURE), R(Qe.eDI_MOVEMENT_MARKER, ut.eMOVEMENT_MARKER), L(Qe.eDI_UPPER_GENERIC, ut.eGENERIC_UPPER), L(Qe.eDI_LOWER_GENERIC, ut.eGENERIC_LOWER), console.log("ReconstructionDialog proceed 1");
      const C = new o.module.VectorString();
      for (const j of f.value.mandibleTeeth)
        j.status != ItemStatus.EMPTY && C.push_back(j.toothName);
      for (const j of f.value.maxillaTeeth)
        j.status != ItemStatus.EMPTY && C.push_back(j.toothName);
      v.SetTeethList(C), C.delete(), console.log("ReconstructionDialog proceed 2"), await uu(
        s,
        o,
        f.value.selectedTeethLibraryModelName,
        f.value.selectedTeethLibraryGUID,
        f.value.selectedTeethLibraryPool
      ), v.SetSelectedLibrary(f.value.selectedTeethLibraryModelName, f.value.selectedTeethLibraryGUID), console.log("ReconstructionDialog proceed 3");
      const A = v.ValidateAndAddReconstruction();
      console.log("ReconstructionDialog proceed 4", A), A && (console.log("ReconstructionDialog proceed 5"), o.getContextCAD().DeleteAddReconstructionObject(), console.log("ReconstructionDialog proceed 6", A), i("confirm"), n.value.close());
    }, g = () => {
      o.getContextCAD().DeleteAddReconstructionObject(), i("reject"), n.value.close();
    };
    return (v, T) => {
      const R = Cn("ReconstructionSetupComponent");
      return O(), he(r(Ee), {
        class: "flex-col",
        style: { width: "90vw", height: "90vh" }
      }, {
        default: w(() => [
          d(r(Ee), { class: "flex-row h-full mb-2" }, {
            default: w(() => [
              d($f, {
                class: "horizontal-padding",
                context: r(o),
                "preselected-type": r(a).preselectedMode,
                onTypeSelected: p,
                onModifyType: b,
                style: { flex: "1 1 0" }
              }, null, 8, ["context", "preselected-type"]),
              r(c) != null ? (O(), J(ze, { key: 0 }, [
                T[4] || (T[4] = y("div", { style: { "{\n                        width": "0.1rem", height: "90%", "background-color": "var(--p-rg-border-color)", margin: "5rem 1rem" } }, null, -1)),
                d(kf, {
                  class: "horizontal-padding",
                  context: r(o),
                  reconstructionType: r(c),
                  onWorkflowSelected: m,
                  onModifyWorkflow: S,
                  style: { flex: "1 1 0" }
                }, null, 8, ["context", "reconstructionType"]),
                T[5] || (T[5] = y("div", { style: { "{\n                        width": "0.1rem", height: "90%", "background-color": "var(--p-rg-border-color)", margin: "5rem 1rem" } }, null, -1)),
                r(u) != null || r(a).preselectedMode != null ? (O(), he(R, {
                  key: 0,
                  class: "horizontal-padding",
                  context: r(o),
                  "production-center-list": r(l),
                  "setup-params": r(f),
                  "onUpdate:setupParams": T[0] || (T[0] = (L) => za(f) ? f.value = L : null),
                  "smile-setup-params": r(h),
                  "onUpdate:smileSetupParams": T[1] || (T[1] = (L) => za(h) ? h.value = L : null),
                  "production-setup-params": r(I),
                  "onUpdate:productionSetupParams": T[2] || (T[2] = (L) => za(I) ? I.value = L : null),
                  style: { flex: "2 1 0" }
                }, null, 8, ["context", "production-center-list", "setup-params", "smile-setup-params", "production-setup-params"])) : ue("", !0)
              ], 64)) : ue("", !0)
            ]),
            _: 1
          }),
          d(r(Ee), { class: "p-dialog-footer justify-center" }, {
            default: w(() => [
              d(r(la), {
                disabled: r(c) == null || r(u) == null,
                class: "mt-6",
                label: v.$t("shared.ok"),
                onClick: E
              }, null, 8, ["disabled", "label"]),
              d(r(ya), {
                class: "mt-6",
                label: v.$t("shared.cancel"),
                onClick: T[3] || (T[3] = (L) => g())
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), yO = { class: "flex flex-col" }, _O = /* @__PURE__ */ qe({
  __name: "IPTeethViewComponent",
  props: {
    projectContext: {},
    showLines: { type: Boolean, default: !1 },
    singleJawboneType: { default: null }
  },
  setup(e) {
    const { t } = Yt(), { cleanupAll: n, onEvent: a } = Ra(), o = e, l = F(o.projectContext.settings.general.useUSStyleToothChart);
    a(o.projectContext.settings.onSettingsModified, () => {
      l.value = o.projectContext.settings.general.useUSStyleToothChart;
    });
    const s = F({
      teeth: [],
      selectedObject: void 0,
      objectsModel: null,
      objectsPreview: null,
      implants: [],
      warnString: "warn",
      showLines: o.showLines,
      singleJawboneType: void 0,
      useUSStyleToothChart: l.value
    }), i = F(!1);
    function c(v, T, R) {
      const L = u(v, R);
      L && (L.tooth.editMode === Ta.ADD || o.projectContext.objects.selectImplant(L.name));
    }
    function u(v, T) {
      if (!v) return null;
      const R = b(T)[v - 1];
      if (!R)
        return console.warn("Tooth name not found for id", { id: v, jawboneType: T }), null;
      const L = Object.keys(Jt).indexOf(T.toString());
      let C = s.value.teeth[L].find((A) => A.id === v);
      return s.value.singleJawboneType === null && (C = s.value.teeth[T].find((A) => A.id === v)), C ? { name: R, tooth: C } : (console.warn("Tooth with id not found in CAD teeth view model", { id: v, jawboneType: T }), null);
    }
    function p(v) {
      s.value.warnString = "";
      const T = i.value ? Ta.NO_EDIT : Ta.ADD, R = b(v).map((C, A) => {
        var H, M;
        const j = o.projectContext.objects.implantExists(C), N = o.projectContext.objects.getImplantByToothName(C), x = j ? Ta.SELECT_ONLY : T, z = j || i.value ? Fn.NONE : Fn.ADD;
        let X = j ? pt.OK : pt.EMPTY;
        return ((H = s.value.selectedObject) == null ? void 0 : H.getName()) === C && (X = pt.OK_SELECTED), (N != null && N.getColorOverride() || (M = N == null ? void 0 : N.getSleeve()) != null && M.getColorOverride()) && (X == pt.OK_SELECTED ? (N != null && N.isSleeveChanged() && !(N != null && N.isInCollision()) ? X = pt.WARNING_SELECTED : N != null && N.isInCollision() && (X = pt.COLLISION_SELECTED), N && N.collisions && (N.collisions.nerveCollision && (s.value.warnString += `${t("implant-planner.nerveCollision")} 
`), N.collisions.sleeveCollision && (s.value.warnString += `${t("implant-planner.sleeveCollision")} 
`), N.collisions.anatomyCollision && (s.value.warnString += `${t("implant-planner.anatomyCollision")} 
`), N.collisions.implantCollision ? s.value.warnString += `${t("implant-planner.implantCollision")} 
` : N.collisions.securityZoneCollision && (s.value.warnString += `${t("implant-planner.securityZoneCollision")} 
`), N.collisions.sleeveChanged != null && (s.value.warnString += `${N.collisions.sleeveChanged} 
`))) : N != null && N.isSleeveChanged() && !(N != null && N.isInCollision()) ? X = pt.WARNING : N != null && N.isInCollision() && (X = pt.COLLISION)), {
          id: A + 1,
          editMode: x,
          status: X,
          hoverIcon: z,
          toothName: C
        };
      }), L = Object.keys(Jt).indexOf(v.toString());
      s.value.singleJawboneType !== void 0 ? s.value.teeth.length < 1 ? s.value.teeth.push(R) : s.value.teeth[0] = R : s.value.teeth.length < 2 ? s.value.teeth.push(R) : s.value.teeth[L] = R;
    }
    function b(v) {
      return v === Jt.MANDIBLE ? ys(o.projectContext.settings.general.useUSStyleToothChart) : _s(o.projectContext.settings.general.useUSStyleToothChart);
    }
    function f(v, T, R) {
      var N;
      const L = u(v, R);
      if (!L || i.value && L.tooth.status === pt.EMPTY)
        return;
      const A = o.projectContext.objects.getImplantByToothName(L.name), j = (A == null ? void 0 : A.getColorOverride()) || ((N = A == null ? void 0 : A.getSleeve()) == null ? void 0 : N.getColorOverride());
      A && j ? A != null && A.isSleeveChanged() && !(A != null && A.isInCollision()) ? L.tooth.status = pt.WARNING_SELECTED : A.isInCollision() && (L.tooth.status = pt.COLLISION_SELECTED) : L.tooth.status = pt.OK_SELECTED;
    }
    function h() {
      for (const v in Jt)
        if (Jt.hasOwnProperty(v)) {
          const T = Jt[v];
          (Number(T) || T === 0) && p(T);
        }
    }
    h(), Mt(async () => {
      const v = o.projectContext.objects.selectedObject.get();
      v && await m(v);
    });
    function I(v) {
      return (v == null ? void 0 : v.type) === Le._IMPLANT;
    }
    async function m(v) {
      v !== null && !I(v) || (s.value.selectedObject = v ?? void 0, E(v), await S(v), h());
    }
    async function S(v) {
      if (!v) {
        s.value.objectsPreview = null;
        return;
      }
      const T = o.projectContext.viewConfiguration.colorScheme.get();
      s.value.objectsPreview = {
        implantPreview: await ea(v, T)
      };
      const R = v.getAbutment();
      R ? s.value.objectsPreview.abutmentPreview = await ea(R, T) : s.value.objectsPreview.abutmentPreview = void 0;
      const L = v.getSleeve();
      L ? s.value.objectsPreview.sleevePreview = await ea(L, T) : s.value.objectsPreview.sleevePreview = void 0;
    }
    function E(v) {
      if (v && v.type !== Le._IMPLANT)
        return;
      const T = v;
      if (T) {
        const R = T.getImplantInfo().implantInfo, L = {
          objectId: T.getName(),
          implant: {
            name: `${R.manufacturerName} / ${R.modelName}`,
            diameter: R.diameter,
            length: R.length,
            visibility: T.getVisibility(),
            locked: T.getLocked()
          }
        }, C = T.getAbutment();
        if (C) {
          const j = C.getAbutmentInfo();
          L.abutment = {
            name: `${j.manufacturerName} / ${j.modelName} / ${j.name}`,
            visibility: C.getVisibility(),
            rotationZ: T.GetRotation(),
            rotationZProsthetic: T.GetRotation(!0)
          };
        } else
          L.abutment = void 0;
        const A = T.getSleeve();
        A ? (L.sleeve = {
          name: A.getSleeveName(),
          visibility: A.getVisibility()
        }, L.overallLength = A.getOverallLength(), L.sleeveDistance = A.getDistanceFromImplant(), L.sleeveDistanceLocked = !!A.getSleeveInfo().lockDistance, L.drillLengths = A.getDrillLengths(), L.drillLength = A.getDrillLength()) : (L.sleeve = void 0, L.overallLength = void 0, L.sleeveDistance = void 0, L.sleeveDistanceLocked = !1, L.drillLengths = void 0, L.drillLength = void 0), s.value.objectsModel = L;
      } else
        s.value.objectsModel = null;
    }
    const g = (v, T, R) => {
      p(R);
    };
    return (v, T) => (O(), J("div", yO, [
      d(r(Nc), {
        modelValue: s.value,
        "onUpdate:modelValue": T[0] || (T[0] = (R) => s.value = R),
        jawboneType: r(Jt).MAXILLA,
        indexTeeth: 0,
        warningString: s.value.warnString,
        showLines: s.value.showLines,
        onToothClick: c,
        onToothMouseOut: g,
        onToothMouseOver: f
      }, null, 8, ["modelValue", "jawboneType", "warningString", "showLines"]),
      d(r(Nc), {
        modelValue: s.value,
        "onUpdate:modelValue": T[1] || (T[1] = (R) => s.value = R),
        jawboneType: r(Jt).MANDIBLE,
        indexTeeth: 1,
        warningString: s.value.warnString,
        showLines: s.value.showLines,
        onToothClick: c,
        onToothMouseOut: g,
        onToothMouseOver: f
      }, null, 8, ["modelValue", "jawboneType", "warningString", "showLines"])
    ]));
  }
}), wO = { class: "flex flex-row-wrap gap-20" }, SO = /* @__PURE__ */ qe({
  __name: "IPTeethViewDialog",
  setup(e) {
    const n = Xn("dialogRef").value.data;
    return (a, o) => {
      const l = _O;
      return O(), J("div", wO, [
        d(l, {
          projectContext: r(n).projectContext,
          showLines: !0
        }, null, 8, ["projectContext"]),
        d(r(Mh))
      ]);
    };
  }
}), IO = { class: "text-lg" }, Vf = /* @__PURE__ */ qe({
  __name: "IPFromPlannerFromFileDialog",
  emits: ["importFromFile", "importFromPlanner"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = t, o = () => {
      a("importFromFile"), n.value.close();
    }, l = () => {
      a("importFromPlanner"), n.value.close();
    };
    return (s, i) => (O(), J(ze, null, [
      d(r(Ee), null, {
        default: w(() => [
          y("span", IO, V(s.$t("implant-planner.selectAnImportOption")), 1)
        ]),
        _: 1
      }),
      d(r(Ee), {
        class: "flex-row mt-6",
        style: { "justify-content": "space-around" }
      }, {
        default: w(() => [
          d(r(Ce), {
            class: "btn-wizard-lg",
            label: s.$t("implant-planner.importFromFile"),
            onClick: o
          }, null, 8, ["label"]),
          d(r(Ce), {
            class: "btn-wizard-lg ml-2",
            label: s.$t("implant-planner.importFromPlanner"),
            onClick: l
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
});
function lp(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = EO(e)) || t) {
      n && (e = n);
      var a = 0, o = function() {
      };
      return { s: o, n: function() {
        return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
      }, e: function(u) {
        throw u;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var l, s = !0, i = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var u = n.next();
    return s = u.done, u;
  }, e: function(u) {
    i = !0, l = u;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (i) throw l;
    }
  } };
}
function EO(e, t) {
  if (e) {
    if (typeof e == "string") return ip(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ip(e, t) : void 0;
  }
}
function ip(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
var sp = {
  filter: function(t, n, a, o, l) {
    var s = [];
    if (!t)
      return s;
    var i = lp(t), c;
    try {
      for (i.s(); !(c = i.n()).done; ) {
        var u = c.value;
        if (typeof u == "string") {
          if (this.filters[o](u, a, l)) {
            s.push(u);
            continue;
          }
        } else {
          var p = lp(n), b;
          try {
            for (p.s(); !(b = p.n()).done; ) {
              var f = b.value, h = Fa(u, f);
              if (this.filters[o](h, a, l)) {
                s.push(u);
                break;
              }
            }
          } catch (I) {
            p.e(I);
          } finally {
            p.f();
          }
        }
      }
    } catch (I) {
      i.e(I);
    } finally {
      i.f();
    }
    return s;
  },
  filters: {
    startsWith: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = qn(n.toString()).toLocaleLowerCase(a), l = qn(t.toString()).toLocaleLowerCase(a);
      return l.slice(0, o.length) === o;
    },
    contains: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = qn(n.toString()).toLocaleLowerCase(a), l = qn(t.toString()).toLocaleLowerCase(a);
      return l.indexOf(o) !== -1;
    },
    notContains: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = qn(n.toString()).toLocaleLowerCase(a), l = qn(t.toString()).toLocaleLowerCase(a);
      return l.indexOf(o) === -1;
    },
    endsWith: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = qn(n.toString()).toLocaleLowerCase(a), l = qn(t.toString()).toLocaleLowerCase(a);
      return l.indexOf(o, l.length - o.length) !== -1;
    },
    equals: function(t, n, a) {
      return n == null || n === "" ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() === n.getTime() : qn(t.toString()).toLocaleLowerCase(a) == qn(n.toString()).toLocaleLowerCase(a);
    },
    notEquals: function(t, n, a) {
      return n == null || n === "" ? !1 : t == null ? !0 : t.getTime && n.getTime ? t.getTime() !== n.getTime() : qn(t.toString()).toLocaleLowerCase(a) != qn(n.toString()).toLocaleLowerCase(a);
    },
    in: function(t, n) {
      if (n == null || n.length === 0)
        return !0;
      for (var a = 0; a < n.length; a++)
        if (as(t, n[a]))
          return !0;
      return !1;
    },
    between: function(t, n) {
      return n == null || n[0] == null || n[1] == null ? !0 : t == null ? !1 : t.getTime ? n[0].getTime() <= t.getTime() && t.getTime() <= n[1].getTime() : n[0] <= t && t <= n[1];
    },
    lt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() < n.getTime() : t < n;
    },
    lte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() <= n.getTime() : t <= n;
    },
    gt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() > n.getTime() : t > n;
    },
    gte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() >= n.getTime() : t >= n;
    },
    dateIs: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() === n.toDateString();
    },
    dateIsNot: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() !== n.toDateString();
    },
    dateBefore: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() < n.getTime();
    },
    dateAfter: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() > n.getTime();
    }
  },
  register: function(t, n) {
    this.filters[t] = n;
  }
};
function rp() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pv_id_";
  return vm(e);
}
var Bf = {
  name: "BlankIcon",
  extends: sa
};
function TO(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("rect", {
    width: "1",
    height: "1",
    fill: "currentColor",
    "fill-opacity": "0"
  }, null, -1)]), 16);
}
Bf.render = TO;
var Uf = {
  name: "CheckIcon",
  extends: sa
};
function CO(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Uf.render = CO;
var Gf = {
  name: "SearchIcon",
  extends: sa
};
function NO(e, t, n, a, o, l) {
  return O(), J("svg", Pe({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Gf.render = NO;
const LO = {
  name: "BaseListbox",
  extends: Eu,
  props: {
    options: Array,
    optionLabel: null,
    optionValue: null,
    optionDisabled: null,
    optionGroupLabel: null,
    optionGroupChildren: null,
    listStyle: null,
    scrollHeight: {
      type: String,
      default: "14rem"
    },
    dataKey: null,
    multiple: {
      type: Boolean,
      default: !1
    },
    metaKeySelection: {
      type: Boolean,
      default: !1
    },
    filter: Boolean,
    filterPlaceholder: String,
    filterLocale: String,
    filterMatchMode: {
      type: String,
      default: "contains"
    },
    filterFields: {
      type: Array,
      default: null
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    autoOptionFocus: {
      type: Boolean,
      default: !0
    },
    selectOnFocus: {
      type: Boolean,
      default: !1
    },
    focusOnHover: {
      type: Boolean,
      default: !0
    },
    highlightOnSelect: {
      type: Boolean,
      default: !0
    },
    checkmark: {
      type: Boolean,
      default: !1
    },
    filterMessage: {
      type: String,
      default: null
    },
    selectionMessage: {
      type: String,
      default: null
    },
    emptySelectionMessage: {
      type: String,
      default: null
    },
    emptyFilterMessage: {
      type: String,
      default: null
    },
    emptyMessage: {
      type: String,
      default: null
    },
    filterIcon: {
      type: String,
      default: void 0
    },
    striped: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: cb,
  provide() {
    return {
      $pcListbox: this,
      $parentInstance: this
    };
  }
}, OO = {
  name: "Listbox",
  extends: LO,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur", "filter", "item-dblclick", "option-dblclick"],
  list: null,
  virtualScroller: null,
  optionTouched: !1,
  startRangeIndex: -1,
  searchTimeout: null,
  searchValue: "",
  data() {
    return {
      id: this.$attrs.id,
      filterValue: null,
      focused: !1,
      focusedOptionIndex: -1
    };
  },
  watch: {
    "$attrs.id": function(e) {
      this.id = e || rp();
    },
    options() {
      this.autoUpdateModel();
    }
  },
  mounted() {
    this.id = this.id || rp(), this.autoUpdateModel();
  },
  methods: {
    getOptionIndex(e, t) {
      return this.virtualScrollerDisabled ? e : t && t(e).index;
    },
    getOptionLabel(e) {
      return this.optionLabel ? Fa(e, this.optionLabel) : typeof e == "string" ? e : null;
    },
    getOptionValue(e) {
      return this.optionValue ? Fa(e, this.optionValue) : e;
    },
    getOptionRenderKey(e, t) {
      return (this.dataKey ? Fa(e, this.dataKey) : this.getOptionLabel(e)) + "_" + t;
    },
    getPTOptions(e, t, n, a) {
      return this.ptm(a, {
        context: {
          selected: this.isSelected(e),
          focused: this.focusedOptionIndex === this.getOptionIndex(n, t),
          disabled: this.isOptionDisabled(e)
        }
      });
    },
    isOptionDisabled(e) {
      return this.optionDisabled ? Fa(e, this.optionDisabled) : !1;
    },
    isOptionGroup(e) {
      return this.optionGroupLabel && e.optionGroup && e.group;
    },
    getOptionGroupLabel(e) {
      return Fa(e, this.optionGroupLabel);
    },
    getOptionGroupChildren(e) {
      return Fa(e, this.optionGroupChildren);
    },
    getAriaPosInset(e) {
      return (this.optionGroupLabel ? e - this.visibleOptions.slice(0, e).filter((t) => this.isOptionGroup(t)).length : e) + 1;
    },
    onFirstHiddenFocus() {
      Bi(this.list);
      const e = ld(this.$el, ':not([data-p-hidden-focusable="true"])');
      this.$refs.lastHiddenFocusableElement.tabIndex = xo(e) ? void 0 : -1, this.$refs.firstHiddenFocusableElement.tabIndex = -1;
    },
    onLastHiddenFocus(e) {
      if (e.relatedTarget === this.list) {
        const n = ld(this.$el, ':not([data-p-hidden-focusable="true"])');
        Bi(n), this.$refs.firstHiddenFocusableElement.tabIndex = void 0;
      } else
        Bi(this.$refs.firstHiddenFocusableElement);
      this.$refs.lastHiddenFocusableElement.tabIndex = -1;
    },
    onFocusout(e) {
      !this.$el.contains(e.relatedTarget) && this.$refs.lastHiddenFocusableElement && this.$refs.firstHiddenFocusableElement && (this.$refs.lastHiddenFocusableElement.tabIndex = this.$refs.firstHiddenFocusableElement.tabIndex = void 0);
    },
    onListFocus(e) {
      this.focused = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : this.findSelectedOptionIndex(), this.autoUpdateModel(), this.$emit("focus", e);
    },
    onListBlur(e) {
      this.focused = !1, this.focusedOptionIndex = this.startRangeIndex = -1, this.searchValue = "", this.$emit("blur", e);
    },
    onListKeyDown(e) {
      const t = e.metaKey || e.ctrlKey;
      switch (e.code) {
        case "ArrowDown":
          this.onArrowDownKey(e);
          break;
        case "ArrowUp":
          this.onArrowUpKey(e);
          break;
        case "Home":
          this.onHomeKey(e);
          break;
        case "End":
          this.onEndKey(e);
          break;
        case "PageDown":
          this.onPageDownKey(e);
          break;
        case "PageUp":
          this.onPageUpKey(e);
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.onSpaceKey(e);
          break;
        case "Tab":
          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.onShiftKey(e);
          break;
        default:
          if (this.multiple && e.code === "KeyA" && t) {
            const n = this.visibleOptions.filter((a) => this.isValidOption(a)).map((a) => this.getOptionValue(a));
            this.updateModel(e, n), e.preventDefault();
            break;
          }
          !t && Uy(e.key) && (this.searchOptions(e, e.key), e.preventDefault());
          break;
      }
    },
    onOptionSelect(e, t, n = -1) {
      this.disabled || this.isOptionDisabled(t) || (this.multiple ? this.onOptionSelectMultiple(e, t) : this.onOptionSelectSingle(e, t), this.optionTouched = !1, n !== -1 && (this.focusedOptionIndex = n));
    },
    onOptionMouseDown(e, t) {
      this.changeFocusedOptionIndex(e, t);
    },
    onOptionMouseMove(e, t) {
      this.focusOnHover && this.focused && this.changeFocusedOptionIndex(e, t);
    },
    onOptionTouchEnd() {
      this.disabled || (this.optionTouched = !0);
    },
    onOptionDblClick(e, t) {
      this.$emit("item-dblclick", {
        originalEvent: e,
        value: t
      }), this.$emit("option-dblclick", {
        originalEvent: e,
        value: t
      });
    },
    onOptionSelectSingle(e, t) {
      let n = this.isSelected(t), a = !1, o = null;
      if (this.optionTouched ? !1 : this.metaKeySelection) {
        let s = e && (e.metaKey || e.ctrlKey);
        n ? s && (o = null, a = !0) : (o = this.getOptionValue(t), a = !0);
      } else
        o = n ? null : this.getOptionValue(t), a = !0;
      a && this.updateModel(e, o);
    },
    onOptionSelectMultiple(e, t) {
      let n = this.isSelected(t), a = null;
      if (this.optionTouched ? !1 : this.metaKeySelection) {
        let l = e.metaKey || e.ctrlKey;
        n ? a = l ? this.removeOption(t) : [this.getOptionValue(t)] : (a = l ? this.d_value || [] : [], a = [...a, this.getOptionValue(t)]);
      } else
        a = n ? this.removeOption(t) : [...this.d_value || [], this.getOptionValue(t)];
      this.updateModel(e, a);
    },
    onOptionSelectRange(e, t = -1, n = -1) {
      if (t === -1 && (t = this.findNearestSelectedOptionIndex(n, !0)), n === -1 && (n = this.findNearestSelectedOptionIndex(t)), t !== -1 && n !== -1) {
        const a = Math.min(t, n), o = Math.max(t, n), l = this.visibleOptions.slice(a, o + 1).filter((s) => this.isValidOption(s)).map((s) => this.getOptionValue(s));
        this.updateModel(e, l);
      }
    },
    onFilterChange(e) {
      this.$emit("filter", { originalEvent: e, value: e.target.value, filterValue: this.visibleOptions }), this.focusedOptionIndex = this.startRangeIndex = -1;
    },
    onFilterBlur() {
      this.focusedOptionIndex = this.startRangeIndex = -1;
    },
    onFilterKeyDown(e) {
      switch (e.code) {
        case "ArrowDown":
          this.onArrowDownKey(e);
          break;
        case "ArrowUp":
          this.onArrowUpKey(e);
          break;
        case "ArrowLeft":
        case "ArrowRight":
          this.onArrowLeftKey(e, !0);
          break;
        case "Home":
          this.onHomeKey(e, !0);
          break;
        case "End":
          this.onEndKey(e, !0);
          break;
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(e);
          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.onShiftKey(e);
          break;
      }
    },
    onArrowDownKey(e) {
      const t = this.focusedOptionIndex !== -1 ? this.findNextOptionIndex(this.focusedOptionIndex) : this.findFirstFocusedOptionIndex();
      this.multiple && e.shiftKey && this.onOptionSelectRange(e, this.startRangeIndex, t), this.changeFocusedOptionIndex(e, t), e.preventDefault();
    },
    onArrowUpKey(e) {
      const t = this.focusedOptionIndex !== -1 ? this.findPrevOptionIndex(this.focusedOptionIndex) : this.findLastFocusedOptionIndex();
      this.multiple && e.shiftKey && this.onOptionSelectRange(e, t, this.startRangeIndex), this.changeFocusedOptionIndex(e, t), e.preventDefault();
    },
    onArrowLeftKey(e, t = !1) {
      t && (this.focusedOptionIndex = -1);
    },
    onHomeKey(e, t = !1) {
      if (t) {
        const n = e.currentTarget;
        e.shiftKey ? n.setSelectionRange(0, e.target.selectionStart) : (n.setSelectionRange(0, 0), this.focusedOptionIndex = -1);
      } else {
        let n = e.metaKey || e.ctrlKey, a = this.findFirstOptionIndex();
        this.multiple && e.shiftKey && n && this.onOptionSelectRange(e, a, this.startRangeIndex), this.changeFocusedOptionIndex(e, a);
      }
      e.preventDefault();
    },
    onEndKey(e, t = !1) {
      if (t) {
        const n = e.currentTarget;
        if (e.shiftKey)
          n.setSelectionRange(e.target.selectionStart, n.value.length);
        else {
          const a = n.value.length;
          n.setSelectionRange(a, a), this.focusedOptionIndex = -1;
        }
      } else {
        let n = e.metaKey || e.ctrlKey, a = this.findLastOptionIndex();
        this.multiple && e.shiftKey && n && this.onOptionSelectRange(e, this.startRangeIndex, a), this.changeFocusedOptionIndex(e, a);
      }
      e.preventDefault();
    },
    onPageUpKey(e) {
      this.scrollInView(0), e.preventDefault();
    },
    onPageDownKey(e) {
      this.scrollInView(this.visibleOptions.length - 1), e.preventDefault();
    },
    onEnterKey(e) {
      this.focusedOptionIndex !== -1 && (this.multiple && e.shiftKey ? this.onOptionSelectRange(e, this.focusedOptionIndex) : this.onOptionSelect(e, this.visibleOptions[this.focusedOptionIndex]));
    },
    onSpaceKey(e) {
      e.preventDefault(), this.onEnterKey(e);
    },
    onShiftKey() {
      this.startRangeIndex = this.focusedOptionIndex;
    },
    isOptionMatched(e) {
      var t;
      return this.isValidOption(e) && typeof this.getOptionLabel(e) == "string" && ((t = this.getOptionLabel(e)) == null ? void 0 : t.toLocaleLowerCase(this.filterLocale).startsWith(this.searchValue.toLocaleLowerCase(this.filterLocale)));
    },
    isValidOption(e) {
      return Dt(e) && !(this.isOptionDisabled(e) || this.isOptionGroup(e));
    },
    isValidSelectedOption(e) {
      return this.isValidOption(e) && this.isSelected(e);
    },
    isEquals(e, t) {
      return as(e, t, this.equalityKey);
    },
    isSelected(e) {
      const t = this.getOptionValue(e);
      return this.multiple ? (this.d_value || []).some((n) => this.isEquals(n, t)) : this.isEquals(this.d_value, t);
    },
    findFirstOptionIndex() {
      return this.visibleOptions.findIndex((e) => this.isValidOption(e));
    },
    findLastOptionIndex() {
      return Di(this.visibleOptions, (e) => this.isValidOption(e));
    },
    findNextOptionIndex(e) {
      const t = e < this.visibleOptions.length - 1 ? this.visibleOptions.slice(e + 1).findIndex((n) => this.isValidOption(n)) : -1;
      return t > -1 ? t + e + 1 : e;
    },
    findPrevOptionIndex(e) {
      const t = e > 0 ? Di(this.visibleOptions.slice(0, e), (n) => this.isValidOption(n)) : -1;
      return t > -1 ? t : e;
    },
    findSelectedOptionIndex() {
      if (this.$filled)
        if (this.multiple)
          for (let e = this.d_value.length - 1; e >= 0; e--) {
            const t = this.d_value[e], n = this.visibleOptions.findIndex((a) => this.isValidSelectedOption(a) && this.isEquals(t, this.getOptionValue(a)));
            if (n > -1) return n;
          }
        else
          return this.visibleOptions.findIndex((e) => this.isValidSelectedOption(e));
      return -1;
    },
    findFirstSelectedOptionIndex() {
      return this.$filled ? this.visibleOptions.findIndex((e) => this.isValidSelectedOption(e)) : -1;
    },
    findLastSelectedOptionIndex() {
      return this.$filled ? Di(this.visibleOptions, (e) => this.isValidSelectedOption(e)) : -1;
    },
    findNextSelectedOptionIndex(e) {
      const t = this.$filled && e < this.visibleOptions.length - 1 ? this.visibleOptions.slice(e + 1).findIndex((n) => this.isValidSelectedOption(n)) : -1;
      return t > -1 ? t + e + 1 : -1;
    },
    findPrevSelectedOptionIndex(e) {
      const t = this.$filled && e > 0 ? Di(this.visibleOptions.slice(0, e), (n) => this.isValidSelectedOption(n)) : -1;
      return t > -1 ? t : -1;
    },
    findNearestSelectedOptionIndex(e, t = !1) {
      let n = -1;
      return this.$filled && (t ? (n = this.findPrevSelectedOptionIndex(e), n = n === -1 ? this.findNextSelectedOptionIndex(e) : n) : (n = this.findNextSelectedOptionIndex(e), n = n === -1 ? this.findPrevSelectedOptionIndex(e) : n)), n > -1 ? n : e;
    },
    findFirstFocusedOptionIndex() {
      const e = this.findFirstSelectedOptionIndex();
      return e < 0 ? this.findFirstOptionIndex() : e;
    },
    findLastFocusedOptionIndex() {
      const e = this.findLastSelectedOptionIndex();
      return e < 0 ? this.findLastOptionIndex() : e;
    },
    searchOptions(e, t) {
      this.searchValue = (this.searchValue || "") + t;
      let n = -1;
      Dt(this.searchValue) && (this.focusedOptionIndex !== -1 ? (n = this.visibleOptions.slice(this.focusedOptionIndex).findIndex((a) => this.isOptionMatched(a)), n = n === -1 ? this.visibleOptions.slice(0, this.focusedOptionIndex).findIndex((a) => this.isOptionMatched(a)) : n + this.focusedOptionIndex) : n = this.visibleOptions.findIndex((a) => this.isOptionMatched(a)), n === -1 && this.focusedOptionIndex === -1 && (n = this.findFirstFocusedOptionIndex()), n !== -1 && this.changeFocusedOptionIndex(e, n)), this.searchTimeout && clearTimeout(this.searchTimeout), this.searchTimeout = setTimeout(() => {
        this.searchValue = "", this.searchTimeout = null;
      }, 500);
    },
    removeOption(e) {
      return this.d_value.filter((t) => !as(t, this.getOptionValue(e), this.equalityKey));
    },
    changeFocusedOptionIndex(e, t) {
      this.focusedOptionIndex !== t && (this.focusedOptionIndex = t, this.scrollInView(), this.selectOnFocus && !this.multiple && this.onOptionSelect(e, this.visibleOptions[t]));
    },
    scrollInView(e = -1) {
      this.$nextTick(() => {
        const t = e !== -1 ? `${this.id}_${e}` : this.focusedOptionId, n = wu(this.list, `li[id="${t}"]`);
        n ? n.scrollIntoView && n.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" }) : this.virtualScrollerDisabled || this.virtualScroller && this.virtualScroller.scrollToIndex(e !== -1 ? e : this.focusedOptionIndex);
      });
    },
    autoUpdateModel() {
      this.selectOnFocus && this.autoOptionFocus && !this.$filled && !this.multiple && this.focused && (this.focusedOptionIndex = this.findFirstFocusedOptionIndex(), this.onOptionSelect(null, this.visibleOptions[this.focusedOptionIndex]));
    },
    updateModel(e, t) {
      this.writeValue(t, e), this.$emit("change", { originalEvent: e, value: t });
    },
    listRef(e, t) {
      this.list = e, t && t(e);
    },
    virtualScrollerRef(e) {
      this.virtualScroller = e;
    }
  },
  computed: {
    optionsListFlat() {
      return this.filterValue ? sp.filter(this.options, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale) : this.options;
    },
    optionsListGroup() {
      const e = [];
      return (this.options || []).forEach((t) => {
        const n = this.getOptionGroupChildren(t) || [], a = this.filterValue ? sp.filter(n, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale) : n;
        a != null && a.length && e.push({ optionGroup: t, group: !0 }, ...a);
      }), e;
    },
    visibleOptions() {
      return this.optionGroupLabel ? this.optionsListGroup : this.optionsListFlat;
    },
    // @deprecated use $filled instead
    hasSelectedOption() {
      return Dt(this.d_value);
    },
    equalityKey() {
      return this.optionValue ? null : this.dataKey;
    },
    searchFields() {
      return this.filterFields || [this.optionLabel];
    },
    filterResultMessageText() {
      return Dt(this.visibleOptions) ? this.filterMessageText.replaceAll("{0}", this.visibleOptions.length) : this.emptyFilterMessageText;
    },
    filterMessageText() {
      return this.filterMessage || this.$primevue.config.locale.searchMessage || "";
    },
    emptyFilterMessageText() {
      return this.emptyFilterMessage || this.$primevue.config.locale.emptySearchMessage || this.$primevue.config.locale.emptyFilterMessage || "";
    },
    emptyMessageText() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage || "";
    },
    selectionMessageText() {
      return this.selectionMessage || this.$primevue.config.locale.selectionMessage || "";
    },
    emptySelectionMessageText() {
      return this.emptySelectionMessage || this.$primevue.config.locale.emptySelectionMessage || "";
    },
    selectedMessageText() {
      return this.$filled ? this.selectionMessageText.replaceAll("{0}", this.multiple ? this.d_value.length : "1") : this.emptySelectionMessageText;
    },
    focusedOptionId() {
      return this.focusedOptionIndex !== -1 ? `${this.id}_${this.focusedOptionIndex}` : null;
    },
    ariaSetSize() {
      return this.visibleOptions.filter((e) => !this.isOptionGroup(e)).length;
    },
    virtualScrollerDisabled() {
      return !this.virtualScrollerOptions;
    }
  },
  directives: {
    ripple: jp
  },
  components: {
    InputText: ca,
    VirtualScroller: ub,
    InputIcon: rb,
    IconField: sb,
    SearchIcon: Gf,
    CheckIcon: Uf,
    BlankIcon: Bf
  }
}, DO = ["id"], AO = ["tabindex"], RO = ["id", "aria-multiselectable", "aria-label", "aria-labelledby", "aria-activedescendant", "aria-disabled"], MO = ["id"], PO = ["id", "aria-label", "aria-selected", "aria-disabled", "aria-setsize", "aria-posinset", "onClick", "onMousedown", "onMousemove", "onDblclick", "data-p-selected", "data-p-focused", "data-p-disabled"], xO = ["tabindex"];
function jO(e, t, n, a, o, l) {
  const s = Cn("InputText"), i = Cn("SearchIcon"), c = Cn("InputIcon"), u = Cn("IconField"), p = Cn("CheckIcon"), b = Cn("BlankIcon"), f = Cn("VirtualScroller"), h = ou("ripple");
  return O(), J("div", Pe({
    id: o.id,
    class: e.cx("root"),
    onFocusout: t[7] || (t[7] = (...I) => l.onFocusout && l.onFocusout(...I))
  }, e.ptmi("root")), [
    y("span", Pe({
      ref: "firstHiddenFocusableElement",
      role: "presentation",
      "aria-hidden": "true",
      class: "p-hidden-accessible p-hidden-focusable",
      tabindex: e.disabled ? -1 : e.tabindex,
      onFocus: t[0] || (t[0] = (...I) => l.onFirstHiddenFocus && l.onFirstHiddenFocus(...I))
    }, e.ptm("hiddenFirstFocusableEl"), {
      "data-p-hidden-accessible": !0,
      "data-p-hidden-focusable": !0
    }), null, 16, AO),
    e.$slots.header ? (O(), J("div", {
      key: 0,
      class: He(e.cx("header"))
    }, [
      St(e.$slots, "header", {
        value: e.d_value,
        options: l.visibleOptions
      })
    ], 2)) : ue("", !0),
    e.filter ? (O(), J("div", Pe({
      key: 1,
      class: e.cx("header")
    }, e.ptm("header")), [
      d(u, {
        unstyled: e.unstyled,
        pt: e.ptm("pcFilterContainer")
      }, {
        default: w(() => [
          d(s, {
            modelValue: o.filterValue,
            "onUpdate:modelValue": t[1] || (t[1] = (I) => o.filterValue = I),
            type: "text",
            class: He(e.cx("pcFilter")),
            placeholder: e.filterPlaceholder,
            role: "searchbox",
            autocomplete: "off",
            disabled: e.disabled,
            unstyled: e.unstyled,
            "aria-owns": o.id + "_list",
            "aria-activedescendant": l.focusedOptionId,
            tabindex: !e.disabled && !o.focused ? e.tabindex : -1,
            onInput: l.onFilterChange,
            onBlur: l.onFilterBlur,
            onKeydown: l.onFilterKeyDown,
            pt: e.ptm("pcFilter")
          }, null, 8, ["modelValue", "class", "placeholder", "disabled", "unstyled", "aria-owns", "aria-activedescendant", "tabindex", "onInput", "onBlur", "onKeydown", "pt"]),
          d(c, {
            unstyled: e.unstyled,
            pt: e.ptm("pcFilterIconContainer")
          }, {
            default: w(() => [
              St(e.$slots, "filtericon", {}, () => [
                e.filterIcon ? (O(), J("span", Pe({
                  key: 0,
                  class: e.filterIcon
                }, e.ptm("filterIcon")), null, 16)) : (O(), he(i, bo(Pe({ key: 1 }, e.ptm("filterIcon"))), null, 16))
              ])
            ]),
            _: 3
          }, 8, ["unstyled", "pt"])
        ]),
        _: 3
      }, 8, ["unstyled", "pt"]),
      y("span", Pe({
        role: "status",
        "aria-live": "polite",
        class: "p-hidden-accessible"
      }, e.ptm("hiddenFilterResult"), { "data-p-hidden-accessible": !0 }), V(l.filterResultMessageText), 17)
    ], 16)) : ue("", !0),
    y("div", Pe({
      class: e.cx("listContainer"),
      style: [{ "max-height": l.virtualScrollerDisabled ? e.scrollHeight : "" }, e.listStyle]
    }, e.ptm("listContainer")), [
      d(f, Pe({ ref: l.virtualScrollerRef }, e.virtualScrollerOptions, {
        items: l.visibleOptions,
        style: [{ height: e.scrollHeight }, e.listStyle],
        tabindex: -1,
        disabled: l.virtualScrollerDisabled,
        pt: e.ptm("virtualScroller")
      }), Kg({
        content: w(({ styleClass: I, contentRef: m, items: S, getItemOptions: E, contentStyle: g, itemSize: v }) => [
          y("ul", Pe({
            ref: (T) => l.listRef(T, m),
            id: o.id + "_list",
            class: [e.cx("list"), I],
            style: g,
            tabindex: -1,
            role: "listbox",
            "aria-multiselectable": e.multiple,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabelledby,
            "aria-activedescendant": o.focused ? l.focusedOptionId : void 0,
            "aria-disabled": e.disabled,
            onFocus: t[3] || (t[3] = (...T) => l.onListFocus && l.onListFocus(...T)),
            onBlur: t[4] || (t[4] = (...T) => l.onListBlur && l.onListBlur(...T)),
            onKeydown: t[5] || (t[5] = (...T) => l.onListKeyDown && l.onListKeyDown(...T))
          }, e.ptm("list")), [
            (O(!0), J(ze, null, Rt(S, (T, R) => (O(), J(ze, {
              key: l.getOptionRenderKey(T, l.getOptionIndex(R, E))
            }, [
              l.isOptionGroup(T) ? (O(), J("li", Pe({
                key: 0,
                id: o.id + "_" + l.getOptionIndex(R, E),
                style: { height: v ? v + "px" : void 0 },
                class: e.cx("optionGroup"),
                role: "option"
              }, { ref_for: !0 }, e.ptm("optionGroup")), [
                St(e.$slots, "optiongroup", {
                  option: T.optionGroup,
                  index: l.getOptionIndex(R, E)
                }, () => [
                  yt(V(l.getOptionGroupLabel(T.optionGroup)), 1)
                ])
              ], 16, MO)) : Pt((O(), J("li", Pe({
                key: 1,
                id: o.id + "_" + l.getOptionIndex(R, E),
                style: { height: v ? v + "px" : void 0 },
                class: e.cx("option", { option: T, index: R, getItemOptions: E }),
                role: "option",
                "aria-label": l.getOptionLabel(T),
                "aria-selected": l.isSelected(T),
                "aria-disabled": l.isOptionDisabled(T),
                "aria-setsize": l.ariaSetSize,
                "aria-posinset": l.getAriaPosInset(l.getOptionIndex(R, E)),
                onClick: (L) => l.onOptionSelect(L, T, l.getOptionIndex(R, E)),
                onMousedown: (L) => l.onOptionMouseDown(L, l.getOptionIndex(R, E)),
                onMousemove: (L) => l.onOptionMouseMove(L, l.getOptionIndex(R, E)),
                onTouchend: t[2] || (t[2] = (L) => l.onOptionTouchEnd()),
                onDblclick: (L) => l.onOptionDblClick(L, T)
              }, { ref_for: !0 }, l.getPTOptions(T, E, R, "option"), {
                "data-p-selected": l.isSelected(T),
                "data-p-focused": o.focusedOptionIndex === l.getOptionIndex(R, E),
                "data-p-disabled": l.isOptionDisabled(T)
              }), [
                e.checkmark ? (O(), J(ze, { key: 0 }, [
                  l.isSelected(T) ? (O(), he(p, Pe({
                    key: 0,
                    class: e.cx("optionCheckIcon")
                  }, { ref_for: !0 }, e.ptm("optionCheckIcon")), null, 16, ["class"])) : (O(), he(b, Pe({
                    key: 1,
                    class: e.cx("optionBlankIcon")
                  }, { ref_for: !0 }, e.ptm("optionBlankIcon")), null, 16, ["class"]))
                ], 64)) : ue("", !0),
                St(e.$slots, "option", {
                  option: T,
                  selected: l.isSelected(T),
                  index: l.getOptionIndex(R, E)
                }, () => [
                  yt(V(l.getOptionLabel(T)), 1)
                ])
              ], 16, PO)), [
                [h]
              ])
            ], 64))), 128)),
            o.filterValue && (!S || S && S.length === 0) ? (O(), J("li", Pe({
              key: 0,
              class: e.cx("emptyMessage"),
              role: "option"
            }, e.ptm("emptyMessage")), [
              St(e.$slots, "emptyfilter", {}, () => [
                yt(V(l.emptyFilterMessageText), 1)
              ])
            ], 16)) : !e.options || e.options && e.options.length === 0 ? (O(), J("li", Pe({
              key: 1,
              class: e.cx("emptyMessage"),
              role: "option"
            }, e.ptm("emptyMessage")), [
              St(e.$slots, "empty", {}, () => [
                yt(V(l.emptyMessageText), 1)
              ])
            ], 16)) : ue("", !0)
          ], 16, RO)
        ]),
        _: 2
      }, [
        e.$slots.loader ? {
          name: "loader",
          fn: w(({ options: I }) => [
            St(e.$slots, "loader", { options: I })
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["items", "style", "disabled", "pt"])
    ], 16),
    St(e.$slots, "footer", {
      value: e.d_value,
      options: l.visibleOptions
    }),
    !e.options || e.options && e.options.length === 0 ? (O(), J("span", Pe({
      key: 2,
      role: "status",
      "aria-live": "polite",
      class: "p-hidden-accessible"
    }, e.ptm("hiddenEmptyMessage"), { "data-p-hidden-accessible": !0 }), V(l.emptyMessageText), 17)) : ue("", !0),
    y("span", Pe({
      role: "status",
      "aria-live": "polite",
      class: "p-hidden-accessible"
    }, e.ptm("hiddenSelectedMessage"), { "data-p-hidden-accessible": !0 }), V(l.selectedMessageText), 17),
    y("span", Pe({
      ref: "lastHiddenFocusableElement",
      role: "presentation",
      "aria-hidden": "true",
      class: "p-hidden-accessible p-hidden-focusable",
      tabindex: e.disabled ? -1 : e.tabindex,
      onFocus: t[6] || (t[6] = (...I) => l.onLastHiddenFocus && l.onLastHiddenFocus(...I))
    }, e.ptm("hiddenLastFocusableEl"), {
      "data-p-hidden-accessible": !0,
      "data-p-hidden-focusable": !0
    }), null, 16, xO)
  ], 16, DO);
}
const FO = /* @__PURE__ */ $t(OO, [["render", jO]]), $O = {
  class: /* @__PURE__ */ He("flex mt-2 text-lg bold")
}, kO = { class: "col-4-no-padding" }, VO = { class: "col-span-8 no-padding" }, BO = { class: "col-4-no-padding" }, UO = { class: "col no-padding" }, GO = { class: "col-4-no-padding" }, WO = { class: "col-span-8 no-padding" }, zO = /* @__PURE__ */ qe({
  __name: "ProductionOptionsComponent",
  props: /* @__PURE__ */ xn({
    productionCenterList: {}
  }, {
    setupParams: { required: !0 },
    setupParamsModifiers: {}
  }),
  emits: ["update:setupParams"],
  setup(e) {
    const t = Ln(e, "setupParams"), n = e, a = () => {
      if (t.value != null) {
        const o = t.value.materialLibrary.selectedItem;
        o != null && (t.value.color.items = tO(o.productionCenterId, o.materialId, n.productionCenterList), t.value.color.selectedItem = t.value.color.items[0], t.value.presetLibrary.items = nO(o.productionCenterId, o.materialId, n.productionCenterList), t.value.presetLibrary.selectedItem = t.value.presetLibrary.items[0]);
      }
    };
    return (o, l) => (O(), he(r(Ee), { class: "flex-col w-full" }, {
      default: w(() => [
        y("div", $O, V(o.$t("implant-planner.productionOptions")), 1),
        d(r(Ee), { class: "flex-row" }, {
          default: w(() => [
            d(r(Ee), { class: "flex-col col-span-6" }, {
              default: w(() => [
                d(r(Ee), {
                  class: "mt-6",
                  style: { "align-items": "baseline" }
                }, {
                  default: w(() => [
                    y("div", kO, [
                      y("span", null, V(o.$t("shared.materialLibrary")), 1)
                    ]),
                    y("div", VO, [
                      d(r(Pn), {
                        modelValue: t.value.materialLibrary.selectedItem,
                        "onUpdate:modelValue": [
                          l[0] || (l[0] = (s) => t.value.materialLibrary.selectedItem = s),
                          a
                        ],
                        options: t.value.materialLibrary.items,
                        class: "w-full",
                        optionLabel: "name",
                        placeholder: o.$t("implant-planner.none"),
                        showClear: !0
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _: 1
                }),
                d(r(Ee), {
                  class: "mt-6",
                  style: { "align-items": "baseline" }
                }, {
                  default: w(() => [
                    y("div", BO, [
                      y("span", null, V(o.$t("shared.color")), 1)
                    ]),
                    y("div", UO, [
                      d(r(Pn), {
                        modelValue: t.value.color.selectedItem,
                        "onUpdate:modelValue": l[1] || (l[1] = (s) => t.value.color.selectedItem = s),
                        options: t.value.color.items,
                        class: "w-full",
                        optionLabel: "name",
                        placeholder: o.$t("implant-planner.none"),
                        showClear: !0
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Ee), { class: "flex-col col-span-6 ml-2" }, {
              default: w(() => [
                d(r(Ee), {
                  class: "mt-6",
                  style: { "align-items": "baseline" }
                }, {
                  default: w(() => [
                    y("div", GO, [
                      y("span", null, V(o.$t("implant-planner.presetLibrary")), 1)
                    ]),
                    y("div", WO, [
                      d(r(Pn), {
                        modelValue: t.value.presetLibrary.selectedItem,
                        "onUpdate:modelValue": l[2] || (l[2] = (s) => t.value.presetLibrary.selectedItem = s),
                        options: t.value.presetLibrary.items,
                        class: "w-full",
                        optionLabel: "name",
                        placeholder: o.$t("implant-planner.none"),
                        showClear: !0
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), HO = {
  class: /* @__PURE__ */ He("flex mt-2 text-lg bold")
}, YO = {
  class: /* @__PURE__ */ He("flex mt-2")
}, KO = {
  class: "flex flex-col",
  style: { "text-align": "center" }
}, ZO = { key: 0 }, JO = /* @__PURE__ */ qe({
  __name: "SmileSetupComponent",
  props: /* @__PURE__ */ xn({
    context: {}
  }, {
    setupParams: { required: !0 },
    setupParamsModifiers: {}
  }),
  emits: ["update:setupParams"],
  setup(e) {
    const { t } = Yt(), n = e, a = Ln(e, "setupParams"), o = Aa(), l = (s) => {
      o.open(ql, {
        props: {
          closable: !0,
          modal: !0,
          header: t("implant-planner.uploadImage"),
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        data: {
          dropArea: !0,
          selectFilesBtn: !0,
          selectFolderBtn: !0,
          accept: Ip,
          writeToWasmFS: !1,
          filterAssociatedFiles: !1,
          singleSelection: !0,
          showTypeColumn: !1,
          hideTreeWhenNoFolders: !0,
          showAccept: !0
        },
        emits: {
          onUploadFiles: async (i) => {
            let c = null;
            s == Ga.eP_LEFT ? c = It.eOT_TEXTURED_LEFT_IMAGE : s == Ga.eP_RIGHT ? c = It.eOT_TEXTURED_RIGHT_IMAGE : s == Ga.eP_FRONT ? c = It.eOT_TEXTURED_FRONT_IMAGE : s == Ga.eP_TOP && (c = It.eOT_TEXTURED_TOP_IMAGE), console.log("onUploadFiles called from emit - image files: ", i, "cadType", c);
            const u = await vs(i, n.context, "Image 2D", !0, c ?? It.eOT_TEXTURED_FRONT_IMAGE);
            if (u) {
              const p = zn(n.context.getContextCAD().GetMainForm());
              if (!p) return;
              if (p.AddSTLObject(u.id), a.value) {
                const b = n.context.viewConfiguration.colorScheme.get(), f = await Zi(u, !0, b);
                a.value[s].items.push({ id: u.id, preview: f, selected: !0 });
              }
            }
          }
        }
      });
    };
    return (s, i) => a.value ? (O(), he(r(Ee), {
      key: 0,
      class: "flex-col w-full"
    }, {
      default: w(() => [
        y("div", HO, V(s.$t("implant-planner.smileSetup")), 1),
        y("div", YO, V(s.$t("implant-planner.clickOnEachIconToUploadTheCorrespondentDPicture")), 1),
        d(r(Ee), {
          class: "flex-row gap-2 mt-2",
          style: { "justify-content": "space-around" }
        }, {
          default: w(() => [
            (O(!0), J(ze, null, Rt(a.value, (c, u) => (O(), he(r(Ee), {
              key: u,
              class: "flex-col"
            }, {
              default: w(() => [
                y("div", KO, V(c.label), 1),
                d(r(Ee), { class: "flex-row justify-center" }, {
                  default: w(() => [
                    d(r(Ce), {
                      class: "mt-2",
                      dropdown: !!c.items.length,
                      disabled: !c.items.length,
                      "dropdown-location-top": !0,
                      togglable: !0,
                      toggled: c.items.findIndex((p) => p.selected) != -1,
                      "icon-src": `/cad/head/${c.iconSrc}.png`,
                      "icon-src-height": "50px",
                      "icon-src-width": "50px",
                      ignoreSvgFilter: !0,
                      style: { width: "66px", overflow: "visible" }
                    }, {
                      default: w(() => [
                        c.items.length ? (O(), J("div", ZO, [
                          (O(!0), J(ze, null, Rt(c.items, (p, b) => (O(), he(r(Ce), {
                            key: b,
                            "preview-src": p.preview,
                            togglable: !0,
                            toggled: p.selected,
                            "onUpdate:toggled": (f) => p.selected = f,
                            ignoreSvgFilter: !0,
                            iconSrcObjectFit: "contain",
                            iconSrcPadding: "5px",
                            style: { width: "66px", height: "66px", padding: "0" }
                          }, null, 8, ["preview-src", "toggled", "onUpdate:toggled"]))), 128))
                        ])) : ue("", !0)
                      ]),
                      _: 2
                    }, 1032, ["dropdown", "disabled", "toggled", "icon-src"])
                  ]),
                  _: 2
                }, 1024),
                d(r(Ee), { class: "flex-row justify-center" }, {
                  default: w(() => [
                    d(r(Ce), {
                      class: "mt-2 no-padding",
                      "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                      "icon-src-height": "28px",
                      "icon-src-width": "28px",
                      iconSrcPadding: "5px",
                      style: { width: "28px" },
                      onClick: (p) => l(u)
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : ue("", !0);
  }
}), XO = {
  class: "p-dialog-header text-4xl flex-col",
  style: { "justify-content": "center !important" }
}, qO = {
  class: /* @__PURE__ */ He("text-4xl bold flex mt-2")
}, QO = { class: "flex-col" }, eD = {
  class: /* @__PURE__ */ He("text-2xl bold flex mt-2")
}, tD = {
  class: /* @__PURE__ */ He("flex mt-2 text-lg")
}, nD = {
  class: "flex",
  style: { flex: "1 1 0" }
}, aD = {
  class: "flex mt-2",
  style: { flex: "2 1 0" }
}, oD = {
  class: "flex",
  style: { flex: "1 1 0" }
}, lD = {
  key: 0,
  class: /* @__PURE__ */ He("mt-2 flex"),
  style: { "align-items": "baseline" }
}, iD = { class: "col-4 no-padding" }, sD = {
  class: "col-2 no-padding flex justify-end",
  style: { "align-self": "center" }
}, rD = {
  class: "no-padding ml-2 grow",
  style: { overflow: "hidden" }
}, uD = {
  key: 0,
  class: /* @__PURE__ */ He("mt-2 flex"),
  style: { "align-items": "baseline" }
}, cD = { class: "col-4 no-padding" }, dD = {
  class: "col-2 no-padding flex justify-end",
  style: { "align-self": "center" }
}, pD = {
  class: "no-padding ml-2 grow",
  style: { overflow: "hidden" }
}, mD = /* @__PURE__ */ qe({
  __name: "ReconstructionSetupComponentRedesign",
  props: /* @__PURE__ */ xn({
    context: {},
    productionCenterList: {},
    isCADReconstruction: { type: Boolean }
  }, {
    setupParams: { required: !0 },
    setupParamsModifiers: {},
    smileSetupParams: { required: !0 },
    smileSetupParamsModifiers: {},
    productionSetupParams: { required: !0 },
    productionSetupParamsModifiers: {}
  }),
  emits: /* @__PURE__ */ xn(["confirm"], ["update:setupParams", "update:smileSetupParams", "update:productionSetupParams"]),
  setup(e, { emit: t }) {
    const { t: n } = Yt(), a = `${Hi},${wp}`, o = Aa(), l = e, s = Ln(e, "setupParams"), i = Ln(e, "smileSetupParams"), c = Ln(e, "productionSetupParams"), u = () => {
      o.open(If, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: { borderRadius: "16px" }
        },
        data: {
          context: l.context
        },
        emits: {
          onConfirm: (E, g, v, T) => {
            s.value.selectedTeethLibrary = E, s.value.selectedTeethLibraryModelName = g, s.value.selectedTeethLibraryGUID = v, s.value.selectedTeethLibraryPool = T;
          }
        }
      });
    }, p = l.context.settings.general.useUSStyleToothChart;
    function b(E) {
      return E === Jt.MANDIBLE ? ys(l.context.settings.general.useUSStyleToothChart) : _s(l.context.settings.general.useUSStyleToothChart);
    }
    function f(E, g) {
      if (!E) return null;
      const v = b(g)[E - 1];
      let T;
      return g == Jt.MAXILLA ? T = s.value.maxillaTeeth.find((R) => R.id === E) : g == Jt.MANDIBLE && (T = s.value.mandibleTeeth.find((R) => R.id === E)), !T || !v ? (console.warn("Tooth with id not found in reconstruction setup model", { id: E, jawboneType: g }), null) : { name: v, tooth: T };
    }
    let h = -1, I = -1;
    function m(E, g, v) {
      const T = f(E, v);
      if (T)
        if (g.shiftKey) {
          let R = -1, L = -1;
          v == Jt.MAXILLA ? (s.value.maxillaTeeth.forEach((C) => {
            C.status = pt.EMPTY, C.hoverIcon = Fn.ADD;
          }), R = Math.min(E, h), L = Math.max(E, h)) : v == Jt.MANDIBLE && (s.value.mandibleTeeth.forEach((C) => {
            C.status = pt.EMPTY, C.hoverIcon = Fn.ADD;
          }), R = Math.min(E, I), L = Math.max(E, I));
          for (let C = R; C <= L; C++) {
            const A = f(C, v);
            if (!A)
              return;
            A.tooth.status = pt.OK, A.tooth.hoverIcon = Fn.REMOVE;
          }
        } else
          T.tooth.hoverIcon === Fn.ADD ? (console.log("Add clicked", T), T.tooth.status = pt.OK, T.tooth.hoverIcon = Fn.REMOVE, v == Jt.MAXILLA ? h = E : v == Jt.MANDIBLE && (I = E)) : T.tooth.hoverIcon === Fn.REMOVE && (console.log("Remove clicked", T), T.tooth.status = pt.EMPTY, T.tooth.hoverIcon = Fn.ADD);
    }
    const S = (E) => {
      const g = () => {
        o.open(ql, {
          props: {
            closable: !0,
            modal: !0,
            header: n("shared.uploadFile"),
            contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" },
            style: { minWidth: "40vw" }
          },
          data: {
            dropArea: !0,
            selectFilesBtn: !0,
            selectFolderBtn: !0,
            accept: a,
            context: l.context,
            objectName: Pl.value[E],
            singleSelection: !0,
            showTypeColumn: !1,
            hideTreeWhenNoFolders: !0,
            showAccept: !0
          },
          emits: {
            onUploadFiles: async (v) => {
              console.log("onImportFromFile -> onUploadFiles: ", v);
              const T = await vs(v, l.context, Pl.value[E], !1, KL[E]);
              if (T) {
                const R = zn(l.context.getContextCAD().GetMainForm());
                if (!R) return;
                const L = R.AddSTLObject(T.id), C = zn(l.context.getContextCAD().GetXAddReconstructionObject());
                C.FillType(op[E]);
                const A = eu(C.GetObjectOptions(op[E]));
                s.value.dropdownItems[E].items = A, s.value.dropdownItems[E].selectedItem = A.find((j) => j.id === L) ?? A.find((j) => j.name === T.getGUIName()) ?? null;
              }
            }
          }
        });
      };
      l.isCADReconstruction ? o.open(Vf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("shared.import"),
          style: { width: "20vw" },
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        emits: {
          onImportFromFile: () => {
            console.log("onImportFromFile"), g();
          },
          onImportFromPlanner: async () => {
            console.log("onImportFromPlanner");
            const v = await l.context.getObjects().getObjectImportPreviewList();
            o.open(Rp, {
              props: {
                closable: !0,
                modal: !0,
                header: n("shared.uploadFile"),
                style: { width: "23rem" },
                contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
              },
              data: {
                importObjects: v
              },
              emits: {
                onProceedToImport: (T) => {
                  console.log("onImportFromPlanner -> onProceedToImport: ", T), console.log("Upload objet as type", E);
                }
              }
            });
          }
        }
      }) : g();
    };
    return (E, g) => {
      const v = Mu, T = JO, R = zO, L = FO;
      return O(), he(r(Ee), {
        class: "flex-col w-full h-full",
        style: { overflow: "hidden" }
      }, {
        default: w(() => [
          y("div", XO, [
            y("div", qO, V(E.$t("implant-planner.addNewReconstruction")), 1)
          ]),
          d(r(Ee), {
            class: "flex-row grow gap-2 mt-2",
            style: { "align-items": "center" }
          }, {
            default: w(() => [
              d(r(Ee), {
                class: "flex-col",
                style: { flex: "1 1 0" }
              }, {
                default: w(() => [
                  y("div", QO, [
                    y("div", eD, V(s.value.headerText), 1),
                    y("div", tD, V(s.value.instructionsText), 1)
                  ]),
                  d(r(Ee), { class: "flex-col mt-8" }, {
                    default: w(() => [
                      y("div", nD, [
                        y("span", null, V(E.$t("implant-planner.editreplaceTheName")), 1)
                      ]),
                      y("div", aD, [
                        d(v, {
                          class: "flex justify-end w-full",
                          modelValue: s.value.reconstructionName,
                          "onUpdate:modelValue": g[0] || (g[0] = (C) => s.value.reconstructionName = C)
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  s.value.selectTeethLibrary ? (O(), he(r(Ee), {
                    key: 0,
                    class: "flex-col mt-2"
                  }, {
                    default: w(() => [
                      y("div", oD, [
                        y("span", null, V(E.$t("implant-planner.selectTeethLibrary")), 1)
                      ]),
                      d(r(Ce), {
                        class: "flex mt-2",
                        label: s.value.selectedTeethLibrary,
                        onClick: u
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })) : ue("", !0),
                  i.value ? (O(), he(r(Ee), {
                    key: 1,
                    class: "flex-row mt-2",
                    style: { "border-top": "3px solid rgba(255, 255, 255, 0.02)" }
                  }, {
                    default: w(() => [
                      d(T, {
                        "setup-params": i.value,
                        "onUpdate:setupParams": g[1] || (g[1] = (C) => i.value = C),
                        context: e.context
                      }, null, 8, ["setup-params", "context"])
                    ]),
                    _: 1
                  })) : ue("", !0),
                  c.value ? (O(), he(r(Ee), {
                    key: 2,
                    class: "flex-row mt-6",
                    style: { "border-top": "3px solid rgba(255, 255, 255, 0.02)" }
                  }, {
                    default: w(() => [
                      d(R, {
                        "setup-params": c.value,
                        "onUpdate:setupParams": g[2] || (g[2] = (C) => c.value = C),
                        "production-center-list": e.productionCenterList
                      }, null, 8, ["setup-params", "production-center-list"])
                    ]),
                    _: 1
                  })) : ue("", !0)
                ]),
                _: 1
              }),
              d(r(Ee), {
                class: "",
                style: { flex: "1 1 0", "align-items": "center", "justify-content": "center", background: "rgba(255, 255, 255, 0.02)", "border-radius": "24px", padding: "32px 32px 32px 32px !important" }
              }, {
                default: w(() => [
                  d(r(Ee), { class: "flex-col" }, {
                    default: w(() => [
                      d(r(wr), {
                        class: "justify-center",
                        jawboneType: r(Jt).MAXILLA,
                        teeth: s.value.maxillaTeeth,
                        useUSStyleToothChart: r(p),
                        warningString: "",
                        "show-lines": !0,
                        onToothClick: m
                      }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart"]),
                      d(r(wr), {
                        class: "justify-center",
                        jawboneType: r(Jt).MANDIBLE,
                        teeth: s.value.mandibleTeeth,
                        useUSStyleToothChart: r(p),
                        warningString: "",
                        "show-lines": !0,
                        onToothClick: m
                      }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              d(r(Ee), {
                class: "flex-row grow",
                style: { flex: "1 1 0" }
              }, {
                default: w(() => [
                  d(r(Ee), {
                    class: "flex-col ml-2 h-full w-full",
                    style: { flex: "2 1 0" }
                  }, {
                    default: w(() => [
                      d(r(Ee), {
                        class: "flex-col justify-end",
                        style: { flex: "1 1 0", padding: "16px 0 16px 0" }
                      }, {
                        default: w(() => [
                          (O(!0), J(ze, null, Rt(s.value.dropdownItems, (C, A) => (O(), J(ze, { key: A }, [
                            C.visible && A < r(Qe).eDI_MODEL ? (O(), J("div", lD, [
                              y("div", iD, [
                                y("span", null, V(r(Pl)[A]), 1)
                              ]),
                              y("div", sD, [
                                C.showImportBtn ? (O(), he(r(Ce), {
                                  key: 0,
                                  class: He("no-padding"),
                                  "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                                  iconSrcPadding: "5px",
                                  onClick: (j) => S(A)
                                }, null, 8, ["onClick"])) : ue("", !0)
                              ]),
                              y("div", rD, [
                                d(r(Pn), {
                                  modelValue: C.selectedItem,
                                  "onUpdate:modelValue": (j) => C.selectedItem = j,
                                  options: C.items,
                                  class: "w-full",
                                  dataKey: "id",
                                  optionLabel: "name",
                                  placeholder: E.$t("implant-planner.none"),
                                  showClear: !0
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                              ])
                            ])) : ue("", !0)
                          ], 64))), 128))
                        ]),
                        _: 1
                      }),
                      d(r(Ee), {
                        class: "flex-col",
                        style: { flex: "1 1 0", padding: "16px 0 16px 0" }
                      }, {
                        default: w(() => [
                          (O(!0), J(ze, null, Rt(s.value.dropdownItems, (C, A) => (O(), J(ze, { key: A }, [
                            C.visible && A >= r(Qe).eDI_MODEL && A < r(Qe).eDI_UPPER_GENERIC ? (O(), J("div", uD, [
                              y("div", cD, [
                                y("span", null, V(r(Pl)[A]), 1)
                              ]),
                              y("div", dD, [
                                C.showImportBtn ? (O(), he(r(Ce), {
                                  key: 0,
                                  class: He("no-padding"),
                                  "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                                  iconSrcPadding: "5px",
                                  onClick: (j) => S(A)
                                }, null, 8, ["onClick"])) : ue("", !0)
                              ]),
                              y("div", pD, [
                                d(r(Pn), {
                                  modelValue: C.selectedItem,
                                  "onUpdate:modelValue": (j) => C.selectedItem = j,
                                  options: C.items,
                                  class: "w-full",
                                  dataKey: "id",
                                  optionLabel: "name",
                                  placeholder: E.$t("implant-planner.none"),
                                  showClear: !0
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                              ])
                            ])) : ue("", !0)
                          ], 64))), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  s.value.dropdownItems[r(Qe).eDI_LOWER_GENERIC].visible || s.value.dropdownItems[r(Qe).eDI_UPPER_GENERIC].visible ? (O(), he(r(Ee), {
                    key: 0,
                    class: "grow flex-col justify-center ml-4 w-full",
                    style: { flex: "1 1 0" }
                  }, {
                    default: w(() => [
                      (O(!0), J(ze, null, Rt([r(Qe).eDI_UPPER_GENERIC, r(Qe).eDI_LOWER_GENERIC], (C, A) => (O(), J(ze, { key: A }, [
                        d(r(Ee), {
                          class: He([C == r(Qe).eDI_UPPER_GENERIC ? "justify-end" : "", "flex-col mt-12"]),
                          style: { "flex-grow": "2" }
                        }, {
                          default: w(() => [
                            s.value.dropdownItems[C].visible ? (O(), J(ze, { key: 0 }, [
                              d(r(Ee), { class: "flex-row" }, {
                                default: w(() => [
                                  d(r(Ee), {
                                    class: "no-padding grow",
                                    style: { "align-self": "center" }
                                  }, {
                                    default: w(() => [
                                      y("span", null, V(r(Pl)[C]), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  d(r(Ee), {
                                    class: "no-padding grow-0 justify-end",
                                    style: { "align-self": "center" }
                                  }, {
                                    default: w(() => [
                                      s.value.dropdownItems[C].showImportBtn ? (O(), he(r(Ce), {
                                        key: 0,
                                        class: He("no-padding"),
                                        "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                                        iconSrcPadding: "5px",
                                        onClick: (j) => S(A)
                                      }, null, 8, ["onClick"])) : ue("", !0)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              d(L, {
                                class: "mt-2",
                                style: { "min-height": "80px" },
                                modelValue: s.value.dropdownItems[C].selectedItem,
                                "onUpdate:modelValue": (j) => s.value.dropdownItems[C].selectedItem = j,
                                options: s.value.dropdownItems[C].items,
                                dataKey: "id",
                                multiple: "",
                                optionLabel: "name"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                            ], 64)) : ue("", !0)
                          ]),
                          _: 2
                        }, 1032, ["class"]),
                        C == r(Qe).eDI_UPPER_GENERIC ? (O(), he(r(Ee), {
                          key: 0,
                          class: "grow"
                        })) : ue("", !0)
                      ], 64))), 128))
                    ]),
                    _: 1
                  })) : ue("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), Wf = /* @__PURE__ */ qe({
  __name: "ReconstructionSetupDialogRedesign",
  emits: ["confirm", "reject"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data;
    let o, l;
    const s = Jn(), i = Aa();
    let c = F(!1);
    Mt(async () => {
      o = a.context, l = [], a.preselectedMode != null && (a.preselectedMode == pa.eCREATE_WAXUP && (h(ve.eRD_DIGITAL_SMILE_DESIGN), await R(We.eWF_NONE, "")), a.preselectedMode == pa.eTMJ_DIAGNOSIS && (h(ve.eRD_TMJ_DIAGNOSIS), await R(We.eWF_NONE, ""))), c.value = !0;
    });
    const { t: u } = Yt(), p = t, b = F(null), f = F(null), h = (j) => {
      console.log("Selected type", j), b.value = j;
    }, I = () => {
      b.value = null, f.value = null;
    }, m = Te(() => c.value ? f.value != null ? 2 : b.value != null ? 1 : 0 : -1), S = Te(() => {
      if (m.value == 0 || a.preselectedMode != null)
        return u("shared.cancel");
      if (m.value == 1)
        return u("implant-planner.selectReconstructionType");
      if (m.value == 2)
        return u("implant-planner.selectWorkflow");
    }), E = Te(() => m.value == 2 ? u("shared.ok") : u("shared.next")), g = F({
      headerText: "",
      instructionsText: "",
      reconstructionName: "",
      selectTeethLibrary: !0,
      selectedTeethLibrary: "",
      selectedTeethLibraryModelName: "",
      selectedTeethLibraryGUID: "",
      selectedTeethLibraryPool: "",
      dropdownItems: {
        [Qe.eDI_MODEL_ANTAGONIST]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_GINGIVA_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_WAXUP_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MARKER_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_DENTURE_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_FACE_SCAN]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MODEL]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_GINGIVA]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_WAXUP]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_DENTURE]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_MOVEMENT_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_UPPER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [Qe.eDI_LOWER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] }
      },
      teethMapEnabled: !0,
      maxillaTeeth: [],
      mandibleTeeth: []
    }), v = F(null), T = F(null), R = async (j, N) => {
      if (console.log("Workflow Selected type", j), f.value = j, b.value != null && f.value != null) {
        const x = await xf(o, b.value, f.value, N, a.preselectedMode, a.preselectedWorkFlow, s);
        if (g.value = x.setupParams, x.smileParams && Am() ? (console.log("SmileParams", x.smileParams), v.value = await jf(o)) : v.value = null, x.productionParams) {
          const z = Ff(b.value, f.value, l);
          console.log("productionParams", z), T.value = {
            materialLibrary: {
              selectedItem: null,
              items: z
            },
            color: {
              selectedItem: null,
              items: []
            },
            presetLibrary: {
              selectedItem: null,
              items: []
            }
          };
        } else
          T.value = null;
      }
    }, L = () => {
      f.value = null;
    };
    ot(g.value.dropdownItems[Qe.eDI_MODEL], () => {
      console.log("setupParams.value.dropdownItems[TDropdownItem.eDI_MODEL] changed", g.value.dropdownItems[Qe.eDI_MODEL]);
    }), ot(
      g,
      () => {
        console.log("SetupParams changed", g);
      },
      { deep: !0 }
    ), ot(
      v,
      () => {
        console.log("smileParams changed", v);
      },
      { deep: !0 }
    ), ot(
      T,
      () => {
        console.log("productionParams changed", T);
      },
      { deep: !0 }
    );
    const C = async () => {
      o.freezeWizardPanel(!0), console.log("ReconstructionDialog proceed 0");
      const j = zn(o.getContextCAD().GetXAddReconstructionObject());
      j.SetModeWorkflowName(b.value, f.value, g.value.reconstructionName);
      const N = (ne) => ne && !Array.isArray(ne) ? ne.id ?? -1 : -1, x = (ne, W) => {
        const se = g.value.dropdownItems[ne];
        j.SelectedSelectionChangedById(N(se.selectedItem), se.visible, W);
      }, z = (ne, W) => {
        const se = g.value.dropdownItems[ne], be = se.selectedItem ? Array.isArray(se.selectedItem) ? se.selectedItem : [se.selectedItem] : [], Re = new o.module.VectorInt();
        for (const U of be)
          U.id != null && Re.push_back(U.id);
        j.SelectedGenericSelectionChangedByIds(Re, se.visible, W), Re.delete();
      };
      if (x(Qe.eDI_MODEL_ANTAGONIST, ut.eANTAGONIST), x(Qe.eDI_GINGIVA_ANTAGONIST, ut.eGINGIVA_ANTAGONIST), x(Qe.eDI_WAXUP_ANTAGONIST, ut.eWAXUP_ANTAGONIST), x(Qe.eDI_MARKER_ANTAGONIST, ut.eMARKER_ANTAGONIST), x(Qe.eDI_DENTURE_ANTAGONIST, ut.eDENTURE_ANTAGONIST), x(Qe.eDI_FACE_SCAN, ut.eFACE_SCAN), x(Qe.eDI_MODEL, ut.eMODEL), x(Qe.eDI_GINGIVA, ut.eGINGIVA), x(Qe.eDI_WAXUP, ut.eWAXUP), x(Qe.eDI_MARKER, ut.eMARKER), x(Qe.eDI_DENTURE, ut.eDENTURE), x(Qe.eDI_MOVEMENT_MARKER, ut.eMOVEMENT_MARKER), z(Qe.eDI_UPPER_GENERIC, ut.eGENERIC_UPPER), z(Qe.eDI_LOWER_GENERIC, ut.eGENERIC_LOWER), v.value) {
        let ne = new o.module.VectorString();
        for (let W of v.value[Ga.eP_FRONT].items)
          W.selected && ne.push_back(W.id.toString());
        j.SetSelected2DImage(It.eOT_TEXTURED_FRONT_IMAGE, ne), ne.delete(), ne = new o.module.VectorString();
        for (let W of v.value[Ga.eP_RIGHT].items)
          W.selected && ne.push_back(W.id.toString());
        j.SetSelected2DImage(It.eOT_TEXTURED_RIGHT_IMAGE, ne), ne.delete(), ne = new o.module.VectorString();
        for (let W of v.value[Ga.eP_LEFT].items)
          W.selected && ne.push_back(W.id.toString());
        j.SetSelected2DImage(It.eOT_TEXTURED_LEFT_IMAGE, ne), ne.delete(), ne = new o.module.VectorString();
        for (let W of v.value[Ga.eP_TOP].items)
          W.selected && ne.push_back(W.id.toString());
        j.SetSelected2DImage(It.eOT_TEXTURED_TOP_IMAGE, ne), ne.delete();
      }
      const X = new o.module.VectorString();
      for (const ne of g.value.mandibleTeeth)
        ne.status != pt.EMPTY && X.push_back(ne.toothName);
      for (const ne of g.value.maxillaTeeth)
        ne.status != pt.EMPTY && X.push_back(ne.toothName);
      j.SetTeethList(X), X.delete(), await uu(
        s,
        o,
        g.value.selectedTeethLibraryModelName,
        g.value.selectedTeethLibraryGUID,
        g.value.selectedTeethLibraryPool
      ), j.SetSelectedLibrary(g.value.selectedTeethLibraryModelName, g.value.selectedTeethLibraryGUID);
      const H = (ne) => {
        o.freezeWizardPanel(!1);
        let W = !0;
        return i.open($i, {
          props: {
            closable: !1,
            draggable: !1,
            modal: !0,
            header: ne.GetLabel(),
            style: { width: "25vw" }
          },
          data: {
            message: ne.GetMessage(),
            showCancel: ne.GetShowCancel(),
            showYesNo: ne.GetYesNo()
          },
          emits: {
            onConfirm: () => {
              console.log("confirmed"), W = !0;
            },
            onReject: () => {
              console.log("rejected"), W = !1;
            }
          }
        }), W;
      };
      console.log("ReconstructionDialog proceed 3");
      const M = j.ValidateAndAddReconstruction(), te = () => {
        const ne = j.ValidateAndAddReconstruction2();
        ne.GetInitialized() && H(ne);
      };
      if (console.log("ReconstructionDialog proceed 4", M.GetInitialized()), M.GetInitialized()) {
        const ne = H(M);
        M.GetYesNo() && ne && te();
        return;
      }
      o.getContextCAD().DeleteAddReconstructionObject(), o.freezeWizardPanel(!1), p("confirm"), n.value.close();
    }, A = () => {
      if (a.preselectedMode == null) {
        if (m.value == 2) {
          L();
          return;
        } else if (m.value == 1) {
          I();
          return;
        }
      }
      o.getContextCAD().DeleteAddReconstructionObject(), p("reject"), n.value.close();
    };
    return (j, N) => r(c) ? (O(), he(r(Ee), {
      key: 0,
      class: "flex-col",
      style: { overflow: "auto", "max-width": "70vw", "min-width": "60vw" }
    }, {
      default: w(() => [
        d(r(Ee), { class: "flex-row h-full mb-2" }, {
          default: w(() => [
            r(m) == 0 ? (O(), he($f, {
              key: 0,
              class: "horizontal-padding",
              context: r(o),
              "preselected-type": r(a).preselectedMode,
              onTypeSelected: h,
              onModifyType: I,
              style: { flex: "1 1 0" }
            }, null, 8, ["context", "preselected-type"])) : ue("", !0),
            r(m) == 1 ? (O(), J(ze, { key: 1 }, [
              r(b) != null ? (O(), he(kf, {
                key: 0,
                class: "horizontal-padding",
                context: r(o),
                reconstructionType: r(b),
                onWorkflowSelected: R,
                onModifyWorkflow: L,
                style: { flex: "1 1 0" }
              }, null, 8, ["context", "reconstructionType"])) : ue("", !0)
            ], 64)) : ue("", !0),
            r(m) == 2 ? (O(), J(ze, { key: 2 }, [
              r(f) != null || r(a).preselectedMode != null ? (O(), he(mD, {
                key: 0,
                class: "horizontal-padding",
                context: r(o),
                "production-center-list": r(l),
                isCADReconstruction: r(a).preselectedMode == null,
                "setup-params": r(g),
                "onUpdate:setupParams": N[0] || (N[0] = (x) => za(g) ? g.value = x : null),
                "smile-setup-params": r(v),
                "onUpdate:smileSetupParams": N[1] || (N[1] = (x) => za(v) ? v.value = x : null),
                "production-setup-params": r(T),
                "onUpdate:productionSetupParams": N[2] || (N[2] = (x) => za(T) ? T.value = x : null),
                style: { flex: "2 1 0" }
              }, null, 8, ["context", "production-center-list", "isCADReconstruction", "setup-params", "smile-setup-params", "production-setup-params"])) : ue("", !0)
            ], 64)) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(Ee), { class: "p-dialog-footer justify-center" }, {
          default: w(() => [
            d(r(ya), {
              class: "mt-6",
              label: r(S),
              onClick: N[3] || (N[3] = (x) => A())
            }, null, 8, ["label"]),
            d(r(la), {
              disabled: r(b) == null || r(f) == null,
              class: "mt-6",
              label: r(E),
              onClick: C
            }, null, 8, ["disabled", "label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : ue("", !0);
  }
}), fD = {
  class: "text-xl mb-6",
  style: { "border-bottom": "1px solid" }
}, gD = { for: "patientName" }, hD = { for: "dateOfBirth" }, bD = { for: "clinician" }, vD = { for: "drugTherapies" }, yD = { for: "generalHealthStatus" }, _D = {
  class: "text-xl mb-6",
  style: { "border-bottom": "1px solid" }
}, wD = { for: "examDate" }, SD = { for: "images" }, ID = { for: "sliceThickness" }, ED = { for: "description" }, TD = { for: "projectName" }, CD = { for: "lastModified" }, ND = {
  class: "text-xl mt-2 mb-2",
  style: { "border-bottom": "1px solid" }
}, LD = { style: { flex: "1 1 100px" } }, OD = { style: { flex: "1 1 100px" } }, DD = { style: { flex: "1 1 100px" } }, AD = { style: { flex: "1 1 100px" } }, RD = { class: "flex" }, MD = /* @__PURE__ */ qe({
  __name: "ReportSettingsGeneralTab",
  props: {
    dataObject: { required: !0 },
    dataObjectModifiers: {}
  },
  emits: ["update:dataObject"],
  setup(e) {
    const { t } = Yt(), n = Ln(e, "dataObject");
    return (a, o) => (O(), he(r(Ee), { style: { "flex-direction": "column" } }, {
      default: w(() => [
        d(r(Ee), {
          class: "gap-4",
          style: { "flex-direction": "row" }
        }, {
          default: w(() => [
            d(r(Ee), {
              class: "gap-2",
              style: { "flex-direction": "column", flex: "1 1 0" }
            }, {
              default: w(() => [
                y("span", fD, V(a.$t("medic-web-engine.patientInformation")), 1),
                d(r(at), { class: "gap-8" }, {
                  default: w(() => [
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "patientName",
                          class: "w-full",
                          modelValue: n.value.name,
                          "onUpdate:modelValue": o[0] || (o[0] = (l) => n.value.name = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", gD, V(a.$t("medic-web-engine.name")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(Js), {
                          id: "dateOfBirth",
                          dateFormat: "yy-mm-dd",
                          class: "w-full",
                          modelValue: n.value.dateOfBirth,
                          "onUpdate:modelValue": o[1] || (o[1] = (l) => n.value.dateOfBirth = l)
                        }, null, 8, ["modelValue"]),
                        y("label", hD, V(a.$t("medic-web-engine.dateOfBirth")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "clinician",
                          class: "w-full",
                          modelValue: n.value.clinician,
                          "onUpdate:modelValue": o[2] || (o[2] = (l) => n.value.clinician = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", bD, V(a.$t("medic-web-engine.clinician")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "drugTherapies",
                          class: "w-full",
                          modelValue: n.value.drugTherapies,
                          "onUpdate:modelValue": o[3] || (o[3] = (l) => n.value.drugTherapies = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", vD, V(a.$t("medic-web-engine.drugTherapies")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "generalHealthStatus",
                          class: "w-full",
                          modelValue: n.value.generalHealthStatus,
                          "onUpdate:modelValue": o[4] || (o[4] = (l) => n.value.generalHealthStatus = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", yD, V(a.$t("medic-web-engine.generalHealthStatus")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Ee), { style: { "flex-direction": "column", flex: "1 1 0" } }, {
              default: w(() => [
                y("span", _D, V(a.$t("medic-web-engine.examInformation")), 1),
                d(r(at), { class: "gap-8" }, {
                  default: w(() => [
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(Js), {
                          id: "examDate",
                          dateFormat: "yy-mm-dd",
                          class: "w-full",
                          modelValue: n.value.examDate,
                          "onUpdate:modelValue": o[5] || (o[5] = (l) => n.value.examDate = l)
                        }, null, 8, ["modelValue"]),
                        y("label", wD, V(a.$t("medic-web-engine.examDate")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "images",
                          class: "w-full",
                          modelValue: n.value.images,
                          "onUpdate:modelValue": o[6] || (o[6] = (l) => n.value.images = l),
                          type: "number"
                        }, null, 8, ["modelValue"]),
                        y("label", SD, V(a.$t("medic-web-engine.images")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "sliceThickness",
                          class: "w-full",
                          modelValue: n.value.sliceThickness,
                          "onUpdate:modelValue": o[7] || (o[7] = (l) => n.value.sliceThickness = l),
                          type: "number",
                          step: "0.1"
                        }, null, 8, ["modelValue"]),
                        y("label", ID, V(a.$t("medic-web-engine.sliceThickness")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "description",
                          class: "w-full",
                          modelValue: n.value.description,
                          "onUpdate:modelValue": o[8] || (o[8] = (l) => n.value.description = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", ED, V(a.$t("medic-web-engine.description")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(ca), {
                          id: "projectName",
                          class: "w-full",
                          modelValue: n.value.projectName,
                          "onUpdate:modelValue": o[9] || (o[9] = (l) => n.value.projectName = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", TD, V(a.$t("medic-web-engine.projectName")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(Qn), { class: "w-full" }, {
                      default: w(() => [
                        d(r(Js), {
                          id: "lastModified",
                          dateFormat: "yy-mm-dd",
                          class: "w-full",
                          modelValue: n.value.lastModified,
                          "onUpdate:modelValue": o[10] || (o[10] = (l) => n.value.lastModified = l)
                        }, null, 8, ["modelValue"]),
                        y("label", CD, V(a.$t("medic-web-engine.lastModified")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(r(at), null, {
          default: w(() => [
            y("span", ND, V(a.$t("medic-web-engine.styleSettings")), 1),
            d(r(Ee), {
              class: "gap-2 mt-2",
              style: { "flex-direction": "column" }
            }, {
              default: w(() => [
                d(r(Ee), {
                  class: "gap-2",
                  style: { "flex-direction": "row", flex: "1 1 0", "align-items": "baseline" }
                }, {
                  default: w(() => [
                    d(r(Ee), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: w(() => [
                        y("span", LD, V(a.$t("medic-web-engine.backgroundColor3d")), 1),
                        d(r(Lc), {
                          modelValue: n.value.bgColor3d,
                          "onUpdate:modelValue": o[11] || (o[11] = (l) => n.value.bgColor3d = l),
                          style: { flex: "6 1 0" }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    d(r(Ee), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: w(() => [
                        y("span", OD, V(a.$t("medic-web-engine.template3d")), 1),
                        d(r(Pn), {
                          style: { flex: "6 1 0" },
                          modelValue: n.value.template3d,
                          "onUpdate:modelValue": o[12] || (o[12] = (l) => n.value.template3d = l),
                          options: ["X-Ray", "Bones", "Soft Tissues", "Teeth"]
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Ee), {
                  class: "gap-2",
                  style: { "flex-direction": "row", flex: "1 1 0", "align-items": "baseline" }
                }, {
                  default: w(() => [
                    d(r(Ee), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: w(() => [
                        y("span", DD, V(a.$t("medic-web-engine.fontColor")), 1),
                        d(r(Lc), {
                          style: { flex: "6 1 0" },
                          modelValue: n.value.fontColor,
                          "onUpdate:modelValue": o[13] || (o[13] = (l) => n.value.fontColor = l),
                          class: "grow"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    d(r(Ee), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: w(() => [
                        y("label", AD, V(a.$t("medic-web-engine.fontSize")), 1),
                        d(r(xp), {
                          style: { flex: "6 1 0" },
                          modelValue: n.value.fontSize,
                          "onUpdate:modelValue": o[14] || (o[14] = (l) => n.value.fontSize = l),
                          class: "grow",
                          min: 1,
                          max: 25,
                          useGrouping: !1
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Ee), {
              style: { "flex-direction": "column" },
              class: "gap-2 mt-2"
            }, {
              default: w(() => [
                d(r(Ee), {
                  class: "gap-2 mt-1 mb-1",
                  style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline" }
                }, {
                  default: w(() => [
                    y("span", RD, V(a.$t("medic-web-engine.showCollisionWarnings")), 1),
                    d(r(db), {
                      class: "flex ml-2 mt-1 mb-1",
                      modelValue: n.value.showCollisionWarnings,
                      "onUpdate:modelValue": o[15] || (o[15] = (l) => n.value.showCollisionWarnings = l),
                      binary: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), PD = {
  name: "BaseFloatLabel",
  extends: Ja,
  props: {
    variant: {
      type: String,
      default: "over"
    }
  },
  style: pb,
  provide() {
    return {
      $pcFloatLabel: this,
      $parentInstance: this
    };
  }
}, xD = {
  name: "FloatLabel",
  extends: PD,
  inheritAttrs: !1
};
function jD(e, t, n, a, o, l) {
  return O(), J("span", Pe({
    class: e.cx("root")
  }, e.ptmi("root")), [
    St(e.$slots, "default")
  ], 16);
}
const FD = /* @__PURE__ */ $t(xD, [["render", jD]]), $D = { for: "implantsType" }, kD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, VD = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, BD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, UD = {
  for: "immediateLoadingYes",
  style: { margin: "0" }
}, GD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, WD = {
  for: "immediateLoadingNo",
  style: { margin: "0" }
}, zD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, HD = {
  for: "immediateLoadingEval",
  style: { margin: "0" }
}, YD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, KD = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, ZD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, JD = {
  for: "guideTeeth",
  style: { margin: "0" }
}, XD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, qD = {
  for: "guideSoft",
  style: { margin: "0" }
}, QD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, eA = {
  for: "guideBone",
  style: { margin: "0" }
}, tA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, nA = {
  for: "guideCustom",
  style: { margin: "0" }
}, aA = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, oA = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, lA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, iA = {
  for: "fixPins",
  style: { margin: "0" }
}, sA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, rA = {
  for: "fixScrews",
  style: { margin: "0" }
}, uA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, cA = {
  for: "fixOther",
  style: { margin: "0" }
}, dA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, pA = {
  for: "fixNone",
  style: { margin: "0" }
}, mA = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, fA = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, gA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, hA = {
  for: "densityMapYes",
  style: { margin: "0" }
}, bA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, vA = {
  for: "densityMapNo",
  style: { margin: "0" }
}, yA = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, _A = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, wA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, SA = {
  for: "boneRegenYes",
  style: { margin: "0" }
}, IA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, EA = {
  for: "boneRegenNo",
  style: { margin: "0" }
}, TA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, CA = {
  for: "boneRegenEval",
  style: { margin: "0" }
}, NA = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, LA = { style: { display: "flex", "flex-direction": "row", gap: "8px", flex: "1" } }, OA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, DA = {
  for: "flaplessYes",
  style: { margin: "0" }
}, AA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, RA = {
  for: "flaplessNo",
  style: { margin: "0" }
}, MA = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, PA = { style: { display: "flex", "flex-direction": "row", gap: "8px", flex: "1" } }, xA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, jA = {
  for: "sinusYes",
  style: { margin: "0" }
}, FA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, $A = {
  for: "sinusNo",
  style: { margin: "0" }
}, kA = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, VA = { style: { display: "flex", "flex-direction": "row", gap: "8px", flex: "1" } }, BA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, UA = {
  for: "nasalYes",
  style: { margin: "0" }
}, GA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, WA = {
  for: "nasalNo",
  style: { margin: "0" }
}, zA = { for: "generalNotes" }, HA = /* @__PURE__ */ qe({
  __name: "ReportSettingsPlanningTab",
  props: {
    dataObject: { required: !0 },
    dataObjectModifiers: {}
  },
  emits: ["update:dataObject"],
  setup(e) {
    const { t } = Yt(), n = Ln(e, "dataObject");
    return (a, o) => {
      const l = FD;
      return O(), he(r(Ee), { style: { "flex-direction": "column", flex: "1 1 0" } }, {
        default: w(() => [
          d(l, { style: { width: "100%", "margin-bottom": "16px", "margin-top": "24px" } }, {
            default: w(() => [
              d(r(ca), {
                id: "implantsType",
                style: { width: "100%" },
                modelValue: n.value.implantsType,
                "onUpdate:modelValue": o[0] || (o[0] = (s) => n.value.implantsType = s),
                type: "text"
              }, null, 8, ["modelValue"]),
              y("label", $D, V(r(t)("medic-web-engine.implantsType")), 1)
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => {
              var s;
              return [
                y("span", null, V(r(t)("medic-web-engine.numberOfImplants", { count: ((s = n.value) == null ? void 0 : s.numberOfImplants) || 0 })), 1)
              ];
            }),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", kD, V(r(t)("medic-web-engine.immediateLoading")), 1),
              y("div", VD, [
                y("div", BD, [
                  d(r(tn), {
                    modelValue: n.value.immediateLoading,
                    "onUpdate:modelValue": o[1] || (o[1] = (s) => n.value.immediateLoading = s),
                    inputId: "immediateLoadingYes",
                    value: "yes"
                  }, null, 8, ["modelValue"]),
                  y("label", UD, V(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", GD, [
                  d(r(tn), {
                    modelValue: n.value.immediateLoading,
                    "onUpdate:modelValue": o[2] || (o[2] = (s) => n.value.immediateLoading = s),
                    inputId: "immediateLoadingNo",
                    value: "no"
                  }, null, 8, ["modelValue"]),
                  y("label", WD, V(r(t)("medic-web-framework.no")), 1)
                ]),
                y("div", zD, [
                  d(r(tn), {
                    modelValue: n.value.immediateLoading,
                    "onUpdate:modelValue": o[3] || (o[3] = (s) => n.value.immediateLoading = s),
                    inputId: "immediateLoadingEval",
                    value: "evaluate"
                  }, null, 8, ["modelValue"]),
                  y("label", HD, V(r(t)("medic-web-engine.toBeEvaluatedDuringSurgery")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", YD, V(r(t)("medic-web-engine.typeOfGuide")), 1),
              y("div", KD, [
                y("div", ZD, [
                  d(r(tn), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[4] || (o[4] = (s) => n.value.guideType = s),
                    inputId: "guideTeeth",
                    value: r(t)("medic-web-engine.teethSupported")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", JD, V(r(t)("medic-web-engine.teethSupported")), 1)
                ]),
                y("div", XD, [
                  d(r(tn), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[5] || (o[5] = (s) => n.value.guideType = s),
                    inputId: "guideSoft",
                    value: r(t)("medic-web-engine.softTissuesSupported")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", qD, V(r(t)("medic-web-engine.softTissuesSupported")), 1)
                ]),
                y("div", QD, [
                  d(r(tn), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[6] || (o[6] = (s) => n.value.guideType = s),
                    inputId: "guideBone",
                    value: r(t)("medic-web-engine.boneSupported")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", eA, V(r(t)("medic-web-engine.boneSupported")), 1)
                ]),
                y("div", tA, [
                  d(r(tn), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[7] || (o[7] = (s) => n.value.guideType = s),
                    inputId: "guideCustom",
                    value: r(t)("medic-web-engine.custom")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", nA, V(r(t)("medic-web-engine.custom")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", aA, V(r(t)("medic-web-engine.typeOfFixation")), 1),
              y("div", oA, [
                y("div", lA, [
                  d(r(tn), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[8] || (o[8] = (s) => n.value.fixationType = s),
                    inputId: "fixPins",
                    value: r(t)("medic-web-engine.fixationPins")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", iA, V(r(t)("medic-web-engine.fixationPins")), 1)
                ]),
                y("div", sA, [
                  d(r(tn), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[9] || (o[9] = (s) => n.value.fixationType = s),
                    inputId: "fixScrews",
                    value: r(t)("medic-web-engine.fixationScrews")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", rA, V(r(t)("medic-web-engine.fixationScrews")), 1)
                ]),
                y("div", uA, [
                  d(r(tn), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[10] || (o[10] = (s) => n.value.fixationType = s),
                    inputId: "fixOther",
                    value: r(t)("medic-web-engine.other")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", cA, V(r(t)("medic-web-engine.other")), 1)
                ]),
                y("div", dA, [
                  d(r(tn), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[11] || (o[11] = (s) => n.value.fixationType = s),
                    inputId: "fixNone",
                    value: r(t)("medic-web-engine.none")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", pA, V(r(t)("medic-web-engine.none")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", mA, V(r(t)("medic-web-engine.showDensityBoneMap")), 1),
              y("div", fA, [
                y("div", gA, [
                  d(r(tn), {
                    modelValue: n.value.showDensityBoneMap,
                    "onUpdate:modelValue": o[12] || (o[12] = (s) => n.value.showDensityBoneMap = s),
                    inputId: "densityMapYes",
                    value: "inside"
                  }, null, 8, ["modelValue"]),
                  y("label", hA, V(r(t)("medic-web-engine.showDensityBoneMap")), 1)
                ]),
                y("div", bA, [
                  d(r(tn), {
                    modelValue: n.value.showDensityBoneMap,
                    "onUpdate:modelValue": o[13] || (o[13] = (s) => n.value.showDensityBoneMap = s),
                    inputId: "densityMapNo",
                    value: "outside"
                  }, null, 8, ["modelValue"]),
                  y("label", vA, V(r(t)("medic-web-engine.boneDensityOutsideVolume")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", yA, V(r(t)("medic-web-engine.boneRegeneration")), 1),
              y("div", _A, [
                y("div", wA, [
                  d(r(tn), {
                    modelValue: n.value.boneRegeneration,
                    "onUpdate:modelValue": o[14] || (o[14] = (s) => n.value.boneRegeneration = s),
                    inputId: "boneRegenYes",
                    value: "yes"
                  }, null, 8, ["modelValue"]),
                  y("label", SA, V(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", IA, [
                  d(r(tn), {
                    modelValue: n.value.boneRegeneration,
                    "onUpdate:modelValue": o[15] || (o[15] = (s) => n.value.boneRegeneration = s),
                    inputId: "boneRegenNo",
                    value: "no"
                  }, null, 8, ["modelValue"]),
                  y("label", EA, V(r(t)("medic-web-framework.no")), 1)
                ]),
                y("div", TA, [
                  d(r(tn), {
                    modelValue: n.value.boneRegeneration,
                    "onUpdate:modelValue": o[16] || (o[16] = (s) => n.value.boneRegeneration = s),
                    inputId: "boneRegenEval",
                    value: "evaluate"
                  }, null, 8, ["modelValue"]),
                  y("label", CA, V(r(t)("medic-web-engine.toBeEvaluatedDuringSurgery")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", NA, V(r(t)("medic-web-engine.flaplessSurgery")), 1),
              y("div", LA, [
                y("div", OA, [
                  d(r(tn), {
                    modelValue: n.value.flaplessSurgery,
                    "onUpdate:modelValue": o[17] || (o[17] = (s) => n.value.flaplessSurgery = s),
                    inputId: "flaplessYes",
                    value: "Yes"
                  }, null, 8, ["modelValue"]),
                  y("label", DA, V(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", AA, [
                  d(r(tn), {
                    modelValue: n.value.flaplessSurgery,
                    "onUpdate:modelValue": o[18] || (o[18] = (s) => n.value.flaplessSurgery = s),
                    inputId: "flaplessNo",
                    value: "No"
                  }, null, 8, ["modelValue"]),
                  y("label", RA, V(r(t)("medic-web-framework.no")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", MA, V(r(t)("medic-web-engine.addSinusGraftLift")), 1),
              y("div", PA, [
                y("div", xA, [
                  d(r(tn), {
                    modelValue: n.value.addSinusGraftLift,
                    "onUpdate:modelValue": o[19] || (o[19] = (s) => n.value.addSinusGraftLift = s),
                    inputId: "sinusYes",
                    value: "Yes"
                  }, null, 8, ["modelValue"]),
                  y("label", jA, V(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", FA, [
                  d(r(tn), {
                    modelValue: n.value.addSinusGraftLift,
                    "onUpdate:modelValue": o[20] || (o[20] = (s) => n.value.addSinusGraftLift = s),
                    inputId: "sinusNo",
                    value: "No"
                  }, null, 8, ["modelValue"]),
                  y("label", $A, V(r(t)("medic-web-framework.no")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: w(() => [
              y("label", kA, V(r(t)("medic-web-engine.addNasalGraftLift")), 1),
              y("div", VA, [
                y("div", BA, [
                  d(r(tn), {
                    modelValue: n.value.addNasalGraftLift,
                    "onUpdate:modelValue": o[21] || (o[21] = (s) => n.value.addNasalGraftLift = s),
                    inputId: "nasalYes",
                    value: "Yes"
                  }, null, 8, ["modelValue"]),
                  y("label", UA, V(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", GA, [
                  d(r(tn), {
                    modelValue: n.value.addNasalGraftLift,
                    "onUpdate:modelValue": o[22] || (o[22] = (s) => n.value.addNasalGraftLift = s),
                    inputId: "nasalNo",
                    value: "No"
                  }, null, 8, ["modelValue"]),
                  y("label", WA, V(r(t)("medic-web-framework.no")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(l, { style: { width: "100%", "margin-top": "24px", "margin-bottom": "16px" } }, {
            default: w(() => [
              d(r(mb), {
                id: "generalNotes",
                style: { width: "100%" },
                modelValue: n.value.generalNotes,
                "onUpdate:modelValue": o[23] || (o[23] = (s) => n.value.generalNotes = s),
                type: "text",
                rows: "4"
              }, null, 8, ["modelValue"]),
              y("label", zA, V(r(t)("medic-web-engine.generalNotes")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), YA = ["src"], KA = /* @__PURE__ */ qe({
  __name: "ReportSettingsLogoTab",
  props: {
    dataObject: { required: !0 },
    dataObjectModifiers: {}
  },
  emits: ["update:dataObject"],
  setup(e) {
    const t = Ln(e, "dataObject"), n = ia(), a = F(null), o = (i) => new Promise((c, u) => {
      const p = new FileReader();
      p.onload = () => {
        c(typeof p.result == "string" ? p.result : "");
      }, p.onerror = () => {
        u(p.error);
      }, p.readAsDataURL(i);
    });
    Mt(async () => {
      if (!(t.value.logoBase64.trim().length > 0))
        try {
          const i = await fetch(n.getAssetUrl("/img/implantReportLogo.png"));
          if (!i.ok)
            return;
          const c = await i.blob();
          t.value.logoBase64 = await o(c);
        } catch (i) {
          console.warn("Failed to load default report logo.", i);
        }
    });
    const l = () => {
      var i;
      (i = a.value) == null || i.click();
    }, s = (i) => {
      var b;
      const u = (b = i.target.files) == null ? void 0 : b[0];
      if (!u || !u.type.startsWith("image/"))
        return;
      const p = new FileReader();
      p.onload = () => {
        const f = typeof p.result == "string" ? p.result : "";
        t.value.logoBase64 = f;
      }, p.readAsDataURL(u);
    };
    return (i, c) => (O(), he(r(Ee), { class: "flex-col" }, {
      default: w(() => [
        d(r(Ee), { class: "mb-4" }, {
          default: w(() => [
            d(r(Ce), {
              class: "",
              label: "Change Logo Image",
              onClick: l
            }),
            y("input", {
              ref_key: "fileInput",
              ref: a,
              type: "file",
              accept: "image/png",
              class: "hidden",
              onChange: s
            }, null, 544)
          ]),
          _: 1
        }),
        d(r(Ee), { class: "mt-4" }, {
          default: w(() => [
            t.value.logoBase64.length ? (O(), J("img", {
              key: 0,
              src: t.value.logoBase64,
              alt: "Logo",
              width: "256",
              height: "256"
            }, null, 8, YA)) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), zf = /* @__PURE__ */ qe({
  __name: "ReportSettings",
  emits: ["ok", "close"],
  setup(e, { emit: t }) {
    var R, L, C, A;
    const n = Xn("dialogRef"), a = n.value.data, o = t, l = ["General", "Planning", "Logo"], s = F(l[0]), i = (j) => {
      if (!j)
        return null;
      const N = j instanceof Date ? j : new Date(j);
      return Number.isNaN(N.getTime()) ? null : N;
    }, c = (j) => {
      if (!/^\d{8}$/.test(j))
        return null;
      const N = Number(j.slice(0, 4)), x = Number(j.slice(4, 6)), z = Number(j.slice(6, 8));
      if (!Number.isFinite(N) || !Number.isFinite(x) || !Number.isFinite(z))
        return null;
      const X = new Date(N, x - 1, z);
      return X.getFullYear() !== N || X.getMonth() !== x - 1 || X.getDate() !== z ? null : X;
    }, u = (j) => {
      const N = j.trim(), x = [/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/, /^(\d{4})-(\d{1,2})-(\d{1,2})$/, /^(\d{4})(\d{2})(\d{2})$/];
      for (const z of x) {
        const X = N.match(z);
        if (!X)
          continue;
        const H = Number(X[1]), M = Number(X[2]), te = Number(X[3]);
        if (!Number.isFinite(H) || !Number.isFinite(M) || !Number.isFinite(te))
          continue;
        const ne = new Date(H, M - 1, te);
        if (ne.getFullYear() === H && ne.getMonth() === M - 1 && ne.getDate() === te)
          return ne;
      }
      return null;
    }, p = (j, N) => ((j || "").replace(/\r/g, "").split(`
`)[N] || "").trim(), b = (j) => {
      var x;
      const N = (((x = a.context.projectGeneralData) == null ? void 0 : x.dicomData) || "").replace(/\r/g, "").split(`
`);
      for (const z of N)
        if (z.startsWith(`${j}=`))
          return z.slice(j.length + 1).trim();
      return "";
    }, f = () => {
      for (const j of a.context.objects.implants.values())
        if (typeof j.getProjectImplantInfo == "function") {
          const N = j.getProjectImplantInfo();
          if (N != null && N.manufacturerName)
            return N.manufacturerName;
        }
      return "";
    }, h = () => {
      var x, z;
      const j = p((x = a.context.projectGeneralData) == null ? void 0 : x.patientData, 0);
      if (j)
        return j;
      const N = a.context.patientInfo;
      return N != null && N.patientName ? N.patientName : (z = N == null ? void 0 : N.extra) != null && z.patientName ? N.extra.patientName : N != null && N.firstName ? N.firstName : "";
    }, I = () => {
      var N;
      const j = p((N = a.context.projectGeneralData) == null ? void 0 : N.seriesData, 1);
      return j ? u(j) : null;
    }, m = () => {
      const j = a.context.getImageData().getDimensions(), N = Number(j == null ? void 0 : j[2]);
      return !Number.isFinite(N) || N <= 0 ? "" : String(Math.trunc(N));
    }, S = () => {
      const j = a.context.getImageData().getSpacing(), N = Number(j == null ? void 0 : j[2]);
      return !Number.isFinite(N) || N <= 0 ? "" : String(ki(N));
    }, E = () => {
      var N;
      const j = (((N = a.context.projectInfo) == null ? void 0 : N.projectFilename) || "").trim();
      return j ? j.replace(/\.zip$/i, "") : (a.context.projectName || "").trim().replace(/\.zip$/i, "");
    }, g = F({
      name: h(),
      dateOfBirth: c(p((R = a.context.projectGeneralData) == null ? void 0 : R.patientData, 2)) || i((L = a.context.patientInfo) == null ? void 0 : L.dateOfBirth),
      clinician: b("PATIENT_REF"),
      drugTherapies: "",
      generalHealthStatus: "",
      examDate: I(),
      images: m(),
      sliceThickness: S(),
      description: p((C = a.context.projectGeneralData) == null ? void 0 : C.seriesData, 0),
      projectName: E(),
      lastModified: i((A = a.context.projectInfo) == null ? void 0 : A.lastModified) || /* @__PURE__ */ new Date(),
      bgColor3d: "#000000",
      template3d: "Bones",
      fontColor: "#000000",
      fontSize: 10,
      zoom3d: !0,
      showCollisionWarnings: !0,
      implantsType: f(),
      numberOfImplants: a.context.objects.implants.size,
      immediateLoading: "yes",
      guideType: "Soft tissues supported",
      fixationType: "Fixation Pins",
      showDensityBoneMap: "inside",
      boneRegeneration: "no",
      flaplessSurgery: "Yes",
      addSinusGraftLift: "No",
      addNasalGraftLift: "No",
      generalNotes: "",
      notes: "",
      logoBase64: "",
      ww: 4e3,
      wl: 1e3
    }), v = () => {
      o("ok", g.value), n.value.close();
    }, T = () => {
      o("close"), n.value.close();
    };
    return (j, N) => (O(), he(r(Ee), {
      class: "flex-col",
      style: { overflow: "auto" }
    }, {
      default: w(() => [
        d(r(Be), { class: "mb-4 gap-2" }, {
          default: w(() => [
            (O(), J(ze, null, Rt(l, (x) => d(r(Ce), {
              style: { flex: "1 1 0" },
              key: x,
              label: x,
              toggled: x === s.value,
              onClick: (z) => s.value = x
            }, null, 8, ["label", "toggled", "onClick"])), 64))
          ]),
          _: 1
        }),
        d(r(Ee), { style: { "flex-grow": "1" } }, {
          default: w(() => [
            s.value === "General" ? (O(), he(MD, {
              key: 0,
              dataObject: g.value,
              "onUpdate:dataObject": N[0] || (N[0] = (x) => g.value = x),
              style: { flex: "1 1 0" }
            }, null, 8, ["dataObject"])) : ue("", !0),
            s.value === "Planning" ? (O(), he(HA, {
              key: 1,
              dataObject: g.value,
              "onUpdate:dataObject": N[1] || (N[1] = (x) => g.value = x),
              style: { flex: "1 1 0" }
            }, null, 8, ["dataObject"])) : ue("", !0),
            s.value === "Logo" ? (O(), he(KA, {
              key: 2,
              dataObject: g.value,
              "onUpdate:dataObject": N[2] || (N[2] = (x) => g.value = x),
              style: { flex: "1 1 0" }
            }, null, 8, ["dataObject"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(Ee), { class: "p-dialog-footer justify-center mt-8" }, {
          default: w(() => [
            d(r(la), {
              label: "OK",
              onClick: N[3] || (N[3] = (x) => v()),
              class: "mr-4"
            }),
            d(r(ya), {
              label: "Cancel",
              onClick: N[4] || (N[4] = (x) => T())
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), ZA = /* @__PURE__ */ qe({
  __name: "IPCadPlaygroundComponent",
  setup(e) {
    const t = pn();
    console.log("projectContext: ", t);
    const { t: n } = Yt(), a = Aa(), o = F(!0), l = F(!0), s = F(!0);
    let i;
    Mt(() => {
      i = pn();
    });
    const c = F(!0), u = () => {
      a.open(ql, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.universalUpload"),
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        data: {
          dropArea: !0,
          selectFilesBtn: !0,
          selectFolderBtn: !0,
          accept: oh + Ip + Hi,
          context: i
        },
        emits: {
          onUploadFiles: (g) => {
            console.log("onUploadFiles called from emit: ", g);
          }
        }
      });
    };
    let p = F([]);
    const b = async () => {
      p.value = await i.objects.getObjectImportPreviewList(), a.open(mL, {
        props: {
          modal: !0,
          header: n("implant-planner.importDObjects")
        },
        data: {
          importObjects: p.value
        },
        emits: {
          onProceedToImport: async (g) => {
            console.log("Proceed to import:", g), new Ph(i, xh.DEFAULT_RECONSTRUCTION).importObjects(g, i), i.sceneRepaint();
          }
        }
      });
    }, f = async () => {
      a.open(If, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: { borderRadius: "16px" }
        },
        data: {
          context: i
        },
        emits: {
          onConfirm: (g, v, T, R) => {
            console.log("Proceed: ", g, v, T, R);
          }
        }
      });
    }, h = async () => {
      a.open(vO, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: {
            borderRadius: "16px",
            padding: "0 1.5rem",
            overflow: "hidden"
          }
        },
        data: {
          context: i
        },
        emits: {
          onConfirm: () => {
            console.log("Proceed");
          }
        }
      });
    }, I = async () => {
      a.open(Wf, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: {
            borderRadius: "16px",
            padding: "0 1.5rem",
            overflow: "hidden"
          }
        },
        data: {
          context: i
        },
        emits: {
          onConfirm: () => {
            console.log("Proceed");
          }
        }
      });
    }, m = () => {
      console.log("IPTeethViewDialog project context: ", t), a.open(SO, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.teethView"),
          style: { width: "80vw" }
        },
        data: {
          projectContext: t
        }
      });
    }, S = () => {
      a.open(Vf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("shared.import"),
          style: { width: "20vw" },
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        emits: {
          onImportFromFile: () => {
            console.log("onImportFromFile"), a.open(ql, {
              props: {
                closable: !0,
                modal: !0,
                header: n("shared.uploadFile"),
                contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
              },
              data: {
                dropArea: !0,
                selectFilesBtn: !0,
                selectFolderBtn: !0,
                accept: Hi
              },
              emits: {
                onUploadFiles: (g) => {
                  console.log("onImportFromFile -> onUploadFiles: ", g);
                }
              }
            });
          },
          onImportFromPlanner: async () => {
            console.log("onImportFromPlanner");
            const g = await i.getObjects().getObjectImportPreviewList();
            a.open(Rp, {
              props: {
                closable: !0,
                modal: !0,
                header: n("shared.uploadFile"),
                style: { width: "23rem" },
                contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
              },
              data: {
                importObjects: g
              },
              emits: {
                onProceedToImport: (v) => {
                  console.log("onImportFromPlanner -> onProceedToImport: ", v);
                }
              }
            });
          }
        }
      });
    }, E = () => {
      a.open(zf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.reportSettings"),
          style: { width: "900px", minHeight: "650px" },
          contentStyle: { borderRadius: "8px", background: "#0a7cc1" }
        },
        emits: {
          close: () => {
          }
        }
      });
    };
    return (g, v) => {
      const T = dL;
      return O(), J(ze, null, [
        y("span", null, V(g.$t("implant-planner.includeDemoComponents")), 1),
        o.value ? (O(), he(r(Ce), {
          key: 0,
          label: g.$t("implant-planner.universalFilePicker"),
          onClick: u,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        l.value ? (O(), he(T, {
          key: 1,
          label: g.$t("implant-planner.setactivereconstruction"),
          onClick: b,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        s.value ? (O(), he(T, {
          key: 2,
          label: g.$t("implant-planner.openTeethLibraryPreview"),
          onClick: f,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        c.value ? (O(), he(r(Ce), {
          key: 3,
          class: "mt-2",
          label: g.$t("implant-planner.showTeethViewDialog"),
          onClick: m
        }, null, 8, ["label"])) : ue("", !0),
        h ? (O(), he(T, {
          key: 4,
          label: g.$t("implant-planner.showReconstructionSetup"),
          onClick: h,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        I ? (O(), he(T, {
          key: 5,
          label: g.$t("implant-planner.showReconstructionSetupRedesign"),
          onClick: I,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        d(T, {
          label: g.$t("implant-planner.showImportFromDialog"),
          onClick: S,
          class: "mt-2"
        }, null, 8, ["label"]),
        d(r(Ce), {
          label: "Show Report Settings Dialog",
          onClick: E,
          class: "mt-2"
        })
      ], 64);
    };
  }
}), JA = {}, XA = { class: "card-wiz" }, qA = { class: "grid grid-cols-12 gap-4 grid-cols-12 gap-6" }, QA = { class: "text-2xl font-medium" }, e2 = { class: "card-wiz" }, t2 = { class: "grid grid-cols-12 gap-4 grid-cols-12 gap-6" }, n2 = { class: "text-1xl font-medium" };
function a2(e, t) {
  const n = ZA;
  return O(), J(ze, null, [
    y("div", XA, [
      y("div", qA, [
        y("span", QA, V(e.$t("implant-planner.cad")), 1)
      ])
    ]),
    y("div", e2, [
      y("div", t2, [
        y("span", n2, V(e.$t("implant-planner.demoComponents")), 1)
      ])
    ]),
    d(n)
  ], 64);
}
const Yu = /* @__PURE__ */ $t(JA, [["render", a2]]), o2 = {
  name: "BaseToolbar",
  extends: Ja,
  props: {
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: fb,
  provide() {
    return {
      $pcToolbar: this,
      $parentInstance: this
    };
  }
}, l2 = {
  name: "Toolbar",
  extends: o2,
  inheritAttrs: !1
}, i2 = ["aria-labelledby"];
function s2(e, t, n, a, o, l) {
  return O(), J("div", Pe({
    class: e.cx("root"),
    role: "toolbar",
    "aria-labelledby": e.ariaLabelledby
  }, e.ptmi("root")), [
    y("div", Pe({
      class: e.cx("start")
    }, e.ptm("start")), [
      St(e.$slots, "start")
    ], 16),
    y("div", Pe({
      class: e.cx("center")
    }, e.ptm("center")), [
      St(e.$slots, "center")
    ], 16),
    y("div", Pe({
      class: e.cx("end")
    }, e.ptm("end")), [
      St(e.$slots, "end")
    ], 16)
  ], 16, i2);
}
const r2 = /* @__PURE__ */ $t(l2, [["render", s2]]), Ku = /* @__PURE__ */ qe({
  __name: "IPAppMenuHorizontalContainer",
  setup(e) {
    return (t, n) => {
      const a = r2;
      return O(), he(a, {
        class: "bg-horizontalbar mb-2 ml-4 mr-3",
        style: { height: "4rem !important" }
      }, {
        start: w(() => [
          d(r(Ee), { class: "gap-8 align-center" }, {
            default: w(() => [
              St(t.$slots, "start")
            ]),
            _: 3
          })
        ]),
        _: 3
      });
    };
  }
}), u2 = { class: "layout-menuitem-icon" }, c2 = /* @__PURE__ */ qe({
  __name: "IPAppMenuHorizontalItem",
  props: {
    modelValue: {},
    index: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = F("selected-main-menu-horizontal"), l = F("selected-main-menu-text"), s = F("p-menuitem-icon"), i = Te(() => n.modelValue === n.index);
    Wa(() => {
      const p = n.modelValue === n.index;
      o.value = p ? "selected-main-menu-horizontal color-primary-var" : "", l.value = p ? "selected-main-menu-text" : "p-menuitem-text", s.value = p ? "selected-main-menu-icon" : "p-menuitem-icon", n.disabled && (o.value += " wizard-menu-item-disabled");
    });
    const c = () => {
      a("update:modelValue", n.index);
    }, u = Te(() => i.value ? "svg-icon-selected" : "svg-icon-color");
    return (p, b) => (O(), J("div", null, [
      y("li", {
        class: He([[o.value, n.index !== 0 ? "ml-5" : "", (i.value, "")], "layout-root-menuitem bg-horizontalbar-item-wiz"]),
        role: "menuitem"
      }, [
        y("a", {
          class: "p-ripple pointer flex align-center gap-2",
          href: "javascript:void(0)",
          role: "menuitem",
          onClick: c
        }, [
          y("i", u2, [
            d(r(su), {
              cIcon: n.index.toString(),
              isMenuIcon: !0,
              colorClass: u.value
            }, null, 8, ["cIcon", "colorClass"])
          ]),
          y("span", {
            class: He([i.value ? "color-primary-var " : ""])
          }, [
            St(p.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 2),
      i.value ? (O(), J("div", {
        key: 0,
        class: He([n.index !== 0 ? "ml-5" : "", i.value ? "mt-2" : "", "border-bottom-5 -mb-1"]),
        style: { height: "100%" }
      }, null, 2)) : ue("", !0)
    ]));
  }
}), Zu = /* @__PURE__ */ $t(c2, [["__scopeId", "data-v-0685d90d"]]), d2 = {
  name: "BaseSteps",
  extends: Ja,
  props: {
    id: {
      type: String
    },
    model: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: !0
    },
    activeStep: {
      type: Number,
      default: 0
    }
  },
  style: gb,
  provide() {
    return {
      $pcSteps: this,
      $parentInstance: this
    };
  }
}, p2 = {
  name: "Steps",
  extends: d2,
  inheritAttrs: !1,
  emits: ["update:activeStep", "step-change"],
  data() {
    return {
      d_activeStep: this.activeStep
    };
  },
  watch: {
    activeStep(e) {
      this.d_activeStep = e;
    }
  },
  mounted() {
    const e = this.findFirstItem();
    e && (e.tabIndex = "0");
  },
  methods: {
    getPTOptions(e, t, n) {
      return this.ptm(e, {
        context: {
          item: t,
          index: n,
          active: this.isActive(n),
          disabled: this.isItemDisabled(t, n)
        }
      });
    },
    onItemClick(e, t, n) {
      if (this.disabled(t) || this.readonly) {
        e.preventDefault();
        return;
      }
      t.command && t.command({
        originalEvent: e,
        item: t
      }), n !== this.d_activeStep && (this.d_activeStep = n, this.$emit("update:activeStep", this.d_activeStep)), this.$emit("step-change", {
        originalEvent: e,
        index: n
      });
    },
    onItemKeydown(e, t) {
      switch (e.code) {
        case "ArrowRight": {
          this.navigateToNextItem(e.target), e.preventDefault();
          break;
        }
        case "ArrowLeft": {
          this.navigateToPrevItem(e.target), e.preventDefault();
          break;
        }
        case "Home": {
          this.navigateToFirstItem(e.target), e.preventDefault();
          break;
        }
        case "End": {
          this.navigateToLastItem(e.target), e.preventDefault();
          break;
        }
        case "Tab":
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onItemClick(e, t), e.preventDefault();
          break;
        }
      }
    },
    navigateToNextItem(e) {
      const t = this.findNextItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    navigateToPrevItem(e) {
      const t = this.findPrevItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    navigateToFirstItem(e) {
      const t = this.findFirstItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    navigateToLastItem(e) {
      const t = this.findLastItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    findNextItem(e) {
      const t = e.parentElement.nextElementSibling;
      return t ? t.children[0] : null;
    },
    findPrevItem(e) {
      const t = e.parentElement.previousElementSibling;
      return t ? t.children[0] : null;
    },
    findFirstItem() {
      const e = wu(this.$refs.list, '[data-pc-section="item"]');
      return e ? e.children[0] : null;
    },
    findLastItem() {
      const e = mm(this.$refs.list, '[data-pc-section="item"]');
      return e ? e[e.length - 1].children[0] : null;
    },
    setFocusToMenuitem(e, t) {
      e.tabIndex = "-1", t.tabIndex = "0", t.focus();
    },
    isActive(e) {
      return e === this.d_activeStep;
    },
    isItemDisabled(e, t) {
      return this.disabled(e) || this.readonly && !this.isActive(t);
    },
    visible(e) {
      return typeof e.visible == "function" ? e.visible() : e.visible !== !1;
    },
    disabled(e) {
      return typeof e.disabled == "function" ? e.disabled() : e.disabled;
    },
    label(e) {
      return typeof e.label == "function" ? e.label() : e.label;
    },
    getMenuItemProps(e, t) {
      return {
        action: Pe(
          {
            class: this.cx("itemLink"),
            onClick: (n) => this.onItemClick(n, e),
            onKeyDown: (n) => this.onItemKeydown(n, e)
          },
          this.getPTOptions("itemLink", e, t)
        ),
        step: Pe(
          {
            class: this.cx("itemNumber")
          },
          this.getPTOptions("itemNumber", e, t)
        ),
        label: Pe(
          {
            class: this.cx("itemLabel")
          },
          this.getPTOptions("itemLabel", e, t)
        )
      };
    }
  }
}, m2 = ["id"], f2 = ["aria-current", "onClick", "onKeydown", "data-p-active", "data-p-disabled"];
function g2(e, t, n, a, o, l) {
  return O(), J("nav", Pe({
    id: e.id,
    class: e.cx("root")
  }, e.ptmi("root")), [
    y("ol", Pe({
      ref: "list",
      class: e.cx("list")
    }, e.ptm("list")), [
      (O(!0), J(ze, null, Rt(e.model, (s, i) => (O(), J(ze, {
        key: l.label(s) + "_" + i.toString()
      }, [
        l.visible(s) ? (O(), J("li", Pe({
          key: 0,
          class: [e.cx("item", { item: s, index: i }), s.class],
          style: s.style,
          "aria-current": l.isActive(i) ? "step" : void 0,
          onClick: (c) => l.onItemClick(c, s, i),
          onKeydown: (c) => l.onItemKeydown(c, s, i)
        }, { ref_for: !0 }, l.getPTOptions("item", s, i), {
          "data-p-active": l.isActive(i),
          "data-p-disabled": l.isItemDisabled(s, i)
        }), [
          e.$slots.item ? (O(), he(Ea(e.$slots.item), {
            key: 1,
            item: s,
            index: i,
            active: i === o.d_activeStep,
            label: l.label(s),
            props: l.getMenuItemProps(s, i)
          }, null, 8, ["item", "index", "active", "label", "props"])) : (O(), J("span", Pe({
            key: 0,
            class: e.cx("itemLink")
          }, { ref_for: !0 }, l.getPTOptions("itemLink", s, i)), [
            y("span", Pe({
              class: e.cx("itemNumber")
            }, { ref_for: !0 }, l.getPTOptions("itemNumber", s, i)), V(i + 1), 17),
            y("span", Pe({
              class: e.cx("itemLabel")
            }, { ref_for: !0 }, l.getPTOptions("itemLabel", s, i)), V(l.label(s)), 17)
          ], 16))
        ], 16, f2)) : ue("", !0)
      ], 64))), 128))
    ], 16)
  ], 16, m2);
}
const h2 = /* @__PURE__ */ $t(p2, [["render", g2]]);
var xl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, b2 = { exports: {} };
(function(e, t) {
  (function(n, a) {
    a();
  })(xl, function() {
    function n(u, p) {
      return typeof p > "u" ? p = { autoBom: !1 } : typeof p != "object" && (console.warn("Deprecated: Expected third argument to be a object"), p = { autoBom: !p }), p.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(u.type) ? new Blob(["\uFEFF", u], { type: u.type }) : u;
    }
    function a(u, p, b) {
      var f = new XMLHttpRequest();
      f.open("GET", u), f.responseType = "blob", f.onload = function() {
        c(f.response, p, b);
      }, f.onerror = function() {
        console.error("could not download file");
      }, f.send();
    }
    function o(u) {
      var p = new XMLHttpRequest();
      p.open("HEAD", u, !1);
      try {
        p.send();
      } catch {
      }
      return 200 <= p.status && 299 >= p.status;
    }
    function l(u) {
      try {
        u.dispatchEvent(new MouseEvent("click"));
      } catch {
        var p = document.createEvent("MouseEvents");
        p.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), u.dispatchEvent(p);
      }
    }
    var s = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof xl == "object" && xl.global === xl ? xl : void 0, i = s.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), c = s.saveAs || (typeof window != "object" || window !== s ? function() {
    } : "download" in HTMLAnchorElement.prototype && !i ? function(u, p, b) {
      var f = s.URL || s.webkitURL, h = document.createElement("a");
      p = p || u.name || "download", h.download = p, h.rel = "noopener", typeof u == "string" ? (h.href = u, h.origin === location.origin ? l(h) : o(h.href) ? a(u, p, b) : l(h, h.target = "_blank")) : (h.href = f.createObjectURL(u), setTimeout(function() {
        f.revokeObjectURL(h.href);
      }, 4e4), setTimeout(function() {
        l(h);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(u, p, b) {
      if (p = p || u.name || "download", typeof u != "string") navigator.msSaveOrOpenBlob(n(u, b), p);
      else if (o(u)) a(u, p, b);
      else {
        var f = document.createElement("a");
        f.href = u, f.target = "_blank", setTimeout(function() {
          l(f);
        });
      }
    } : function(u, p, b, f) {
      if (f = f || open("", "_blank"), f && (f.document.title = f.document.body.innerText = "downloading..."), typeof u == "string") return a(u, p, b);
      var h = u.type === "application/octet-stream", I = /constructor/i.test(s.HTMLElement) || s.safari, m = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((m || h && I || i) && typeof FileReader < "u") {
        var S = new FileReader();
        S.onloadend = function() {
          var v = S.result;
          v = m ? v : v.replace(/^data:[^;]*;/, "data:attachment/file;"), f ? f.location.href = v : location = v, f = null;
        }, S.readAsDataURL(u);
      } else {
        var E = s.URL || s.webkitURL, g = E.createObjectURL(u);
        f ? f.location = g : location.href = g, f = null, setTimeout(function() {
          E.revokeObjectURL(g);
        }, 4e4);
      }
    });
    s.saveAs = c.saveAs = c, e.exports = c;
  });
})(b2);
const Zt = (e, t) => {
  const n = {
    data: {},
    objectType: "object"
  }, a = (o, l, s) => {
    for (const i in l) {
      const c = l[i];
      if ("write" in c)
        c.write(o, s[i], s);
      else {
        const [u, p] = c;
        let b;
        if (u in o.data)
          if (o.data[u].objectType === "object")
            b = o.data[u];
          else
            throw "non-object value already exists at key " + u;
        else
          b = {
            data: {},
            objectType: "object"
          };
        o.data[u] = b, a(b, p, s[i]);
      }
    }
  };
  return a(n, e, t), n;
}, Ht = (e, t) => {
  const n = {}, a = [], o = (l, s, i) => {
    for (const c in s) {
      a.push(c);
      const u = s[c];
      if ("read" in u)
        i[c] = u.read(l);
      else {
        const [p, b] = u, f = {};
        if (i[c] = f, !l)
          throw "object is undefined?: " + [...a];
        const h = l.data[p];
        if (!h)
          throw "missing object: " + [...a, p];
        if (h.objectType !== "object")
          throw "not an object: " + [...a, p];
        o(h, b, f);
      }
      a.pop();
    }
  };
  return o(t, e, n), n;
};
class Hf {
  constructor(t) {
    on(this, "defaultValue");
    this.defaultValue = t;
  }
  read(t) {
    const n = At(t, "CLRED"), a = At(t, "CLGREEN"), o = At(t, "CLBLUE");
    if (n !== void 0 && a !== void 0 && o !== void 0)
      return [n, a, o];
    if (this.defaultValue !== void 0)
      return this.defaultValue;
    throw "missing color info";
  }
  write(t, n) {
    t.data.CLRED = gt(n[0]), t.data.CLGREEN = gt(n[1]), t.data.CLBLUE = gt(n[2]);
  }
}
class Sl {
  constructor(t, n, a, o) {
    on(this, "key");
    on(this, "defaultValue");
    on(this, "reader");
    on(this, "writer");
    this.key = t, this.defaultValue = o, this.reader = n, this.writer = a;
  }
  read(t) {
    const n = this.reader(t, this.key);
    if (n !== void 0)
      return n;
    if (this.defaultValue !== void 0)
      return this.defaultValue;
    console.error("key and default missing: " + this.key);
  }
  write(t, n) {
    t.data[this.key] = this.writer(n);
  }
}
const ct = (e, t) => new Sl(e, va, Zn, t), $e = (e, t) => new Sl(e, At, gt, t), Ju = (e, t) => new Sl(e, ui, lo, t), up = (e, t) => new Sl(e, Gi, Io, t), Vn = (e, t) => new Sl(e, RI, Io, t), v2 = (e, t) => new Sl(e, MI, Io, t), vr = (e, t) => ({
  read(n) {
    const a = [At(n, e[0]), At(n, e[1]), At(n, e[2])];
    if (a.includes(void 0))
      throw "missing keys: " + e;
    return a;
  },
  write(n, a) {
    n.data[e[0]] = gt(a[0]), n.data[e[1]] = gt(a[1]), n.data[e[2]] = gt(a[2]);
  }
}), tu = (e) => {
  const t = {
    objectType: "object",
    data: {}
  };
  e.filename !== void 0 && (t.filename = e.filename);
  for (const [n, a] of Object.entries(e.data))
    a.objectType === "object" ? t.data[n] = tu(a) : t.data[n] = {
      ...a,
      data: new Uint8Array(a.data)
    };
  return t;
}, y2 = (e) => "rawProjectObject" in e, ss = (e, t, n) => {
  const a = Yf(e, t, n);
  return {
    read: (s) => {
      const i = a.read(s), c = [];
      if (i.forEach((u, p) => {
        u === void 0 && c.push(p);
      }), c.length)
        throw "array missing values: " + c.join(", ");
      return i;
    },
    write: (s, i, c) => {
      a.write(s, i, c);
    }
  };
}, Yf = (e, t, n) => ({
  read: (l) => {
    const s = $n(l, n), i = [];
    for (let c = 0; c < s; c++) {
      const u = `${t}_${c}`, p = en(l, u);
      if (p !== void 0) {
        let b;
        "model" in e ? b = e.model : b = e.mapper(p);
        const f = Ht(b, p);
        i.push(f);
      } else
        i.push(void 0);
    }
    return i;
  },
  write: (l, s) => {
    for (let i = 0; i < s.length; i++) {
      const c = `${t}_${i}`, u = s[i];
      if (u !== void 0) {
        let p;
        "model" in e ? p = e.model : p = e.reverseMapper(u), l.data[c] = Zt(p, u);
      }
    }
    l.data[`${n}`] = gt(s.length);
  }
});
function Do(e, t) {
  const n = Rs(e, [t, "FileName"]), a = PI(e, [t, "FileStream"]).data, o = nf(e, [t, "FileSize"]);
  return { fileName: n, data: new Int8Array(a.buffer), fileSize: o };
}
function Ao(e, t, n) {
  n && (xs(e, [t, "FileName"], n.fileName), xI(e, [t, "FileStream"], n.data), Qo(e, [t, "FileSize"], n.fileSize));
}
function xi(e, t) {
  const n = Vl(e, [t, "RED"]), a = Vl(e, [t, "GREEN"]), o = Vl(e, [t, "BLUE"]), l = Vl(e, [t, "ALPHA"]);
  return n !== void 0 && a !== void 0 && o !== void 0 && l !== void 0 ? [n, a, o, l] : [255, 255, 255, 255];
}
function ji(e, t, n) {
  Qo(e, [t, "RED"], n[0]), Qo(e, [t, "GREEN"], n[1]), Qo(e, [t, "BLUE"], n[2]), Qo(e, [t, "ALPHA"], n[3]);
}
const _2 = {
  name: ct("NAME"),
  manufacturerName: ct("MANUFACTURER_NAME"),
  implantFileName: ct("FILE_NAME"),
  implantOriginalName: ct("IMPLANT_ORIGINAL_NAME"),
  modelName: ct("MODEL_NAME"),
  sameManufacturerImplants: ct("SAME_MANUFACTURER_IMPLANTS"),
  guid: ct("GUID"),
  sellingCode: ct("IMPLANT_SELLING_CODE"),
  implantConnectorHeight: $e("IMPLANT_CONECTOR_HEIGHT"),
  diameter: $e("DIAMETER"),
  length: $e("LENGTH"),
  color: $e("COLOR")
}, wi = {
  shapePoints: $e("SHAPE_POINTS", 0),
  objectType: $e("OBJECT_TYPE", Le._NONE),
  objectSubType: $e("OBJECT_SUB_TYPE", Le._NONE),
  name: ct("OBJECT_NAME"),
  displayText: ct("OBJECT_DISPLAY_TEXT"),
  objectNote: ct("OBJECT_NOTE", ""),
  visible: Ju("VISIBLE", !0),
  enabled: $e("ENABLED", 1),
  deleted: $e("DELETED", 0),
  color: new Hf(),
  opacity: $e("CLALPHA", 0),
  ownerCount: $e("OWNER_COUNT", 0),
  owners: {
    read: (e) => {
      const t = Ha(e, "OWNER_COUNT"), n = [];
      if (t != null)
        for (let a = 0; a < t; a++) {
          const o = Rs(e, [`OWNER_${a}`, ""]);
          n.push(o);
        }
      return n;
    },
    write: (e, t) => {
      const n = "OWNER_COUNT";
      e.data[n] = gt(t.length), t.forEach((a, o) => {
        const l = `OWNER_${o}`;
        xs(e, [l, ""], a);
      });
    }
  }
}, Kf = {
  origin: Vn("ORIGIN"),
  normal: Vn("NORMAL"),
  tangent: Vn("TANGENT"),
  viewUp: Vn("VIEWUP")
}, w2 = {
  objectName: ct("OBJECT_NAME"),
  displayText: ct("OBJECT_DISPLAY_TEXT"),
  objectType: $e("OBJECT_TYPE", Le._NONE),
  objectSubType: $e("OBJECT_SUB_TYPE", Le._NONE),
  name: ct("NAME"),
  manufacturerName: ct("MANUFACTURER_NAME"),
  implantFileName: ct("FILE_NAME"),
  implantOriginalName: ct("IMPLANT_ORIGINAL_NAME"),
  modelName: ct("MODEL_NAME"),
  sameManufacturerImplants: ct("SAME_MANUFACTURER_IMPLANTS"),
  guid: ct("GUID"),
  sellingCode: ct("IMPLANT_SELLING_CODE"),
  orientation: $e("ORIENTATION"),
  implantConnectorHeight: $e("IMPLANT_CONECTOR_HEIGHT"),
  diameter: $e("DIAMETER"),
  length: $e("LENGTH"),
  color: $e("COLOR"),
  nonSymmetric: $e("NON_SYMMETRIC"),
  fileSha: ct("FILE_SHA"),
  connectionSides: {
    read: (e) => At(e, "CONNECTION_SIDES"),
    write: (e, t) => {
      t !== void 0 && (e.data.CONNECTION_SIDES = gt(t));
    }
  },
  stlFile: {
    read: (e) => Do(e, "STLFile"),
    write: (e, t) => {
      Ao(e, "STLFile", t);
    }
  },
  plyFilename: ct("PLYFilename"),
  stlSuffix: ct("STLSuffix"),
  textureCount: {
    read: (e) => At(e, "TextureCount"),
    write: (e, t) => {
      t !== void 0 && (e.data.TextureCount = gt(t));
    }
  },
  textureFiles: {
    read: (e) => {
      const t = Ha(e, "TextureCount");
      if (t === void 0) return;
      const n = [];
      for (let a = 0; a < t; a++) {
        const o = Do(e, `TextureFile[${a}]`);
        o && n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      t && t.forEach((n, a) => {
        Ao(e, `TextureFile[${a}]`, n);
      });
    }
  },
  textureFileNames: {
    read: (e) => {
      const t = Ha(e, "TextureCount");
      if (t === void 0) return;
      const n = [];
      for (let a = 0; a < t; a++) {
        const o = Rs(e, [`Texture[${a}]`]);
        n.push(o || "");
      }
      return n;
    },
    write: (e, t) => {
      if (!t) return;
      const n = "TextureCount";
      e.data[n] = gt(t.length), t.forEach((a, o) => {
        const l = `Texture[${o}]`;
        xs(e, [l], a);
      });
    }
  }
}, Zf = {
  name: ct("OBJECT_NAME"),
  displayText: ct("OBJECT_DISPLAY_TEXT"),
  objectType: $e("OBJECT_TYPE"),
  objectSubType: $e("OBJECT_SUB_TYPE"),
  implantInfo: ["IMPLANT", _2]
}, Sa = {
  manufacturerName: ct("MANUFACTURER_NAME"),
  modelName: ct("MODEL_NAME"),
  fileName: ct("FILE_NAME"),
  name: ct("NAME"),
  guid: ct("GUID"),
  color: $e("COLOR"),
  angle: $e("ANGLE"),
  connectorHeight: $e("CONNECTION_HEIGHT"),
  abutmentSellingCode: ct("ABUTMENT_SELLING_CODE"),
  rotationZ: $e("ROTATION_Z"),
  stlFile: {
    read: (e) => {
      if (en(e, "STLFile"))
        return Do(e, "STLFile");
    },
    write: (e, t) => {
      t && Ao(e, "STLFile", t);
    }
  }
}, Ro = {
  originalName: ct("SLEEVE_ORIGINAL_NAME"),
  manufacturerName: ct("SLEEVE_MANUFACTURER"),
  modelName: ct("SLEEVE_MODEL"),
  sellingCode: ct("SLEEVE_SELLING_CODE"),
  drillLengthSizes: ct("SLEEVE_DRILL_SIZES"),
  dExternal: $e("SLEEVE_DEXTERNAL"),
  dInternal: $e("SLEEVE_DINTERNAL"),
  dHexagon: {
    read: (e) => Ki(At(e, "SLEEVE_DHEXAGON") ?? 0, ui(e, "SLEEVE_CYLINDER_SHAPE")),
    write: (e, t, n) => {
      e.data.SLEEVE_DHEXAGON = gt(Ki(t, n.cylinderShape));
    }
  },
  lSleeve: $e("SLEEVE_LSLEEVE"),
  lLip: $e("SLEEVE_LLIP"),
  lCut: $e("SLEEVE_LCUT", 0),
  distanceFromImplant: $e("SLEEVE_DISTANCE_FROM_IMPLANT"),
  originalDistanceFromImplant: $e("SLEEVE_ORIGINAL_DISTANCE_FROM_IMPLANT"),
  referencedSleeve: {
    read: (e) => At(e, "SLEEVE_REFERENCED_SLEEVE"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_REFERENCED_SLEEVE = gt(t));
    }
  },
  reductionSystemSize: $e("SLEEVE_REDUCTION_SYSTEM_SIZE"),
  cylinderShape: {
    read: (e) => !!ui(e, "SLEEVE_CYLINDER_SHAPE") || (At(e, "SLEEVE_DHEXAGON") ?? 0) < 0,
    write: (e, t, n) => {
      e.data.SLEEVE_CYLINDER_SHAPE = lo(t || n.dHexagon < 0);
    }
  },
  lockDistance: {
    read: (e) => At(e, "SLEEVE_LOCK_DISTANCE"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_LOCK_DISTANCE = gt(t));
    }
  },
  distanceFromImplantOffset: {
    read: (e) => At(e, "SLEEVE_DISTANCE_FROM_IMPLANT_OFFSET"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_DISTANCE_FROM_IMPLANT_OFFSET = gt(t));
    }
  },
  rotationAll: {
    read: (e) => At(e, "ROTATION_ALL"),
    write: (e, t) => {
      t !== void 0 && (e.data.ROTATION_ALL = gt(t));
    }
  },
  rotationCut: {
    read: (e) => At(e, "ROTATION_CUT"),
    write: (e, t) => {
      t !== void 0 && (e.data.ROTATION_CUT = gt(t));
    }
  },
  connectionIndex: {
    read: (e) => At(e, "CONNECTION_INDEX"),
    write: (e, t) => {
      t !== void 0 && (e.data.CONNECTION_INDEX = gt(t));
    }
  },
  stlFileGuid: {
    read: (e) => va(e, "SLEEVE_STL_FILEGUID"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_STL_FILEGUID = Zn(t));
    }
  },
  stlFileNegativeGuid: {
    read: (e) => va(e, "SLEEVE_STL_NEGATIVE_FILEGUID") ?? va(e, "SLEEVE_STL_NEGATIVE_FILE_GUID"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_STL_NEGATIVE_FILEGUID = Zn(t));
    }
  },
  stlData: {
    read: (e) => {
      if (en(e, "SLEEVE_STL_FILE"))
        return Do(e, "SLEEVE_STL_FILE");
    },
    write: (e, t) => {
      t && Ao(e, "SLEEVE_STL_FILE", t);
    }
  },
  stlNegativeData: {
    read: (e) => {
      if (en(e, "SLEEVE_STL_NEGATIVE_FILE"))
        return Do(e, "SLEEVE_STL_NEGATIVE_FILE");
    },
    write: (e, t) => {
      t && Ao(e, "SLEEVE_STL_NEGATIVE_FILE", t);
    }
  }
}, cp = {
  name: ct("name"),
  guide_radius_hexagon: $e("guide_radius_hexagon"),
  guide_lip_length: $e("guide_lip_length"),
  guide_cut_size: $e("guide_cut_size"),
  guide_rotation_all: $e("guide_rotation_all"),
  guide_rotation_cut: $e("guide_rotation_cut")
}, rs = {
  name: ct("name"),
  d1Model: $e("d1Model"),
  d2Model: $e("d2Model"),
  l1Model: $e("l1Model"),
  l2Model: $e("l2Model"),
  cutSizeModel: $e("cutSizeModel"),
  bottomExtrusionRModel: $e("bottomExtrusionRModel"),
  support_lenght: $e("support_lenght"),
  supportRModel: $e("supportRModel"),
  base_lenght: $e("base_lenght"),
  rotation_cutModel: $e("rotation_cutModel"),
  stlFileGuid: {
    read: (e) => va(e, "STL_FILEGUID"),
    write: (e, t) => {
      t !== void 0 && (e.data.STL_FILEGUID = Zn(t));
    }
  },
  stlData: {
    read: (e) => {
      if (en(e, "STL_FILE"))
        return Do(e, "STL_FILE");
    },
    write: (e, t) => {
      t && Ao(e, "STL_FILE", t);
    }
  }
}, Jf = {
  ...wi,
  origin: Vn("ORIGIN", [0, 0, 0]),
  CadToothInfoOrderNumber: $e("CadToothInfoOrderNumber", -1),
  CadToothInfoType: $e("CadToothInfoType", -1)
}, S2 = {
  ...wi,
  ...Kf
}, us = {
  ...S2,
  isTextureConverted: $e("TEXTURE_CONVERTED", 0),
  storedOrigin: Vn("STORED_ORIGIN"),
  storedNormal: Vn("STORED_NORMAL"),
  storedViewUp: Vn("STORED_VIEWUP"),
  registrationMatrix: up("REGISTRATION_MATRIX"),
  registrationMatrixInverse: up("REGISTRATION_MATRIX_INVERSE"),
  diameter: $e("DIAMETER", 0),
  diameter2: $e("DIAMETER2", 0),
  height: $e("HEIGHT", 0),
  implantInfo: ["IMPLANT", w2],
  rotation: $e("ROTATION", 0),
  implantType: $e("IMPLANT_TYPE", 0),
  cadType: $e("CAD_TYPE", -1),
  cadToothInfoOrderNumber: $e("CAD_TOOTH_INFO_ORDER_NUMBER", -1),
  cadToothInfoType: $e("CAD_TOOTH_INFO_TYPE", -1),
  cadCorrespondenceId: $e("CAD_CORRESPONDENCE_ID", -1),
  cadReconstructionTypeId: $e("CAD_RECONSTRUCTION_TYPE_ID", -1),
  stlFileCam5Attachment: {
    read: (e) => va(e, "STL_FILE_CAM5_ATTACHMENT"),
    write: (e, t) => {
      t !== void 0 && (e.data.STL_FILE_CAM5_ATTACHMENT = Zn(t));
    }
  },
  stlFileCam5RegistrationMatrix: {
    read: (e) => Gi(e, "STL_FILE_CAM5_REGISTRATION_MATRIX"),
    write: (e, t) => {
      t !== void 0 && (e.data.STL_FILE_CAM5_REGISTRATION_MATRIX = Io(t));
    }
  },
  toothPosition: ct("TOOTH_POSITION"),
  trackingType: $e("trackingType", -1),
  // This abutment stay only if type == _IMPLANT
  abutment: {
    read: (e) => {
      const t = en(e, "ABUTMENT");
      if (t)
        return Ht(Sa, t);
    },
    write: (e, t) => {
      t && (e.data.ABUTMENT = Zt(Sa, t));
    }
  },
  secondaryAbutment: {
    read: (e) => {
      const t = en(e, "SECONDARY_ABUTMENT");
      if (t)
        return Ht(Sa, t);
    },
    write: (e, t) => {
      t && (e.data.SECONDARY_ABUTMENT = Zt(Sa, t));
    }
  },
  secondaryScanAbutment: {
    read: (e) => {
      const t = en(e, "SECONDARY_SCAN_ABUTMENT");
      if (t)
        return Ht(Sa, t);
    },
    write(e, t) {
      t && (e.data.SECONDARY_SCAN_ABUTMENT = Zt(Sa, t));
    }
  },
  scanAbutment: {
    read: (e) => {
      const t = en(e, "SCAN_ABUTMENT");
      if (t)
        return Ht(Sa, t);
    },
    write(e, t) {
      t && (e.data.SCAN_ABUTMENT = Zt(Sa, t));
    }
  },
  abutmentColor: {
    read: (e) => xi(e, "ABUTMENT_CL"),
    write(e, t) {
      ji(e, "ABUTMENT_CL", t);
    }
  },
  secScanAbutmentColor: {
    read: (e) => xi(e, "SEC_SCAN_ABUTMENT_CL"),
    write(e, t) {
      ji(e, "SEC_SCAN_ABUTMENT_CL", t);
    }
  },
  scanAbutmentColor: {
    read: (e) => xi(e, "SCAN_ABUTMENT_CL"),
    write(e, t) {
      ji(e, "SCAN_ABUTMENT_CL", t);
    }
  },
  secAbutmentColor: {
    read: (e) => xi(e, "SEC_ABUTMENT_CL"),
    write(e, t) {
      ji(e, "SEC_ABUTMENT_CL", t);
    }
  },
  sleeveInfo: {
    read: (e) => {
      const t = en(e, "SLEEVE_INFO");
      if (t)
        return Ht(Ro, t);
    },
    write: (e, t) => {
      t && (e.data.SLEEVE_INFO = Zt(Ro, t));
    }
  },
  implantModel: {
    read: (e) => {
      const t = en(e, "IMPLANT_MODEL");
      if (t)
        return Ht(rs, t);
    },
    write: (e, t) => {
      t && (e.data.IMPLANT_MODEL = Zt(rs, t));
    }
  },
  drillLength: {
    read: (e) => At(e, "DRILL_LENGTH"),
    write: (e, t) => {
      t !== void 0 && (e.data.DRILL_LENGTH = gt(t));
    }
  },
  drillLengthMm: {
    read: (e) => At(e, "DRILL_LENGTH_MM"),
    write: (e, t) => {
      t !== void 0 && (e.data.DRILL_LENGTH_MM = gt(t));
    }
  },
  sleeveManuallyChanged: {
    read: (e) => At(e, "sleeveManuallyChanged"),
    write: (e, t) => {
      t !== void 0 && (e.data.sleeveManuallyChanged = gt(t));
    }
  },
  sameManufacturerImplantsCount: {
    read: (e) => At(e, "SAME_MANUFACTURER_IMPLANTS_COUNT"),
    write: (e, t) => {
      t !== void 0 && (e.data.SAME_MANUFACTURER_IMPLANTS_COUNT = gt(t));
    }
  },
  sameManufacturerImplants: {
    read: (e) => {
      const t = Ha(e, "SAME_MANUFACTURER_IMPLANTS_COUNT");
      if (t === void 0) return;
      const n = [];
      for (let a = 0; a < t; a++) {
        const o = Rs(e, [`SAME_MANUFACTURER_IMPLANTS_${a}`, ""]);
        n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      if (!t) return;
      const n = "SAME_MANUFACTURER_IMPLANTS_COUNT";
      e.data[n] = gt(t.length), t.forEach((a, o) => {
        const l = `SAME_MANUFACTURER_IMPLANTS_${o}`;
        xs(e, [l, ""], a);
      });
    }
  },
  scaleX: {
    read: (e) => At(e, "SCALE_X"),
    write: (e, t) => {
      t !== void 0 && (e.data.SCALE_X = gt(t));
    }
  },
  scaleY: {
    read: (e) => At(e, "SCALE_Y"),
    write: (e, t) => {
      t !== void 0 && (e.data.SCALE_Y = gt(t));
    }
  },
  scaleZ: {
    read: (e) => At(e, "SCALE_Z"),
    write: (e, t) => {
      t !== void 0 && (e.data.SCALE_Z = gt(t));
    }
  },
  // VOLUME fields
  // TODO missing dataArrays !!!! --> should all be parsed to sgpr + sgbd so these fields shold be redundant
  volume_data: {
    read: (e) => At(e, "volume_data"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_data = gt(t));
    }
  },
  volume_data_curve: {
    read: (e) => At(e, "volume_data_curve"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_data_curve = gt(t));
    }
  },
  volume_data_scalars: {
    read: (e) => At(e, "volume_data_scalars"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_data_scalars = gt(t));
    }
  },
  offset_protection_mask_data: {
    read: (e) => At(e, "offset_protection_mask_data"),
    write: (e, t) => {
      t !== void 0 && (e.data.offset_protection_mask_data = gt(t));
    }
  },
  offset1: {
    read: (e) => At(e, "offset1"),
    write: (e, t) => {
      t !== void 0 && (e.data.offset1 = gt(t));
    }
  },
  offset2: {
    read: (e) => At(e, "offset2"),
    write: (e, t) => {
      t !== void 0 && (e.data.offset2 = gt(t));
    }
  },
  capvalue: {
    read: (e) => At(e, "capvalue"),
    write: (e, t) => {
      t !== void 0 && (e.data.capvalue = gt(t));
    }
  },
  smoothing_distance: {
    read: (e) => At(e, "smoothing_distance"),
    write: (e, t) => {
      t !== void 0 && (e.data.smoothing_distance = gt(t));
    }
  },
  smoothing_on: {
    read: (e) => At(e, "smoothing_on"),
    write: (e, t) => {
      t !== void 0 && (e.data.smoothing_on = gt(t));
    }
  },
  inverted_volume: {
    read: (e) => At(e, "inverted_volume"),
    write: (e, t) => {
      t !== void 0 && (e.data.inverted_volume = gt(t));
    }
  },
  volume_transform: {
    read: (e) => Gi(e, "volume_transform"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_transform = Io(t));
    }
  },
  volume_transform_to_3D: {
    read: (e) => Gi(e, "volume_transform_to_3D"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_transform_to_3D = Io(t));
    }
  }
}, Xf = {
  ...wi,
  points: {
    read: (e) => {
      const t = $n(e, "SHAPE_POINTS"), n = [];
      for (let a = 0; a < t; a++) {
        const o = wo(qo(e, `POINT_${a}`), "");
        n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      const n = "SHAPE_POINTS";
      e.data[n] = gt(t.length), t.forEach((a, o) => {
        const l = `POINT_${o}`;
        el(e, [l, ""], a);
      });
    }
  }
}, qf = {
  ...Xf,
  maxilla0Mandible: {
    read: (e) => {
      const t = nf(e, ["Maxiilla_0_Mandibla", ""]);
      if (![-1, 0, 1].includes(t))
        throw "failed to parse cpr maxilla/mandible value";
      return t;
    },
    write: (e, t) => {
      if (![-1, 0, 1].includes(t))
        throw "";
      Qo(e, ["Maxiilla_0_Mandibla", ""], t);
    }
  },
  owner: {
    read: (e) => {
      if ($n(e, "OBJECT_SUB_TYPE") === Le._CPR_DENTAL) {
        const n = wo(qo(e, "OWNER_O"), ""), a = wo(qo(e, "OWNER_N"), ""), o = wo(qo(e, "OWNER_S"), ""), l = wo(qo(e, "OWNER_T"), "");
        return {
          o: n,
          n: a,
          s: o,
          t: l
        };
      } else
        return;
    },
    write: (e, t) => {
      t && (el(e, ["OWNER_O", ""], t.o), el(e, ["OWNER_N", ""], t.n), el(e, ["OWNER_S", ""], t.s), el(e, ["OWNER_T", ""], t.t));
    }
  }
}, Qf = {
  ...Xf,
  radius: $e("RADIUS")
}, I2 = {
  name: ct("NAME"),
  filename: ct("FILENAME"),
  manufacturerName: ct("MANUFACTURER_NAME"),
  modelName: ct("MODEL_NAME"),
  color: ct("COLOR"),
  guid: ct("GUID"),
  stlFile: {
    read: (e) => Do(e, "STLFile"),
    write: (e, t) => {
      Ao(e, "STLFile", t);
    }
  }
}, eg = {
  ...wi,
  sleeveInfo: {
    read: (e) => {
      const t = en(e, "SLEEVE_INFO");
      if (t)
        return Ht(Ro, t);
    },
    write: (e, t) => {
      t && (e.data.SLEEVE_INFO = Zt(Ro, t));
    }
  },
  pinInfo: ["INFO", I2],
  implantGuide: {
    read: (e) => {
      const t = en(e, "IMPLANT_GUIDE");
      if (t)
        return Ht(cp, t);
    },
    write: (e, t) => {
      t && (e.data.IMPLANT_GUIDE = Zt(cp, t));
    }
  },
  implantModel: {
    read: (e) => {
      const t = en(e, "IMPLANT_MODEL");
      if (t)
        return Ht(rs, t);
    },
    write: (e, t) => {
      t && (e.data.IMPLANT_MODEL = Zt(rs, t));
    }
  },
  ...Kf
}, Si = {
  ...wi,
  points: {
    read: (e) => {
      const t = $n(e, "SHAPE_POINTS"), n = [];
      for (let a = 0; a < t; a++) {
        const o = wo(qo(e, `POINT_${a}`), "");
        n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      const n = "SHAPE_POINTS";
      e.data[n] = gt(t.length), t.forEach((a, o) => {
        const l = `POINT_${o}`;
        el(e, [l, ""], a);
      });
    }
  },
  owner: ct("OWNER")
}, tg = {
  ...Si
}, ng = {
  ...Si,
  annotationText: ct("ANNOTATION_TEXT")
}, ag = {
  ...Si
}, og = {
  ...Si
}, lg = {
  ...Si,
  statistics: [
    "STATISTICS",
    {
      area: $e("Area"),
      length: $e("Length"),
      avg: $e("Avg"),
      min: $e("Min"),
      max: $e("Max"),
      stdDev: $e("StdDev")
    }
  ]
}, ig = {
  shapePoints: $e("SHAPE_POINTS", 0),
  objectType: $e("OBJECT_TYPE", Le._NONE),
  objectSubType: $e("OBJECT_SUB_TYPE", Le._NONE),
  name: ct("OBJECT_NAME", ""),
  displayText: ct("OBJECT_DISPLAY_TEXT", ""),
  objectNote: ct("OBJECT_NOTE", ""),
  visible: Ju("VISIBLE", !0),
  enabled: $e("ENABLED", 1),
  deleted: $e("DELETED", 0),
  color: new Hf([0, 0, 0]),
  opacity: $e("CLALPHA", 0),
  ownerCount: $e("OWNER_COUNT", 0),
  owners: {
    read: (e) => {
      const t = Ha(e, "OWNER_COUNT") ?? 0, n = [];
      for (let a = 0; a < t; a++) {
        const o = af(e, [`OWNER_${a}`, ""]);
        o !== void 0 && n.push(o);
      }
      return n;
    },
    write: () => {
    }
  },
  points: {
    read: (e) => {
      const t = Ha(e, "SHAPE_POINTS") ?? 0, n = [];
      for (let a = 0; a < t; a++) {
        const o = en(e, `POINT_${a}`);
        if (o)
          try {
            n.push(wo(o, ""));
          } catch {
            return [];
          }
      }
      return n;
    },
    write: () => {
    }
  },
  owner: ct("OWNER", ""),
  rawProjectObject: {
    read: tu,
    write: (e, t) => {
      const n = tu(t);
      e.data = n.data, n.filename !== void 0 && (e.filename = n.filename);
    }
  }
}, E2 = (e) => {
  const t = $n(e, "OBJECT_TYPE");
  return t === Le._CPR_SHAPE_INDICATOR ? tg : t === Le._ANNOTATION ? ng : t === Le._DISTANCE ? ag : t === Le._ANGLE ? og : t === Le._POLYGON ? lg : ig;
}, T2 = (e) => {
  const t = e.objectType;
  if (y2(e))
    return ig;
  if (t === Le._CPR_SHAPE_INDICATOR)
    return tg;
  if (t === Le._ANNOTATION)
    return ng;
  if (t === Le._DISTANCE)
    return ag;
  if (t === Le._ANGLE)
    return og;
  if (t === Le._POLYGON)
    return lg;
  throw "unknown collection2d object type: " + t;
}, sg = {
  objects: ss(
    {
      mapper: E2,
      reverseMapper: T2
    },
    "OBJECT",
    "OBJECTS_COUNT"
  ),
  iAnnotAdded: $e("iAnnotAdded"),
  iDistanceAdded: $e("iDistanceAdded"),
  iAngleAdded: $e("iAngleAdded"),
  iPolyAdded: $e("iPolyAdded")
}, cs = {
  dim: vr(["DIM_0", "DIM_1", "DIM_2"]),
  offset: vr(["OFFSET_0", "OFFSET_1", "OFFSET_2"]),
  spacing: vr(["MM_0", "MM_1", "MM_2"]),
  windowLevel: $e("WL"),
  windowWidth: $e("WW")
}, ds = {
  croppedPointMin: Vn("CROPPED_POINT_MIN"),
  croppedPointMax: Vn("CROPPED_POINT_MAX"),
  generalNotes: ct("GENERAL_NOTES"),
  patientData: {
    read: (e) => va(e, "PATIENT_DATA"),
    write: (e, t) => {
      t !== void 0 && (e.data.PATIENT_DATA = Zn(t));
    }
  },
  seriesData: {
    read: (e) => va(e, "SERIES_DATA"),
    write: (e, t) => {
      t !== void 0 && (e.data.SERIES_DATA = Zn(t));
    }
  },
  dicomData: {
    read: (e) => va(e, "DICOM_DATA"),
    write: (e, t) => {
      t !== void 0 && (e.data.DICOM_DATA = Zn(t));
    }
  },
  modified: {
    read: (e) => ({
      year: $n(e, "PROJECT_MODIFIED_YEAR"),
      month: $n(e, "PROJECT_MODIFIED_MONTH"),
      day: $n(e, "PROJECT_MODIFIED_DAY"),
      hour: $n(e, "PROJECT_MODIFIED_HOUR"),
      minutes: $n(e, "PROJECT_MODIFIED_MINUTES"),
      seconds: $n(e, "PROJECT_MODIFIED_SECONDS")
    }),
    write: (e, t) => {
      e.data.PROJECT_MODIFIED_YEAR = gt(t.year), e.data.PROJECT_MODIFIED_MONTH = gt(t.month), e.data.PROJECT_MODIFIED_DAY = gt(t.day), e.data.PROJECT_MODIFIED_HOUR = gt(t.hour), e.data.PROJECT_MODIFIED_MINUTES = gt(t.minutes), e.data.PROJECT_MODIFIED_SECONDS = gt(t.seconds);
    }
  },
  projectCropped: $e("PROJECT_CROPPED"),
  projectVersion: $e("PROJECT_VERSION"),
  useUSToothMap: Ju("PROJECT_USE_US_TOOTH_MAP")
}, C2 = {
  indexId: $e("INDEXID"),
  stateId: ct("STATEID"),
  layoutType: $e("LAYOUT_TYPE"),
  desktopType: $e("DESKTOP_TYPE"),
  bookType: $e("BOOK_TYPE"),
  origin: Vn("ORIGIN"),
  cprAngle: $e("CPR_ANGLE")
}, N2 = {
  stateId: $e("STATEID"),
  origin: Vn("ORIGIN"),
  xAxis: Vn("X_AXIS"),
  yAxis: Vn("Y_AXIS"),
  zAxis: Vn("Z_AXIS"),
  windowLevelWidth: v2("WINDOW_LEVEL_WIDTH"),
  filterType: $e("FILTER_TYPE"),
  mipThickness: $e("MIP_THICKENSS")
}, L2 = {
  stateId: $e("STATEID"),
  columns: $e("COLUMNS"),
  rows: $e("ROWS")
}, O2 = {
  presenterWindow: [
    "PRESENTER_WINDOW",
    {
      bookmarks: ss({ model: L2 }, "BOOKMARK", "BOOKMARKS_COUNT"),
      viewWidget: [
        "VIEW_WIDGET",
        {
          bookmarks: ss({ model: N2 }, "BOOKMARK", "BOOKMARKS_COUNT")
        }
      ]
    }
  ]
}, rg = {
  layout: [
    "LAYOUT",
    {
      bookmarks: ss({ model: C2 }, "BOOKMARK", "BOOKMARKS_COUNT")
    }
  ],
  windows: [
    "WINDOWS",
    {
      windows: Yf({ model: O2 }, "WINDOW", "WINDOWS_COUNT")
    }
  ]
};
new TextEncoder().encode("Salted__");
function Fi(e) {
  return new TextEncoder().encode(e);
}
async function ao(e) {
  const t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((a) => a.toString(16).padStart(2, "0")).join("");
}
const D2 = (e) => Ht(qf, e), A2 = (e) => Ht(Qf, e), R2 = (e) => {
  const t = Ht(eg, e);
  return t.name == "Pin 1" && (t.name = "Pin A"), t.name == "Pin 2" && (t.name = "Pin B"), t.name == "Pin 3" && (t.name = "Pin C"), t.name == "Pin 4" && (t.name = "Pin D"), t.name == "Pin 5" && (t.name = "Pin E"), t.name == "Pin 6" && (t.name = "Pin F"), t.name == "Pin 7" && (t.name = "Pin G"), t.name == "Pin 8" && (t.name = "Pin H"), t.name == "Pin 9" && (t.name = "Pin I"), t;
}, M2 = (e) => Ht(us, e), P2 = (e) => Ht(Jf, e), x2 = (e) => Ht(us, e), j2 = (e) => {
  const t = Ht(Zf, e);
  let n;
  const a = en(e, "ABUTMENT");
  a && (n = Ht(Sa, a));
  let o;
  const l = en(e, "SLEEVE_INFO");
  return l && As(l, "SLEEVE_ORIGINAL_NAME") && (o = Ht(Ro, l)), {
    implant: t,
    abutment: n,
    sleeve: o
  };
}, F2 = (e) => {
  const t = {
    data: {},
    objectType: "object"
  }, n = Zt(Zf, e.implant);
  if (t.data = n.data, e.abutment) {
    const a = Zt(Sa, e.abutment);
    t.data.ABUTMENT = a;
  }
  if (e.sleeve) {
    const a = Zt(Ro, e.sleeve);
    t.data.SLEEVE_INFO = a;
  }
  return t;
};
function $2(e) {
  const t = [], n = [], a = [], o = [], l = [], s = [], i = [], c = $n(e, "OBJECTS_COUNT");
  if (isNaN(c))
    throw "OBJECT_COUNT NaN";
  for (let u = 0; u < c; u++) {
    const p = `OBJECT_${u}`, b = en(e, p);
    if (!b)
      throw `${p} object data missing`;
    const f = $n(b, "OBJECT_TYPE");
    f === Le._NERVE ? o.push(A2(b)) : f === Le._IMPLANT ? t.push(x2(b)) : f === Le._CPR_CURVE ? a.push(D2(b)) : f === Le._PIN ? n.push(R2(b)) : f === Le._STL_OBJECT || f === Le._STL_TOOTH || f === Le._STL_PROSTHESIS || f === Le._STL_TEETH_MODEL ? l.push(M2(b)) : f === Le._TOOTH_MARKER ? s.push(P2(b)) : (console.warn("loader not implemented for object type", f), i.push(b));
  }
  return {
    implants: t,
    pins: n,
    cprCurves: a,
    nerves: o,
    stlObjects: l,
    toothMarkers: s,
    unsupportedObjects: i
  };
}
function k2(e, t, n) {
  e.name = vo(e.name, t, n), e.toothPosition = vo(e.toothPosition, t, n);
}
function V2(e, t, n) {
  if (t !== n) {
    for (const a of e.implants)
      k2(a, t, n);
    for (const a of e.toothMarkers)
      a.name = vo(a.name, t, n), a.displayText = vo(a.displayText, t, n);
    for (const a of e.stlObjects)
      a.objectType === Le._STL_TOOTH && (a.name = vo(a.name, t, n), a.displayText = vo(a.displayText, t, n));
  }
}
async function B2(e, t, n, a, o) {
  var ne;
  const { pr: l, stlInfo: s, imageData: i, mobile: c, segmentationResult: u } = n, p = (o == null ? void 0 : o.volumeQuality) ?? "full", b = (o == null ? void 0 : o.includeImplants) ?? !0, f = (o == null ? void 0 : o.includePins) ?? !0, h = (o == null ? void 0 : o.includeProjectStlObjects) ?? !0, I = o != null && o.includedProjectStlObjectNames && o.includedProjectStlObjectNames.length > 0 ? new Set(o.includedProjectStlObjectNames) : void 0, S = {
    loaded: 0,
    total: 1 + (s ? 1 : 0) + (c ? 1 : 0) + 1 + 4 + 2 + 1
  }, E = () => {
    S.loaded++, a && a(S);
  };
  l.then(E), s && s.then(E), u.then(E);
  const g = (s == null ? void 0 : s.then((W) => {
    const se = en(W, "COLLECTION_3D");
    return se ? $2(se) : null;
  })) ?? null, v = l.then((W) => Ht(cs, W)), T = l.then((W) => Ht(ds, W)), R = l.then((W) => {
    const se = en(W, "BOOKMARKS");
    return se ? Ht(rg, se) : null;
  }), L = l.then((W) => {
    const se = en(W, "COLLECTION_2D");
    return se ? Ht(sg, se) : null;
  }), C = Promise.all([i, v]).then(([W, se]) => {
    const be = {
      imageData: W,
      projectImageData: se
    };
    return kh(be.projectImageData, be.imageData);
  });
  await Promise.all([
    C.then((W) => {
      e.setImageData(W, p === "decimated");
    }).then(E),
    T.then((W) => {
      e.projectGeneralData = W;
    }).then(E),
    R.then((W) => {
      W && (e.projectBookmarks = W, e.objects.remapBookmarksFromProject());
    }).then(E),
    L.then((W) => {
      W && (e.objects.projectCollection2D = W);
    }).then(E)
  ]), e.replaceVolumeObject(), e.setVolumeInterpolationType(Vh.LINEAR);
  const A = (W) => {
    const se = [];
    return W && W.length && W.forEach((be) => {
      se.push([be.x, be.y, be.z]);
    }), se;
  };
  let j = !1, N = !1;
  const x = await g, z = ((ne = e.projectGeneralData) == null ? void 0 : ne.useUSToothMap) ?? !1, X = e.settings.general.useUSStyleToothChart, H = I ? new Set(Array.from(I).map((W) => vo(W, z, X))) : void 0;
  if (E(), x) {
    V2(x, z, X), e.projectGeneralData && (e.projectGeneralData.useUSToothMap = X);
    const { implants: W, pins: se, cprCurves: be, nerves: Re, stlObjects: U, toothMarkers: ie } = x;
    if (b)
      for (const re of W)
        e.objects.addProjectImplant(re);
    if (f)
      for (const re of se)
        e.objects.addPin(re, void 0);
    for (const re of be)
      e.objects.addCPRCurve(re);
    for (const re of Re)
      e.objects.addNerve(re), re.objectSubType == Le._NERVE_LEFT && (j = !0), re.objectSubType == Le._NERVE_RIGHT && (N = !0);
    for (const re of U) {
      if (!h || H && !H.has(re.name))
        continue;
      let q = !1;
      for (let [De, _e] of e.objects.stls)
        _e.getName() == re.name && _e.IsVolume() && (q = !0, _e.SetImplantPlanerProjectStl(re));
      q || e.objects.addSTL(re, {
        ply: re.implantInfo.stlSuffix === ".ply"
      });
    }
    for (const re of ie) {
      const q = Bh.fromProjectToothMarker(e, re, {});
      e.objects.toothMarkers.set(q.id, q);
    }
    e.objects.unsupportedProjectStlObjects = x.unsupportedObjects;
  }
  E();
  const M = await u;
  e.segmentationResult = M;
  let te = !1;
  if (M) {
    if (!e.objects.hasCPR()) {
      const be = {
        maxilla0Mandible: an.MAXILLA,
        owner: {
          o: [0, 0, 0],
          n: [0, 0, 1],
          s: [0, 1, 0],
          t: [1, 0, 0]
        },
        points: [],
        name: "Maxilla_CPR",
        displayText: "",
        objectType: Le._CPR_CURVE,
        objectSubType: Le._CPR_DENTAL,
        visible: !0,
        color: e.settings.defaultColors.cprColor,
        opacity: 1,
        objectNote: "",
        enabled: 1,
        deleted: 0,
        owners: ["AXIAL"],
        ownerCount: 1,
        shapePoints: 0
      };
      let Re = M.cpr.maxilla;
      e.CPRType == an.MANDIBLE || !Re ? (e.CPRType = an.MANDIBLE, Re = M.cpr.mandible, be.maxilla0Mandible = an.MANDIBLE, be.name = "Mandible_CPR") : e.CPRType = an.MAXILLA, be.points = A(Re), be.points.length && (be.owner = Uh(be.points), e.objects.addCPRCurve(be, !0));
    }
    const W = e.settings.defaultColors.nerves, se = {
      radius: 3,
      points: [],
      opacity: 1,
      name: "",
      objectType: Le._NERVE,
      objectSubType: Le._NONE,
      color: W,
      visible: !0,
      displayText: "",
      objectNote: "",
      enabled: 1,
      deleted: 0,
      owners: [],
      ownerCount: 0,
      shapePoints: 0
    };
    j || (se.points = A(M.nerve.left), se.points.length && (se.name = "Left Nerve", se.objectSubType = Le._NERVE_LEFT, e.objects.addNerve(se, void 0, !0))), N || (se.points = A(M.nerve.right), se.points.length && (se.name = "Right Nerve", se.objectSubType = Le._NERVE_RIGHT, e.objects.addNerve(se, void 0, !0))), (!j || !N) && (te = !0);
  }
  if (e.objects.projectCollection2D && e.projectBookmarks) {
    for (const W of e.projectBookmarks.windows.windows)
      if (W)
        for (const se of W.presenterWindow.viewWidget.bookmarks) {
          const be = e.objects.scaleVectorFromImplantPlanner(yo.fromValues(se.origin[0], se.origin[1], se.origin[2]));
          se.origin = be;
        }
    for (const W of e.projectBookmarks.layout.bookmarks) {
      const se = e.objects.scaleVectorFromImplantPlanner(yo.fromValues(W.origin[0], W.origin[1], W.origin[2]));
      W.origin = se;
    }
    for (const W of e.objects.projectCollection2D.objects) {
      console.log("Scaling point");
      for (const se in W.points)
        W.points[se] = e.objects.scaleVectorFromImplantPlanner(W.points[se]);
    }
    e.objects.projectCollection2D.objects.forEach((W) => {
      e.toolManager.measurementsTool.measurementTool.addMeasurementFromProject(W);
    });
  }
  E(), await t(e, !1), te && (await e.toolManager.setTool(un.NERVE, Qt.PRIMARY), await e.toolManager.setTool(un.NONE, Qt.PRIMARY)), e.settings.onProjectLoaded();
}
function U2(e) {
  const t = [], n = [], a = [], o = [], l = [], s = Ha(e, "DIM_0") || 0, i = Ha(e, "DIM_1") || 0, c = Ha(e, "DIM_2") || 0, u = en(e, "COLLECTION_3D");
  if (u) {
    const I = $n(u, "OBJECTS_COUNT");
    if (isNaN(I))
      throw "OBJECT_COUNT NaN";
    for (let m = 0; m < I; m++) {
      const S = `OBJECT_${m}`, E = en(u, S);
      if (!E)
        throw `${S} object data missing`;
      $n(E, "OBJECT_TYPE") === Le._IMPLANT && t.push(j2(E));
    }
  }
  const p = As(e, "PROJECT_SCREENSHOT").data, b = va(e, "PLANNER_PROJECT_STEP") || "", f = ui(e, "LOAD_OBJECTS_FROM_PATIENT") || !1, h = ui(e, "SEGMENTATION_INVOKED_BY_USER") || !1;
  return {
    imgDims: [s, i, c],
    implants: t,
    pins: n,
    cprCurves: a,
    nerves: o,
    stlObjects: l,
    screenshot: p,
    plannerStep: b,
    loadObjectsFromPatient: f,
    segmentationInvokedByUser: h
  };
}
async function G2(e, t, n, a) {
  const o = {
    data: t ? { ...t.data } : {},
    objectType: "object"
  }, l = e.objects.getImplantObjectData();
  if (l.length) {
    const i = {
      data: {},
      objectType: "object"
    };
    i.data.OBJECTS_COUNT = gt(l.length);
    for (let c = 0; c < l.length; c++) {
      const u = `OBJECT_${c}`, b = {
        implant: {
          name: l[c].name,
          displayText: l[c].displayText,
          objectType: l[c].objectType,
          objectSubType: l[c].objectSubType,
          implantInfo: l[c].implantInfo
        },
        abutment: l[c].abutment,
        sleeve: l[c].sleeveInfo
      }, f = F2(b);
      i.data[u] = f;
    }
    o.data.COLLECTION_3D = i;
  }
  let s = "";
  if (n) {
    o.data.LOAD_OBJECTS_FROM_PATIENT = lo(!0), o.data.SEGMENTATION_INVOKED_BY_USER = lo(!1);
    const i = e.getVolume().volumeActor;
    i && (s = await Gh({
      actor: i,
      orientation: "front",
      focalPoint: i.getOrigin(),
      distance: 1,
      width: 800,
      height: 800,
      background: [0.2, 0.2, 0.2, 0]
    }) || "");
  } else {
    let i = e.getViewWidget(Nn._3D);
    if (i || (e.layoutManager.construct3DWindow(), i = e.getViewWidget(Nn._3D), console.warn("View3D not found and constructed for screenshot")), i) {
      const c = i.isVisible(), u = i.getViewport();
      c || (i.setViewport(Dp.topLeft), i.show(), i.sceneRefresh()), i.orientationWidget.hide(), s = await Ko({ context: e, view: i, gradientBackground: a, noOverlay: !0 }) || "", i.orientationWidget.show(), c || (i.setViewport(u), i.hide(), i.sceneRefresh()), e.sceneRefresh();
    }
  }
  if (s) {
    const i = s.indexOf(","), c = s.slice(i), p = {
      objectType: "value",
      type: "string",
      data: Yr(c)
    };
    o.data.PROJECT_SCREENSHOT = p;
  }
  return o.data.PLANNER_PROJECT_STEP = Zn(ug(e)), n || (o.data.SEGMENTATION_INVOKED_BY_USER = lo(!1), o.data.LOAD_OBJECTS_FROM_PATIENT = lo(!1)), o;
}
async function W2(e, t, n = []) {
  console.log("Uploading project by files (batch)...");
  const a = `${t.fileName.replaceAll(".zip", "")}`, o = [], l = [...n], s = 40, i = 50, c = (g) => {
    t && t.progressCallback && t.progressCallback(s + g * i);
  }, u = new ba();
  u.data = e.pr;
  const p = `${a}.pr.json`, b = await u.write({
    dataWriteFunction: async (g, v) => {
      o.push([g.slice(2, g.length), v]);
    },
    filenameWithoutJson: p.slice(0, p.length - 5)
  }), f = Fi(b), h = await ao(f);
  if (l.push({ part_name: a, file_type: "pr.json", file: new Blob([b]), hash: h }), e.erpFile) {
    const g = JSON.stringify(e.erpFile), v = Fi(g), T = await ao(v);
    l.push({ part_name: a, file_type: "erp", file: new Blob([g]), hash: T });
  }
  if (e.stlInfo) {
    const g = new ba();
    g.data = e.stlInfo;
    const v = `${a}.stlinfo.json`, T = await g.write({
      dataWriteFunction: async (C, A) => {
        o.push([C.slice(2, C.length), A]);
      },
      filenameWithoutJson: v.slice(0, v.length - 5)
    }), R = Fi(T), L = await ao(R);
    l.push({ part_name: a, file_type: "stlinfo.json", file: new Blob([T]), hash: L });
  }
  if (e.imageData) {
    const g = await ao(e.imageData);
    l.push({ part_name: a, file_type: "prinfo", file: new Blob([e.imageData]), hash: g });
  }
  if (e.mobile) {
    const g = new ba();
    g.data = e.mobile;
    const v = `${a}.mobile.json`, T = await g.write(
      {
        dataWriteFunction: async (C, A) => {
          o.push([C.slice(2, C.length), A]);
        },
        filenameWithoutJson: v.slice(0, v.length - 5)
      },
      !0
    ), R = Fi(T), L = await ao(R);
    l.push({ part_name: a, file_type: "mobile.json", file: new Blob([T]), hash: L });
  }
  t && t.progressCallback && t.progressCallback(s);
  const { data: I } = await t.serverApi.getZippedFilesList(t.project.patientName, a + ".zip"), m = [];
  for (let g of I) {
    if (g.fileType != "bin") continue;
    let v = !1;
    o.forEach(([T, R]) => {
      if (T.toString().replaceAll(".bin", "") == g.name) {
        v = !0;
        return;
      }
    }), v || m.push(g.id);
  }
  if (m.length)
    try {
      await t.serverApi.deleteProjectPartsBatch(t.project.patientName, a, m);
    } catch (g) {
      console.warn("Batch delete failed, proceeding without blocking upload", g);
    }
  for (let [g, v] of o) {
    const T = await ao(v);
    l.push({ part_name: g.toString().replaceAll(".bin", ""), file_type: "bin", file: new Blob([v]), hash: T });
  }
  const S = [], E = {};
  for (let g of I)
    E[g.name + "." + g.fileType] = g.sha256;
  for (let g of l) {
    const v = E[g.part_name + "." + g.file_type];
    if (!v) {
      S.push(g);
      continue;
    }
    if (g.hash != v) {
      S.push(g);
      continue;
    }
  }
  if (S.length == 0)
    return console.log("No parts changed, skipping upload"), t && t.progressCallback && t.progressCallback(s + i), !0;
  console.log("Uploading changed parts", S);
  try {
    const g = await t.serverApi.uploadProjectPartsBatch(
      t.project.patientName,
      a,
      S,
      c,
      t == null ? void 0 : t.createDate
    );
    console.log("Batch upload response", g);
  } catch (g) {
    return console.log("Failed to upload project", g), !1;
  }
  return console.log("Project uploaded successfully"), !0;
}
async function z2(e, t, n) {
  var p;
  const a = t.imageData ?? await ((p = t.loadOriginalImageData) == null ? void 0 : p.call(t));
  if (!a) throw new Error("Original volume data is required to export a complete project.");
  const o = [], l = [], s = new ba();
  s.data = t.pr;
  const i = `${e}.pr.json`, c = await s.write({
    dataWriteFunction: async (b, f) => {
      l.push([b.slice(2, b.length), f]);
    },
    filenameWithoutJson: i.slice(0, i.length - 5)
  });
  if (o.push([i, c]), t.stlInfo) {
    const b = new ba();
    b.data = t.stlInfo;
    const f = `${e}.stlinfo.json`, h = await b.write({
      dataWriteFunction: async (I, m) => {
        l.push([I.slice(2, I.length), m]);
      },
      filenameWithoutJson: f.slice(0, f.length - 5)
    });
    o.push([f, h]);
  }
  if (a && l.push([`${e}.prinfo`, a]), t.mobile) {
    const b = new ba();
    b.data = t.mobile;
    const f = `${e}.mobile.json`, h = await b.write(
      {
        dataWriteFunction: async (I, m) => {
          l.push([I.slice(2, I.length), m]);
        },
        filenameWithoutJson: f.slice(0, f.length - 5)
      },
      !0
    );
    o.push([f, h]);
  }
  const u = new fi();
  return o.forEach(([b, f]) => u.file(b, f)), l.forEach(([b, f]) => u.file(b, f)), await u.generateAsync(
    {
      type: "blob",
      compression: "DEFLATE",
      // Enable compression
      compressionOptions: { level: 6 }
      // Optional: 1 (fastest) to 9 (best compression)
    },
    n
  );
}
async function H2(e, t) {
  const n = [], a = [];
  if (t.mobile) {
    const l = new ba();
    l.data = t.mobile;
    const s = `${e}.mobile.json`, i = await l.write(
      {
        dataWriteFunction: async (c, u) => {
          a.push([c.slice(2, c.length), u]);
        },
        filenameWithoutJson: s.slice(0, s.length - 5)
      },
      !0
    );
    n.push([s, i]);
  }
  const o = n[0][1];
  return new Blob([o], { type: "text/plain" });
}
function Y2(e, t, n) {
  const a = Zt(
    cs,
    e.volumeDecimated ? Ht(cs, t) : n ?? e.getImageInfo()
  ), o = Ht(ds, t);
  let l = {};
  if (e.projectBookmarks) {
    let p = Qr(e.projectBookmarks);
    for (const b of p.windows.windows)
      if (b)
        for (const f of b.presenterWindow.viewWidget.bookmarks)
          f.origin = e.objects.scaleVectorToImplantPlanner(yo.fromValues(f.origin[0], f.origin[1], f.origin[2]));
    for (const b of p.layout.bookmarks)
      b.origin = e.objects.scaleVectorToImplantPlanner(b.origin);
    p = e.objects.remapBookmarksToProject(p), l = { BOOKMARKS: Zt(rg, p) };
  }
  let s = {};
  if (e.objects.projectCollection2D) {
    const p = Qr(e.objects.projectCollection2D.objects);
    for (const f of p)
      for (const h in f.points)
        f.points[h] = e.objects.scaleVectorToImplantPlanner(f.points[h]);
    const b = {
      objects: p,
      iAngleAdded: e.objects.projectCollection2D.iAngleAdded,
      iAnnotAdded: e.objects.projectCollection2D.iAnnotAdded,
      iDistanceAdded: e.objects.projectCollection2D.iDistanceAdded,
      iPolyAdded: e.objects.projectCollection2D.iPolyAdded
    };
    s = { COLLECTION_2D: Zt(sg, b) };
  }
  const c = (() => {
    const p = /* @__PURE__ */ new Date();
    return new Date(p.getTime() - p.getTimezoneOffset() / 60);
  })();
  o.modified = {
    year: c.getFullYear(),
    month: c.getMonth(),
    day: c.getDate(),
    hour: c.getHours(),
    minutes: c.getMinutes(),
    seconds: c.getSeconds()
  }, o.useUSToothMap = e.settings.general.useUSStyleToothChart;
  const u = Zt(ds, o);
  return {
    objectType: "object",
    data: {
      ...t.data,
      ...s,
      ...l,
      ...a.data,
      ...u.data
    }
  };
}
function K2(e, t, n) {
  const a = e.objects.getImplantObjectData(), o = e.objects.getPinObjectData(), l = e.objects.getCprCurveObjectData(), s = e.objects.getNerveObjectData(), i = e.objects.getStlObjectData(), c = e.objects.getToothMarkerObjectData();
  a.length + o.length + (l ? 1 : 0) + s.length + i.length + c.length;
  const u = { data: {}, objectType: "object" }, p = [];
  for (const f of a) {
    const h = Zt(us, f);
    p.push(h);
  }
  for (const f of o) {
    const { pin: h, sleeve: I } = f, m = Zt(eg, h);
    I && (m.data.SLEEVE_INFO = Zt(Ro, I)), p.push(m);
  }
  l && p.push(Zt(qf, l));
  for (const f of s)
    p.push(Zt(Qf, f));
  for (const f of i)
    p.push(Zt(us, f));
  for (const f of c)
    p.push(Zt(Jf, f));
  for (const f of e.objects.unsupportedProjectStlObjects)
    p.push(f);
  const b = {
    data: {},
    objectType: "object"
  };
  return p.forEach((f, h) => {
    b.data[`OBJECT_${h}`] = f;
  }), b.data.OBJECTS_COUNT = gt(p.length), u.data.COLLECTION_3D = b, u;
}
async function Xu(e, t, n, a) {
  const o = e.getFS(), l = Ji(e, t, "pr"), s = Ji(e, t, "bd"), i = Xi(o.FS, l), c = Xi(o.FS, s);
  if (i && i.size && c && c.size) {
    console.log("Saving ", t, "pr and bd file from WasmFS to project");
    const u = o.FS.readFile(e.projectName + "." + t + "pr"), p = o.FS.readFile(e.projectName + "." + t + "bd");
    if (u.length > 0 && p.length > 0) {
      const b = await ao(u), f = new Blob([u]), h = await ao(p), I = new Blob([p]), m = n.fileName.replaceAll(".zip", "");
      return console.log("upload: ", n.project.patientName, " proj name:", n.fileName, ", suffix:", t), a(m, t + "pr", f, b), a(m, t + "bd", I, h), !0;
    }
  }
  return !1;
}
async function yr(e, t, n, a, o) {
  if (!await Xu(t, e, n, a)) {
    const s = n.fileName.replaceAll(".zip", ""), { data: i } = await n.serverApi.getZippedFilesList(n.project.patientName, s + ".zip"), c = i.find((p) => p.name == s && p.fileType == e + "pr"), u = i.find((p) => p.name == s && p.fileType == e + "bd");
    (c || u) && (console.log("Deleting ", e, "pr and bd file from saved project"), c && o(c.id), u && o(u.id));
  }
}
async function Z2(e, t, n, a) {
  const o = e.getEngine(), l = e.getFS(), s = new l.VectorString();
  for (let [i, c] of e.objects.stls)
    c.IsVolume() && c.cadType == It.eOT_SEGMENTED_BONE && s.push_back(c.id);
  if (s.size() > 0) {
    const i = new o.xProjectLoaderUtil();
    try {
      i.InitializeCADProjectSaving("", e.projectName, Sr.eM_BONE_SEGMENTATION), i.AddBoneSegmentationVisualObjectsForSave(s), i.FinalizeCADProjectSaving();
    } finally {
      s.delete(), i.delete();
    }
    await Xu(e, "bs", t, n) || console.error("Failed to save bone segmentation project");
  } else {
    s.delete();
    const i = t.fileName.replaceAll(".zip", ""), { data: c } = await t.serverApi.getZippedFilesList(t.project.patientName, i + ".zip"), u = c.find((b) => b.name == i && b.fileType == "bspr"), p = c.find((b) => b.name == i && b.fileType == "bsbd");
    (u || p) && (console.log("Deleting bspr and bsbd file from saved project"), u && a(u.id), p && a(p.id));
  }
}
async function J2(e, t, n, a) {
  await Xu(e, "ts", t, n) || console.error("Failed to save teeth segmentation project");
}
async function qu(e, t, n, a, o) {
  const { pr: l, stlInfo: s, mobile: i } = t, c = Y2(e, l, o == null ? void 0 : o.imageInfoOverride), u = K2(e), p = await G2(e, i, n, a == null ? void 0 : a.gradientBackground);
  a && a.progressCallback && a.progressCallback(10, !0);
  const b = [], f = [];
  if (!n && a && !e.volumeDecimated) {
    const S = (g, v, T, R) => {
      b.push({ part_name: g, file_type: v, file: T, hash: R });
    }, E = (g) => f.push(g);
    await yr("ipts", e, a, S, E), a && a.progressCallback && a.progressCallback(20), await Z2(e, a, S, E), a && a.progressCallback && a.progressCallback(30), e.contextCAD.tsprFileFromSegmentation && await J2(e, a, S), await yr("m", e, a, S, E), await yr("sg", e, a, S, E);
  }
  const h = e.volumeDecimated ? void 0 : e.getImageDataBuffer(), I = X2(e), m = {
    pr: c,
    stlInfo: u,
    imageData: h,
    mobile: p,
    erpFile: I,
    loadOriginalImageData: e.volumeDecimated ? e.loadOriginalImageData : void 0
  };
  if (a) {
    const S = a.fileName.replaceAll(".zip", "");
    if (console.log("Delete Ids: ", f), f.length > 0)
      try {
        await a.serverApi.deleteProjectPartsBatch(a.project.patientName, S, f);
      } catch (T) {
        console.warn("Batch delete failed, proceeding without blocking upload", T);
      }
    if (!await W2(m, a, b))
      return console.error("Upload failed -> deleting copyied projec"), null;
    const g = await H2(a.fileName.replaceAll(".zip", ""), m), v = {
      erp: {},
      extra: {
        erp: {
          project: m.erpFile.project
        },
        latestProjectStepShort: ug(e)
      },
      format: "json"
    };
    await a.serverApi.uploadMetadataToProject(a.project.patientName, a.fileName.replaceAll(".zip", "") + ".zip", v), await a.serverApi.uploadFile(
      a.project.patientName,
      a.fileName.replaceAll(".zip", "") + ".zip.mobile.json",
      a.isWeblinkProject || a.isWeblinkOperator ? "project_attachment_preview" : "mobile",
      g,
      (T) => {
        a && a.progressCallback && a.progressCallback(90 + T * 5);
      },
      a.createDate
    );
  }
  return m;
}
function X2(e) {
  const t = zn(e.erpFile) || jh();
  t.project.name = e.projectName, t.project.weblinkId && t.project.weblinkId.length == 0, t.project.orderId && t.project.orderId.length == 0;
  const n = e.patientInfo;
  n && (t.project.patient.id = n.patientId || "0", t.project.patient.name = n.patientName, t.project.patient.birthDate = n.dateOfBirth ? of(new Date(n.dateOfBirth)) : ""), e.user && (t.project.user.customerName = e.user.name, t.project.user.email = e.user.username, t.project.user.id = e.user.id), t.project.implants = [], e.objects.implants.forEach((a) => {
    const o = Fh(), l = a.getProjectImplantInfo();
    o.position = l.name, o.producer = l.manufacturerName, o.model = l.modelName, o.name = l.implantOriginalName, o.diameter = l.diameter.toString(), o.length = l.length.toString(), o.notes = a.getNotes(), o.selling_code = l.sellingCode;
    const s = a.getAbutment();
    if (s) {
      const c = s.getAbutmentInfo();
      o.abutment.model = c.modelName, o.abutment.name = c.name, o.abutment.selling_code = c.abutmentSellingCode;
    }
    const i = a.getSleeve();
    if (i) {
      const c = i.getSleeveInfo();
      t.project.sleeve_list[c.sellingCode] = t.project.sleeve_list[c.sellingCode] + 1, o.sleeve.name = c.originalName, o.sleeve.model = c.modelName, o.sleeve.drill_length = i.getDrillLength(), o.sleeve.selling_code = c.sellingCode, o.sleeve.offset = i.getDistanceFromImplant(), o.sleeve.d_internal = c.dInternal, o.sleeve.d_external = c.dExternal;
    }
    t.project.implants.push(o);
  }), t.project.pins = [], e.objects.pins.forEach((a) => {
    const o = $h(), l = a.getProjectPinInfo();
    o.position = a.getName(), o.producer = l.manufacturerName, o.model = l.modelName;
    const s = a.getSleeve();
    if (s) {
      const i = s.getSleeveInfo();
      o.sleeve.name = i.originalName, o.sleeve.model = i.modelName, o.sleeve.selling_code = i.sellingCode, o.sleeve.d_internal = i.dInternal, o.sleeve.d_external = i.dExternal;
    }
    t.project.pins.push(o);
  }), t.project.sleeve_list = {}, t.project.sleeve_list["3DM00986"] = 1;
  for (const [a, o] of Object.entries(t.project.sleeve_list))
    t.project.sleeve_list[a] = o;
  return t;
}
function ug(e) {
  switch (e.layoutManager.wizardTabIndex.get()) {
    case we.VOI_SETTINGS:
      return nt("implant-planner.voiSettings");
    case we.THREED_SETTINGS:
      return nt("implant-planner.threedSettings");
    case we.DATA_IMPORT:
      return nt("implant-planner.dataImport");
    case we.CPR_SETTINGS:
      return nt("implant-planner.cprSettings");
    case we.NERVE_DRAWING:
      return nt("implant-planner.nerveSettings");
    case we.TEETH_SETUP:
      return nt("implant-planner.teethSetup");
    case we.IMPLANT_PLANNING:
      return nt("implant-planner.implantPlanning");
    default:
      return nt("implant-planner.newProject");
  }
}
const q2 = /^[\p{L}\p{M}0-9._@+()\- ]{1,128}$/u;
function Q2(e) {
  return q2.test(e);
}
function dp({ isWeblinkLoader: e, isWeblinkViewer: t, project: n, fileHash: a }) {
  var l;
  const o = n && a ? ps(n, a) : (l = n == null ? void 0 : n.projectFileList) == null ? void 0 : l.find((s) => s.id === n.projectFileId || s.name === n.projectFilename);
  return !!(e || t || n != null && n.weblinkOrderData || (o == null ? void 0 : o.type) === ga.ProjectAttachment || o != null && o.weblinkOrderData);
}
function ps(e, t) {
  const n = Array.isArray(t) ? t[0] : t;
  return n ? e.projectFileList.find((a) => a.uuid === n) : void 0;
}
function pp(e, t, n) {
  var o;
  const a = ps(e, t);
  return !!n && ((o = a == null ? void 0 : a.uploadedBy) == null ? void 0 : o.username) === n;
}
function eR(e) {
  var t;
  return typeof e.status == "number" && e.status >= 200 && e.status < 300 && ((t = e.data) == null ? void 0 : t.success) === !0 && Number.isInteger(e.data.fileId) && (e.data.fileId ?? 0) > 0 && typeof e.data.uuid == "string" && e.data.uuid.trim().length > 0;
}
function mp(e) {
  var t, n;
  return e.status === 409 && !((t = e.data) != null && t.message) || /file[\s_-]*(?:already[\s_-]*)?exists|filename[\s_-]*(?:already[\s_-]*)?exists/i.test(((n = e.data) == null ? void 0 : n.message) ?? "");
}
const tR = ["src"], nR = { class: "flex flex-col grow min-w-0" }, aR = { for: "filename" }, oR = {
  key: 0,
  class: "p-error"
}, lR = {
  key: 1,
  class: "p-error"
}, iR = {
  key: 1,
  class: "flex flex-col content-center justify-center"
}, sR = { class: "mt-4 text-2xl mb-2 flex justify-center" }, rR = { class: "mt-4 text-2xl mb-2 flex justify-center" }, uR = { class: "mt-4 text-2xl mb-2 flex justify-center" }, cR = { class: "mt-4 text-2xl mb-2 flex justify-center" }, Qu = /* @__PURE__ */ qe({
  __name: "SaveProjectComponent",
  setup(e) {
    const { t } = Yt(), n = Xn("dialogRef"), a = Es(), o = n.value.data, l = F(
      o.isSaveAs ? 4 : 0
      /* SAVING */
    );
    ot(l, (N) => {
      N === 2 && o.context.setModified(!1);
    });
    const s = F([
      {
        label: t("implant-planner.savingProject"),
        state: 0
        /* SAVING */
      },
      {
        label: t("implant-planner.uploadingToCloud"),
        state: 1
        /* UPLOADING */
      },
      {
        label: t("shared.done"),
        state: 2
        /* DONE */
      }
    ]), i = ml(), c = F(i.getUser()), u = F(lh(c.value)), p = mi(), b = F(0), f = gl(), h = Jn(), I = F("");
    let m = !1;
    const S = F(!1), E = F("");
    let g = null;
    const v = () => {
      var N;
      (N = o.onComplete) == null || N.call(o), n.value.close();
    };
    function T() {
      l.value++;
      for (let [N, x] of s.value.entries())
        x.class = N === l.value ? "p-highlight p-steps-current" : "";
    }
    async function R() {
      var Re, U;
      if (S.value) return;
      S.value = !0, E.value = "";
      const N = g == null ? void 0 : g.project;
      let x = f.params.fileHash, z = f.params.projectHash;
      if (!N) {
        l.value = 3, S.value = !1;
        return;
      }
      const X = N.projectFileList.length === 0, H = dp({
        isWeblinkLoader: X,
        fileHash: f.params.fileHash,
        isWeblinkViewer: o.implantPlannerViewMode === bt.WeblinkViewer,
        project: N
      }), M = ps(N, f.params.fileHash), te = !H && !pp(N, f.params.fileHash, (Re = c.value) == null ? void 0 : Re.username), ne = !H && M ? M.name : N.projectFilename, W = (ie) => {
        E.value = ie, l.value = 4, S.value = !1;
      };
      if (!H && !M) {
        W(t("shared.errorWhileCopyingProjectFile"));
        return;
      }
      const se = async (ie) => {
        m = !1;
        try {
          const re = await h.copyProject(N.patientName, ne, I.value.replaceAll(".zip", "") + ".zip", ie);
          return eR(re) ? (m = !0, x = re.data.uuid, !0) : (W(t(mp(re) ? "implant-planner.projectNameAlreadyExistsChooseDifferent" : "shared.errorWhileCopyingProjectFile")), !1);
        } catch (re) {
          const q = re == null ? void 0 : re.response;
          return W(t(q && mp(q) ? "implant-planner.projectNameAlreadyExistsChooseDifferent" : "shared.errorWhileCopyingProjectFile")), !1;
        }
      }, be = async () => {
        var ie, re;
        try {
          l.value = 0;
          const q = (xe, k) => {
            k && T(), b.value = xe;
          };
          if (!await qu(o.context, o.projectData, !1, {
            fileName: I.value.replaceAll(".zip", ""),
            project: N,
            serverApi: h,
            progressCallback: q,
            gradientBackground: !0,
            createDate: (/* @__PURE__ */ new Date()).toISOString(),
            isWeblinkLoader: X,
            isWeblinkProject: H,
            isWeblinkOperator: u.value
          })) {
            m && await h.deleteProjectFile(N.patientName, I.value.replaceAll(".zip", "") + ".zip"), l.value = 3;
            return;
          }
          b.value = 100;
          let _e = await o.projectLoader.getProjectInfo(f.params);
          if (_e != null && _e.project) {
            const xe = _e.project.projectFileList.find((k) => k.name == I.value.replaceAll(".zip", "") + ".zip");
            if (xe) {
              const k = _e.projectFullName.replace(_e.project.projectFilename, I.value + ".zip");
              o.context.projectName = k.replaceAll(".zip", ""), o.context.projectFullName.set(k), o.context.fileHash = xe.uuid, await a.push({
                name: "ImplantPlannerProjectLoaderView",
                params: {
                  fileHash: xe.uuid,
                  projectHash: z
                }
              });
            } else {
              let k = "";
              const { firstName: K, lastName: Ae } = ((ie = _e.patientInfo) == null ? void 0 : ie.extra) || {}, me = _e.projectFullName.replace(_e.project.projectFilename, `${I.value}.zip`);
              k = K && Ae ? `${K} ${Ae} // ${me}` : me, o.context.projectName = me.replaceAll(".zip", ""), o.context.projectFullName.set(k), o.context.fileHash = Array.isArray(x) ? x[0] : x, await a.push({
                name: "ImplantPlannerProjectLoaderView",
                params: {
                  fileHash: x,
                  projectHash: f.params.projectHash
                }
              });
            }
          }
          await ((re = o.onSuccess) == null ? void 0 : re.call(o)), T();
        } catch (q) {
          console.error(q), l.value = 3;
        } finally {
          S.value = !1;
        }
      };
      if (X) {
        const ie = N.projectFilename.replaceAll(".zip", "") === I.value, re = t(ie ? "shared.projectAlreadyExistsDoYouWantToReplaceIt" : "shared.doYouWantToSaveTheProject");
        l.value = 0;
        let q = !1;
        p.require({
          message: re,
          header: t("implant-planner.saveProject"),
          onHide: () => {
            q || (l.value = 4, S.value = !1);
          },
          accept: async () => {
            if (!q) {
              if (q = !0, m = !1, !ie && !await se(ga.ProjectAttachmentPreview)) {
                p.close();
                return;
              }
              l.value = 0, await be(), p.close();
            }
          },
          reject: () => {
            S.value = !1, p.close(), o.onComplete && o.onComplete(), n.value.close();
          }
        });
        return;
      } else {
        const ie = !!((U = N == null ? void 0 : N.projectFileList) != null && U.some((q) => (q == null ? void 0 : q.name.replaceAll(".zip", "")) === (I == null ? void 0 : I.value.replaceAll(".zip", ""))));
        if (te && I.value.replaceAll(".zip", "") === ne.replaceAll(".zip", "")) {
          W(t("implant-planner.cannotOverwriteForeignProject"));
          return;
        }
        if (te && ie) {
          W(t("implant-planner.projectNameAlreadyExistsChooseDifferent"));
          return;
        }
        const re = t(ie ? "shared.projectAlreadyExistsDoYouWantToReplaceIt" : "doYouWantToSaveTheProject");
        if (m = !1, ie) {
          l.value = 0;
          let q = !1;
          p.require({
            message: re,
            header: t("implant-planner.warning"),
            icon: "pi pi-exclamation-triangle",
            onHide: () => {
              q || (l.value = 4, S.value = !1);
            },
            accept: async () => {
              q || (q = !0, l.value = 0, await be(), p.close());
            },
            reject: () => {
              l.value = 4, S.value = !1, p.close();
            }
          });
        } else {
          if (l.value = 0, !await se()) return;
          await be();
        }
      }
    }
    const L = () => {
      !A.value || S.value || R();
    }, C = (N) => {
      if (N.key === "Enter") {
        if (l.value === 2 || l.value === 3) {
          N.preventDefault(), v();
          return;
        }
        l.value === 4 && A.value && (N.preventDefault(), L());
      }
    };
    Mt(async () => {
      var X, H, M;
      window.addEventListener("keydown", C), g = await o.projectLoader.getProjectInfo(f.params);
      const N = g == null ? void 0 : g.project, x = N && !dp({
        fileHash: f.params.fileHash,
        isWeblinkLoader: N.projectFileList.length === 0,
        isWeblinkViewer: o.implantPlannerViewMode === bt.WeblinkViewer,
        project: N
      }), z = x ? (X = ps(N, f.params.fileHash)) == null ? void 0 : X.name : void 0;
      I.value = ((H = z ?? (N == null ? void 0 : N.projectFilename)) == null ? void 0 : H.replaceAll(".zip", "")) ?? "", x && !pp(N, f.params.fileHash, (M = c.value) == null ? void 0 : M.username) && (l.value = 4), l.value == 0 && await R();
    }), On(() => {
      window.removeEventListener("keydown", C);
    });
    const A = Te(() => Q2(I.value)), j = Te(() => c.value.username !== o.projectOwner && !u.value);
    return (N, x) => {
      const z = Mu, X = h2, H = jm;
      return O(), J(ze, null, [
        l.value === 4 ? (O(), he(r(Be), {
          key: 0,
          class: "items-center justify-center gap-4"
        }, {
          default: w(() => [
            r(j) ? (O(), he(r(Be), {
              key: 0,
              class: "gap-2 pb-6 items-center"
            }, {
              default: w(() => [
                y("img", {
                  class: "svg-icon",
                  src: r(ih)("icon_top_nav_info")
                }, null, 8, tR),
                y("span", null, V(N.$t("implant-planner.noticeSavedProjectVisibleToOwner", { owner: r(o).projectOwner })), 1)
              ]),
              _: 1
            })) : ue("", !0),
            d(r(Be), { class: "gap-4 pt-4 items-start" }, {
              default: w(() => [
                y("div", nR, [
                  d(r(Qn), { class: "w-full" }, {
                    default: w(() => [
                      d(z, {
                        id: "filename",
                        class: "w-full h-56px",
                        modelValue: I.value,
                        "onUpdate:modelValue": x[0] || (x[0] = (M) => I.value = M),
                        onKeydown: x[1] || (x[1] = Zg(ka((M) => r(A) && L(), ["prevent"]), ["enter"]))
                      }, null, 8, ["modelValue"]),
                      y("label", aR, V(N.$t("implant-planner.filename")), 1)
                    ]),
                    _: 1
                  }),
                  E.value ? (O(), J("small", oR, V(E.value), 1)) : ue("", !0),
                  I.value && !r(A) ? (O(), J("small", lR, V(N.$t("implant-planner.filenameValidationHint")), 1)) : ue("", !0)
                ]),
                d(r(Ce), {
                  class: "h-56px flex grow",
                  label: N.$t("shared.save"),
                  addEnterListener: !0,
                  disabled: !r(A) || S.value,
                  onClick: L
                }, null, 8, ["label", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : ue("", !0),
        l.value !== 4 ? (O(), J("div", iR, [
          d(X, {
            class: "mt-4",
            model: s.value,
            "active-step": l.value,
            "aria-label": "Form Steps"
          }, null, 8, ["model", "active-step"]),
          l.value === 0 ? (O(), J(ze, { key: 0 }, [
            y("p", sR, V(N.$t("implant-planner.savingProject")), 1),
            d(H, { animationDuration: "0.6s" })
          ], 64)) : ue("", !0),
          l.value === 1 ? (O(), J(ze, { key: 1 }, [
            y("p", rR, V(N.$t("shared.uploadingProject")), 1),
            d(r(gi), {
              value: b.value,
              showValue: !1,
              style: { height: "2rem" },
              pt: { value: { style: { transition: "none" } } }
            }, {
              default: w(() => [
                yt(V(b.value.toFixed(0)) + " % ", 1)
              ]),
              _: 1
            }, 8, ["value"])
          ], 64)) : ue("", !0),
          l.value === 2 ? (O(), J(ze, { key: 2 }, [
            y("p", uR, V(N.$t("implant-planner.projectSaved")), 1),
            d(r(Ce), {
              label: N.$t("shared.close"),
              addEnterListener: !0,
              onClick: v
            }, null, 8, ["label"])
          ], 64)) : ue("", !0),
          l.value === 3 ? (O(), J(ze, { key: 3 }, [
            y("p", cR, V(N.$t("implant-planner.errorWhileUploading")), 1),
            d(r(Ce), {
              class: "h-56px",
              label: N.$t("shared.close"),
              addEnterListener: !0,
              onClick: v
            }, null, 8, ["label"])
          ], 64)) : ue("", !0)
        ])) : ue("", !0)
      ], 64);
    };
  }
});
function ec() {
  return {
    [we.VOI_SETTINGS]: Ve._FULLSCREEN_3D,
    [we.THREED_SETTINGS]: Ve._FULLSCREEN_3D,
    [we.DATA_IMPORT]: Ve._FULLSCREEN_3D,
    [we.CPR_SETTINGS]: Ve._CPR_SETTINGS_WIZARD,
    [we.NERVE_DRAWING]: Ve._NERVE_DRAWING_WIZARD,
    [we.TEETH_SETUP]: Ve._LARGE_3D_MPR,
    [we.IMPLANT_PLANNING]: Ve._3D_CPR_CROSS_TANGENT_AXIAL,
    [we.GUIDE_DESIGN]: Ve._FULLSCREEN_3D,
    [we.REPORTS_EXPORT]: Ve._3D_CROSS_CPR
  };
}
const dR = { class: "layout-dialog-grid mt-6" }, pR = ["onClick"], mR = ["src"], fR = { class: "flex items-center justify-center layout-dialog-grid-item-label" }, gR = /* @__PURE__ */ qe({
  __name: "IPLayoutDialogStlLibrary",
  props: {
    modelValue: {}
  },
  emits: ["updateLayout"],
  setup(e, { emit: t }) {
    const n = e, a = et({
      wizardIndex: -1,
      oldLayout: Ve._STL_PICKER_PREVIEW,
      newLayout: void 0,
      availableLayouts: a0(),
      wizardPanelVisible: !1
    }), o = t, l = F(Number(n.modelValue.oldLayout));
    Wa(() => {
      n.modelValue && Object.assign(a, n.modelValue);
    }), Mt(() => {
      n.modelValue && Object.assign(a, n.modelValue);
    });
    const s = (u) => {
      l.value = u, o("updateLayout", Object.keys(Ve).indexOf(u.toString()));
    }, i = ia(), c = (u, p) => {
      console.log(u, p);
      const b = u === p ? "/img/" + u + "_selected.png" : "/img/" + u + "_not_selected.png";
      return i.getAssetUrl(b);
    };
    return (u, p) => (O(), J("div", dR, [
      (O(!0), J(ze, null, Rt(a.availableLayouts, (b) => (O(), J("div", {
        key: b.name,
        class: "pointer flex flex-col items-center",
        onClick: (f) => s(b.code)
      }, [
        y("div", null, [
          y("img", {
            src: c(b.code, l.value),
            alt: "",
            draggable: "false"
          }, null, 8, mR),
          y("span", fR, V(b.name), 1)
        ])
      ], 8, pR))), 128))
    ]));
  }
}), tc = /* @__PURE__ */ $t(gR, [["__scopeId", "data-v-94c2bd17"]]), nc = /* @__PURE__ */ qe({
  __name: "IPTeethSetupContainerCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = F([]), a, o = F("");
    const l = F(Math.random());
    let s = F();
    const i = Ra(), c = Aa(), u = Po();
    let p, b = !1;
    const f = t;
    On(() => {
      b = !1, h == null || h.cleanup(), u.disableNavbarButtons([Ie.UNDO, Ie.REDO]);
    });
    let h = null;
    return Mt(async () => {
      b = !0, u.enableNavbarButtons([Ie.UNDO, Ie.REDO]);
      const I = document.getElementById("wizard-container");
      h = I ? cu(I) : null;
      const m = new so([0, 0]), S = F(document.getElementById("wizard-container")), E = S.value ? S.value.getBoundingClientRect() : { width: 0, height: 0 };
      m.set([(E == null ? void 0 : E.width) * 2 / 3, E == null ? void 0 : E.height]);
      const g = () => {
        var x, z;
        const j = (x = S.value) == null ? void 0 : x.getBoundingClientRect();
        if (!j) return;
        const N = (z = S.value) == null ? void 0 : z.children[2];
        if (N) {
          const H = Array.from(N.children).find((M) => M instanceof HTMLDivElement && M.style.display !== "none");
          if (H instanceof HTMLDivElement) {
            const M = H.getBoundingClientRect();
            m.set([M.width, M.height]);
            return;
          }
        }
        m.set([j.width * 2 / 3, j.height]);
      };
      ru(S, () => {
        g();
      }), p = pn(), p.showLoading(nt("implant-planner.loadingTeethSetup"), !1, void 0, !0), p.setCADMode(!0), p.contextCAD.GetMainForm().SetJSLambda((j) => {
        b && (j ? (n.value = j.GetWidgetOrder().slice(), a = j.GetWidgets(), o.value = j.GetToolTitle(), console.log("xDynamicGUIParser JS Retrieving GUI FROM LAMBDA - order title", j.GetToolTitle())) : (console.log("toolWidget == nullptr"), n.value = [], a = void 0, o.value = ""), l.value = Math.random());
      }, qt.eJSLT_RETIEVE_GUI), p.contextCAD.GetMainForm().SetJSLambda((j) => {
        b && (j ? g() : R());
      }, qt.eJSLT_UPDATE_OBJECT_TREE_LIST);
      let v;
      const T = new so({ items: [] }), R = () => {
        T.set(v());
      };
      v = () => {
        try {
          const j = p.contextCAD.GetMainForm().GetWasmObjectListItems(), N = [];
          for (let X = 0; X < j.size(); X++) {
            const H = j.get(X), M = H.GetGroup(), te = H.GetColor();
            N.includes(M) || N.push(M);
          }
          const x = [];
          for (let X = 0; X < N.length; X++) {
            const H = [];
            for (let M = 0; M < j.size(); M++) {
              const te = j.get(M);
              if (N[X] === te.GetGroup()) {
                const ne = te.GetColor();
                H.push({
                  key: te.GetId(),
                  label: te.GetLabel(),
                  visible: te.GetState(),
                  color: [ne.get(0), ne.get(1), ne.get(2)],
                  onClick: (W) => {
                    p.contextCAD.GetMainForm().WasmObjectListItemClicked(W, !0);
                  },
                  onSelect: (W) => {
                    p.contextCAD.GetMainForm().WasmObjectListItemClicked(W, !0);
                  },
                  onUnselect: (W) => {
                    p.contextCAD.GetMainForm().WasmObjectListItemClicked(W, !1);
                  }
                });
              }
            }
            x.push({
              key: N[X],
              label: N[X],
              children: H
            });
          }
          return {
            items: x
          };
        } catch (j) {
          return console.error("Error in getObjectListItems", j), { items: [] };
        }
      };
      const L = (j) => {
        const N = p.contextCAD.GetMainForm().WasmObjectListContextMenuClicked(j);
        return pu(N);
      };
      await p.setTabIndex(30), s.value = p.contextCAD.tabWidgetHandler, await gs({
        mainForm: p.contextCAD.GetMainForm(),
        widgetsOrder: n,
        isActive: () => b
      }), console.log("tabWidgetHandler", s), h == null || h.createVueOverlayComponent(
        du,
        {
          objectTree: T,
          viewSize: m,
          initialPosition: Ql.topRight,
          getContextMenuItems: L
          // parent: context.getOverlayContainer(),
          // dockEvent: () => {
          //     context.dockOverlays();
          // },
        },
        {
          noContainerResize: !0
        }
      );
      const C = h == null ? void 0 : h.createVueOverlayComponent(
        Mp,
        {
          viewSize: m,
          barSize: new so([220, 100]),
          initialPosition: Ql.bottomRight,
          // initialPosition: AnchorPosition.topRight,
          onWheelCallback: () => {
            p.contextCAD.GetMainForm().WasmScalarBarSetScalarBarScale(nn.getActiveScalarBarScale());
          },
          headerButtonClicked: (j) => {
            p.contextCAD.GetMainForm().WasmScalarBarHeaderButtonClicked(j);
          },
          contactsButtonClicked: () => {
            p.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!0);
          },
          modelContactsButtonClicked: () => {
            p.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!1);
          }
          // parent: context.getOverlayContainer(),
          // dockEvent: () => {
          //     context.dockOverlays();
          // },
        },
        {
          noContainerResize: !0
        }
      );
      C == null || C.setEnabled(!1);
      const A = (j, N, x, z, X, H, M, te, ne, W, se) => {
        console.log(
          "Update Contacts Widget",
          j,
          N,
          x,
          z,
          X,
          H,
          M,
          te,
          ne,
          W,
          se
        ), nn.updateTitle(N), C == null || C.setEnabled(z), nn.sReverseGradient.set(se), nn.sHint.set(x), nn.setActiveScalarBarMode(j), nn.contactsButtonVisible.set(X), nn.contactsButtonChecked.set(H), nn.modelContactsButtonVisible.set(M), nn.modelContactsButtonChecked.set(te), nn.headerButtonVisible.set(ne), nn.headerButtonChecked.set(W);
      };
      p.contextCAD.GetMainForm().SetJSLambda(
        (j, N, x, z, X, H, M, te, ne, W, se, be) => {
          b && (be || (console.log("Update Contacts Widget"), A(
            j,
            N,
            x,
            z,
            X,
            H,
            M,
            te,
            ne,
            W,
            se
          )));
        },
        qt.eJSLT_UPDATE_CONTACTS_WIDGET
      ), i.onEvent(p.onShowAddReconstructionDialog, (j) => {
        b && (console.log("Show Dialog", j.preSelectMode, j.preSelectWorkflow), c.open(Wf, {
          props: {
            modal: !0,
            showHeader: !1,
            contentStyle: {
              borderRadius: "16px",
              padding: "0 1.5rem",
              overflow: "hidden"
            }
          },
          data: {
            context: p,
            preselectedMode: j.preSelectMode
          },
          emits: {
            onConfirm: () => {
              console.log("Confirmed 0"), j.lambda(), console.log("Confirmed 1");
            },
            onReject: () => {
              console.log("Rejected 0"), j.lambda(), console.log("Rejected 1");
            }
          }
        }));
      }), p.hideLoading();
    }), On(() => {
      try {
        p.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), p.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_OBJECT_TREE_LIST), p.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_CONTACTS_WIDGET), p.setCADMode(!1), p.setTabIndex(1), h == null || h.cleanup();
      } catch (I) {
        console.error("Error during unmount: ", I);
      }
    }), (I, m) => (O(), he(r(at), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: w(() => [
        d(r(at), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: w(() => [
            r(n).length ? (O(), he(r(hs), {
              key: l.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(o)
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(at), { style: { flex: "0 0 auto" } }, {
          default: w(() => [
            r(s) ? (O(), he(r(bs), {
              key: 0,
              "tab-handler": r(s),
              context: r(p),
              onNextStepNested: m[0] || (m[0] = (S) => f("nextStepNested")),
              onPreviousStepNested: m[1] || (m[1] = (S) => f("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), hR = /* @__PURE__ */ qe({
  __name: "IPAppMenuContainer",
  setup(e) {
    const t = gl(), n = Ep();
    n.menuMode = vn.SIDEBAR, ot(t, () => {
      n.menuActive = !1;
    });
    function a() {
      console.log("onSidebarMouseOver "), n.menuMode === "sidebar" && !n.sidebarStatic && (n.sidebarActive = n.isDesktop(), console.log("model.sidebarActive: ", n.sidebarActive), setTimeout(() => {
        n.pinActive = n.isDesktop(), console.log("odel.pinActive: ", n.pinActive);
      }, 200));
    }
    function o() {
      n.menuMode === "sidebar" && !n.sidebarStatic && setTimeout(() => {
        n.sidebarActive = !1, n.pinActive = !1;
      }, 250);
    }
    function l() {
      n.menuClick = !0;
    }
    return Te(() => (n.sidebarActive, "")), (s, i) => (O(), J("div", null, [
      y("div", {
        class: He([{ "layout-sidebar-active": r(n).sidebarActive }, "layout-menu-wrapper margin-t-80px"]),
        style: { "margin-bottom": "0.5rem", background: "transparent", border: "1px solid rgba(255, 255, 255, 0)", width: "3.5rem", overflow: "hidden" },
        onClick: l,
        onMouseleave: o,
        onMouseover: a
      }, [
        d(r(at), null, {
          default: w(() => [
            St(s.$slots, "mainMenuTabs")
          ]),
          _: 3
        })
      ], 34)
    ]));
  }
}), bR = { class: "layout-menuitem-icon ml-1 flex justify-center" }, vR = { class: "ml-4 mt-1 layout-menuitem-text text-sm menu-item-color" }, yR = /* @__PURE__ */ qe({
  __name: "IPAppMenuItem",
  props: {
    modelValue: {},
    index: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = F(n.index === 0 ? "bg-purple-500" : "bg-purple-500 "), l = F(n.index);
    Wa(() => {
      o.value = n.modelValue == n.index ? "active-menuitem" : "", n.disabled && (o.value += " wizard-menu-item-disabled");
    });
    const s = () => {
      a("update:modelValue", n.index);
    }, i = Te(() => n.index === 0 ? "rounded-t" : n.index == 11 ? "rounded-b" : "rounded-none");
    return (c, u) => (O(), J("li", {
      class: He([[i.value, o.value], "bg-siderbar-item-wiz flex align-center"]),
      role: "menuitem"
    }, [
      y("a", {
        class: "p-ripple flex align-center cursor-pointer",
        role: "menuitem",
        onClick: s,
        style: { background: "transparent !important" }
      }, [
        y("i", bR, [
          d(r(su), {
            cIcon: l.value.toString(),
            isMenuIcon: !0
          }, null, 8, ["cIcon"])
        ]),
        y("span", vR, [
          St(c.$slots, "default", {}, void 0, !0)
        ])
      ])
    ], 2));
  }
}), _R = /* @__PURE__ */ $t(yR, [["__scopeId", "data-v-e6174a60"]]), wR = { style: { "text-align": "center", color: "white", "text-shadow": "0 1px 1px black" } }, SR = {
  key: 0,
  class: "mt-20",
  style: { width: "20vw" }
}, IR = { style: { display: "flex", "justify-content": "center" } }, ER = { style: { display: "flex", "justify-content": "center" } }, TR = { class: "ml-1 flex justify-center" }, CR = { class: "col-span-12" }, NR = {
  class: "ml-1 flex justify-start",
  style: { "white-space": "pre-wrap" }
}, LR = { class: "col-span-12" }, OR = {
  key: 0,
  id: "sidebarContainer",
  class: "flex flex-row-wrap",
  style: { "margin-top": "0.5rem", "margin-bottom": "0.5rem" }
}, DR = { class: "mainMenuTabs" }, AR = {
  class: "grow",
  style: { margin: "0 0.5rem" }
}, RR = /* @__PURE__ */ qe({
  __name: "IPProjectLoaderView",
  props: {
    loader: {},
    source: { default: al.IMPLANT_PLANNER }
  },
  setup(e) {
    const { t } = Yt(), n = Po(), a = e, o = a.loader(Jn()), l = Aa(), s = ia();
    let i = new ws(s.getAssetUrl(""));
    const c = F(), u = F(), p = F(!1), b = F(!0), f = F(!1), h = F(0), I = F(!1), m = F(Math.random()), S = F(!0), E = F(!1), g = F(0), v = F(), T = F("Loading project"), R = gl(), L = Mo(), C = oa(), { wizardLayouts: A } = Co(oa()), j = Es(), N = mu.actions, x = Ra();
    F(kn.REALGUIDE), F(!0);
    const z = F(a.source == al.IMPLANT_PLANNER ? bt.ImplantPlannerBase : bt.WeblinkViewer);
    Ss(i);
    const X = Te(() => p.value && !I.value ? "rgba(91, 91, 91, 0.5)" : "var(--webcad-main-bg)"), H = () => {
      const B = i.undoManager.getUndoDescription(), ye = i.undoManager.getRedoDescription(), Xe = B ? `Undo ${B}` : void 0, Ze = ye ? `Redo ${ye}` : void 0;
      let lt = [], ce = [];
      i.undoManager.canUndo() ? lt.push(Ie.UNDO) : ce.push(Ie.UNDO), i.undoManager.canRedo() ? lt.push(Ie.REDO) : ce.push(Ie.REDO), n.disableNavbarButtons(ce), n.enableNavbarButtons(lt);
      const Se = [
        { button: Ie.UNDO, tooltip: Xe },
        { button: Ie.REDO, tooltip: Ze }
      ];
      n.addTooltips(Se);
    }, M = F(!1), te = () => {
      M.value = !1;
    }, ne = F(!1), W = F(!1), se = ks(), be = () => {
      se.stlLibraryWindowVisible ? W.value = !0 : ne.value = !0;
    }, Re = F(!1), U = F(!1), ie = F(!1), re = F("");
    C.prepareDefaults(ec());
    const q = F(i.layoutManager.wizardTabIndex.get()), { menuMode: De } = Co(oa()), _e = Te(() => (De.value = De.value == vn.OVERLAY ? vn.SIDEBAR : De.value, De.value === vn.HORIZONTAL && p.value)), xe = Te(() => ({
      "bg-top-nav-bar-wiz dynamic-margin-left bg-body-wiz": !0,
      "mt-1 dynamic-margin-left": z.value === bt.WeblinkViewer || !_e.value
    })), k = Te(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": z.value !== bt.WeblinkViewer && !_e.value
    })), K = [
      {
        type: we.VOI_SETTINGS,
        tabLabel: "VOI Settings",
        component: Ou,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.THREED_SETTINGS,
        tabLabel: "3D Settings",
        component: Du,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.DATA_IMPORT,
        tabLabel: "Data Import",
        component: Au,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.CPR_SETTINGS,
        tabLabel: "CPR Settings",
        component: Ru,
        defaultLayout: Ve._CPR_SETTINGS_WIZARD
      },
      {
        type: we.NERVE_DRAWING,
        tabLabel: "Nerve Drawing",
        component: Pu,
        defaultLayout: Ve._NERVE_DRAWING_WIZARD
      },
      /*
      {
          type: WizardType.TEETH_SETUP,
          tabLabel: "Teeth Setup",
      },
      */
      {
        type: we.IMPLANT_PLANNING,
        tabLabel: "Implant Planning",
        component: zu,
        defaultLayout: Ve._3D_CPR_CROSS_TANGENT_AXIAL
      }
      /*
      {
          type: WizardType.REPORTS_EXPORT,
          tabLabel: "Reports / Export",
      },
      {
          type: WizardType.ADVANCED_TOOLS,
          tabLabel: "Advanced Tools",
      },
      {
          type: WizardType.OBJECT_LIST,
          tabLabel: "Object List",
      },
      */
      // {
      //     type: WizardType.GUIDE_DESIGN,
      //     tabLabel: "Guide Design",
      //     component: IPGuideDesignPrimaryComponentView,
      //     defaultLayout: LayoutTemplate._FULLSCREEN_3D,
      //     disabled: false,
      //     wizardsList: [
      //         {
      //             component: IPVolumeUndercutWizardView,
      //             stepName: "Volume Undercut",
      //         },
      //         {
      //             component: IPGuideDesignWizardView,
      //             stepName: "Guide Design",
      //         },
      //     ],
      // },
      /*
      {
          type: WizardType.SEGMENTATION,
          tabLabel: "Segmentation",
      },
      {
          type: WizardType.SANDBOX,
          tabLabel: "Sandbox",
      },
      {
          type: WizardType.PROJECT_SETUP,
          tabLabel: "Project Setup",
      },
      {
          type: WizardType.RECONSTRUCTION_SETUP,
          tabLabel: "Reconstruction Setup",
      },
      {
          type: WizardType.ACTIVE_RECONSTRUCTION,
          tabLabel: "Active Reconstruction",
      },
      */
    ];
    oo.SHOW_CAD_WIZARD && (K.push({
      type: we.CAD,
      tabLabel: "Cad",
      component: Yu,
      defaultLayout: Ve._3D_CPR_CROSS_TANGENT_AXIAL
    }), K.push({
      type: we.TEETH_SETUP,
      tabLabel: "Teeth Setup",
      component: nc,
      defaultLayout: Ve._FULLSCREEN_3D
    }));
    const Ae = F(K.find((B) => B.type === q.value));
    i.setModalsInstance(L), i.setResourceUrl("/resources/");
    const me = i.getEngineInstance();
    async function Ne(B, ye) {
      var lt, ce, Se;
      B.setRootElement(c.value), B.setCADRootElement(u.value), B.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (lt = B.getInteractorStyle()) == null || lt.setCameraInteractorEnabled(!0), (ce = B.getInteractorStyle()) == null || ce.setMouseMode(B.settings.general.useLeftButtonForRotationOn3d ? kn.REALGUIDE : kn.IMPLANTPLANNER), (Se = B.getInteractorStyle()) == null || Se.setMouseMode2D(kn.REALGUIDE), A.value[we.VOI_SETTINGS] !== void 0 && C.setWizardLayout(we.VOI_SETTINGS, Ve._FULLSCREEN_3D);
      for (const rt of Object.keys(A.value))
        B.layoutManager.storeLayout(rt.toString(), A.value[Number(rt)]);
      B.layoutManager.constructAllWindows();
      const Ze = B.layoutManager.getLayout(q.value.toString()) ?? B.layoutManager.getDefaultLayout();
      B.layoutManager.setLayout(Ze), Y(Ze);
    }
    const Ge = (B) => {
      se.stlLibraryWindowVisible ? (i.layoutManager.storeLayout("StlLibrary", B), i.layoutManager.setLayout(B)) : (i.layoutManager.storeLayout(q.value.toString(), B), i.layoutManager.setLayout(B), Y(B), C.setWizardLayout(q.value, B));
    }, Ue = () => {
      n.enableNavbarButtons([Ie.LAYOUT]);
    }, Ke = () => {
      n.disableNavbarButtons([Ie.LAYOUT]);
    }, st = () => {
      const B = K.findIndex((Ze) => Ze.type === q.value);
      if (B === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (B === K.length - 1) {
        console.warn("nextStep called on last wizard");
        return;
      }
      let ye = 0;
      B == we.CPR_SETTINGS && i.CPRType !== an.MANDIBLE && (ye = 1);
      const Xe = K[B + 1 + ye].type;
      i.layoutManager.wizardTabIndex.set(Xe), q.value = Xe, Q();
    }, G = () => {
      const B = K.findIndex((Ze) => Ze.type === q.value);
      if (B === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (B === 0) {
        console.warn("previousStep called on first wizard");
        return;
      }
      let ye = 0;
      B == 5 && i.CPRType !== an.MANDIBLE && (ye = 1);
      const Xe = K[B - 1 - ye].type;
      i.layoutManager.wizardTabIndex.set(Xe), q.value = Xe, Q();
    };
    x.onEvent(i.warningDialogEvent, (B) => {
      re.value = B, ie.value = !0;
    }), x.onEvent(i.screenshotUploadEvent, async ({ filename: B, image: ye }) => {
      var Ze, lt, ce;
      const Xe = (ce = (lt = (Ze = i.patientInfo) == null ? void 0 : Ze.extra) == null ? void 0 : lt.extra) == null ? void 0 : ce.study_instance_UID;
      if (Xe)
        try {
          await o.uploadScreenshot(Xe, B, ga.Image, ye), uo(t("weblink.successfullyUploadedScreenshot"));
        } catch (Se) {
          Tn(Se, t("web-rg.uploadFailed"));
        }
    }), x.watch(i.layoutBtnVisible, (B) => {
      B ? Ue() : Ke();
    }), x.watch(i.loadingFlag, (B) => {
      b.value = B, T.value = i.loadingText, f.value = i.progressBarFlag, h.value = i.progressBarValue.get(), I.value = i.nonTransparentLoading.get();
    }), x.watch(i.nextPrevVisible, (B) => {
      S.value = B, console.log("Setting nextprevFlag to:", B);
    }), x.watch(i.cadMode, (B) => {
      E.value = B, g.value = B ? 1 : 0, console.log("Setting cadMode to:", B);
    }), x.watch(i.progressBarValue, (B) => {
      h.value = B;
    }), x.watch(i.layoutManager.wizardTabIndex, () => {
      q.value = i.layoutManager.wizardTabIndex.get(), Q();
    });
    const P = F(!0);
    x.watch(i.tabButtonsEnabled, (B) => {
      P.value = B, console.log("TabButtonsEnabled", P.value);
    }), ot(q, (B) => {
      i.toolManager.activeTool.WindowLevel.set(!1), ju(), i.layoutManager.wizardTabIndex.set(B);
      let ye = i.layoutManager.getLayout(B.toString()) ?? i.layoutManager.getDefaultLayout();
      if (Ue(), le(), q.value === we.DATA_IMPORT && (i.layoutManager.storeLayout(we.DATA_IMPORT.toString(), Ve._FULLSCREEN_3D), ye = i.layoutManager.getLayout(B.toString()) ?? i.layoutManager.getDefaultLayout(), Ke()), q.value == we.CPR_SETTINGS && (i.layoutManager.storeLayout(we.CPR_SETTINGS.toString(), Ve._CPR_SETTINGS_WIZARD), ye = i.layoutManager.getLayout(B.toString()) ?? i.layoutManager.getDefaultLayout(), Ke()), q.value == we.NERVE_DRAWING && (i.objects.hasCPR() || (U.value = !0), i.layoutManager.storeLayout(we.NERVE_DRAWING.toString(), Ve._NERVE_DRAWING_WIZARD), ye = i.layoutManager.getLayout(B.toString()) ?? i.layoutManager.getDefaultLayout(), Ke()), q.value == we.GUIDE_DESIGN && (i.layoutManager.storeLayout(we.GUIDE_DESIGN.toString(), Ve._FULLSCREEN_3D), ye = i.layoutManager.getLayout(B.toString()) ?? i.layoutManager.getDefaultLayout(), Ke()), ((Ze) => {
        switch (console.log("setActiveTool wizard : ", Ze), Ze) {
          case we.CPR_SETTINGS:
            i.toolManager.setTool(un.CPR, Qt.PRIMARY);
            break;
          case we.NERVE_DRAWING:
            i.toolManager.setTool(un.NERVE, Qt.PRIMARY);
            break;
          case we.DATA_IMPORT:
            i.toolManager.setTool(un.MATCHING_TOOL, Qt.PRIMARY);
            break;
          default:
            i.toolManager.setTool(un.NONE, Qt.PRIMARY);
        }
      })(q.value), q.value === we.DATA_IMPORT && Ke(), !(q.value === we.CPR_SETTINGS || q.value === we.NERVE_DRAWING)) {
        const Ze = i.layoutManager.layoutTemplateContainsCpr(ye);
        Re.value = i.objects.hasCPR(), Ze && !Re.value && (ye = Ve._3D_MPR);
      }
      i.layoutManager.setLayout(ye), i.resize(), i.resetOrientation(), Y(ye), C.updateSelectedWizardIndex(q.value), le();
    });
    const de = () => {
      var ye, Xe;
      i.layoutManager.storeLayout(((ye = Ae.value) == null ? void 0 : ye.type.toString()) ?? "", ((Xe = Ae.value) == null ? void 0 : Xe.defaultLayout) ?? Ve._FULLSCREEN_3D);
      const B = i.layoutManager.getLayout(q.value.toString()) ?? i.layoutManager.getDefaultLayout();
      i.layoutManager.setLayout(B), ne.value = !1, Y(B);
    }, fe = () => {
      const B = i.layoutManager.getLayout("StlLibrary");
      B !== void 0 && i.layoutManager.setLayout(B), W.value = !1;
    }, ke = F(), le = () => {
      v.value && n.showProjectOnNavbar(v.value);
    };
    ot(p, () => {
      p.value && n.showNavbar({
        buttons: Bu(z.value),
        showZimvieLogo: !1,
        showNavbarPosition: !0,
        isWizard: !0
      });
    }), Mt(async () => {
      var lt, ce;
      console.log("legacy wizard"), n.showOnlyLogo(), (lt = document.getElementById("top-navbar-container")) == null || lt.classList.add("bg-body-wiz"), i.undoManager.onUndoChange.subscribe(H), H(), i.toolManager.onUndoManagerChange.subscribe(H), i.toolManager.onUndoManagerPop.subscribe(H), z.value === bt.WeblinkViewer && (dt(), vt()), console.log("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const B = performance.now(), ye = await me;
      Is(ye), console.log("engine await: ", performance.now() - B), await pe(R.params), await ((ce = i.contextCAD) == null ? void 0 : ce.LoadCADResources()), z.value === bt.WeblinkViewer && (i.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING), q.value = we.IMPLANT_PLANNING, Q()), i.objects.hasCPR() && i.objects.initializeCPRCurve(), i.objects.hasCPR() && (i.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING), q.value = we.IMPLANT_PLANNING, Q()), D(), le(), Vt(kt), z.value === bt.WeblinkViewer && (i.readOnly = !0, i.objects.lockUnlockAllImplantPins(!0)), i.objects.checkCollisions(), p.value = !0, b.value = !1;
      const Xe = i.getOverlayContainer(), Ze = document.createElement("div");
      Ze.id = "stlLibraryContainer", Ze.style.position = "absolute", Ze.style.pointerEvents = "none", Ze.style.userSelect = "none", Ze.style.inset = "0px", Xe.appendChild(Ze), i.sceneRepaint();
    }), On(() => {
      i && p.value && i.cleanup();
    });
    async function pe(B) {
      f.value = !0, h.value = 0, m.value = Math.random();
      const ye = await o.getProjectInfo(B);
      if (!ye) {
        console.error("Project not found");
        return;
      }
      const Xe = ye.project;
      i.patientInfo = ye.patientInfo, v.value = ye.projectFullName, le(), ke.value = Xe.patientName, f.value = !0, h.value = 5, m.value = Math.random();
      const Ze = (lt) => {
        h.value = lt.loaded / lt.total * 100, m.value = Math.random();
      };
      await o.loadProject(Xe, i, Ne, Ze);
    }
    const Z = (B) => {
      i.objects.unSelectObject();
      const ye = o.getLoadedProjectData();
      i && ye && l.open(Qu, {
        props: {
          closable: !1,
          modal: !0,
          header: t("implant-planner.saveProject"),
          style: { width: "50vw" }
        },
        data: {
          context: i,
          projectData: ye,
          isSaveAs: B,
          projectLoader: o,
          implantPlannerViewMode: z.value
        }
      });
    }, ee = et(rl()), $ = et(rl()), _ = r(De);
    function D() {
      z.value === bt.WeblinkViewer ? xu() : De.value === vn.HORIZONTAL ? cl() : ul();
    }
    Ka(() => {
      Wt(kt), _ === vn.HORIZONTAL && z.value === bt.WeblinkViewer ? cl() : _ === vn.SIDEBAR && z.value === bt.WeblinkViewer && ul();
    });
    const Y = (B) => {
      ee.oldLayout = B, ee.newLayout = B;
    };
    function Q() {
      const B = K.find((ye) => ye.type === q.value);
      B && (Ae.value = B);
    }
    function ae() {
      var B;
      if (q.value === we.DATA_IMPORT)
        return {
          patientName: ke.value
        };
      if (q.value === we.GUIDE_DESIGN)
        return {
          wizardsList: (B = Ae == null ? void 0 : Ae.value) == null ? void 0 : B.wizardsList
        };
      if (q.value === we.IMPLANT_PLANNING && z.value === bt.WeblinkViewer)
        return {
          isReadOnly: !0
        };
    }
    const ge = Te(() => q.value === 0), Fe = Te(() => q.value === K[K.length - 1].type), Me = () => {
      Q();
    }, je = () => {
      console.log("IPProjectLoaderView.vue: doneFromSteps clicked -");
    }, dt = () => {
      n.disableNavbarButtons([Ie.UNDO, Ie.REDO, Ie.SAVE, Ie.SAVE_AS, Ie.RESET, Ie.RULER, Ie.SETTINGS]);
    };
    async function vt() {
      await fl().loadSTLLibrary();
    }
    ot(
      () => C.colorScheme,
      () => {
        i.setColorScheme(C.colorScheme);
      },
      {
        immediate: !0
      }
    );
    async function mt() {
      await i.toolManager.destructAllTools(), z.value === bt.WeblinkViewer ? await j.push({ name: "Home", params: { name: R.params.name, id: ke.value } }) : await j.push({ name: "Patients", params: { id: ke.value } });
    }
    const kt = async (B) => {
      if (B === Ie.SAVE)
        Z();
      else if (B === Ie.SAVE_AS)
        Z(!0);
      else if (B === Ie.SETTINGS)
        M.value = !0;
      else if (B === Ie.RESET)
        i && (i.resetOrientation(), i.sceneRepaint());
      else if (B === Ie.LAYOUT)
        be();
      else if (B === Ie.SCREENSHOT) {
        const ye = await i.takeWindowScreenshotWebcad();
        if (ye) {
          const Xe = /* @__PURE__ */ new Date(), Ze = (rt) => String(rt).padStart(2, "0"), lt = `${i.projectInfo.projectFilename.replace(".zip", "")} ${Xe.getFullYear()}-${Ze(Xe.getMonth() + 1)}-${Ze(Xe.getDate())} at ${Ze(Xe.getHours())}.${Ze(Xe.getMinutes())}.${Ze(Xe.getSeconds())}.png`, ce = ye.toDataURL();
          if (ce) {
            const rt = document.createElement("a");
            document.body.appendChild(rt), rt.href = ce, rt.download = lt, rt.click(), window.URL.revokeObjectURL(ce);
          }
          const Se = await new Promise((rt) => ye.toBlob(rt, "image/png"));
          if (Se)
            try {
              await o.uploadScreenshot(i.patientInfo.extra.extra.study_instance_UID, lt, ga.Image, Se), uo(t("weblink.successfullyUploadedScreenshot"));
            } catch (rt) {
              Tn(rt, t("web-rg.uploadFailed"));
            }
        }
      } else if (B === Ie.W_L) {
        if (i) {
          const ye = i.toolManager.activeTool.WindowLevel.get();
          i.toolManager.activeTool.WindowLevel.set(!ye);
        }
      } else B === Ie.HELP ? await L.showViewerHelpModal() : B === Ie.INFO ? i.setInfoFlag(!i.getInfoFlag().get()) : B === Ie.UNDO ? await i.undoManager.undo() : B === Ie.REDO ? await i.undoManager.redo() : B === Ie.RULER_DISTANCE ? N.addNewDistanceMeasurement.notify() : B === Ie.RULER_ANGLE ? N.addNewAngleMeasurement.notify() : B === Ie.RULER_ANNOTATION ? N.addNewAnnotation.notify() : B === Ie.RULER_ROI ? N.addNewROIMeasurement.notify() : B === Ie.RULER_CLEAR ? N.clearAllMeasurements.notify() : B === Ie.ZIMVIE_LOGO ? await mt() : B === Ie.RG_LOGO ? await mt() : B === Ie.EXIT && await mt();
    };
    function Ct() {
      q.value = we.CPR_SETTINGS, Q();
    }
    const ft = /* @__PURE__ */ new WeakMap();
    function Vt(B) {
      const ye = (Xe) => {
        Promise.resolve().then(() => B(Xe)).catch((Ze) => {
          console.error("Navbar button handler failed", Ze), Tn(Ze instanceof Error ? Ze.message : String(Ze));
        });
      };
      ft.set(B, ye), ol.on(ll.NAVBAR_BUTTON_CLICKED, ye);
    }
    function Wt(B) {
      const ye = ft.get(B);
      ol.off(ll.NAVBAR_BUTTON_CLICKED, ye ?? B), ft.delete(B);
    }
    const jn = Te(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${_e.value ? 160 : 95}px + 100vh) !important`
    })), ra = Te(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${_e.value ? 155 : 90}px + 100vh) !important`
    }));
    return (B, ye) => {
      const Xe = Lu, Ze = Nu, lt = Cu;
      return O(), J(ze, null, [
        b.value ? (O(), J("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Tt({
            position: "absolute",
            inset: "0px",
            background: X.value,
            zIndex: "1000000",
            pointerEvents: "all",
            cursor: "wait"
          })
        }, [
          d(r(fs), { strokeWidth: 5 }, {
            default: w(() => [
              y("div", wR, V(T.value), 1),
              f.value ? (O(), J("div", SR, [
                (O(), he(r(gi), {
                  value: h.value,
                  key: m.value,
                  style: { height: "2rem" }
                }, {
                  default: w(() => [
                    yt(V(h.value.toFixed(0)) + " %", 1)
                  ]),
                  _: 1
                }, 8, ["value"]))
              ])) : ue("", !0)
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        d(r(Gn), {
          visible: ne.value,
          "onUpdate:visible": ye[1] || (ye[1] = (ce) => ne.value = ce),
          breakpoints: { "960px": "75vw", "640px": "100vw" },
          modal: !0,
          style: { width: "50vw" },
          header: B.$t("implant-planner.changeLayout")
        }, {
          footer: w(() => [
            y("div", IR, [
              d(r(Ce), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: B.$t("shared.ok"),
                onClick: ye[0] || (ye[0] = (ce) => ne.value = !1)
              }, null, 8, ["label"]),
              d(r(Ce), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: B.$t("shared.cancel"),
                onClick: de
              }, null, 8, ["label"])
            ])
          ]),
          default: w(() => [
            d(Xe, {
              "model-value": ee,
              onUpdateLayout: Ge
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: W.value,
          "onUpdate:visible": ye[3] || (ye[3] = (ce) => W.value = ce),
          breakpoints: { "960px": "45vw", "640px": "60vw" },
          modal: !0,
          style: { width: "30vw" },
          header: B.$t("implant-planner.changeLayout")
        }, {
          footer: w(() => [
            y("div", ER, [
              d(r(Ce), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: B.$t("shared.ok"),
                onClick: ye[2] || (ye[2] = (ce) => W.value = !1)
              }, null, 8, ["label"]),
              d(r(Ce), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: B.$t("shared.cancel"),
                onClick: fe
              }, null, 8, ["label"])
            ])
          ]),
          default: w(() => [
            d(tc, {
              "model-value": $,
              onUpdateLayout: Ge
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: U.value,
          "onUpdate:visible": ye[5] || (ye[5] = (ce) => U.value = ce),
          closable: !1,
          draggable: !1,
          modal: "",
          header: B.$t("implant-planner.warning"),
          style: { width: "25vw" }
        }, {
          default: w(() => [
            y("p", TR, V(B.$t("implant-planner.cprDoesNotExist")), 1),
            y("div", CR, [
              d(r(Ce), {
                class: "w-full",
                label: B.$t("implant-planner.goToCprSettings"),
                onClick: ye[4] || (ye[4] = (ce) => [Ct(), U.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: ie.value,
          "onUpdate:visible": ye[7] || (ye[7] = (ce) => ie.value = ce),
          closable: !1,
          draggable: !1,
          modal: "",
          header: re.value,
          style: { width: "25vw" }
        }, {
          default: w(() => [
            y("p", NR, V(r(i).warningString.get()), 1),
            y("div", LR, [
              d(r(Ce), {
                autofocus: "",
                class: "w-full",
                label: B.$t("shared.ok"),
                onClick: ye[6] || (ye[6] = (ce) => [ie.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        Pt(d(Ku, { class: "show-horizontal-bar horizontal-wizard-menu" }, {
          start: w(() => [
            (O(!0), J(ze, null, Rt(K, (ce) => (O(), he(Zu, {
              key: ce.type,
              modelValue: q.value,
              "onUpdate:modelValue": ye[8] || (ye[8] = (Se) => q.value = Se),
              index: ce.type,
              disabled: ce.disabled || !P.value,
              onClick: Me
            }, {
              default: w(() => [
                yt(V(ce.tabLabel), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "index", "disabled"]))), 128))
          ]),
          _: 1
        }, 512), [
          [sn, _e.value && z.value === r(bt).ImplantPlannerBase]
        ]),
        d(r(Ee), {
          id: "mainContainer",
          ref: "root",
          class: He(xe.value),
          style: { "margin-bottom": "0.5rem", "margin-left": "0.5rem", "margin-right": "0.5rem", "margin-top": "0 !important", border: "1px solid rgba(255, 255, 255, 0)", "border-radius": "8px" }
        }, {
          default: w(() => [
            p.value ? (O(), J("div", OR, [
              Pt(y("div", null, [
                y("div", DR, [
                  d(hR, null, {
                    mainMenuTabs: w(() => [
                      (O(!0), J(ze, null, Rt(K, (ce) => (O(), he(_R, {
                        key: ce.type,
                        modelValue: q.value,
                        "onUpdate:modelValue": ye[9] || (ye[9] = (Se) => q.value = Se),
                        index: ce.type,
                        disabled: ce.disabled || !P.value,
                        onClick: Me
                      }, {
                        default: w(() => [
                          yt(V(ce.tabLabel), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "index", "disabled"]))), 128))
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [sn, !_e.value && z.value === r(bt).ImplantPlannerBase]
              ]),
              d(r(Ee), {
                class: He(k.value),
                style: Tt(jn.value)
              }, {
                default: w(() => [
                  y("div", AR, [
                    d(Ze, {
                      isFirstItem: ge.value,
                      isVisible: !b.value && !E.value && S.value && z.value === r(bt).ImplantPlannerBase,
                      isLastItem: Fe.value,
                      onNextStep: st,
                      onPreviousStep: G
                    }, {
                      default: w(() => {
                        var ce;
                        return [
                          (O(), he(Ea(((ce = Ae.value) == null ? void 0 : ce.component) ?? {}), Pe(ae(), { onDone: je }), null, 16))
                        ];
                      }),
                      _: 1
                    }, 8, ["isFirstItem", "isVisible", "isLastItem"])
                  ])
                ]),
                _: 1
              }, 8, ["class", "style"])
            ])) : ue("", !0),
            d(r(Ee), {
              id: "wizard-container",
              style: Tt(ra.value)
            }, {
              default: w(() => [
                ue("", !0),
                ye[12] || (ye[12] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                Pt(y("div", {
                  ref_key: "vtkContainer",
                  ref: c,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden" }
                }, null, 512), [
                  [sn, !E.value]
                ]),
                Pt(y("div", {
                  ref_key: "vtkContainerCAD",
                  ref: u,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden", position: "relative" }
                }, null, 512), [
                  [sn, E.value]
                ]),
                ye[13] || (ye[13] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class"]),
        M.value ? (O(), he(lt, {
          key: 1,
          visible: !0,
          settings: r(i).settings,
          onConfirm: te,
          onCancel: te
        }, null, 8, ["settings"])) : ue("", !0)
      ], 64);
    };
  }
}), Rx = /* @__PURE__ */ $t(RR, [["__scopeId", "data-v-928ef00a"]]), MR = /* @__PURE__ */ qe({
  __name: "IPModelDesignCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = F([]), a, o = F("");
    const l = F(Math.random());
    let s = F();
    const i = Po();
    let c, u = !1;
    const p = t;
    let b = null;
    return Mt(async () => {
      u = !0, i.enableNavbarButtons([Ie.UNDO, Ie.REDO]);
      const f = document.getElementById("wizard-container");
      b = f ? cu(f) : null;
      const h = new so([0, 0]), I = F(document.getElementById("wizard-container")), m = I.value ? I.value.getBoundingClientRect() : { width: 100, height: 100 };
      h.set([Math.min(100, (m == null ? void 0 : m.width) * 2 / 3), Math.min(100, m == null ? void 0 : m.height)]);
      const S = () => {
        var j, N;
        const C = (j = I.value) == null ? void 0 : j.getBoundingClientRect();
        if (!C) return;
        const A = (N = I.value) == null ? void 0 : N.children[2];
        if (A) {
          const z = Array.from(A.children).find((X) => X instanceof HTMLDivElement && X.style.display !== "none");
          if (z instanceof HTMLDivElement) {
            const X = z.getBoundingClientRect();
            h.set([X.width, X.height]);
            return;
          }
        }
        h.set([C.width * 2 / 3, C.height]);
      };
      ru(I, () => {
        S();
      }), c = pn(), c.showLoading(nt("implant-planner.loadingCreateModel"), !1, void 0, !0), c.setCADMode(!0), c.contextCAD.GetMainForm().SetJSLambda((C) => {
        u && (console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI start toolwidget exists", !!C), C ? (n.value = C.GetWidgetOrder().slice(), a = C.GetWidgets(), o.value = C.GetToolTitle(), console.log(
          "000000 DynamicGUIComponent RETRIEVESTATICGUI widgets, order title",
          C.GetWidgetOrder().slice(),
          C.GetToolTitle(),
          C.GetWidgets()
        )) : (n.value = [], a = void 0, o.value = ""), l.value = Math.random(), console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI end"));
      }, qt.eJSLT_RETIEVE_GUI);
      const E = (C) => {
        u && (console.log("DEBUGG: finalizeCADWizard"), c.setCADMode(!1), c.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING));
      };
      c.contextCAD.GetMainForm().SetJSLambda(E, qt.eJSLT_FINALIZE_CAD_WIZARD);
      let g;
      const v = new so({ items: [] }), T = () => {
        v.set(g());
      };
      g = () => {
        try {
          const C = c.contextCAD.GetMainForm().GetWasmObjectListItems(), A = [];
          for (let x = 0; x < C.size(); x++) {
            const z = C.get(x), X = z.GetGroup(), H = z.GetColor();
            console.log(z.GetLabel(), X, z.GetState(), H.get(0), H.get(1), H.get(2)), A.includes(X) || A.push(X);
          }
          const j = [];
          for (let x = 0; x < A.length; x++) {
            const z = [];
            for (let X = 0; X < C.size(); X++) {
              const H = C.get(X);
              if (A[x] === H.GetGroup()) {
                const M = H.GetColor();
                z.push({
                  key: H.GetId(),
                  label: H.GetLabel(),
                  visible: H.GetState(),
                  color: [M.get(0), M.get(1), M.get(2)],
                  onClick: (te) => {
                    c.contextCAD.GetMainForm().WasmObjectListItemClicked(te, !0);
                  },
                  onSelect: (te) => {
                    c.contextCAD.GetMainForm().WasmObjectListItemClicked(te, !0);
                  },
                  onUnselect: (te) => {
                    c.contextCAD.GetMainForm().WasmObjectListItemClicked(te, !1);
                  }
                });
              }
            }
            j.push({
              key: A[x],
              label: A[x],
              children: z
            });
          }
          return {
            items: j
          };
        } catch (C) {
          return console.error("Error in getObjectListItems", C), { items: [] };
        }
      };
      const R = (C) => {
        const A = c.contextCAD.GetMainForm().WasmObjectListContextMenuClicked(C);
        return pu(A);
      };
      for (let C of c.objects.implants.values())
        await C.loadExtrusionParts();
      await c.setTabIndex(19) && (s.value = c.contextCAD.tabWidgetHandler, await gs({
        mainForm: c.contextCAD.GetMainForm(),
        widgetsOrder: n,
        isActive: () => u
      }), console.log("tabWidgetHandler", s), console.log("Creating Object List", b, h), b == null || b.createVueOverlayComponent(
        du,
        {
          objectTree: v,
          viewSize: h,
          initialPosition: Ql.topRight,
          getContextMenuItems: R
        },
        {
          noContainerResize: !0
        }
      ), c.contextCAD.GetMainForm().SetJSLambda((C) => {
        u && (C ? S() : T());
      }, qt.eJSLT_UPDATE_OBJECT_TREE_LIST), S(), T(), c.hideLoading());
    }), On(() => {
      u = !1, c.objects.implants.forEach((f) => {
        f.deleteExtrusionParts();
      }), b == null || b.cleanup(), i.disableNavbarButtons([Ie.UNDO, Ie.REDO]);
      try {
        c.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), c.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_OBJECT_TREE_LIST), c.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_FINALIZE_CAD_WIZARD), c.setCADMode(!1), c.setTabIndex(1);
      } catch (f) {
        console.error("Error during unmount: ", f);
      }
    }), (f, h) => (O(), he(r(at), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: w(() => [
        d(r(at), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: w(() => [
            r(n).length ? (O(), he(r(hs), {
              key: l.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(o),
              class: "mb-2"
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(at), { style: { flex: "0 0 auto" } }, {
          default: w(() => [
            r(s) ? (O(), he(r(bs), {
              key: 0,
              "tab-handler": r(s),
              context: r(c),
              onNextStepNested: h[0] || (h[0] = (I) => p("nextStepNested")),
              onPreviousStepNested: h[1] || (h[1] = (I) => p("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), PR = /* @__PURE__ */ qe({
  __name: "IPGuideDesignCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = F([]), a, o, l = F("");
    const s = F(Math.random());
    let i = F();
    const c = Po();
    let u, p = !1;
    const b = t;
    let f = null;
    return Mt(async () => {
      p = !0, c.enableNavbarButtons([Ie.UNDO, Ie.REDO]);
      const h = document.getElementById("wizard-container");
      f = h ? cu(h) : null;
      const I = new so([0, 0]), m = F(document.getElementById("wizard-container")), S = m.value ? m.value.getBoundingClientRect() : { width: 100, height: 100 };
      I.set([Math.min(100, (S == null ? void 0 : S.width) * 2 / 3), Math.min(100, S == null ? void 0 : S.height)]);
      const E = () => {
        var z, X;
        const N = (z = m.value) == null ? void 0 : z.getBoundingClientRect();
        if (!N) return;
        const x = (X = m.value) == null ? void 0 : X.children[2];
        if (x) {
          const M = Array.from(x.children).find((te) => te instanceof HTMLDivElement && te.style.display !== "none");
          if (M instanceof HTMLDivElement) {
            const te = M.getBoundingClientRect();
            I.set([te.width, te.height]);
            return;
          }
        }
        I.set([N.width * 2 / 3, N.height]);
      };
      ru(m, () => {
        E();
      }), u = pn(), u.showLoading(nt("implant-planner.loadingGuideDesign"), !1, void 0, !0), u.setCADMode(!0), u.contextCAD.GetMainForm().SetJSLambda((N) => {
        p && (console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI start toolwidget exists", !!N), N ? (o = N, n.value = N.GetWidgetOrder().slice(), a = N.GetWidgets(), l.value = N.GetToolTitle(), console.log(
          "000000 DynamicGUIComponent RETRIEVESTATICGUI widgets, order title",
          N.GetWidgetOrder().slice(),
          N.GetToolTitle(),
          N.GetWidgets()
        )) : (o = void 0, n.value = [], a = void 0, l.value = ""), s.value = Math.random(), console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI end"));
      }, qt.eJSLT_RETIEVE_GUI);
      const g = () => {
        p && (console.log("DEBUGG: finalizeCADWizard"), u.setCADMode(!1), u.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING));
      };
      u.contextCAD.GetMainForm().SetJSLambda(g, qt.eJSLT_FINALIZE_CAD_WIZARD);
      let v;
      const T = new so({ items: [] }), R = () => {
        T.set(v());
      };
      v = () => {
        try {
          const N = u.contextCAD.GetMainForm().GetWasmObjectListItems(), x = [];
          for (let H = 0; H < N.size(); H++) {
            const M = N.get(H), te = M.GetGroup(), ne = M.GetColor();
            console.log(M.GetLabel(), te, M.GetState(), ne.get(0), ne.get(1), ne.get(2)), x.includes(te) || x.push(te);
          }
          const z = [];
          for (let H = 0; H < x.length; H++) {
            const M = [];
            for (let te = 0; te < N.size(); te++) {
              const ne = N.get(te);
              if (x[H] === ne.GetGroup()) {
                const W = ne.GetColor();
                M.push({
                  key: ne.GetId(),
                  label: ne.GetLabel(),
                  visible: ne.GetState(),
                  color: [W.get(0), W.get(1), W.get(2)],
                  onClick: (se) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(se, !0);
                  },
                  onSelect: (se) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(se, !0);
                  },
                  onUnselect: (se) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(se, !1);
                  }
                });
              }
            }
            z.push({
              key: x[H],
              label: x[H],
              children: M
            });
          }
          return {
            items: z
          };
        } catch (N) {
          return console.error("Error in getObjectListItems", N), { items: [] };
        }
      };
      const L = (N) => {
        const x = u.contextCAD.GetMainForm().WasmObjectListContextMenuClicked(N);
        return pu(x);
      }, C = f == null ? void 0 : f.createVueOverlayComponent(
        Mp,
        {
          viewSize: I,
          barSize: new so([220, 100]),
          initialPosition: Ql.bottomRight,
          // initialPosition: AnchorPosition.topRight,
          onWheelCallback: () => {
            u.contextCAD.GetMainForm().WasmScalarBarSetScalarBarScale(nn.getActiveScalarBarScale());
          },
          headerButtonClicked: (N) => {
            u.contextCAD.GetMainForm().WasmScalarBarHeaderButtonClicked(N);
          },
          contactsButtonClicked: () => {
            u.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!0);
          },
          modelContactsButtonClicked: () => {
            u.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!1);
          }
          // parent: context.getOverlayContainer(),
          // dockEvent: () => {
          //     context.dockOverlays();
          // },
        },
        {
          noContainerResize: !0
        }
      );
      C == null || C.setEnabled(!1);
      const A = (N, x, z, X, H, M, te, ne, W, se, be) => {
        console.log(
          "Update Contacts Widget",
          N,
          x,
          z,
          X,
          H,
          M,
          te,
          ne,
          W,
          se,
          be
        ), nn.updateTitle(x), C == null || C.setEnabled(X), nn.sReverseGradient.set(be), nn.sHint.set(z), nn.setActiveScalarBarMode(N), nn.contactsButtonVisible.set(H), nn.contactsButtonChecked.set(M), nn.modelContactsButtonVisible.set(te), nn.modelContactsButtonChecked.set(ne), nn.headerButtonVisible.set(W), nn.headerButtonChecked.set(se);
      };
      u.contextCAD.GetMainForm().SetJSLambda(
        (N, x, z, X, H, M, te, ne, W, se, be, Re) => {
          p && (Re || A(
            N,
            x,
            z,
            X,
            H,
            M,
            te,
            ne,
            W,
            se,
            be
          ));
        },
        qt.eJSLT_UPDATE_CONTACTS_WIDGET
      ), u.objects.loadGuideObjectsParts(10, 5, 0.12), await u.setTabIndex(12) && (i.value = u.contextCAD.tabWidgetHandler, await gs({
        mainForm: u.contextCAD.GetMainForm(),
        widgetsOrder: n,
        getRootToolWidget: () => o,
        isActive: () => p
      }), f == null || f.createVueOverlayComponent(
        du,
        {
          objectTree: T,
          viewSize: I,
          initialPosition: Ql.topRight,
          getContextMenuItems: L
        },
        {
          noContainerResize: !0
        }
      ), u.contextCAD.GetMainForm().SetJSLambda((N) => {
        p && (N ? E() : R());
      }, qt.eJSLT_UPDATE_OBJECT_TREE_LIST), E(), R(), u.hideLoading());
    }), On(() => {
      if (p = !1, f == null || f.cleanup(), c.disableNavbarButtons([Ie.UNDO, Ie.REDO]), !(!u || u.isDestructed())) {
        u.objects.clearGuideObjectParts(!0, !0);
        try {
          u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_OBJECT_TREE_LIST), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_FINALIZE_CAD_WIZARD), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_CONTACTS_WIDGET), u.setCADMode(!1), u.setTabIndex(1);
        } catch (h) {
          console.error("Error during unmount: ", h);
        }
      }
    }), (h, I) => (O(), he(r(at), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: w(() => [
        d(r(at), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: w(() => [
            r(n).length ? (O(), he(r(hs), {
              key: s.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(l),
              class: "mb-2"
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(at), { style: { flex: "0 0 auto" } }, {
          default: w(() => [
            r(i) ? (O(), he(r(bs), {
              key: 0,
              "tab-handler": r(i),
              context: r(u),
              onNextStepNested: I[0] || (I[0] = (m) => b("nextStepNested")),
              onPreviousStepNested: I[1] || (I[1] = (m) => b("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), cg = /* @__PURE__ */ qe({
  __name: "IPAppMenuContainerRedesign",
  setup(e) {
    const t = gl(), n = Ep();
    n.menuMode = vn.SIDEBAR, ot(t, () => {
      n.menuActive = !1;
    });
    function a() {
      n.menuClick = !0;
    }
    return Te(() => (n.sidebarActive, "")), (o, l) => (O(), J("div", null, [
      y("div", {
        class: He([{ "layout-sidebar-active": r(n).sidebarActive }, "layout-menu-wrapper margin-t-80px"]),
        style: { "margin-bottom": "0.5rem", background: "transparent", border: "1px solid rgba(255, 255, 255, 0)", width: "108px", overflow: "hidden" },
        onClick: a
      }, [
        d(r(at), null, {
          default: w(() => [
            St(o.$slots, "mainMenuTabs")
          ]),
          _: 3
        })
      ], 2)
    ]));
  }
}), xR = { class: "layout-menuitem-icon ml-1 flex justify-center" }, jR = { class: "text-center layout-menuitem-text text-sm menu-item-color" }, FR = /* @__PURE__ */ qe({
  __name: "IPAppMenuItemRedesign",
  props: {
    modelValue: {},
    index: {},
    disabled: { type: Boolean, default: !1 },
    isLast: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = F(n.index === 0 ? "bg-purple-500" : "bg-purple-500 "), l = F(n.index);
    Wa(() => {
      o.value = n.modelValue == n.index ? "bg-primary-color" : "app-menu-btn", n.disabled && (o.value += " wizard-menu-item-disabled");
    });
    const s = () => {
      a("update:modelValue", n.index);
    }, i = Te(() => n.index === 0 ? "rounded-t" : [we.CAD_DESIGN, we.GUIDE_DESIGN, we.CREATE_MODEL].includes(n.index) || n.isLast ? "rounded-b" : "rounded-none");
    return (c, u) => (O(), he(r(at), {
      id: `btnTabMenuIndex_${n.index}`,
      class: He([i.value, o.value, "cursor-pointer align-center gap-2"]),
      style: Tt({ padding: "1.5rem 0.5rem", pointerEvents: n.disabled ? "none" : "auto", opacity: n.disabled ? "0.6" : "1" }),
      onClick: s
    }, {
      default: w(() => [
        d(r(Ee), null, {
          default: w(() => [
            y("i", xR, [
              d(r(su), {
                cIcon: l.value.toString(),
                isMenuIcon: !0
              }, null, 8, ["cIcon"])
            ])
          ]),
          _: 1
        }),
        d(r(Ee), null, {
          default: w(() => [
            y("span", jR, [
              St(c.$slots, "default", {}, void 0, !0)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id", "class", "style"]));
  }
}), dg = /* @__PURE__ */ $t(FR, [["__scopeId", "data-v-a7423a41"]]), $R = { class: "p-dialog-title" }, kR = { class: "p-dialog-header-actions" }, VR = { class: "flex flex-row-wrap grow gap-4 justify-center mt-4" }, BR = ["data-cy"], UR = {
  class: "wrapper-element",
  style: { "z-index": "1000" }
}, GR = { class: "ml-2 font-bold text-xl" }, WR = ["onMouseover", "onClick"], zR = /* @__PURE__ */ qe({
  __name: "IPSelectDesignComponent",
  emits: ["selected", "close"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = ia(), l = t, s = Mf(a.preselectedMode), i = document.createElement("div");
    Mt(() => {
      const h = document.getElementById("commentContainer");
      h ? h.appendChild(i) : console.log("commentContainer does not exist");
    });
    const c = Te(() => "col-span-12"), u = (h) => {
      i.innerHTML = h;
    }, p = () => {
      i.innerHTML = "";
    }, b = (h) => {
      let I = we.UNKNOWN;
      switch (h.reconstructionDesign) {
        case ve.eRD_GUIDE:
          I = we.GUIDE_DESIGN;
          break;
        case ve.eRD_ANALOGS_MODEL:
          I = we.CREATE_MODEL;
          break;
      }
      l("selected", I), n.value.close();
    }, f = () => {
      l("close"), n.value.close();
    };
    return (h, I) => {
      const m = Hu;
      return O(), he(r(Ee), {
        class: He([c.value, "flex-col"]),
        style: { overflow: "auto" }
      }, {
        default: w(() => [
          d(r(Be), {
            class: "p-dialog-header",
            style: { "user-select": "none" }
          }, {
            default: w(() => [
              y("div", $R, V(r(a).headerText), 1),
              y("div", kR, [
                d(r(Ce), {
                  icon: "pi pi-times",
                  background: !1,
                  onClick: f
                })
              ])
            ]),
            _: 1
          }),
          d(r(Ee), { class: "overflow-auto" }, {
            default: w(() => [
              y("div", VR, [
                (O(!0), J(ze, null, Rt(r(s), (S, E) => (O(), J("div", {
                  class: "item-element",
                  "data-cy": `design-${S.name}`,
                  key: E
                }, [
                  y("div", UR, [
                    y("span", GR, V(S.name), 1)
                  ]),
                  d(m, {
                    alt: S.name,
                    src: r(o).getAssetUrl(S.imageSrc),
                    "image-class": "small-image",
                    preview: "",
                    style: { width: "100%", height: "auto" },
                    pt: {
                      image: {
                        style: {
                          background: "transparent !important",
                          maxHeight: "17rem",
                          borderRadius: "8px"
                        }
                      },
                      previewMask: {
                        style: {
                          borderRadius: "8px"
                        }
                      }
                    }
                  }, {
                    indicatoricon: w(() => [
                      y("div", {
                        class: "w-full h-full flex flex-col justify-start",
                        onMouseover: (g) => u(S.comment),
                        onMouseleave: p,
                        onClick: (g) => b(S)
                      }, null, 40, WR)
                    ]),
                    _: 2
                  }, 1032, ["alt", "src"])
                ], 8, BR))), 128))
              ])
            ]),
            _: 1
          }),
          I[0] || (I[0] = y("div", {
            id: "commentContainer",
            class: "flex justify-center mt-2",
            style: { "min-height": "20vh", "white-space": "pre-wrap", top: "auto" }
          }, null, -1))
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
}), HR = /* @__PURE__ */ $t(zR, [["__scopeId", "data-v-4e2210a7"]]), YR = { class: "hidden" }, KR = { style: { width: "100%", border: "1px solid var(--surface-border, #d6d6d6)", "border-radius": "8px", overflow: "hidden" } }, ZR = { style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #d6d6d6)", "font-weight": "600", "font-size": "0.85rem" } }, JR = { style: { "max-height": "140px", "overflow-y": "auto" } }, XR = {
  key: 0,
  style: { padding: "12px", "font-size": "0.9rem" }
}, qR = {
  key: 1,
  style: { padding: "12px", "font-size": "0.9rem" }
}, QR = ["title"], eM = { class: "text-xs" }, tM = { style: { width: "100%", border: "1px solid var(--surface-border, #d6d6d6)", "border-radius": "8px", overflow: "hidden" } }, nM = { style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #d6d6d6)", "font-weight": "600", "font-size": "0.85rem" } }, aM = { style: { "max-height": "140px", "overflow-y": "auto" } }, oM = {
  key: 0,
  style: { padding: "12px", "font-size": "0.9rem" }
}, lM = {
  key: 1,
  style: { padding: "12px", "font-size": "0.9rem" }
}, iM = ["title"], sM = { class: "text-xs" }, rM = /* @__PURE__ */ qe({
  __name: "IPReportsWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Yt(), a = Aa(), o = mi(), l = Jn(), s = ml(), i = F(0), c = F(!1), u = F([]), p = F([]), b = F(null);
    Mt(async () => {
      i.value = await s.getNumberOfExportsTokens(), await M();
    });
    const f = t;
    let h = pn(), I = Jn();
    const m = Te(() => !!(h.license.versionType & Va.NORMAL)), S = Te(() => !!(h.license.versionType & Va.PRO)), E = Te(() => !0), g = Te(() => S.value || m.value), v = Te(() => m.value && E.value), T = Te(() => (S.value || m.value) && E.value), R = Te(() => m.value ? i.value != 0 : !0), L = Te(() => {
      let k = n("shared.export");
      if (m.value) {
        const K = i.value;
        K === 1 ? k += ` (${K} ${n("shared.token")})` : K >= 0 && (k += ` (${K} ${n("shared.tokens")})`);
      }
      return k;
    }), C = (k) => {
      if (!k)
        return null;
      try {
        const K = JSON.parse(k);
        if (typeof K == "object" && K !== null)
          return K;
      } catch (K) {
        console.warn("Invalid processing file metadata.", K);
      }
      return null;
    }, A = (k) => {
      if (!k)
        return "-";
      const K = k instanceof Date ? k : new Date(k);
      return Number.isNaN(K.getTime()) ? typeof k == "string" ? k : "-" : K.toLocaleString();
    }, j = (k) => {
      const K = k.trim();
      return K.toLowerCase().endsWith(".zip") ? K : `${K}.zip`;
    }, N = (k, K, Ae = "application/octet-stream") => {
      const me = new Blob([k], { type: Ae }), Ne = window.URL.createObjectURL(me), Ge = document.createElement("a");
      Ge.href = Ne, Ge.download = K, document.body.appendChild(Ge), Ge.click(), Ge.remove(), window.URL.revokeObjectURL(Ne);
    }, x = async (k) => {
      const K = await fi.loadAsync(k), Ae = Object.values(K.files).filter((me) => !me.dir);
      if (Ae.length)
        for (let me of Ae) {
          const Ne = await me.async("arraybuffer");
          N(Ne, me.name);
        }
    }, z = (k, K) => {
      N(k, j(K), "application/zip");
    }, X = (k) => {
      var G;
      const K = k.type === "processing-data" || k.type === "report-data";
      if (!h.fileHash || !K || !k.metadata)
        return null;
      const Ae = C(k.metadata);
      if (!Ae)
        return null;
      const me = Ae["job-type"], Ne = Ae["origin-file-uuid"];
      if (me !== "REPORT" && me !== "EXPORT")
        return null;
      const Ue = (() => {
        const P = Ae.exportFileName;
        if (typeof P == "string" && P.trim().length > 0)
          return P.trim();
        const de = Ae["job-input-params"];
        if (typeof de == "string") {
          const fe = C(de), ke = fe == null ? void 0 : fe.exportFileName;
          if (typeof ke == "string" && ke.trim().length > 0)
            return ke.trim();
        } else if (typeof de == "object" && de !== null) {
          const fe = de.exportFileName;
          if (typeof fe == "string" && fe.trim().length > 0)
            return fe.trim();
        }
        return k.name.replace(/\.zip$/i, "").trim();
      })();
      if (Ue.length === 0)
        return null;
      const Ke = ((G = k.file) == null ? void 0 : G.createDate) ?? k.localCreateDate, st = new Date(Ke).getTime();
      return {
        fileUuid: k.uuid,
        fileName: Ue.trim(),
        createdDateLabel: A(Ke),
        createdDateTimestamp: Number.isNaN(st) ? 0 : st,
        jobType: me,
        originFileUuid: typeof Ne == "string" ? Ne : void 0
      };
    }, H = async () => {
      if (!h.projectHash)
        return [];
      const { data: k } = await l.GetProjectByUUID(h.projectHash);
      if (!k)
        return [];
      const { data: K } = await l.getPatientFullById(k.id);
      return (K == null ? void 0 : K.files) ?? [];
    }, M = async () => {
      if (!h.fileHash || !h.projectHash) {
        u.value = [], p.value = [];
        return;
      }
      c.value = !0;
      try {
        const K = (await H()).map((me) => X(me)).filter((me) => me !== null).sort((me, Ne) => Ne.createdDateTimestamp - me.createdDateTimestamp), Ae = h.fileHash ? K.filter((me) => me.originFileUuid === h.fileHash) : [];
        u.value = Ae.filter((me) => me.jobType === "REPORT"), p.value = Ae.filter((me) => me.jobType === "EXPORT");
      } catch (k) {
        Tn(k instanceof Error ? k.message : n("implant-planner.errorLoadingReportExportList"), n("implant-planner.errorLoadingReportExportList"));
      } finally {
        c.value = !1;
      }
    }, te = async (k) => {
      if (!b.value) {
        b.value = k.fileUuid;
        try {
          const K = await l.GetFileByUUID(k.fileUuid);
          if (K.status !== Qa.OK) {
            Tn(K.data, n("implant-planner.errorFindingExportData"));
            return;
          }
          k.jobType === "EXPORT" ? z(K.data, k.fileName) : await x(K.data);
        } catch (K) {
          Tn(K instanceof Error ? K.message : n("implant-planner.errorFindingExportData"), n("implant-planner.errorFindingExportData"));
        } finally {
          b.value = null;
        }
      }
    }, ne = (k) => k.replace(/[\\/:*?"<>|]/g, "_").trim(), W = () => {
      var me, Ne;
      const k = h.patientInfo, K = (k == null ? void 0 : k.patientName) || ((me = k == null ? void 0 : k.extra) == null ? void 0 : me.patientName) || [k == null ? void 0 : k.firstName, k == null ? void 0 : k.lastName].filter((Ge) => Ge && Ge.length > 0).join("_") || ((Ne = h.projectInfo) == null ? void 0 : Ne.patientName) || h.projectName || "Report";
      return `${ne(K).replace(/\s+/g, "_") || "Report"}_Report`;
    }, se = () => {
      a.open(zf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.implantReportSettings"),
          style: { width: "70vw", minHeight: "60vh" },
          contentStyle: { borderRadius: "8px" }
        },
        data: {
          context: h
        },
        emits: {
          onOk: async (k) => {
            await Re(k);
          },
          close: () => {
          }
        }
      });
    }, be = async () => {
      var me;
      const k = h.objects.getReportXML(), K = new File([k], "drillReport.xml", { type: "application/xml" }), Ae = await I.triggerDrillReport(((me = h.patientInfo) == null ? void 0 : me.firstName) || "drill-report", K);
      Ae.status == 200 && Ae.data.success && Ae.data.reportUrl && window.open(Ae.data.reportUrl, "_blank");
    }, Re = async (k) => {
      let K = !1;
      const Ae = async () => {
        var Z, ee;
        const Ne = k.logoBase64;
        if (!Ne)
          return;
        if (!Ne.startsWith("data:")) {
          console.warn("Report logo is not a data URL, skipping upload.");
          return;
        }
        const [Ge, Ue] = Ne.split(",");
        if (!Ue)
          return;
        const Ke = Ge.match(/data:(.*?);base64/), st = (Ke == null ? void 0 : Ke[1]) || "image/png", G = atob(Ue), P = new Uint8Array(G.length);
        for (let $ = 0; $ < G.length; $++)
          P[$] = G.charCodeAt($);
        const de = new Blob([P], { type: st }), ke = `report-logo.${st.includes("jpeg") ? "jpg" : st.split("/")[1] || "png"}`, le = ((Z = h.projectInfo) == null ? void 0 : Z.patientName) || h.projectName || ((ee = h.patientInfo) == null ? void 0 : ee.patientName);
        if (!le)
          throw new Error("Project name is required to upload the report logo.");
        (await l.uploadFile(le, ke, "report_logo", de)).status == Qa.OK && (k.logoBase64 = "");
      }, me = async () => {
        var Ue, Ke, st;
        const Ne = await h.getModalsInstance().showTextInputModal(n("shared.export"), W(), n("implant-planner.enterReportFileName"));
        if (!Ne)
          return;
        const Ge = () => {
          K = !0, h.hideLoading();
        };
        h.showLoading(n("implant-planner.generatingReport"), !1, void 0, void 0, !0, Ge);
        try {
          if (h.fileHash) {
            await Ae();
            const G = [4e3, 1e3];
            k.ww = G[0], k.wl = G[1], k.dateOfBirth = k.dateOfBirth instanceof Date ? (Ue = k.dateOfBirth) == null ? void 0 : Ue.toLocaleDateString() : k.dateOfBirth, k.examDate = k.examDate instanceof Date ? (Ke = k.examDate) == null ? void 0 : Ke.toLocaleDateString() : k.examDate, k.lastModified = k.lastModified instanceof Date ? (st = k.lastModified) == null ? void 0 : st.toLocaleDateString() : k.lastModified, k.fontColor && !k.fontColor.startsWith("#") && (k.fontColor = `#${k.fontColor}`), k.bgColor3d && !k.bgColor3d.startsWith("#") && (k.bgColor3d = `#${k.bgColor3d}`);
            const P = JSON.stringify(k, (le, pe) => pe instanceof Date ? pe.toISOString() : pe), de = await l.triggerReportJob(h.fileHash, Ne, P);
            if (K)
              return;
            if (de.status !== Qa.OK) {
              Tn(de.data, n("implant-planner.errorGeneratingReport"));
              return;
            }
            const fe = de.data.data;
            let ke = !1;
            for (; !ke && !K; ) {
              const le = await l.getJobStatusUuid(fe);
              if (console.log("Job status", le), K)
                break;
              if (le.status === Qa.OK && le.data.some((pe) => pe.status === "COMPLETED")) {
                ke = !0, uo(n("implant-planner.reportCompletedMessage"), n("implant-planner.reportCompletedTitle"));
                break;
              }
              await new Promise((pe) => setTimeout(pe, 3e3));
            }
            if (K) {
              console.warn("Report canceled by user.");
              return;
            }
            if (ke && h.projectInfo && h.projectHash) {
              const { data: le } = await l.GetProjectByUUID(h.projectHash);
              if (le) {
                const { data: pe } = await l.getPatientFullById(le.id), ee = ((pe == null ? void 0 : pe.files) ?? []).find(($) => $.name == `${fe}.zip`);
                if (ee) {
                  const $ = await l.GetFileByUUID(ee.uuid);
                  $.status == Qa.OK && await x($.data);
                }
              } else
                Tn(de.data, "Error finding report data for download.");
            }
            await M();
          }
        } catch (G) {
          Sp(n("implant-planner.errorGeneratingReport"), G);
        } finally {
          K || h.hideLoading();
        }
      };
      h.shouldProjectBeSaved() ? o.require({
        message: n("implant-planner.saveBeforeReportPrompt"),
        header: n("implant-planner.saveProject"),
        icon: "pi pi-exclamation-triangle",
        acceptLabel: n("medic-web-framework.yes"),
        rejectLabel: n("medic-web-framework.no"),
        accept: async () => {
          await h.saveProject(), await me();
        },
        reject: () => {
          console.log("User chose not to save the project before report generation.");
        }
      }) : await me();
    }, U = async (k) => {
      let K = !1;
      const Ae = async () => {
        const me = await h.getModalsInstance().showTextInputModal(n("shared.export"), "Exports", "Enter export file name:");
        let Ne = !0;
        if (me) {
          const Ge = () => {
            K = !0, h.hideLoading();
          };
          h.showLoading(n("shared.exporting"), !1, void 0, void 0, !0, Ge);
          try {
            if (h.fileHash) {
              const Ue = await l.triggerExportJob(h.fileHash, k, Ne, me);
              if (K) {
                i.value = await s.getNumberOfExportsTokens();
                return;
              }
              if (Ue.status !== Qa.OK) {
                Tn(Ue.data, "Error exporting data");
                return;
              }
              const Ke = Ue.data.data;
              let st = !1;
              for (; !st && !K; ) {
                const G = await l.getJobStatusUuid(Ke);
                if (K)
                  break;
                if (G.status === Qa.OK && G.data.some((P) => P.status === "COMPLETED")) {
                  st = !0, uo(n("implant-planner.exportCompletedMessage"), n("implant-planner.exportCompletedTitle"));
                  break;
                }
                await new Promise((P) => setTimeout(P, 3e3));
              }
              if (K) {
                console.warn("Export canceled by user."), i.value = await s.getNumberOfExportsTokens();
                return;
              }
              if (st && h.projectInfo && h.projectHash) {
                if (K) {
                  i.value = await s.getNumberOfExportsTokens();
                  return;
                }
                const { data: G } = await l.GetProjectByUUID(h.projectHash);
                if (G) {
                  const { data: P } = await l.getPatientFullById(G.id), fe = ((P == null ? void 0 : P.files) ?? []).find((ke) => ke.name == `${Ke}.zip`);
                  if (fe) {
                    if (K) {
                      i.value = await s.getNumberOfExportsTokens();
                      return;
                    }
                    const ke = await l.GetFileByUUID(fe.uuid);
                    if (K) {
                      i.value = await s.getNumberOfExportsTokens();
                      return;
                    }
                    ke.status == Qa.OK && z(ke.data, me);
                  } else
                    Tn(Ue.data, n("implant-planner.errorFindingExportData"));
                }
              }
            }
          } catch (Ue) {
            Tn(Ue instanceof Error ? Ue.message : n("implant-planner.unknownExportError"), n("implant-planner.errorExportingData"));
          } finally {
            K || h.hideLoading();
          }
        }
        i.value = await s.getNumberOfExportsTokens(), await M();
      };
      h.shouldProjectBeSaved() ? o.require({
        message: n("implant-planner.saveBeforeExportPrompt"),
        header: n("implant-planner.saveProject"),
        icon: "pi pi-exclamation-triangle",
        acceptLabel: n("medic-web-framework.yes"),
        rejectLabel: n("medic-web-framework.no"),
        accept: async () => {
          await h.saveProject(), await Ae();
        },
        reject: () => {
          console.log("User chose not to save the project before export.");
        }
      }) : await Ae();
    }, ie = () => {
      U(0);
    }, re = () => {
      U(1);
    }, q = () => {
      U(2);
    }, De = () => {
      U(3);
    }, _e = () => {
    }, xe = () => {
      U(4);
    };
    return (k, K) => {
      const Ae = co;
      return O(), J(ze, null, [
        d(jo, {
          onHideWizard: K[0] || (K[0] = (me) => f("hideWizard"))
        }, {
          default: w(() => [
            yt(V(k.$t("implant-planner.reportsExportData")), 1)
          ]),
          _: 1
        }),
        d(bl, null, {
          default: w(() => [
            r(g) ? (O(), he(r(at), {
              key: 0,
              class: "gap-2"
            }, {
              default: w(() => [
                d(r(Be), null, {
                  default: w(() => [
                    d(Ae, null, {
                      default: w(() => [
                        yt(V(k.$t("implant-planner.report")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.implantReport"),
                      class: He("w-full web-rg-icon-btn"),
                      onClick: se
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.drillReport"),
                      class: He("w-full web-rg-icon-btn"),
                      onClick: be
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : ue("", !0),
            d(r(at), { class: "gap-2" }, {
              default: w(() => [
                d(r(Be), null, {
                  default: w(() => [
                    d(Ae, null, {
                      default: w(() => [
                        yt(V(r(L)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.exportAnatomy"),
                      class: He("w-full web-rg-icon-btn"),
                      onClick: ie
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                r(v) ? (O(), he(r(Be), { key: 0 }, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.exportGuideAndModel"),
                      class: He("w-full web-rg-icon-btn"),
                      disabled: !r(R),
                      onClick: re
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })) : ue("", !0),
                r(v) ? (O(), he(r(Be), { key: 1 }, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.exportGuideForMilling"),
                      class: He("w-full web-rg-icon-btn"),
                      disabled: !r(R),
                      onClick: q
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })) : ue("", !0),
                r(T) ? (O(), he(r(Be), { key: 2 }, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.exportForCadcam"),
                      class: He("w-full web-rg-icon-btn"),
                      onClick: De
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })) : ue("", !0),
                y("template", YR, [
                  d(r(Be), null, {
                    default: w(() => [
                      d(r(Ce), {
                        label: k.$t("implant-planner.exportToMininavident"),
                        class: He("w-full web-rg-icon-btn"),
                        onClick: _e
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                r(v) ? (O(), he(r(Be), { key: 3 }, {
                  default: w(() => [
                    d(r(Ce), {
                      label: k.$t("implant-planner.exportAll"),
                      class: He("w-full web-rg-icon-btn"),
                      disabled: !r(R),
                      onClick: xe
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })) : ue("", !0)
              ]),
              _: 1
            }),
            d(r(at), { class: "gap-2" }, {
              default: w(() => [
                d(r(Be), null, {
                  default: w(() => [
                    d(Ae, null, {
                      default: w(() => [
                        yt(V(k.$t("implant-planner.existingReports")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    y("div", KR, [
                      y("div", ZR, [
                        y("span", null, V(k.$t("implant-planner.fileNameColumn")), 1),
                        y("span", null, V(k.$t("implant-planner.createdDateColumn")), 1),
                        K[1] || (K[1] = y("span", null, null, -1))
                      ]),
                      y("div", JR, [
                        r(c) ? (O(), J("div", XR, V(k.$t("shared.loading")), 1)) : r(u).length ? (O(!0), J(ze, { key: 2 }, Rt(r(u), (me) => (O(), J("div", {
                          key: me.fileUuid,
                          style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #ededed)" }
                        }, [
                          y("span", {
                            class: "text-xs",
                            title: me.fileName,
                            style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
                          }, V(me.fileName), 9, QR),
                          y("span", eM, V(me.createdDateLabel), 1),
                          d(r(Ce), {
                            "aria-label": k.$t("shared.download"),
                            icon: r(b) === me.fileUuid ? "pi pi-spinner pi-spin" : "pi pi-download",
                            disabled: r(b) === me.fileUuid,
                            style: { width: "32px", "min-width": "32px", height: "32px", padding: "0" },
                            onClick: (Ne) => te(me)
                          }, null, 8, ["aria-label", "icon", "disabled", "onClick"])
                        ]))), 128)) : (O(), J("div", qR, V(k.$t("implant-planner.noExistingReports")), 1))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    d(Ae, null, {
                      default: w(() => [
                        yt(V(k.$t("implant-planner.existingExports")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Be), null, {
                  default: w(() => [
                    y("div", tM, [
                      y("div", nM, [
                        y("span", null, V(k.$t("implant-planner.fileNameColumn")), 1),
                        y("span", null, V(k.$t("implant-planner.createdDateColumn")), 1),
                        K[2] || (K[2] = y("span", null, null, -1))
                      ]),
                      y("div", aM, [
                        r(c) ? (O(), J("div", oM, V(k.$t("shared.loading")), 1)) : r(p).length ? (O(!0), J(ze, { key: 2 }, Rt(r(p), (me) => (O(), J("div", {
                          key: me.fileUuid,
                          style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #ededed)" }
                        }, [
                          y("span", {
                            class: "text-xs",
                            title: me.fileName,
                            style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
                          }, V(me.fileName), 9, iM),
                          y("span", sM, V(me.createdDateLabel), 1),
                          d(r(Ce), {
                            "aria-label": k.$t("shared.download"),
                            icon: r(b) === me.fileUuid ? "pi pi-spinner pi-spin" : "pi pi-download",
                            disabled: r(b) === me.fileUuid,
                            style: { width: "32px", "min-width": "32px", height: "32px", padding: "0" },
                            onClick: (Ne) => te(me)
                          }, null, 8, ["aria-label", "icon", "disabled", "onClick"])
                        ]))), 128)) : (O(), J("div", lM, V(k.$t("implant-planner.noExistingExports")), 1))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), uM = "webcad-ip-autosave", fp = 1, Oa = "snapshots", Da = "latest", cM = 1440 * 60 * 1e3;
function Vs(e) {
  const t = Object.entries(e).filter(([, o]) => !!o), n = t.map(([o]) => o), a = t.reduce((o, [, l]) => o + ((l == null ? void 0 : l.byteLength) ?? 0), 0);
  return {
    count: t.length,
    names: n,
    bytes: a
  };
}
function dM() {
  return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
function Ii() {
  return typeof indexedDB < "u";
}
function Bs() {
  return new Promise((e, t) => {
    if (!Ii()) {
      Ye.debug("[Autosave] IndexedDB not available"), t(new Error("IndexedDB is not available"));
      return;
    }
    const n = indexedDB.open(uM, fp);
    n.onupgradeneeded = () => {
      const a = n.result;
      if (Ye.debug("[Autosave] Upgrading DB schema", { version: fp }), !a.objectStoreNames.contains(Oa)) {
        const o = a.createObjectStore(Oa, { keyPath: "id" });
        o.createIndex("projectKey", "projectKey", { unique: !1 }), o.createIndex("expiresAt", "expiresAt", { unique: !1 });
      }
      a.objectStoreNames.contains(Da) || a.createObjectStore(Da, { keyPath: "projectKey" });
    }, n.onsuccess = () => {
      Ye.debug("[Autosave] DB opened"), e(n.result);
    }, n.onerror = () => t(n.error ?? new Error("Failed to open IndexedDB"));
  });
}
function ac(e) {
  return new Promise((t, n) => {
    e.oncomplete = () => t(), e.onabort = () => n(e.error ?? new Error("IndexedDB transaction aborted")), e.onerror = () => n(e.error ?? new Error("IndexedDB transaction failed"));
  });
}
function pi(e) {
  return new Promise((t, n) => {
    e.onsuccess = () => t(e.result), e.onerror = () => n(e.error ?? new Error("IndexedDB request failed"));
  });
}
function oc(e, t) {
  const a = e.index("projectKey").getAll(t);
  return pi(a);
}
function gp(e) {
  return e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
}
function pM(e) {
  const t = {}, n = e.getFS(), a = ["ipts", "bs", "ts", "m", "sg"];
  for (const l of a) {
    const s = Ji(e, l, "pr"), i = Ji(e, l, "bd"), c = Xi(n.FS, s), u = Xi(n.FS, i);
    if (!c || !u || !c.size || !u.size)
      continue;
    const p = n.FS.readFile(`${e.projectName}.${l}pr`), b = n.FS.readFile(`${e.projectName}.${l}bd`);
    t[`${l}pr`] = gp(p), t[`${l}bd`] = gp(b);
  }
  const o = Vs(t);
  return Ye.debug("[Autosave] Collected CAD parts", {
    projectName: e.projectName,
    partCount: o.count,
    partNames: o.names,
    totalBytes: o.bytes
  }), t;
}
function hp(e, t) {
  const n = t || e.projectFileUuid || "", a = `${e.patientName}::${e.projectFilename}::${n}`;
  return Ye.debug("[Autosave] Computed project key", {
    patientName: e.patientName,
    projectFilename: e.projectFilename,
    fileHash: n,
    key: a
  }), a;
}
async function mM(e, t) {
  Ye.debug("[Autosave] Building payload", {
    projectName: e.projectName,
    hasLoadedPr: !!t.pr,
    hasLoadedStlInfo: !!t.stlInfo,
    hasLoadedMobile: !!t.mobile
  });
  let n;
  try {
    n = Ht(cs, t.pr);
  } catch (s) {
    Ye.warn("[Autosave] Failed to read original image metadata; using current image metadata", s);
  }
  const a = await qu(e, t, !1, void 0, {
    imageInfoOverride: n
  });
  if (!a)
    return Ye.debug("[Autosave] Payload build returned null"), null;
  const o = {
    pr: structuredClone(a.pr),
    stlInfo: a.stlInfo ? structuredClone(a.stlInfo) : void 0,
    mobile: a.mobile ? structuredClone(a.mobile) : void 0,
    erpFile: a.erpFile ? structuredClone(a.erpFile) : void 0,
    cadParts: pM(e)
  }, l = Vs(o.cadParts);
  return Ye.debug("[Autosave] Payload built", {
    projectName: e.projectName,
    hasPr: !!o.pr,
    hasStlInfo: !!o.stlInfo,
    hasMobile: !!o.mobile,
    hasErp: !!o.erpFile,
    cadPartCount: l.count,
    cadPartNames: l.names,
    cadTotalBytes: l.bytes
  }), o;
}
async function lc(e = Date.now()) {
  if (!Ii()) {
    Ye.debug("[Autosave] Skipping purge - IndexedDB unavailable");
    return;
  }
  Ye.debug("[Autosave] Purge expired snapshots start", { nowTs: e });
  const t = await Bs();
  try {
    const n = t.transaction([Oa, Da], "readwrite"), a = n.objectStore(Oa), o = n.objectStore(Da), l = await pi(a.getAll());
    let s = 0;
    for (const i of l)
      if (i.expiresAt <= e) {
        a.delete(i.id), s += 1;
        const c = await pi(o.get(i.projectKey));
        (c == null ? void 0 : c.snapshotId) === i.id && o.delete(i.projectKey);
      }
    await ac(n), Ye.debug("[Autosave] Purge expired snapshots done", {
      scanned: l.length,
      removed: s
    });
  } finally {
    t.close();
  }
}
async function fM(e, t, n) {
  if (!Ii()) {
    Ye.debug("[Autosave] Skipping save - IndexedDB unavailable", { projectKey: e });
    return;
  }
  const a = Vs(t.cadParts);
  Ye.debug("[Autosave] Save snapshot start", {
    projectKey: e,
    fileHash: n,
    hasPr: !!t.pr,
    hasStlInfo: !!t.stlInfo,
    hasMobile: !!t.mobile,
    hasErp: !!t.erpFile,
    cadPartCount: a.count,
    cadPartNames: a.names,
    cadTotalBytes: a.bytes
  }), await lc();
  const o = await Bs();
  try {
    const l = Date.now(), s = {
      id: dM(),
      projectKey: e,
      fileHash: n,
      createdAt: new Date(l).toISOString(),
      expiresAt: l + cM,
      status: "ready",
      payload: t
    }, i = o.transaction([Oa, Da], "readwrite"), c = i.objectStore(Oa), u = i.objectStore(Da), p = await oc(c, e);
    for (const b of p)
      c.delete(b.id);
    Ye.debug("[Autosave] Replacing previous snapshots", {
      projectKey: e,
      removed: p.length
    }), c.put(s), u.put({
      projectKey: e,
      snapshotId: s.id,
      createdAt: s.createdAt
    }), await ac(i), Ye.debug("[Autosave] Save snapshot success", {
      projectKey: e,
      snapshotId: s.id,
      createdAt: s.createdAt,
      expiresAt: s.expiresAt
    });
  } finally {
    o.close();
  }
}
async function gM(e) {
  if (!Ii())
    return Ye.debug("[Autosave] Skipping read - IndexedDB unavailable", { projectKey: e }), null;
  Ye.debug("[Autosave] Read latest snapshot start", { projectKey: e }), await lc();
  const t = await Bs();
  try {
    const n = t.transaction([Oa, Da], "readonly"), a = n.objectStore(Oa), o = n.objectStore(Da), l = await pi(o.get(e));
    let s = null;
    if (l != null && l.snapshotId && (s = await pi(a.get(l.snapshotId))), !s) {
      const i = await oc(a, e);
      i.length && (i.sort((c, u) => u.expiresAt - c.expiresAt), s = i[0]);
    }
    if (s) {
      const i = Vs(s.payload.cadParts);
      Ye.debug("[Autosave] Read latest snapshot hit", {
        projectKey: e,
        snapshotId: s.id,
        createdAt: s.createdAt,
        expiresAt: s.expiresAt,
        hasPr: !!s.payload.pr,
        hasStlInfo: !!s.payload.stlInfo,
        hasMobile: !!s.payload.mobile,
        hasErp: !!s.payload.erpFile,
        cadPartCount: i.count,
        cadPartNames: i.names,
        cadTotalBytes: i.bytes
      });
    } else
      Ye.debug("[Autosave] Read latest snapshot miss", { projectKey: e });
    return s;
  } catch (n) {
    return Ye.warn("Failed to read autosave snapshot", n), null;
  } finally {
    t.close();
  }
}
async function _r(e) {
  if (!Ii()) {
    Ye.debug("[Autosave] Skipping delete - IndexedDB unavailable", { projectKey: e });
    return;
  }
  Ye.debug("[Autosave] Delete snapshots start", { projectKey: e });
  const t = await Bs();
  try {
    const n = t.transaction([Oa, Da], "readwrite"), a = n.objectStore(Oa), o = n.objectStore(Da), l = await oc(a, e);
    for (const s of l)
      a.delete(s.id);
    o.delete(e), await ac(n), Ye.debug("[Autosave] Delete snapshots done", {
      projectKey: e,
      removed: l.length
    });
  } finally {
    t.close();
  }
}
const hM = {
  class: "flex flex-col",
  style: {
    borderRadius: "16px",
    padding: "2rem",
    background: "rgba(69,93,130,0.85)",
    width: "clamp(20rem, 30vw, 42rem)",
    maxWidth: "90vw"
  }
}, bM = { style: {
  textAlign: "center",
  color: "white",
  textShadow: "0 1px 1px black",
  overflowWrap: "anywhere",
  wordBreak: "break-word"
} }, vM = {
  class: "mt-8",
  style: { width: "100%" }
}, yM = {
  key: 0,
  class: "mt-6 flex justify-center"
}, _M = { style: { display: "flex", "justify-content": "center" } }, wM = { class: "ml-1 mb-3 mt-3 flex justify-center" }, SM = { class: "col-span-12" }, IM = {
  class: "ml-1 mb-3 mt-3 flex justify-start",
  style: { "white-space": "pre-wrap" }
}, EM = { class: "col-span-12" }, TM = {
  key: 0,
  class: "flex flex-col gap-3"
}, CM = {
  class: "m-0",
  style: { "white-space": "pre-wrap" }
}, NM = { style: { padding: "0.75rem", "border-radius": "0.5rem", background: "rgba(0, 0, 0, 0.08)" } }, LM = { style: { display: "flex", "flex-direction": "column", gap: "0.35rem" } }, OM = { style: { "font-weight": "600" } }, DM = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, AM = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, RM = {
  key: 0,
  style: { display: "flex", gap: "0.5rem", "align-items": "center" }
}, MM = {
  key: 1,
  style: { display: "flex", gap: "0.5rem", "align-items": "center" }
}, PM = {
  key: 2,
  style: { display: "flex", "flex-direction": "column", gap: "0.35rem" }
}, xM = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, jM = { style: { "max-height": "9rem", "overflow-y": "auto", "padding-left": "1.25rem", "border-left": "1px solid rgba(0, 0, 0, 0.15)" } }, FM = ["disabled", "value"], $M = {
  key: 3,
  style: { display: "flex", "flex-direction": "column", gap: "0.35rem" }
}, kM = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, VM = { style: { "max-height": "9rem", "overflow-y": "auto", "padding-left": "1.25rem", "border-left": "1px solid rgba(0, 0, 0, 0.15)" } }, BM = ["disabled", "value"], UM = {
  key: 0,
  id: "sidebarContainer",
  class: "flex flex-row"
}, GM = { class: "mainMenuTabs" }, WM = {
  class: "h-full web-rg-wizard",
  style: { margin: "0 0.5rem" }
}, zM = /* @__PURE__ */ qe({
  __name: "IPProjectLoaderViewRedesign",
  props: {
    loader: {},
    source: { default: al.IMPLANT_PLANNER },
    readOnly: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { t } = Yt(), n = Po(), a = window, o = e, l = Jn(), s = o.loader(l), i = Aa(), c = ia(), u = ml(), p = F(u.getUser().username), b = F(u.getUser().license);
    let f = u.getSessionLicence();
    const h = u.getUser(), I = mi();
    Ye.log("License", f);
    let m = new ws(c.getAssetUrl(""), f);
    m.user = h;
    const S = () => {
      v.value = !1;
    }, E = F(), g = F(), v = F(!0), T = F(!1), R = F(!0), L = F(!1), C = F(0), A = F(!1), j = F(!1), N = F(Math.random()), x = F(!0), z = F(!1), X = F(!1), H = F(0), M = F(), te = F(t("shared.loadingProject")), ne = gl(), W = Mo(), se = oa(), { wizardLayouts: be } = Co(oa()), Re = Es(), U = mu.actions, ie = Ra();
    F(kn.REALGUIDE), F(!0);
    const re = F(o.source == al.IMPLANT_PLANNER ? bt.ImplantPlannerBase : bt.WeblinkViewer), q = F(o.readOnly), De = Tp(), _e = Te(() => re.value === bt.WeblinkViewer && q.value ? 116 : De.rgScreenType === "lg" ? 110 : 70);
    Ss(m);
    const xe = Te(() => T.value && !j.value ? "rgba(91, 91, 91, 0.5)" : "linear-gradient(to top, rgb(40, 106, 173) 1%, rgb(11, 14, 26) 105%)"), k = () => {
      const oe = m.undoManager.getUndoDescription(), Oe = m.undoManager.getRedoDescription(), it = oe ? `Undo ${oe}` : void 0, Et = Oe ? `Redo ${Oe}` : void 0;
      let Ft = [], Je = [];
      m.undoManager.canUndo() ? Ft.push(Ie.UNDO) : Je.push(Ie.UNDO), m.undoManager.canRedo() ? Ft.push(Ie.REDO) : Je.push(Ie.REDO), n.disableNavbarButtons(Je), n.enableNavbarButtons(Ft);
      const Ot = [
        { button: Ie.UNDO, tooltip: it },
        { button: Ie.REDO, tooltip: Et }
      ];
      n.addTooltips(Ot);
    }, K = F(!1), Ae = () => {
      K.value = !1;
    }, me = F(!1), Ne = F(!1), Ge = ks(), Ue = () => {
      if (z.value) {
        const oe = m.contextCAD.getLayout();
        Bo(oe);
      }
      Ge.stlLibraryWindowVisible ? Ne.value = !0 : me.value = !0;
    }, Ke = F(!1), st = F(!1), G = F(!1), P = F("");
    let de = null;
    const fe = F("");
    let ke = null, le = !1;
    const pe = typeof a.isIOS == "function" && a.isIOS(), Z = pe && re.value === bt.ImplantPlannerBase, ee = F(!1);
    let $ = null;
    const _ = F(null), D = F("decimated"), Y = F(!0), Q = F(!0), ae = F(!0), ge = F(!1), Fe = F([]), Me = F([]), je = (oe) => {
      D.value = oe.volumeQuality ?? "full", Y.value = oe.includeImplants ?? !0, Q.value = oe.includePins ?? !0, ae.value = oe.includeProjectStlObjects ?? !0, ge.value = oe.includePatientStlObjects ?? !1, Fe.value = [...oe.includedProjectStlObjectNames ?? []], Me.value = [...oe.includedPatientStlFilenames ?? []];
    }, dt = Te(() => ({
      volumeQuality: D.value,
      includeImplants: Y.value,
      includePins: Q.value,
      includeProjectStlObjects: ae.value && Fe.value.length > 0,
      includePatientStlObjects: ge.value && Me.value.length > 0,
      includedProjectStlObjectNames: [...Fe.value],
      includedPatientStlFilenames: [...Me.value]
    })), vt = Te(() => _.value ? s.estimateProjectLoadMemory(_.value, dt.value) : 0), mt = Te(() => _.value ? _.value.budgetMemoryBytes - vt.value : 0), kt = Te(() => mt.value >= 0), Ct = (oe) => rh(Math.max(0, Math.round(oe))), ft = (oe) => (_.value = oe, je(s.buildDefaultProjectLoadSelection(oe)), ee.value = !0, new Promise((Oe) => {
      $ = Oe;
    })), Vt = (oe) => {
      ee.value = !1, $ && ($(oe), $ = null);
    }, Wt = () => {
      Vt(dt.value);
    }, jn = () => {
      Vt(null);
    }, ra = () => {
      ke !== null && (Ye.debug("[Autosave] Clearing interval", { intervalId: ke }), window.clearInterval(ke), ke = null);
    }, B = async () => {
      if (q.value || le || !T.value || !fe.value) {
        Ye.debug("[Autosave] Skipping tick", {
          reason: "guard",
          readOnly: q.value,
          autosaveInFlight: le,
          loaded: T.value,
          hasProjectKey: !!fe.value
        });
        return;
      }
      if (!m.shouldProjectBeSaved()) {
        Ye.debug("[Autosave] Skipping tick", {
          reason: "project-not-dirty",
          projectKey: fe.value
        });
        return;
      }
      const oe = s.getLoadedProjectData();
      if (!oe) {
        Ye.debug("[Autosave] Skipping tick", {
          reason: "missing-loaded-project-data",
          projectKey: fe.value
        });
        return;
      }
      le = !0;
      try {
        Ye.debug("[Autosave] Tick start", {
          projectKey: fe.value,
          projectName: m.projectName,
          fileHash: m.fileHash
        });
        const Oe = await mM(m, oe);
        if (!Oe) {
          Ye.debug("[Autosave] Tick aborted - payload was null", {
            projectKey: fe.value
          });
          return;
        }
        const it = typeof m.fileHash == "string" ? m.fileHash : void 0;
        await fM(fe.value, Oe, it), Ye.debug("[Autosave] Tick completed", {
          projectKey: fe.value,
          fileHash: it
        });
      } catch (Oe) {
        Ye.warn("Autosave failed", Oe);
      } finally {
        le = !1;
      }
    }, ye = () => {
      if (Ye.debug("[Autosave] Restart interval requested", {
        readOnly: q.value,
        projectKey: fe.value,
        intervalMinutes: m.settings.general.autosaveIntervalMinutes
      }), ra(), q.value || !fe.value) {
        Ye.debug("[Autosave] Interval not started", {
          reason: "guard",
          readOnly: q.value,
          hasProjectKey: !!fe.value
        });
        return;
      }
      const oe = m.settings.general.autosaveIntervalMinutes;
      if (!Number.isFinite(oe) || oe <= 0) {
        Ye.debug("[Autosave] Interval not started", {
          reason: "invalid-minutes",
          minutes: oe
        });
        return;
      }
      ke = window.setInterval(
        () => {
          B();
        },
        oe * 60 * 1e3
      ), Ye.debug("[Autosave] Interval started", {
        intervalId: ke,
        minutes: oe,
        projectKey: fe.value
      });
    }, Xe = () => {
      document.visibilityState === "hidden" && (Ye.debug("[Autosave] visibilitychange -> hidden, running best-effort autosave", {
        projectKey: fe.value
      }), B());
    }, Ze = () => {
      Ye.debug("[Autosave] pagehide, running best-effort autosave", {
        projectKey: fe.value
      }), B();
    }, lt = (oe) => {
      const Oe = m.shouldProjectBeSaved(), it = !q.value && T.value && Oe;
      Ye.debug("[Autosave] beforeunload fired", {
        projectKey: fe.value,
        readOnly: q.value,
        loaded: T.value,
        dirty: Oe,
        shouldPrompt: it
      }), it && (oe.preventDefault(), oe.returnValue = "", Ye.debug("[Autosave] beforeunload blocked because project has unsaved changes", {
        projectKey: fe.value,
        projectName: m.projectName,
        fileHash: m.fileHash
      }));
    }, ce = (oe) => new Promise((Oe) => {
      de && de(), de = Oe, P.value = oe, G.value = !0;
    });
    se.prepareDefaults(ec());
    const Se = F(m.layoutManager.wizardTabIndex.get()), { menuMode: rt } = Co(oa()), _t = Te(() => rt.value === vn.HORIZONTAL && T.value), Gt = Te(() => !q.value && !De.isMobileView), wt = Te(() => ({
      "bg-top-nav-bar-wiz bg-body-wiz": !0
    })), Dn = Te(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": re.value !== bt.WeblinkViewer && !_t.value
    })), Bt = [];
    Ye.log("Version type:", f == null ? void 0 : f.versionType);
    let Ei = !1, sc = !1, Us = !1;
    f && f.versionType & Va.NORMAL && (Ei = !0), f && f.versionType & Va.PRO && (sc = !0), f && f.versionType & Va.START && (Us = !0);
    function rc() {
      oo.VENDOR_ID !== uh.PRODENT || (f == null ? void 0 : f.licenseType) !== "PLAN" || (console.log("INFO: Prodent with Plan license falling back to START!"), f.licenseType = "START", f.versionType = Va.START | Va.SUBSCRIPTION, Us = !0, m.license = f, m.AIEnabled = !1);
    }
    rc(), Bt.push(
      {
        type: we.VOI_SETTINGS,
        tabLabel: t("implant-planner.voiSettings"),
        component: Ou,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.THREED_SETTINGS,
        tabLabel: t("implant-planner.threedSettings"),
        component: Du,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.DATA_IMPORT,
        tabLabel: t("implant-planner.dataImport"),
        component: Au,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.CPR_SETTINGS,
        tabLabel: t("implant-planner.cprSettings"),
        component: Ru,
        defaultLayout: Ve._CPR_SETTINGS_WIZARD
      },
      {
        type: we.NERVE_DRAWING,
        tabLabel: t("implant-planner.nerveSettings"),
        component: Pu,
        defaultLayout: Ve._NERVE_DRAWING_WIZARD
      },
      {
        type: we.TEETH_SETUP,
        tabLabel: t("implant-planner.teethSetup"),
        component: nc,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.IMPLANT_PLANNING,
        tabLabel: t("implant-planner.implantPlanning"),
        component: zu,
        defaultLayout: Ve._3D_CPR_CROSS_TANGENT_AXIAL
      }
    ), (Ei || sc) && Bt.push({
      type: we.REPORTS_EXPORT,
      tabLabel: t("implant-planner.reportsExport"),
      component: rM,
      defaultLayout: Ve._FULLSCREEN_3D
    }), Ei && Bt.push(
      {
        type: we.CAD_DESIGN,
        tabLabel: t("implant-planner.design"),
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.GUIDE_DESIGN,
        tabLabel: t("implant-planner.guideDesign"),
        component: PR,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.CREATE_MODEL,
        tabLabel: t("implant-planner.createModel"),
        component: MR,
        defaultLayout: Ve._FULLSCREEN_3D
      }
    ), oo.SHOW_CAD_WIZARD && Bt.push({
      type: we.CAD,
      tabLabel: "Cad",
      component: Yu,
      defaultLayout: Ve._3D_CPR_CROSS_TANGENT_AXIAL
    });
    const fo = F(Bt.find((oe) => oe.type === Se.value));
    pe && (q.value = !0, m.readOnly = !0);
    let Gs;
    Z || (m.setModalsInstance(W), m.setResourceUrl("/resources/"), Gs = m.getEngineInstance());
    async function vg(oe) {
      var Et, Ft, Je;
      oe.setRootElement(E.value), oe.setCADRootElement(g.value), oe.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (Et = oe.getInteractorStyle()) == null || Et.setCameraInteractorEnabled(!0), (Ft = oe.getInteractorStyle()) == null || Ft.setMouseMode(oe.settings.general.useLeftButtonForRotationOn3d ? kn.REALGUIDE : kn.IMPLANTPLANNER), (Je = oe.getInteractorStyle()) == null || Je.setMouseMode2D(kn.REALGUIDE), be.value[we.VOI_SETTINGS] !== void 0 && se.setWizardLayout(we.VOI_SETTINGS, Ve._FULLSCREEN_3D);
      for (const Ot of Object.keys(be.value))
        oe.layoutManager.storeLayout(Ot.toString(), be.value[Number(Ot)]);
      oe.layoutManager.constructAllWindows();
      const it = oe.layoutManager.getLayout(Se.value.toString()) ?? oe.layoutManager.getDefaultLayout();
      oe.layoutManager.setLayout(it), Bo(it);
    }
    const uc = (oe) => {
      if (z.value) {
        m.contextCAD.setLayout(oe), Bo(oe);
        return;
      }
      Ge.stlLibraryWindowVisible ? (m.layoutManager.storeLayout("StlLibrary", oe), m.layoutManager.setLayout(oe)) : (m.layoutManager.storeLayout(Se.value.toString(), oe), m.layoutManager.setLayout(oe), Bo(oe), se.setWizardLayout(Se.value, oe));
    }, cc = () => {
      n.enableNavbarButtons([Ie.LAYOUT]);
    }, Il = () => {
      n.disableNavbarButtons([Ie.LAYOUT]);
    }, yg = () => {
      const oe = Bt.findIndex((Et) => Et.type === Se.value);
      if (oe === -1) {
        Ye.warn("current wizard not found");
        return;
      }
      if (oe === Bt.length - 1) {
        Ye.warn("nextStep called on last wizard");
        return;
      }
      let Oe = 0;
      oe == we.CPR_SETTINGS && m.CPRType !== an.MANDIBLE && (Oe = 1);
      const it = Bt[oe + 1 + Oe].type;
      m.layoutManager.wizardTabIndex.set(it), Se.value = it, qa();
    }, _g = () => {
      const oe = Bt.findIndex((Et) => Et.type === Se.value);
      if (oe === -1) {
        Ye.warn("current wizard not found");
        return;
      }
      if (oe === 0) {
        Ye.warn("previousStep called on first wizard");
        return;
      }
      let Oe = 0;
      oe == 5 && m.CPRType !== an.MANDIBLE && (Oe = 1);
      const it = Bt[oe - 1 - Oe].type;
      m.layoutManager.wizardTabIndex.set(it), Se.value = it, qa();
    };
    ie.onEvent(m.warningDialogEvent, (oe) => {
      ce(oe);
    }), ie.onEvent(m.screenshotUploadEvent, async ({ filename: oe, image: Oe }) => {
      var Et, Ft, Je;
      const it = (Je = (Ft = (Et = m.patientInfo) == null ? void 0 : Et.extra) == null ? void 0 : Ft.extra) == null ? void 0 : Je.study_instance_UID;
      if (it)
        try {
          await s.uploadScreenshot(it, oe, ga.Image, Oe), uo(t("weblink.successfullyUploadedScreenshot"));
        } catch (Ot) {
          Tn(Ot, t("web-rg.uploadFailed"));
        }
    }), ot(G, (oe) => {
      if (!oe && de) {
        const Oe = de;
        de = null, Oe();
      }
    }), ie.watch(m.layoutBtnVisible, (oe) => {
      oe ? cc() : Il();
    }), ie.watch(m.loadingFlag, (oe) => {
      R.value = oe, te.value = m.loadingText, L.value = m.progressBarFlag, C.value = m.progressBarValue.get(), j.value = m.nonTransparentLoading.get();
    }), ie.watch(m.loadingCancelVisible, (oe) => {
      A.value = oe;
    }), ie.watch(m.wizardPanelFreeze, (oe) => {
      X.value = oe;
    }), ie.watch(m.nextPrevVisible, (oe) => {
      x.value = oe, Ye.debug("Setting nextprevFlag to:", oe);
    }), ie.watch(m.cadMode, (oe) => {
      z.value = oe, H.value = oe ? 1 : 0, n.setCadMode(z.value), Ye.debug("Setting cadMode to:", oe);
    }), ie.watch(m.progressBarValue, (oe) => {
      C.value = oe;
    }), ie.watch(m.layoutManager.wizardTabIndex, () => {
      Se.value = m.layoutManager.wizardTabIndex.get(), qa();
    });
    const go = F(!0);
    ie.watch(m.tabButtonsEnabled, (oe) => {
      go.value = oe, Ye.debug("TabButtonsEnabled", go.value);
    });
    const wg = () => {
      const oe = m.loadingCancelHandler;
      oe ? (te.value = "Canceling ...", L.value = !1, oe()) : m.hideLoading();
    };
    ie.onEvent(m.saveProjectEvent, () => {
      Tl(!0, () => m.completeSaveProject());
    }), ie.onEvent(m.settings.onSettingsModified, () => {
      var oe;
      Ye.debug("[Autosave] Settings modified", {
        autosaveIntervalMinutes: m.settings.general.autosaveIntervalMinutes
      }), ye(), (oe = a.__setViewerTelemetryAllowed) == null || oe.call(a, m.settings.general.allowTelemetry);
    });
    let dc = 0;
    ot(Se, (oe) => {
      if (dc = m.layoutManager.wizardTabIndex.get(), Se.value === we.CAD_DESIGN) {
        i.open(HR, {
          props: {
            closable: !1,
            showHeader: !1,
            modal: !0,
            contentStyle: {
              borderRadius: "16px",
              padding: "0 1.5rem",
              overflow: "hidden"
            }
          },
          data: {
            headerText: t("implant-planner.selectDesign"),
            preselectedMode: pa.eDESIGN
          },
          emits: {
            onSelected: (Et) => {
              Se.value = Et, qa();
            },
            onClose: () => {
              Se.value = dc;
            }
          }
        });
        return;
      }
      m.toolManager.activeTool.WindowLevel.set(!1), ju(), m.layoutManager.wizardTabIndex.set(oe);
      let Oe = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout();
      if (cc(), Vo(), Se.value === we.DATA_IMPORT && (m.layoutManager.storeLayout(we.DATA_IMPORT.toString(), Ve._FULLSCREEN_3D), Oe = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), Il()), Se.value == we.CPR_SETTINGS && (m.layoutManager.storeLayout(we.CPR_SETTINGS.toString(), Ve._CPR_SETTINGS_WIZARD), Oe = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), Il()), Se.value == we.NERVE_DRAWING && (m.objects.hasCPR() || (st.value = !0), m.layoutManager.storeLayout(we.NERVE_DRAWING.toString(), Ve._NERVE_DRAWING_WIZARD), Oe = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), Il()), Se.value == we.IMPLANT_PLANNING && !m.objects.hasCPR() && !q.value && (st.value = !0), Se.value == we.GUIDE_DESIGN && (m.layoutManager.storeLayout(we.GUIDE_DESIGN.toString(), Ve._FULLSCREEN_3D), Oe = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), Il()), ((Et) => {
        switch (Ye.debug("setActiveTool wizard : ", Et), Et) {
          case we.CPR_SETTINGS:
            m.toolManager.setTool(un.CPR, Qt.PRIMARY);
            break;
          case we.NERVE_DRAWING:
            m.toolManager.setTool(un.NERVE, Qt.PRIMARY);
            break;
          case we.DATA_IMPORT:
            m.toolManager.setTool(un.MATCHING_TOOL, Qt.PRIMARY);
            break;
          default:
            m.toolManager.setTool(un.NONE, Qt.PRIMARY);
        }
      })(Se.value), !(Se.value === we.CPR_SETTINGS || Se.value === we.NERVE_DRAWING)) {
        const Et = m.layoutManager.layoutTemplateContainsCpr(Oe);
        Ke.value = m.objects.hasCPR(), Et && !Ke.value && (Oe = Ve._3D_MPR);
      }
      m.layoutManager.setLayout(Oe), m.resize(), m.resetOrientation(), Bo(Oe), se.updateSelectedWizardIndex(Se.value), Vo();
    });
    const Sg = () => {
      var Oe, it;
      if (z.value) {
        me.value = !1;
        return;
      }
      m.layoutManager.storeLayout(((Oe = fo.value) == null ? void 0 : Oe.type.toString()) ?? "", ((it = fo.value) == null ? void 0 : it.defaultLayout) ?? Ve._FULLSCREEN_3D);
      const oe = m.layoutManager.getLayout(Se.value.toString()) ?? m.layoutManager.getDefaultLayout();
      m.layoutManager.setLayout(oe), me.value = !1, Bo(oe);
    }, Ig = () => {
      const oe = m.layoutManager.getLayout("StlLibrary");
      oe !== void 0 && m.layoutManager.setLayout(oe), Ne.value = !1;
    }, El = F();
    let Ws = !1;
    ie.watch(m.projectFullName, () => {
      Vo();
    });
    const Vo = () => {
      M.value = m.projectFullName.get(), Ye.debug("showProjectName projectFullName.value: ", M.value), M.value && n.showProjectOnNavbar(M.value);
    };
    ot(T, () => {
      if (T.value) {
        const oe = ne.params.name === "default" || ne.params.name === "ids" ? "3Diemme" : void 0;
        n.showNavbar({
          buttons: Bu(q.value ? re.value : bt.ImplantPlannerBase, q.value),
          showZimvieLogo: !1,
          showNavbarPosition: !0,
          isWizard: !0,
          username: p.value,
          showDoctors: !1,
          ...oe && { pcName: oe }
        });
      }
    }), Mt(async () => {
      var Je;
      if (Z) {
        R.value = !1, L.value = !1, A.value = !1, i.open($i, {
          props: {
            closable: !1,
            draggable: !1,
            modal: !0,
            header: t("implant-planner.warning"),
            style: { width: "25rem", maxWidth: "90vw" }
          },
          data: {
            message: t("shared.iOSComingSoon"),
            showCancel: !1,
            showYesNo: !1
          },
          emits: {
            onConfirm: async () => {
              await ho();
            }
          }
        });
        return;
      }
      if (!oo.VENDOR_ID)
        try {
          const { data: Ot } = await l.getVendorInfo(), An = Ot == null ? void 0 : Ot.data;
          oo.VENDOR_ID = sh(An);
        } catch (Ot) {
          console.log("Error while getting vendor info:", Ot);
        }
      rc(), Cp(), n.showOnlyLogo(), Vo(), m.undoManager.onUndoChange.subscribe(k), k(), m.toolManager.onUndoManagerChange.subscribe(k), m.toolManager.onUndoManagerPop.subscribe(k), re.value === bt.WeblinkViewer && (q.value && Dg(), Ag()), Ye.debug("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const oe = performance.now();
      if (!Gs)
        return;
      const Oe = await Gs;
      if (Is(Oe), Ye.debug("engine await: ", performance.now() - oe), !await Eg(ne.params)) return;
      await ((Je = m.contextCAD) == null ? void 0 : Je.LoadCADResources(l)), q.value ? (m.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING), Se.value = we.IMPLANT_PLANNING) : Se.value = we.VOI_SETTINGS, qa(), m.objects.hasCPR() && m.objects.initializeCPRCurve(), m.objects.hasCPR() && (m.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING), Se.value = we.IMPLANT_PLANNING, qa()), Cg(), Vo(), Mg(gc), q.value ? (m.readOnly = !0, m.objects.lockUnlockAllImplantPins(!0)) : Us && m.objects.lockUnlockAllImplantPins(!0), m.objects.checkCollisions(void 0, void 0, !0), T.value = !0, R.value = !1;
      const Et = m.getOverlayContainer(), Ft = document.createElement("div");
      Ft.id = "stlLibraryContainer", Ft.style.position = "absolute", Ft.style.pointerEvents = "none", Ft.style.userSelect = "none", Ft.style.inset = "0px", Et.appendChild(Ft), m.sceneRepaint(), setTimeout(() => {
        m.resetOrientation();
      }, 0), m.setModified(!1), Ws && !q.value && m.setModified(!0), q.value ? Ye.debug("[Autosave] Lifecycle listeners skipped for read-only project") : (ye(), document.addEventListener("visibilitychange", Xe), window.addEventListener("pagehide", Ze), window.addEventListener("beforeunload", lt), Ye.debug("[Autosave] Lifecycle listeners attached")), yc();
    }), On(() => {
      Ye.debug("[Autosave] View unmount start"), ra(), document.removeEventListener("visibilitychange", Xe), window.removeEventListener("pagehide", Ze), window.removeEventListener("beforeunload", lt), Ye.debug("[Autosave] Lifecycle listeners removed"), de && (de(), de = null), $ && ($(null), $ = null);
    });
    function zs(oe, Oe = !1) {
      return new Promise((it) => {
        i.open($i, {
          props: {
            header: t("implant-planner.volumeTextureLimitTitle"),
            modal: !0,
            draggable: !1,
            style: { width: "34rem", maxWidth: "90vw" }
          },
          data: { message: oe, showCancel: Oe, showYesNo: Oe },
          emits: {
            onConfirm: () => it(!0),
            onReject: () => it(!1),
            onCancel: () => it(!1)
          },
          onClose: () => it(!1)
        });
      });
    }
    async function Eg(oe) {
      var _c;
      Ye.debug("[Autosave] loadProject start", { routeParams: oe }), Ws = !1, L.value = !0, C.value = 0, N.value = Math.random();
      const Oe = await s.getProjectInfo(oe);
      if (!Oe) {
        Ye.error("Project not found");
        return;
      }
      const it = Oe.project;
      it.projectFilename && (m.projectName = it.projectFilename.replaceAll(".zip", "")), m.patientInfo = Oe.patientInfo, m.projectInfo = it, m.projectHash = oe.projectHash;
      const Et = oe.fileHash, Ft = Array.isArray(Et) ? Et[0] : Et;
      m.fileHash = Ft, m.projectFullName.set(Oe.projectFullName), q.value ? (fe.value = "", Ye.debug("[Autosave] Disabled for read-only project", {
        projectName: it.projectFilename,
        patientName: it.patientName,
        fileHash: Ft
      })) : (fe.value = hp(it, Ft), Ye.debug("[Autosave] Active project context set", {
        projectName: it.projectFilename,
        patientName: it.patientName,
        fileHash: Ft,
        projectKey: fe.value
      })), Vo(), El.value = it.patientName;
      let Je, Ot = null;
      if (pe) {
        const hn = async () => {
          const Hn = R.value, Uo = L.value;
          R.value = !1, L.value = !1, await W.showInfoModal(t("implant-planner.iOSLimitedModeTitle"), t("implant-planner.iOSLimitedModeMessage")), R.value = Hn, L.value = Uo, N.value = Math.random();
        };
        try {
          const Hn = await s.getProjectLoadPreflight(it);
          if (Ot = Hn, Hn) {
            Je = s.buildDefaultProjectLoadSelection(Hn), R.value = !1, L.value = !1;
            const Uo = await ft(Hn);
            if (!Uo)
              return await ho(), !1;
            Je = Uo, R.value = !0, L.value = !0, N.value = Math.random();
          } else
            await hn();
        } catch (Hn) {
          Ye.warn("Failed to fetch iOS load preflight", Hn), await hn();
        }
      }
      try {
        if (Ot ?? (Ot = await s.getProjectLoadPreflight(it)), Ot != null && Ot.volumeDimensions) {
          const hn = Wh(Ot.volumeDimensions, (Je == null ? void 0 : Je.volumeQuality) === "decimated");
          if (hn && !hn.current.fits) {
            if (R.value = !1, L.value = !1, !((_c = hn.reduced) != null && _c.fits))
              return await zs(t("implant-planner.volumeTextureCannotFit")), await ho(), !1;
            if (!await zs(t("implant-planner.volumeTextureDecimationPrompt"), !0))
              return await ho(), !1;
            Je = { ...Je, volumeQuality: "decimated" }, R.value = !0, L.value = !0;
          }
        }
      } catch (hn) {
        return Ye.warn("Volume texture preflight failed", hn), R.value = !1, L.value = !1, await zs(t("implant-planner.volumeTextureCheckFailed")), await ho(), !1;
      }
      let An = null;
      if (q.value || !fe.value)
        Ye.debug("[Autosave] Recovery disabled", {
          readOnly: q.value,
          hasProjectKey: !!fe.value
        });
      else {
        await lc();
        const hn = await gM(fe.value);
        if (hn) {
          R.value = !1, L.value = !1, Ye.debug("[Autosave] Recovery candidate found, opening decision dialog", {
            projectKey: fe.value,
            snapshotId: hn.id,
            createdAt: hn.createdAt
          });
          let Hn = !1;
          An = await new Promise((Uo) => {
            const Ks = () => {
              R.value = !0, L.value = !0, N.value = Math.random(), Ye.debug("[Autosave] Recovery selection made, restoring loading overlay", {
                projectKey: fe.value
              });
            }, Zs = (Vg) => {
              Hn || (Hn = !0, Uo(Vg));
            };
            I.require({
              message: t("implant-planner.autosaveRecoveryPrompt"),
              header: t("implant-planner.autosaveRecoveryTitle"),
              icon: "pi pi-exclamation-triangle",
              acceptLabel: t("implant-planner.openAutosaved"),
              rejectLabel: t("implant-planner.openOriginal"),
              accept: () => {
                Ks(), Ye.debug("[Autosave] Recovery decision: open-autosaved", {
                  projectKey: fe.value,
                  snapshotId: hn.id
                }), Zs(hn.payload);
              },
              reject: () => {
                Ks(), Ye.debug("[Autosave] Recovery decision: open-original-and-delete-autosave", {
                  projectKey: fe.value,
                  snapshotId: hn.id
                }), _r(fe.value), Zs(null);
              },
              onHide: () => {
                Hn || (Ks(), Ye.debug("[Autosave] Recovery dialog closed without explicit action, defaulting to original and deleting autosave", {
                  projectKey: fe.value,
                  snapshotId: hn.id
                }), _r(fe.value), Zs(null));
              }
            });
          });
        } else
          Ye.debug("[Autosave] No recovery snapshot found for project", {
            projectKey: fe.value
          });
      }
      L.value = !0, C.value = 5, N.value = Math.random();
      const kg = (hn) => {
        C.value = hn.loaded / hn.total * 100, N.value = Math.random();
      }, Ti = await s.loadProject(it, m, vg, kg, An, Je);
      return Ye.debug("[Autosave] loadProject finished", {
        projectKey: fe.value,
        usedAutosavePayload: !!An,
        success: Ti.success
      }), Ti.success ? (Ws = Ti.loadedObjectsFromPatient, !0) : (m.warningString.set(Ti.error), m.hideLoading(), await ce("Warning"), await ho(), !1);
    }
    const Tl = (oe, Oe) => {
      var Et;
      m.objects.unSelectObject();
      const it = s.getLoadedProjectData();
      re.value === bt.WeblinkViewer && (oe = !0), m && it && i.open(Qu, {
        props: {
          closable: !0,
          modal: !0,
          header: t("implant-planner.saveProject"),
          style: { width: "40vw" },
          contentStyle: {
            overflow: "hidden"
          }
        },
        data: {
          context: m,
          projectData: it,
          isSaveAs: oe,
          projectLoader: s,
          implantPlannerViewMode: re.value,
          onComplete: Oe,
          onSuccess: async () => {
            var Ot;
            Ye.debug("[Autosave] Manual save success hook start", {
              previousProjectKey: fe.value,
              projectName: m.projectName,
              fileHash: m.fileHash
            }), fe.value && await _r(fe.value);
            const Ft = typeof m.fileHash == "string" ? m.fileHash : void 0, Je = ((Ot = m.projectInfo) == null ? void 0 : Ot.patientName) ?? El.value;
            fe.value = hp(
              {
                patientName: Je,
                projectFilename: `${m.projectName}.zip`,
                projectFileUuid: Ft
              },
              Ft
            ), Ye.debug("[Autosave] Manual save success hook done", {
              newProjectKey: fe.value,
              currentFileHash: Ft
            }), ye();
          },
          projectOwner: (Et = m.projectInfo.owner) == null ? void 0 : Et.username
        }
      });
    }, Hs = et(rl()), Tg = et(rl()), pc = r(rt);
    function Cg() {
      re.value === bt.WeblinkViewer && q.value ? xu() : rt.value === vn.HORIZONTAL ? cl() : ul();
    }
    Ka(() => {
      m && T.value && m.cleanup(), Pg(gc), pc === vn.HORIZONTAL && re.value === bt.WeblinkViewer && q.value ? cl() : pc === vn.SIDEBAR && re.value === bt.WeblinkViewer && q.value && ul();
    });
    const Bo = (oe) => {
      Hs.oldLayout = oe, Hs.newLayout = oe;
    };
    function qa() {
      const oe = Bt.find((Oe) => Oe.type === Se.value);
      oe && (fo.value = oe);
    }
    function Ng() {
      var oe;
      if (Se.value === we.DATA_IMPORT)
        return {
          patientName: El.value
        };
      if (Se.value === we.GUIDE_DESIGN)
        return {
          wizardsList: (oe = fo == null ? void 0 : fo.value) == null ? void 0 : oe.wizardsList
        };
      if (Se.value === we.IMPLANT_PLANNING && q.value)
        return {
          isReadOnly: !0
        };
    }
    const Lg = Te(() => Se.value === 0), mc = Te(() => Ei ? [we.CAD_DESIGN, we.GUIDE_DESIGN, we.CREATE_MODEL].includes(Se.value) : Se.value === Bt[Bt.length - 1].type), fc = () => {
      qa();
    }, Og = () => {
      Ye.debug("IPProjectLoaderView.vue: doneFromSteps clicked");
    }, Dg = () => {
      n.disableNavbarButtons([Ie.UNDO, Ie.REDO, Ie.SAVE, Ie.SAVE_AS, Ie.RESET, Ie.RULER, Ie.SETTINGS]);
    };
    async function Ag() {
      await fl().loadSTLLibrary();
    }
    ot(
      () => se.colorScheme,
      () => {
        m.setColorScheme(se.colorScheme);
      },
      {
        immediate: !0
      }
    );
    async function ho() {
      if (m.cadMode.get()) {
        if (!await m.exitCAD())
          return;
        m.setCADMode(!1);
      }
      await m.toolManager.destructAllTools(), m.cleanup(), re.value === bt.WeblinkViewer ? window.opener ? window.close() : await Re.push({ name: "Home", params: { name: ne.params.name, id: El.value } }) : (Np(), await Re.push({ name: "Patients", params: { id: El.value } }));
    }
    const gc = async (oe) => {
      if (oe === Ie.SAVE)
        Tl();
      else if (oe === Ie.SAVE_AS) {
        if (!go.value) {
          m.warningString.set(t("implant-planner.exitWizardBeforeSaving")), P.value = t("implant-planner.warning"), G.value = !0;
          return;
        }
        re.value === bt.WeblinkViewer ? Tl(!1) : Tl(!0);
      } else if (oe === Ie.SETTINGS)
        K.value = !0;
      else if (oe === Ie.RESET)
        m && (m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().resetView() : (m.resetOrientation(), m.sceneRepaint()));
      else if (oe === Ie.LAYOUT)
        Ue();
      else if (oe === Ie.SCREENSHOT) {
        const Oe = await m.takeWindowScreenshotWebcad();
        if (Oe) {
          const it = /* @__PURE__ */ new Date(), Et = (An) => String(An).padStart(2, "0"), Ft = `${m.projectInfo.projectFilename.replace(".zip", "")}_${it.getFullYear()}-${Et(it.getMonth() + 1)}-${Et(it.getDate())}_${Et(it.getHours())}.${Et(it.getMinutes())}.${Et(it.getSeconds())}.png`, Je = Oe.toDataURL();
          if (Je) {
            const An = document.createElement("a");
            document.body.appendChild(An), An.href = Je, An.download = Ft, An.click(), window.URL.revokeObjectURL(Je);
          }
          const Ot = await new Promise((An) => Oe.toBlob(An, "image/png"));
          if (Ot)
            try {
              await s.uploadScreenshot(m.patientInfo.extra.extra.study_instance_UID, Ft, ga.Image, Ot), uo(t("weblink.successfullyUploadedScreenshot"));
            } catch (An) {
              Tn(An, t("web-rg.uploadFailed"));
            }
        }
      } else if (oe === Ie.W_L) {
        if (m) {
          const Oe = m.toolManager.activeTool.WindowLevel.get();
          m.toolManager.activeTool.WindowLevel.set(!Oe), m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().toggleContrast(!Oe);
        }
      } else if (oe === Ie.HELP)
        await W.showViewerHelpModal();
      else if (oe === Ie.INFO) {
        const Oe = !m.getInfoFlag().get();
        m.setInfoFlag(Oe), m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().toggleInfo(Oe);
      } else if (oe === Ie.UNDO)
        m.cadMode.get() ? m.contextCAD.GetMainForm().Undo() : await m.undoManager.undo();
      else if (oe === Ie.REDO)
        m.cadMode.get() ? m.contextCAD.GetMainForm().Redo() : await m.undoManager.redo();
      else if (oe === Ie.RULER_DISTANCE)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().openRuler() : U.addNewDistanceMeasurement.notify();
      else if (oe === Ie.RULER_ANGLE)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().openAngle() : U.addNewAngleMeasurement.notify();
      else if (oe === Ie.RULER_ANNOTATION)
        m.cadMode.get() ? await new Promise((Oe) => {
          const it = () => {
            Oe();
          };
          m.contextCAD.GetMainForm().GetTopToolbar().openAnnotationA(it);
        }) : U.addNewAnnotation.notify();
      else if (oe === Ie.RULER_ROI)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().openPoly() : U.addNewROIMeasurement.notify();
      else if (oe === Ie.RULER_CLEAR)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().clearAllMeasurements() : U.clearAllMeasurements.notify();
      else if (oe === Ie.RULER_PLANE)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().openPlane();
      else if (oe === Ie.RULER_SPHERE)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().openSphere();
      else if (oe === Ie.RULER_TETRAHEDRON)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().openTetrahedron();
      else if (oe === Ie.RULER_LANDMARK)
        m.cadMode.get() && await new Promise((Oe) => {
          const it = () => {
            Oe();
          };
          m.contextCAD.GetMainForm().GetTopToolbar().openLandmarkA(it);
        });
      else if (oe === Ie.RULER_CLEAR_EXCEPT)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().clearAllExcept();
      else if (oe === Ie.EXIT || oe === Ie.ZIMVIE_LOGO || oe === Ie.RG_LOGO)
        if (go.value) {
          const Oe = async () => {
            n.hideNavbar(), await ho();
          };
          m.shouldProjectBeSaved() && !q.value ? i.open($i, {
            props: {
              closable: !1,
              draggable: !1,
              modal: !0,
              header: t("implant-planner.saveProject"),
              style: { width: "35vw" }
            },
            data: {
              message: t("implant-planner.saveChangesPrompt"),
              showCancel: !0,
              showYesNo: !0,
              showAll: !0
            },
            emits: {
              onConfirm: async () => {
                Tl(!0, Oe);
              },
              onReject: async () => {
                await Oe();
              },
              onCancel: () => {
              }
            }
          }) : await Oe();
        } else {
          m.warningString.set(t("implant-planner.exitWizardBeforeExitProject")), P.value = t("implant-planner.warning"), G.value = !0;
          return;
        }
    };
    function Rg() {
      Se.value = we.CPR_SETTINGS, qa();
    }
    const Ys = /* @__PURE__ */ new WeakMap();
    function Mg(oe) {
      const Oe = (it) => {
        Promise.resolve().then(() => oe(it)).catch((Et) => {
          console.error("Navbar button handler failed", Et), Tn(Et instanceof Error ? Et.message : String(Et));
        });
      };
      Ys.set(oe, Oe), ol.on(ll.NAVBAR_BUTTON_CLICKED, Oe);
    }
    function Pg(oe) {
      const Oe = Ys.get(oe);
      ol.off(ll.NAVBAR_BUTTON_CLICKED, Oe ?? oe), Ys.delete(oe);
    }
    const hc = Te(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), xg = Te(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), jg = Te(() => ({
      paddingLeft: "0.75rem",
      paddingRight: "0.75rem",
      paddingBottom: "0.5rem",
      height: `calc(-${_t.value ? 155 : _e.value}px + 100vh) !important`,
      //height reduced for navbar
      pointerEvents: X.value ? "none" : "auto",
      overflow: "hidden"
    })), bc = F(), vc = F(!1), yc = () => {
      const oe = bc.value;
      oe && (vc.value = oe.scrollTop + oe.clientHeight >= oe.scrollHeight - 1);
    }, Fg = Te(() => ({
      overflow: "auto",
      background: vc.value ? "none" : "linear-gradient(#0000, #0003) bottom / 100% 36px no-repeat"
    })), $g = (oe) => oe == we.CAD_DESIGN ? ![we.GUIDE_DESIGN, we.CREATE_MODEL].includes(Se.value) : oe == we.CREATE_MODEL ? we.CREATE_MODEL == Se.value : oe == we.GUIDE_DESIGN ? we.GUIDE_DESIGN == Se.value : !0;
    return (oe, Oe) => {
      const it = Lu, Et = Nu, Ft = Cu;
      return O(), J(ze, null, [
        R.value ? (O(), J("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Tt({
            position: "absolute",
            inset: "0px",
            background: xe.value,
            pointerEvents: "all",
            cursor: "wait",
            zIndex: "100000"
          })
        }, [
          d(r(fs), {
            strokeWidth: 5,
            hideSpinner: !0
          }, {
            default: w(() => [
              y("div", hM, [
                y("div", bM, V(te.value), 1),
                y("div", vM, [
                  (O(), he(r(gi), {
                    value: C.value,
                    key: N.value,
                    showValue: !1,
                    style: { height: "2rem", width: "100%" },
                    mode: L.value ? "determinate" : "indeterminate",
                    pt: { value: { style: { transition: "none" } } }
                  }, null, 8, ["value", "mode"]))
                ]),
                A.value ? (O(), J("div", yM, [
                  d(r(Ce), {
                    class: "btn-wizard-md p-confirmdialog-accept-button",
                    icon: "pi pi-times",
                    label: oe.$t("shared.cancel"),
                    onClick: wg
                  }, null, 8, ["label"])
                ])) : ue("", !0)
              ])
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        d(r(Gn), {
          visible: me.value,
          "onUpdate:visible": Oe[1] || (Oe[1] = (Je) => me.value = Je),
          breakpoints: { "960px": "75vw", "640px": "100vw" },
          modal: !0,
          style: { width: "50vw" },
          header: oe.$t("implant-planner.changeLayout")
        }, {
          footer: w(() => [
            d(r(Ee), { class: "justify-center gap-2" }, {
              default: w(() => [
                d(r(la), {
                  label: oe.$t("shared.ok"),
                  onClick: Oe[0] || (Oe[0] = (Je) => me.value = !1)
                }, null, 8, ["label"]),
                z.value ? ue("", !0) : (O(), he(r(ya), {
                  key: 0,
                  label: oe.$t("shared.cancel"),
                  onClick: Sg
                }, null, 8, ["label"]))
              ]),
              _: 1
            })
          ]),
          default: w(() => [
            d(it, {
              "model-value": Hs,
              cadMode: z.value,
              onUpdateLayout: uc
            }, null, 8, ["model-value", "cadMode"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: Ne.value,
          "onUpdate:visible": Oe[3] || (Oe[3] = (Je) => Ne.value = Je),
          breakpoints: { "960px": "45vw", "640px": "60vw" },
          modal: !0,
          style: { width: "30vw" },
          header: oe.$t("implant-planner.changeLayout")
        }, {
          footer: w(() => [
            y("div", _M, [
              d(r(Ce), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: oe.$t("shared.ok"),
                onClick: Oe[2] || (Oe[2] = (Je) => Ne.value = !1)
              }, null, 8, ["label"]),
              d(r(Ce), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: oe.$t("shared.cancel"),
                onClick: Ig
              }, null, 8, ["label"])
            ])
          ]),
          default: w(() => [
            d(tc, {
              "model-value": Tg,
              onUpdateLayout: uc
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: st.value,
          "onUpdate:visible": Oe[5] || (Oe[5] = (Je) => st.value = Je),
          closable: !1,
          draggable: !1,
          modal: "",
          header: oe.$t("implant-planner.warning"),
          style: { width: "25vw" }
        }, {
          default: w(() => [
            y("p", wM, V(oe.$t("implant-planner.cprDoesNotExist")), 1),
            y("div", SM, [
              d(r(Ce), {
                class: "w-full",
                label: oe.$t("implant-planner.goToCprSettings"),
                onClick: Oe[4] || (Oe[4] = (Je) => [Rg(), st.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: G.value,
          "onUpdate:visible": Oe[7] || (Oe[7] = (Je) => G.value = Je),
          closable: !1,
          draggable: !1,
          modal: "",
          header: P.value,
          style: { width: "25vw" }
        }, {
          default: w(() => [
            y("p", IM, V(r(m).warningString.get()), 1),
            y("div", EM, [
              d(r(Ce), {
                autofocus: "",
                class: "w-full",
                label: oe.$t("shared.ok"),
                onClick: Oe[6] || (Oe[6] = (Je) => [G.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: ee.value,
          "onUpdate:visible": Oe[16] || (Oe[16] = (Je) => ee.value = Je),
          closable: !1,
          draggable: !1,
          modal: "",
          header: oe.$t("implant-planner.iOSLimitedLoadTitle"),
          breakpoints: { "640px": "95vw" },
          style: { width: "40vw", maxWidth: "96vw" }
        }, {
          footer: w(() => [
            d(r(Ee), { class: "justify-center gap-2" }, {
              default: w(() => [
                d(r(ya), {
                  label: oe.$t("shared.cancel"),
                  onClick: jn
                }, null, 8, ["label"]),
                d(r(la), {
                  disabled: !kt.value,
                  label: oe.$t("shared.continue"),
                  onClick: Wt
                }, null, 8, ["disabled", "label"])
              ]),
              _: 1
            })
          ]),
          default: w(() => [
            _.value ? (O(), J("div", TM, [
              y("p", CM, V(oe.$t("implant-planner.iOSLimitedLoadDescription")), 1),
              y("div", NM, [
                y("div", null, V(oe.$t("implant-planner.iOSAvailableMemory")) + ": " + V(Ct(_.value.budgetMemoryBytes)), 1),
                y("div", null, V(oe.$t("implant-planner.iOSEstimatedSelectionMemory")) + ": " + V(Ct(vt.value)), 1),
                y("div", {
                  style: Tt({ color: mt.value >= 0 ? "#16a34a" : "#dc2626", fontWeight: "bold" })
                }, V(oe.$t("implant-planner.iOSRemainingMemory")) + ": " + V(mt.value >= 0 ? Ct(mt.value) : "-" + Ct(Math.abs(mt.value))), 5)
              ]),
              y("div", LM, [
                y("div", OM, V(oe.$t("implant-planner.iOSVolumeQuality")), 1),
                y("label", DM, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Oe[8] || (Oe[8] = (Je) => D.value = Je),
                    type: "radio",
                    value: "full"
                  }, null, 512), [
                    [wc, D.value]
                  ]),
                  y("span", null, V(oe.$t("implant-planner.iOSVolumeFull")) + " (" + V(Ct(_.value.volumeFullEstimateBytes)) + ")", 1)
                ]),
                y("label", AM, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Oe[9] || (Oe[9] = (Je) => D.value = Je),
                    type: "radio",
                    value: "decimated"
                  }, null, 512), [
                    [wc, D.value]
                  ]),
                  y("span", null, V(oe.$t("implant-planner.iOSVolumeDecimated")) + " (" + V(Ct(_.value.volumeDecimatedEstimateBytes)) + ")", 1)
                ])
              ]),
              _.value.implantCount ? (O(), J("label", RM, [
                Pt(y("input", {
                  "onUpdate:modelValue": Oe[10] || (Oe[10] = (Je) => Y.value = Je),
                  type: "checkbox"
                }, null, 512), [
                  [Go, Y.value]
                ]),
                y("span", null, V(oe.$t("implant-planner.iOSLoadImplants")) + " (" + V(_.value.implantCount) + ", " + V(Ct(_.value.implantEstimateBytes)) + ")", 1)
              ])) : ue("", !0),
              _.value.pinCount ? (O(), J("label", MM, [
                Pt(y("input", {
                  "onUpdate:modelValue": Oe[11] || (Oe[11] = (Je) => Q.value = Je),
                  type: "checkbox"
                }, null, 512), [
                  [Go, Q.value]
                ]),
                y("span", null, V(oe.$t("implant-planner.iOSLoadPins")) + " (" + V(_.value.pinCount) + ", " + V(Ct(_.value.pinEstimateBytes)) + ")", 1)
              ])) : ue("", !0),
              _.value.projectStlCandidates.length > 0 ? (O(), J("div", PM, [
                y("label", xM, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Oe[12] || (Oe[12] = (Je) => ae.value = Je),
                    type: "checkbox"
                  }, null, 512), [
                    [Go, ae.value]
                  ]),
                  y("span", null, V(oe.$t("implant-planner.iOSLoadProjectStls")), 1)
                ]),
                y("div", jM, [
                  (O(!0), J(ze, null, Rt(_.value.projectStlCandidates, (Je) => (O(), J("label", {
                    key: Je.id,
                    style: Tt({ display: "flex", gap: "0.5rem", alignItems: "center", opacity: ae.value ? 1 : 0.5 })
                  }, [
                    Pt(y("input", {
                      "onUpdate:modelValue": Oe[13] || (Oe[13] = (Ot) => Fe.value = Ot),
                      disabled: !ae.value,
                      type: "checkbox",
                      value: Je.name
                    }, null, 8, FM), [
                      [Go, Fe.value]
                    ]),
                    y("span", null, V(Je.name) + " (" + V(Ct(Je.estimatedBytes)) + ")", 1)
                  ], 4))), 128))
                ])
              ])) : ue("", !0),
              _.value.patientStlCandidates.length > 0 ? (O(), J("div", $M, [
                y("label", kM, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Oe[14] || (Oe[14] = (Je) => ge.value = Je),
                    type: "checkbox"
                  }, null, 512), [
                    [Go, ge.value]
                  ]),
                  y("span", null, V(oe.$t("implant-planner.iOSLoadPatientStls")), 1)
                ]),
                y("div", VM, [
                  (O(!0), J(ze, null, Rt(_.value.patientStlCandidates, (Je) => (O(), J("label", {
                    key: Je.id,
                    style: Tt({ display: "flex", gap: "0.5rem", alignItems: "center", opacity: ge.value ? 1 : 0.5 })
                  }, [
                    Pt(y("input", {
                      "onUpdate:modelValue": Oe[15] || (Oe[15] = (Ot) => Me.value = Ot),
                      disabled: !ge.value,
                      type: "checkbox",
                      value: Je.name
                    }, null, 8, BM), [
                      [Go, Me.value]
                    ]),
                    y("span", null, V(Je.name) + " (" + V(Ct(Je.estimatedBytes)) + ")", 1)
                  ], 4))), 128))
                ])
              ])) : ue("", !0)
            ])) : ue("", !0)
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        Pt(d(Ku, { class: "show-horizontal-bar horizontal-wizard-menu" }, {
          start: w(() => [
            (O(!0), J(ze, null, Rt(Bt, (Je) => (O(), he(Zu, {
              key: Je.type,
              modelValue: Se.value,
              "onUpdate:modelValue": Oe[17] || (Oe[17] = (Ot) => Se.value = Ot),
              index: Je.type,
              disabled: Je.disabled || !go.value,
              onClick: fc
            }, {
              default: w(() => [
                yt(V(Je.tabLabel), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "index", "disabled"]))), 128))
          ]),
          _: 1
        }, 512), [
          [sn, _t.value && Gt.value]
        ]),
        Pt(d(r(Ee), {
          id: "mainContainer",
          ref: "root",
          class: He(wt.value),
          style: Tt(jg.value)
        }, {
          default: w(() => [
            T.value ? (O(), J("div", UM, [
              Pt(y("div", {
                ref_key: "scrollEl",
                ref: bc,
                class: "h-full",
                style: Tt(Fg.value),
                onScroll: yc
              }, [
                y("div", GM, [
                  d(cg, null, {
                    mainMenuTabs: w(() => [
                      (O(!0), J(ze, null, Rt(Bt, (Je) => (O(), J(ze, {
                        key: Je.type
                      }, [
                        $g(Je.type) ? (O(), he(dg, {
                          key: 0,
                          modelValue: Se.value,
                          "onUpdate:modelValue": Oe[18] || (Oe[18] = (Ot) => Se.value = Ot),
                          index: Je.type,
                          disabled: Je.disabled || !go.value,
                          isLast: mc.value,
                          onClick: fc
                        }, {
                          default: w(() => [
                            yt(V(Je.tabLabel), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "index", "disabled", "isLast"])) : ue("", !0)
                      ], 64))), 128))
                    ]),
                    _: 1
                  })
                ])
              ], 36), [
                [sn, !_t.value && Gt.value]
              ]),
              Pt(d(r(Ee), {
                id: "wizardTabContainer",
                class: He(Dn.value),
                style: Tt(hc.value)
              }, {
                default: w(() => [
                  y("div", WM, [
                    d(Et, {
                      isFirstItem: Lg.value,
                      isVisible: !R.value && go.value && x.value && Gt.value,
                      isLastItem: mc.value,
                      onNextStep: yg,
                      onPreviousStep: _g,
                      onHideWizard: S
                    }, {
                      default: w(() => {
                        var Je;
                        return [
                          (O(), he(Ea(((Je = fo.value) == null ? void 0 : Je.component) ?? {}), Pe(Ng(), {
                            onDone: Og,
                            onShowWizard: Oe[19] || (Oe[19] = (Ot) => v.value = !0),
                            onHideWizard: S
                          }), null, 16))
                        ];
                      }),
                      _: 1
                    }, 8, ["isFirstItem", "isVisible", "isLastItem"])
                  ])
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [sn, v.value]
              ]),
              Pt(d(r(Ee), {
                class: He(Dn.value),
                style: Tt(hc.value)
              }, {
                default: w(() => [
                  d(r(Lt), {
                    id: "toggleWizardContainer",
                    class: "items-center",
                    style: { "border-radius": "16px", margin: "0 0.5rem", background: "transparent !important" }
                  }, {
                    default: w(() => [
                      d(r(Ce), {
                        class: "web-rg-toggle-wiz-btn",
                        iconSrc: "/icons/rg_left_panel_open.svg",
                        onClick: Oe[20] || (Oe[20] = (Je) => v.value = !0)
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [sn, !v.value]
              ])
            ])) : ue("", !0),
            d(r(Ee), {
              id: "wizard-container",
              style: Tt(xg.value)
            }, {
              default: w(() => [
                ue("", !0),
                Oe[23] || (Oe[23] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                Pt(y("div", {
                  ref_key: "vtkContainer",
                  ref: E,
                  id: "vtkContainer",
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden" }
                }, null, 512), [
                  [sn, !z.value]
                ]),
                Pt(y("div", {
                  ref_key: "vtkContainerCAD",
                  ref: g,
                  id: "vtkContainerCAD",
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden", position: "relative" }
                }, null, 512), [
                  [sn, z.value]
                ]),
                Oe[24] || (Oe[24] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class", "style"]), [
          [sn, T.value]
        ]),
        K.value ? (O(), he(Ft, {
          key: 1,
          license: b.value,
          visible: !0,
          settings: r(m).settings,
          onConfirm: Ae,
          onCancel: Ae
        }, null, 8, ["license", "settings"])) : ue("", !0)
      ], 64);
    };
  }
}), Mx = /* @__PURE__ */ $t(zM, [["__scopeId", "data-v-fc9e8837"]]);
function HM() {
  return {
    dentistCode: "",
    dentistOfficeCode: "",
    project: {
      code: "",
      notes: "",
      panoramicImage: "",
      patient: {
        code: "",
        name: "",
        surname: "",
        birthDate: "",
        gender: "",
        fiscalCode: ""
      },
      implants: [],
      frontalImage: "",
      occlusalImage: "",
      rightImage: "",
      leftImage: ""
    }
  };
}
async function YM(e) {
  const t = nt("implant-planner.exportingProject");
  if (!e.objects.hasCPR())
    return e.warningString.set(nt("implant-planner.cprCurveMissingExportWarning")), e.warningDialogEvent.notify(nt("shared.error")), null;
  const n = HM();
  let a = e.patientInfo;
  a || (console.error("Patient info is missing"), a = {
    patientName: "",
    extra: {
      patientName: "",
      modality: "",
      patientID: "",
      doctorID: "",
      study_instance_UID: "",
      description: ""
    }
  }), n.dentistCode = a.extra.doctorID, n.dentistOfficeCode = a.extra.doctorID, n.project.code = a.extra.study_instance_UID, n.project.notes = "";
  const o = (m, S) => {
    const E = e.settings.implants.showWarningsPopup;
    e.settings.implants.showWarningsPopup = S, e.settings.implants.securityZone = m, e.settings.onSettingsModified.notify(), e.settings.implants.showWarningsPopup = E;
  };
  e.showLoading(t, !0, 0, !0), o(!1, !0);
  const l = [1600, 800];
  e.objects.SetImplantReportDims(l, l, l, l, l, "", [255, 255, 255]);
  const s = e.layoutManager.getCurrentLayoutState().template;
  e.toolManager.coordControl.hideCrossIndicators = !0, e.objects.hasCPR() && (n.project.panoramicImage = await e.objects.SaveImplantReportCPR()), e.showLoading(t, !0, 5, !0);
  let i = a.firstName.split(" ");
  const c = a.firstName.split("^");
  c.length >= 2 && (i = c), i.length >= 1 ? n.project.patient.name = i[0] : n.project.patient.name = "", i.length >= 2 ? n.project.patient.surname = i[1] : n.project.patient.surname = "", n.project.patient.code = a.extra.patientID;
  const u = a.dateOfBirth.getFullYear(), p = String(a.dateOfBirth.getMonth() + 1).padStart(2, "0"), b = String(a.dateOfBirth.getDate()).padStart(2, "0");
  n.project.patient.birthDate = `${u}${p}${b}`, n.project.patient.gender = "", n.project.patient.fiscalCode = "";
  const f = e.objects.implants.size;
  let h = 0;
  for (const m of e.objects.implants.values()) {
    e.showLoading(t, !0, 10 + Math.floor(70 * h / f), !0), h++;
    const S = {
      images: [],
      crossSectionImage: "",
      position: "",
      producer: "",
      model: "",
      diameter: "",
      length: "",
      implant_code: "",
      abutment: "",
      abutmentDimensions: "",
      abutment_code: ""
    }, E = await m.getCrossScreenshot(Nn.CROSS, void 0, 0.75), g = await m.getCrossScreenshot(Nn.TANGENT, void 0, 0.75);
    let v = "";
    const T = e.getViewWidget(Nn._3D);
    if (e.layoutManager.setLayout(Ve._FULLSCREEN_3D), T) {
      const C = m.getPosition(), A = m.getNormal(), j = m.getBinormal(), N = T.getRenderer().getActiveCamera().getDistance(), x = yo.create(), z = yo.create();
      yo.scaleAndAdd(x, C, A, -N), yo.scale(z, j, -1), T.getRenderer().getActiveCamera().setViewUp(z[0], z[1], z[2]), T.getRenderer().getActiveCamera().setPosition(x[0], x[1], x[2]), T.getRenderer().resetCameraClippingRange();
      const X = await Ko({ context: e, view: T, noOverlay: !0, compression: 0.75, background: "white" });
      X && (v = X);
    }
    S.images.push(g), S.images.push(v), S.crossSectionImage = E, S.position = m.getName();
    const R = m.getImplantInfo().implantInfo;
    S.producer = R.manufacturerName, S.model = R.modelName, S.diameter = R.diameter.toString(), S.length = R.length.toString(), S.implant_code = R.sellingCode || "NONE";
    const L = m.getAbutment();
    if (L) {
      const C = L.getAbutmentInfo();
      S.abutment = C.modelName, S.abutmentDimensions = C.name, S.abutment_code = C.abutmentSellingCode || "NONE";
    }
    n.project.implants.push(S);
  }
  e.showLoading(t, !0, 85, !0), e.layoutManager.setLayout(Ve._FULLSCREEN_3D);
  const I = e.getViewWidget(Nn._3D);
  if (I) {
    e.toolManager.coordControl.set3DViewOrientation(Ll.Front);
    const m = await Ko({ context: e, view: I, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.frontalImage = m || "";
    let S = Ll.Top;
    e.CPRType == an.MAXILLA && (S = Ll.Bottom), e.toolManager.coordControl.set3DViewOrientation(S);
    const E = await Ko({ context: e, view: I, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.occlusalImage = E || "", e.toolManager.coordControl.set3DViewOrientation(Ll.Right);
    const g = await Ko({ context: e, view: I, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.rightImage = g || "", e.toolManager.coordControl.set3DViewOrientation(Ll.Left);
    const v = await Ko({ context: e, view: I, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.leftImage = v || "";
  }
  return e.showLoading(t, !0, 95, !0), e.toolManager.coordControl.hideCrossIndicators = !1, s && e.layoutManager.setLayout(s), e.showLoading(t, !0, 100, !0), o(!0, !0), e.hideLoading(), n;
}
const KM = { style: { "text-align": "center", color: "white", "text-shadow": "0 1px 1px black" } }, ZM = {
  key: 0,
  class: "mt-20",
  style: { width: "20vw" }
}, JM = { style: { color: "white" } }, XM = { style: { display: "flex", "justify-content": "center" } }, qM = { class: "ml-1 flex justify-center" }, QM = { class: "col-span-12" }, eP = {
  class: "ml-1 flex justify-start",
  style: { "white-space": "pre-wrap" }
}, tP = { class: "col-span-12" }, nP = {
  key: 0,
  id: "sidebarContainer",
  class: "flex flex-row",
  style: { "margin-top": "0.5rem", "margin-bottom": "0.5rem" }
}, aP = {
  class: "mainMenuTabs",
  style: { background: "linear-gradient(to right, rgba(24, 43, 75, 0.7) 15%, rgba(22, 25, 36, 0.7) 100%)", "border-radius": "16px" }
}, oP = {
  class: "grow",
  style: { "border-radius": "16px", margin: "0 0.5rem", background: "linear-gradient(to right, #172e4d 100%, #162a46 100%)" }
}, lP = /* @__PURE__ */ qe({
  __name: "IPProjectLoaderViewRedesignAlfred",
  props: {
    loader: {},
    source: { default: al.IMPLANT_PLANNER }
  },
  setup(e) {
    const { t } = Yt(), n = Po(), a = e, o = a.loader(Jn()), l = Aa(), s = ia();
    let i = new ws(s.getAssetUrl(""));
    const c = () => {
      console.log("hide IProjectLoaderVie"), p.value = !1;
    }, u = F(), p = F(!0), b = F(!1), f = F(!0), h = F(!1), I = F(0), m = F(Math.random()), S = F(!0), E = F(!1), g = F(0), v = F(), T = F("Loading project"), R = gl(), L = Mo(), C = Jn(), A = oa(), { wizardLayouts: j } = Co(oa()), N = Es(), x = mu.actions, z = Ra(), X = ml(), H = F(X.getUser().license);
    F(kn.REALGUIDE), F(!0);
    const M = F(a.source == al.IMPLANT_PLANNER ? bt.ImplantPlannerBase : bt.WeblinkViewer), te = Tp(), ne = Te(() => te.rgScreenType === "lg" ? 90 : 70);
    Ss(i);
    const W = Te(() => b.value ? "rgba(91, 91, 91, 0.5)" : "var(--webcad-main-bg)"), se = () => {
      const ce = i.undoManager.getUndoDescription(), Se = i.undoManager.getRedoDescription(), rt = ce ? `Undo ${ce}` : void 0, _t = Se ? `Redo ${Se}` : void 0;
      let Gt = [], wt = [];
      i.undoManager.canUndo() ? Gt.push(Ie.UNDO) : wt.push(Ie.UNDO), i.undoManager.canRedo() ? Gt.push(Ie.REDO) : wt.push(Ie.REDO), n.disableNavbarButtons(wt), n.enableNavbarButtons(Gt);
      const Dn = [
        { button: Ie.UNDO, tooltip: rt },
        { button: Ie.REDO, tooltip: _t }
      ];
      n.addTooltips(Dn);
    }, be = F(!1), Re = () => {
      be.value = !1;
    }, U = F(!1), ie = F(!1), re = ks(), q = () => {
      re.stlLibraryWindowVisible ? ie.value = !0 : U.value = !0;
    }, De = F(!1), _e = F(!1), xe = F(!1), k = F("");
    A.prepareDefaults(ec());
    const K = F(i.layoutManager.wizardTabIndex.get()), { menuMode: Ae } = Co(oa()), me = Te(() => Ae.value === vn.HORIZONTAL && b.value), Ne = Te(() => ({
      "bg-top-nav-bar-wiz dynamic-margin-left bg-body-wiz": !0,
      "mt-1 dynamic-margin-left": M.value === bt.WeblinkViewer || !me.value
    })), Ge = Te(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": M.value !== bt.WeblinkViewer && !me.value
    })), Ue = [
      {
        type: we.VOI_SETTINGS,
        tabLabel: "VOI Settings",
        component: Ou,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.THREED_SETTINGS,
        tabLabel: "3D Settings",
        component: Du,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.DATA_IMPORT,
        tabLabel: "Data Import",
        component: Au,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.CPR_SETTINGS,
        tabLabel: "CPR Settings",
        component: Ru,
        defaultLayout: Ve._CPR_SETTINGS_WIZARD
      },
      {
        type: we.NERVE_DRAWING,
        tabLabel: "Nerve Drawing",
        component: Pu,
        defaultLayout: Ve._NERVE_DRAWING_WIZARD
      },
      {
        type: we.TEETH_SETUP,
        tabLabel: "Teeth Setup",
        component: nc,
        defaultLayout: Ve._FULLSCREEN_3D
      },
      {
        type: we.IMPLANT_PLANNING,
        tabLabel: "Implant Planning",
        component: zu,
        defaultLayout: Ve._3D_CPR_CROSS_TANGENT_AXIAL
      }
      /*
      {
          type: WizardType.REPORTS_EXPORT,
          tabLabel: "Reports / Export",
      },
      {
          type: WizardType.ADVANCED_TOOLS,
          tabLabel: "Advanced Tools",
      },
      {
          type: WizardType.OBJECT_LIST,
          tabLabel: "Object List",
      },
      */
      // {
      //     type: WizardType.GUIDE_DESIGN,
      //     tabLabel: "Guide Design",
      //     component: IPGuideDesignPrimaryComponentView,
      //     defaultLayout: LayoutTemplate._FULLSCREEN_3D,
      //     disabled: false,
      //     wizardsList: [
      //         {
      //             component: IPVolumeUndercutWizardView,
      //             stepName: "Volume Undercut",
      //         },
      //         {
      //             component: IPGuideDesignWizardView,
      //             stepName: "Guide Design",
      //         },
      //     ],
      // },
      /*
      {
          type: WizardType.SEGMENTATION,
          tabLabel: "Segmentation",
      },
      {
          type: WizardType.SANDBOX,
          tabLabel: "Sandbox",
      },
      {
          type: WizardType.PROJECT_SETUP,
          tabLabel: "Project Setup",
      },
      {
          type: WizardType.RECONSTRUCTION_SETUP,
          tabLabel: "Reconstruction Setup",
      },
      {
          type: WizardType.ACTIVE_RECONSTRUCTION,
          tabLabel: "Active Reconstruction",
      },
      */
    ];
    oo.SHOW_CAD_WIZARD && Ue.push({
      type: we.CAD,
      tabLabel: "Cad",
      component: Yu,
      defaultLayout: Ve._3D_CPR_CROSS_TANGENT_AXIAL
    });
    const Ke = F(Ue.find((ce) => ce.type === K.value));
    i.setModalsInstance(L), i.setResourceUrl("/resources/");
    const st = i.getEngineInstance();
    async function G(ce, Se) {
      var Gt, wt, Dn;
      ce.setRootElement(u.value), ce.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (Gt = ce.getInteractorStyle()) == null || Gt.setCameraInteractorEnabled(!0), (wt = ce.getInteractorStyle()) == null || wt.setMouseMode(ce.settings.general.useLeftButtonForRotationOn3d ? kn.REALGUIDE : kn.IMPLANTPLANNER), (Dn = ce.getInteractorStyle()) == null || Dn.setMouseMode2D(kn.REALGUIDE), j.value[we.VOI_SETTINGS] !== void 0 && A.setWizardLayout(we.VOI_SETTINGS, Ve._FULLSCREEN_3D);
      for (const Bt of Object.keys(j.value))
        ce.layoutManager.storeLayout(Bt.toString(), j.value[Number(Bt)]);
      ce.layoutManager.constructAllWindows();
      const _t = ce.layoutManager.getLayout(K.value.toString()) ?? ce.layoutManager.getDefaultLayout();
      ce.layoutManager.setLayout(_t), Me(_t);
    }
    const P = (ce) => {
      re.stlLibraryWindowVisible ? (i.layoutManager.storeLayout("StlLibrary", ce), i.layoutManager.setLayout(ce)) : (i.layoutManager.storeLayout(K.value.toString(), ce), i.layoutManager.setLayout(ce), Me(ce), A.setWizardLayout(K.value, ce));
    }, de = () => {
      n.enableNavbarButtons([Ie.LAYOUT]);
    }, fe = () => {
      n.disableNavbarButtons([Ie.LAYOUT]);
    }, ke = () => {
      const ce = Ue.findIndex((_t) => _t.type === K.value);
      if (ce === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (ce === Ue.length - 1) {
        console.warn("nextStep called on last wizard");
        return;
      }
      let Se = 0;
      ce == we.CPR_SETTINGS && i.CPRType !== an.MANDIBLE && (Se = 1);
      const rt = Ue[ce + 1 + Se].type;
      i.layoutManager.wizardTabIndex.set(rt), K.value = rt, je();
    }, le = () => {
      const ce = Ue.findIndex((_t) => _t.type === K.value);
      if (ce === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (ce === 0) {
        console.warn("previousStep called on first wizard");
        return;
      }
      let Se = 0;
      ce == 5 && i.CPRType !== an.MANDIBLE && (Se = 1);
      const rt = Ue[ce - 1 - Se].type;
      i.layoutManager.wizardTabIndex.set(rt), K.value = rt, je();
    };
    z.onEvent(i.warningDialogEvent, (ce) => {
      k.value = ce, xe.value = !0;
    }), z.onEvent(i.screenshotUploadEvent, async ({ filename: ce, image: Se }) => {
      var _t, Gt, wt;
      const rt = (wt = (Gt = (_t = i.patientInfo) == null ? void 0 : _t.extra) == null ? void 0 : Gt.extra) == null ? void 0 : wt.study_instance_UID;
      if (rt)
        try {
          await o.uploadScreenshot(rt, ce, ga.Image, Se), uo(t("weblink.successfullyUploadedScreenshot"));
        } catch (Dn) {
          Tn(Dn, t("web-rg.uploadFailed"));
        }
    }), z.watch(i.layoutBtnVisible, (ce) => {
      ce ? de() : fe();
    }), z.watch(i.loadingFlag, (ce) => {
      f.value = ce, T.value = i.loadingText, h.value = i.progressBarFlag, I.value = i.progressBarValue.get();
    }), z.watch(i.nextPrevVisible, (ce) => {
      S.value = ce, console.log("Setting nextprevFlag to:", ce);
    }), z.watch(i.cadMode, (ce) => {
      E.value = ce, g.value = ce ? 1 : 0, console.log("Setting cadMode to:", ce);
    }), z.watch(i.progressBarValue, (ce) => {
      I.value = ce;
    }), z.watch(i.layoutManager.wizardTabIndex, () => {
      K.value = i.layoutManager.wizardTabIndex.get(), je();
    });
    const pe = F(!0);
    z.watch(i.tabButtonsEnabled, (ce) => {
      pe.value = ce, console.log("TabButtonsEnabled", pe.value);
    }), ot(K, (ce) => {
      i.toolManager.activeTool.WindowLevel.set(!1), ju(), i.layoutManager.wizardTabIndex.set(ce);
      let Se = i.layoutManager.getLayout(ce.toString()) ?? i.layoutManager.getDefaultLayout();
      if (de(), _(), K.value === we.DATA_IMPORT && (i.layoutManager.storeLayout(we.DATA_IMPORT.toString(), Ve._FULLSCREEN_3D), Se = i.layoutManager.getLayout(ce.toString()) ?? i.layoutManager.getDefaultLayout(), fe()), K.value == we.CPR_SETTINGS && (i.layoutManager.storeLayout(we.CPR_SETTINGS.toString(), Ve._CPR_SETTINGS_WIZARD), Se = i.layoutManager.getLayout(ce.toString()) ?? i.layoutManager.getDefaultLayout(), fe()), K.value == we.NERVE_DRAWING && (i.objects.hasCPR() || (_e.value = !0), i.layoutManager.storeLayout(we.NERVE_DRAWING.toString(), Ve._NERVE_DRAWING_WIZARD), Se = i.layoutManager.getLayout(ce.toString()) ?? i.layoutManager.getDefaultLayout(), fe()), K.value == we.GUIDE_DESIGN && (i.layoutManager.storeLayout(we.GUIDE_DESIGN.toString(), Ve._FULLSCREEN_3D), Se = i.layoutManager.getLayout(ce.toString()) ?? i.layoutManager.getDefaultLayout(), fe()), ((_t) => {
        switch (console.log("setActiveTool wizard : ", _t), _t) {
          case we.CPR_SETTINGS:
            i.toolManager.setTool(un.CPR, Qt.PRIMARY);
            break;
          case we.NERVE_DRAWING:
            i.toolManager.setTool(un.NERVE, Qt.PRIMARY);
            break;
          case we.DATA_IMPORT:
            i.toolManager.setTool(un.MATCHING_TOOL, Qt.PRIMARY);
            break;
          default:
            i.toolManager.setTool(un.NONE, Qt.PRIMARY);
        }
      })(K.value), K.value === we.DATA_IMPORT && fe(), !(K.value === we.CPR_SETTINGS || K.value === we.NERVE_DRAWING)) {
        const _t = i.layoutManager.layoutTemplateContainsCpr(Se);
        De.value = i.objects.hasCPR(), _t && !De.value && (Se = Ve._3D_MPR);
      }
      i.layoutManager.setLayout(Se), i.resize(), i.resetOrientation(), Me(Se), A.updateSelectedWizardIndex(K.value), _();
    });
    const Z = () => {
      var Se, rt;
      i.layoutManager.storeLayout(((Se = Ke.value) == null ? void 0 : Se.type.toString()) ?? "", ((rt = Ke.value) == null ? void 0 : rt.defaultLayout) ?? Ve._FULLSCREEN_3D);
      const ce = i.layoutManager.getLayout(K.value.toString()) ?? i.layoutManager.getDefaultLayout();
      i.layoutManager.setLayout(ce), U.value = !1, Me(ce);
    }, ee = () => {
      const ce = i.layoutManager.getLayout("StlLibrary");
      ce !== void 0 && i.layoutManager.setLayout(ce), ie.value = !1;
    }, $ = F(), _ = () => {
      console.log("showProjectName projectFullName.value: ", v.value), v.value && n.showProjectOnNavbar(v.value);
    };
    ot(b, () => {
      b.value && (console.log("watch loaded!"), n.showNavbar({
        buttons: Bu(M.value),
        showZimvieLogo: !1,
        showNavbarPosition: !0,
        isWizard: !0,
        showDoctors: !1
      }));
    }), Mt(async () => {
      Cp(), n.showOnlyLogo(), _(), i.undoManager.onUndoChange.subscribe(se), se(), i.toolManager.onUndoManagerChange.subscribe(se), i.toolManager.onUndoManagerPop.subscribe(se), M.value === bt.WeblinkViewer && (ft(), Vt()), console.log("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const ce = performance.now(), Se = await st;
      Is(Se), console.log("engine await: ", performance.now() - ce), await D(R.params), M.value === bt.WeblinkViewer && (i.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING), K.value = we.IMPLANT_PLANNING, je()), i.objects.hasCPR() && i.objects.initializeCPRCurve(), i.objects.hasCPR() && (i.layoutManager.wizardTabIndex.set(we.IMPLANT_PLANNING), K.value = we.IMPLANT_PLANNING, je()), Fe(), _(), ye(jn), M.value === bt.WeblinkViewer && (i.readOnly = !0, i.objects.lockUnlockAllImplantPins(!0)), i.objects.checkCollisions(), b.value = !0, f.value = !1;
      const rt = i.getOverlayContainer(), _t = document.createElement("div");
      _t.id = "stlLibraryContainer", _t.style.position = "absolute", _t.style.pointerEvents = "none", _t.style.userSelect = "none", _t.style.inset = "0px", rt.appendChild(_t), i.sceneRepaint(), setTimeout(() => {
        i.resetOrientation();
      }, 0), R.params.alfredId && (b.value = !0, setTimeout(async () => {
        const Gt = await YM(i);
        try {
          if (Gt) {
            const wt = i.patientInfo;
            Gt.dentistCode = "T002-004", Gt.project.patient.birthDate = of(wt.dateOfBirth), Gt.project.patient.ALFRED_PATIENT_ID = parseInt(R.params.alfredId), await C.exportToAlfred(Gt), await L.showInfoModal("Export to Alfred", "Export to Alfred complete, please return to Alfred to continue the import.");
          }
        } catch (wt) {
          console.error("Export to Alfred failed", wt), await L.showInfoModal("Export to Alfred", "Export to Alfred failed, please try again.");
        }
      }, 500));
    });
    async function D(ce) {
      h.value = !0, I.value = 0, m.value = Math.random();
      const Se = await o.getProjectInfo(ce);
      if (!Se) {
        console.error("Project not found");
        return;
      }
      const rt = Se.project;
      i.patientInfo = Se.patientInfo, v.value = Se.projectFullName, _(), $.value = rt.patientName, h.value = !0, I.value = 5, m.value = Math.random();
      const _t = (Gt) => {
        I.value = Gt.loaded / Gt.total * 100, m.value = Math.random();
      };
      await o.loadProject(rt, i, G, _t);
    }
    const Y = (ce) => {
      i.objects.unSelectObject();
      const Se = o.getLoadedProjectData();
      i && Se && l.open(Qu, {
        props: {
          closable: !1,
          modal: !0,
          header: t("implant-planner.saveProject"),
          style: { width: "40vw" }
        },
        data: {
          context: i,
          projectData: Se,
          isSaveAs: ce,
          projectLoader: o,
          implantPlannerViewMode: M.value
        }
      });
    }, Q = et(rl()), ae = et(rl()), ge = r(Ae);
    function Fe() {
      M.value === bt.WeblinkViewer ? xu() : Ae.value === vn.HORIZONTAL ? cl() : ul();
    }
    Ka(() => {
      i && b.value && i.cleanup(), Xe(jn), ge === vn.HORIZONTAL && M.value === bt.WeblinkViewer ? cl() : ge === vn.SIDEBAR && M.value === bt.WeblinkViewer && ul();
    });
    const Me = (ce) => {
      Q.oldLayout = ce, Q.newLayout = ce;
    };
    function je() {
      const ce = Ue.find((Se) => Se.type === K.value);
      ce && (Ke.value = ce);
    }
    function dt() {
      var ce;
      if (K.value === we.DATA_IMPORT)
        return {
          patientName: $.value
        };
      if (K.value === we.GUIDE_DESIGN)
        return {
          wizardsList: (ce = Ke == null ? void 0 : Ke.value) == null ? void 0 : ce.wizardsList
        };
      if (K.value === we.IMPLANT_PLANNING && M.value === bt.WeblinkViewer)
        return {
          isReadOnly: !0
        };
    }
    const vt = Te(() => K.value === 0), mt = Te(() => K.value === Ue[Ue.length - 1].type), kt = () => {
      je();
    }, Ct = () => {
      console.log("IPProjectLoaderView.vue: doneFromSteps clicked -");
    }, ft = () => {
      n.disableNavbarButtons([Ie.UNDO, Ie.REDO, Ie.SAVE, Ie.SAVE_AS, Ie.RESET, Ie.RULER, Ie.SETTINGS]);
    };
    async function Vt() {
      await fl().loadSTLLibrary();
    }
    ot(
      () => A.colorScheme,
      () => {
        i.setColorScheme(A.colorScheme);
      },
      {
        immediate: !0
      }
    );
    async function Wt() {
      await i.toolManager.destructAllTools(), M.value === bt.WeblinkViewer ? await N.push({ name: "Home", params: { name: R.params.name, id: $.value } }) : (Np(), await N.push({ name: "Patients", params: { id: $.value } }));
    }
    const jn = async (ce) => {
      if (ce === Ie.SAVE)
        Y();
      else if (ce === Ie.SAVE_AS)
        Y(!0);
      else if (ce === Ie.SETTINGS)
        be.value = !0;
      else if (ce === Ie.RESET)
        i && (i.resetOrientation(), i.sceneRepaint());
      else if (ce === Ie.LAYOUT)
        q();
      else if (ce === Ie.SCREENSHOT) {
        const Se = await i.takeWindowScreenshotWebcad();
        if (Se) {
          const rt = /* @__PURE__ */ new Date(), _t = (Bt) => String(Bt).padStart(2, "0"), Gt = `${i.projectInfo.projectFilename.replace(".zip", "")} ${rt.getFullYear()}-${_t(rt.getMonth() + 1)}-${_t(rt.getDate())} at ${_t(rt.getHours())}.${_t(rt.getMinutes())}.${_t(rt.getSeconds())}.png`, wt = Se.toDataURL();
          if (wt) {
            const Bt = document.createElement("a");
            document.body.appendChild(Bt), Bt.href = wt, Bt.download = Gt, Bt.click(), window.URL.revokeObjectURL(wt);
          }
          const Dn = await new Promise((Bt) => Se.toBlob(Bt, "image/png"));
          if (Dn)
            try {
              await o.uploadScreenshot(i.patientInfo.extra.extra.study_instance_UID, Gt, ga.Image, Dn), uo(t("weblink.successfullyUploadedScreenshot"));
            } catch (Bt) {
              Tn(Bt, t("web-rg.uploadFailed"));
            }
        }
      } else if (ce === Ie.W_L) {
        if (i) {
          const Se = i.toolManager.activeTool.WindowLevel.get();
          i.toolManager.activeTool.WindowLevel.set(!Se);
        }
      } else ce === Ie.HELP ? await L.showViewerHelpModal() : ce === Ie.INFO ? i.setInfoFlag(!i.getInfoFlag().get()) : ce === Ie.UNDO ? await i.undoManager.undo() : ce === Ie.REDO ? await i.undoManager.redo() : ce === Ie.RULER_DISTANCE ? x.addNewDistanceMeasurement.notify() : ce === Ie.RULER_ANGLE ? x.addNewAngleMeasurement.notify() : ce === Ie.RULER_ANNOTATION ? x.addNewAnnotation.notify() : ce === Ie.RULER_ROI ? x.addNewROIMeasurement.notify() : ce === Ie.RULER_CLEAR ? x.clearAllMeasurements.notify() : ce === Ie.ZIMVIE_LOGO ? (n.hideNavbar(), await Wt()) : ce === Ie.RG_LOGO ? (n.hideNavbar(), await Wt()) : ce === Ie.EXIT && (n.hideNavbar(), await Wt());
    };
    function ra() {
      K.value = we.CPR_SETTINGS, je();
    }
    const B = /* @__PURE__ */ new WeakMap();
    function ye(ce) {
      const Se = (rt) => {
        Promise.resolve().then(() => ce(rt)).catch((_t) => {
          console.error("Navbar button handler failed", _t), Tn(_t instanceof Error ? _t.message : String(_t));
        });
      };
      B.set(ce, Se), ol.on(ll.NAVBAR_BUTTON_CLICKED, Se);
    }
    function Xe(ce) {
      const Se = B.get(ce);
      ol.off(ll.NAVBAR_BUTTON_CLICKED, Se ?? ce), B.delete(ce);
    }
    const Ze = Te(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${me.value ? 160 : 95}px + 100vh) !important`
    })), lt = Te(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${me.value ? 155 : ne.value}px + 100vh) !important`
    }));
    return (ce, Se) => {
      const rt = Lu, _t = Nu, Gt = Cu;
      return O(), J(ze, null, [
        f.value ? (O(), J("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Tt({
            position: "absolute",
            inset: "0px",
            background: W.value,
            zIndex: "1000000",
            pointerEvents: "all",
            cursor: "wait"
          })
        }, [
          d(r(fs), {
            strokeWidth: 5,
            hideSpinner: !0
          }, {
            default: w(() => [
              y("div", KM, V(T.value), 1),
              h.value ? (O(), J("div", ZM, [
                (O(), he(r(gi), {
                  value: I.value,
                  key: m.value,
                  style: { height: "2rem" }
                }, {
                  default: w(() => [
                    y("span", JM, V(I.value.toFixed(0)) + " %", 1)
                  ]),
                  _: 1
                }, 8, ["value"]))
              ])) : ue("", !0)
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        d(r(Gn), {
          visible: U.value,
          "onUpdate:visible": Se[1] || (Se[1] = (wt) => U.value = wt),
          breakpoints: { "960px": "75vw", "640px": "100vw" },
          modal: !0,
          style: { width: "50vw" },
          header: ce.$t("implant-planner.changeLayout")
        }, {
          footer: w(() => [
            d(r(Ee), { class: "justify-center gap-2" }, {
              default: w(() => [
                d(r(la), {
                  label: ce.$t("shared.ok"),
                  onClick: Se[0] || (Se[0] = (wt) => U.value = !1)
                }, null, 8, ["label"]),
                d(r(ya), {
                  label: ce.$t("shared.cancel"),
                  onClick: Z
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          default: w(() => [
            d(rt, {
              "model-value": Q,
              onUpdateLayout: P
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: ie.value,
          "onUpdate:visible": Se[3] || (Se[3] = (wt) => ie.value = wt),
          breakpoints: { "960px": "45vw", "640px": "60vw" },
          modal: !0,
          style: { width: "30vw" },
          header: ce.$t("implant-planner.changeLayout")
        }, {
          footer: w(() => [
            y("div", XM, [
              d(r(Ce), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: ce.$t("shared.ok"),
                onClick: Se[2] || (Se[2] = (wt) => ie.value = !1)
              }, null, 8, ["label"]),
              d(r(Ce), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: ce.$t("shared.cancel"),
                onClick: ee
              }, null, 8, ["label"])
            ])
          ]),
          default: w(() => [
            d(tc, {
              "model-value": ae,
              onUpdateLayout: P
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: _e.value,
          "onUpdate:visible": Se[5] || (Se[5] = (wt) => _e.value = wt),
          closable: !1,
          draggable: !1,
          modal: "",
          header: ce.$t("implant-planner.warning"),
          style: { width: "25vw" }
        }, {
          default: w(() => [
            y("p", qM, V(ce.$t("implant-planner.cprDoesNotExist")), 1),
            y("div", QM, [
              d(r(Ce), {
                class: "w-full",
                label: ce.$t("implant-planner.goToCprSettings"),
                onClick: Se[4] || (Se[4] = (wt) => [ra(), _e.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Gn), {
          visible: xe.value,
          "onUpdate:visible": Se[7] || (Se[7] = (wt) => xe.value = wt),
          closable: !1,
          draggable: !1,
          modal: "",
          header: k.value,
          style: { width: "25vw" }
        }, {
          default: w(() => [
            y("p", eP, V(r(i).warningString.get()), 1),
            y("div", tP, [
              d(r(Ce), {
                autofocus: "",
                class: "w-full",
                label: ce.$t("shared.ok"),
                onClick: Se[6] || (Se[6] = (wt) => [xe.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        Pt(d(Ku, { class: "show-horizontal-bar horizontal-wizard-menu" }, {
          start: w(() => [
            (O(!0), J(ze, null, Rt(Ue, (wt) => (O(), he(Zu, {
              key: wt.type,
              modelValue: K.value,
              "onUpdate:modelValue": Se[8] || (Se[8] = (Dn) => K.value = Dn),
              index: wt.type,
              disabled: wt.disabled || !pe.value,
              onClick: kt
            }, {
              default: w(() => [
                yt(V(wt.tabLabel), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "index", "disabled"]))), 128))
          ]),
          _: 1
        }, 512), [
          [sn, me.value && M.value === r(bt).ImplantPlannerBase]
        ]),
        Pt(d(r(Ee), {
          id: "mainContainer",
          ref: "root",
          class: He(Ne.value),
          style: { "margin-bottom": "0.5rem", "margin-left": "0.5rem", "margin-right": "0.5rem", "margin-top": "0 !important", border: "1px solid rgba(255, 255, 255, 0)", "border-radius": "8px" }
        }, {
          default: w(() => [
            b.value ? (O(), J("div", nP, [
              Pt(y("div", null, [
                y("div", aP, [
                  d(cg, null, {
                    mainMenuTabs: w(() => [
                      (O(!0), J(ze, null, Rt(Ue, (wt) => (O(), he(dg, {
                        key: wt.type,
                        modelValue: K.value,
                        "onUpdate:modelValue": Se[9] || (Se[9] = (Dn) => K.value = Dn),
                        index: wt.type,
                        disabled: wt.disabled || !pe.value,
                        onClick: kt
                      }, {
                        default: w(() => [
                          yt(V(wt.tabLabel), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "index", "disabled"]))), 128))
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [sn, !me.value && M.value === r(bt).ImplantPlannerBase]
              ]),
              Pt(d(r(Ee), {
                class: He(Ge.value),
                style: Tt(Ze.value)
              }, {
                default: w(() => [
                  y("div", oP, [
                    d(_t, {
                      isFirstItem: vt.value,
                      isVisible: !f.value && pe.value && S.value && M.value === r(bt).ImplantPlannerBase,
                      isLastItem: mt.value,
                      onNextStep: ke,
                      onPreviousStep: le,
                      onHideWizard: c
                    }, {
                      default: w(() => {
                        var wt;
                        return [
                          (O(), he(Ea(((wt = Ke.value) == null ? void 0 : wt.component) ?? {}), Pe(dt(), {
                            onDone: Ct,
                            onHideWizard: c
                          }), null, 16))
                        ];
                      }),
                      _: 1
                    }, 8, ["isFirstItem", "isVisible", "isLastItem"])
                  ])
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [sn, p.value]
              ]),
              Pt(d(r(Ee), {
                class: He(Ge.value),
                style: Tt(Ze.value)
              }, {
                default: w(() => [
                  d(r(Lt), {
                    class: "items-center",
                    style: { "border-radius": "16px", margin: "0 0.5rem", background: "transparent !important" }
                  }, {
                    default: w(() => [
                      d(r(Ce), {
                        class: "web-rg-toggle-wiz-btn",
                        iconSrc: "/icons/rg_left_panel_open.svg",
                        onClick: Se[10] || (Se[10] = (wt) => p.value = !0)
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [sn, !p.value]
              ])
            ])) : ue("", !0),
            d(r(Ee), {
              id: "wizard-container",
              style: Tt(lt.value)
            }, {
              default: w(() => [
                ue("", !0),
                Se[13] || (Se[13] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                y("div", {
                  ref_key: "vtkContainer",
                  ref: u,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden" }
                }, null, 512),
                Se[14] || (Se[14] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class"]), [
          [sn, !f.value]
        ]),
        be.value ? (O(), he(Gt, {
          key: 1,
          license: H.value,
          visible: !0,
          settings: r(i).settings,
          onConfirm: Re,
          onCancel: Re
        }, null, 8, ["license", "settings"])) : ue("", !0)
      ], 64);
    };
  }
}), Px = /* @__PURE__ */ $t(lP, [["__scopeId", "data-v-9f145f71"]]), iP = { style: { "text-align": "center", color: "white", "text-shadow": "0 1px 1px black" } }, sP = {
  class: "mt-20",
  style: { width: "20vw" }
}, rP = {
  key: 0,
  style: { color: "white" }
}, uP = {
  class: "h-full web-rg-wizard",
  style: { margin: "0 0.5rem" }
}, cP = /* @__PURE__ */ qe({
  __name: "IPFreeformingAppLoader",
  setup(e) {
    const t = F(), n = F(!0), a = F(!1), o = F(!0), l = F(!1), s = F(0), i = F(!1), c = F("Loading project"), u = F(Math.random()), p = Te(() => i.value ? "linear-gradient(to top, rgb(40, 106, 173) 1%, rgb(11, 14, 26) 105%)" : "rgba(91, 91, 91, 0.5)"), b = Te(() => ({
      "bg-top-nav-bar-wiz bg-body-wiz h-full": !0
    })), f = Te(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": !0
    })), h = Te(() => ({
      flexGrow: 15,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), I = Te(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), m = Te(() => ({
      paddingLeft: "0.75rem",
      paddingRight: "0.75rem",
      paddingBottom: "0.5rem"
      // height: `calc(-${showHorizontal.value ? 155 : wizardHeight.value}px + 100vh) !important`, //height reduced for navbar
    })), S = Ra(), E = Mo(), g = F("testObject");
    let v = new ws("");
    return Ss(v), Mt(async () => {
      var j, N, x, z;
      console.log("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const T = await v.getEngineInstance();
      Is(T);
      const L = await (await fetch("resources/testObject.obj")).blob(), C = new File([L], "testObject.obj", {
        type: L.type,
        lastModified: (/* @__PURE__ */ new Date()).getTime()
      }), A = await vs([C], v, "testObject");
      A && (g.value = A.id), v.setModalsInstance(E), v.setResourceUrl("/resources/"), v.setCADRootElement(t.value), v.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (j = v.getInteractorStyle()) == null || j.setCameraInteractorEnabled(!0), (N = v.getInteractorStyle()) == null || N.setMouseMode(v.settings.general.useLeftButtonForRotationOn3d ? kn.REALGUIDE : kn.IMPLANTPLANNER), (x = v.getInteractorStyle()) == null || x.setMouseMode2D(kn.REALGUIDE), await ((z = v.contextCAD) == null ? void 0 : z.LoadCADResources()), o.value = !1, a.value = !0, v.sceneRepaint(), setTimeout(() => {
        v.resetOrientation();
      }, 0), S.watch(v.loadingFlag, (X) => {
        o.value = X, c.value = v.loadingText, l.value = v.progressBarFlag, s.value = v.progressBarValue.get(), i.value = v.nonTransparentLoading.get();
      });
    }), On(() => {
      v && a.value && v.cleanup();
    }), (T, R) => {
      const L = xm;
      return O(), J(ze, null, [
        o.value ? (O(), J("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Tt({
            position: "absolute",
            inset: "0px",
            background: p.value,
            pointerEvents: "all",
            cursor: "wait",
            zIndex: "100000"
          })
        }, [
          d(r(fs), {
            strokeWidth: 5,
            hideSpinner: !0
          }, {
            default: w(() => [
              y("div", iP, V(c.value), 1),
              y("div", sP, [
                (O(), he(r(gi), {
                  value: s.value,
                  key: u.value,
                  style: { height: "2rem" },
                  mode: l.value ? "determinate" : "indeterminate"
                }, {
                  default: w(() => [
                    l.value ? (O(), J("span", rP, V(s.value.toFixed(0)) + " %", 1)) : ue("", !0)
                  ]),
                  _: 1
                }, 8, ["value", "mode"]))
              ])
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        Pt(d(r(Ee), {
          id: "mainContainer",
          ref: "root",
          class: He(b.value),
          style: Tt(m.value)
        }, {
          default: w(() => [
            a.value ? (O(), he(r(Ee), {
              key: 0,
              id: "wizardTabContainer",
              class: He(f.value),
              style: Tt(I.value)
            }, {
              default: w(() => [
                Pt(y("div", uP, [
                  d(r(at), {
                    class: "h-full",
                    style: { position: "relative" }
                  }, {
                    default: w(() => [
                      d(r(at), {
                        class: "overflow-x-hidden overflow-y-auto h-full grow",
                        id: "wizardBody"
                      }, {
                        default: w(() => [
                          d(L, {
                            "selected-object-id": g.value,
                            isDemo: !0
                          }, null, 8, ["selected-object-id"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 512), [
                  [sn, n.value]
                ])
              ]),
              _: 1
            }, 8, ["class", "style"])) : ue("", !0),
            d(r(Ee), {
              id: "wizard-container",
              style: Tt(h.value)
            }, {
              default: w(() => [
                R[0] || (R[0] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                y("div", {
                  ref_key: "vtkContainerCAD",
                  ref: t,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden", position: "relative" }
                }, null, 512),
                R[1] || (R[1] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class", "style"]), [
          [sn, a.value]
        ])
      ], 64);
    };
  }
}), xx = /* @__PURE__ */ $t(cP, [["__scopeId", "data-v-5f778baa"]]), dP = { class: "flex gap-2 -mt-2" }, pP = { class: "ip-viewer-settings -mt-2" }, mP = { class: "p-tabmenu p-component" }, fP = {
  class: "p-tabmenu-nav p-reset",
  role: "tablist"
}, gP = {
  key: 0,
  class: "pt-4"
}, hP = { key: 1 }, jx = /* @__PURE__ */ qe({
  __name: "IPAboutInfoComponent",
  setup(e) {
    const t = Xn("dialogRef"), { t: n, locale: a } = Yt(), o = t.value.data, l = {
      General: 0,
      Info: 1
    }, s = F(l.General), i = F(!0), c = F(!1), u = () => {
      var p;
      (p = t.value) != null && p.options && (t.value.options.props || (t.value.options.props = {}), t.value.options.props.header = n("shared.settings"));
    };
    return u(), ot(a, u), (p, b) => (O(), he(r(at), null, {
      default: w(() => [
        y("div", dP, [
          y("div", pP, [
            y("div", mP, [
              y("div", fP, [
                d(r(Ul), {
                  state: s.value,
                  "onUpdate:state": b[0] || (b[0] = (f) => s.value = f),
                  index: l.General
                }, {
                  default: w(() => [
                    yt(V(p.$t("implant-planner.general")), 1)
                  ]),
                  _: 1
                }, 8, ["state", "index"]),
                d(r(Ul), {
                  state: s.value,
                  "onUpdate:state": b[1] || (b[1] = (f) => s.value = f),
                  index: l.Info,
                  style: { width: "75px !important" }
                }, {
                  default: w(() => [
                    yt(V(p.$t("shared.info")), 1)
                  ]),
                  _: 1
                }, 8, ["state", "index"])
              ])
            ])
          ])
        ]),
        s.value === l.General ? (O(), J("div", gP, [
          d(r(at), { class: "gap-4" }, {
            default: w(() => [
              r(o).showOnlyAddreses ? ue("", !0) : (O(), he(r(Ec), {
                key: 0,
                header: p.$t("medic-web-framework.theme"),
                isCollapsed: i.value,
                "onUpdate:isCollapsed": b[2] || (b[2] = (f) => i.value = f)
              }, {
                default: w(() => [
                  d(r(ch))
                ]),
                _: 1
              }, 8, ["header", "isCollapsed"])),
              r(o).showOnlyAddreses ? ue("", !0) : (O(), he(r(Ec), {
                key: 1,
                header: p.$t("medic-web-framework.language"),
                isCollapsed: c.value,
                "onUpdate:isCollapsed": b[3] || (b[3] = (f) => c.value = f)
              }, {
                default: w(() => [
                  d(r(Be), { class: "rg-panel mt-4" }, {
                    default: w(() => [
                      d(r(dh))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["header", "isCollapsed"]))
            ]),
            _: 1
          })
        ])) : ue("", !0),
        s.value === l.Info ? (O(), J("div", hP, [
          d(r(at), { class: "gap-1 overflow-y-auto overflow-x-hidden pt-2" }, {
            default: w(() => [
              d(Om, {
                model: r(o).model,
                "onUpdate:model": b[4] || (b[4] = (f) => r(o).model = f)
              }, null, 8, ["model"])
            ]),
            _: 1
          })
        ])) : ue("", !0),
        d(r(hb)),
        d(r(Be), { class: "items-center justify-center pt-2" }, {
          default: w(() => [
            d(r(la), {
              label: p.$t("shared.close"),
              icon: "pi pi-check",
              onClick: b[5] || (b[5] = (f) => r(t).close())
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Fx = /* @__PURE__ */ qe({
  __name: "IPDataImportPreview",
  props: {
    object: {},
    textureObject: {},
    objectName: {},
    context: {}
  },
  setup(e) {
    const t = e, n = F();
    let a, o = null;
    return Mt(async () => {
      if (t.context)
        o = t.context;
      else
        try {
          o = pn();
        } catch (l) {
          console.log("Context is null", l);
        }
      o ? a = new zh(n.value, o) : a = new Hh(n.value, [0, 0, 0, 0]), t.object && await a.onFileSelected(t.object, t.objectName, t.textureObject);
    }), On(() => {
      a.delete();
    }), (l, s) => (O(), J("div", {
      ref_key: "vtkContainer",
      ref: n,
      style: { height: "35vh !important", width: "100% !important" }
    }, null, 512));
  }
}), ko = 1024 * 1024, pg = 750 * ko, mg = 180 * ko, bP = pg - mg, vP = 24 * ko, yP = 2.7, fg = 8, gg = 8 * ko, _P = Math.round(gg / fg), wP = 1.6, SP = 2 * ko, IP = Math.round(0.5 * ko), hg = 3 * ko;
function Eo(e) {
  if (typeof e == "object" && e !== null && !Array.isArray(e))
    return e;
}
function EP(e) {
  try {
    const t = atob(e), n = Uint8Array.from(t, (a) => a.charCodeAt(0));
    return new TextDecoder().decode(n);
  } catch {
    try {
      return atob(e);
    } catch {
      return "";
    }
  }
}
function ic(e) {
  const t = e.indexOf("=");
  if (t === -1)
    return e;
  const n = e.slice(0, t), a = e.slice(t + 1);
  return n === "base64" ? EP(a) : e;
}
function To(e) {
  if (typeof e == "number")
    return Number.isFinite(e) ? e : void 0;
  if (typeof e == "boolean")
    return e ? 1 : 0;
  if (typeof e == "string") {
    const t = ic(e), n = Number(t);
    return Number.isFinite(n) ? n : void 0;
  }
}
function TP(e) {
  if (typeof e == "boolean")
    return e;
  const t = To(e);
  if (t !== void 0)
    return t !== 0;
  if (typeof e == "string") {
    const n = ic(e).toLowerCase();
    if (n === "true")
      return !0;
    if (n === "false")
      return !1;
  }
}
function bp(e) {
  if (typeof e != "string")
    return;
  const t = ic(e).trim();
  return t.length > 0 ? t : void 0;
}
function zi(e, t) {
  const n = e > 0 ? e : t;
  return Math.round(n * wP);
}
function vp(e, t) {
  if (!e)
    return 0;
  const n = t === "decimated" ? fg : 1, o = Math.max(1, Math.floor(e[0] * e[1] * e[2] / n)) * Int16Array.BYTES_PER_ELEMENT;
  return Math.max(t === "decimated" ? _P : gg, Math.round(o * yP));
}
function bg(e) {
  const t = Eo(e);
  if (!t)
    return 0;
  let n = 0;
  for (const [a, o] of Object.entries(t)) {
    if (a.toLowerCase() === "filesize") {
      const l = To(o);
      l && l > 0 && (n += l);
      continue;
    }
    n += bg(o);
  }
  return n;
}
function CP(e) {
  const t = {
    implantCount: 0,
    implantFileSizeBytes: 0,
    pinCount: 0,
    pinFileSizeBytes: 0,
    projectStlCandidates: []
  }, n = Eo(e), a = n ? Eo(n.COLLECTION_3D) : void 0;
  if (!a)
    return t;
  const o = Math.max(0, Math.floor(To(a.OBJECTS_COUNT) ?? 0));
  for (let l = 0; l < o; l++) {
    const s = Eo(a[`OBJECT_${l}`]);
    if (!s)
      continue;
    const i = To(s.OBJECT_TYPE), c = bg(s);
    if (i === Le._IMPLANT) {
      t.implantCount += 1, t.implantFileSizeBytes += c;
      continue;
    }
    if (i === Le._PIN) {
      t.pinCount += 1, t.pinFileSizeBytes += c;
      continue;
    }
    if (!(i === Le._STL_OBJECT || i === Le._STL_TOOTH || i === Le._STL_PROSTHESIS || i === Le._STL_TEETH_MODEL))
      continue;
    const p = bp(s.OBJECT_NAME) ?? bp(s.NAME) ?? `STL ${t.projectStlCandidates.length + 1}`;
    t.projectStlCandidates.push({
      id: `project-stl-${l}`,
      name: p,
      fileSizeBytes: c,
      estimatedBytes: zi(c, hg),
      source: "project"
    });
  }
  return t;
}
function NP(e) {
  const t = (a) => {
    const o = Math.floor(To(a.DIM_0) ?? 0), l = Math.floor(To(a.DIM_1) ?? 0), s = Math.floor(To(a.DIM_2) ?? 0);
    return o <= 0 || l <= 0 || s <= 0 ? null : [o, l, s];
  };
  return ((a) => {
    const o = Eo(a);
    if (!o)
      return null;
    const l = [o], s = /* @__PURE__ */ new Set([o]);
    for (; l.length > 0; ) {
      const i = l.pop();
      if (!i)
        continue;
      const c = t(i);
      if (c)
        return c;
      for (const u of Object.values(i)) {
        const p = Eo(u);
        !p || s.has(p) || (s.add(p), l.push(p));
      }
    }
    return null;
  })(e);
}
function LP(e, t) {
  const n = e.projectStlCandidates.map((o) => o.name), a = e.patientStlCandidates.map((o) => o.name);
  return {
    volumeQuality: (t == null ? void 0 : t.volumeQuality) ?? e.defaultSelection.volumeQuality ?? "full",
    includeImplants: (t == null ? void 0 : t.includeImplants) ?? e.defaultSelection.includeImplants ?? !0,
    includePins: (t == null ? void 0 : t.includePins) ?? e.defaultSelection.includePins ?? !0,
    includeProjectStlObjects: (t == null ? void 0 : t.includeProjectStlObjects) ?? e.defaultSelection.includeProjectStlObjects ?? !0,
    includePatientStlObjects: (t == null ? void 0 : t.includePatientStlObjects) ?? e.defaultSelection.includePatientStlObjects ?? e.loadObjectsFromPatientDefault,
    includedProjectStlObjectNames: (t == null ? void 0 : t.includedProjectStlObjectNames) ?? e.defaultSelection.includedProjectStlObjectNames ?? n,
    includedPatientStlFilenames: (t == null ? void 0 : t.includedPatientStlFilenames) ?? e.defaultSelection.includedPatientStlFilenames ?? a
  };
}
class $x {
  constructor(t) {
    on(this, "api");
    // original project data, used to merge with modified project before saving
    on(this, "loadedProjectData", null);
    this.api = t;
  }
  buildDefaultProjectLoadSelection(t) {
    return {
      ...t.defaultSelection,
      includedProjectStlObjectNames: [...t.defaultSelection.includedProjectStlObjectNames ?? []],
      includedPatientStlFilenames: [...t.defaultSelection.includedPatientStlFilenames ?? []]
    };
  }
  estimateProjectLoadMemory(t, n) {
    const a = LP(t, n);
    let o = t.baseOverheadBytes;
    if (o += a.volumeQuality === "decimated" ? t.volumeDecimatedEstimateBytes : t.volumeFullEstimateBytes, a.includeImplants && (o += t.implantEstimateBytes), a.includePins && (o += t.pinEstimateBytes), a.includeProjectStlObjects) {
      const l = a.includedProjectStlObjectNames.length > 0 ? new Set(a.includedProjectStlObjectNames) : void 0;
      for (const s of t.projectStlCandidates)
        l && !l.has(s.name) || (o += s.estimatedBytes);
    }
    if (a.includePatientStlObjects) {
      const l = a.includedPatientStlFilenames.length > 0 ? new Set(a.includedPatientStlFilenames) : void 0;
      for (const s of t.patientStlCandidates)
        l && !l.has(s.name) || (o += s.estimatedBytes);
    }
    return Math.round(o);
  }
  async getProjectLoadPreflight(t) {
    var E;
    const { data: n, status: a } = await this.api.getZippedFilesList(t.patientName, t.projectFilename);
    if (a === 202)
      return null;
    const o = (g) => n.find((v) => v.fileType === g), l = o("mobile.json"), s = o("pr.json"), i = o("stlinfo.json"), c = async (g) => {
      if (!g)
        return null;
      try {
        return (await this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, g.id, !1)).data;
      } catch (v) {
        return Ye.warn("Failed to fetch preload json file", {
          fileType: g.fileType,
          projectFilename: t.projectFilename,
          patientName: t.patientName,
          error: v
        }), null;
      }
    }, [u, p, b] = await Promise.all([c(l), c(s), c(i)]), f = CP(b), h = (t.projectFileList ?? []).filter((g) => g.type === ga.STL).map((g, v) => {
      var R;
      const T = ((R = g.file) == null ? void 0 : R.size) ?? 0;
      return {
        id: `patient-stl-${v}`,
        name: g.name,
        fileSizeBytes: T,
        estimatedBytes: zi(T, hg),
        source: "patient"
      };
    }), I = NP(p), m = TP((E = Eo(u)) == null ? void 0 : E.LOAD_OBJECTS_FROM_PATIENT) ?? !1, S = {
      totalMemoryBytes: pg,
      reservedMemoryBytes: mg,
      budgetMemoryBytes: bP,
      baseOverheadBytes: vP,
      volumeDimensions: I,
      volumeFullEstimateBytes: vp(I, "full"),
      volumeDecimatedEstimateBytes: vp(I, "decimated"),
      implantCount: f.implantCount,
      implantEstimateBytes: zi(f.implantFileSizeBytes, f.implantCount * SP),
      pinCount: f.pinCount,
      pinEstimateBytes: zi(f.pinFileSizeBytes, f.pinCount * IP),
      projectStlCandidates: f.projectStlCandidates,
      patientStlCandidates: h,
      loadObjectsFromPatientDefault: m,
      defaultSelection: {
        volumeQuality: "decimated",
        includeImplants: !0,
        includePins: !0,
        includeProjectStlObjects: !0,
        includePatientStlObjects: m,
        includedProjectStlObjectNames: f.projectStlCandidates.map((g) => g.name),
        includedPatientStlFilenames: h.map((g) => g.name)
      },
      defaultEstimateBytes: 0
    };
    return S.defaultEstimateBytes = this.estimateProjectLoadMemory(S, S.defaultSelection), S;
  }
  async getFileDataSilent(t, n) {
    try {
      const { data: a } = await this.api.getFile(t, n);
      return new Int8Array(a);
    } catch {
      return null;
    }
  }
  async loadProjectObjects(t, n, a, o) {
    var b;
    if ((o == null ? void 0 : o.includePatientStlObjects) === !1)
      return 0;
    const l = o != null && o.includedPatientStlFilenames && o.includedPatientStlFilenames.length > 0 ? new Set(o.includedPatientStlFilenames) : void 0, s = [];
    if ((b = n.projectFileList) == null || b.forEach((f) => {
      if (f.type === ga.STL) {
        if (l && !l.has(f.name))
          return;
        const h = {
          id: f.id,
          uuid: "",
          lastModified: new Date(f.file.changeDate),
          patientId: n.patientName,
          //user: file.uploadedBy.name,
          filename: f.name,
          itemImageSrc: this.api.getFileUrl(n.patientName, f.name).url,
          type: f.type,
          thumbnailImageSrc: "",
          alt: "",
          title: ""
        }, I = n.projectFileList.find((S) => S.type === ga.STL_Preview && S.name === f.name + ".thumb");
        let m = "";
        I && (m = this.api.getFileUrl(n.patientName, I.name).url), s.push({
          ...h,
          thumbnailImageSrc: m,
          previewUrl: m
        });
      }
    }), !s.length)
      return 0;
    const i = async (f) => {
      const h = await this.getStlFile(n.patientName, f.filename);
      if (!h)
        return !1;
      const I = f.filename.replace(/\.[^/.]+$/, ""), m = f.filename.toLowerCase(), S = m.endsWith(".ply");
      let E = "", g = null;
      if (S)
        for (const A of [".jpg", ".jpeg", ".png"]) {
          const j = `${I}${A}`, N = await this.getFileDataSilent(n.patientName, j);
          if (N && N.length) {
            E = j, g = N;
            break;
          }
        }
      const v = Lp();
      v.implantInfo.stlFile.data = h, v.implantInfo.stlFile.fileName = f.filename, v.implantInfo.stlFile.fileSize = h.length;
      const T = f.filename.match(/\[([^\]]+)]/), R = T ? T[1] : f.filename;
      T && (R === "Anatomy" ? v.objectType = Le._STL_TEETH_MODEL : R === "Waxup-Prosthesis" && (v.objectType = Le._STL_PROSTHESIS)), v.name = R, v.implantInfo.objectName = R;
      const L = !!(g && g.length);
      S && g && g.length && (v.implantInfo.textureCount = 1, v.implantInfo.textureFileNames = [E], v.implantInfo.textureFiles = [
        {
          fileSize: g.length,
          data: g,
          fileName: E
        }
      ]);
      const C = m.endsWith(".ply") || m.endsWith(".obj");
      return t.objects.addSTL(v, { ignoreScaling: !1, ply: C, fromDataImport: !0, hasTexture: L }), !0;
    };
    a == null || a({
      loaded: 0,
      total: s.length
    });
    const c = [], u = {
      loaded: 0,
      total: s.length
    };
    for (const f of s) {
      const h = i(f);
      h.then(() => {
        u.loaded++, a == null || a(u);
      }), c.push(h);
    }
    return (await Promise.all(c)).filter(Boolean).length;
  }
  async loadProject(t, n, a, o, l, s) {
    Ye.debug("[Autosave] Loader start", {
      patientName: t.patientName,
      projectFilename: t.projectFilename,
      hasAutosavePayload: !!l,
      autosaveCadPartCount: l ? Object.keys(l.cadParts ?? {}).length : 0
    }), Yh(n), Kh(n);
    const i = await this.api.getZippedFilesList(t.patientName, t.projectFilename);
    if (i.status, i.status == 202)
      return { success: !1, error: nt("implant-planner.projectPreparing"), loadedObjectsFromPatient: !1 };
    const c = i.data;
    if (!c)
      return { success: !1, error: nt("implant-planner.projectFilesNotFound"), loadedObjectsFromPatient: !1 };
    const u = (l == null ? void 0 : l.cadParts) ?? {}, p = (P) => {
      const de = u[P];
      return de && de.byteLength > 0 && Ye.debug("[Autosave] Loader using CAD part from autosave", {
        fileType: P,
        bytes: de.byteLength
      }), de && de.byteLength > 0 ? de : void 0;
    };
    let b = !1, f;
    const h = t.projectFileList.find((P) => P.name === t.projectFilename), I = (P) => {
      const de = U2(P);
      return de.imgDims[0] == 1 && de.imgDims[1] == 1 && de.imgDims[2] == 1 ? { success: !1, error: nt("implant-planner.cadModuleUnavailable"), loadedObjectsFromPatient: !1 } : (b = de.loadObjectsFromPatient, console.log("segmentationInvokedByUser", de.segmentationInvokedByUser, "mFile.loadObjectsFromPatient", de.loadObjectsFromPatient), de.segmentationInvokedByUser && (f = t.projectFileList.find((fe) => {
        if (fe.type === "processing-data" && fe.metadata) {
          const ke = JSON.parse(fe.metadata);
          if (ke && h && ke["job-type"] == "SEGMENTATION" && ke["origin-file-id"] == h.id)
            return !0;
        }
      })), { success: !0, loadedObjectsFromPatient: !1 });
    }, m = c.find((P) => P.fileType === "mobile.json");
    let S = l != null && l.mobile ? structuredClone(l.mobile) : null;
    if (S && Ye.debug("[Autosave] Loader using mobile from autosave"), !S && m) {
      const de = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, m.id, !1).then((fe) => fe.data);
      S = await gr(
        de,
        t.patientName,
        t.projectFilename,
        fr(m, "mobile"),
        c,
        this.api,
        void 0,
        !0
      );
    }
    if (S) {
      const P = I(S);
      if (!P.success)
        return P;
    }
    (s == null ? void 0 : s.includePatientStlObjects) === !1 && (b = !1);
    const E = (s == null ? void 0 : s.volumeQuality) === "decimated", g = c.find((P) => P.fileType === "pr.json"), v = c.find((P) => P.fileType === "stlinfo.json"), T = c.find((P) => P.fileType === "prinfo"), R = c.find((P) => P.fileType === "iptspr"), L = c.find((P) => P.fileType === "iptsbd"), C = c.find((P) => P.fileType === "bspr"), A = c.find((P) => P.fileType === "bsbd"), j = c.find((P) => P.fileType === "tspr"), N = c.find((P) => P.fileType === "tsbd"), x = c.find((P) => P.fileType === "mpr"), z = c.find((P) => P.fileType === "mbd"), X = c.find((P) => P.fileType === "sgpr"), H = c.find((P) => P.fileType === "sgbd"), M = c.find((P) => P.fileType === "erp"), te = n.getFS(), ne = n.getEngine(), W = (P, de, fe) => {
      te.FS.writeFile(n.projectName + "." + fe + "pr", new Uint8Array(P)), te.FS.writeFile(n.projectName + "." + fe + "bd", new Uint8Array(de)), console.log("File saved to Wasm FS: " + n.projectName + "." + fe + "pr");
      let ke = Sr.eM_BONE_SEGMENTATION, le = It.eOT_SEGMENTED_BONE;
      fe == "ts" && (ke = Sr.eM_TOOTH_SEGMENTATION, le = It.eOT_CNN_SEGMENTED_TOOTH);
      const pe = new ne.xProjectLoaderUtil();
      try {
        pe.InitializeCADProjectLoading("", n.projectName, ke);
        const Z = pe.GetNumberOfCADVolumeLabels();
        for (let ee = 0; ee < Z; ee++) {
          const $ = n.objects.addVolume("", "", !0, le);
          pe.AssignVolumeById(ee, $.id), $.syncWasmInfo();
        }
      } finally {
        try {
          pe.FinalizeCADProjectLoading();
        } catch (Z) {
          console.warn("FinalizeCADProjectLoading failed", Z);
        }
        pe.delete();
      }
    }, se = (P, de, fe, ke) => {
      const le = this.api.getProjectFileFromZipById(t.patientName, P, de), pe = this.api.getProjectFileFromZipById(t.patientName, P, fe);
      return Promise.all([le, pe]).then(([Z, ee]) => {
        W(Z.data, ee.data, ke);
      });
    }, be = [], Re = async () => {
      if (!f) return null;
      const { data: P } = await this.api.getZippedFilesList(t.patientName, f.name), de = P.find((pe) => pe.name === "result");
      if (!de)
        return console.error("Segmentation result file not found!"), null;
      const { data: fe } = await this.api.getProjectFileFromZipById(
        t.patientName,
        de.name,
        de.id,
        !1
      ), ke = await fe, le = (pe) => {
        const Z = P.find((ee) => pe === `${ee.name}.${ee.fileType}`);
        return Z ? Z.id : null;
      };
      if (ke) {
        if (!C || !A) {
          if (!E && ke.boneSegmentationProject && ke.boneSegmentationProject[0]) {
            const pe = ke.boneSegmentationProject[0], Z = le(pe.prFile), ee = le(pe.bdFile);
            Z && ee && be.push(se(de.name, Z, ee, "bs"));
          } else if (ke.bone) {
            const pe = n.getFS(), Z = "/segmentations";
            n.makeDir(Z);
            for (const ee of ke.bone)
              try {
                const $ = le(ee.file);
                if (!$)
                  throw new Error(`Segmentation File not found: ${ee.file}`);
                const { data: _ } = await this.api.getProjectFileFromZipById(t.patientName, de.name, $);
                ee.buffer = _, pe.FS.writeFile(Z + "/" + ee.file, new Int8Array(ee.buffer));
                let D = ee.name;
                switch (ee.file) {
                  case "bone_mandible_with_teeth.nii.gz":
                    D = "Mandible With Teeth";
                    break;
                  case "bone_mandible_no_teeth.nii.gz":
                    D = "Mandible Without Teeth";
                    break;
                  case "bone_maxilla_with_teeth.nii.gz":
                    D = "Maxilla With Teeth";
                    break;
                  case "bone_maxilla_no_teeth.nii.gz":
                    D = "Maxilla Without Teeth";
                    break;
                }
                n.objects.addVolume(Z + "/" + ee.file, D, !0, It.eOT_SEGMENTED_BONE), pe.FS.unlink(Z + "/" + ee.file), pe.FS.rmdir(Z);
              } catch ($) {
                console.log("EXCEPTION: GetFile", $);
              }
          }
        }
        if (!j || !N) {
          if (!E && ke.toothSegmentationProject && ke.toothSegmentationProject[0]) {
            const pe = ke.toothSegmentationProject[0], Z = le(pe.prFile), ee = le(pe.bdFile);
            Z && ee && (be.push(se(de.name, Z, ee, "ts")), n.contextCAD.tsprFileFromSegmentation = !0);
          } else if (ke.teeth) {
            const pe = ke.teeth.mandible;
            if (pe) {
              const ee = n.getFS(), $ = "/segmentations";
              n.makeDir($);
              for (const _ of pe)
                try {
                  const D = le(_.file);
                  if (!D)
                    throw new Error(`Segmentation File not found: ${_.file}`);
                  const { data: Y } = await this.api.getProjectFileFromZipById(t.patientName, de.name, D);
                  _.buffer = Y, ee.FS.writeFile($ + "/" + _.file, new Int8Array(_.buffer)), n.objects.addVolume($ + "/" + _.file, _.name, !0, It.eOT_CNN_SEGMENTED_TOOTH), ee.FS.unlink($ + "/" + _.file);
                } catch (D) {
                  console.log("EXCEPTION: GetFile", D);
                }
              ee.FS.rmdir($);
            }
            const Z = ke.teeth.maxilla;
            if (Z) {
              const ee = n.getFS(), $ = "/segmentations";
              n.makeDir($);
              for (const _ of Z)
                try {
                  const D = le(_.file);
                  if (!D)
                    throw new Error(`Segmentation File not found: ${_.file}`);
                  const { data: Y } = await this.api.getProjectFileFromZipById(t.patientName, de.name, D);
                  _.buffer = Y, ee.FS.writeFile($ + "/" + _.file, new Int8Array(_.buffer)), n.objects.addVolume($ + "/" + _.file, _.name, !0, It.eOT_CNN_SEGMENTED_TOOTH), ee.FS.unlink($ + "/" + _.file);
                } catch (D) {
                  console.log("EXCEPTION: GetFile", D);
                }
              ee.FS.rmdir($);
            }
          }
        }
      }
      return ke;
    }, U = !!(l != null && l.pr) || !!g, ie = !!(l != null && l.stlInfo) || !!v;
    if (Ye.debug("[Autosave] Loader source availability", {
      hasProjectObject: U,
      hasStlInfoObject: ie,
      hasImageFile: !!T,
      hasMobile: !!S,
      usingAutosavePr: !!(l != null && l.pr),
      usingAutosaveStlInfo: !!(l != null && l.stlInfo),
      usingAutosaveMobile: !!(l != null && l.mobile)
    }), !U || !ie || !T || S == null)
      return { success: !1, error: nt("implant-planner.projectFilesNotFound"), loadedObjectsFromPatient: !1 };
    const re = Re();
    let q = {
      loaded: 0,
      total: 100
    }, De = {
      loaded: 0,
      total: 1
    }, _e = {
      loaded: 0,
      total: 0
    };
    const xe = () => {
      o == null || o({
        loaded: q.loaded + De.loaded + _e.loaded,
        total: q.total + De.total + _e.total
      });
    }, k = (P) => {
      q = P, xe();
    }, K = (P) => {
      De = P, xe();
    }, Ae = (P) => {
      _e = P, xe();
    }, me = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, T.id), Ne = async (P, de) => {
      n.contextCAD.iptsTeethLibraryPromise = void 0, te.FS.writeFile(n.projectName + ".iptspr", new Uint8Array(P)), te.FS.writeFile(n.projectName + ".iptsbd", new Uint8Array(de));
      const ke = new TextDecoder("utf-8").decode(P), Z = new DOMParser().parseFromString(ke, "application/xml").querySelector("TeethSetupReconstruction TeethLibraryGUID");
      let ee = "", $ = "", _ = !1;
      const D = await this.api.getPoolAssetList("webcadteethlibraries"), Q = (Array.isArray(D.data) ? D.data : []).map((ge) => (ge.name || "").replace(/\.zip$/i, "").replace(/\.xml$/i, "")).filter((ge) => !!ge);
      let ae = [];
      try {
        const ge = await this.api.getCadLibrariesFilteredListByType("webcadteethlibraries", void 0, "xml");
        ae = Array.isArray(ge.data) ? ge.data : [];
      } catch {
        ae = [];
      }
      Q.length && (ee = Q[0], $ = "webcadteethlibraries");
      for (let ge = 0; ge < ae.length; ge++)
        if (JSON.parse(ae[ge].metadata).guid === (Z == null ? void 0 : Z.textContent)) {
          ee = ae[ge].modelName, $ = "webcadteethlibraries", _ = !0;
          break;
        }
      if (!_) {
        const Fe = (await this.api.getCadLibrariesListByType("cadteethlibraries")).data.filter((Me) => Me.fileType === "xml");
        for (let Me = 0; Me < Fe.length; Me++) {
          const je = JSON.parse(Fe[Me].metadata);
          if (ee == "" && (ee = Fe[Me].modelName, $ = "cadteethlibraries"), je.guid === (Z == null ? void 0 : Z.textContent)) {
            ee = Fe[Me].modelName, $ = "cadteethlibraries", _ = !0;
            break;
          }
        }
      }
      ee != "" && $ != "" ? n.contextCAD.iptsTeethLibraryPromise = uu(this.api, n, ee, (Z == null ? void 0 : Z.textContent) || "", $, !0).then(() => {
        console.log("Library loaded");
      }).catch((ge) => {
        console.warn("Failed to preload teeth library for project load: ", ge), n.warningString.set(nt("implant-planner.teethLibraryNotFoundOnServer"));
      }) : n.warningString.set(nt("implant-planner.teethLibraryNotFoundOnServer"));
    };
    if (!E) {
      const P = p("iptspr"), de = p("iptsbd");
      if (P && de)
        n.contextCAD.iptsPromise = Ne(P, de);
      else if (R && L) {
        const D = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, R.id), Y = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, L.id);
        n.contextCAD.iptsPromise = Promise.all([D, Y]).then(async ([Q, ae]) => {
          await Ne(Q.data, ae.data);
        });
      }
      const fe = p("bspr"), ke = p("bsbd");
      fe && ke ? be.push(Promise.resolve(W(fe, ke, "bs"))) : C && A && be.push(se(t.projectFilename, C.id, A.id, "bs"));
      const le = p("tspr"), pe = p("tsbd");
      le && pe ? be.push(Promise.resolve(W(le, pe, "ts"))) : j && N && be.push(se(t.projectFilename, j.id, N.id, "ts"));
      const Z = p("mpr"), ee = p("mbd");
      if (Z && ee)
        n.contextCAD.mPromise = Promise.resolve().then(() => {
          te.FS.writeFile(n.projectName + ".mpr", new Uint8Array(Z)), te.FS.writeFile(n.projectName + ".mbd", new Uint8Array(ee));
        });
      else if (x && z) {
        const D = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, x.id), Y = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, z.id);
        n.contextCAD.mPromise = Promise.all([D, Y]).then(([Q, ae]) => {
          te.FS.writeFile(n.projectName + ".mpr", new Uint8Array(Q.data)), te.FS.writeFile(n.projectName + ".mbd", new Uint8Array(ae.data));
        });
      }
      const $ = p("sgpr"), _ = p("sgbd");
      if ($ && _)
        be.push(
          Promise.resolve().then(() => {
            te.FS.writeFile(n.projectName + ".sgpr", new Uint8Array($)), te.FS.writeFile(n.projectName + ".sgbd", new Uint8Array(_));
          })
        );
      else if (X && H) {
        const D = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, X.id), Y = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, H.id);
        be.push(
          Promise.all([D, Y]).then(([Q, ae]) => {
            te.FS.writeFile(n.projectName + ".sgpr", new Uint8Array(Q.data)), te.FS.writeFile(n.projectName + ".sgbd", new Uint8Array(ae.data));
          })
        );
      }
    }
    if (l != null && l.erpFile)
      Ye.debug("[Autosave] Loader using ERP from autosave"), n.erpFile = structuredClone(l.erpFile);
    else if (M) {
      const P = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, M.id, !1);
      be.push(
        Promise.all([P]).then(([de]) => {
          n.erpFile = de.data;
        })
      );
    }
    const Ge = me.then((P) => P.data);
    n.loadOriginalImageData = T ? async () => (await this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, T.id)).data : void 0;
    const Ue = l != null && l.pr ? Promise.resolve(structuredClone(l.pr)) : gr(
      this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, g.id, !1).then((P) => P.data),
      t.patientName,
      t.projectFilename,
      fr(g, "pr"),
      c,
      this.api
    ), Ke = l != null && l.stlInfo ? Promise.resolve(structuredClone(l.stlInfo)) : gr(
      this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, v.id, !1).then((P) => P.data),
      t.patientName,
      t.projectFilename,
      fr(v, "stlinfo"),
      c,
      this.api,
      k
    );
    l != null && l.stlInfo && (q = { loaded: 100, total: 100 }, xe());
    const st = {
      pr: Ue,
      stlInfo: Ke,
      mobile: S,
      imageData: Ge,
      segmentationResult: re
    };
    await Promise.all(be), await B2(n, a, st, K, s);
    let G = !1;
    return b && (G = await this.loadProjectObjects(n, t, Ae, s) > 0), this.loadedProjectData = {
      pr: await Ue,
      stlInfo: await Ke,
      mobile: await S
    }, Ye.debug("[Autosave] Loader success", {
      patientName: t.patientName,
      projectFilename: t.projectFilename,
      usedAutosavePr: !!(l != null && l.pr),
      usedAutosaveStlInfo: !!(l != null && l.stlInfo),
      usedAutosaveMobile: !!(l != null && l.mobile),
      usedAutosaveErp: !!(l != null && l.erpFile)
    }), { success: !0, error: "", loadedObjectsFromPatient: G };
  }
  async uploadScreenshot(t, n, a, o) {
    const { data: l } = await this.api.uploadFile(t, n, a, o);
    return l.fileId;
  }
  getLoadedProjectData() {
    return this.loadedProjectData;
  }
}
function kx(e, t) {
  return ph(`${e}:${t}`);
}
const OP = async ({ context: e, projectName: t, generalData: n, patientInfo: a, progressCallback: o }) => {
  const l = Zt(ds, n);
  e.patientInfo || (e.patientInfo = a);
  const s = await qu(
    e,
    {
      pr: l,
      stlInfo: {},
      mobile: { objectType: "object", data: {} }
    },
    !0
  );
  return s ? {
    projectData: s,
    zip: await z2(t, s, o)
  } : null;
}, nu = (e) => e.webkitRelativePath || e.name, DP = (e) => nu(e).slice(0, nu(e).length - e.name.length), Vx = async ({ module: e, engine: t, files: n, onProgress: a }) => {
  var f, h, I;
  const o = new t.xDicomPreviewGenerator(), l = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), i = [], c = "/previewFile.dcm";
  let u = !1;
  const p = (m) => {
    e.FS.writeFile(c, m), u = !0;
  }, b = () => {
    if (u)
      try {
        e.FS.unlink(c);
      } finally {
        u = !1;
      }
  };
  try {
    for (let S = 0; S < n.length; S++) {
      const E = n[S], g = new Int8Array(await E.arrayBuffer());
      if (!mh(E.name, g)) {
        i.push({ reason: "not-dicom", filename: E.name });
        continue;
      }
      const v = nu(E);
      p(g);
      try {
        const T = fh(o, c);
        if (!T.readable) {
          i.push({ reason: "read-error", filename: E.name });
          continue;
        }
        s.set(v, E);
        const R = T.frameCount > 1 ? JSON.stringify([T.seriesId, v]) : T.seriesId || v;
        gh(l, DP(E), R, {
          fileName: v,
          slicePos: ((h = (f = T.frames[0]) == null ? void 0 : f.position) == null ? void 0 : h.join("\\")) || "",
          nOfFrames: String(T.frameCount),
          direction: ((I = T.frames[0]) == null ? void 0 : I.direction.join("\\")) || "",
          metadata: T
        });
      } finally {
        b();
      }
      a == null || a(Math.round((S + 1) / n.length * 60));
    }
    const m = [];
    for (const [S, E] of l)
      for (const [g, v] of E) {
        const T = hh(v);
        i.push(...T.failures.map((z) => ({ ...z, seriesId: g })));
        const R = T.slices;
        if (!R.length) continue;
        const L = bh(R), C = L && s.get(L.fileName);
        if (!C || !L) continue;
        const A = R.find((z) => z.fileName === L.fileName).metadata, { thickness: j, dimensions: N } = A;
        p(new Int8Array(await C.arrayBuffer())), o.GetDICOMSlicePreview(c, L.frameId);
        const x = o.GetBase64String();
        if (!x) {
          i.push({ seriesId: g, filename: C.name, reason: "decode-error" }), b();
          continue;
        }
        m.push({
          id: g,
          folder: S,
          files: R.map((z) => s.get(z.fileName)).filter(Boolean),
          slices: R,
          selected: !0,
          preview: x,
          modality: A.modality,
          description: A.description,
          thickness: j,
          dimensions: N
        }), b();
      }
    return a == null || a(100), { candidates: m, failures: i };
  } finally {
    try {
      b();
    } finally {
      o.delete();
    }
  }
}, AP = (e, t) => {
  let n = "";
  for (const a of t.split("/").filter(Boolean)) {
    n += `/${a}`;
    try {
      e.FS.mkdir(n);
    } catch {
    }
  }
}, Bx = async (e) => {
  const { module: t, engine: n, context: a, candidate: o } = e, l = new n.xLoadDicom();
  try {
    l.PrepareForDataUpload();
    for (const f of o.files) {
      const I = `/app/${f.webkitRelativePath || f.name}`;
      AP(t, I.slice(0, I.lastIndexOf("/"))), t.FS.writeFile(I, new Int8Array(await f.arrayBuffer())), l.AddToFiles(I, new Int8Array([1]));
    }
    l.PicEditCall();
    const s = l.GetImageDataView(), i = Zh(s);
    s.delete(), a.setImageData(i), a.replaceVolumeObject({ render: !1 }), a.setExternalEngineInstance(n);
    const c = a.getImageData().getDimensions(), u = /* @__PURE__ */ new Date(), p = e.patientBirthDate.toISOString().slice(0, 10).replaceAll("-", ""), b = {
      generalNotes: "",
      patientData: [e.patientName, e.patientId, p].join(`
`),
      seriesData: [o.description || "", "", " 0kV "].join(`
`),
      dicomData: `PATIENT_NAME=${e.patientName}
PATIENT_ID=${e.patientId}
PATIENT_DOB=${p}
PATIENT_SERIES_DESCR=${o.description || ""}
MODALITY=${o.modality || ""}`,
      modified: { year: u.getFullYear(), month: u.getMonth(), day: u.getDate(), hour: u.getHours(), minutes: u.getMinutes(), seconds: u.getSeconds() },
      projectVersion: e.projectVersion || 1,
      projectCropped: 0,
      croppedPointMin: [0, 0, 0],
      croppedPointMax: c,
      useUSToothMap: a.settings.general.useUSStyleToothChart
    };
    return OP({
      context: a,
      projectName: e.projectName,
      generalData: b,
      patientInfo: {
        patientName: e.patientName,
        patientBirthDate: e.patientBirthDate.toISOString(),
        patientID: e.patientId
      },
      progressCallback: e.onProgress
    });
  } finally {
    l.delete();
  }
};
export {
  jx as IPAboutInfoComponent,
  Fx as IPDataImportPreview,
  xx as IPFreeformingAppLoader,
  $x as IPProjectLoader,
  Rx as IPProjectLoaderView,
  Mx as IPProjectLoaderViewRedesign,
  Px as IPProjectLoaderViewRedesignAlfred,
  Ax as LoadRGFileFromServer,
  Vx as analyzeDicomSeries,
  mr as arrayToBase64,
  OP as createDicomProjectZip,
  H2 as createMobileForUpload,
  z2 as createProjectZip,
  Bx as generateDicomCandidateProject,
  Nx as getDefaultName,
  N_ as getImplantPlannerEnvironment,
  Ox as getMetaDataFromZip,
  Ur as getObjectNames,
  Lx as getPreviewProjectFromZip,
  kx as getProjectHash,
  Cx as initI18n,
  Am as isDevelopmentModulesEnabled,
  U2 as loadMobileFile,
  qu as prepareProjectData,
  ds as projectGeneralDataModel,
  Tx as setImplantIsDevelopment,
  Ex as setImplantPlannerEnvironment,
  Dx as uploadProjectFromZip,
  Zt as writeProjectObject
};
//# sourceMappingURL=implantplanner.js.map
